//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { SharedClientBase } from "@ccq/ts-lib";
import * as ng from 'angular';

export class ClientBase extends SharedClientBase {
    /*
    Sean Kao 02/12/2024 - Please don't remove this comment

    Due to how the NSwag TypeScript generator is implemented,
    there needs to be at least 2 newline characters between the curly braces of the class definition,
    otherwise the generator places ClientBase at the bottom of ModularZARPClient.ts instead of on top,
    which breaks the build
    */
}

export class AccountClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(acctName: string): ng.IPromise<Account> {
        let url_ = this.baseUrl + "/api/account/{acctName}";
        if (acctName === undefined || acctName === null)
            throw new Error("The parameter 'acctName' must be defined.");
        url_ = url_.replace("{acctName}", encodeURIComponent("" + acctName));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Account> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Account;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Account>(null as any);
    }

    /**
     * @return OK
     */
    sendFriendReferralEmail(username: string, usersurname: string, useremail: string, friendname: string, friendsurname: string, friendemail: string, friendbody: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/account/sendfriendreferralemail?";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined and cannot be null.");
        else
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (usersurname === undefined || usersurname === null)
            throw new Error("The parameter 'usersurname' must be defined and cannot be null.");
        else
            url_ += "usersurname=" + encodeURIComponent("" + usersurname) + "&";
        if (useremail === undefined || useremail === null)
            throw new Error("The parameter 'useremail' must be defined and cannot be null.");
        else
            url_ += "useremail=" + encodeURIComponent("" + useremail) + "&";
        if (friendname === undefined || friendname === null)
            throw new Error("The parameter 'friendname' must be defined and cannot be null.");
        else
            url_ += "friendname=" + encodeURIComponent("" + friendname) + "&";
        if (friendsurname === undefined || friendsurname === null)
            throw new Error("The parameter 'friendsurname' must be defined and cannot be null.");
        else
            url_ += "friendsurname=" + encodeURIComponent("" + friendsurname) + "&";
        if (friendemail === undefined || friendemail === null)
            throw new Error("The parameter 'friendemail' must be defined and cannot be null.");
        else
            url_ += "friendemail=" + encodeURIComponent("" + friendemail) + "&";
        if (friendbody === undefined || friendbody === null)
            throw new Error("The parameter 'friendbody' must be defined and cannot be null.");
        else
            url_ += "friendbody=" + encodeURIComponent("" + friendbody) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendFriendReferralEmail(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendFriendReferralEmail(_response);
            throw _response;
        });
    }

    protected processSendFriendReferralEmail(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    requestAssistanceReview(reason: string, caseid: number, productFamily: ProductFamilyEnum): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/account/requestassistancereview?";
        if (reason === undefined || reason === null)
            throw new Error("The parameter 'reason' must be defined and cannot be null.");
        else
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        if (caseid === undefined || caseid === null)
            throw new Error("The parameter 'caseid' must be defined and cannot be null.");
        else
            url_ += "caseid=" + encodeURIComponent("" + caseid) + "&";
        if (productFamily === undefined || productFamily === null)
            throw new Error("The parameter 'productFamily' must be defined and cannot be null.");
        else
            url_ += "productFamily=" + encodeURIComponent("" + productFamily) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRequestAssistanceReview(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRequestAssistanceReview(_response);
            throw _response;
        });
    }

    protected processRequestAssistanceReview(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sendIntroducerRegistrationEmail(introducerEmail: string, introducerFirstName: string, introducerCode: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/account/sendintroducerregistrationemail?";
        if (introducerEmail === undefined || introducerEmail === null)
            throw new Error("The parameter 'introducerEmail' must be defined and cannot be null.");
        else
            url_ += "introducerEmail=" + encodeURIComponent("" + introducerEmail) + "&";
        if (introducerFirstName === undefined || introducerFirstName === null)
            throw new Error("The parameter 'introducerFirstName' must be defined and cannot be null.");
        else
            url_ += "introducerFirstName=" + encodeURIComponent("" + introducerFirstName) + "&";
        if (introducerCode === undefined || introducerCode === null)
            throw new Error("The parameter 'introducerCode' must be defined and cannot be null.");
        else
            url_ += "introducerCode=" + encodeURIComponent("" + introducerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendIntroducerRegistrationEmail(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendIntroducerRegistrationEmail(_response);
            throw _response;
        });
    }

    protected processSendIntroducerRegistrationEmail(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getFooterWebConfigValue(): ng.IPromise<WebConfigDTO> {
        let url_ = this.baseUrl + "/api/account/getfooterwebconfigvalue";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetFooterWebConfigValue(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetFooterWebConfigValue(_response);
            throw _response;
        });
    }

    protected processGetFooterWebConfigValue(response: any): ng.IPromise<WebConfigDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebConfigDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<WebConfigDTO>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<Account[]> {
        let url_ = this.baseUrl + "/api/account/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<Account[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Account[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Account[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<Account> {
        let url_ = this.baseUrl + "/api/account/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<Account> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Account;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Account>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/account/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<AccountPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/account/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<AccountPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AccountPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<AccountPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/account/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<AccountPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AccountPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: Account): ng.IPromise<Account> {
        let url_ = this.baseUrl + "/api/account/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<Account> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Account;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Account>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: Account): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/account/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: Account[]): ng.IPromise<Account[]> {
        let url_ = this.baseUrl + "/api/account/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<Account[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Account[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Account[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: Account[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/account/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/account/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/account/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AccountCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous> {
        let url_ = this.baseUrl + "/odata/AccountOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous>(null as any);
    }

    /**
     * @return OK
     */
    post(body: AccountInsert): ng.IPromise<Account> {
        let url_ = this.baseUrl + "/api/crud/account/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<Account> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Account;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Account>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: AccountUpdate): ng.IPromise<Account> {
        let url_ = this.baseUrl + "/api/crud/account/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<Account> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Account;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Account>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/account/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/account/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AppFeatureClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<AppFeature[]> {
        let url_ = this.baseUrl + "/api/appfeature/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<AppFeature[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppFeature[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppFeature[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<AppFeature> {
        let url_ = this.baseUrl + "/api/appfeature/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<AppFeature> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppFeature;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppFeature>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/appfeature/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<AppFeaturePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/appfeature/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<AppFeaturePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppFeaturePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppFeaturePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<AppFeaturePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/appfeature/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<AppFeaturePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppFeaturePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppFeaturePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: AppFeature): ng.IPromise<AppFeature> {
        let url_ = this.baseUrl + "/api/appfeature/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<AppFeature> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppFeature;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppFeature>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: AppFeature): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/appfeature/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: AppFeature[]): ng.IPromise<AppFeature[]> {
        let url_ = this.baseUrl + "/api/appfeature/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<AppFeature[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppFeature[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppFeature[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: AppFeature[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/appfeature/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/appfeature/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/appfeature/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AppFeatureCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous2> {
        let url_ = this.baseUrl + "/odata/AppFeatureOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous2> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous2;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous2>(null as any);
    }

    /**
     * @return OK
     */
    post(body: AppFeatureInsert): ng.IPromise<AppFeature> {
        let url_ = this.baseUrl + "/api/crud/appfeature/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<AppFeature> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppFeature;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppFeature>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: AppFeatureUpdate): ng.IPromise<AppFeature> {
        let url_ = this.baseUrl + "/api/crud/appfeature/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<AppFeature> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppFeature;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppFeature>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/appfeature/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/appfeature/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ApplicationUserClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<ApplicationUser[]> {
        let url_ = this.baseUrl + "/api/applicationuser/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<ApplicationUser[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/applicationuser/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/applicationuser/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ApplicationUserPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/applicationuser/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ApplicationUserPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUserPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUserPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ApplicationUserPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/applicationuser/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ApplicationUserPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUserPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUserPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: ApplicationUser): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/applicationuser/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: ApplicationUser): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/applicationuser/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: ApplicationUser[]): ng.IPromise<ApplicationUser[]> {
        let url_ = this.baseUrl + "/api/applicationuser/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<ApplicationUser[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: ApplicationUser[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/applicationuser/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/applicationuser/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/applicationuser/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ApplicationUserCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous3> {
        let url_ = this.baseUrl + "/odata/ApplicationUserOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous3> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous3;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous3>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ApplicationUserInsert): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/crud/applicationuser/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ApplicationUserUpdate): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/crud/applicationuser/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/applicationuser/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/applicationuser/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AppPackageClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<AppPackage[]> {
        let url_ = this.baseUrl + "/api/apppackage/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<AppPackage[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackage[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackage[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<AppPackage> {
        let url_ = this.baseUrl + "/api/apppackage/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<AppPackage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackage>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/apppackage/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<AppPackagePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/apppackage/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<AppPackagePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<AppPackagePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/apppackage/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<AppPackagePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: AppPackage): ng.IPromise<AppPackage> {
        let url_ = this.baseUrl + "/api/apppackage/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<AppPackage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackage>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: AppPackage): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/apppackage/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: AppPackage[]): ng.IPromise<AppPackage[]> {
        let url_ = this.baseUrl + "/api/apppackage/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<AppPackage[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackage[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackage[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: AppPackage[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/apppackage/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/apppackage/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/apppackage/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AppPackageCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous4> {
        let url_ = this.baseUrl + "/odata/AppPackageOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous4> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous4;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous4>(null as any);
    }

    /**
     * @return OK
     */
    post(body: AppPackageInsert): ng.IPromise<AppPackage> {
        let url_ = this.baseUrl + "/api/crud/apppackage/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<AppPackage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackage>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: AppPackageUpdate): ng.IPromise<AppPackage> {
        let url_ = this.baseUrl + "/api/crud/apppackage/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<AppPackage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackage>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/apppackage/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/apppackage/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AppPackageFeatureClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<AppPackageFeature[]> {
        let url_ = this.baseUrl + "/api/apppackagefeature/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<AppPackageFeature[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackageFeature[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackageFeature[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<AppPackageFeature> {
        let url_ = this.baseUrl + "/api/apppackagefeature/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<AppPackageFeature> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackageFeature;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackageFeature>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/apppackagefeature/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<AppPackageFeaturePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/apppackagefeature/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<AppPackageFeaturePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackageFeaturePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackageFeaturePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<AppPackageFeaturePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/apppackagefeature/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<AppPackageFeaturePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackageFeaturePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackageFeaturePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: AppPackageFeature): ng.IPromise<AppPackageFeature> {
        let url_ = this.baseUrl + "/api/apppackagefeature/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<AppPackageFeature> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackageFeature;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackageFeature>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: AppPackageFeature): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/apppackagefeature/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: AppPackageFeature[]): ng.IPromise<AppPackageFeature[]> {
        let url_ = this.baseUrl + "/api/apppackagefeature/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<AppPackageFeature[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackageFeature[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackageFeature[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: AppPackageFeature[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/apppackagefeature/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/apppackagefeature/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/apppackagefeature/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AppPackageFeatureCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous5> {
        let url_ = this.baseUrl + "/odata/AppPackageFeatureOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous5> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous5;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous5>(null as any);
    }

    /**
     * @return OK
     */
    post(body: AppPackageFeatureInsert): ng.IPromise<AppPackageFeature> {
        let url_ = this.baseUrl + "/api/crud/apppackagefeature/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<AppPackageFeature> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackageFeature;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackageFeature>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: AppPackageFeatureUpdate): ng.IPromise<AppPackageFeature> {
        let url_ = this.baseUrl + "/api/crud/apppackagefeature/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<AppPackageFeature> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackageFeature;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackageFeature>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/apppackagefeature/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/apppackagefeature/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AppPackagePricingClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<AppPackagePricing[]> {
        let url_ = this.baseUrl + "/api/apppackagepricing/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<AppPackagePricing[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePricing[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePricing[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<AppPackagePricing> {
        let url_ = this.baseUrl + "/api/apppackagepricing/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<AppPackagePricing> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePricing;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePricing>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/apppackagepricing/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<AppPackagePricingPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/apppackagepricing/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<AppPackagePricingPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePricingPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePricingPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<AppPackagePricingPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/apppackagepricing/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<AppPackagePricingPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePricingPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePricingPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: AppPackagePricing): ng.IPromise<AppPackagePricing> {
        let url_ = this.baseUrl + "/api/apppackagepricing/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<AppPackagePricing> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePricing;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePricing>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: AppPackagePricing): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/apppackagepricing/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: AppPackagePricing[]): ng.IPromise<AppPackagePricing[]> {
        let url_ = this.baseUrl + "/api/apppackagepricing/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<AppPackagePricing[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePricing[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePricing[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: AppPackagePricing[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/apppackagepricing/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/apppackagepricing/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/apppackagepricing/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AppPackagePricingCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous6> {
        let url_ = this.baseUrl + "/odata/AppPackagePricingOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous6> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous6;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous6>(null as any);
    }

    /**
     * @return OK
     */
    post(body: AppPackagePricingInsert): ng.IPromise<AppPackagePricing> {
        let url_ = this.baseUrl + "/api/crud/apppackagepricing/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<AppPackagePricing> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePricing;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePricing>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: AppPackagePricingUpdate): ng.IPromise<AppPackagePricing> {
        let url_ = this.baseUrl + "/api/crud/apppackagepricing/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<AppPackagePricing> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePricing;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePricing>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/apppackagepricing/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/apppackagepricing/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AppUserPermissionClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<AppUserPermission[]> {
        let url_ = this.baseUrl + "/api/appuserpermission/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<AppUserPermission[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppUserPermission[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppUserPermission[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<AppUserPermission> {
        let url_ = this.baseUrl + "/api/appuserpermission/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<AppUserPermission> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppUserPermission;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppUserPermission>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/appuserpermission/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<AppUserPermissionPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/appuserpermission/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<AppUserPermissionPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppUserPermissionPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppUserPermissionPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<AppUserPermissionPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/appuserpermission/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<AppUserPermissionPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppUserPermissionPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppUserPermissionPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: AppUserPermission): ng.IPromise<AppUserPermission> {
        let url_ = this.baseUrl + "/api/appuserpermission/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<AppUserPermission> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppUserPermission;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppUserPermission>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: AppUserPermission): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/appuserpermission/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: AppUserPermission[]): ng.IPromise<AppUserPermission[]> {
        let url_ = this.baseUrl + "/api/appuserpermission/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<AppUserPermission[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppUserPermission[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppUserPermission[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: AppUserPermission[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/appuserpermission/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/appuserpermission/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/appuserpermission/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AppUserPermissionCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous7> {
        let url_ = this.baseUrl + "/odata/AppUserPermissionOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous7> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous7;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous7>(null as any);
    }

    /**
     * @return OK
     */
    post(body: AppUserPermissionInsert): ng.IPromise<AppUserPermission> {
        let url_ = this.baseUrl + "/api/crud/appuserpermission/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<AppUserPermission> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppUserPermission;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppUserPermission>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: AppUserPermissionUpdate): ng.IPromise<AppUserPermission> {
        let url_ = this.baseUrl + "/api/crud/appuserpermission/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<AppUserPermission> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppUserPermission;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppUserPermission>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/appuserpermission/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/appuserpermission/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AssetLiabilityItemClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<AssetLiabilityItem[]> {
        let url_ = this.baseUrl + "/api/assetliabilityitem/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<AssetLiabilityItem[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetLiabilityItem[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AssetLiabilityItem[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<AssetLiabilityItem> {
        let url_ = this.baseUrl + "/api/assetliabilityitem/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<AssetLiabilityItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetLiabilityItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AssetLiabilityItem>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/assetliabilityitem/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<AssetLiabilityItemPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/assetliabilityitem/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<AssetLiabilityItemPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetLiabilityItemPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AssetLiabilityItemPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<AssetLiabilityItemPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/assetliabilityitem/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<AssetLiabilityItemPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetLiabilityItemPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AssetLiabilityItemPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: AssetLiabilityItem): ng.IPromise<AssetLiabilityItem> {
        let url_ = this.baseUrl + "/api/assetliabilityitem/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<AssetLiabilityItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetLiabilityItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AssetLiabilityItem>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: AssetLiabilityItem): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/assetliabilityitem/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: AssetLiabilityItem[]): ng.IPromise<AssetLiabilityItem[]> {
        let url_ = this.baseUrl + "/api/assetliabilityitem/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<AssetLiabilityItem[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetLiabilityItem[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AssetLiabilityItem[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: AssetLiabilityItem[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/assetliabilityitem/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/assetliabilityitem/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/assetliabilityitem/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AssetLiabilityItemCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous8> {
        let url_ = this.baseUrl + "/odata/AssetLiabilityItemOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous8> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous8;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous8>(null as any);
    }

    /**
     * @return OK
     */
    post(body: AssetLiabilityItemInsert): ng.IPromise<AssetLiabilityItem> {
        let url_ = this.baseUrl + "/api/crud/assetliabilityitem/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<AssetLiabilityItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetLiabilityItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AssetLiabilityItem>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: AssetLiabilityItemUpdate): ng.IPromise<AssetLiabilityItem> {
        let url_ = this.baseUrl + "/api/crud/assetliabilityitem/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<AssetLiabilityItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetLiabilityItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AssetLiabilityItem>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/assetliabilityitem/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/assetliabilityitem/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AuditLogClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<AuditLog[]> {
        let url_ = this.baseUrl + "/api/auditlog/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<AuditLog[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditLog[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AuditLog[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<AuditLog> {
        let url_ = this.baseUrl + "/api/auditlog/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<AuditLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AuditLog>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/auditlog/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<AuditLogPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/auditlog/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<AuditLogPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditLogPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AuditLogPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<AuditLogPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/auditlog/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<AuditLogPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditLogPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AuditLogPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: AuditLog): ng.IPromise<AuditLog> {
        let url_ = this.baseUrl + "/api/auditlog/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<AuditLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AuditLog>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: AuditLog): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/auditlog/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: AuditLog[]): ng.IPromise<AuditLog[]> {
        let url_ = this.baseUrl + "/api/auditlog/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<AuditLog[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditLog[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AuditLog[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: AuditLog[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/auditlog/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/auditlog/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/auditlog/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AuditLogCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous9> {
        let url_ = this.baseUrl + "/odata/AuditLogOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous9> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous9;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous9>(null as any);
    }

    /**
     * @return OK
     */
    post(body: AuditLogInsert): ng.IPromise<AuditLog> {
        let url_ = this.baseUrl + "/api/crud/auditlog/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<AuditLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AuditLog>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: AuditLogUpdate): ng.IPromise<AuditLog> {
        let url_ = this.baseUrl + "/api/crud/auditlog/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<AuditLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AuditLog>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/auditlog/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/auditlog/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class AuthClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    localLogin(username: string, password: string): ng.IPromise<AuthDTO> {
        let url_ = this.baseUrl + "/api/Auth/LocalLogin?";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined and cannot be null.");
        else
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processLocalLogin(_response);
        }, (_response) => {
            if (_response.status)
                return this.processLocalLogin(_response);
            throw _response;
        });
    }

    protected processLocalLogin(response: any): ng.IPromise<AuthDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthDTO;
            return this.q.resolve(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthErrorDetails;
            return throwException(this.q, "Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AuthDTO>(null as any);
    }

    /**
     * @return OK
     */
    changePassword(body: PasswordChangeDTO): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/Auth/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processChangePassword(_response);
        }, (_response) => {
            if (_response.status)
                return this.processChangePassword(_response);
            throw _response;
        });
    }

    protected processChangePassword(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }
}

export class BrickflowEventLogClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param user (optional) 
     * @param userRole (optional) 
     * @param organisationLinkId (optional) 
     * @param productType (optional) 
     * @param developmentInputWithNoLoginUniqueRef (optional) 
     * @param dealId (optional) 
     * @param clientId (optional) 
     * @return OK
     */
    logPageLoad(identifier: string, orgCode: string | null, user?: string | undefined, userRole?: string | undefined, organisationLinkId?: number | null | undefined, productType?: ProductTypeEnum | undefined, developmentInputWithNoLoginUniqueRef?: string | undefined, dealId?: number | null | undefined, clientId?: number | null | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/logpageload?";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined and cannot be null.");
        else
            url_ += "identifier=" + encodeURIComponent("" + identifier) + "&";
        if (orgCode === undefined)
            throw new Error("The parameter 'orgCode' must be defined.");
        else if(orgCode !== null)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (user === null)
            throw new Error("The parameter 'user' cannot be null.");
        else if (user !== undefined)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (userRole === null)
            throw new Error("The parameter 'userRole' cannot be null.");
        else if (userRole !== undefined)
            url_ += "userRole=" + encodeURIComponent("" + userRole) + "&";
        if (organisationLinkId !== undefined && organisationLinkId !== null)
            url_ += "organisationLinkId=" + encodeURIComponent("" + organisationLinkId) + "&";
        if (productType === null)
            throw new Error("The parameter 'productType' cannot be null.");
        else if (productType !== undefined)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (developmentInputWithNoLoginUniqueRef === null)
            throw new Error("The parameter 'developmentInputWithNoLoginUniqueRef' cannot be null.");
        else if (developmentInputWithNoLoginUniqueRef !== undefined)
            url_ += "developmentInputWithNoLoginUniqueRef=" + encodeURIComponent("" + developmentInputWithNoLoginUniqueRef) + "&";
        if (dealId !== undefined && dealId !== null)
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processLogPageLoad(_response);
        }, (_response) => {
            if (_response.status)
                return this.processLogPageLoad(_response);
            throw _response;
        });
    }

    protected processLogPageLoad(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param devInputWithNoLogin (optional) 
     * @param param1 (optional) 
     * @param clientId (optional) 
     * @return OK
     */
    logEvent(identifier: string, eventType: EventLogEnum, productType: ProductTypeEnum, dealId: number, devInputWithNoLogin?: string | undefined, param1?: string | undefined, clientId?: number | null | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/logevent?";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined and cannot be null.");
        else
            url_ += "identifier=" + encodeURIComponent("" + identifier) + "&";
        if (eventType === undefined || eventType === null)
            throw new Error("The parameter 'eventType' must be defined and cannot be null.");
        else
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (devInputWithNoLogin === null)
            throw new Error("The parameter 'devInputWithNoLogin' cannot be null.");
        else if (devInputWithNoLogin !== undefined)
            url_ += "devInputWithNoLogin=" + encodeURIComponent("" + devInputWithNoLogin) + "&";
        if (param1 === null)
            throw new Error("The parameter 'param1' cannot be null.");
        else if (param1 !== undefined)
            url_ += "param1=" + encodeURIComponent("" + param1) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processLogEvent(_response);
        }, (_response) => {
            if (_response.status)
                return this.processLogEvent(_response);
            throw _response;
        });
    }

    protected processLogEvent(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<BrickflowEventLog[]> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<BrickflowEventLog[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrickflowEventLog[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrickflowEventLog[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<BrickflowEventLog> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<BrickflowEventLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrickflowEventLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrickflowEventLog>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<BrickflowEventLogPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<BrickflowEventLogPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrickflowEventLogPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrickflowEventLogPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<BrickflowEventLogPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<BrickflowEventLogPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrickflowEventLogPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrickflowEventLogPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: BrickflowEventLog): ng.IPromise<BrickflowEventLog> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<BrickflowEventLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrickflowEventLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrickflowEventLog>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: BrickflowEventLog): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: BrickflowEventLog[]): ng.IPromise<BrickflowEventLog[]> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<BrickflowEventLog[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrickflowEventLog[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrickflowEventLog[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: BrickflowEventLog[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/brickfloweventlog/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class BrickflowEventLogCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous10> {
        let url_ = this.baseUrl + "/odata/BrickflowEventLogOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous10> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous10;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous10>(null as any);
    }

    /**
     * @return OK
     */
    post(body: BrickflowEventLogInsert): ng.IPromise<BrickflowEventLog> {
        let url_ = this.baseUrl + "/api/crud/brickfloweventlog/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<BrickflowEventLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrickflowEventLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrickflowEventLog>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: BrickflowEventLogUpdate): ng.IPromise<BrickflowEventLog> {
        let url_ = this.baseUrl + "/api/crud/brickfloweventlog/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<BrickflowEventLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrickflowEventLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrickflowEventLog>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/brickfloweventlog/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/brickfloweventlog/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class BridgingDealClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    fetchCustom(id: number): ng.IPromise<BridgingDeal> {
        let url_ = this.baseUrl + "/api/bridgingdeal/FetchCustom?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchCustom(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchCustom(_response);
            throw _response;
        });
    }

    protected processFetchCustom(response: any): ng.IPromise<BridgingDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingDeal>(null as any);
    }

    /**
     * @return OK
     */
    updateSearchAndGetResults(body: UpdateBridgingSearchGetResultRequest): ng.IPromise<UpdateBridgingSearchGetResultResponse> {
        let url_ = this.baseUrl + "/api/bridgingdeal/updatesearchandgetresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateSearchAndGetResults(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateSearchAndGetResults(_response);
            throw _response;
        });
    }

    protected processUpdateSearchAndGetResults(response: any): ng.IPromise<UpdateBridgingSearchGetResultResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateBridgingSearchGetResultResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<UpdateBridgingSearchGetResultResponse>(null as any);
    }

    /**
     * @return OK
     */
    saveBridgingSearchReturnsId(body: SaveBridgingSearchRequest): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/bridgingdeal/savebridgingsearchreturnsId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveBridgingSearchReturnsId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveBridgingSearchReturnsId(_response);
            throw _response;
        });
    }

    protected processSaveBridgingSearchReturnsId(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    saveBridgingSearchReturnsUniqueRef(body: SaveBridgingSearchRequest): ng.IPromise<SaveSearchReturnUniqueRefResponse> {
        let url_ = this.baseUrl + "/api/bridgingdeal/savebridgingsearchreturnsuniqueref";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveBridgingSearchReturnsUniqueRef(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveBridgingSearchReturnsUniqueRef(_response);
            throw _response;
        });
    }

    protected processSaveBridgingSearchReturnsUniqueRef(response: any): ng.IPromise<SaveSearchReturnUniqueRefResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaveSearchReturnUniqueRefResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SaveSearchReturnUniqueRefResponse>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<BridgingDeal[]> {
        let url_ = this.baseUrl + "/api/bridgingdeal/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<BridgingDeal[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingDeal[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingDeal[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<BridgingDeal> {
        let url_ = this.baseUrl + "/api/bridgingdeal/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<BridgingDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingDeal>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/bridgingdeal/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<BridgingDealPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/bridgingdeal/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<BridgingDealPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingDealPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingDealPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<BridgingDealPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/bridgingdeal/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<BridgingDealPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingDealPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingDealPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: BridgingDeal): ng.IPromise<BridgingDeal> {
        let url_ = this.baseUrl + "/api/bridgingdeal/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<BridgingDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingDeal>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: BridgingDeal): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/bridgingdeal/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: BridgingDeal[]): ng.IPromise<BridgingDeal[]> {
        let url_ = this.baseUrl + "/api/bridgingdeal/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<BridgingDeal[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingDeal[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingDeal[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: BridgingDeal[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/bridgingdeal/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/bridgingdeal/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/bridgingdeal/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class BridgingDealCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous11> {
        let url_ = this.baseUrl + "/odata/BridgingDealOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous11> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous11;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous11>(null as any);
    }

    /**
     * @return OK
     */
    post(body: BridgingDealInsert): ng.IPromise<BridgingDeal> {
        let url_ = this.baseUrl + "/api/crud/bridgingdeal/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<BridgingDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingDeal>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: BridgingDealUpdate): ng.IPromise<BridgingDeal> {
        let url_ = this.baseUrl + "/api/crud/bridgingdeal/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<BridgingDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingDeal>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/bridgingdeal/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/bridgingdeal/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class BridgingSearchClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getSearchCriteriaAndResults(body: SearchResultsRequest): ng.IPromise<BridgingSearchResultsResponse> {
        let url_ = this.baseUrl + "/api/bridgingsearch/getsearchcriteriaandresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSearchCriteriaAndResults(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSearchCriteriaAndResults(_response);
            throw _response;
        });
    }

    protected processGetSearchCriteriaAndResults(response: any): ng.IPromise<BridgingSearchResultsResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingSearchResultsResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingSearchResultsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getSearchResults(body: SearchResultsRequest): ng.IPromise<BridgingSearchResultsResponse> {
        let url_ = this.baseUrl + "/api/bridgingsearch/getsearchresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSearchResults(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSearchResults(_response);
            throw _response;
        });
    }

    protected processGetSearchResults(response: any): ng.IPromise<BridgingSearchResultsResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingSearchResultsResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingSearchResultsResponse>(null as any);
    }
}

export class BridgingSearchCriteriaClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param debug1 (optional) 
     * @param debug2 (optional) 
     * @param orgCode (optional) 
     * @param showLenderNamesAndLogosOverride (optional) 
     * @return OK
     */
    exportToPdf(body: BridgingDeal, debug1?: boolean | null | undefined, debug2?: boolean | null | undefined, orgCode?: string | undefined, showLenderNamesAndLogosOverride?: boolean | null | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/bridgingcriteria/exportsearchtopdf?";
        if (debug1 !== undefined && debug1 !== null)
            url_ += "debug1=" + encodeURIComponent("" + debug1) + "&";
        if (debug2 !== undefined && debug2 !== null)
            url_ += "debug2=" + encodeURIComponent("" + debug2) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (showLenderNamesAndLogosOverride !== undefined && showLenderNamesAndLogosOverride !== null)
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportToPdf(_response);
            throw _response;
        });
    }

    protected processExportToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param debug1 (optional) 
     * @param debug2 (optional) 
     * @param orgCode (optional) 
     * @param showLenderNamesAndLogosOverride (optional) 
     * @return OK
     */
    exportSearchToPdf(dealId: number, debug1?: boolean | undefined, debug2?: boolean | undefined, orgCode?: string | undefined, showLenderNamesAndLogosOverride?: boolean | null | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/bridgingcriteria/exportsearchtopdf?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (debug1 === null)
            throw new Error("The parameter 'debug1' cannot be null.");
        else if (debug1 !== undefined)
            url_ += "debug1=" + encodeURIComponent("" + debug1) + "&";
        if (debug2 === null)
            throw new Error("The parameter 'debug2' cannot be null.");
        else if (debug2 !== undefined)
            url_ += "debug2=" + encodeURIComponent("" + debug2) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (showLenderNamesAndLogosOverride !== undefined && showLenderNamesAndLogosOverride !== null)
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportSearchToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportSearchToPdf(_response);
            throw _response;
        });
    }

    protected processExportSearchToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param orgCode (optional) 
     * @return OK
     */
    exportShortListedResultsToPdf(showLenderNamesAndLogosOverride: boolean, body: BridgingDeal, orgCode?: string | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/bridgingcriteria/exportshortlistedresultstopdf?";
        if (showLenderNamesAndLogosOverride === undefined || showLenderNamesAndLogosOverride === null)
            throw new Error("The parameter 'showLenderNamesAndLogosOverride' must be defined and cannot be null.");
        else
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportShortListedResultsToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportShortListedResultsToPdf(_response);
            throw _response;
        });
    }

    protected processExportShortListedResultsToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }
}

export class CaseClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param productId (optional) 
     * @param productResultList (optional) 
     * @param isPrimaryApplicant (optional) 
     * @return OK
     */
    promoteSearchToCase(searchId: number, productId?: number | null | undefined, productResultList?: number | null | undefined, isPrimaryApplicant?: boolean | undefined): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/case/promotesearchtocase?";
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined and cannot be null.");
        else
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productResultList !== undefined && productResultList !== null)
            url_ += "productResultList=" + encodeURIComponent("" + productResultList) + "&";
        if (isPrimaryApplicant === null)
            throw new Error("The parameter 'isPrimaryApplicant' cannot be null.");
        else if (isPrimaryApplicant !== undefined)
            url_ += "isPrimaryApplicant=" + encodeURIComponent("" + isPrimaryApplicant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPromoteSearchToCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPromoteSearchToCase(_response);
            throw _response;
        });
    }

    protected processPromoteSearchToCase(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param productResultList (optional) 
     * @param isPrimaryApplicant (optional) 
     * @return OK
     */
    promoteAndUpdateToDeal(searchId: number, productId?: number | null | undefined, productResultList?: number | null | undefined, isPrimaryApplicant?: boolean | undefined): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/case/promoteandmigratetodeal?";
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined and cannot be null.");
        else
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productResultList !== undefined && productResultList !== null)
            url_ += "productResultList=" + encodeURIComponent("" + productResultList) + "&";
        if (isPrimaryApplicant === null)
            throw new Error("The parameter 'isPrimaryApplicant' cannot be null.");
        else if (isPrimaryApplicant !== undefined)
            url_ += "isPrimaryApplicant=" + encodeURIComponent("" + isPrimaryApplicant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPromoteAndUpdateToDeal(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPromoteAndUpdateToDeal(_response);
            throw _response;
        });
    }

    protected processPromoteAndUpdateToDeal(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param productResultList (optional) 
     * @return OK
     */
    setProductOnCase(caseId: number, productId?: number | null | undefined, productResultList?: number | null | undefined): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/case/setproductoncase?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productResultList !== undefined && productResultList !== null)
            url_ += "productResultList=" + encodeURIComponent("" + productResultList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSetProductOnCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSetProductOnCase(_response);
            throw _response;
        });
    }

    protected processSetProductOnCase(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    setStatusOnCase(caseId: number, caseStatus: CaseStatusEnum): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/case/setstatusoncase?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (caseStatus === undefined || caseStatus === null)
            throw new Error("The parameter 'caseStatus' must be defined and cannot be null.");
        else
            url_ += "caseStatus=" + encodeURIComponent("" + caseStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSetStatusOnCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSetStatusOnCase(_response);
            throw _response;
        });
    }

    protected processSetStatusOnCase(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @param lenderId (optional) 
     * @param isLender (optional) 
     * @return OK
     */
    exportDataDump(caseId: number, lenderId?: number | undefined, isLender?: boolean | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/case/exportdatadump?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (lenderId === null)
            throw new Error("The parameter 'lenderId' cannot be null.");
        else if (lenderId !== undefined)
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        if (isLender === null)
            throw new Error("The parameter 'isLender' cannot be null.");
        else if (isLender !== undefined)
            url_ += "isLender=" + encodeURIComponent("" + isLender) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportDataDump(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportDataDump(_response);
            throw _response;
        });
    }

    protected processExportDataDump(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    sendNote(clientFirstName: string, clientSurname: string, clientEmail: string, note: string, caseId: number, section: number, suplId: number, developmentExperienceId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/case/sendnote?";
        if (clientFirstName === undefined || clientFirstName === null)
            throw new Error("The parameter 'clientFirstName' must be defined and cannot be null.");
        else
            url_ += "clientFirstName=" + encodeURIComponent("" + clientFirstName) + "&";
        if (clientSurname === undefined || clientSurname === null)
            throw new Error("The parameter 'clientSurname' must be defined and cannot be null.");
        else
            url_ += "clientSurname=" + encodeURIComponent("" + clientSurname) + "&";
        if (clientEmail === undefined || clientEmail === null)
            throw new Error("The parameter 'clientEmail' must be defined and cannot be null.");
        else
            url_ += "clientEmail=" + encodeURIComponent("" + clientEmail) + "&";
        if (note === undefined || note === null)
            throw new Error("The parameter 'note' must be defined and cannot be null.");
        else
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (section === undefined || section === null)
            throw new Error("The parameter 'section' must be defined and cannot be null.");
        else
            url_ += "section=" + encodeURIComponent("" + section) + "&";
        if (suplId === undefined || suplId === null)
            throw new Error("The parameter 'suplId' must be defined and cannot be null.");
        else
            url_ += "suplId=" + encodeURIComponent("" + suplId) + "&";
        if (developmentExperienceId === undefined || developmentExperienceId === null)
            throw new Error("The parameter 'developmentExperienceId' must be defined and cannot be null.");
        else
            url_ += "DevelopmentExperienceId=" + encodeURIComponent("" + developmentExperienceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendNote(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendNote(_response);
            throw _response;
        });
    }

    protected processSendNote(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    requestReview(caseId: number, confirmPhoneNumber: string, requestMessageReason: string): ng.IPromise<CaseChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/case/requestreview?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (confirmPhoneNumber === undefined || confirmPhoneNumber === null)
            throw new Error("The parameter 'confirmPhoneNumber' must be defined and cannot be null.");
        else
            url_ += "confirmPhoneNumber=" + encodeURIComponent("" + confirmPhoneNumber) + "&";
        if (requestMessageReason === undefined || requestMessageReason === null)
            throw new Error("The parameter 'requestMessageReason' must be defined and cannot be null.");
        else
            url_ += "requestMessageReason=" + encodeURIComponent("" + requestMessageReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRequestReview(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRequestReview(_response);
            throw _response;
        });
    }

    protected processRequestReview(response: any): ng.IPromise<CaseChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    approveCase(caseId: number): ng.IPromise<CaseChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/case/approve?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processApproveCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processApproveCase(_response);
            throw _response;
        });
    }

    protected processApproveCase(response: any): ng.IPromise<CaseChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    submitForHoTs(caseId: number, brokerCommission: number | null, brokerPhoneNumber: string, isBrokerPhoneNumberUpdated: boolean, body: LenderInfo[]): ng.IPromise<CaseChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/case/submittolenders?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (brokerCommission === undefined)
            throw new Error("The parameter 'brokerCommission' must be defined.");
        else if(brokerCommission !== null)
            url_ += "brokerCommission=" + encodeURIComponent("" + brokerCommission) + "&";
        if (brokerPhoneNumber === undefined || brokerPhoneNumber === null)
            throw new Error("The parameter 'brokerPhoneNumber' must be defined and cannot be null.");
        else
            url_ += "brokerPhoneNumber=" + encodeURIComponent("" + brokerPhoneNumber) + "&";
        if (isBrokerPhoneNumberUpdated === undefined || isBrokerPhoneNumberUpdated === null)
            throw new Error("The parameter 'isBrokerPhoneNumberUpdated' must be defined and cannot be null.");
        else
            url_ += "isBrokerPhoneNumberUpdated=" + encodeURIComponent("" + isBrokerPhoneNumberUpdated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSubmitForHoTs(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSubmitForHoTs(_response);
            throw _response;
        });
    }

    protected processSubmitForHoTs(response: any): ng.IPromise<CaseChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    reSubmitForHoTs(caseId: number, brokerCommission: number | null, brokerPhoneNumber: string, isBrokerPhoneNumberUpdated: boolean, body: LenderInfo[]): ng.IPromise<CaseChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/case/resubmittolenders?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (brokerCommission === undefined)
            throw new Error("The parameter 'brokerCommission' must be defined.");
        else if(brokerCommission !== null)
            url_ += "brokerCommission=" + encodeURIComponent("" + brokerCommission) + "&";
        if (brokerPhoneNumber === undefined || brokerPhoneNumber === null)
            throw new Error("The parameter 'brokerPhoneNumber' must be defined and cannot be null.");
        else
            url_ += "brokerPhoneNumber=" + encodeURIComponent("" + brokerPhoneNumber) + "&";
        if (isBrokerPhoneNumberUpdated === undefined || isBrokerPhoneNumberUpdated === null)
            throw new Error("The parameter 'isBrokerPhoneNumberUpdated' must be defined and cannot be null.");
        else
            url_ += "isBrokerPhoneNumberUpdated=" + encodeURIComponent("" + isBrokerPhoneNumberUpdated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processReSubmitForHoTs(_response);
        }, (_response) => {
            if (_response.status)
                return this.processReSubmitForHoTs(_response);
            throw _response;
        });
    }

    protected processReSubmitForHoTs(response: any): ng.IPromise<CaseChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseChangedMessageDTO>(null as any);
    }

    /**
     * @param isLender (optional) 
     * @return OK
     */
    exportToPdf(caseId: number, lenderId: number, isLender?: boolean | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/case/exporttopdf?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (lenderId === undefined || lenderId === null)
            throw new Error("The parameter 'lenderId' must be defined and cannot be null.");
        else
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        if (isLender === null)
            throw new Error("The parameter 'isLender' cannot be null.");
        else if (isLender !== undefined)
            url_ += "isLender=" + encodeURIComponent("" + isLender) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportToPdf(_response);
            throw _response;
        });
    }

    protected processExportToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    downloadZip(caseId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/case/downloadzip?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDownloadZip(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDownloadZip(_response);
            throw _response;
        });
    }

    protected processDownloadZip(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    setBrokerOrganisation(caseId: number, organisationId: number): ng.IPromise<CaseNote> {
        let url_ = this.baseUrl + "/api/case/setbrokerorganisation?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined and cannot be null.");
        else
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSetBrokerOrganisation(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSetBrokerOrganisation(_response);
            throw _response;
        });
    }

    protected processSetBrokerOrganisation(response: any): ng.IPromise<CaseNote> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseNote;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseNote>(null as any);
    }

    /**
     * @return OK
     */
    setBrokerUser(caseId: number, brokerUserId: number): ng.IPromise<CaseNote> {
        let url_ = this.baseUrl + "/api/case/setbrokeruser?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (brokerUserId === undefined || brokerUserId === null)
            throw new Error("The parameter 'brokerUserId' must be defined and cannot be null.");
        else
            url_ += "brokerUserId=" + encodeURIComponent("" + brokerUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSetBrokerUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSetBrokerUser(_response);
            throw _response;
        });
    }

    protected processSetBrokerUser(response: any): ng.IPromise<CaseNote> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseNote;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseNote>(null as any);
    }

    /**
     * @return OK
     */
    isUserInvitedToCase(userId: number, caseId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/case/isuserinvitedtocase?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsUserInvitedToCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsUserInvitedToCase(_response);
            throw _response;
        });
    }

    protected processIsUserInvitedToCase(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    downloadFileWithLink(fileName: string): ng.IPromise<FileResponse> {
        let url_ = this.baseUrl + "/api/case/downloadfilewithlink?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            responseType: "arraybuffer",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDownloadFileWithLink(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDownloadFileWithLink(_response);
            throw _response;
        });
    }

    protected processDownloadFileWithLink(response: any): ng.IPromise<FileResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return this.q.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(new Blob([response.data]), this.q).then(_responseText => {
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return this.q.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    autofillCase(body: Case): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/case/autofill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAutofillCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAutofillCase(_response);
            throw _response;
        });
    }

    protected processAutofillCase(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    shortlistMoreLenders(caseId: number, hasCriteriaChanged: boolean): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/case/shortlistmorelenders?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (hasCriteriaChanged === undefined || hasCriteriaChanged === null)
            throw new Error("The parameter 'hasCriteriaChanged' must be defined and cannot be null.");
        else
            url_ += "hasCriteriaChanged=" + encodeURIComponent("" + hasCriteriaChanged) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processShortlistMoreLenders(_response);
        }, (_response) => {
            if (_response.status)
                return this.processShortlistMoreLenders(_response);
            throw _response;
        });
    }

    protected processShortlistMoreLenders(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    assignLenderToCase(body: AssignLenderToDealRequest): ng.IPromise<AssignBrokerToDealResponse> {
        let url_ = this.baseUrl + "/api/case/assignlendertocase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAssignLenderToCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAssignLenderToCase(_response);
            throw _response;
        });
    }

    protected processAssignLenderToCase(response: any): ng.IPromise<AssignBrokerToDealResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignBrokerToDealResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AssignBrokerToDealResponse>(null as any);
    }

    /**
     * @return OK
     */
    saveSaveAsSearch(searchId: number, attachClient: boolean, body: ShareDealDTO): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/case/savesaveassearch?";
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined and cannot be null.");
        else
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (attachClient === undefined || attachClient === null)
            throw new Error("The parameter 'attachClient' must be defined and cannot be null.");
        else
            url_ += "attachClient=" + encodeURIComponent("" + attachClient) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveSaveAsSearch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveSaveAsSearch(_response);
            throw _response;
        });
    }

    protected processSaveSaveAsSearch(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    developmentTrackrecordAddUpdateListReturnOnlyID(body: DevelopmentTrackRecord[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/case/developmenttrackrecordaddupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDevelopmentTrackrecordAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDevelopmentTrackrecordAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processDevelopmentTrackrecordAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<Case[]> {
        let url_ = this.baseUrl + "/api/case/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<Case[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Case[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Case[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<Case> {
        let url_ = this.baseUrl + "/api/case/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<Case> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Case;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Case>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/case/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<CasePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/case/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<CasePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CasePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CasePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<CasePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/case/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<CasePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CasePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CasePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: Case): ng.IPromise<Case> {
        let url_ = this.baseUrl + "/api/case/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<Case> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Case;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Case>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: Case): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/case/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: Case[]): ng.IPromise<Case[]> {
        let url_ = this.baseUrl + "/api/case/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<Case[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Case[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Case[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: Case[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/case/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/case/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/case/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CaseCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous12> {
        let url_ = this.baseUrl + "/odata/CaseOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous12> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous12;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous12>(null as any);
    }

    /**
     * @return OK
     */
    post(body: CaseInsert): ng.IPromise<Case> {
        let url_ = this.baseUrl + "/api/crud/case/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<Case> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Case;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Case>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: CaseUpdate): ng.IPromise<Case> {
        let url_ = this.baseUrl + "/api/crud/case/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<Case> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Case;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Case>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/case/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/case/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CaseLenderClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    submitHoT(caseLenderState: CaseLenderStateEnum, body: CaseLender): ng.IPromise<CaseLenderChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/caselender/submitoffer?";
        if (caseLenderState === undefined || caseLenderState === null)
            throw new Error("The parameter 'caseLenderState' must be defined and cannot be null.");
        else
            url_ += "caseLenderState=" + encodeURIComponent("" + caseLenderState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSubmitHoT(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSubmitHoT(_response);
            throw _response;
        });
    }

    protected processSubmitHoT(response: any): ng.IPromise<CaseLenderChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    rejectCase(body: CaseLender): ng.IPromise<CaseLenderChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/caselender/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRejectCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRejectCase(_response);
            throw _response;
        });
    }

    protected processRejectCase(response: any): ng.IPromise<CaseLenderChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    withdrawHoT(body: CaseLender): ng.IPromise<CaseLenderChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/caselender/withdraw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processWithdrawHoT(_response);
        }, (_response) => {
            if (_response.status)
                return this.processWithdrawHoT(_response);
            throw _response;
        });
    }

    protected processWithdrawHoT(response: any): ng.IPromise<CaseLenderChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    applyToLender(caseId: number, caseLenderId: number, sendEmails: boolean): ng.IPromise<CaseLenderChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/caselender/apply?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (caseLenderId === undefined || caseLenderId === null)
            throw new Error("The parameter 'caseLenderId' must be defined and cannot be null.");
        else
            url_ += "caseLenderId=" + encodeURIComponent("" + caseLenderId) + "&";
        if (sendEmails === undefined || sendEmails === null)
            throw new Error("The parameter 'sendEmails' must be defined and cannot be null.");
        else
            url_ += "sendEmails=" + encodeURIComponent("" + sendEmails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processApplyToLender(_response);
        }, (_response) => {
            if (_response.status)
                return this.processApplyToLender(_response);
            throw _response;
        });
    }

    protected processApplyToLender(response: any): ng.IPromise<CaseLenderChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    cancelApplication(caseId: number, caseLenderId: number): ng.IPromise<CaseLenderChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/caselender/cancel?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (caseLenderId === undefined || caseLenderId === null)
            throw new Error("The parameter 'caseLenderId' must be defined and cannot be null.");
        else
            url_ += "caseLenderId=" + encodeURIComponent("" + caseLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCancelApplication(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCancelApplication(_response);
            throw _response;
        });
    }

    protected processCancelApplication(response: any): ng.IPromise<CaseLenderChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    sendFeedbackToBorrower(caseOwner: string, body: CaseLender): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/caselender/sendfeedbacktoborrower?";
        if (caseOwner === undefined || caseOwner === null)
            throw new Error("The parameter 'caseOwner' must be defined and cannot be null.");
        else
            url_ += "caseOwner=" + encodeURIComponent("" + caseOwner) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendFeedbackToBorrower(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendFeedbackToBorrower(_response);
            throw _response;
        });
    }

    protected processSendFeedbackToBorrower(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sendFeedbackToLender(body: CaseLender): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/caselender/sendfeedbacktolender";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendFeedbackToLender(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendFeedbackToLender(_response);
            throw _response;
        });
    }

    protected processSendFeedbackToLender(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @param debug2 (optional) 
     * @param caseLenderId (optional) 
     * @return OK
     */
    fetchByCaseId(caseId: number, debug2?: boolean | undefined, caseLenderId?: number | undefined): ng.IPromise<CaseLender[]> {
        let url_ = this.baseUrl + "/api/caselender/fetchByCaseId?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (debug2 === null)
            throw new Error("The parameter 'debug2' cannot be null.");
        else if (debug2 !== undefined)
            url_ += "debug2=" + encodeURIComponent("" + debug2) + "&";
        if (caseLenderId === null)
            throw new Error("The parameter 'caseLenderId' cannot be null.");
        else if (caseLenderId !== undefined)
            url_ += "caseLenderId=" + encodeURIComponent("" + caseLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchByCaseId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchByCaseId(_response);
            throw _response;
        });
    }

    protected processFetchByCaseId(response: any): ng.IPromise<CaseLender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLender[]>(null as any);
    }

    /**
     * @return OK
     */
    fetchCaseLender(caseId: number): ng.IPromise<CaseLender> {
        let url_ = this.baseUrl + "/api/caselender/fetchcaselender?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchCaseLender(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchCaseLender(_response);
            throw _response;
        });
    }

    protected processFetchCaseLender(response: any): ng.IPromise<CaseLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLender>(null as any);
    }

    /**
     * @param showLenderNames (optional) 
     * @return OK
     */
    getSelectedCaseLender(id: number, showLenderNames?: boolean | undefined): ng.IPromise<CaseLender> {
        let url_ = this.baseUrl + "/api/caselender/selectedcaselender?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (showLenderNames === null)
            throw new Error("The parameter 'showLenderNames' cannot be null.");
        else if (showLenderNames !== undefined)
            url_ += "showLenderNames=" + encodeURIComponent("" + showLenderNames) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSelectedCaseLender(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSelectedCaseLender(_response);
            throw _response;
        });
    }

    protected processGetSelectedCaseLender(response: any): ng.IPromise<CaseLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLender>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeletedIncludingSelectedResult(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/caselender?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeletedIncludingSelectedResult(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeletedIncludingSelectedResult(_response);
            throw _response;
        });
    }

    protected processMarkAsDeletedIncludingSelectedResult(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    exportDIPDataDump(showLenderNames: boolean, body: CaseLender[]): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/caselender/exportdipdatadump?";
        if (showLenderNames === undefined || showLenderNames === null)
            throw new Error("The parameter 'showLenderNames' must be defined and cannot be null.");
        else
            url_ += "showLenderNames=" + encodeURIComponent("" + showLenderNames) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportDIPDataDump(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportDIPDataDump(_response);
            throw _response;
        });
    }

    protected processExportDIPDataDump(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<CaseLender[]> {
        let url_ = this.baseUrl + "/api/caselender/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<CaseLender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLender[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<CaseLender> {
        let url_ = this.baseUrl + "/api/caselender/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<CaseLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLender>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/caselender/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<CaseLenderPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/caselender/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<CaseLenderPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<CaseLenderPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/caselender/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<CaseLenderPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: CaseLender): ng.IPromise<CaseLender> {
        let url_ = this.baseUrl + "/api/caselender/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<CaseLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLender>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: CaseLender): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/caselender/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: CaseLender[]): ng.IPromise<CaseLender[]> {
        let url_ = this.baseUrl + "/api/caselender/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<CaseLender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLender[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: CaseLender[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/caselender/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/caselender/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/caselender/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CaseLenderCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous13> {
        let url_ = this.baseUrl + "/odata/CaseLenderOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous13> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous13;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous13>(null as any);
    }

    /**
     * @return OK
     */
    post(body: CaseLenderInsert): ng.IPromise<CaseLender> {
        let url_ = this.baseUrl + "/api/crud/caselender/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<CaseLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLender>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: CaseLenderUpdate): ng.IPromise<CaseLender> {
        let url_ = this.baseUrl + "/api/crud/caselender/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<CaseLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLender>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/caselender/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/caselender/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CaseLenderMessageClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    addUpdateAndSendNotification(body: CaseLenderMessage): ng.IPromise<CaseLenderMessage> {
        let url_ = this.baseUrl + "/api/caselendermessage/AddUpdateAndSendNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateAndSendNotification(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateAndSendNotification(_response);
            throw _response;
        });
    }

    protected processAddUpdateAndSendNotification(response: any): ng.IPromise<CaseLenderMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessage>(null as any);
    }

    /**
     * @return OK
     */
    updateCaseLenderMessageReadDatetime(caseLenderId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/caselendermessage/updatecaselendermessagereaddatetime?";
        if (caseLenderId === undefined || caseLenderId === null)
            throw new Error("The parameter 'caseLenderId' must be defined and cannot be null.");
        else
            url_ += "caseLenderId=" + encodeURIComponent("" + caseLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateCaseLenderMessageReadDatetime(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateCaseLenderMessageReadDatetime(_response);
            throw _response;
        });
    }

    protected processUpdateCaseLenderMessageReadDatetime(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<CaseLenderMessage[]> {
        let url_ = this.baseUrl + "/api/caselendermessage/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<CaseLenderMessage[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessage[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessage[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<CaseLenderMessage> {
        let url_ = this.baseUrl + "/api/caselendermessage/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<CaseLenderMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessage>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/caselendermessage/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<CaseLenderMessagePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/caselendermessage/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<CaseLenderMessagePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessagePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessagePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<CaseLenderMessagePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/caselendermessage/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<CaseLenderMessagePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessagePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessagePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: CaseLenderMessage): ng.IPromise<CaseLenderMessage> {
        let url_ = this.baseUrl + "/api/caselendermessage/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<CaseLenderMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessage>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: CaseLenderMessage): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/caselendermessage/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: CaseLenderMessage[]): ng.IPromise<CaseLenderMessage[]> {
        let url_ = this.baseUrl + "/api/caselendermessage/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<CaseLenderMessage[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessage[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessage[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: CaseLenderMessage[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/caselendermessage/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/caselendermessage/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/caselendermessage/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CaseLenderMessageCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous14> {
        let url_ = this.baseUrl + "/odata/CaseLenderMessageOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous14> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous14;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous14>(null as any);
    }

    /**
     * @return OK
     */
    post(body: CaseLenderMessageInsert): ng.IPromise<CaseLenderMessage> {
        let url_ = this.baseUrl + "/api/crud/caselendermessage/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<CaseLenderMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessage>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: CaseLenderMessageUpdate): ng.IPromise<CaseLenderMessage> {
        let url_ = this.baseUrl + "/api/crud/caselendermessage/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<CaseLenderMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessage>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/caselendermessage/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/caselendermessage/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CaseLenderMessageTrackClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<CaseLenderMessageTrack[]> {
        let url_ = this.baseUrl + "/api/caselendermessagetrack/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<CaseLenderMessageTrack[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessageTrack[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessageTrack[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<CaseLenderMessageTrack> {
        let url_ = this.baseUrl + "/api/caselendermessagetrack/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<CaseLenderMessageTrack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessageTrack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessageTrack>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/caselendermessagetrack/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<CaseLenderMessageTrackPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/caselendermessagetrack/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<CaseLenderMessageTrackPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessageTrackPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessageTrackPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<CaseLenderMessageTrackPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/caselendermessagetrack/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<CaseLenderMessageTrackPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessageTrackPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessageTrackPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: CaseLenderMessageTrack): ng.IPromise<CaseLenderMessageTrack> {
        let url_ = this.baseUrl + "/api/caselendermessagetrack/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<CaseLenderMessageTrack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessageTrack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessageTrack>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: CaseLenderMessageTrack): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/caselendermessagetrack/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: CaseLenderMessageTrack[]): ng.IPromise<CaseLenderMessageTrack[]> {
        let url_ = this.baseUrl + "/api/caselendermessagetrack/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<CaseLenderMessageTrack[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessageTrack[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessageTrack[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: CaseLenderMessageTrack[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/caselendermessagetrack/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/caselendermessagetrack/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/caselendermessagetrack/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CaseLenderMessageTrackCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous15> {
        let url_ = this.baseUrl + "/odata/CaseLenderMessageTrackOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous15> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous15;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous15>(null as any);
    }

    /**
     * @return OK
     */
    post(body: CaseLenderMessageTrackInsert): ng.IPromise<CaseLenderMessageTrack> {
        let url_ = this.baseUrl + "/api/crud/caselendermessagetrack/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<CaseLenderMessageTrack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessageTrack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessageTrack>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: CaseLenderMessageTrackUpdate): ng.IPromise<CaseLenderMessageTrack> {
        let url_ = this.baseUrl + "/api/crud/caselendermessagetrack/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<CaseLenderMessageTrack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderMessageTrack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderMessageTrack>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/caselendermessagetrack/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/caselendermessagetrack/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CaseMemberClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    addUpdateAndInviteApplicant(body: CaseMember): ng.IPromise<CaseMember> {
        let url_ = this.baseUrl + "/api/casemember/AddUpdateAndInviteApplicant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateAndInviteApplicant(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateAndInviteApplicant(_response);
            throw _response;
        });
    }

    protected processAddUpdateAndInviteApplicant(response: any): ng.IPromise<CaseMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember>(null as any);
    }

    /**
     * @return OK
     */
    fetchByCaseId(caseId: number): ng.IPromise<CaseMember[]> {
        let url_ = this.baseUrl + "/api/casemember/fetchByCaseId?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchByCaseId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchByCaseId(_response);
            throw _response;
        });
    }

    protected processFetchByCaseId(response: any): ng.IPromise<CaseMember[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember[]>(null as any);
    }

    /**
     * @return OK
     */
    copyShareholder(caseId: number, newCaseId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/casemember/copyShareholder?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (newCaseId === undefined || newCaseId === null)
            throw new Error("The parameter 'newCaseId' must be defined and cannot be null.");
        else
            url_ += "newCaseId=" + encodeURIComponent("" + newCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCopyShareholder(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCopyShareholder(_response);
            throw _response;
        });
    }

    protected processCopyShareholder(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    inviteApplicant(uniqueId: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/casemember/inviteApplicant?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processInviteApplicant(_response);
        }, (_response) => {
            if (_response.status)
                return this.processInviteApplicant(_response);
            throw _response;
        });
    }

    protected processInviteApplicant(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    securityCheck(body: SecurityCheckMessageRequest): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/casemember/securityCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSecurityCheck(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSecurityCheck(_response);
            throw _response;
        });
    }

    protected processSecurityCheck(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getSecurityQuestions(uniqueId: string): ng.IPromise<SecurityQuestionEnum> {
        let url_ = this.baseUrl + "/api/casemember/getsecurityquestions?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSecurityQuestions(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSecurityQuestions(_response);
            throw _response;
        });
    }

    protected processGetSecurityQuestions(response: any): ng.IPromise<SecurityQuestionEnum> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SecurityQuestionEnum;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SecurityQuestionEnum>(null as any);
    }

    /**
     * @return OK
     */
    fetchCaseMemberAndReturnEmail(uniqueId: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/casemember/fetchCaseMemberAndReturnEmail?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchCaseMemberAndReturnEmail(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchCaseMemberAndReturnEmail(_response);
            throw _response;
        });
    }

    protected processFetchCaseMemberAndReturnEmail(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    fetchCaseMemberAndReturnRegisterInformation(uniqueId: string): ng.IPromise<CaseMember> {
        let url_ = this.baseUrl + "/api/casemember/FetchCaseMemberAndReturnRegisterInformation?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchCaseMemberAndReturnRegisterInformation(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchCaseMemberAndReturnRegisterInformation(_response);
            throw _response;
        });
    }

    protected processFetchCaseMemberAndReturnRegisterInformation(response: any): ng.IPromise<CaseMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleteAndSetNextCaseMemberAsPrimary(caseId: number, caseMemberId: number): ng.IPromise<CaseMember[]> {
        let url_ = this.baseUrl + "/api/casemember/MarkAsDeleteAndSetNextCaseMemberAsPrimary?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (caseMemberId === undefined || caseMemberId === null)
            throw new Error("The parameter 'caseMemberId' must be defined and cannot be null.");
        else
            url_ += "caseMemberId=" + encodeURIComponent("" + caseMemberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleteAndSetNextCaseMemberAsPrimary(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleteAndSetNextCaseMemberAsPrimary(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleteAndSetNextCaseMemberAsPrimary(response: any): ng.IPromise<CaseMember[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember[]>(null as any);
    }

    /**
     * @return OK
     */
    saveAddressHistory(caseMemberId: number, body: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/casemember/saveaddresshistory?";
        if (caseMemberId === undefined || caseMemberId === null)
            throw new Error("The parameter 'caseMemberId' must be defined and cannot be null.");
        else
            url_ += "caseMemberId=" + encodeURIComponent("" + caseMemberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveAddressHistory(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveAddressHistory(_response);
            throw _response;
        });
    }

    protected processSaveAddressHistory(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getWebConfigValue(): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/casemember/getWebConfigValue";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetWebConfigValue(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetWebConfigValue(_response);
            throw _response;
        });
    }

    protected processGetWebConfigValue(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    addorUpdateCaseMember(sendInviteEmail: boolean, body: CaseMember): ng.IPromise<CaseMember> {
        let url_ = this.baseUrl + "/api/casemember/addorupdatecasemember?";
        if (sendInviteEmail === undefined || sendInviteEmail === null)
            throw new Error("The parameter 'sendInviteEmail' must be defined and cannot be null.");
        else
            url_ += "sendInviteEmail=" + encodeURIComponent("" + sendInviteEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddorUpdateCaseMember(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddorUpdateCaseMember(_response);
            throw _response;
        });
    }

    protected processAddorUpdateCaseMember(response: any): ng.IPromise<CaseMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember>(null as any);
    }

    /**
     * @return OK
     */
    fetchCaseMembersWithAccess(caseId: number): ng.IPromise<CaseMember[]> {
        let url_ = this.baseUrl + "/api/casemember/fetchcasememberswithaccess?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchCaseMembersWithAccess(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchCaseMembersWithAccess(_response);
            throw _response;
        });
    }

    protected processFetchCaseMembersWithAccess(response: any): ng.IPromise<CaseMember[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateCustom(body: CaseMember): ng.IPromise<CaseMember> {
        let url_ = this.baseUrl + "/api/casemember/addupdatecustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateCustom(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateCustom(_response);
            throw _response;
        });
    }

    protected processAddUpdateCustom(response: any): ng.IPromise<CaseMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<CaseMember[]> {
        let url_ = this.baseUrl + "/api/casemember/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<CaseMember[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<CaseMember> {
        let url_ = this.baseUrl + "/api/casemember/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<CaseMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/casemember/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<CaseMemberPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/casemember/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<CaseMemberPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMemberPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMemberPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<CaseMemberPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/casemember/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<CaseMemberPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMemberPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMemberPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: CaseMember): ng.IPromise<CaseMember> {
        let url_ = this.baseUrl + "/api/casemember/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<CaseMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: CaseMember): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/casemember/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: CaseMember[]): ng.IPromise<CaseMember[]> {
        let url_ = this.baseUrl + "/api/casemember/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<CaseMember[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: CaseMember[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/casemember/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/casemember/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/casemember/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CaseMemberCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous16> {
        let url_ = this.baseUrl + "/odata/CaseMemberOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous16> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous16;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous16>(null as any);
    }

    /**
     * @return OK
     */
    post(body: CaseMemberInsert): ng.IPromise<CaseMember> {
        let url_ = this.baseUrl + "/api/crud/casemember/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<CaseMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: CaseMemberUpdate): ng.IPromise<CaseMember> {
        let url_ = this.baseUrl + "/api/crud/casemember/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<CaseMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseMember>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/casemember/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/casemember/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CaseNoteClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<CaseNote[]> {
        let url_ = this.baseUrl + "/api/casenote/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<CaseNote[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseNote[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseNote[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<CaseNote> {
        let url_ = this.baseUrl + "/api/casenote/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<CaseNote> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseNote;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseNote>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/casenote/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<CaseNotePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/casenote/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<CaseNotePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseNotePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseNotePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<CaseNotePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/casenote/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<CaseNotePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseNotePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseNotePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: CaseNote): ng.IPromise<CaseNote> {
        let url_ = this.baseUrl + "/api/casenote/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<CaseNote> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseNote;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseNote>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: CaseNote): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/casenote/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: CaseNote[]): ng.IPromise<CaseNote[]> {
        let url_ = this.baseUrl + "/api/casenote/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<CaseNote[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseNote[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseNote[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: CaseNote[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/casenote/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/casenote/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/casenote/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CaseNoteCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous17> {
        let url_ = this.baseUrl + "/odata/CaseNoteOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous17> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous17;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous17>(null as any);
    }

    /**
     * @return OK
     */
    post(body: CaseNoteInsert): ng.IPromise<CaseNote> {
        let url_ = this.baseUrl + "/api/crud/casenote/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<CaseNote> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseNote;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseNote>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: CaseNoteUpdate): ng.IPromise<CaseNote> {
        let url_ = this.baseUrl + "/api/crud/casenote/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<CaseNote> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseNote;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseNote>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/casenote/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/casenote/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ClaimClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    clearUserClaimsCache(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/Claim/ClearUserClaimsCache";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processClearUserClaimsCache(_response);
        }, (_response) => {
            if (_response.status)
                return this.processClearUserClaimsCache(_response);
            throw _response;
        });
    }

    protected processClearUserClaimsCache(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    resetDatabase(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/Claim/ResetDatabase";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processResetDatabase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processResetDatabase(_response);
            throw _response;
        });
    }

    protected processResetDatabase(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getMyClaims(): ng.IPromise<AppClaimsEnum[]> {
        let url_ = this.baseUrl + "/api/Claim/GetMyClaims";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMyClaims(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMyClaims(_response);
            throw _response;
        });
    }

    protected processGetMyClaims(response: any): ng.IPromise<AppClaimsEnum[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppClaimsEnum[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppClaimsEnum[]>(null as any);
    }

    /**
     * @return OK
     */
    getMyUserSessionData(): ng.IPromise<UserSessionDataDTO> {
        let url_ = this.baseUrl + "/api/Claim/GetMyUserSessionData";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMyUserSessionData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMyUserSessionData(_response);
            throw _response;
        });
    }

    protected processGetMyUserSessionData(response: any): ng.IPromise<UserSessionDataDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSessionDataDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<UserSessionDataDTO>(null as any);
    }

    /**
     * @return OK
     */
    listAllClaims(includeUXClaims: boolean, includeServerClaims: boolean, includeTableClaims: boolean): ng.IPromise<StringStringListTuple[]> {
        let url_ = this.baseUrl + "/api/Claim/ListAllClaims?";
        if (includeUXClaims === undefined || includeUXClaims === null)
            throw new Error("The parameter 'includeUXClaims' must be defined and cannot be null.");
        else
            url_ += "includeUXClaims=" + encodeURIComponent("" + includeUXClaims) + "&";
        if (includeServerClaims === undefined || includeServerClaims === null)
            throw new Error("The parameter 'includeServerClaims' must be defined and cannot be null.");
        else
            url_ += "includeServerClaims=" + encodeURIComponent("" + includeServerClaims) + "&";
        if (includeTableClaims === undefined || includeTableClaims === null)
            throw new Error("The parameter 'includeTableClaims' must be defined and cannot be null.");
        else
            url_ += "includeTableClaims=" + encodeURIComponent("" + includeTableClaims) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListAllClaims(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListAllClaims(_response);
            throw _response;
        });
    }

    protected processListAllClaims(response: any): ng.IPromise<StringStringListTuple[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringStringListTuple[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<StringStringListTuple[]>(null as any);
    }

    /**
     * @return OK
     */
    listAllClaimsAsEnum(includeUXClaims: boolean, includeServerClaims: boolean, includeTableClaims: boolean): ng.IPromise<CustomClaimsTypesEnumStringInt32DictionaryListTuple[]> {
        let url_ = this.baseUrl + "/api/Claim/ListAllClaimsAsEnum?";
        if (includeUXClaims === undefined || includeUXClaims === null)
            throw new Error("The parameter 'includeUXClaims' must be defined and cannot be null.");
        else
            url_ += "includeUXClaims=" + encodeURIComponent("" + includeUXClaims) + "&";
        if (includeServerClaims === undefined || includeServerClaims === null)
            throw new Error("The parameter 'includeServerClaims' must be defined and cannot be null.");
        else
            url_ += "includeServerClaims=" + encodeURIComponent("" + includeServerClaims) + "&";
        if (includeTableClaims === undefined || includeTableClaims === null)
            throw new Error("The parameter 'includeTableClaims' must be defined and cannot be null.");
        else
            url_ += "includeTableClaims=" + encodeURIComponent("" + includeTableClaims) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListAllClaimsAsEnum(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListAllClaimsAsEnum(_response);
            throw _response;
        });
    }

    protected processListAllClaimsAsEnum(response: any): ng.IPromise<CustomClaimsTypesEnumStringInt32DictionaryListTuple[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomClaimsTypesEnumStringInt32DictionaryListTuple[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CustomClaimsTypesEnumStringInt32DictionaryListTuple[]>(null as any);
    }

    /**
     * @return OK
     */
    listAllClaimsAsEnumWithDescription(includeUXClaims: boolean, includeServerClaims: boolean, includeTableClaims: boolean): ng.IPromise<CustomClaimsTypesEnumStringInt32DictionaryStringTupleListTuple[]> {
        let url_ = this.baseUrl + "/api/Claim/ListAllClaimsAsEnumWithDescription?";
        if (includeUXClaims === undefined || includeUXClaims === null)
            throw new Error("The parameter 'includeUXClaims' must be defined and cannot be null.");
        else
            url_ += "includeUXClaims=" + encodeURIComponent("" + includeUXClaims) + "&";
        if (includeServerClaims === undefined || includeServerClaims === null)
            throw new Error("The parameter 'includeServerClaims' must be defined and cannot be null.");
        else
            url_ += "includeServerClaims=" + encodeURIComponent("" + includeServerClaims) + "&";
        if (includeTableClaims === undefined || includeTableClaims === null)
            throw new Error("The parameter 'includeTableClaims' must be defined and cannot be null.");
        else
            url_ += "includeTableClaims=" + encodeURIComponent("" + includeTableClaims) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListAllClaimsAsEnumWithDescription(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListAllClaimsAsEnumWithDescription(_response);
            throw _response;
        });
    }

    protected processListAllClaimsAsEnumWithDescription(response: any): ng.IPromise<CustomClaimsTypesEnumStringInt32DictionaryStringTupleListTuple[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomClaimsTypesEnumStringInt32DictionaryStringTupleListTuple[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CustomClaimsTypesEnumStringInt32DictionaryStringTupleListTuple[]>(null as any);
    }

    /**
     * @return OK
     */
    listTablesWithRowLevelPermissions(): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/Claim/ListTablesWithRowLevelPermissions";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListTablesWithRowLevelPermissions(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListTablesWithRowLevelPermissions(_response);
            throw _response;
        });
    }

    protected processListTablesWithRowLevelPermissions(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    getEntitiesWithPermissions(tableName: string): ng.IPromise<EntityWithPermissionsDTO[]> {
        let url_ = this.baseUrl + "/api/Claim/GetEntitiesWithPermissions?";
        if (tableName === undefined || tableName === null)
            throw new Error("The parameter 'tableName' must be defined and cannot be null.");
        else
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetEntitiesWithPermissions(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetEntitiesWithPermissions(_response);
            throw _response;
        });
    }

    protected processGetEntitiesWithPermissions(response: any): ng.IPromise<EntityWithPermissionsDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityWithPermissionsDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<EntityWithPermissionsDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    renameAppUserGroup(newGroupName: string, currentGroupId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/Claim/RenameAppUserGroup?";
        if (newGroupName === undefined || newGroupName === null)
            throw new Error("The parameter 'newGroupName' must be defined and cannot be null.");
        else
            url_ += "newGroupName=" + encodeURIComponent("" + newGroupName) + "&";
        if (currentGroupId === undefined || currentGroupId === null)
            throw new Error("The parameter 'currentGroupId' must be defined and cannot be null.");
        else
            url_ += "currentGroupId=" + encodeURIComponent("" + currentGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRenameAppUserGroup(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRenameAppUserGroup(_response);
            throw _response;
        });
    }

    protected processRenameAppUserGroup(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    createNewApplicationUserGroup(groupName: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/Claim/CreateNewApplicationUserGroup?";
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined and cannot be null.");
        else
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateNewApplicationUserGroup(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateNewApplicationUserGroup(_response);
            throw _response;
        });
    }

    protected processCreateNewApplicationUserGroup(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    renameClaimGroup(newGroupName: string, currentGroupName: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/Claim/RenameClaimGroup?";
        if (newGroupName === undefined || newGroupName === null)
            throw new Error("The parameter 'newGroupName' must be defined and cannot be null.");
        else
            url_ += "newGroupName=" + encodeURIComponent("" + newGroupName) + "&";
        if (currentGroupName === undefined || currentGroupName === null)
            throw new Error("The parameter 'currentGroupName' must be defined and cannot be null.");
        else
            url_ += "currentGroupName=" + encodeURIComponent("" + currentGroupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRenameClaimGroup(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRenameClaimGroup(_response);
            throw _response;
        });
    }

    protected processRenameClaimGroup(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    deleteClaimGroupByName(groupName: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/Claim/DeleteClaimGroupByName?";
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined and cannot be null.");
        else
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDeleteClaimGroupByName(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDeleteClaimGroupByName(_response);
            throw _response;
        });
    }

    protected processDeleteClaimGroupByName(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    createNewClaimGroup(groupName: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/Claim/CreateNewClaimGroup?";
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined and cannot be null.");
        else
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateNewClaimGroup(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateNewClaimGroup(_response);
            throw _response;
        });
    }

    protected processCreateNewClaimGroup(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    deleteAppUserGroup(groupToDeleteId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/Claim/DeleteAppUserGroup?";
        if (groupToDeleteId === undefined || groupToDeleteId === null)
            throw new Error("The parameter 'groupToDeleteId' must be defined and cannot be null.");
        else
            url_ += "groupToDeleteId=" + encodeURIComponent("" + groupToDeleteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDeleteAppUserGroup(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDeleteAppUserGroup(_response);
            throw _response;
        });
    }

    protected processDeleteAppUserGroup(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    checkForAdminRole(userName: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/Claim/CheckForAdminRole?";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCheckForAdminRole(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCheckForAdminRole(_response);
            throw _response;
        });
    }

    protected processCheckForAdminRole(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    checkForUsers(): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/Claim/CheckForUsers";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCheckForUsers(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCheckForUsers(_response);
            throw _response;
        });
    }

    protected processCheckForUsers(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getOIDCConfig(): ng.IPromise<OidcConfigDTO[]> {
        let url_ = this.baseUrl + "/api/Claim/GetOIDCConfig";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOIDCConfig(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOIDCConfig(_response);
            throw _response;
        });
    }

    protected processGetOIDCConfig(response: any): ng.IPromise<OidcConfigDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OidcConfigDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OidcConfigDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    addRemoveUpdateClaimGroupsToAppUserOrUsers(body: ClaimGroupAddUpdateDeleteDTO): ng.IPromise<ClaimGroupsInApplicationUser[]> {
        let url_ = this.baseUrl + "/api/Claim/AddRemoveUpdateClaimGroupsToAppUserOrUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddRemoveUpdateClaimGroupsToAppUserOrUsers(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddRemoveUpdateClaimGroupsToAppUserOrUsers(_response);
            throw _response;
        });
    }

    protected processAddRemoveUpdateClaimGroupsToAppUserOrUsers(response: any): ng.IPromise<ClaimGroupsInApplicationUser[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClaimGroupsInApplicationUser[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ClaimGroupsInApplicationUser[]>(null as any);
    }

    /**
     * @return OK
     */
    addRemoveUpdateClaimGroupsToClaimGroupOrClaimGroups(body: ClaimGroupAddUpdateDeleteDTO): ng.IPromise<ClaimGroupsInClaimGroup[]> {
        let url_ = this.baseUrl + "/api/Claim/AddRemoveUpdateClaimGroupsToClaimGroupOrClaimGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddRemoveUpdateClaimGroupsToClaimGroupOrClaimGroups(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddRemoveUpdateClaimGroupsToClaimGroupOrClaimGroups(_response);
            throw _response;
        });
    }

    protected processAddRemoveUpdateClaimGroupsToClaimGroupOrClaimGroups(response: any): ng.IPromise<ClaimGroupsInClaimGroup[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClaimGroupsInClaimGroup[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ClaimGroupsInClaimGroup[]>(null as any);
    }

    /**
     * @return OK
     */
    addRemoveUpdateClaimGroupsToAppUserGroupOrUserGroups(body: ClaimGroupAddUpdateDeleteDTO): ng.IPromise<ClaimGroupsInApplicationUserGroup[]> {
        let url_ = this.baseUrl + "/api/Claim/AddRemoveUpdateClaimGroupsToAppUserGroupOrUserGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddRemoveUpdateClaimGroupsToAppUserGroupOrUserGroups(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddRemoveUpdateClaimGroupsToAppUserGroupOrUserGroups(_response);
            throw _response;
        });
    }

    protected processAddRemoveUpdateClaimGroupsToAppUserGroupOrUserGroups(response: any): ng.IPromise<ClaimGroupsInApplicationUserGroup[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClaimGroupsInApplicationUserGroup[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ClaimGroupsInApplicationUserGroup[]>(null as any);
    }

    /**
     * @return OK
     */
    addRemoveUpdateClaimsToAppUserOrUsers(body: ClaimEnumsToAddUpdateDeleteDTO): ng.IPromise<ClaimEnumsInApplicationUser[]> {
        let url_ = this.baseUrl + "/api/Claim/AddRemoveUpdateClaimsToAppUserOrUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddRemoveUpdateClaimsToAppUserOrUsers(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddRemoveUpdateClaimsToAppUserOrUsers(_response);
            throw _response;
        });
    }

    protected processAddRemoveUpdateClaimsToAppUserOrUsers(response: any): ng.IPromise<ClaimEnumsInApplicationUser[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClaimEnumsInApplicationUser[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ClaimEnumsInApplicationUser[]>(null as any);
    }

    /**
     * @return OK
     */
    addRemoveUpdateClaimsToClaimGroupOrClaimGroups(body: ClaimEnumsToAddUpdateDeleteDTO): ng.IPromise<ClaimEnumsInClaimGroup[]> {
        let url_ = this.baseUrl + "/api/Claim/AddRemoveUpdateClaimsToClaimGroupOrClaimGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddRemoveUpdateClaimsToClaimGroupOrClaimGroups(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddRemoveUpdateClaimsToClaimGroupOrClaimGroups(_response);
            throw _response;
        });
    }

    protected processAddRemoveUpdateClaimsToClaimGroupOrClaimGroups(response: any): ng.IPromise<ClaimEnumsInClaimGroup[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClaimEnumsInClaimGroup[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ClaimEnumsInClaimGroup[]>(null as any);
    }

    /**
     * @return OK
     */
    addRemoveUpdateClaimsToAppUserGroupOrUserGroups(body: ClaimEnumsToAddUpdateDeleteDTO): ng.IPromise<ClaimEnumsInApplicationUserGroup[]> {
        let url_ = this.baseUrl + "/api/Claim/AddRemoveUpdateClaimsToAppUserGroupOrUserGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddRemoveUpdateClaimsToAppUserGroupOrUserGroups(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddRemoveUpdateClaimsToAppUserGroupOrUserGroups(_response);
            throw _response;
        });
    }

    protected processAddRemoveUpdateClaimsToAppUserGroupOrUserGroups(response: any): ng.IPromise<ClaimEnumsInApplicationUserGroup[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClaimEnumsInApplicationUserGroup[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ClaimEnumsInApplicationUserGroup[]>(null as any);
    }

    /**
     * @return OK
     */
    addRemoveUpdateAppUsersInAppuserGroups(body: ApplicationUsersToApplicationUserGroupsDTO): ng.IPromise<ApplicationUserApplicationUserGroup[]> {
        let url_ = this.baseUrl + "/api/Claim/AddRemoveUpdateAppUsersInAppuserGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddRemoveUpdateAppUsersInAppuserGroups(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddRemoveUpdateAppUsersInAppuserGroups(_response);
            throw _response;
        });
    }

    protected processAddRemoveUpdateAppUsersInAppuserGroups(response: any): ng.IPromise<ApplicationUserApplicationUserGroup[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUserApplicationUserGroup[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUserApplicationUserGroup[]>(null as any);
    }

    /**
     * @return OK
     */
    addRemoveUpdatePermsOnEntityRowsForApplicationUsers(recordTablesWithIdsInSetToAddRemovePermissionsFromTo: DataRecordAddUpdateDeletePermissionTableSubListDTO[], claimSets: number[], permTypes: PermissionTypesOnDataEnum, removeExistingUnMentioned: boolean): ng.IPromise<StringBaseDataMultiOwnerListTuple[]> {
        let url_ = this.baseUrl + "/api/Claim/AddRemoveUpdatePermsOnEntityRowsForApplicationUsers?";
        if (recordTablesWithIdsInSetToAddRemovePermissionsFromTo === undefined || recordTablesWithIdsInSetToAddRemovePermissionsFromTo === null)
            throw new Error("The parameter 'recordTablesWithIdsInSetToAddRemovePermissionsFromTo' must be defined and cannot be null.");
        else
            recordTablesWithIdsInSetToAddRemovePermissionsFromTo && recordTablesWithIdsInSetToAddRemovePermissionsFromTo.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "RecordTablesWithIdsInSetToAddRemovePermissionsFromTo[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (claimSets === undefined || claimSets === null)
            throw new Error("The parameter 'claimSets' must be defined and cannot be null.");
        else
            claimSets && claimSets.forEach(item => { url_ += "ClaimSets=" + encodeURIComponent("" + item) + "&"; });
        if (permTypes === undefined || permTypes === null)
            throw new Error("The parameter 'permTypes' must be defined and cannot be null.");
        else
            url_ += "PermTypes=" + encodeURIComponent("" + permTypes) + "&";
        if (removeExistingUnMentioned === undefined || removeExistingUnMentioned === null)
            throw new Error("The parameter 'removeExistingUnMentioned' must be defined and cannot be null.");
        else
            url_ += "RemoveExistingUnMentioned=" + encodeURIComponent("" + removeExistingUnMentioned) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddRemoveUpdatePermsOnEntityRowsForApplicationUsers(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddRemoveUpdatePermsOnEntityRowsForApplicationUsers(_response);
            throw _response;
        });
    }

    protected processAddRemoveUpdatePermsOnEntityRowsForApplicationUsers(response: any): ng.IPromise<StringBaseDataMultiOwnerListTuple[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringBaseDataMultiOwnerListTuple[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<StringBaseDataMultiOwnerListTuple[]>(null as any);
    }

    /**
     * @return OK
     */
    addRemoveUpdatePermsOnEntityRowsForApplicationUserGroups(recordTablesWithIdsInSetToAddRemovePermissionsFromTo: DataRecordAddUpdateDeletePermissionTableSubListDTO[], claimSets: number[], permTypes: PermissionTypesOnDataEnum, removeExistingUnMentioned: boolean): ng.IPromise<StringBaseDataMultiOwnerListTuple[]> {
        let url_ = this.baseUrl + "/api/Claim/AddRemoveUpdatePermsOnEntityRowsForApplicationUserGroups?";
        if (recordTablesWithIdsInSetToAddRemovePermissionsFromTo === undefined || recordTablesWithIdsInSetToAddRemovePermissionsFromTo === null)
            throw new Error("The parameter 'recordTablesWithIdsInSetToAddRemovePermissionsFromTo' must be defined and cannot be null.");
        else
            recordTablesWithIdsInSetToAddRemovePermissionsFromTo && recordTablesWithIdsInSetToAddRemovePermissionsFromTo.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "RecordTablesWithIdsInSetToAddRemovePermissionsFromTo[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (claimSets === undefined || claimSets === null)
            throw new Error("The parameter 'claimSets' must be defined and cannot be null.");
        else
            claimSets && claimSets.forEach(item => { url_ += "ClaimSets=" + encodeURIComponent("" + item) + "&"; });
        if (permTypes === undefined || permTypes === null)
            throw new Error("The parameter 'permTypes' must be defined and cannot be null.");
        else
            url_ += "PermTypes=" + encodeURIComponent("" + permTypes) + "&";
        if (removeExistingUnMentioned === undefined || removeExistingUnMentioned === null)
            throw new Error("The parameter 'removeExistingUnMentioned' must be defined and cannot be null.");
        else
            url_ += "RemoveExistingUnMentioned=" + encodeURIComponent("" + removeExistingUnMentioned) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddRemoveUpdatePermsOnEntityRowsForApplicationUserGroups(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddRemoveUpdatePermsOnEntityRowsForApplicationUserGroups(_response);
            throw _response;
        });
    }

    protected processAddRemoveUpdatePermsOnEntityRowsForApplicationUserGroups(response: any): ng.IPromise<StringBaseDataMultiOwnerListTuple[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringBaseDataMultiOwnerListTuple[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<StringBaseDataMultiOwnerListTuple[]>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    applicationUsersPaged(includeClaims: boolean, includeApplicationUserGroups: boolean, includeClaimGroups: boolean, page: number | null, count?: number | null | undefined): ng.IPromise<ApplicationUserPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/Claim/ApplicationUsersPaged?";
        if (includeClaims === undefined || includeClaims === null)
            throw new Error("The parameter 'includeClaims' must be defined and cannot be null.");
        else
            url_ += "includeClaims=" + encodeURIComponent("" + includeClaims) + "&";
        if (includeApplicationUserGroups === undefined || includeApplicationUserGroups === null)
            throw new Error("The parameter 'includeApplicationUserGroups' must be defined and cannot be null.");
        else
            url_ += "IncludeApplicationUserGroups=" + encodeURIComponent("" + includeApplicationUserGroups) + "&";
        if (includeClaimGroups === undefined || includeClaimGroups === null)
            throw new Error("The parameter 'includeClaimGroups' must be defined and cannot be null.");
        else
            url_ += "includeClaimGroups=" + encodeURIComponent("" + includeClaimGroups) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processApplicationUsersPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processApplicationUsersPaged(_response);
            throw _response;
        });
    }

    protected processApplicationUsersPaged(response: any): ng.IPromise<ApplicationUserPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUserPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUserPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    applicationList(includeClaims: boolean, includeApplicationUserGroups: boolean, includeClaimGroups: boolean): ng.IPromise<ApplicationUser[]> {
        let url_ = this.baseUrl + "/api/Claim/ApplicationList?";
        if (includeClaims === undefined || includeClaims === null)
            throw new Error("The parameter 'includeClaims' must be defined and cannot be null.");
        else
            url_ += "includeClaims=" + encodeURIComponent("" + includeClaims) + "&";
        if (includeApplicationUserGroups === undefined || includeApplicationUserGroups === null)
            throw new Error("The parameter 'includeApplicationUserGroups' must be defined and cannot be null.");
        else
            url_ += "IncludeApplicationUserGroups=" + encodeURIComponent("" + includeApplicationUserGroups) + "&";
        if (includeClaimGroups === undefined || includeClaimGroups === null)
            throw new Error("The parameter 'includeClaimGroups' must be defined and cannot be null.");
        else
            url_ += "includeClaimGroups=" + encodeURIComponent("" + includeClaimGroups) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processApplicationList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processApplicationList(_response);
            throw _response;
        });
    }

    protected processApplicationList(response: any): ng.IPromise<ApplicationUser[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser[]>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    applicationUserGroupsPaged(includeClaims: boolean, includeApplicationUserGroups: boolean, includeClaimGroups: boolean, page: number | null, count?: number | null | undefined): ng.IPromise<ApplicationUserGroupPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/Claim/ApplicationUserGroupsPaged?";
        if (includeClaims === undefined || includeClaims === null)
            throw new Error("The parameter 'includeClaims' must be defined and cannot be null.");
        else
            url_ += "includeClaims=" + encodeURIComponent("" + includeClaims) + "&";
        if (includeApplicationUserGroups === undefined || includeApplicationUserGroups === null)
            throw new Error("The parameter 'includeApplicationUserGroups' must be defined and cannot be null.");
        else
            url_ += "IncludeApplicationUserGroups=" + encodeURIComponent("" + includeApplicationUserGroups) + "&";
        if (includeClaimGroups === undefined || includeClaimGroups === null)
            throw new Error("The parameter 'includeClaimGroups' must be defined and cannot be null.");
        else
            url_ += "includeClaimGroups=" + encodeURIComponent("" + includeClaimGroups) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processApplicationUserGroupsPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processApplicationUserGroupsPaged(_response);
            throw _response;
        });
    }

    protected processApplicationUserGroupsPaged(response: any): ng.IPromise<ApplicationUserGroupPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUserGroupPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUserGroupPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    applicationUserGroupsList(includeClaims: boolean, includeApplicationUserGroups: boolean, includeClaimGroups: boolean): ng.IPromise<ApplicationUserGroup[]> {
        let url_ = this.baseUrl + "/api/Claim/ApplicationUserGroupsList?";
        if (includeClaims === undefined || includeClaims === null)
            throw new Error("The parameter 'includeClaims' must be defined and cannot be null.");
        else
            url_ += "includeClaims=" + encodeURIComponent("" + includeClaims) + "&";
        if (includeApplicationUserGroups === undefined || includeApplicationUserGroups === null)
            throw new Error("The parameter 'includeApplicationUserGroups' must be defined and cannot be null.");
        else
            url_ += "IncludeApplicationUserGroups=" + encodeURIComponent("" + includeApplicationUserGroups) + "&";
        if (includeClaimGroups === undefined || includeClaimGroups === null)
            throw new Error("The parameter 'includeClaimGroups' must be defined and cannot be null.");
        else
            url_ += "includeClaimGroups=" + encodeURIComponent("" + includeClaimGroups) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processApplicationUserGroupsList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processApplicationUserGroupsList(_response);
            throw _response;
        });
    }

    protected processApplicationUserGroupsList(response: any): ng.IPromise<ApplicationUserGroup[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUserGroup[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUserGroup[]>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    claimGroupsPaged(includeClaims: boolean, includeApplicationUserGroups: boolean, includeApplicationUsers: boolean, includeClaimGroups: boolean, page: number | null, count?: number | null | undefined): ng.IPromise<ClaimGroupPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/Claim/ClaimGroupsPaged?";
        if (includeClaims === undefined || includeClaims === null)
            throw new Error("The parameter 'includeClaims' must be defined and cannot be null.");
        else
            url_ += "includeClaims=" + encodeURIComponent("" + includeClaims) + "&";
        if (includeApplicationUserGroups === undefined || includeApplicationUserGroups === null)
            throw new Error("The parameter 'includeApplicationUserGroups' must be defined and cannot be null.");
        else
            url_ += "IncludeApplicationUserGroups=" + encodeURIComponent("" + includeApplicationUserGroups) + "&";
        if (includeApplicationUsers === undefined || includeApplicationUsers === null)
            throw new Error("The parameter 'includeApplicationUsers' must be defined and cannot be null.");
        else
            url_ += "IncludeApplicationUsers=" + encodeURIComponent("" + includeApplicationUsers) + "&";
        if (includeClaimGroups === undefined || includeClaimGroups === null)
            throw new Error("The parameter 'includeClaimGroups' must be defined and cannot be null.");
        else
            url_ += "includeClaimGroups=" + encodeURIComponent("" + includeClaimGroups) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processClaimGroupsPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processClaimGroupsPaged(_response);
            throw _response;
        });
    }

    protected processClaimGroupsPaged(response: any): ng.IPromise<ClaimGroupPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClaimGroupPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ClaimGroupPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    claimGroupsList(includeClaims: boolean, includeApplicationUserGroups: boolean, includeApplicationUsers: boolean, includeClaimGroups: boolean): ng.IPromise<ClaimGroup[]> {
        let url_ = this.baseUrl + "/api/Claim/ClaimGroupsList?";
        if (includeClaims === undefined || includeClaims === null)
            throw new Error("The parameter 'includeClaims' must be defined and cannot be null.");
        else
            url_ += "includeClaims=" + encodeURIComponent("" + includeClaims) + "&";
        if (includeApplicationUserGroups === undefined || includeApplicationUserGroups === null)
            throw new Error("The parameter 'includeApplicationUserGroups' must be defined and cannot be null.");
        else
            url_ += "IncludeApplicationUserGroups=" + encodeURIComponent("" + includeApplicationUserGroups) + "&";
        if (includeApplicationUsers === undefined || includeApplicationUsers === null)
            throw new Error("The parameter 'includeApplicationUsers' must be defined and cannot be null.");
        else
            url_ += "IncludeApplicationUsers=" + encodeURIComponent("" + includeApplicationUsers) + "&";
        if (includeClaimGroups === undefined || includeClaimGroups === null)
            throw new Error("The parameter 'includeClaimGroups' must be defined and cannot be null.");
        else
            url_ += "includeClaimGroups=" + encodeURIComponent("" + includeClaimGroups) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processClaimGroupsList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processClaimGroupsList(_response);
            throw _response;
        });
    }

    protected processClaimGroupsList(response: any): ng.IPromise<ClaimGroup[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClaimGroup[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ClaimGroup[]>(null as any);
    }

    /**
     * @return OK
     */
    addListIfNotExists(reset: boolean): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/Claim/AddListIfNotExists?";
        if (reset === undefined || reset === null)
            throw new Error("The parameter 'reset' must be defined and cannot be null.");
        else
            url_ += "reset=" + encodeURIComponent("" + reset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddListIfNotExists(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddListIfNotExists(_response);
            throw _response;
        });
    }

    protected processAddListIfNotExists(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ClientClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    fetchListByDealId(dealId: number): ng.IPromise<Client[]> {
        let url_ = this.baseUrl + "/api/client/fetchbydealid?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchListByDealId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchListByDealId(_response);
            throw _response;
        });
    }

    protected processFetchListByDealId(response: any): ng.IPromise<Client[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Client[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Client[]>(null as any);
    }

    /**
     * @return OK
     */
    fetchByDealClientUniqueRef(dealClientUniqueRef: string): ng.IPromise<Client> {
        let url_ = this.baseUrl + "/api/client/fetchbydealclientuniqueref?";
        if (dealClientUniqueRef === undefined || dealClientUniqueRef === null)
            throw new Error("The parameter 'dealClientUniqueRef' must be defined and cannot be null.");
        else
            url_ += "dealClientUniqueRef=" + encodeURIComponent("" + dealClientUniqueRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchByDealClientUniqueRef(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchByDealClientUniqueRef(_response);
            throw _response;
        });
    }

    protected processFetchByDealClientUniqueRef(response: any): ng.IPromise<Client> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Client;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Client>(null as any);
    }

    /**
     * @return OK
     * @deprecated
     */
    scheduleSearchAbandonedEmail(clientId: number, organisationId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/client/schedulesearchabandonedemail?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined and cannot be null.");
        else
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processScheduleSearchAbandonedEmail(_response);
        }, (_response) => {
            if (_response.status)
                return this.processScheduleSearchAbandonedEmail(_response);
            throw _response;
        });
    }

    protected processScheduleSearchAbandonedEmail(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    updateClientWithUserId(clientId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/client/updateclientwithuserid?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateClientWithUserId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateClientWithUserId(_response);
            throw _response;
        });
    }

    protected processUpdateClientWithUserId(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<Client[]> {
        let url_ = this.baseUrl + "/api/client/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<Client[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Client[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Client[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<Client> {
        let url_ = this.baseUrl + "/api/client/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<Client> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Client;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Client>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/client/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ClientPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/client/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ClientPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ClientPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ClientPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/client/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ClientPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ClientPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: Client): ng.IPromise<Client> {
        let url_ = this.baseUrl + "/api/client/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<Client> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Client;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Client>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: Client): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/client/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: Client[]): ng.IPromise<Client[]> {
        let url_ = this.baseUrl + "/api/client/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<Client[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Client[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Client[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: Client[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/client/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/client/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/client/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ClientCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous18> {
        let url_ = this.baseUrl + "/odata/ClientOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous18> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous18;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous18>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ClientInsert): ng.IPromise<Client> {
        let url_ = this.baseUrl + "/api/crud/client/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<Client> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Client;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Client>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ClientUpdate): ng.IPromise<Client> {
        let url_ = this.baseUrl + "/api/crud/client/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<Client> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Client;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Client>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/client/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/client/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CommercialDealClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    updateSearchAndGetResults(body: UpdateCommercialSearchGetResultRequest): ng.IPromise<UpdateCommercialSearchGetResultResponse> {
        let url_ = this.baseUrl + "/api/commercialdeal/updatesearchandgetresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateSearchAndGetResults(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateSearchAndGetResults(_response);
            throw _response;
        });
    }

    protected processUpdateSearchAndGetResults(response: any): ng.IPromise<UpdateCommercialSearchGetResultResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateCommercialSearchGetResultResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<UpdateCommercialSearchGetResultResponse>(null as any);
    }

    /**
     * @return OK
     */
    saveCommercialSearchReturnsId(body: SaveCommercialSearchRequest): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/commercialdeal/savecommercialsearchreturnsId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveCommercialSearchReturnsId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveCommercialSearchReturnsId(_response);
            throw _response;
        });
    }

    protected processSaveCommercialSearchReturnsId(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    saveCommercialSearchReturnsUniqueRef(body: SaveCommercialSearchRequest): ng.IPromise<SaveSearchReturnUniqueRefResponse> {
        let url_ = this.baseUrl + "/api/commercialdeal/savecommercialsearchreturnsuniqueref";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveCommercialSearchReturnsUniqueRef(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveCommercialSearchReturnsUniqueRef(_response);
            throw _response;
        });
    }

    protected processSaveCommercialSearchReturnsUniqueRef(response: any): ng.IPromise<SaveSearchReturnUniqueRefResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaveSearchReturnUniqueRefResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SaveSearchReturnUniqueRefResponse>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<CommercialDeal[]> {
        let url_ = this.baseUrl + "/api/commercialdeal/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<CommercialDeal[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommercialDeal[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CommercialDeal[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<CommercialDeal> {
        let url_ = this.baseUrl + "/api/commercialdeal/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<CommercialDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommercialDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CommercialDeal>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/commercialdeal/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<CommercialDealPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/commercialdeal/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<CommercialDealPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommercialDealPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CommercialDealPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<CommercialDealPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/commercialdeal/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<CommercialDealPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommercialDealPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CommercialDealPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: CommercialDeal): ng.IPromise<CommercialDeal> {
        let url_ = this.baseUrl + "/api/commercialdeal/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<CommercialDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommercialDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CommercialDeal>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: CommercialDeal): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/commercialdeal/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: CommercialDeal[]): ng.IPromise<CommercialDeal[]> {
        let url_ = this.baseUrl + "/api/commercialdeal/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<CommercialDeal[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommercialDeal[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CommercialDeal[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: CommercialDeal[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/commercialdeal/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/commercialdeal/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/commercialdeal/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CommercialDealCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous19> {
        let url_ = this.baseUrl + "/odata/CommercialDealOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous19> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous19;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous19>(null as any);
    }

    /**
     * @return OK
     */
    post(body: CommercialDealInsert): ng.IPromise<CommercialDeal> {
        let url_ = this.baseUrl + "/api/crud/commercialdeal/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<CommercialDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommercialDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CommercialDeal>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: CommercialDealUpdate): ng.IPromise<CommercialDeal> {
        let url_ = this.baseUrl + "/api/crud/commercialdeal/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<CommercialDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommercialDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CommercialDeal>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/commercialdeal/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/commercialdeal/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class CommercialSearchResultsClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getSearchCriteriaAndResults(body: SearchResultsRequest): ng.IPromise<CommercialSearchResultsResponse> {
        let url_ = this.baseUrl + "/api/commercialsearchresults/getsearchcriteriaandresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSearchCriteriaAndResults(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSearchCriteriaAndResults(_response);
            throw _response;
        });
    }

    protected processGetSearchCriteriaAndResults(response: any): ng.IPromise<CommercialSearchResultsResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommercialSearchResultsResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CommercialSearchResultsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getSearchResults(body: SearchResultsRequest): ng.IPromise<CommercialSearchResultsResponse> {
        let url_ = this.baseUrl + "/api/commercialsearchresults/getsearchresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSearchResults(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSearchResults(_response);
            throw _response;
        });
    }

    protected processGetSearchResults(response: any): ng.IPromise<CommercialSearchResultsResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommercialSearchResultsResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CommercialSearchResultsResponse>(null as any);
    }

    /**
     * @param debug1 (optional) 
     * @param debug2 (optional) 
     * @param orgCode (optional) 
     * @param showLenderNamesAndLogosOverride (optional) 
     * @return OK
     */
    exportToPdf(body: CommercialDeal, debug1?: boolean | null | undefined, debug2?: boolean | null | undefined, orgCode?: string | undefined, showLenderNamesAndLogosOverride?: boolean | null | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/commercialsearchresults/exportsearchtopdf?";
        if (debug1 !== undefined && debug1 !== null)
            url_ += "debug1=" + encodeURIComponent("" + debug1) + "&";
        if (debug2 !== undefined && debug2 !== null)
            url_ += "debug2=" + encodeURIComponent("" + debug2) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (showLenderNamesAndLogosOverride !== undefined && showLenderNamesAndLogosOverride !== null)
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportToPdf(_response);
            throw _response;
        });
    }

    protected processExportToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param debug1 (optional) 
     * @param debug2 (optional) 
     * @param orgCode (optional) 
     * @param showLenderNamesAndLogosOverride (optional) 
     * @return OK
     */
    exportSearchToPdf(dealId: number, debug1?: boolean | undefined, debug2?: boolean | undefined, orgCode?: string | undefined, showLenderNamesAndLogosOverride?: boolean | null | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/commercialsearchresults/exportsearchtopdf?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (debug1 === null)
            throw new Error("The parameter 'debug1' cannot be null.");
        else if (debug1 !== undefined)
            url_ += "debug1=" + encodeURIComponent("" + debug1) + "&";
        if (debug2 === null)
            throw new Error("The parameter 'debug2' cannot be null.");
        else if (debug2 !== undefined)
            url_ += "debug2=" + encodeURIComponent("" + debug2) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (showLenderNamesAndLogosOverride !== undefined && showLenderNamesAndLogosOverride !== null)
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportSearchToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportSearchToPdf(_response);
            throw _response;
        });
    }

    protected processExportSearchToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param orgCode (optional) 
     * @return OK
     */
    exportShortListedResultsToPdf(showLenderNamesAndLogosOverride: boolean, body: CommercialDeal, orgCode?: string | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/commercialsearchresults/exportshortlistedresultstopdf?";
        if (showLenderNamesAndLogosOverride === undefined || showLenderNamesAndLogosOverride === null)
            throw new Error("The parameter 'showLenderNamesAndLogosOverride' must be defined and cannot be null.");
        else
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportShortListedResultsToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportShortListedResultsToPdf(_response);
            throw _response;
        });
    }

    protected processExportShortListedResultsToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }
}

export class ComparablePropertyClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<ComparableProperty[]> {
        let url_ = this.baseUrl + "/api/comparableproperty/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<ComparableProperty[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComparableProperty[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ComparableProperty[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<ComparableProperty> {
        let url_ = this.baseUrl + "/api/comparableproperty/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<ComparableProperty> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComparableProperty;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ComparableProperty>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/comparableproperty/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ComparablePropertyPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/comparableproperty/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ComparablePropertyPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComparablePropertyPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ComparablePropertyPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ComparablePropertyPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/comparableproperty/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ComparablePropertyPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComparablePropertyPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ComparablePropertyPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: ComparableProperty): ng.IPromise<ComparableProperty> {
        let url_ = this.baseUrl + "/api/comparableproperty/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<ComparableProperty> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComparableProperty;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ComparableProperty>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: ComparableProperty): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/comparableproperty/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: ComparableProperty[]): ng.IPromise<ComparableProperty[]> {
        let url_ = this.baseUrl + "/api/comparableproperty/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<ComparableProperty[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComparableProperty[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ComparableProperty[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: ComparableProperty[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/comparableproperty/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/comparableproperty/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/comparableproperty/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ComparablePropertyCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous20> {
        let url_ = this.baseUrl + "/odata/ComparablePropertyOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous20> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous20;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous20>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ComparablePropertyInsert): ng.IPromise<ComparableProperty> {
        let url_ = this.baseUrl + "/api/crud/comparableproperty/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<ComparableProperty> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComparableProperty;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ComparableProperty>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ComparablePropertyUpdate): ng.IPromise<ComparableProperty> {
        let url_ = this.baseUrl + "/api/crud/comparableproperty/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<ComparableProperty> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComparableProperty;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ComparableProperty>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/comparableproperty/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/comparableproperty/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DashboardClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getSearchesForUser(body: GetSearchesForUserRequest): ng.IPromise<GetSearchesForUserResponse> {
        let url_ = this.baseUrl + "/api/dashboard/getsearchesforuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSearchesForUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSearchesForUser(_response);
            throw _response;
        });
    }

    protected processGetSearchesForUser(response: any): ng.IPromise<GetSearchesForUserResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSearchesForUserResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<GetSearchesForUserResponse>(null as any);
    }

    /**
     * @return OK
     */
    getCasesForUser(body: GetCasesForUserRequest): ng.IPromise<GetSearchesForUserResponse> {
        let url_ = this.baseUrl + "/api/dashboard/getcasesforuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCasesForUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCasesForUser(_response);
            throw _response;
        });
    }

    protected processGetCasesForUser(response: any): ng.IPromise<GetSearchesForUserResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSearchesForUserResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<GetSearchesForUserResponse>(null as any);
    }

    /**
     * @param clientCaseName (optional) 
     * @param status (optional) 
     * @param bridgingProductType (optional) 
     * @return OK
     */
    getBridgingCases(cases: Deal[], userName: string, clientCaseName?: string | undefined, status?: CaseStatusEnum | null | undefined, bridgingProductType?: ProductTypeEnum | undefined): ng.IPromise<CaseSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/dashboard/getbridgingpreconstructioncases?";
        if (cases === undefined || cases === null)
            throw new Error("The parameter 'cases' must be defined and cannot be null.");
        else
            cases && cases.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "cases[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (clientCaseName === null)
            throw new Error("The parameter 'clientCaseName' cannot be null.");
        else if (clientCaseName !== undefined)
            url_ += "clientCaseName=" + encodeURIComponent("" + clientCaseName) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (bridgingProductType === null)
            throw new Error("The parameter 'bridgingProductType' cannot be null.");
        else if (bridgingProductType !== undefined)
            url_ += "bridgingProductType=" + encodeURIComponent("" + bridgingProductType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetBridgingCases(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetBridgingCases(_response);
            throw _response;
        });
    }

    protected processGetBridgingCases(response: any): ng.IPromise<CaseSummaryDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseSummaryDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseSummaryDTO[]>(null as any);
    }

    /**
     * @param clientCaseName (optional) 
     * @param status (optional) 
     * @param productType (optional) 
     * @return OK
     */
    getCommercialCases(cases: Deal[], userName: string, clientCaseName?: string | undefined, status?: CaseStatusEnum | null | undefined, productType?: ProductTypeEnum | undefined): ng.IPromise<CaseSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/dashboard/getcommercialcases?";
        if (cases === undefined || cases === null)
            throw new Error("The parameter 'cases' must be defined and cannot be null.");
        else
            cases && cases.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "cases[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (clientCaseName === null)
            throw new Error("The parameter 'clientCaseName' cannot be null.");
        else if (clientCaseName !== undefined)
            url_ += "clientCaseName=" + encodeURIComponent("" + clientCaseName) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (productType === null)
            throw new Error("The parameter 'productType' cannot be null.");
        else if (productType !== undefined)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCommercialCases(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCommercialCases(_response);
            throw _response;
        });
    }

    protected processGetCommercialCases(response: any): ng.IPromise<CaseSummaryDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseSummaryDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseSummaryDTO[]>(null as any);
    }
}

export class DealClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    fetchCustom(id: number): ng.IPromise<Deal> {
        let url_ = this.baseUrl + "/api/deal/FetchCustom?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchCustom(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchCustom(_response);
            throw _response;
        });
    }

    protected processFetchCustom(response: any): ng.IPromise<Deal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Deal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Deal>(null as any);
    }

    /**
     * @return OK
     */
    shareDeal(body: ShareDealDTO): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deal/sharedeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processShareDeal(_response);
        }, (_response) => {
            if (_response.status)
                return this.processShareDeal(_response);
            throw _response;
        });
    }

    protected processShareDeal(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    fetchByUniqueRef(dealUniqueRef: string): ng.IPromise<Deal> {
        let url_ = this.baseUrl + "/api/deal/fetchbyuniqueref?";
        if (dealUniqueRef === undefined || dealUniqueRef === null)
            throw new Error("The parameter 'dealUniqueRef' must be defined and cannot be null.");
        else
            url_ += "dealUniqueRef=" + encodeURIComponent("" + dealUniqueRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchByUniqueRef(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchByUniqueRef(_response);
            throw _response;
        });
    }

    protected processFetchByUniqueRef(response: any): ng.IPromise<Deal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Deal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Deal>(null as any);
    }

    /**
     * @return OK
     */
    assignBrokerToDeal(body: AssignBrokerToDealRequest): ng.IPromise<AssignBrokerToDealResponse> {
        let url_ = this.baseUrl + "/api/deal/assignbrokertodeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAssignBrokerToDeal(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAssignBrokerToDeal(_response);
            throw _response;
        });
    }

    protected processAssignBrokerToDeal(response: any): ng.IPromise<AssignBrokerToDealResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignBrokerToDealResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AssignBrokerToDealResponse>(null as any);
    }

    /**
     * @return OK
     */
    assignLenderToDeal(body: AssignLenderToDealRequest): ng.IPromise<AssignLenderToDealResponse> {
        let url_ = this.baseUrl + "/api/deal/assignlendertodeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAssignLenderToDeal(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAssignLenderToDeal(_response);
            throw _response;
        });
    }

    protected processAssignLenderToDeal(response: any): ng.IPromise<AssignLenderToDealResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignLenderToDealResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AssignLenderToDealResponse>(null as any);
    }

    /**
     * @param lenderId (optional) 
     * @param isLender (optional) 
     * @return OK
     */
    downloadZip(dealId: number, productFamily: ProductFamilyEnum, lenderId?: number | undefined, isLender?: boolean | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/deal/downloadzip?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (productFamily === undefined || productFamily === null)
            throw new Error("The parameter 'productFamily' must be defined and cannot be null.");
        else
            url_ += "productFamily=" + encodeURIComponent("" + productFamily) + "&";
        if (lenderId === null)
            throw new Error("The parameter 'lenderId' cannot be null.");
        else if (lenderId !== undefined)
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        if (isLender === null)
            throw new Error("The parameter 'isLender' cannot be null.");
        else if (isLender !== undefined)
            url_ += "isLender=" + encodeURIComponent("" + isLender) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDownloadZip(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDownloadZip(_response);
            throw _response;
        });
    }

    protected processDownloadZip(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param lenderId (optional) 
     * @param isLender (optional) 
     * @return OK
     */
    downloadZipByProductType(dealId: number, productType: ProductTypeEnum, lenderId?: number | undefined, isLender?: boolean | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/deal/downloadzipbyproducttype?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (lenderId === null)
            throw new Error("The parameter 'lenderId' cannot be null.");
        else if (lenderId !== undefined)
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        if (isLender === null)
            throw new Error("The parameter 'isLender' cannot be null.");
        else if (isLender !== undefined)
            url_ += "isLender=" + encodeURIComponent("" + isLender) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDownloadZipByProductType(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDownloadZipByProductType(_response);
            throw _response;
        });
    }

    protected processDownloadZipByProductType(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    submitToLenders(body: SubmitToLendersRequest): ng.IPromise<CaseChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/deal/submittolenders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSubmitToLenders(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSubmitToLenders(_response);
            throw _response;
        });
    }

    protected processSubmitToLenders(response: any): ng.IPromise<CaseChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    fetchByDealId(body: FetchDealRequest): ng.IPromise<FetchDealResponse> {
        let url_ = this.baseUrl + "/api/deal/fetchbydealid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchByDealId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchByDealId(_response);
            throw _response;
        });
    }

    protected processFetchByDealId(response: any): ng.IPromise<FetchDealResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FetchDealResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FetchDealResponse>(null as any);
    }

    /**
     * @return OK
     */
    fetchProductFamilyByClientUniqueRef(dealClientUniqueRef: string): ng.IPromise<ProductFamilyEnum> {
        let url_ = this.baseUrl + "/api/deal/fetchproductfamilybyclientuniqueref?";
        if (dealClientUniqueRef === undefined || dealClientUniqueRef === null)
            throw new Error("The parameter 'dealClientUniqueRef' must be defined and cannot be null.");
        else
            url_ += "dealClientUniqueRef=" + encodeURIComponent("" + dealClientUniqueRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchProductFamilyByClientUniqueRef(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchProductFamilyByClientUniqueRef(_response);
            throw _response;
        });
    }

    protected processFetchProductFamilyByClientUniqueRef(response: any): ng.IPromise<ProductFamilyEnum> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductFamilyEnum;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductFamilyEnum>(null as any);
    }

    /**
     * @return OK
     */
    markSectionAsComplete(body: MarkSectionAsCompleteRequest): ng.IPromise<MarkSectionAsCompleteResponse> {
        let url_ = this.baseUrl + "/api/deal/marksectionascomplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkSectionAsComplete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkSectionAsComplete(_response);
            throw _response;
        });
    }

    protected processMarkSectionAsComplete(response: any): ng.IPromise<MarkSectionAsCompleteResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarkSectionAsCompleteResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<MarkSectionAsCompleteResponse>(null as any);
    }

    /**
     * @return OK
     */
    shareModuleToBorrower(body: ShareModuleRequest): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deal/sharemoduletoborrower";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processShareModuleToBorrower(_response);
        }, (_response) => {
            if (_response.status)
                return this.processShareModuleToBorrower(_response);
            throw _response;
        });
    }

    protected processShareModuleToBorrower(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @param isLender (optional) 
     * @return OK
     */
    exportToPdf(dealId: number, lenderId: number, productFamily: ProductFamilyEnum, isLender?: boolean | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/deal/exporttopdf?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (lenderId === undefined || lenderId === null)
            throw new Error("The parameter 'lenderId' must be defined and cannot be null.");
        else
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        if (productFamily === undefined || productFamily === null)
            throw new Error("The parameter 'productFamily' must be defined and cannot be null.");
        else
            url_ += "productFamily=" + encodeURIComponent("" + productFamily) + "&";
        if (isLender === null)
            throw new Error("The parameter 'isLender' cannot be null.");
        else if (isLender !== undefined)
            url_ += "isLender=" + encodeURIComponent("" + isLender) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportToPdf(_response);
            throw _response;
        });
    }

    protected processExportToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param lenderId (optional) 
     * @param isLender (optional) 
     * @return OK
     */
    exportDataDump(dealId: number, productfamily: ProductFamilyEnum, lenderId?: number | undefined, isLender?: boolean | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/deal/exportdatadump?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (productfamily === undefined || productfamily === null)
            throw new Error("The parameter 'productfamily' must be defined and cannot be null.");
        else
            url_ += "productfamily=" + encodeURIComponent("" + productfamily) + "&";
        if (lenderId === null)
            throw new Error("The parameter 'lenderId' cannot be null.");
        else if (lenderId !== undefined)
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        if (isLender === null)
            throw new Error("The parameter 'isLender' cannot be null.");
        else if (isLender !== undefined)
            url_ += "isLender=" + encodeURIComponent("" + isLender) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportDataDump(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportDataDump(_response);
            throw _response;
        });
    }

    protected processExportDataDump(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    copyCase(id: number, name: string, productFamily: ProductFamilyEnum): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/deal/copycase?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (productFamily === undefined || productFamily === null)
            throw new Error("The parameter 'productFamily' must be defined and cannot be null.");
        else
            url_ += "productFamily=" + encodeURIComponent("" + productFamily) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCopyCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCopyCase(_response);
            throw _response;
        });
    }

    protected processCopyCase(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    isUserInvitedToDeal(body: InvitedUserRequest): ng.IPromise<InvitedUserResponse> {
        let url_ = this.baseUrl + "/api/deal/isuserinvitedtodeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsUserInvitedToDeal(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsUserInvitedToDeal(_response);
            throw _response;
        });
    }

    protected processIsUserInvitedToDeal(response: any): ng.IPromise<InvitedUserResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvitedUserResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<InvitedUserResponse>(null as any);
    }

    /**
     * @return OK
     */
    promoteSearchToCase(body: PromoteSearchToCaseRequest): ng.IPromise<PromoteSearchToCaseResponse> {
        let url_ = this.baseUrl + "/api/deal/promotesearchtocase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPromoteSearchToCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPromoteSearchToCase(_response);
            throw _response;
        });
    }

    protected processPromoteSearchToCase(response: any): ng.IPromise<PromoteSearchToCaseResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PromoteSearchToCaseResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PromoteSearchToCaseResponse>(null as any);
    }

    /**
     * @return OK
     */
    saveEnterpriseClientAndRenameDeal(body: SaveEnterpriseClientAndRenameSearchRequest): ng.IPromise<SaveEnterpriseClientAndRenameSearchResponse> {
        let url_ = this.baseUrl + "/api/deal/saveenterpriseclientandrenamedeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveEnterpriseClientAndRenameDeal(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveEnterpriseClientAndRenameDeal(_response);
            throw _response;
        });
    }

    protected processSaveEnterpriseClientAndRenameDeal(response: any): ng.IPromise<SaveEnterpriseClientAndRenameSearchResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaveEnterpriseClientAndRenameSearchResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SaveEnterpriseClientAndRenameSearchResponse>(null as any);
    }

    /**
     * @return OK
     */
    getRegionByPostcode(postcodeSearchString: string): ng.IPromise<GetRegionByPostcodeResponse> {
        let url_ = this.baseUrl + "/api/deal/getregionbypostcode?";
        if (postcodeSearchString === undefined || postcodeSearchString === null)
            throw new Error("The parameter 'postcodeSearchString' must be defined and cannot be null.");
        else
            url_ += "postcodeSearchString=" + encodeURIComponent("" + postcodeSearchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetRegionByPostcode(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetRegionByPostcode(_response);
            throw _response;
        });
    }

    protected processGetRegionByPostcode(response: any): ng.IPromise<GetRegionByPostcodeResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRegionByPostcodeResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<GetRegionByPostcodeResponse>(null as any);
    }

    /**
     * @return OK
     */
    saveSaveAsSearch(body: SaveAsSearchRequest): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deal/savesaveassearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveSaveAsSearch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveSaveAsSearch(_response);
            throw _response;
        });
    }

    protected processSaveSaveAsSearch(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getSearchResultsCountByUniqueRefAndLogPageLoadEvent(uniqueRef: string, orgCode: string | null): ng.IPromise<GetSearchResultsCountByUniqueRefAndLogPageLoadEventResponse> {
        let url_ = this.baseUrl + "/api/deal/getsearchresultscountbyuniquerefandlogpageloadevent?";
        if (uniqueRef === undefined || uniqueRef === null)
            throw new Error("The parameter 'uniqueRef' must be defined and cannot be null.");
        else
            url_ += "uniqueRef=" + encodeURIComponent("" + uniqueRef) + "&";
        if (orgCode === undefined)
            throw new Error("The parameter 'orgCode' must be defined.");
        else if(orgCode !== null)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSearchResultsCountByUniqueRefAndLogPageLoadEvent(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSearchResultsCountByUniqueRefAndLogPageLoadEvent(_response);
            throw _response;
        });
    }

    protected processGetSearchResultsCountByUniqueRefAndLogPageLoadEvent(response: any): ng.IPromise<GetSearchResultsCountByUniqueRefAndLogPageLoadEventResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSearchResultsCountByUniqueRefAndLogPageLoadEventResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<GetSearchResultsCountByUniqueRefAndLogPageLoadEventResponse>(null as any);
    }

    /**
     * @return OK
     */
    renameDeal(dealUniqueRef: string, newName: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/deal/renamedeal?";
        if (dealUniqueRef === undefined || dealUniqueRef === null)
            throw new Error("The parameter 'dealUniqueRef' must be defined and cannot be null.");
        else
            url_ += "dealUniqueRef=" + encodeURIComponent("" + dealUniqueRef) + "&";
        if (newName === undefined || newName === null)
            throw new Error("The parameter 'newName' must be defined and cannot be null.");
        else
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRenameDeal(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRenameDeal(_response);
            throw _response;
        });
    }

    protected processRenameDeal(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getDealSummary(dealId: number): ng.IPromise<DealSummaryDTO> {
        let url_ = this.baseUrl + "/api/deal/getdealsummary?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetDealSummary(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetDealSummary(_response);
            throw _response;
        });
    }

    protected processGetDealSummary(response: any): ng.IPromise<DealSummaryDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealSummaryDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealSummaryDTO>(null as any);
    }

    /**
     * @return OK
     */
    getDealStatus(dealId: number): ng.IPromise<CaseStatusEnum> {
        let url_ = this.baseUrl + "/api/deal/status?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetDealStatus(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetDealStatus(_response);
            throw _response;
        });
    }

    protected processGetDealStatus(response: any): ng.IPromise<CaseStatusEnum> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseStatusEnum;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseStatusEnum>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<Deal[]> {
        let url_ = this.baseUrl + "/api/deal/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<Deal[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Deal[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Deal[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<Deal> {
        let url_ = this.baseUrl + "/api/deal/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<Deal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Deal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Deal>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/deal/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DealPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/deal/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DealPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DealPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/deal/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DealPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: Deal): ng.IPromise<Deal> {
        let url_ = this.baseUrl + "/api/deal/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<Deal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Deal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Deal>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: Deal): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/deal/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: Deal[]): ng.IPromise<Deal[]> {
        let url_ = this.baseUrl + "/api/deal/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<Deal[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Deal[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Deal[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: Deal[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/deal/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deal/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deal/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealClientClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    fetchDealMembersWithAccess(dealId: number): ng.IPromise<Client[]> {
        let url_ = this.baseUrl + "/api/dealclient/fetchdealmemberswithaccess?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchDealMembersWithAccess(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchDealMembersWithAccess(_response);
            throw _response;
        });
    }

    protected processFetchDealMembersWithAccess(response: any): ng.IPromise<Client[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Client[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Client[]>(null as any);
    }

    /**
     * @return OK
     */
    addorUpdateApplicant(sendInviteEmail: boolean, body: DealClient): ng.IPromise<DealClient> {
        let url_ = this.baseUrl + "/api/dealclient/addorupdateapplicant?";
        if (sendInviteEmail === undefined || sendInviteEmail === null)
            throw new Error("The parameter 'sendInviteEmail' must be defined and cannot be null.");
        else
            url_ += "sendInviteEmail=" + encodeURIComponent("" + sendInviteEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddorUpdateApplicant(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddorUpdateApplicant(_response);
            throw _response;
        });
    }

    protected processAddorUpdateApplicant(response: any): ng.IPromise<DealClient> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClient;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClient>(null as any);
    }

    /**
     * @return OK
     */
    inviteApplicant(uniqueId: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/dealclient/inviteapplicant?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processInviteApplicant(_response);
        }, (_response) => {
            if (_response.status)
                return this.processInviteApplicant(_response);
            throw _response;
        });
    }

    protected processInviteApplicant(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleteAndSetNextApplicantAsPrimary(dealId: number, dealClientId: number): ng.IPromise<DealClient[]> {
        let url_ = this.baseUrl + "/api/dealclient/markasdeleteandsetnextapplicantasprimary?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (dealClientId === undefined || dealClientId === null)
            throw new Error("The parameter 'dealClientId' must be defined and cannot be null.");
        else
            url_ += "dealClientId=" + encodeURIComponent("" + dealClientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleteAndSetNextApplicantAsPrimary(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleteAndSetNextApplicantAsPrimary(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleteAndSetNextApplicantAsPrimary(response: any): ng.IPromise<DealClient[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClient[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClient[]>(null as any);
    }

    /**
     * @return OK
     */
    securityCheck(body: SecurityCheckMessageRequest): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/dealclient/securityCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSecurityCheck(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSecurityCheck(_response);
            throw _response;
        });
    }

    protected processSecurityCheck(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getShareholderEmailAndSecurityQuestions(uniqueId: string): ng.IPromise<GetShareholderEmailAndSecurityQuestionsResponse> {
        let url_ = this.baseUrl + "/api/dealclient/getshareholderemailandsecurityquestions?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetShareholderEmailAndSecurityQuestions(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetShareholderEmailAndSecurityQuestions(_response);
            throw _response;
        });
    }

    protected processGetShareholderEmailAndSecurityQuestions(response: any): ng.IPromise<GetShareholderEmailAndSecurityQuestionsResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetShareholderEmailAndSecurityQuestionsResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<GetShareholderEmailAndSecurityQuestionsResponse>(null as any);
    }

    /**
     * @return OK
     */
    fetchDealClientByUniqueId(uniqueId: string): ng.IPromise<DealClient> {
        let url_ = this.baseUrl + "/api/dealclient/fetchdealclientbyuniqueId?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchDealClientByUniqueId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchDealClientByUniqueId(_response);
            throw _response;
        });
    }

    protected processFetchDealClientByUniqueId(response: any): ng.IPromise<DealClient> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClient;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClient>(null as any);
    }

    /**
     * @return OK
     */
    updateApplicantDetails(body: DealClient): ng.IPromise<DealClient> {
        let url_ = this.baseUrl + "/api/dealclient/updateapplicantdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateApplicantDetails(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateApplicantDetails(_response);
            throw _response;
        });
    }

    protected processUpdateApplicantDetails(response: any): ng.IPromise<DealClient> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClient;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClient>(null as any);
    }

    /**
     * @return OK
     */
    saveAddressHistory(dealClientId: number, body: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/dealclient/saveaddresshistory?";
        if (dealClientId === undefined || dealClientId === null)
            throw new Error("The parameter 'dealClientId' must be defined and cannot be null.");
        else
            url_ += "dealClientId=" + encodeURIComponent("" + dealClientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveAddressHistory(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveAddressHistory(_response);
            throw _response;
        });
    }

    protected processSaveAddressHistory(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    submitLenderReferral(body: MakeReferralMessageRequest): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealclient/submitlenderreferral";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSubmitLenderReferral(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSubmitLenderReferral(_response);
            throw _response;
        });
    }

    protected processSubmitLenderReferral(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    addCurrentUserToDeal(dealUniqueRef: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/dealclient/addcurrentusertodeal?";
        if (dealUniqueRef === undefined || dealUniqueRef === null)
            throw new Error("The parameter 'dealUniqueRef' must be defined and cannot be null.");
        else
            url_ += "dealUniqueRef=" + encodeURIComponent("" + dealUniqueRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddCurrentUserToDeal(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddCurrentUserToDeal(_response);
            throw _response;
        });
    }

    protected processAddCurrentUserToDeal(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    updateClientContactInfoAndNotifyBroker(updatedContact: string, dealId: number, clientId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/dealclient/updateclientcontactinfoandnotifybroker?";
        if (updatedContact === undefined || updatedContact === null)
            throw new Error("The parameter 'updatedContact' must be defined and cannot be null.");
        else
            url_ += "updatedContact=" + encodeURIComponent("" + updatedContact) + "&";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateClientContactInfoAndNotifyBroker(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateClientContactInfoAndNotifyBroker(_response);
            throw _response;
        });
    }

    protected processUpdateClientContactInfoAndNotifyBroker(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DealClient[]> {
        let url_ = this.baseUrl + "/api/dealclient/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DealClient[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClient[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClient[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DealClient> {
        let url_ = this.baseUrl + "/api/dealclient/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DealClient> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClient;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClient>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/dealclient/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DealClientPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/dealclient/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DealClientPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClientPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClientPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DealClientPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/dealclient/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DealClientPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClientPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClientPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DealClient): ng.IPromise<DealClient> {
        let url_ = this.baseUrl + "/api/dealclient/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DealClient> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClient;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClient>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DealClient): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/dealclient/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DealClient[]): ng.IPromise<DealClient[]> {
        let url_ = this.baseUrl + "/api/dealclient/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DealClient[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClient[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClient[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DealClient[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/dealclient/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealclient/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealclient/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealClientCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous21> {
        let url_ = this.baseUrl + "/odata/DealClientOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous21> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous21;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous21>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DealClientInsert): ng.IPromise<DealClient> {
        let url_ = this.baseUrl + "/api/crud/dealclient/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DealClient> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClient;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClient>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DealClientUpdate): ng.IPromise<DealClient> {
        let url_ = this.baseUrl + "/api/crud/dealclient/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DealClient> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealClient;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealClient>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/dealclient/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/dealclient/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealCompletionClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getBrokerAppraisalDetails(): ng.IPromise<BrokerAppraisalMessageResponse> {
        let url_ = this.baseUrl + "/api/dealcompletion/getbrokerappraisaldetails";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetBrokerAppraisalDetails(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetBrokerAppraisalDetails(_response);
            throw _response;
        });
    }

    protected processGetBrokerAppraisalDetails(response: any): ng.IPromise<BrokerAppraisalMessageResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerAppraisalMessageResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrokerAppraisalMessageResponse>(null as any);
    }

    /**
     * @return OK
     */
    sendDealCompletionEmail(body: DealCompletion): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealcompletion/senddealcompletionemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendDealCompletionEmail(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendDealCompletionEmail(_response);
            throw _response;
        });
    }

    protected processSendDealCompletionEmail(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DealCompletion[]> {
        let url_ = this.baseUrl + "/api/dealcompletion/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DealCompletion[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealCompletion[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealCompletion[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DealCompletion> {
        let url_ = this.baseUrl + "/api/dealcompletion/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DealCompletion> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealCompletion;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealCompletion>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/dealcompletion/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DealCompletionPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/dealcompletion/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DealCompletionPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealCompletionPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealCompletionPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DealCompletionPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/dealcompletion/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DealCompletionPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealCompletionPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealCompletionPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DealCompletion): ng.IPromise<DealCompletion> {
        let url_ = this.baseUrl + "/api/dealcompletion/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DealCompletion> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealCompletion;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealCompletion>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DealCompletion): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/dealcompletion/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DealCompletion[]): ng.IPromise<DealCompletion[]> {
        let url_ = this.baseUrl + "/api/dealcompletion/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DealCompletion[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealCompletion[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealCompletion[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DealCompletion[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/dealcompletion/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealcompletion/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealcompletion/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealCompletionCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous22> {
        let url_ = this.baseUrl + "/odata/DealCompletionOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous22> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous22;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous22>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DealCompletionInsert): ng.IPromise<DealCompletion> {
        let url_ = this.baseUrl + "/api/crud/dealcompletion/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DealCompletion> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealCompletion;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealCompletion>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DealCompletionUpdate): ng.IPromise<DealCompletion> {
        let url_ = this.baseUrl + "/api/crud/dealcompletion/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DealCompletion> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealCompletion;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealCompletion>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/dealcompletion/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/dealcompletion/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous23> {
        let url_ = this.baseUrl + "/odata/DealOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous23> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous23;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous23>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DealInsert): ng.IPromise<Deal> {
        let url_ = this.baseUrl + "/api/crud/deal/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<Deal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Deal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Deal>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DealUpdate): ng.IPromise<Deal> {
        let url_ = this.baseUrl + "/api/crud/deal/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<Deal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Deal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Deal>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/deal/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/deal/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealFileAttachmentClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param dealLenderId (optional) 
     * @param dealClientId (optional) 
     * @return OK
     */
    getAmazonFileUploadUri(filename: string, fileType: string, dealId: number, module: ModuleEnum, dealLenderId?: number | undefined, dealClientId?: number | undefined): ng.IPromise<DealFileAttachment> {
        let url_ = this.baseUrl + "/api/dealfileattachment/fileuploaduri?";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined and cannot be null.");
        else
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (module === undefined || module === null)
            throw new Error("The parameter 'module' must be defined and cannot be null.");
        else
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        if (dealLenderId === null)
            throw new Error("The parameter 'dealLenderId' cannot be null.");
        else if (dealLenderId !== undefined)
            url_ += "dealLenderId=" + encodeURIComponent("" + dealLenderId) + "&";
        if (dealClientId === null)
            throw new Error("The parameter 'dealClientId' cannot be null.");
        else if (dealClientId !== undefined)
            url_ += "dealClientId=" + encodeURIComponent("" + dealClientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAmazonFileUploadUri(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAmazonFileUploadUri(_response);
            throw _response;
        });
    }

    protected processGetAmazonFileUploadUri(response: any): ng.IPromise<DealFileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealFileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealFileAttachment>(null as any);
    }

    /**
     * @return OK
     */
    getAmazonFileAccessUri(key: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/dealfileattachment/fileuri?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAmazonFileAccessUri(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAmazonFileAccessUri(_response);
            throw _response;
        });
    }

    protected processGetAmazonFileAccessUri(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    fileRename(body: DealFileAttachment): ng.IPromise<DealFileAttachment> {
        let url_ = this.baseUrl + "/api/dealfileattachment/filerename";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFileRename(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFileRename(_response);
            throw _response;
        });
    }

    protected processFileRename(response: any): ng.IPromise<DealFileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealFileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealFileAttachment>(null as any);
    }

    /**
     * @return OK
     */
    fetchListByDealId(dealId: number): ng.IPromise<DealFileAttachment[]> {
        let url_ = this.baseUrl + "/api/dealfileattachment/fetchlistbydealid?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchListByDealId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchListByDealId(_response);
            throw _response;
        });
    }

    protected processFetchListByDealId(response: any): ng.IPromise<DealFileAttachment[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealFileAttachment[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealFileAttachment[]>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DealFileAttachment[]> {
        let url_ = this.baseUrl + "/api/dealfileattachment/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DealFileAttachment[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealFileAttachment[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealFileAttachment[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DealFileAttachment> {
        let url_ = this.baseUrl + "/api/dealfileattachment/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DealFileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealFileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealFileAttachment>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/dealfileattachment/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DealFileAttachmentPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/dealfileattachment/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DealFileAttachmentPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealFileAttachmentPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealFileAttachmentPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DealFileAttachmentPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/dealfileattachment/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DealFileAttachmentPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealFileAttachmentPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealFileAttachmentPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DealFileAttachment): ng.IPromise<DealFileAttachment> {
        let url_ = this.baseUrl + "/api/dealfileattachment/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DealFileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealFileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealFileAttachment>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DealFileAttachment): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/dealfileattachment/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DealFileAttachment[]): ng.IPromise<DealFileAttachment[]> {
        let url_ = this.baseUrl + "/api/dealfileattachment/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DealFileAttachment[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealFileAttachment[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealFileAttachment[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DealFileAttachment[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/dealfileattachment/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealfileattachment/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealfileattachment/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealFileAttachmentCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous24> {
        let url_ = this.baseUrl + "/odata/DealFileAttachmentOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous24> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous24;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous24>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DealFileAttachmentInsert): ng.IPromise<DealFileAttachment> {
        let url_ = this.baseUrl + "/api/crud/dealfileattachment/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DealFileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealFileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealFileAttachment>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DealFileAttachmentUpdate): ng.IPromise<DealFileAttachment> {
        let url_ = this.baseUrl + "/api/crud/dealfileattachment/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DealFileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealFileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealFileAttachment>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/dealfileattachment/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/dealfileattachment/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealLenderClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    markAsDeletedCustom(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deallender/MarkAsDeletedCustom?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeletedCustom(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeletedCustom(_response);
            throw _response;
        });
    }

    protected processMarkAsDeletedCustom(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @param debug2 (optional) 
     * @param dealLenderId (optional) 
     * @return OK
     */
    fetchByDealId(dealId: number, debug2?: boolean | undefined, dealLenderId?: number | undefined): ng.IPromise<DealLender[]> {
        let url_ = this.baseUrl + "/api/deallender/fetchByDealId?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (debug2 === null)
            throw new Error("The parameter 'debug2' cannot be null.");
        else if (debug2 !== undefined)
            url_ += "debug2=" + encodeURIComponent("" + debug2) + "&";
        if (dealLenderId === null)
            throw new Error("The parameter 'dealLenderId' cannot be null.");
        else if (dealLenderId !== undefined)
            url_ += "dealLenderId=" + encodeURIComponent("" + dealLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchByDealId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchByDealId(_response);
            throw _response;
        });
    }

    protected processFetchByDealId(response: any): ng.IPromise<DealLender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLender[]>(null as any);
    }

    /**
     * @return OK
     */
    fetchDealLender(dealId: number): ng.IPromise<DealLender> {
        let url_ = this.baseUrl + "/api/deallender/fetchdeallender?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchDealLender(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchDealLender(_response);
            throw _response;
        });
    }

    protected processFetchDealLender(response: any): ng.IPromise<DealLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLender>(null as any);
    }

    /**
     * @return OK
     */
    getSelectedCaseLender(id: number): ng.IPromise<DealLender> {
        let url_ = this.baseUrl + "/api/deallender/selectedcaselender?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSelectedCaseLender(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSelectedCaseLender(_response);
            throw _response;
        });
    }

    protected processGetSelectedCaseLender(response: any): ng.IPromise<DealLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLender>(null as any);
    }

    /**
     * @return OK
     */
    submitOffer(body: BridgingSubmitOfferRequest): ng.IPromise<BridgingSubmitOfferResponse> {
        let url_ = this.baseUrl + "/api/deallender/submitoffer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSubmitOffer(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSubmitOffer(_response);
            throw _response;
        });
    }

    protected processSubmitOffer(response: any): ng.IPromise<BridgingSubmitOfferResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BridgingSubmitOfferResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BridgingSubmitOfferResponse>(null as any);
    }

    /**
     * @return OK
     */
    applyToLender(dealId: number, dealLenderId: number): ng.IPromise<CaseLenderChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/deallender/apply?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (dealLenderId === undefined || dealLenderId === null)
            throw new Error("The parameter 'dealLenderId' must be defined and cannot be null.");
        else
            url_ += "dealLenderId=" + encodeURIComponent("" + dealLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processApplyToLender(_response);
        }, (_response) => {
            if (_response.status)
                return this.processApplyToLender(_response);
            throw _response;
        });
    }

    protected processApplyToLender(response: any): ng.IPromise<CaseLenderChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    cancelApplication(dealId: number, dealLenderId: number): ng.IPromise<CaseLenderChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/deallender/cancel?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (dealLenderId === undefined || dealLenderId === null)
            throw new Error("The parameter 'dealLenderId' must be defined and cannot be null.");
        else
            url_ += "dealLenderId=" + encodeURIComponent("" + dealLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCancelApplication(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCancelApplication(_response);
            throw _response;
        });
    }

    protected processCancelApplication(response: any): ng.IPromise<CaseLenderChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    sendProceedDipEmails(dealId: number, dealLenderId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deallender/sendproceeddipemails?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (dealLenderId === undefined || dealLenderId === null)
            throw new Error("The parameter 'dealLenderId' must be defined and cannot be null.");
        else
            url_ += "dealLenderId=" + encodeURIComponent("" + dealLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendProceedDipEmails(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendProceedDipEmails(_response);
            throw _response;
        });
    }

    protected processSendProceedDipEmails(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    rejectCase(body: DealLender): ng.IPromise<CaseLenderChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/deallender/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRejectCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRejectCase(_response);
            throw _response;
        });
    }

    protected processRejectCase(response: any): ng.IPromise<CaseLenderChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    withdrawHoT(body: DealLender): ng.IPromise<CaseLenderChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/deallender/withdraw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processWithdrawHoT(_response);
        }, (_response) => {
            if (_response.status)
                return this.processWithdrawHoT(_response);
            throw _response;
        });
    }

    protected processWithdrawHoT(response: any): ng.IPromise<CaseLenderChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    shortlistMoreLenders(dealId: number, hasCriteriaChanged: boolean, body: ShortlistRequest): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deallender/shortlistmorelenders?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (hasCriteriaChanged === undefined || hasCriteriaChanged === null)
            throw new Error("The parameter 'hasCriteriaChanged' must be defined and cannot be null.");
        else
            url_ += "hasCriteriaChanged=" + encodeURIComponent("" + hasCriteriaChanged) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processShortlistMoreLenders(_response);
        }, (_response) => {
            if (_response.status)
                return this.processShortlistMoreLenders(_response);
            throw _response;
        });
    }

    protected processShortlistMoreLenders(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    exportDIPDataDump(showLenderNames: boolean, productFamily: ProductFamilyEnum, body: DealLender[]): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/deallender/exportdipdatadump?";
        if (showLenderNames === undefined || showLenderNames === null)
            throw new Error("The parameter 'showLenderNames' must be defined and cannot be null.");
        else
            url_ += "showLenderNames=" + encodeURIComponent("" + showLenderNames) + "&";
        if (productFamily === undefined || productFamily === null)
            throw new Error("The parameter 'productFamily' must be defined and cannot be null.");
        else
            url_ += "productFamily=" + encodeURIComponent("" + productFamily) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportDIPDataDump(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportDIPDataDump(_response);
            throw _response;
        });
    }

    protected processExportDIPDataDump(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param showLenderNames (optional) 
     * @return OK
     */
    exportDipToPdf(productFamily: ProductFamilyEnum, body: DealLender[], showLenderNames?: boolean | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/deallender/exportdiptopdf?";
        if (productFamily === undefined || productFamily === null)
            throw new Error("The parameter 'productFamily' must be defined and cannot be null.");
        else
            url_ += "productFamily=" + encodeURIComponent("" + productFamily) + "&";
        if (showLenderNames === null)
            throw new Error("The parameter 'showLenderNames' cannot be null.");
        else if (showLenderNames !== undefined)
            url_ += "showLenderNames=" + encodeURIComponent("" + showLenderNames) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportDipToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportDipToPdf(_response);
            throw _response;
        });
    }

    protected processExportDipToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    addLenderPortalLinkDetails(dealLenderId: number, body: UserSimpleDTO): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deallender/addlenderportallinkdetails?";
        if (dealLenderId === undefined || dealLenderId === null)
            throw new Error("The parameter 'dealLenderId' must be defined and cannot be null.");
        else
            url_ += "dealLenderId=" + encodeURIComponent("" + dealLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddLenderPortalLinkDetails(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddLenderPortalLinkDetails(_response);
            throw _response;
        });
    }

    protected processAddLenderPortalLinkDetails(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    dealLenderAddUpdateListReturnOnlyId(body: ShortlistRequest): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/deallender/deallenderaddupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDealLenderAddUpdateListReturnOnlyId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDealLenderAddUpdateListReturnOnlyId(_response);
            throw _response;
        });
    }

    protected processDealLenderAddUpdateListReturnOnlyId(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    submitToDealLocker(dealLenderId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deallender/submittodeallocker?";
        if (dealLenderId === undefined || dealLenderId === null)
            throw new Error("The parameter 'dealLenderId' must be defined and cannot be null.");
        else
            url_ += "dealLenderId=" + encodeURIComponent("" + dealLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSubmitToDealLocker(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSubmitToDealLocker(_response);
            throw _response;
        });
    }

    protected processSubmitToDealLocker(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updateShortlistedLenders(body: ShortlistRequest): ng.IPromise<DealLender[]> {
        let url_ = this.baseUrl + "/api/deallender/updateshortlistedlenders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateShortlistedLenders(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateShortlistedLenders(_response);
            throw _response;
        });
    }

    protected processUpdateShortlistedLenders(response: any): ng.IPromise<DealLender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLender[]>(null as any);
    }

    /**
     * @return OK
     */
    fetchDealLendersByDealId(dealId: number): ng.IPromise<DealLender[]> {
        let url_ = this.baseUrl + "/api/deallender/fetchdeallendersbydealid?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchDealLendersByDealId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchDealLendersByDealId(_response);
            throw _response;
        });
    }

    protected processFetchDealLendersByDealId(response: any): ng.IPromise<DealLender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLender[]>(null as any);
    }

    /**
     * @return OK
     */
    sendDealToPackagerForReview(dealId: number, dealLenderId: number): ng.IPromise<CaseLenderChangedMessageDTO> {
        let url_ = this.baseUrl + "/api/deallender/senddealtopackagerforreview?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (dealLenderId === undefined || dealLenderId === null)
            throw new Error("The parameter 'dealLenderId' must be defined and cannot be null.");
        else
            url_ += "dealLenderId=" + encodeURIComponent("" + dealLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendDealToPackagerForReview(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendDealToPackagerForReview(_response);
            throw _response;
        });
    }

    protected processSendDealToPackagerForReview(response: any): ng.IPromise<CaseLenderChangedMessageDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseLenderChangedMessageDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CaseLenderChangedMessageDTO>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DealLender[]> {
        let url_ = this.baseUrl + "/api/deallender/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DealLender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLender[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DealLender> {
        let url_ = this.baseUrl + "/api/deallender/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DealLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLender>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/deallender/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DealLenderPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/deallender/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DealLenderPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DealLenderPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/deallender/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DealLenderPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DealLender): ng.IPromise<DealLender> {
        let url_ = this.baseUrl + "/api/deallender/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DealLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLender>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DealLender): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/deallender/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DealLender[]): ng.IPromise<DealLender[]> {
        let url_ = this.baseUrl + "/api/deallender/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DealLender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLender[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DealLender[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/deallender/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deallender/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deallender/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealLenderCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous25> {
        let url_ = this.baseUrl + "/odata/DealLenderOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous25> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous25;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous25>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DealLenderInsert): ng.IPromise<DealLender> {
        let url_ = this.baseUrl + "/api/crud/deallender/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DealLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLender>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DealLenderUpdate): ng.IPromise<DealLender> {
        let url_ = this.baseUrl + "/api/crud/deallender/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DealLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLender>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/deallender/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/deallender/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealLenderMessageClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    addUpdateCustom(body: DealLenderMessage): ng.IPromise<DealLenderMessage> {
        let url_ = this.baseUrl + "/api/deallendermessage/addupdatecustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateCustom(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateCustom(_response);
            throw _response;
        });
    }

    protected processAddUpdateCustom(response: any): ng.IPromise<DealLenderMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessage>(null as any);
    }

    /**
     * @return OK
     */
    updateDealLenderMessageReadDatetime(dealLenderId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/deallendermessage/updatedeallendermessagereaddatetime?";
        if (dealLenderId === undefined || dealLenderId === null)
            throw new Error("The parameter 'dealLenderId' must be defined and cannot be null.");
        else
            url_ += "dealLenderId=" + encodeURIComponent("" + dealLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateDealLenderMessageReadDatetime(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateDealLenderMessageReadDatetime(_response);
            throw _response;
        });
    }

    protected processUpdateDealLenderMessageReadDatetime(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getTotalUnreadMessagesPerAppraisal(body: AppraisalData[]): ng.IPromise<TotalUnreadMessagesByAppraisal[]> {
        let url_ = this.baseUrl + "/api/deallendermessage/gettotalunreadmessagesperappraisal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetTotalUnreadMessagesPerAppraisal(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetTotalUnreadMessagesPerAppraisal(_response);
            throw _response;
        });
    }

    protected processGetTotalUnreadMessagesPerAppraisal(response: any): ng.IPromise<TotalUnreadMessagesByAppraisal[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TotalUnreadMessagesByAppraisal[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TotalUnreadMessagesByAppraisal[]>(null as any);
    }

    /**
     * @return OK
     */
    getTotalUnreadMessagesByProductType(): ng.IPromise<TotalUnreadMessagesByAppraisalResponse> {
        let url_ = this.baseUrl + "/api/deallendermessage/gettotalunreadmessagesbyproducttype";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetTotalUnreadMessagesByProductType(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetTotalUnreadMessagesByProductType(_response);
            throw _response;
        });
    }

    protected processGetTotalUnreadMessagesByProductType(response: any): ng.IPromise<TotalUnreadMessagesByAppraisalResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TotalUnreadMessagesByAppraisalResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TotalUnreadMessagesByAppraisalResponse>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DealLenderMessage[]> {
        let url_ = this.baseUrl + "/api/deallendermessage/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DealLenderMessage[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessage[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessage[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DealLenderMessage> {
        let url_ = this.baseUrl + "/api/deallendermessage/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DealLenderMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessage>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/deallendermessage/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DealLenderMessagePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/deallendermessage/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DealLenderMessagePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessagePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessagePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DealLenderMessagePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/deallendermessage/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DealLenderMessagePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessagePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessagePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DealLenderMessage): ng.IPromise<DealLenderMessage> {
        let url_ = this.baseUrl + "/api/deallendermessage/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DealLenderMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessage>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DealLenderMessage): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/deallendermessage/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DealLenderMessage[]): ng.IPromise<DealLenderMessage[]> {
        let url_ = this.baseUrl + "/api/deallendermessage/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DealLenderMessage[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessage[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessage[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DealLenderMessage[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/deallendermessage/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deallendermessage/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deallendermessage/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealLenderMessageCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous26> {
        let url_ = this.baseUrl + "/odata/DealLenderMessageOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous26> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous26;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous26>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DealLenderMessageInsert): ng.IPromise<DealLenderMessage> {
        let url_ = this.baseUrl + "/api/crud/deallendermessage/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DealLenderMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessage>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DealLenderMessageUpdate): ng.IPromise<DealLenderMessage> {
        let url_ = this.baseUrl + "/api/crud/deallendermessage/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DealLenderMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessage>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/deallendermessage/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/deallendermessage/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealLenderMessageTrackClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DealLenderMessageTrack[]> {
        let url_ = this.baseUrl + "/api/deallendermessagetrack/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DealLenderMessageTrack[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessageTrack[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessageTrack[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DealLenderMessageTrack> {
        let url_ = this.baseUrl + "/api/deallendermessagetrack/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DealLenderMessageTrack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessageTrack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessageTrack>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/deallendermessagetrack/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DealLenderMessageTrackPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/deallendermessagetrack/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DealLenderMessageTrackPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessageTrackPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessageTrackPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DealLenderMessageTrackPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/deallendermessagetrack/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DealLenderMessageTrackPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessageTrackPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessageTrackPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DealLenderMessageTrack): ng.IPromise<DealLenderMessageTrack> {
        let url_ = this.baseUrl + "/api/deallendermessagetrack/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DealLenderMessageTrack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessageTrack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessageTrack>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DealLenderMessageTrack): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/deallendermessagetrack/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DealLenderMessageTrack[]): ng.IPromise<DealLenderMessageTrack[]> {
        let url_ = this.baseUrl + "/api/deallendermessagetrack/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DealLenderMessageTrack[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessageTrack[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessageTrack[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DealLenderMessageTrack[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/deallendermessagetrack/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deallendermessagetrack/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/deallendermessagetrack/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealLenderMessageTrackCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous27> {
        let url_ = this.baseUrl + "/odata/DealLenderMessageTrackOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous27> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous27;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous27>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DealLenderMessageTrackInsert): ng.IPromise<DealLenderMessageTrack> {
        let url_ = this.baseUrl + "/api/crud/deallendermessagetrack/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DealLenderMessageTrack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessageTrack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessageTrack>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DealLenderMessageTrackUpdate): ng.IPromise<DealLenderMessageTrack> {
        let url_ = this.baseUrl + "/api/crud/deallendermessagetrack/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DealLenderMessageTrack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealLenderMessageTrack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealLenderMessageTrack>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/deallendermessagetrack/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/deallendermessagetrack/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealNoteClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DealNote[]> {
        let url_ = this.baseUrl + "/api/dealnote/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DealNote[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealNote[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealNote[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DealNote> {
        let url_ = this.baseUrl + "/api/dealnote/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DealNote> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealNote;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealNote>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/dealnote/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DealNotePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/dealnote/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DealNotePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealNotePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealNotePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DealNotePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/dealnote/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DealNotePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealNotePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealNotePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DealNote): ng.IPromise<DealNote> {
        let url_ = this.baseUrl + "/api/dealnote/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DealNote> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealNote;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealNote>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DealNote): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/dealnote/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DealNote[]): ng.IPromise<DealNote[]> {
        let url_ = this.baseUrl + "/api/dealnote/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DealNote[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealNote[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealNote[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DealNote[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/dealnote/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealnote/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealnote/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealNoteCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous28> {
        let url_ = this.baseUrl + "/odata/DealNoteOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous28> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous28;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous28>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DealNoteInsert): ng.IPromise<DealNote> {
        let url_ = this.baseUrl + "/api/crud/dealnote/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DealNote> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealNote;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealNote>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DealNoteUpdate): ng.IPromise<DealNote> {
        let url_ = this.baseUrl + "/api/crud/dealnote/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DealNote> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealNote;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealNote>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/dealnote/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/dealnote/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealScheduleClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DealSchedule[]> {
        let url_ = this.baseUrl + "/api/dealschedule/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DealSchedule[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealSchedule[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealSchedule[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DealSchedule> {
        let url_ = this.baseUrl + "/api/dealschedule/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DealSchedule> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealSchedule;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealSchedule>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/dealschedule/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DealSchedulePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/dealschedule/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DealSchedulePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealSchedulePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealSchedulePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DealSchedulePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/dealschedule/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DealSchedulePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealSchedulePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealSchedulePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DealSchedule): ng.IPromise<DealSchedule> {
        let url_ = this.baseUrl + "/api/dealschedule/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DealSchedule> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealSchedule;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealSchedule>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DealSchedule): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/dealschedule/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DealSchedule[]): ng.IPromise<DealSchedule[]> {
        let url_ = this.baseUrl + "/api/dealschedule/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DealSchedule[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealSchedule[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealSchedule[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DealSchedule[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/dealschedule/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealschedule/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/dealschedule/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DealScheduleCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous29> {
        let url_ = this.baseUrl + "/odata/DealScheduleOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous29> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous29;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous29>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DealScheduleInsert): ng.IPromise<DealSchedule> {
        let url_ = this.baseUrl + "/api/crud/dealschedule/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DealSchedule> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealSchedule;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealSchedule>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DealScheduleUpdate): ng.IPromise<DealSchedule> {
        let url_ = this.baseUrl + "/api/crud/dealschedule/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DealSchedule> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DealSchedule;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DealSchedule>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/dealschedule/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/dealschedule/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DeveloperExitFinanceDevScheduleInputClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DeveloperExitFinanceDevScheduleInput[]> {
        let url_ = this.baseUrl + "/api/developerexitfinancedevscheduleinput/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DeveloperExitFinanceDevScheduleInput[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceDevScheduleInput[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceDevScheduleInput[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DeveloperExitFinanceDevScheduleInput> {
        let url_ = this.baseUrl + "/api/developerexitfinancedevscheduleinput/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DeveloperExitFinanceDevScheduleInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceDevScheduleInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceDevScheduleInput>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developerexitfinancedevscheduleinput/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DeveloperExitFinanceDevScheduleInputPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developerexitfinancedevscheduleinput/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DeveloperExitFinanceDevScheduleInputPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceDevScheduleInputPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceDevScheduleInputPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DeveloperExitFinanceDevScheduleInputPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developerexitfinancedevscheduleinput/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DeveloperExitFinanceDevScheduleInputPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceDevScheduleInputPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceDevScheduleInputPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DeveloperExitFinanceDevScheduleInput): ng.IPromise<DeveloperExitFinanceDevScheduleInput> {
        let url_ = this.baseUrl + "/api/developerexitfinancedevscheduleinput/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DeveloperExitFinanceDevScheduleInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceDevScheduleInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceDevScheduleInput>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DeveloperExitFinanceDevScheduleInput): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developerexitfinancedevscheduleinput/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DeveloperExitFinanceDevScheduleInput[]): ng.IPromise<DeveloperExitFinanceDevScheduleInput[]> {
        let url_ = this.baseUrl + "/api/developerexitfinancedevscheduleinput/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DeveloperExitFinanceDevScheduleInput[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceDevScheduleInput[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceDevScheduleInput[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DeveloperExitFinanceDevScheduleInput[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/developerexitfinancedevscheduleinput/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developerexitfinancedevscheduleinput/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developerexitfinancedevscheduleinput/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DeveloperExitFinanceDevScheduleInputCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous30> {
        let url_ = this.baseUrl + "/odata/DeveloperExitFinanceDevScheduleInputOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous30> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous30;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous30>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DeveloperExitFinanceDevScheduleInputInsert): ng.IPromise<DeveloperExitFinanceDevScheduleInput> {
        let url_ = this.baseUrl + "/api/crud/developerexitfinancedevscheduleinput/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DeveloperExitFinanceDevScheduleInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceDevScheduleInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceDevScheduleInput>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DeveloperExitFinanceDevScheduleInputUpdate): ng.IPromise<DeveloperExitFinanceDevScheduleInput> {
        let url_ = this.baseUrl + "/api/crud/developerexitfinancedevscheduleinput/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DeveloperExitFinanceDevScheduleInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceDevScheduleInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceDevScheduleInput>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/developerexitfinancedevscheduleinput/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/developerexitfinancedevscheduleinput/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DeveloperExitFinanceLoanInputClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DeveloperExitFinanceLoanInput[]> {
        let url_ = this.baseUrl + "/api/developerexitfinanceloaninput/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DeveloperExitFinanceLoanInput[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceLoanInput[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceLoanInput[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DeveloperExitFinanceLoanInput> {
        let url_ = this.baseUrl + "/api/developerexitfinanceloaninput/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DeveloperExitFinanceLoanInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceLoanInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceLoanInput>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developerexitfinanceloaninput/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DeveloperExitFinanceLoanInputPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developerexitfinanceloaninput/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DeveloperExitFinanceLoanInputPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceLoanInputPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceLoanInputPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DeveloperExitFinanceLoanInputPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developerexitfinanceloaninput/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DeveloperExitFinanceLoanInputPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceLoanInputPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceLoanInputPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DeveloperExitFinanceLoanInput): ng.IPromise<DeveloperExitFinanceLoanInput> {
        let url_ = this.baseUrl + "/api/developerexitfinanceloaninput/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DeveloperExitFinanceLoanInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceLoanInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceLoanInput>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DeveloperExitFinanceLoanInput): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developerexitfinanceloaninput/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DeveloperExitFinanceLoanInput[]): ng.IPromise<DeveloperExitFinanceLoanInput[]> {
        let url_ = this.baseUrl + "/api/developerexitfinanceloaninput/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DeveloperExitFinanceLoanInput[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceLoanInput[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceLoanInput[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DeveloperExitFinanceLoanInput[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/developerexitfinanceloaninput/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developerexitfinanceloaninput/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developerexitfinanceloaninput/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DeveloperExitFinanceLoanInputCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous31> {
        let url_ = this.baseUrl + "/odata/DeveloperExitFinanceLoanInputOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous31> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous31;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous31>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DeveloperExitFinanceLoanInputInsert): ng.IPromise<DeveloperExitFinanceLoanInput> {
        let url_ = this.baseUrl + "/api/crud/developerexitfinanceloaninput/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DeveloperExitFinanceLoanInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceLoanInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceLoanInput>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DeveloperExitFinanceLoanInputUpdate): ng.IPromise<DeveloperExitFinanceLoanInput> {
        let url_ = this.baseUrl + "/api/crud/developerexitfinanceloaninput/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DeveloperExitFinanceLoanInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeveloperExitFinanceLoanInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DeveloperExitFinanceLoanInput>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/developerexitfinanceloaninput/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/developerexitfinanceloaninput/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DevelopmentFinanceDealClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    updateSearchAndGetResults(body: UpdateDevFinanceSearchGetResultRequest): ng.IPromise<UpdateDevFinanceSearchGetResultResponse> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/updatesearchandgetresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateSearchAndGetResults(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateSearchAndGetResults(_response);
            throw _response;
        });
    }

    protected processUpdateSearchAndGetResults(response: any): ng.IPromise<UpdateDevFinanceSearchGetResultResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateDevFinanceSearchGetResultResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<UpdateDevFinanceSearchGetResultResponse>(null as any);
    }

    /**
     * @return OK
     */
    saveDevFinanceSearchReturnsId(body: SaveDevFinanceSearchRequest): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/savedevfinancesearchreturnsId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveDevFinanceSearchReturnsId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveDevFinanceSearchReturnsId(_response);
            throw _response;
        });
    }

    protected processSaveDevFinanceSearchReturnsId(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    saveDevFinanceSearchReturnsUniqueRef(body: SaveDevFinanceSearchRequest): ng.IPromise<SaveSearchReturnUniqueRefResponse> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/savedevfinancesearchreturnsuniqueref";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveDevFinanceSearchReturnsUniqueRef(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveDevFinanceSearchReturnsUniqueRef(_response);
            throw _response;
        });
    }

    protected processSaveDevFinanceSearchReturnsUniqueRef(response: any): ng.IPromise<SaveSearchReturnUniqueRefResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaveSearchReturnUniqueRefResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SaveSearchReturnUniqueRefResponse>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DevelopmentFinanceDeal[]> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DevelopmentFinanceDeal[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentFinanceDeal[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentFinanceDeal[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DevelopmentFinanceDeal> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DevelopmentFinanceDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentFinanceDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentFinanceDeal>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DevelopmentFinanceDealPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DevelopmentFinanceDealPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentFinanceDealPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentFinanceDealPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DevelopmentFinanceDealPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DevelopmentFinanceDealPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentFinanceDealPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentFinanceDealPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DevelopmentFinanceDeal): ng.IPromise<DevelopmentFinanceDeal> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DevelopmentFinanceDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentFinanceDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentFinanceDeal>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DevelopmentFinanceDeal): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DevelopmentFinanceDeal[]): ng.IPromise<DevelopmentFinanceDeal[]> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DevelopmentFinanceDeal[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentFinanceDeal[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentFinanceDeal[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DevelopmentFinanceDeal[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentfinancedeal/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DevelopmentFinanceDealCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous32> {
        let url_ = this.baseUrl + "/odata/DevelopmentFinanceDealOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous32> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous32;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous32>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DevelopmentFinanceDealInsert): ng.IPromise<DevelopmentFinanceDeal> {
        let url_ = this.baseUrl + "/api/crud/developmentfinancedeal/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DevelopmentFinanceDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentFinanceDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentFinanceDeal>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DevelopmentFinanceDealUpdate): ng.IPromise<DevelopmentFinanceDeal> {
        let url_ = this.baseUrl + "/api/crud/developmentfinancedeal/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DevelopmentFinanceDeal> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentFinanceDeal;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentFinanceDeal>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/developmentfinancedeal/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/developmentfinancedeal/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DevelopmentInputClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    fetchByIntroducerId(introducerId: number): ng.IPromise<DevelopmentInput[]> {
        let url_ = this.baseUrl + "/api/developmentinput/fetchByIntroducerId?";
        if (introducerId === undefined || introducerId === null)
            throw new Error("The parameter 'introducerId' must be defined and cannot be null.");
        else
            url_ += "IntroducerId=" + encodeURIComponent("" + introducerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchByIntroducerId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchByIntroducerId(_response);
            throw _response;
        });
    }

    protected processFetchByIntroducerId(response: any): ng.IPromise<DevelopmentInput[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInput[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInput[]>(null as any);
    }

    /**
     * @return OK
     */
    listByUserName(username: string): ng.IPromise<DevelopmentInput[]> {
        let url_ = this.baseUrl + "/api/developmentinput/listbyusername?";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined and cannot be null.");
        else
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListByUserName(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListByUserName(_response);
            throw _response;
        });
    }

    protected processListByUserName(response: any): ng.IPromise<DevelopmentInput[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInput[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInput[]>(null as any);
    }

    /**
     * @return OK
     */
    listByUserId(userId: number): ng.IPromise<DevelopmentInput[]> {
        let url_ = this.baseUrl + "/api/developmentinput/listbyuserid?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListByUserId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListByUserId(_response);
            throw _response;
        });
    }

    protected processListByUserId(response: any): ng.IPromise<DevelopmentInput[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInput[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInput[]>(null as any);
    }

    /**
     * @return OK
     */
    saveSearch(body: DevelopmentInput): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentinput/savesearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveSearch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveSearch(_response);
            throw _response;
        });
    }

    protected processSaveSearch(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    copyCase(developmentInputId: number, name: string): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentinput/copycase?";
        if (developmentInputId === undefined || developmentInputId === null)
            throw new Error("The parameter 'developmentInputId' must be defined and cannot be null.");
        else
            url_ += "developmentInputId=" + encodeURIComponent("" + developmentInputId) + "&";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCopyCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCopyCase(_response);
            throw _response;
        });
    }

    protected processCopyCase(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    sendResultsToExistingClient(clientFirstName: string, clientSurname: string, clientEmail: string, clientId: number, notifyClient: boolean, clientPhoneNumber: string, body: DevelopmentInput): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentinput/sendresultstoexistingclient?";
        if (clientFirstName === undefined || clientFirstName === null)
            throw new Error("The parameter 'clientFirstName' must be defined and cannot be null.");
        else
            url_ += "clientFirstName=" + encodeURIComponent("" + clientFirstName) + "&";
        if (clientSurname === undefined || clientSurname === null)
            throw new Error("The parameter 'clientSurname' must be defined and cannot be null.");
        else
            url_ += "clientSurname=" + encodeURIComponent("" + clientSurname) + "&";
        if (clientEmail === undefined || clientEmail === null)
            throw new Error("The parameter 'clientEmail' must be defined and cannot be null.");
        else
            url_ += "clientEmail=" + encodeURIComponent("" + clientEmail) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (notifyClient === undefined || notifyClient === null)
            throw new Error("The parameter 'notifyClient' must be defined and cannot be null.");
        else
            url_ += "notifyClient=" + encodeURIComponent("" + notifyClient) + "&";
        if (clientPhoneNumber === undefined || clientPhoneNumber === null)
            throw new Error("The parameter 'clientPhoneNumber' must be defined and cannot be null.");
        else
            url_ += "clientPhoneNumber=" + encodeURIComponent("" + clientPhoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendResultsToExistingClient(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendResultsToExistingClient(_response);
            throw _response;
        });
    }

    protected processSendResultsToExistingClient(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    sendEmailToExistingUser(searchId: number, showLenderNameValue: boolean, updateshowLenderName: boolean): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentinput/sendemailtoexistinguser?";
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined and cannot be null.");
        else
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (showLenderNameValue === undefined || showLenderNameValue === null)
            throw new Error("The parameter 'showLenderNameValue' must be defined and cannot be null.");
        else
            url_ += "showLenderNameValue=" + encodeURIComponent("" + showLenderNameValue) + "&";
        if (updateshowLenderName === undefined || updateshowLenderName === null)
            throw new Error("The parameter 'updateshowLenderName' must be defined and cannot be null.");
        else
            url_ += "updateshowLenderName=" + encodeURIComponent("" + updateshowLenderName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendEmailToExistingUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendEmailToExistingUser(_response);
            throw _response;
        });
    }

    protected processSendEmailToExistingUser(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @param debug1 (optional) 
     * @param debug2 (optional) 
     * @param orgCode (optional) 
     * @param showLenderNamesAndLogosOverride (optional) 
     * @return OK
     */
    exportSearchToPdf(developmentInputId: number, debug1?: boolean | undefined, debug2?: boolean | undefined, orgCode?: string | undefined, showLenderNamesAndLogosOverride?: boolean | null | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/developmentinput/exportsearchtopdf?";
        if (developmentInputId === undefined || developmentInputId === null)
            throw new Error("The parameter 'developmentInputId' must be defined and cannot be null.");
        else
            url_ += "developmentInputId=" + encodeURIComponent("" + developmentInputId) + "&";
        if (debug1 === null)
            throw new Error("The parameter 'debug1' cannot be null.");
        else if (debug1 !== undefined)
            url_ += "debug1=" + encodeURIComponent("" + debug1) + "&";
        if (debug2 === null)
            throw new Error("The parameter 'debug2' cannot be null.");
        else if (debug2 !== undefined)
            url_ += "debug2=" + encodeURIComponent("" + debug2) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (showLenderNamesAndLogosOverride !== undefined && showLenderNamesAndLogosOverride !== null)
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportSearchToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportSearchToPdf(_response);
            throw _response;
        });
    }

    protected processExportSearchToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param debug1 (optional) 
     * @param debug2 (optional) 
     * @param orgCode (optional) 
     * @param showLenderNamesAndLogosOverride (optional) 
     * @return OK
     */
    exportToPdf(body: DevelopmentInput, debug1?: boolean | undefined, debug2?: boolean | undefined, orgCode?: string | undefined, showLenderNamesAndLogosOverride?: boolean | null | undefined): ng.IPromise<FileResponse> {
        let url_ = this.baseUrl + "/api/developmentinput/exportsearchtopdf?";
        if (debug1 === null)
            throw new Error("The parameter 'debug1' cannot be null.");
        else if (debug1 !== undefined)
            url_ += "debug1=" + encodeURIComponent("" + debug1) + "&";
        if (debug2 === null)
            throw new Error("The parameter 'debug2' cannot be null.");
        else if (debug2 !== undefined)
            url_ += "debug2=" + encodeURIComponent("" + debug2) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (showLenderNamesAndLogosOverride !== undefined && showLenderNamesAndLogosOverride !== null)
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            responseType: "arraybuffer",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportToPdf(_response);
            throw _response;
        });
    }

    protected processExportToPdf(response: any): ng.IPromise<FileResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return this.q.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(new Blob([response.data]), this.q).then(_responseText => {
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return this.q.resolve<FileResponse>(null as any);
    }

    /**
     * @param isNoLoginRecord (optional) 
     * @return OK
     */
    assignBrokerToSearch(developmentInputId: number, brokerUserId: number, isNoLoginRecord?: boolean | null | undefined): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentinput/assignbrokertosearch?";
        if (developmentInputId === undefined || developmentInputId === null)
            throw new Error("The parameter 'developmentInputId' must be defined and cannot be null.");
        else
            url_ += "developmentInputId=" + encodeURIComponent("" + developmentInputId) + "&";
        if (brokerUserId === undefined || brokerUserId === null)
            throw new Error("The parameter 'brokerUserId' must be defined and cannot be null.");
        else
            url_ += "brokerUserId=" + encodeURIComponent("" + brokerUserId) + "&";
        if (isNoLoginRecord !== undefined && isNoLoginRecord !== null)
            url_ += "isNoLoginRecord=" + encodeURIComponent("" + isNoLoginRecord) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAssignBrokerToSearch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAssignBrokerToSearch(_response);
            throw _response;
        });
    }

    protected processAssignBrokerToSearch(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @param orgCode (optional) 
     * @param showLenderNames (optional) 
     * @return OK
     */
    exportDipToPdf(body: CaseLender[], orgCode?: string | undefined, showLenderNames?: boolean | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/developmentinput/exportdiptopdf?";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (showLenderNames === null)
            throw new Error("The parameter 'showLenderNames' cannot be null.");
        else if (showLenderNames !== undefined)
            url_ += "showLenderNames=" + encodeURIComponent("" + showLenderNames) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportDipToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportDipToPdf(_response);
            throw _response;
        });
    }

    protected processExportDipToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param orgCode (optional) 
     * @return OK
     */
    exportShortListedResultsToPdf(showLenderNamesAndLogosOverride: boolean, body: DevelopmentInput, orgCode?: string | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/developmentinput/exportshortlistedresultstopdf?";
        if (showLenderNamesAndLogosOverride === undefined || showLenderNamesAndLogosOverride === null)
            throw new Error("The parameter 'showLenderNamesAndLogosOverride' must be defined and cannot be null.");
        else
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportShortListedResultsToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportShortListedResultsToPdf(_response);
            throw _response;
        });
    }

    protected processExportShortListedResultsToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getRegionByPostcode(postcodeSearchString: string): ng.IPromise<GetRegionByPostcodeResponse> {
        let url_ = this.baseUrl + "/api/developmentinput/getregionbypostcode?";
        if (postcodeSearchString === undefined || postcodeSearchString === null)
            throw new Error("The parameter 'postcodeSearchString' must be defined and cannot be null.");
        else
            url_ += "postcodeSearchString=" + encodeURIComponent("" + postcodeSearchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetRegionByPostcode(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetRegionByPostcode(_response);
            throw _response;
        });
    }

    protected processGetRegionByPostcode(response: any): ng.IPromise<GetRegionByPostcodeResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRegionByPostcodeResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<GetRegionByPostcodeResponse>(null as any);
    }

    /**
     * @return OK
     */
    isUserHasAccessToCase(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentinput/isuserhasaccesstocase?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsUserHasAccessToCase(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsUserHasAccessToCase(_response);
            throw _response;
        });
    }

    protected processIsUserHasAccessToCase(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    fetchCustom(id: number): ng.IPromise<DevelopmentInput> {
        let url_ = this.baseUrl + "/api/developmentinput/FetchCustom?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchCustom(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchCustom(_response);
            throw _response;
        });
    }

    protected processFetchCustom(response: any): ng.IPromise<DevelopmentInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInput>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DevelopmentInput[]> {
        let url_ = this.baseUrl + "/api/developmentinput/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DevelopmentInput[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInput[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInput[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DevelopmentInput> {
        let url_ = this.baseUrl + "/api/developmentinput/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DevelopmentInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInput>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentinput/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DevelopmentInputPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developmentinput/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DevelopmentInputPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DevelopmentInputPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developmentinput/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DevelopmentInputPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DevelopmentInput): ng.IPromise<DevelopmentInput> {
        let url_ = this.baseUrl + "/api/developmentinput/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DevelopmentInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInput>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DevelopmentInput): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentinput/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DevelopmentInput[]): ng.IPromise<DevelopmentInput[]> {
        let url_ = this.baseUrl + "/api/developmentinput/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DevelopmentInput[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInput[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInput[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DevelopmentInput[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/developmentinput/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentinput/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentinput/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DevelopmentInputCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous33> {
        let url_ = this.baseUrl + "/odata/DevelopmentInputOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous33> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous33;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous33>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DevelopmentInputInsert): ng.IPromise<DevelopmentInput> {
        let url_ = this.baseUrl + "/api/crud/developmentinput/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DevelopmentInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInput>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DevelopmentInputUpdate): ng.IPromise<DevelopmentInput> {
        let url_ = this.baseUrl + "/api/crud/developmentinput/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DevelopmentInput> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInput;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInput>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/developmentinput/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/developmentinput/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DevelopmentInputScheduleClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    fetchByCaseId(developmentId: number): ng.IPromise<DevelopmentInputSchedule[]> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/fetchByCaseId?";
        if (developmentId === undefined || developmentId === null)
            throw new Error("The parameter 'developmentId' must be defined and cannot be null.");
        else
            url_ += "DevelopmentId=" + encodeURIComponent("" + developmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchByCaseId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchByCaseId(_response);
            throw _response;
        });
    }

    protected processFetchByCaseId(response: any): ng.IPromise<DevelopmentInputSchedule[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputSchedule[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputSchedule[]>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DevelopmentInputSchedule[]> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DevelopmentInputSchedule[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputSchedule[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputSchedule[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DevelopmentInputSchedule> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DevelopmentInputSchedule> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputSchedule;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputSchedule>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DevelopmentInputSchedulePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DevelopmentInputSchedulePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputSchedulePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputSchedulePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DevelopmentInputSchedulePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DevelopmentInputSchedulePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputSchedulePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputSchedulePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DevelopmentInputSchedule): ng.IPromise<DevelopmentInputSchedule> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DevelopmentInputSchedule> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputSchedule;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputSchedule>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DevelopmentInputSchedule): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DevelopmentInputSchedule[]): ng.IPromise<DevelopmentInputSchedule[]> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DevelopmentInputSchedule[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputSchedule[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputSchedule[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DevelopmentInputSchedule[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentinputschedule/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DevelopmentInputScheduleCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous34> {
        let url_ = this.baseUrl + "/odata/DevelopmentInputScheduleOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous34> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous34;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous34>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DevelopmentInputScheduleInsert): ng.IPromise<DevelopmentInputSchedule> {
        let url_ = this.baseUrl + "/api/crud/developmentinputschedule/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DevelopmentInputSchedule> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputSchedule;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputSchedule>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DevelopmentInputScheduleUpdate): ng.IPromise<DevelopmentInputSchedule> {
        let url_ = this.baseUrl + "/api/crud/developmentinputschedule/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DevelopmentInputSchedule> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputSchedule;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputSchedule>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/developmentinputschedule/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/developmentinputschedule/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DevelopmentInputWithNoLoginClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    fetchByIntroducerId(introducerId: number): ng.IPromise<DevelopmentInputWithNoLogin[]> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/fetchByIntroducerId?";
        if (introducerId === undefined || introducerId === null)
            throw new Error("The parameter 'introducerId' must be defined and cannot be null.");
        else
            url_ += "IntroducerId=" + encodeURIComponent("" + introducerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchByIntroducerId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchByIntroducerId(_response);
            throw _response;
        });
    }

    protected processFetchByIntroducerId(response: any): ng.IPromise<DevelopmentInputWithNoLogin[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLogin[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLogin[]>(null as any);
    }

    /**
     * @return OK
     */
    fetchByUniqueId(uniqueId: string): ng.IPromise<DevelopmentInputWithNoLogin> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/fetchByUniqueId?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "UniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchByUniqueId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchByUniqueId(_response);
            throw _response;
        });
    }

    protected processFetchByUniqueId(response: any): ng.IPromise<DevelopmentInputWithNoLogin> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLogin;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLogin>(null as any);
    }

    /**
     * @return OK
     */
    sendEmailToNewUser(uniqueId: string, showLenderNameValue: boolean, updateshowLenderName: boolean): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/sendemailtonewuser?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "UniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        if (showLenderNameValue === undefined || showLenderNameValue === null)
            throw new Error("The parameter 'showLenderNameValue' must be defined and cannot be null.");
        else
            url_ += "showLenderNameValue=" + encodeURIComponent("" + showLenderNameValue) + "&";
        if (updateshowLenderName === undefined || updateshowLenderName === null)
            throw new Error("The parameter 'updateshowLenderName' must be defined and cannot be null.");
        else
            url_ += "updateshowLenderName=" + encodeURIComponent("" + updateshowLenderName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendEmailToNewUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendEmailToNewUser(_response);
            throw _response;
        });
    }

    protected processSendEmailToNewUser(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @param sendEnterpriseEmail (optional) 
     * @return OK
     */
    saveChangesToReferredSearch(uniqueId: string, body: DevelopmentInputWithNoLogin, sendEnterpriseEmail?: boolean | undefined): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/savechangestoreferredsearch?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "UniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        if (sendEnterpriseEmail === null)
            throw new Error("The parameter 'sendEnterpriseEmail' cannot be null.");
        else if (sendEnterpriseEmail !== undefined)
            url_ += "sendEnterpriseEmail=" + encodeURIComponent("" + sendEnterpriseEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveChangesToReferredSearch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveChangesToReferredSearch(_response);
            throw _response;
        });
    }

    protected processSaveChangesToReferredSearch(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addClientToSearch(uniqueId: string, clientId: number, body: DevelopmentInputWithNoLogin): ng.IPromise<DevelopmentInputWithNoLogin> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/addclienttosearch?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "UniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddClientToSearch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddClientToSearch(_response);
            throw _response;
        });
    }

    protected processAddClientToSearch(response: any): ng.IPromise<DevelopmentInputWithNoLogin> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLogin;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLogin>(null as any);
    }

    /**
     * @return OK
     */
    isResultActive(uniqueId: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/isresultactive?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "UniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsResultActive(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsResultActive(_response);
            throw _response;
        });
    }

    protected processIsResultActive(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    fetchDataByUniqueId(uniqueId: string): ng.IPromise<DevelopmentInputWithNoLogin> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/fetchdatabyuniqueId?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined and cannot be null.");
        else
            url_ += "UniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchDataByUniqueId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchDataByUniqueId(_response);
            throw _response;
        });
    }

    protected processFetchDataByUniqueId(response: any): ng.IPromise<DevelopmentInputWithNoLogin> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLogin;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLogin>(null as any);
    }

    /**
     * @return OK
     */
    sendResultsToExistingClient(clientFirstName: string, clientSurname: string, clientEmail: string, clientId: number, notifyClient: boolean, clientPhoneNumber: string, body: DevelopmentInputWithNoLogin): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/sendresultstoexistingclient?";
        if (clientFirstName === undefined || clientFirstName === null)
            throw new Error("The parameter 'clientFirstName' must be defined and cannot be null.");
        else
            url_ += "clientFirstName=" + encodeURIComponent("" + clientFirstName) + "&";
        if (clientSurname === undefined || clientSurname === null)
            throw new Error("The parameter 'clientSurname' must be defined and cannot be null.");
        else
            url_ += "clientSurname=" + encodeURIComponent("" + clientSurname) + "&";
        if (clientEmail === undefined || clientEmail === null)
            throw new Error("The parameter 'clientEmail' must be defined and cannot be null.");
        else
            url_ += "clientEmail=" + encodeURIComponent("" + clientEmail) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (notifyClient === undefined || notifyClient === null)
            throw new Error("The parameter 'notifyClient' must be defined and cannot be null.");
        else
            url_ += "notifyClient=" + encodeURIComponent("" + notifyClient) + "&";
        if (clientPhoneNumber === undefined || clientPhoneNumber === null)
            throw new Error("The parameter 'clientPhoneNumber' must be defined and cannot be null.");
        else
            url_ += "clientPhoneNumber=" + encodeURIComponent("" + clientPhoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendResultsToExistingClient(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendResultsToExistingClient(_response);
            throw _response;
        });
    }

    protected processSendResultsToExistingClient(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DevelopmentInputWithNoLogin[]> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DevelopmentInputWithNoLogin[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLogin[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLogin[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DevelopmentInputWithNoLogin> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DevelopmentInputWithNoLogin> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLogin;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLogin>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DevelopmentInputWithNoLoginPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DevelopmentInputWithNoLoginPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLoginPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLoginPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DevelopmentInputWithNoLoginPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DevelopmentInputWithNoLoginPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLoginPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLoginPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DevelopmentInputWithNoLogin): ng.IPromise<DevelopmentInputWithNoLogin> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DevelopmentInputWithNoLogin> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLogin;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLogin>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DevelopmentInputWithNoLogin): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DevelopmentInputWithNoLogin[]): ng.IPromise<DevelopmentInputWithNoLogin[]> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DevelopmentInputWithNoLogin[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLogin[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLogin[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DevelopmentInputWithNoLogin[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmentinputwithnologin/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DevelopmentInputWithNoLoginCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous35> {
        let url_ = this.baseUrl + "/odata/DevelopmentInputWithNoLoginOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous35> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous35;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous35>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DevelopmentInputWithNoLoginInsert): ng.IPromise<DevelopmentInputWithNoLogin> {
        let url_ = this.baseUrl + "/api/crud/developmentinputwithnologin/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DevelopmentInputWithNoLogin> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLogin;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLogin>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DevelopmentInputWithNoLoginUpdate): ng.IPromise<DevelopmentInputWithNoLogin> {
        let url_ = this.baseUrl + "/api/crud/developmentinputwithnologin/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DevelopmentInputWithNoLogin> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLogin;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLogin>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/developmentinputwithnologin/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/developmentinputwithnologin/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DevelopmentTrackRecordClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<DevelopmentTrackRecord[]> {
        let url_ = this.baseUrl + "/api/developmenttrackrecord/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<DevelopmentTrackRecord[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentTrackRecord[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentTrackRecord[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<DevelopmentTrackRecord> {
        let url_ = this.baseUrl + "/api/developmenttrackrecord/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<DevelopmentTrackRecord> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentTrackRecord;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentTrackRecord>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmenttrackrecord/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<DevelopmentTrackRecordPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developmenttrackrecord/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<DevelopmentTrackRecordPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentTrackRecordPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentTrackRecordPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<DevelopmentTrackRecordPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/developmenttrackrecord/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<DevelopmentTrackRecordPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentTrackRecordPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentTrackRecordPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: DevelopmentTrackRecord): ng.IPromise<DevelopmentTrackRecord> {
        let url_ = this.baseUrl + "/api/developmenttrackrecord/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<DevelopmentTrackRecord> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentTrackRecord;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentTrackRecord>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: DevelopmentTrackRecord): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/developmenttrackrecord/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: DevelopmentTrackRecord[]): ng.IPromise<DevelopmentTrackRecord[]> {
        let url_ = this.baseUrl + "/api/developmenttrackrecord/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<DevelopmentTrackRecord[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentTrackRecord[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentTrackRecord[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: DevelopmentTrackRecord[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/developmenttrackrecord/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmenttrackrecord/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/developmenttrackrecord/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DevelopmentTrackRecordCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous36> {
        let url_ = this.baseUrl + "/odata/DevelopmentTrackRecordOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous36> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous36;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous36>(null as any);
    }

    /**
     * @return OK
     */
    post(body: DevelopmentTrackRecordInsert): ng.IPromise<DevelopmentTrackRecord> {
        let url_ = this.baseUrl + "/api/crud/developmenttrackrecord/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<DevelopmentTrackRecord> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentTrackRecord;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentTrackRecord>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: DevelopmentTrackRecordUpdate): ng.IPromise<DevelopmentTrackRecord> {
        let url_ = this.baseUrl + "/api/crud/developmenttrackrecord/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<DevelopmentTrackRecord> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentTrackRecord;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentTrackRecord>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/developmenttrackrecord/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/developmenttrackrecord/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class DevFinanceSearchClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getSearchCriteriaAndResults(body: SearchResultsRequest): ng.IPromise<DevFinanceSearchResultsResponse> {
        let url_ = this.baseUrl + "/api/devfinancesearchresults/getsearchcriteriaandresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSearchCriteriaAndResults(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSearchCriteriaAndResults(_response);
            throw _response;
        });
    }

    protected processGetSearchCriteriaAndResults(response: any): ng.IPromise<DevFinanceSearchResultsResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevFinanceSearchResultsResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevFinanceSearchResultsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getSearchResults(body: SearchResultsRequest): ng.IPromise<DevFinanceSearchResultsResponse> {
        let url_ = this.baseUrl + "/api/devfinancesearchresults/getsearchresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSearchResults(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSearchResults(_response);
            throw _response;
        });
    }

    protected processGetSearchResults(response: any): ng.IPromise<DevFinanceSearchResultsResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevFinanceSearchResultsResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevFinanceSearchResultsResponse>(null as any);
    }

    /**
     * @param debug1 (optional) 
     * @param debug2 (optional) 
     * @param orgCode (optional) 
     * @param showLenderNamesAndLogosOverride (optional) 
     * @return OK
     */
    exportToPdf(body: DevelopmentFinanceDeal, debug1?: boolean | null | undefined, debug2?: boolean | null | undefined, orgCode?: string | undefined, showLenderNamesAndLogosOverride?: boolean | null | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/devfinancesearchresults/exportsearchtopdf?";
        if (debug1 !== undefined && debug1 !== null)
            url_ += "debug1=" + encodeURIComponent("" + debug1) + "&";
        if (debug2 !== undefined && debug2 !== null)
            url_ += "debug2=" + encodeURIComponent("" + debug2) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (showLenderNamesAndLogosOverride !== undefined && showLenderNamesAndLogosOverride !== null)
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportToPdf(_response);
            throw _response;
        });
    }

    protected processExportToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param debug1 (optional) 
     * @param debug2 (optional) 
     * @param orgCode (optional) 
     * @param showLenderNamesAndLogosOverride (optional) 
     * @return OK
     */
    exportSearchToPdf(dealId: number, debug1?: boolean | undefined, debug2?: boolean | undefined, orgCode?: string | undefined, showLenderNamesAndLogosOverride?: boolean | null | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/devfinancesearchresults/exportsearchtopdf?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (debug1 === null)
            throw new Error("The parameter 'debug1' cannot be null.");
        else if (debug1 !== undefined)
            url_ += "debug1=" + encodeURIComponent("" + debug1) + "&";
        if (debug2 === null)
            throw new Error("The parameter 'debug2' cannot be null.");
        else if (debug2 !== undefined)
            url_ += "debug2=" + encodeURIComponent("" + debug2) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (showLenderNamesAndLogosOverride !== undefined && showLenderNamesAndLogosOverride !== null)
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportSearchToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportSearchToPdf(_response);
            throw _response;
        });
    }

    protected processExportSearchToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param orgCode (optional) 
     * @return OK
     */
    exportShortListedResultsToPdf(showLenderNamesAndLogosOverride: boolean, body: DevelopmentFinanceDeal, orgCode?: string | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/devfinancesearchresults/exportshortlistedresultstopdf?";
        if (showLenderNamesAndLogosOverride === undefined || showLenderNamesAndLogosOverride === null)
            throw new Error("The parameter 'showLenderNamesAndLogosOverride' must be defined and cannot be null.");
        else
            url_ += "showLenderNamesAndLogosOverride=" + encodeURIComponent("" + showLenderNamesAndLogosOverride) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportShortListedResultsToPdf(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportShortListedResultsToPdf(_response);
            throw _response;
        });
    }

    protected processExportShortListedResultsToPdf(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }
}

export class ExternalApiClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getDeals(body: ThirdPartyGetDealsRequestDTO): ng.IPromise<ThirdPartyGetDealsResponseDTO> {
        let url_ = this.baseUrl + "/api/external/v1/getdeals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetDeals(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetDeals(_response);
            throw _response;
        });
    }

    protected processGetDeals(response: any): ng.IPromise<ThirdPartyGetDealsResponseDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyGetDealsResponseDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyGetDealsResponseDTO>(null as any);
    }

    /**
     * @return OK
     */
    getDealDetails(body: ThirdPartyGetDealRequestDTO): ng.IPromise<ThirdPartyGetDealResponseDTO> {
        let url_ = this.baseUrl + "/api/external/v1/getdealdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetDealDetails(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetDealDetails(_response);
            throw _response;
        });
    }

    protected processGetDealDetails(response: any): ng.IPromise<ThirdPartyGetDealResponseDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyGetDealResponseDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyGetDealResponseDTO>(null as any);
    }

    /**
     * @return OK
     */
    updateDeal(newExternalRef: string, newName: string, productType: string, externalDealRef: string, uniqueRef: string, externalRequestRef: string): ng.IPromise<ThirdPartyUpdateDealResponseDTO> {
        let url_ = this.baseUrl + "/api/external/v1/updatedeal?";
        if (newExternalRef === undefined || newExternalRef === null)
            throw new Error("The parameter 'newExternalRef' must be defined and cannot be null.");
        else
            url_ += "NewExternalRef=" + encodeURIComponent("" + newExternalRef) + "&";
        if (newName === undefined || newName === null)
            throw new Error("The parameter 'newName' must be defined and cannot be null.");
        else
            url_ += "NewName=" + encodeURIComponent("" + newName) + "&";
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "ProductType=" + encodeURIComponent("" + productType) + "&";
        if (externalDealRef === undefined || externalDealRef === null)
            throw new Error("The parameter 'externalDealRef' must be defined and cannot be null.");
        else
            url_ += "ExternalDealRef=" + encodeURIComponent("" + externalDealRef) + "&";
        if (uniqueRef === undefined || uniqueRef === null)
            throw new Error("The parameter 'uniqueRef' must be defined and cannot be null.");
        else
            url_ += "UniqueRef=" + encodeURIComponent("" + uniqueRef) + "&";
        if (externalRequestRef === undefined || externalRequestRef === null)
            throw new Error("The parameter 'externalRequestRef' must be defined and cannot be null.");
        else
            url_ += "ExternalRequestRef=" + encodeURIComponent("" + externalRequestRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateDeal(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateDeal(_response);
            throw _response;
        });
    }

    protected processUpdateDeal(response: any): ng.IPromise<ThirdPartyUpdateDealResponseDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyUpdateDealResponseDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyUpdateDealResponseDTO>(null as any);
    }

    /**
     * @return OK
     */
    bridgingPreconstruction(body: ThirdPartyBridgingDealCriteriaDTO): ng.IPromise<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO> {
        let url_ = this.baseUrl + "/api/external/v1/bridgingPreconstruction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processBridgingPreconstruction(_response);
        }, (_response) => {
            if (_response.status)
                return this.processBridgingPreconstruction(_response);
            throw _response;
        });
    }

    protected processBridgingPreconstruction(response: any): ng.IPromise<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO>(null as any);
    }

    /**
     * @return OK
     */
    bridgingPurchaseOrRefinance(body: ThirdPartyBridgingDealCriteriaDTO): ng.IPromise<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO> {
        let url_ = this.baseUrl + "/api/external/v1/bridgingPurchaseOrRefinance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processBridgingPurchaseOrRefinance(_response);
        }, (_response) => {
            if (_response.status)
                return this.processBridgingPurchaseOrRefinance(_response);
            throw _response;
        });
    }

    protected processBridgingPurchaseOrRefinance(response: any): ng.IPromise<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO>(null as any);
    }

    /**
     * @return OK
     */
    bridgingRefurbishment(body: ThirdPartyBridgingDealCriteriaDTO): ng.IPromise<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO> {
        let url_ = this.baseUrl + "/api/external/v1/bridgingRefurbishment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processBridgingRefurbishment(_response);
        }, (_response) => {
            if (_response.status)
                return this.processBridgingRefurbishment(_response);
            throw _response;
        });
    }

    protected processBridgingRefurbishment(response: any): ng.IPromise<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO>(null as any);
    }

    /**
     * @return OK
     */
    bridgingDeveloperExit(body: ThirdPartyBridgingDealCriteriaDTO): ng.IPromise<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO> {
        let url_ = this.baseUrl + "/api/external/v1/bridgingDeveloperExit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processBridgingDeveloperExit(_response);
        }, (_response) => {
            if (_response.status)
                return this.processBridgingDeveloperExit(_response);
            throw _response;
        });
    }

    protected processBridgingDeveloperExit(response: any): ng.IPromise<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO>(null as any);
    }

    /**
     * @return OK
     */
    commercial(body: ThirdPartyCommercialDealCriteriaDTO): ng.IPromise<ThirdPartyCommercialResultsDTOThirdPartyResultHeaderDTO> {
        let url_ = this.baseUrl + "/api/external/v1/commercial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCommercial(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCommercial(_response);
            throw _response;
        });
    }

    protected processCommercial(response: any): ng.IPromise<ThirdPartyCommercialResultsDTOThirdPartyResultHeaderDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyCommercialResultsDTOThirdPartyResultHeaderDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyCommercialResultsDTOThirdPartyResultHeaderDTO>(null as any);
    }

    /**
     * @return OK
     */
    commercialOwnerOccupier(body: ThirdPartyCommercialDealCriteriaDTO): ng.IPromise<ThirdPartyCommercialResultsDTOThirdPartyResultHeaderDTO> {
        let url_ = this.baseUrl + "/api/external/v1/commercialOwnerOccupier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCommercialOwnerOccupier(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCommercialOwnerOccupier(_response);
            throw _response;
        });
    }

    protected processCommercialOwnerOccupier(response: any): ng.IPromise<ThirdPartyCommercialResultsDTOThirdPartyResultHeaderDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyCommercialResultsDTOThirdPartyResultHeaderDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyCommercialResultsDTOThirdPartyResultHeaderDTO>(null as any);
    }

    /**
     * @return OK
     */
    development(body: ThirdPartyDevelopmentDealCriteriaDTO): ng.IPromise<ThirdPartySearchResultsDTOThirdPartyResultHeaderDTO> {
        let url_ = this.baseUrl + "/api/external/v1/development";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDevelopment(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDevelopment(_response);
            throw _response;
        });
    }

    protected processDevelopment(response: any): ng.IPromise<ThirdPartySearchResultsDTOThirdPartyResultHeaderDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartySearchResultsDTOThirdPartyResultHeaderDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartySearchResultsDTOThirdPartyResultHeaderDTO>(null as any);
    }

    /**
     * @return OK
     */
    deal(body: ThirdPartyBridgingDealCriteriaDTO): ng.IPromise<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO> {
        let url_ = this.baseUrl + "/api/external/v1/deal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDeal(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDeal(_response);
            throw _response;
        });
    }

    protected processDeal(response: any): ng.IPromise<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO>(null as any);
    }

    /**
     * @return OK
     */
    search(body: ThirdPartySearchCriteriaDTO): ng.IPromise<ThirdPartySearchResultsDTOThirdPartyResultHeaderDTO> {
        let url_ = this.baseUrl + "/api/external/v1/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSearch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSearch(_response);
            throw _response;
        });
    }

    protected processSearch(response: any): ng.IPromise<ThirdPartySearchResultsDTOThirdPartyResultHeaderDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartySearchResultsDTOThirdPartyResultHeaderDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartySearchResultsDTOThirdPartyResultHeaderDTO>(null as any);
    }

    /**
     * @return OK
     */
    referUser(body: ThirdPartyReferUserDTO): ng.IPromise<ThirdPartyReferUserResponseDTO> {
        let url_ = this.baseUrl + "/api/external/v1/referuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processReferUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processReferUser(_response);
            throw _response;
        });
    }

    protected processReferUser(response: any): ng.IPromise<ThirdPartyReferUserResponseDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyReferUserResponseDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyReferUserResponseDTO>(null as any);
    }
}

export class ExternalLinksClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<ExternalLinks[]> {
        let url_ = this.baseUrl + "/api/externallinks/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<ExternalLinks[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExternalLinks[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ExternalLinks[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<ExternalLinks> {
        let url_ = this.baseUrl + "/api/externallinks/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<ExternalLinks> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExternalLinks;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ExternalLinks>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/externallinks/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ExternalLinksPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/externallinks/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ExternalLinksPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExternalLinksPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ExternalLinksPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ExternalLinksPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/externallinks/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ExternalLinksPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExternalLinksPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ExternalLinksPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: ExternalLinks): ng.IPromise<ExternalLinks> {
        let url_ = this.baseUrl + "/api/externallinks/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<ExternalLinks> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExternalLinks;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ExternalLinks>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: ExternalLinks): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/externallinks/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: ExternalLinks[]): ng.IPromise<ExternalLinks[]> {
        let url_ = this.baseUrl + "/api/externallinks/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<ExternalLinks[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExternalLinks[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ExternalLinks[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: ExternalLinks[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/externallinks/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/externallinks/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/externallinks/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ExternalLinksCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous37> {
        let url_ = this.baseUrl + "/odata/ExternalLinksOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous37> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous37;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous37>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ExternalLinksInsert): ng.IPromise<ExternalLinks> {
        let url_ = this.baseUrl + "/api/crud/externallinks/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<ExternalLinks> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExternalLinks;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ExternalLinks>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ExternalLinksUpdate): ng.IPromise<ExternalLinks> {
        let url_ = this.baseUrl + "/api/crud/externallinks/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<ExternalLinks> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExternalLinks;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ExternalLinks>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/externallinks/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/externallinks/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class FeedBackClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    addFeedBack(dealLenderId: number, isDeal: boolean, body: FeedBack): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/feedback/addfeedback?";
        if (dealLenderId === undefined || dealLenderId === null)
            throw new Error("The parameter 'dealLenderId' must be defined and cannot be null.");
        else
            url_ += "dealLenderId=" + encodeURIComponent("" + dealLenderId) + "&";
        if (isDeal === undefined || isDeal === null)
            throw new Error("The parameter 'isDeal' must be defined and cannot be null.");
        else
            url_ += "isDeal=" + encodeURIComponent("" + isDeal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddFeedBack(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddFeedBack(_response);
            throw _response;
        });
    }

    protected processAddFeedBack(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getFeedBackAndReviewerDetails(body: FeedBackMessageRequest): ng.IPromise<FeedBackMessageResponse> {
        let url_ = this.baseUrl + "/api/feedback/getfeedbackandreviewerdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetFeedBackAndReviewerDetails(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetFeedBackAndReviewerDetails(_response);
            throw _response;
        });
    }

    protected processGetFeedBackAndReviewerDetails(response: any): ng.IPromise<FeedBackMessageResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeedBackMessageResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FeedBackMessageResponse>(null as any);
    }

    /**
     * @return OK
     */
    sendFeedBackReply(dealLenderId: number, isDeal: boolean, body: FeedBack): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/feedback/sendfeedbackreply?";
        if (dealLenderId === undefined || dealLenderId === null)
            throw new Error("The parameter 'dealLenderId' must be defined and cannot be null.");
        else
            url_ += "dealLenderId=" + encodeURIComponent("" + dealLenderId) + "&";
        if (isDeal === undefined || isDeal === null)
            throw new Error("The parameter 'isDeal' must be defined and cannot be null.");
        else
            url_ += "isDeal=" + encodeURIComponent("" + isDeal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendFeedBackReply(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendFeedBackReply(_response);
            throw _response;
        });
    }

    protected processSendFeedBackReply(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<FeedBack[]> {
        let url_ = this.baseUrl + "/api/feedback/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<FeedBack[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeedBack[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FeedBack[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<FeedBack> {
        let url_ = this.baseUrl + "/api/feedback/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<FeedBack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeedBack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FeedBack>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/feedback/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<FeedBackPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/feedback/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<FeedBackPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeedBackPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FeedBackPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<FeedBackPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/feedback/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<FeedBackPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeedBackPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FeedBackPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: FeedBack): ng.IPromise<FeedBack> {
        let url_ = this.baseUrl + "/api/feedback/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<FeedBack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeedBack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FeedBack>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: FeedBack): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/feedback/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: FeedBack[]): ng.IPromise<FeedBack[]> {
        let url_ = this.baseUrl + "/api/feedback/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<FeedBack[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeedBack[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FeedBack[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: FeedBack[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/feedback/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/feedback/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/feedback/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class FeedBackCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous38> {
        let url_ = this.baseUrl + "/odata/FeedBackOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous38> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous38;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous38>(null as any);
    }

    /**
     * @return OK
     */
    post(body: FeedBackInsert): ng.IPromise<FeedBack> {
        let url_ = this.baseUrl + "/api/crud/feedback/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<FeedBack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeedBack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FeedBack>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: FeedBackUpdate): ng.IPromise<FeedBack> {
        let url_ = this.baseUrl + "/api/crud/feedback/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<FeedBack> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeedBack;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FeedBack>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/feedback/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/feedback/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class FileAttachmentClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param caseLenderId (optional) 
     * @return OK
     */
    getAmazonFileUploadUri(filename: string, fileType: string, casenumber: number, module: ModuleEnum, caseLenderId?: number | undefined): ng.IPromise<FileAttachment> {
        let url_ = this.baseUrl + "/api/fileattachment/fileuploaduri?";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined and cannot be null.");
        else
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (casenumber === undefined || casenumber === null)
            throw new Error("The parameter 'casenumber' must be defined and cannot be null.");
        else
            url_ += "casenumber=" + encodeURIComponent("" + casenumber) + "&";
        if (module === undefined || module === null)
            throw new Error("The parameter 'module' must be defined and cannot be null.");
        else
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        if (caseLenderId === null)
            throw new Error("The parameter 'caseLenderId' cannot be null.");
        else if (caseLenderId !== undefined)
            url_ += "caseLenderId=" + encodeURIComponent("" + caseLenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAmazonFileUploadUri(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAmazonFileUploadUri(_response);
            throw _response;
        });
    }

    protected processGetAmazonFileUploadUri(response: any): ng.IPromise<FileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileAttachment>(null as any);
    }

    /**
     * @return OK
     */
    getAmazonFileUploadURL(filename: string, fileType: string): ng.IPromise<FileAttachment> {
        let url_ = this.baseUrl + "/api/fileattachment/fileupload?";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined and cannot be null.");
        else
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAmazonFileUploadURL(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAmazonFileUploadURL(_response);
            throw _response;
        });
    }

    protected processGetAmazonFileUploadURL(response: any): ng.IPromise<FileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileAttachment>(null as any);
    }

    /**
     * @return OK
     */
    getAmazonFileAccessUri(key: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/fileattachment/fileuri?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAmazonFileAccessUri(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAmazonFileAccessUri(_response);
            throw _response;
        });
    }

    protected processGetAmazonFileAccessUri(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    fileRename(body: FileAttachment): ng.IPromise<FileAttachment> {
        let url_ = this.baseUrl + "/api/fileattachment/filerename";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFileRename(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFileRename(_response);
            throw _response;
        });
    }

    protected processFileRename(response: any): ng.IPromise<FileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileAttachment>(null as any);
    }

    /**
     * @param orgCode (optional) 
     * @return OK
     */
    getPublicImageUrl(fileName: string, fileType: string, orgCode?: string | undefined): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/fileattachment/getpublicimageurl?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetPublicImageUrl(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetPublicImageUrl(_response);
            throw _response;
        });
    }

    protected processGetPublicImageUrl(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<FileAttachment[]> {
        let url_ = this.baseUrl + "/api/fileattachment/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<FileAttachment[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAttachment[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileAttachment[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<FileAttachment> {
        let url_ = this.baseUrl + "/api/fileattachment/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<FileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileAttachment>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/fileattachment/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<FileAttachmentPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/fileattachment/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<FileAttachmentPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAttachmentPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileAttachmentPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<FileAttachmentPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/fileattachment/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<FileAttachmentPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAttachmentPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileAttachmentPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: FileAttachment): ng.IPromise<FileAttachment> {
        let url_ = this.baseUrl + "/api/fileattachment/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<FileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileAttachment>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: FileAttachment): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/fileattachment/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: FileAttachment[]): ng.IPromise<FileAttachment[]> {
        let url_ = this.baseUrl + "/api/fileattachment/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<FileAttachment[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAttachment[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileAttachment[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: FileAttachment[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/fileattachment/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/fileattachment/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/fileattachment/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class FileAttachmentCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous39> {
        let url_ = this.baseUrl + "/odata/FileAttachmentOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous39> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous39;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous39>(null as any);
    }

    /**
     * @return OK
     */
    post(body: FileAttachmentInsert): ng.IPromise<FileAttachment> {
        let url_ = this.baseUrl + "/api/crud/fileattachment/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<FileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileAttachment>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: FileAttachmentUpdate): ng.IPromise<FileAttachment> {
        let url_ = this.baseUrl + "/api/crud/fileattachment/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<FileAttachment> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAttachment;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileAttachment>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/fileattachment/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/fileattachment/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class IntroducerClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    registerIntroducer(sendEmail: boolean, body: Introducer): ng.IPromise<Introducer> {
        let url_ = this.baseUrl + "/api/introducer/register?";
        if (sendEmail === undefined || sendEmail === null)
            throw new Error("The parameter 'sendEmail' must be defined and cannot be null.");
        else
            url_ += "sendEmail=" + encodeURIComponent("" + sendEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRegisterIntroducer(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRegisterIntroducer(_response);
            throw _response;
        });
    }

    protected processRegisterIntroducer(response: any): ng.IPromise<Introducer> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Introducer;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Introducer>(null as any);
    }

    /**
     * @return OK
     */
    sendLikToClient(userFirstName: string, userEmail: string, userId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/introducer/sendLinkToUser?";
        if (userFirstName === undefined || userFirstName === null)
            throw new Error("The parameter 'userFirstName' must be defined and cannot be null.");
        else
            url_ += "userFirstName=" + encodeURIComponent("" + userFirstName) + "&";
        if (userEmail === undefined || userEmail === null)
            throw new Error("The parameter 'userEmail' must be defined and cannot be null.");
        else
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendLikToClient(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendLikToClient(_response);
            throw _response;
        });
    }

    protected processSendLikToClient(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    copyLinkToClipboard(userId: number): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/introducer/copyLinkToClipboard?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCopyLinkToClipboard(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCopyLinkToClipboard(_response);
            throw _response;
        });
    }

    protected processCopyLinkToClipboard(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @param guid (optional) 
     * @return OK
     */
    introduceClient(clientFirstName: string, clientEmail: string, clientsurname: string, clientPhoneNumber: string, guid?: string | undefined): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/introducer/introduceclient?";
        if (clientFirstName === undefined || clientFirstName === null)
            throw new Error("The parameter 'clientFirstName' must be defined and cannot be null.");
        else
            url_ += "clientFirstName=" + encodeURIComponent("" + clientFirstName) + "&";
        if (clientEmail === undefined || clientEmail === null)
            throw new Error("The parameter 'clientEmail' must be defined and cannot be null.");
        else
            url_ += "clientEmail=" + encodeURIComponent("" + clientEmail) + "&";
        if (clientsurname === undefined || clientsurname === null)
            throw new Error("The parameter 'clientsurname' must be defined and cannot be null.");
        else
            url_ += "clientsurname=" + encodeURIComponent("" + clientsurname) + "&";
        if (clientPhoneNumber === undefined || clientPhoneNumber === null)
            throw new Error("The parameter 'clientPhoneNumber' must be defined and cannot be null.");
        else
            url_ += "clientPhoneNumber=" + encodeURIComponent("" + clientPhoneNumber) + "&";
        if (guid === null)
            throw new Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIntroduceClient(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIntroduceClient(_response);
            throw _response;
        });
    }

    protected processIntroduceClient(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sendResultsToClient(clientFirstName: string, clientSurname: string, clientEmail: string, notifyBorrower: boolean, clientPhoneNumber: string, body: DevelopmentInput): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/introducer/sendresultstoclient?";
        if (clientFirstName === undefined || clientFirstName === null)
            throw new Error("The parameter 'clientFirstName' must be defined and cannot be null.");
        else
            url_ += "clientFirstName=" + encodeURIComponent("" + clientFirstName) + "&";
        if (clientSurname === undefined || clientSurname === null)
            throw new Error("The parameter 'clientSurname' must be defined and cannot be null.");
        else
            url_ += "clientSurname=" + encodeURIComponent("" + clientSurname) + "&";
        if (clientEmail === undefined || clientEmail === null)
            throw new Error("The parameter 'clientEmail' must be defined and cannot be null.");
        else
            url_ += "clientEmail=" + encodeURIComponent("" + clientEmail) + "&";
        if (notifyBorrower === undefined || notifyBorrower === null)
            throw new Error("The parameter 'notifyBorrower' must be defined and cannot be null.");
        else
            url_ += "notifyBorrower=" + encodeURIComponent("" + notifyBorrower) + "&";
        if (clientPhoneNumber === undefined || clientPhoneNumber === null)
            throw new Error("The parameter 'clientPhoneNumber' must be defined and cannot be null.");
        else
            url_ += "clientPhoneNumber=" + encodeURIComponent("" + clientPhoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendResultsToClient(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendResultsToClient(_response);
            throw _response;
        });
    }

    protected processSendResultsToClient(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    fetchUnclaimedSearches(): ng.IPromise<DevelopmentInputWithNoLogin[]> {
        let url_ = this.baseUrl + "/api/introducer/fetchunclaimedsearches";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchUnclaimedSearches(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchUnclaimedSearches(_response);
            throw _response;
        });
    }

    protected processFetchUnclaimedSearches(response: any): ng.IPromise<DevelopmentInputWithNoLogin[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentInputWithNoLogin[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DevelopmentInputWithNoLogin[]>(null as any);
    }

    /**
     * @return OK
     */
    getIntroducerDetailsByUserId(userId: number): ng.IPromise<Introducer> {
        let url_ = this.baseUrl + "/api/introducer/getintroducerdetailsbyuserid?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetIntroducerDetailsByUserId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetIntroducerDetailsByUserId(_response);
            throw _response;
        });
    }

    protected processGetIntroducerDetailsByUserId(response: any): ng.IPromise<Introducer> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Introducer;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Introducer>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<Introducer[]> {
        let url_ = this.baseUrl + "/api/introducer/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<Introducer[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Introducer[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Introducer[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<Introducer> {
        let url_ = this.baseUrl + "/api/introducer/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<Introducer> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Introducer;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Introducer>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/introducer/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<IntroducerPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/introducer/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<IntroducerPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntroducerPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<IntroducerPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<IntroducerPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/introducer/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<IntroducerPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntroducerPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<IntroducerPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: Introducer): ng.IPromise<Introducer> {
        let url_ = this.baseUrl + "/api/introducer/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<Introducer> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Introducer;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Introducer>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: Introducer): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/introducer/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: Introducer[]): ng.IPromise<Introducer[]> {
        let url_ = this.baseUrl + "/api/introducer/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<Introducer[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Introducer[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Introducer[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: Introducer[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/introducer/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/introducer/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/introducer/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class IntroducerCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous40> {
        let url_ = this.baseUrl + "/odata/IntroducerOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous40> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous40;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous40>(null as any);
    }

    /**
     * @return OK
     */
    post(body: IntroducerInsert): ng.IPromise<Introducer> {
        let url_ = this.baseUrl + "/api/crud/introducer/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<Introducer> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Introducer;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Introducer>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: IntroducerUpdate): ng.IPromise<Introducer> {
        let url_ = this.baseUrl + "/api/crud/introducer/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<Introducer> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Introducer;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Introducer>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/introducer/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/introducer/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class IntroducerSimpleClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getIntroducerDetails(): ng.IPromise<IntroducerSimpleDTO> {
        let url_ = this.baseUrl + "/getintroducerdetails";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetIntroducerDetails(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetIntroducerDetails(_response);
            throw _response;
        });
    }

    protected processGetIntroducerDetails(response: any): ng.IPromise<IntroducerSimpleDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntroducerSimpleDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<IntroducerSimpleDTO>(null as any);
    }
}

export class InviteClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getListInvitedUsers(userId: number): ng.IPromise<Invite[]> {
        let url_ = this.baseUrl + "/api/invite/getListInvitedBrokers?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetListInvitedUsers(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetListInvitedUsers(_response);
            throw _response;
        });
    }

    protected processGetListInvitedUsers(response: any): ng.IPromise<Invite[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Invite[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Invite[]>(null as any);
    }

    /**
     * @return OK
     */
    checkIfInvitedIsUser(invitationCode: string, userId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/invite/checkIfInvitedIsUser?";
        if (invitationCode === undefined || invitationCode === null)
            throw new Error("The parameter 'invitationCode' must be defined and cannot be null.");
        else
            url_ += "invitationCode=" + encodeURIComponent("" + invitationCode) + "&";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCheckIfInvitedIsUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCheckIfInvitedIsUser(_response);
            throw _response;
        });
    }

    protected processCheckIfInvitedIsUser(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    checkIfRegisterUserWasInvited(inviteEmail: string, inviteGuid: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/invite/checkIfRegisterUserWasInvited?";
        if (inviteEmail === undefined || inviteEmail === null)
            throw new Error("The parameter 'inviteEmail' must be defined and cannot be null.");
        else
            url_ += "inviteEmail=" + encodeURIComponent("" + inviteEmail) + "&";
        if (inviteGuid === undefined || inviteGuid === null)
            throw new Error("The parameter 'inviteGuid' must be defined and cannot be null.");
        else
            url_ += "inviteGuid=" + encodeURIComponent("" + inviteGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCheckIfRegisterUserWasInvited(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCheckIfRegisterUserWasInvited(_response);
            throw _response;
        });
    }

    protected processCheckIfRegisterUserWasInvited(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<Invite[]> {
        let url_ = this.baseUrl + "/api/invite/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<Invite[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Invite[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Invite[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<Invite> {
        let url_ = this.baseUrl + "/api/invite/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<Invite> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Invite;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Invite>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/invite/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<InvitePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/invite/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<InvitePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvitePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<InvitePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<InvitePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/invite/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<InvitePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvitePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<InvitePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: Invite): ng.IPromise<Invite> {
        let url_ = this.baseUrl + "/api/invite/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<Invite> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Invite;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Invite>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: Invite): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/invite/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: Invite[]): ng.IPromise<Invite[]> {
        let url_ = this.baseUrl + "/api/invite/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<Invite[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Invite[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Invite[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: Invite[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/invite/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/invite/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/invite/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class InviteCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous41> {
        let url_ = this.baseUrl + "/odata/InviteOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous41> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous41;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous41>(null as any);
    }

    /**
     * @return OK
     */
    post(body: InviteInsert): ng.IPromise<Invite> {
        let url_ = this.baseUrl + "/api/crud/invite/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<Invite> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Invite;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Invite>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: InviteUpdate): ng.IPromise<Invite> {
        let url_ = this.baseUrl + "/api/crud/invite/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<Invite> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Invite;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Invite>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/invite/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/invite/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class LenderClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    fetchAll(): ng.IPromise<Lender[]> {
        let url_ = this.baseUrl + "/api/lender/fetchall";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetchAll(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetchAll(_response);
            throw _response;
        });
    }

    protected processFetchAll(response: any): ng.IPromise<Lender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Lender[]>(null as any);
    }

    /**
     * @param addLender (optional) 
     * @param updateLender (optional) 
     * @param disableProducts (optional) 
     * @param isSimulated (optional) 
     * @return OK
     */
    importProducts(addLender?: boolean | undefined, updateLender?: boolean | undefined, disableProducts?: boolean | undefined, isSimulated?: boolean | undefined): ng.IPromise<ImportProductResponse> {
        let url_ = this.baseUrl + "/api/lender/importproducts?";
        if (addLender === null)
            throw new Error("The parameter 'addLender' cannot be null.");
        else if (addLender !== undefined)
            url_ += "addLender=" + encodeURIComponent("" + addLender) + "&";
        if (updateLender === null)
            throw new Error("The parameter 'updateLender' cannot be null.");
        else if (updateLender !== undefined)
            url_ += "updateLender=" + encodeURIComponent("" + updateLender) + "&";
        if (disableProducts === null)
            throw new Error("The parameter 'disableProducts' cannot be null.");
        else if (disableProducts !== undefined)
            url_ += "disableProducts=" + encodeURIComponent("" + disableProducts) + "&";
        if (isSimulated === null)
            throw new Error("The parameter 'isSimulated' cannot be null.");
        else if (isSimulated !== undefined)
            url_ += "isSimulated=" + encodeURIComponent("" + isSimulated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processImportProducts(_response);
        }, (_response) => {
            if (_response.status)
                return this.processImportProducts(_response);
            throw _response;
        });
    }

    protected processImportProducts(response: any): ng.IPromise<ImportProductResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportProductResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ImportProductResponse>(null as any);
    }

    /**
     * @return OK
     */
    exportSpreadsheetTemplate(): ng.IPromise<FileResponse> {
        let url_ = this.baseUrl + "/api/lender/exportspreadsheettemplate";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            responseType: "arraybuffer",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportSpreadsheetTemplate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportSpreadsheetTemplate(_response);
            throw _response;
        });
    }

    protected processExportSpreadsheetTemplate(response: any): ng.IPromise<FileResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return this.q.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(new Blob([response.data]), this.q).then(_responseText => {
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return this.q.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    exportProducts(): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/lender/exportproducts";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportProducts(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportProducts(_response);
            throw _response;
        });
    }

    protected processExportProducts(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getUserLenderDetails(): ng.IPromise<Lender> {
        let url_ = this.baseUrl + "/api/lender/getuserlenderdetails";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetUserLenderDetails(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetUserLenderDetails(_response);
            throw _response;
        });
    }

    protected processGetUserLenderDetails(response: any): ng.IPromise<Lender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Lender>(null as any);
    }

    /**
     * @return OK
     */
    getLenderLogos(body: number[]): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/lender/getlenderlogos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetLenderLogos(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetLenderLogos(_response);
            throw _response;
        });
    }

    protected processGetLenderLogos(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllLenderLogos(): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/lender/getalllenderlogos";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAllLenderLogos(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAllLenderLogos(_response);
            throw _response;
        });
    }

    protected processGetAllLenderLogos(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param productType (optional) 
     * @param brokerOrgId (optional) 
     * @return OK
     */
    getTotalLenders(productType?: ProductFamilyEnum | undefined, brokerOrgId?: number | null | undefined): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/lender/gettotallenders?";
        if (productType === null)
            throw new Error("The parameter 'productType' cannot be null.");
        else if (productType !== undefined)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (brokerOrgId !== undefined && brokerOrgId !== null)
            url_ += "brokerOrgId=" + encodeURIComponent("" + brokerOrgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetTotalLenders(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetTotalLenders(_response);
            throw _response;
        });
    }

    protected processGetTotalLenders(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    getSelectedLendersName(body: SelectedResultDTO[]): ng.IPromise<GetSelectedProductLendersNameAndIdResponse> {
        let url_ = this.baseUrl + "/api/lender/getselectedlendersname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSelectedLendersName(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSelectedLendersName(_response);
            throw _response;
        });
    }

    protected processGetSelectedLendersName(response: any): ng.IPromise<GetSelectedProductLendersNameAndIdResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSelectedProductLendersNameAndIdResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<GetSelectedProductLendersNameAndIdResponse>(null as any);
    }

    /**
     * @return OK
     */
    getSelectedDealLenderNames(dealId: number): ng.IPromise<GetSelectedProductLendersNameAndIdResponse> {
        let url_ = this.baseUrl + "/api/lender/getselecteddeallendernames?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSelectedDealLenderNames(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSelectedDealLenderNames(_response);
            throw _response;
        });
    }

    protected processGetSelectedDealLenderNames(response: any): ng.IPromise<GetSelectedProductLendersNameAndIdResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSelectedProductLendersNameAndIdResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<GetSelectedProductLendersNameAndIdResponse>(null as any);
    }

    /**
     * @return OK
     */
    getShortlistedLendersName(body: SelectedResultDTO[]): ng.IPromise<GetSelectedProductLendersNameAndIdResponse> {
        let url_ = this.baseUrl + "/api/lender/getshortlistedlendersname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetShortlistedLendersName(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetShortlistedLendersName(_response);
            throw _response;
        });
    }

    protected processGetShortlistedLendersName(response: any): ng.IPromise<GetSelectedProductLendersNameAndIdResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSelectedProductLendersNameAndIdResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<GetSelectedProductLendersNameAndIdResponse>(null as any);
    }

    /**
     * @return OK
     */
    getShortlistedDealLenderNames(dealId: number): ng.IPromise<GetSelectedProductLendersNameAndIdResponse> {
        let url_ = this.baseUrl + "/api/lender/getshortlisteddeallendernames?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetShortlistedDealLenderNames(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetShortlistedDealLenderNames(_response);
            throw _response;
        });
    }

    protected processGetShortlistedDealLenderNames(response: any): ng.IPromise<GetSelectedProductLendersNameAndIdResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSelectedProductLendersNameAndIdResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<GetSelectedProductLendersNameAndIdResponse>(null as any);
    }

    /**
     * @return OK
     */
    getLenderProductTypes(): ng.IPromise<LenderProductTypeEnum> {
        let url_ = this.baseUrl + "/api/lender/getlenderproducttypes";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetLenderProductTypes(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetLenderProductTypes(_response);
            throw _response;
        });
    }

    protected processGetLenderProductTypes(response: any): ng.IPromise<LenderProductTypeEnum> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderProductTypeEnum;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderProductTypeEnum>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeletedCustom(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/lender?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeletedCustom(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeletedCustom(_response);
            throw _response;
        });
    }

    protected processMarkAsDeletedCustom(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getShortlistedLendersInfoForSubmitToLenders(productType: LenderProductTypeEnum, isDeal: boolean, body: number[]): ng.IPromise<LenderInfo[]> {
        let url_ = this.baseUrl + "/api/lender/getshortlistedlendersinfoforsubmittolenders?";
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (isDeal === undefined || isDeal === null)
            throw new Error("The parameter 'isDeal' must be defined and cannot be null.");
        else
            url_ += "isDeal=" + encodeURIComponent("" + isDeal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetShortlistedLendersInfoForSubmitToLenders(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetShortlistedLendersInfoForSubmitToLenders(_response);
            throw _response;
        });
    }

    protected processGetShortlistedLendersInfoForSubmitToLenders(response: any): ng.IPromise<LenderInfo[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderInfo[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderInfo[]>(null as any);
    }

    /**
     * @return OK
     */
    getSelectedLenderPreferredOrgs(lenderId: number): ng.IPromise<Organisation[]> {
        let url_ = this.baseUrl + "/api/lender/getselectedlenderpreferredorgs?";
        if (lenderId === undefined || lenderId === null)
            throw new Error("The parameter 'lenderId' must be defined and cannot be null.");
        else
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSelectedLenderPreferredOrgs(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSelectedLenderPreferredOrgs(_response);
            throw _response;
        });
    }

    protected processGetSelectedLenderPreferredOrgs(response: any): ng.IPromise<Organisation[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation[]>(null as any);
    }

    /**
     * @return OK
     */
    updatePreferredOrgs(lenderId: number, body: number[]): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/lender/updatepreferredorgs?";
        if (lenderId === undefined || lenderId === null)
            throw new Error("The parameter 'lenderId' must be defined and cannot be null.");
        else
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdatePreferredOrgs(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdatePreferredOrgs(_response);
            throw _response;
        });
    }

    protected processUpdatePreferredOrgs(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getLenderPreferredPackagersText(lenderId: number): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/lender/getlenderpreferredpackagerstext?";
        if (lenderId === undefined || lenderId === null)
            throw new Error("The parameter 'lenderId' must be defined and cannot be null.");
        else
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetLenderPreferredPackagersText(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetLenderPreferredPackagersText(_response);
            throw _response;
        });
    }

    protected processGetLenderPreferredPackagersText(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getLenderPortalLinks(body: number[]): ng.IPromise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/lender/getlenderportallinks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetLenderPortalLinks(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetLenderPortalLinks(_response);
            throw _response;
        });
    }

    protected processGetLenderPortalLinks(response: any): ng.IPromise<{ [key: string]: string; }> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @return OK
     */
    getDealDeletedLenderIds(dealId: number): ng.IPromise<LenderProductPairDTO[]> {
        let url_ = this.baseUrl + "/api/lender/getdealdeletedlenderids?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetDealDeletedLenderIds(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetDealDeletedLenderIds(_response);
            throw _response;
        });
    }

    protected processGetDealDeletedLenderIds(response: any): ng.IPromise<LenderProductPairDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderProductPairDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderProductPairDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    exportLenders(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/lender/exportlenders";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportLenders(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportLenders(_response);
            throw _response;
        });
    }

    protected processExportLenders(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getUsersByLenderId(lenderId: number): ng.IPromise<ApplicationUser[]> {
        let url_ = this.baseUrl + "/api/lender/getusersbylenderid?";
        if (lenderId === undefined || lenderId === null)
            throw new Error("The parameter 'lenderId' must be defined and cannot be null.");
        else
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetUsersByLenderId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetUsersByLenderId(_response);
            throw _response;
        });
    }

    protected processGetUsersByLenderId(response: any): ng.IPromise<ApplicationUser[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser[]>(null as any);
    }

    /**
     * @return OK
     */
    saveLenderUser(isSavingLenderUser: boolean, body: ApplicationUser): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/lender/savelenderuser?";
        if (isSavingLenderUser === undefined || isSavingLenderUser === null)
            throw new Error("The parameter 'isSavingLenderUser' must be defined and cannot be null.");
        else
            url_ += "isSavingLenderUser=" + encodeURIComponent("" + isSavingLenderUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveLenderUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveLenderUser(_response);
            throw _response;
        });
    }

    protected processSaveLenderUser(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    removeLenderUser(lenderUserId: number): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/lender/removelenderuser?";
        if (lenderUserId === undefined || lenderUserId === null)
            throw new Error("The parameter 'lenderUserId' must be defined and cannot be null.");
        else
            url_ += "lenderUserId=" + encodeURIComponent("" + lenderUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemoveLenderUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemoveLenderUser(_response);
            throw _response;
        });
    }

    protected processRemoveLenderUser(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    setLenderAsAdmin(userId: number): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/lender/setlenderasadmin?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSetLenderAsAdmin(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSetLenderAsAdmin(_response);
            throw _response;
        });
    }

    protected processSetLenderAsAdmin(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<Lender[]> {
        let url_ = this.baseUrl + "/api/lender/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<Lender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Lender[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<Lender> {
        let url_ = this.baseUrl + "/api/lender/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<Lender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Lender>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/lender/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<LenderPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/lender/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<LenderPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<LenderPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/lender/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<LenderPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: Lender): ng.IPromise<Lender> {
        let url_ = this.baseUrl + "/api/lender/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<Lender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Lender>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: Lender): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/lender/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: Lender[]): ng.IPromise<Lender[]> {
        let url_ = this.baseUrl + "/api/lender/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<Lender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Lender[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: Lender[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/lender/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/lender/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/lender/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class LenderCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous42> {
        let url_ = this.baseUrl + "/odata/LenderOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous42> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous42;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous42>(null as any);
    }

    /**
     * @return OK
     */
    post(body: LenderInsert): ng.IPromise<Lender> {
        let url_ = this.baseUrl + "/api/crud/lender/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<Lender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Lender>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: LenderUpdate): ng.IPromise<Lender> {
        let url_ = this.baseUrl + "/api/crud/lender/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<Lender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Lender>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/lender/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/lender/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class LenderOrganisationClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<LenderOrganisation[]> {
        let url_ = this.baseUrl + "/api/lenderorganisation/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<LenderOrganisation[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderOrganisation[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderOrganisation[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<LenderOrganisation> {
        let url_ = this.baseUrl + "/api/lenderorganisation/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<LenderOrganisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderOrganisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderOrganisation>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/lenderorganisation/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<LenderOrganisationPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/lenderorganisation/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<LenderOrganisationPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderOrganisationPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderOrganisationPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<LenderOrganisationPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/lenderorganisation/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<LenderOrganisationPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderOrganisationPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderOrganisationPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: LenderOrganisation): ng.IPromise<LenderOrganisation> {
        let url_ = this.baseUrl + "/api/lenderorganisation/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<LenderOrganisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderOrganisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderOrganisation>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: LenderOrganisation): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/lenderorganisation/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: LenderOrganisation[]): ng.IPromise<LenderOrganisation[]> {
        let url_ = this.baseUrl + "/api/lenderorganisation/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<LenderOrganisation[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderOrganisation[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderOrganisation[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: LenderOrganisation[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/lenderorganisation/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/lenderorganisation/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/lenderorganisation/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class LenderOrganisationCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous43> {
        let url_ = this.baseUrl + "/odata/LenderOrganisationOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous43> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous43;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous43>(null as any);
    }

    /**
     * @return OK
     */
    post(body: LenderOrganisationInsert): ng.IPromise<LenderOrganisation> {
        let url_ = this.baseUrl + "/api/crud/lenderorganisation/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<LenderOrganisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderOrganisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderOrganisation>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: LenderOrganisationUpdate): ng.IPromise<LenderOrganisation> {
        let url_ = this.baseUrl + "/api/crud/lenderorganisation/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<LenderOrganisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderOrganisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderOrganisation>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/lenderorganisation/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/lenderorganisation/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class LenderResultClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    listByDevelopmentInput(developmentInputId: number): ng.IPromise<LenderResult[]> {
        let url_ = this.baseUrl + "/api/lenderresult/listbyDevelopmentInput?";
        if (developmentInputId === undefined || developmentInputId === null)
            throw new Error("The parameter 'developmentInputId' must be defined and cannot be null.");
        else
            url_ += "DevelopmentInputId=" + encodeURIComponent("" + developmentInputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListByDevelopmentInput(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListByDevelopmentInput(_response);
            throw _response;
        });
    }

    protected processListByDevelopmentInput(response: any): ng.IPromise<LenderResult[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResult[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResult[]>(null as any);
    }

    /**
     * @return OK
     */
    getByUniqueRef(uniqueRef: string, totalNumberOfEachResults: number): ng.IPromise<LenderResultSetWithInputsDTO> {
        let url_ = this.baseUrl + "/api/lenderresult/listbyuniqueref?";
        if (uniqueRef === undefined || uniqueRef === null)
            throw new Error("The parameter 'uniqueRef' must be defined and cannot be null.");
        else
            url_ += "uniqueRef=" + encodeURIComponent("" + uniqueRef) + "&";
        if (totalNumberOfEachResults === undefined || totalNumberOfEachResults === null)
            throw new Error("The parameter 'totalNumberOfEachResults' must be defined and cannot be null.");
        else
            url_ += "totalNumberOfEachResults=" + encodeURIComponent("" + totalNumberOfEachResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetByUniqueRef(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetByUniqueRef(_response);
            throw _response;
        });
    }

    protected processGetByUniqueRef(response: any): ng.IPromise<LenderResultSetWithInputsDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResultSetWithInputsDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResultSetWithInputsDTO>(null as any);
    }

    /**
     * @param debug1 (optional) 
     * @param debug2 (optional) 
     * @param newLeadFirstName (optional) 
     * @param newLeadEmail (optional) 
     * @param newLeadFullName (optional) 
     * @param newLeadRole (optional) 
     * @param orgCode (optional) 
     * @param isDevelopmentInputWithNoLogin (optional) 
     * @param criteriaChanged (optional) 
     * @return OK
     */
    productsOfferingLargestLoanAndMatching(includeSenior: boolean, includeMez: boolean, totalNumberOfEachResults: number, sendResult: boolean, message: string, from: string, telephone: string, loanLabel: string, emailJourneyStarted: boolean, body: DevelopmentInput, debug1?: boolean | undefined, debug2?: boolean | undefined, newLeadFirstName?: string | undefined, newLeadEmail?: string | undefined, newLeadFullName?: string | undefined, newLeadRole?: string | undefined, orgCode?: string | undefined, isDevelopmentInputWithNoLogin?: boolean | undefined, criteriaChanged?: boolean | undefined): ng.IPromise<LenderResultSetDTO> {
        let url_ = this.baseUrl + "/api/lenderresult/listlargestandmatchingset?";
        if (includeSenior === undefined || includeSenior === null)
            throw new Error("The parameter 'includeSenior' must be defined and cannot be null.");
        else
            url_ += "includeSenior=" + encodeURIComponent("" + includeSenior) + "&";
        if (includeMez === undefined || includeMez === null)
            throw new Error("The parameter 'includeMez' must be defined and cannot be null.");
        else
            url_ += "includeMez=" + encodeURIComponent("" + includeMez) + "&";
        if (totalNumberOfEachResults === undefined || totalNumberOfEachResults === null)
            throw new Error("The parameter 'totalNumberOfEachResults' must be defined and cannot be null.");
        else
            url_ += "totalNumberOfEachResults=" + encodeURIComponent("" + totalNumberOfEachResults) + "&";
        if (sendResult === undefined || sendResult === null)
            throw new Error("The parameter 'sendResult' must be defined and cannot be null.");
        else
            url_ += "sendResult=" + encodeURIComponent("" + sendResult) + "&";
        if (message === undefined || message === null)
            throw new Error("The parameter 'message' must be defined and cannot be null.");
        else
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (telephone === undefined || telephone === null)
            throw new Error("The parameter 'telephone' must be defined and cannot be null.");
        else
            url_ += "telephone=" + encodeURIComponent("" + telephone) + "&";
        if (loanLabel === undefined || loanLabel === null)
            throw new Error("The parameter 'loanLabel' must be defined and cannot be null.");
        else
            url_ += "loanLabel=" + encodeURIComponent("" + loanLabel) + "&";
        if (emailJourneyStarted === undefined || emailJourneyStarted === null)
            throw new Error("The parameter 'emailJourneyStarted' must be defined and cannot be null.");
        else
            url_ += "emailJourneyStarted=" + encodeURIComponent("" + emailJourneyStarted) + "&";
        if (debug1 === null)
            throw new Error("The parameter 'debug1' cannot be null.");
        else if (debug1 !== undefined)
            url_ += "debug1=" + encodeURIComponent("" + debug1) + "&";
        if (debug2 === null)
            throw new Error("The parameter 'debug2' cannot be null.");
        else if (debug2 !== undefined)
            url_ += "debug2=" + encodeURIComponent("" + debug2) + "&";
        if (newLeadFirstName === null)
            throw new Error("The parameter 'newLeadFirstName' cannot be null.");
        else if (newLeadFirstName !== undefined)
            url_ += "newLeadFirstName=" + encodeURIComponent("" + newLeadFirstName) + "&";
        if (newLeadEmail === null)
            throw new Error("The parameter 'newLeadEmail' cannot be null.");
        else if (newLeadEmail !== undefined)
            url_ += "newLeadEmail=" + encodeURIComponent("" + newLeadEmail) + "&";
        if (newLeadFullName === null)
            throw new Error("The parameter 'newLeadFullName' cannot be null.");
        else if (newLeadFullName !== undefined)
            url_ += "newLeadFullName=" + encodeURIComponent("" + newLeadFullName) + "&";
        if (newLeadRole === null)
            throw new Error("The parameter 'newLeadRole' cannot be null.");
        else if (newLeadRole !== undefined)
            url_ += "newLeadRole=" + encodeURIComponent("" + newLeadRole) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (isDevelopmentInputWithNoLogin === null)
            throw new Error("The parameter 'isDevelopmentInputWithNoLogin' cannot be null.");
        else if (isDevelopmentInputWithNoLogin !== undefined)
            url_ += "isDevelopmentInputWithNoLogin=" + encodeURIComponent("" + isDevelopmentInputWithNoLogin) + "&";
        if (criteriaChanged === null)
            throw new Error("The parameter 'criteriaChanged' cannot be null.");
        else if (criteriaChanged !== undefined)
            url_ += "criteriaChanged=" + encodeURIComponent("" + criteriaChanged) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processProductsOfferingLargestLoanAndMatching(_response);
        }, (_response) => {
            if (_response.status)
                return this.processProductsOfferingLargestLoanAndMatching(_response);
            throw _response;
        });
    }

    protected processProductsOfferingLargestLoanAndMatching(response: any): ng.IPromise<LenderResultSetDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResultSetDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResultSetDTO>(null as any);
    }

    /**
     * @return OK
     */
    captureNewUserEmail(captureFirstName: string, captureSurname: string, captureEmail: string, applicantDefinedRole: ApplicantRoleEnum, body: DevelopmentInputDTO): ng.IPromise<LenderResultSetDTO> {
        let url_ = this.baseUrl + "/api/lenderresult/captureNewUserEmail?";
        if (captureFirstName === undefined || captureFirstName === null)
            throw new Error("The parameter 'captureFirstName' must be defined and cannot be null.");
        else
            url_ += "captureFirstName=" + encodeURIComponent("" + captureFirstName) + "&";
        if (captureSurname === undefined || captureSurname === null)
            throw new Error("The parameter 'captureSurname' must be defined and cannot be null.");
        else
            url_ += "captureSurname=" + encodeURIComponent("" + captureSurname) + "&";
        if (captureEmail === undefined || captureEmail === null)
            throw new Error("The parameter 'captureEmail' must be defined and cannot be null.");
        else
            url_ += "captureEmail=" + encodeURIComponent("" + captureEmail) + "&";
        if (applicantDefinedRole === undefined || applicantDefinedRole === null)
            throw new Error("The parameter 'applicantDefinedRole' must be defined and cannot be null.");
        else
            url_ += "applicantDefinedRole=" + encodeURIComponent("" + applicantDefinedRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCaptureNewUserEmail(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCaptureNewUserEmail(_response);
            throw _response;
        });
    }

    protected processCaptureNewUserEmail(response: any): ng.IPromise<LenderResultSetDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResultSetDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResultSetDTO>(null as any);
    }

    /**
     * @return OK
     */
    startNewUserEmailJourney(uniqueRef: string, matchingResults: number, largestResults: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/lenderresult/startNewUserEmailJourney?";
        if (uniqueRef === undefined || uniqueRef === null)
            throw new Error("The parameter 'uniqueRef' must be defined and cannot be null.");
        else
            url_ += "uniqueRef=" + encodeURIComponent("" + uniqueRef) + "&";
        if (matchingResults === undefined || matchingResults === null)
            throw new Error("The parameter 'matchingResults' must be defined and cannot be null.");
        else
            url_ += "matchingResults=" + encodeURIComponent("" + matchingResults) + "&";
        if (largestResults === undefined || largestResults === null)
            throw new Error("The parameter 'largestResults' must be defined and cannot be null.");
        else
            url_ += "largestResults=" + encodeURIComponent("" + largestResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processStartNewUserEmailJourney(_response);
        }, (_response) => {
            if (_response.status)
                return this.processStartNewUserEmailJourney(_response);
            throw _response;
        });
    }

    protected processStartNewUserEmailJourney(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    requestAssistance(reason: string, searchid: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/lenderresult/requestassistance?";
        if (reason === undefined || reason === null)
            throw new Error("The parameter 'reason' must be defined and cannot be null.");
        else
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        if (searchid === undefined || searchid === null)
            throw new Error("The parameter 'searchid' must be defined and cannot be null.");
        else
            url_ += "searchid=" + encodeURIComponent("" + searchid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRequestAssistance(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRequestAssistance(_response);
            throw _response;
        });
    }

    protected processRequestAssistance(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    contactLender(lenderEmail: string, emailSubject: string, note: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/lenderresult/contactLender?";
        if (lenderEmail === undefined || lenderEmail === null)
            throw new Error("The parameter 'lenderEmail' must be defined and cannot be null.");
        else
            url_ += "lenderEmail=" + encodeURIComponent("" + lenderEmail) + "&";
        if (emailSubject === undefined || emailSubject === null)
            throw new Error("The parameter 'emailSubject' must be defined and cannot be null.");
        else
            url_ += "emailSubject=" + encodeURIComponent("" + emailSubject) + "&";
        if (note === undefined || note === null)
            throw new Error("The parameter 'note' must be defined and cannot be null.");
        else
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processContactLender(_response);
        }, (_response) => {
            if (_response.status)
                return this.processContactLender(_response);
            throw _response;
        });
    }

    protected processContactLender(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sortProductsByLTGDV(body: LenderResultSummaryDTO[]): ng.IPromise<LenderResultSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/lenderresult/sortProductsByLTGDV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSortProductsByLTGDV(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSortProductsByLTGDV(_response);
            throw _response;
        });
    }

    protected processSortProductsByLTGDV(response: any): ng.IPromise<LenderResultSummaryDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResultSummaryDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResultSummaryDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<LenderResult[]> {
        let url_ = this.baseUrl + "/api/lenderresult/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<LenderResult[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResult[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResult[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<LenderResult> {
        let url_ = this.baseUrl + "/api/lenderresult/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<LenderResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResult>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/lenderresult/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<LenderResultPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/lenderresult/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<LenderResultPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResultPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResultPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<LenderResultPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/lenderresult/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<LenderResultPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResultPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResultPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: LenderResult): ng.IPromise<LenderResult> {
        let url_ = this.baseUrl + "/api/lenderresult/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<LenderResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResult>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: LenderResult): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/lenderresult/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: LenderResult[]): ng.IPromise<LenderResult[]> {
        let url_ = this.baseUrl + "/api/lenderresult/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<LenderResult[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResult[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResult[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: LenderResult[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/lenderresult/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/lenderresult/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/lenderresult/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class LenderResultCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous44> {
        let url_ = this.baseUrl + "/odata/LenderResultOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous44> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous44;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous44>(null as any);
    }

    /**
     * @return OK
     */
    post(body: LenderResultInsert): ng.IPromise<LenderResult> {
        let url_ = this.baseUrl + "/api/crud/lenderresult/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<LenderResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResult>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: LenderResultUpdate): ng.IPromise<LenderResult> {
        let url_ = this.baseUrl + "/api/crud/lenderresult/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<LenderResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderResult>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/lenderresult/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/lenderresult/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class LicenseAppPackageClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<LicenseAppPackage[]> {
        let url_ = this.baseUrl + "/api/licenseapppackage/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<LicenseAppPackage[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseAppPackage[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseAppPackage[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<LicenseAppPackage> {
        let url_ = this.baseUrl + "/api/licenseapppackage/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<LicenseAppPackage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseAppPackage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseAppPackage>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/licenseapppackage/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<LicenseAppPackagePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/licenseapppackage/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<LicenseAppPackagePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseAppPackagePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseAppPackagePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<LicenseAppPackagePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/licenseapppackage/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<LicenseAppPackagePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseAppPackagePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseAppPackagePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: LicenseAppPackage): ng.IPromise<LicenseAppPackage> {
        let url_ = this.baseUrl + "/api/licenseapppackage/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<LicenseAppPackage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseAppPackage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseAppPackage>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: LicenseAppPackage): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/licenseapppackage/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: LicenseAppPackage[]): ng.IPromise<LicenseAppPackage[]> {
        let url_ = this.baseUrl + "/api/licenseapppackage/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<LicenseAppPackage[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseAppPackage[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseAppPackage[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: LicenseAppPackage[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/licenseapppackage/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/licenseapppackage/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/licenseapppackage/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class LicenseAppPackageCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous45> {
        let url_ = this.baseUrl + "/odata/LicenseAppPackageOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous45> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous45;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous45>(null as any);
    }

    /**
     * @return OK
     */
    post(body: LicenseAppPackageInsert): ng.IPromise<LicenseAppPackage> {
        let url_ = this.baseUrl + "/api/crud/licenseapppackage/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<LicenseAppPackage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseAppPackage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseAppPackage>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: LicenseAppPackageUpdate): ng.IPromise<LicenseAppPackage> {
        let url_ = this.baseUrl + "/api/crud/licenseapppackage/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<LicenseAppPackage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseAppPackage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseAppPackage>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/licenseapppackage/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/licenseapppackage/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class LicenseMasterClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<LicenseMaster[]> {
        let url_ = this.baseUrl + "/api/licensemaster/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<LicenseMaster[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseMaster[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseMaster[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<LicenseMaster> {
        let url_ = this.baseUrl + "/api/licensemaster/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<LicenseMaster> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseMaster;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseMaster>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/licensemaster/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<LicenseMasterPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/licensemaster/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<LicenseMasterPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseMasterPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseMasterPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<LicenseMasterPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/licensemaster/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<LicenseMasterPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseMasterPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseMasterPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: LicenseMaster): ng.IPromise<LicenseMaster> {
        let url_ = this.baseUrl + "/api/licensemaster/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<LicenseMaster> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseMaster;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseMaster>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: LicenseMaster): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/licensemaster/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: LicenseMaster[]): ng.IPromise<LicenseMaster[]> {
        let url_ = this.baseUrl + "/api/licensemaster/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<LicenseMaster[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseMaster[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseMaster[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: LicenseMaster[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/licensemaster/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/licensemaster/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/licensemaster/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class LicenseMasterCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous46> {
        let url_ = this.baseUrl + "/odata/LicenseMasterOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous46> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous46;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous46>(null as any);
    }

    /**
     * @return OK
     */
    post(body: LicenseMasterInsert): ng.IPromise<LicenseMaster> {
        let url_ = this.baseUrl + "/api/crud/licensemaster/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<LicenseMaster> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseMaster;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseMaster>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: LicenseMasterUpdate): ng.IPromise<LicenseMaster> {
        let url_ = this.baseUrl + "/api/crud/licensemaster/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<LicenseMaster> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseMaster;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseMaster>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/licensemaster/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/licensemaster/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class MagicLinkClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    sendLoginEmail(username: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/MagicLink/SendLoginEmail?";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined and cannot be null.");
        else
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendLoginEmail(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendLoginEmail(_response);
            throw _response;
        });
    }

    protected processSendLoginEmail(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthErrorDetails;
            return throwException(this.q, "Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }
}

export class MetadataClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getServiceDocument(): ng.IPromise<ODataServiceDocument> {
        let url_ = this.baseUrl + "/odata";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetServiceDocument(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetServiceDocument(_response);
            throw _response;
        });
    }

    protected processGetServiceDocument(response: any): ng.IPromise<ODataServiceDocument> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ODataServiceDocument;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ODataServiceDocument>(null as any);
    }
}

export class OrganisationClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    findOrganisationIdByUniqueRef(uniqueRef: string): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/organisation/findOrganisationIdByUniqueRef?";
        if (uniqueRef === undefined || uniqueRef === null)
            throw new Error("The parameter 'uniqueRef' must be defined and cannot be null.");
        else
            url_ += "uniqueRef=" + encodeURIComponent("" + uniqueRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFindOrganisationIdByUniqueRef(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFindOrganisationIdByUniqueRef(_response);
            throw _response;
        });
    }

    protected processFindOrganisationIdByUniqueRef(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    findOrganisationByUniqueRef(uniqueRef: string): ng.IPromise<Organisation> {
        let url_ = this.baseUrl + "/api/organisation/findOrganisationByUniqueRef?";
        if (uniqueRef === undefined || uniqueRef === null)
            throw new Error("The parameter 'uniqueRef' must be defined and cannot be null.");
        else
            url_ += "uniqueRef=" + encodeURIComponent("" + uniqueRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFindOrganisationByUniqueRef(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFindOrganisationByUniqueRef(_response);
            throw _response;
        });
    }

    protected processFindOrganisationByUniqueRef(response: any): ng.IPromise<Organisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation>(null as any);
    }

    /**
     * @return OK
     */
    inviteBrokers(orgRef: string, body: InvitedBrokerDTO[]): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/inviteBrokers?";
        if (orgRef === undefined || orgRef === null)
            throw new Error("The parameter 'orgRef' must be defined and cannot be null.");
        else
            url_ += "orgRef=" + encodeURIComponent("" + orgRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processInviteBrokers(_response);
        }, (_response) => {
            if (_response.status)
                return this.processInviteBrokers(_response);
            throw _response;
        });
    }

    protected processInviteBrokers(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    showLenderNamesAndLogos(searchId: number, isDeal: boolean): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/showLenderNamesAndLogos?";
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined and cannot be null.");
        else
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (isDeal === undefined || isDeal === null)
            throw new Error("The parameter 'isDeal' must be defined and cannot be null.");
        else
            url_ += "isDeal=" + encodeURIComponent("" + isDeal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processShowLenderNamesAndLogos(_response);
        }, (_response) => {
            if (_response.status)
                return this.processShowLenderNamesAndLogos(_response);
            throw _response;
        });
    }

    protected processShowLenderNamesAndLogos(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    registerOrganisation(body: RegisterOrganisationDTO): ng.IPromise<RegisterOrganisationDTO> {
        let url_ = this.baseUrl + "/api/organisation/registerorganisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRegisterOrganisation(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRegisterOrganisation(_response);
            throw _response;
        });
    }

    protected processRegisterOrganisation(response: any): ng.IPromise<RegisterOrganisationDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegisterOrganisationDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<RegisterOrganisationDTO>(null as any);
    }

    /**
     * @return OK
     */
    registerBroker(uniqueRef: string, body: ApplicationUser): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/organisation/registerBroker?";
        if (uniqueRef === undefined || uniqueRef === null)
            throw new Error("The parameter 'uniqueRef' must be defined and cannot be null.");
        else
            url_ += "uniqueRef=" + encodeURIComponent("" + uniqueRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRegisterBroker(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRegisterBroker(_response);
            throw _response;
        });
    }

    protected processRegisterBroker(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    registerBorrowers(orgRef: string, body: Invite): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/organisation/registerBorrower?";
        if (orgRef === undefined || orgRef === null)
            throw new Error("The parameter 'orgRef' must be defined and cannot be null.");
        else
            url_ += "orgRef=" + encodeURIComponent("" + orgRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRegisterBorrowers(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRegisterBorrowers(_response);
            throw _response;
        });
    }

    protected processRegisterBorrowers(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param isConvertedToConnectMember (optional) 
     * @return OK
     */
    saveOrganisation(body: Organisation, isConvertedToConnectMember?: boolean | undefined): ng.IPromise<Organisation> {
        let url_ = this.baseUrl + "/api/organisation/saveorganisation?";
        if (isConvertedToConnectMember === null)
            throw new Error("The parameter 'isConvertedToConnectMember' cannot be null.");
        else if (isConvertedToConnectMember !== undefined)
            url_ += "isConvertedToConnectMember=" + encodeURIComponent("" + isConvertedToConnectMember) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveOrganisation(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveOrganisation(_response);
            throw _response;
        });
    }

    protected processSaveOrganisation(response: any): ng.IPromise<Organisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation>(null as any);
    }

    /**
     * @return OK
     */
    getOrganisation(): ng.IPromise<Organisation> {
        let url_ = this.baseUrl + "/api/organisation/getorganisation";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOrganisation(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOrganisation(_response);
            throw _response;
        });
    }

    protected processGetOrganisation(response: any): ng.IPromise<Organisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation>(null as any);
    }

    /**
     * @return OK
     */
    findOrganisationByOrgCode(orgCode: string): ng.IPromise<Organisation> {
        let url_ = this.baseUrl + "/api/organisation/findorganisationbyorgcode?";
        if (orgCode === undefined || orgCode === null)
            throw new Error("The parameter 'orgCode' must be defined and cannot be null.");
        else
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFindOrganisationByOrgCode(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFindOrganisationByOrgCode(_response);
            throw _response;
        });
    }

    protected processFindOrganisationByOrgCode(response: any): ng.IPromise<Organisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation>(null as any);
    }

    /**
     * @return OK
     */
    findOrgApplicationNameByUsername(userName: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/organisation/findorgapplicationnamebyusername?";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFindOrgApplicationNameByUsername(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFindOrgApplicationNameByUsername(_response);
            throw _response;
        });
    }

    protected processFindOrgApplicationNameByUsername(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    deleteOrganisation(orgId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/deleteorganisation?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined and cannot be null.");
        else
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDeleteOrganisation(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDeleteOrganisation(_response);
            throw _response;
        });
    }

    protected processDeleteOrganisation(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    brokerSignUpJourneyG5Email(): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/brokersignupjourneyg5email";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processBrokerSignUpJourneyG5Email(_response);
        }, (_response) => {
            if (_response.status)
                return this.processBrokerSignUpJourneyG5Email(_response);
            throw _response;
        });
    }

    protected processBrokerSignUpJourneyG5Email(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    brokerSignUpJourneyG0Email(brokerEmail: string, brokerFullName: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/brokersignupjourneyg0email?";
        if (brokerEmail === undefined || brokerEmail === null)
            throw new Error("The parameter 'brokerEmail' must be defined and cannot be null.");
        else
            url_ += "brokerEmail=" + encodeURIComponent("" + brokerEmail) + "&";
        if (brokerFullName === undefined || brokerFullName === null)
            throw new Error("The parameter 'brokerFullName' must be defined and cannot be null.");
        else
            url_ += "brokerFullName=" + encodeURIComponent("" + brokerFullName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processBrokerSignUpJourneyG0Email(_response);
        }, (_response) => {
            if (_response.status)
                return this.processBrokerSignUpJourneyG0Email(_response);
            throw _response;
        });
    }

    protected processBrokerSignUpJourneyG0Email(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getOrganisationAdmin(orgId: number): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/organisation/getorganisationadmin?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined and cannot be null.");
        else
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOrganisationAdmin(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOrganisationAdmin(_response);
            throw _response;
        });
    }

    protected processGetOrganisationAdmin(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @param quantity (optional) 
     * @param isFreeTrialForOrg (optional) 
     * @param isAddonSelected (optional) 
     * @return OK
     */
    assignTrialLicenseToOrg(licenseEndDate: string, orgAdminUserId: number, body: AppPackagePricing[], quantity?: number | undefined, isFreeTrialForOrg?: boolean | undefined, isAddonSelected?: boolean | undefined): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/assigntriallicensetoorg?";
        if (licenseEndDate === undefined || licenseEndDate === null)
            throw new Error("The parameter 'licenseEndDate' must be defined and cannot be null.");
        else
            url_ += "licenseEndDate=" + encodeURIComponent("" + licenseEndDate) + "&";
        if (orgAdminUserId === undefined || orgAdminUserId === null)
            throw new Error("The parameter 'orgAdminUserId' must be defined and cannot be null.");
        else
            url_ += "orgAdminUserId=" + encodeURIComponent("" + orgAdminUserId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (isFreeTrialForOrg === null)
            throw new Error("The parameter 'isFreeTrialForOrg' cannot be null.");
        else if (isFreeTrialForOrg !== undefined)
            url_ += "isFreeTrialForOrg=" + encodeURIComponent("" + isFreeTrialForOrg) + "&";
        if (isAddonSelected === null)
            throw new Error("The parameter 'isAddonSelected' cannot be null.");
        else if (isAddonSelected !== undefined)
            url_ += "isAddonSelected=" + encodeURIComponent("" + isAddonSelected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAssignTrialLicenseToOrg(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAssignTrialLicenseToOrg(_response);
            throw _response;
        });
    }

    protected processAssignTrialLicenseToOrg(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getBrickflowBrokerOrg(): ng.IPromise<Organisation> {
        let url_ = this.baseUrl + "/api/organisation/getbrickflowbrokerorg";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetBrickflowBrokerOrg(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetBrickflowBrokerOrg(_response);
            throw _response;
        });
    }

    protected processGetBrickflowBrokerOrg(response: any): ng.IPromise<Organisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation>(null as any);
    }

    /**
     * @return OK
     */
    getUniqueLinks(organisationId: number): ng.IPromise<OrganisationLink[]> {
        let url_ = this.baseUrl + "/api/organisation/getuniquelinks?";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined and cannot be null.");
        else
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetUniqueLinks(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetUniqueLinks(_response);
            throw _response;
        });
    }

    protected processGetUniqueLinks(response: any): ng.IPromise<OrganisationLink[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationLink[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationLink[]>(null as any);
    }

    /**
     * @return OK
     */
    getOrgByUrlIfOrgHasEnterpriseSearchPermission(orgCode: string | null, productFamily: ProductFamilyEnum, orgLinkId: string | null): ng.IPromise<Organisation> {
        let url_ = this.baseUrl + "/api/organisation/getorgbyurliforghasenterprisesearchpermission?";
        if (orgCode === undefined)
            throw new Error("The parameter 'orgCode' must be defined.");
        else if(orgCode !== null)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (productFamily === undefined || productFamily === null)
            throw new Error("The parameter 'productFamily' must be defined and cannot be null.");
        else
            url_ += "productFamily=" + encodeURIComponent("" + productFamily) + "&";
        if (orgLinkId === undefined)
            throw new Error("The parameter 'orgLinkId' must be defined.");
        else if(orgLinkId !== null)
            url_ += "orgLinkId=" + encodeURIComponent("" + orgLinkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOrgByUrlIfOrgHasEnterpriseSearchPermission(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOrgByUrlIfOrgHasEnterpriseSearchPermission(_response);
            throw _response;
        });
    }

    protected processGetOrgByUrlIfOrgHasEnterpriseSearchPermission(response: any): ng.IPromise<Organisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation>(null as any);
    }

    /**
     * @return OK
     */
    findOrganisationAdminByOrgCode(orgCode: string): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/organisation/findorganisationadminbyorgcode?";
        if (orgCode === undefined || orgCode === null)
            throw new Error("The parameter 'orgCode' must be defined and cannot be null.");
        else
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFindOrganisationAdminByOrgCode(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFindOrganisationAdminByOrgCode(_response);
            throw _response;
        });
    }

    protected processFindOrganisationAdminByOrgCode(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    findOrganisationOrgcodeByUrl(widgetUrl: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/organisation/findorganisationorgcodebyurl?";
        if (widgetUrl === undefined || widgetUrl === null)
            throw new Error("The parameter 'widgetUrl' must be defined and cannot be null.");
        else
            url_ += "widgetUrl=" + encodeURIComponent("" + widgetUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFindOrganisationOrgcodeByUrl(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFindOrganisationOrgcodeByUrl(_response);
            throw _response;
        });
    }

    protected processFindOrganisationOrgcodeByUrl(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    isLeadGenLicenseActive(organisationId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/isleadgenlicenseactive?";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined and cannot be null.");
        else
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsLeadGenLicenseActive(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsLeadGenLicenseActive(_response);
            throw _response;
        });
    }

    protected processIsLeadGenLicenseActive(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sendBorrowerMessageToOrganisationAdmin(organisationId: number, message: string, borrowerFirstName: string, borrowerLastName: string, borrowerEmail: string, productType: ProductTypeEnum, screenType: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/sendborrowermessagetoorganisationadmin?";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined and cannot be null.");
        else
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (message === undefined || message === null)
            throw new Error("The parameter 'message' must be defined and cannot be null.");
        else
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (borrowerFirstName === undefined || borrowerFirstName === null)
            throw new Error("The parameter 'borrowerFirstName' must be defined and cannot be null.");
        else
            url_ += "borrowerFirstName=" + encodeURIComponent("" + borrowerFirstName) + "&";
        if (borrowerLastName === undefined || borrowerLastName === null)
            throw new Error("The parameter 'borrowerLastName' must be defined and cannot be null.");
        else
            url_ += "borrowerLastName=" + encodeURIComponent("" + borrowerLastName) + "&";
        if (borrowerEmail === undefined || borrowerEmail === null)
            throw new Error("The parameter 'borrowerEmail' must be defined and cannot be null.");
        else
            url_ += "borrowerEmail=" + encodeURIComponent("" + borrowerEmail) + "&";
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (screenType === undefined || screenType === null)
            throw new Error("The parameter 'screenType' must be defined and cannot be null.");
        else
            url_ += "screenType=" + encodeURIComponent("" + screenType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendBorrowerMessageToOrganisationAdmin(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendBorrowerMessageToOrganisationAdmin(_response);
            throw _response;
        });
    }

    protected processSendBorrowerMessageToOrganisationAdmin(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sendTestEmail(recipientEmailAddress: string, emailSubject: string, emailMessage: string, orgId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/sendtestemail?";
        if (recipientEmailAddress === undefined || recipientEmailAddress === null)
            throw new Error("The parameter 'recipientEmailAddress' must be defined and cannot be null.");
        else
            url_ += "recipientEmailAddress=" + encodeURIComponent("" + recipientEmailAddress) + "&";
        if (emailSubject === undefined || emailSubject === null)
            throw new Error("The parameter 'emailSubject' must be defined and cannot be null.");
        else
            url_ += "emailSubject=" + encodeURIComponent("" + emailSubject) + "&";
        if (emailMessage === undefined || emailMessage === null)
            throw new Error("The parameter 'emailMessage' must be defined and cannot be null.");
        else
            url_ += "emailMessage=" + encodeURIComponent("" + emailMessage) + "&";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined and cannot be null.");
        else
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendTestEmail(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendTestEmail(_response);
            throw _response;
        });
    }

    protected processSendTestEmail(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getOrganisationProductAccess(): ng.IPromise<OrganisationProductAccessMessageResponse> {
        let url_ = this.baseUrl + "/api/organisation/getorganisationproductaccess";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOrganisationProductAccess(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOrganisationProductAccess(_response);
            throw _response;
        });
    }

    protected processGetOrganisationProductAccess(response: any): ng.IPromise<OrganisationProductAccessMessageResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationProductAccessMessageResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationProductAccessMessageResponse>(null as any);
    }

    /**
     * @return OK
     */
    isOrganisationCodeValid(orgId: number, orgCode: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/isorganisationcodevalid?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined and cannot be null.");
        else
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (orgCode === undefined || orgCode === null)
            throw new Error("The parameter 'orgCode' must be defined and cannot be null.");
        else
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsOrganisationCodeValid(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsOrganisationCodeValid(_response);
            throw _response;
        });
    }

    protected processIsOrganisationCodeValid(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getOrganisationAndBrokerByUniqueRef(uniqueRef: string): ng.IPromise<OrganisationAndBrokerDetailsMessage> {
        let url_ = this.baseUrl + "/api/organisation/getorganisationandbrokerbyuniqueRef?";
        if (uniqueRef === undefined || uniqueRef === null)
            throw new Error("The parameter 'uniqueRef' must be defined and cannot be null.");
        else
            url_ += "uniqueRef=" + encodeURIComponent("" + uniqueRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOrganisationAndBrokerByUniqueRef(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOrganisationAndBrokerByUniqueRef(_response);
            throw _response;
        });
    }

    protected processGetOrganisationAndBrokerByUniqueRef(response: any): ng.IPromise<OrganisationAndBrokerDetailsMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationAndBrokerDetailsMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationAndBrokerDetailsMessage>(null as any);
    }

    /**
     * @return OK
     */
    getOrganisationAndBrokerByDealId(dealId: number): ng.IPromise<OrganisationAndBrokerDetailsMessage> {
        let url_ = this.baseUrl + "/api/organisation/getorganisationandbrokerbydealid?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOrganisationAndBrokerByDealId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOrganisationAndBrokerByDealId(_response);
            throw _response;
        });
    }

    protected processGetOrganisationAndBrokerByDealId(response: any): ng.IPromise<OrganisationAndBrokerDetailsMessage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationAndBrokerDetailsMessage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationAndBrokerDetailsMessage>(null as any);
    }

    /**
     * @return OK
     */
    sendBorrowerMessageToSearchBroker(dealId: number, message: string, borrowerFirstName: string, borrowerLastName: string, borrowerEmail: string, productType: ProductTypeEnum, screenType: string, uniqueRef: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/sendborrowermessagetosearchbroker?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (message === undefined || message === null)
            throw new Error("The parameter 'message' must be defined and cannot be null.");
        else
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (borrowerFirstName === undefined || borrowerFirstName === null)
            throw new Error("The parameter 'borrowerFirstName' must be defined and cannot be null.");
        else
            url_ += "borrowerFirstName=" + encodeURIComponent("" + borrowerFirstName) + "&";
        if (borrowerLastName === undefined || borrowerLastName === null)
            throw new Error("The parameter 'borrowerLastName' must be defined and cannot be null.");
        else
            url_ += "borrowerLastName=" + encodeURIComponent("" + borrowerLastName) + "&";
        if (borrowerEmail === undefined || borrowerEmail === null)
            throw new Error("The parameter 'borrowerEmail' must be defined and cannot be null.");
        else
            url_ += "borrowerEmail=" + encodeURIComponent("" + borrowerEmail) + "&";
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (screenType === undefined || screenType === null)
            throw new Error("The parameter 'screenType' must be defined and cannot be null.");
        else
            url_ += "screenType=" + encodeURIComponent("" + screenType) + "&";
        if (uniqueRef === undefined || uniqueRef === null)
            throw new Error("The parameter 'uniqueRef' must be defined and cannot be null.");
        else
            url_ += "uniqueRef=" + encodeURIComponent("" + uniqueRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendBorrowerMessageToSearchBroker(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendBorrowerMessageToSearchBroker(_response);
            throw _response;
        });
    }

    protected processSendBorrowerMessageToSearchBroker(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    validateKey(accessToken: string, pipelineStage: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/organisation/validatekey?";
        if (accessToken === undefined || accessToken === null)
            throw new Error("The parameter 'accessToken' must be defined and cannot be null.");
        else
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (pipelineStage === undefined || pipelineStage === null)
            throw new Error("The parameter 'pipelineStage' must be defined and cannot be null.");
        else
            url_ += "pipelineStage=" + encodeURIComponent("" + pipelineStage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processValidateKey(_response);
        }, (_response) => {
            if (_response.status)
                return this.processValidateKey(_response);
            throw _response;
        });
    }

    protected processValidateKey(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getMissingProperties(accessToken: string, pipelineStage: string): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/organisation/getmissingproperties?";
        if (accessToken === undefined || accessToken === null)
            throw new Error("The parameter 'accessToken' must be defined and cannot be null.");
        else
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (pipelineStage === undefined || pipelineStage === null)
            throw new Error("The parameter 'pipelineStage' must be defined and cannot be null.");
        else
            url_ += "pipelineStage=" + encodeURIComponent("" + pipelineStage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMissingProperties(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMissingProperties(_response);
            throw _response;
        });
    }

    protected processGetMissingProperties(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllOrganisationMembers(orgId: number): ng.IPromise<ApplicationUser[]> {
        let url_ = this.baseUrl + "/api/organisation/getallorganisationmembers?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined and cannot be null.");
        else
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAllOrganisationMembers(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAllOrganisationMembers(_response);
            throw _response;
        });
    }

    protected processGetAllOrganisationMembers(response: any): ng.IPromise<ApplicationUser[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser[]>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<Organisation[]> {
        let url_ = this.baseUrl + "/api/organisation/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<Organisation[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<Organisation> {
        let url_ = this.baseUrl + "/api/organisation/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<Organisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/organisation/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<OrganisationPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/organisation/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<OrganisationPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<OrganisationPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/organisation/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<OrganisationPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: Organisation): ng.IPromise<Organisation> {
        let url_ = this.baseUrl + "/api/organisation/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<Organisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: Organisation): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/organisation/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: Organisation[]): ng.IPromise<Organisation[]> {
        let url_ = this.baseUrl + "/api/organisation/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<Organisation[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: Organisation[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/organisation/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisation/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class OrganisationCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous47> {
        let url_ = this.baseUrl + "/odata/OrganisationOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous47> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous47;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous47>(null as any);
    }

    /**
     * @return OK
     */
    post(body: OrganisationInsert): ng.IPromise<Organisation> {
        let url_ = this.baseUrl + "/api/crud/organisation/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<Organisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: OrganisationUpdate): ng.IPromise<Organisation> {
        let url_ = this.baseUrl + "/api/crud/organisation/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<Organisation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Organisation>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/organisation/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/organisation/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class OrganisationLinkClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    addUpdateCustom(body: OrganisationLink): ng.IPromise<OrganisationLink> {
        let url_ = this.baseUrl + "/api/organisationlink/addupdatecustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateCustom(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateCustom(_response);
            throw _response;
        });
    }

    protected processAddUpdateCustom(response: any): ng.IPromise<OrganisationLink> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationLink;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationLink>(null as any);
    }

    /**
     * @return OK
     */
    getOrganisationLinkAndOrganisation(organisationLinkId: string, orgCode: string): ng.IPromise<OrganisationLink> {
        let url_ = this.baseUrl + "/api/organisationlink/getorganisationlinkandorganisation?";
        if (organisationLinkId === undefined || organisationLinkId === null)
            throw new Error("The parameter 'organisationLinkId' must be defined and cannot be null.");
        else
            url_ += "organisationLinkId=" + encodeURIComponent("" + organisationLinkId) + "&";
        if (orgCode === undefined || orgCode === null)
            throw new Error("The parameter 'orgCode' must be defined and cannot be null.");
        else
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOrganisationLinkAndOrganisation(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOrganisationLinkAndOrganisation(_response);
            throw _response;
        });
    }

    protected processGetOrganisationLinkAndOrganisation(response: any): ng.IPromise<OrganisationLink> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationLink;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationLink>(null as any);
    }

    /**
     * @return OK
     */
    exportUniqueLinkReport(organisationLinkId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/organisationlink/exportuniquelinkreport?";
        if (organisationLinkId === undefined || organisationLinkId === null)
            throw new Error("The parameter 'organisationLinkId' must be defined and cannot be null.");
        else
            url_ += "organisationLinkId=" + encodeURIComponent("" + organisationLinkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportUniqueLinkReport(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportUniqueLinkReport(_response);
            throw _response;
        });
    }

    protected processExportUniqueLinkReport(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getOrganisationLinkLogoByLinkIdAndLogPageLoadEvent(organisationLinkId: number, eventType: string, dealId: number, productType: ProductTypeEnum, userEmail: string, userClientId: number): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/organisationlink/getorganisationlinklogobylinkidandLogpageloadevent?";
        if (organisationLinkId === undefined || organisationLinkId === null)
            throw new Error("The parameter 'organisationLinkId' must be defined and cannot be null.");
        else
            url_ += "organisationLinkId=" + encodeURIComponent("" + organisationLinkId) + "&";
        if (eventType === undefined || eventType === null)
            throw new Error("The parameter 'eventType' must be defined and cannot be null.");
        else
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (userEmail === undefined || userEmail === null)
            throw new Error("The parameter 'userEmail' must be defined and cannot be null.");
        else
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        if (userClientId === undefined || userClientId === null)
            throw new Error("The parameter 'userClientId' must be defined and cannot be null.");
        else
            url_ += "userClientId=" + encodeURIComponent("" + userClientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOrganisationLinkLogoByLinkIdAndLogPageLoadEvent(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOrganisationLinkLogoByLinkIdAndLogPageLoadEvent(_response);
            throw _response;
        });
    }

    protected processGetOrganisationLinkLogoByLinkIdAndLogPageLoadEvent(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<OrganisationLink[]> {
        let url_ = this.baseUrl + "/api/organisationlink/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<OrganisationLink[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationLink[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationLink[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<OrganisationLink> {
        let url_ = this.baseUrl + "/api/organisationlink/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<OrganisationLink> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationLink;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationLink>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/organisationlink/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<OrganisationLinkPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/organisationlink/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<OrganisationLinkPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationLinkPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationLinkPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<OrganisationLinkPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/organisationlink/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<OrganisationLinkPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationLinkPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationLinkPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: OrganisationLink): ng.IPromise<OrganisationLink> {
        let url_ = this.baseUrl + "/api/organisationlink/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<OrganisationLink> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationLink;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationLink>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: OrganisationLink): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/organisationlink/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: OrganisationLink[]): ng.IPromise<OrganisationLink[]> {
        let url_ = this.baseUrl + "/api/organisationlink/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<OrganisationLink[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationLink[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationLink[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: OrganisationLink[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/organisationlink/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisationlink/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/organisationlink/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class OrganisationLinkCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous48> {
        let url_ = this.baseUrl + "/odata/OrganisationLinkOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous48> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous48;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous48>(null as any);
    }

    /**
     * @return OK
     */
    post(body: OrganisationLinkInsert): ng.IPromise<OrganisationLink> {
        let url_ = this.baseUrl + "/api/crud/organisationlink/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<OrganisationLink> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationLink;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationLink>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: OrganisationLinkUpdate): ng.IPromise<OrganisationLink> {
        let url_ = this.baseUrl + "/api/crud/organisationlink/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<OrganisationLink> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationLink;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<OrganisationLink>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/organisationlink/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/organisationlink/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class OTPClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getQRCode(welcomeRequestId: number): ng.IPromise<FileResponse> {
        let url_ = this.baseUrl + "/api/OTP/GetQRCode?";
        if (welcomeRequestId === undefined || welcomeRequestId === null)
            throw new Error("The parameter 'welcomeRequestId' must be defined and cannot be null.");
        else
            url_ += "welcomeRequestId=" + encodeURIComponent("" + welcomeRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            responseType: "arraybuffer",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetQRCode(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetQRCode(_response);
            throw _response;
        });
    }

    protected processGetQRCode(response: any): ng.IPromise<FileResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return this.q.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status === 400) {
            return blobToText(new Blob([response.data]), this.q).then(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthErrorDetails;
            return throwException(this.q, "Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(new Blob([response.data]), this.q).then(_responseText => {
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return this.q.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    sendSMSCode(magic: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/OTP/SendSMSCode?";
        if (magic === undefined || magic === null)
            throw new Error("The parameter 'magic' must be defined and cannot be null.");
        else
            url_ += "magic=" + encodeURIComponent("" + magic) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendSMSCode(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendSMSCode(_response);
            throw _response;
        });
    }

    protected processSendSMSCode(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthErrorDetails;
            return throwException(this.q, "Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getTokenFromSMS(smsCode: string, magic: number): ng.IPromise<AuthDTO> {
        let url_ = this.baseUrl + "/api/OTP/GetTokenFromSMS?";
        if (smsCode === undefined || smsCode === null)
            throw new Error("The parameter 'smsCode' must be defined and cannot be null.");
        else
            url_ += "smsCode=" + encodeURIComponent("" + smsCode) + "&";
        if (magic === undefined || magic === null)
            throw new Error("The parameter 'magic' must be defined and cannot be null.");
        else
            url_ += "magic=" + encodeURIComponent("" + magic) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetTokenFromSMS(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetTokenFromSMS(_response);
            throw _response;
        });
    }

    protected processGetTokenFromSMS(response: any): ng.IPromise<AuthDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthDTO;
            return this.q.resolve(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException(this.q, "Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AuthDTO>(null as any);
    }

    /**
     * @return OK
     */
    getTokenFromOTP(otp: string, magic: number): ng.IPromise<AuthDTO> {
        let url_ = this.baseUrl + "/api/OTP/GetTokenFromOTP?";
        if (otp === undefined || otp === null)
            throw new Error("The parameter 'otp' must be defined and cannot be null.");
        else
            url_ += "otp=" + encodeURIComponent("" + otp) + "&";
        if (magic === undefined || magic === null)
            throw new Error("The parameter 'magic' must be defined and cannot be null.");
        else
            url_ += "magic=" + encodeURIComponent("" + magic) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetTokenFromOTP(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetTokenFromOTP(_response);
            throw _response;
        });
    }

    protected processGetTokenFromOTP(response: any): ng.IPromise<AuthDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthDTO;
            return this.q.resolve(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthErrorDetails;
            return throwException(this.q, "Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AuthDTO>(null as any);
    }

    /**
     * @return OK
     */
    getQRCodeText(welcomeRequestId: number): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/OTP/GetQRCodeText?";
        if (welcomeRequestId === undefined || welcomeRequestId === null)
            throw new Error("The parameter 'welcomeRequestId' must be defined and cannot be null.");
        else
            url_ += "welcomeRequestId=" + encodeURIComponent("" + welcomeRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetQRCodeText(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetQRCodeText(_response);
            throw _response;
        });
    }

    protected processGetQRCodeText(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }
}

export class PaymentClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param developmentInputId (optional) 
     * @return OK
     */
    createCheckoutSession(isAddOnSelected: boolean, selectedUserName: string, body: AppPackagePricing, developmentInputId?: number | null | undefined): ng.IPromise<PaymentSessionDTO> {
        let url_ = this.baseUrl + "/api/pay/createcheckoutsession?";
        if (isAddOnSelected === undefined || isAddOnSelected === null)
            throw new Error("The parameter 'isAddOnSelected' must be defined and cannot be null.");
        else
            url_ += "isAddOnSelected=" + encodeURIComponent("" + isAddOnSelected) + "&";
        if (selectedUserName === undefined || selectedUserName === null)
            throw new Error("The parameter 'selectedUserName' must be defined and cannot be null.");
        else
            url_ += "selectedUserName=" + encodeURIComponent("" + selectedUserName) + "&";
        if (developmentInputId !== undefined && developmentInputId !== null)
            url_ += "developmentInputId=" + encodeURIComponent("" + developmentInputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateCheckoutSession(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateCheckoutSession(_response);
            throw _response;
        });
    }

    protected processCreateCheckoutSession(response: any): ng.IPromise<PaymentSessionDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentSessionDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PaymentSessionDTO>(null as any);
    }

    /**
     * @return OK
     */
    getAllActivePackagePrices(userId: number): ng.IPromise<AppPackagePricing[]> {
        let url_ = this.baseUrl + "/api/pay/getallactivepackageprices?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAllActivePackagePrices(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAllActivePackagePrices(_response);
            throw _response;
        });
    }

    protected processGetAllActivePackagePrices(response: any): ng.IPromise<AppPackagePricing[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePricing[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePricing[]>(null as any);
    }

    /**
     * @param userRole (optional) 
     * @return OK
     */
    getActivePackagePricesForFrequency(frequency: PricingFrequencyEnum, userRole?: UserRoleEnum | undefined): ng.IPromise<AppPackagePricing[]> {
        let url_ = this.baseUrl + "/api/pay/getactivepackagepricesforfrequency?";
        if (frequency === undefined || frequency === null)
            throw new Error("The parameter 'frequency' must be defined and cannot be null.");
        else
            url_ += "frequency=" + encodeURIComponent("" + frequency) + "&";
        if (userRole === null)
            throw new Error("The parameter 'userRole' cannot be null.");
        else if (userRole !== undefined)
            url_ += "userRole=" + encodeURIComponent("" + userRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetActivePackagePricesForFrequency(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetActivePackagePricesForFrequency(_response);
            throw _response;
        });
    }

    protected processGetActivePackagePricesForFrequency(response: any): ng.IPromise<AppPackagePricing[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePricing[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePricing[]>(null as any);
    }

    /**
     * @return OK
     */
    createPortalSession(): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/pay/createportalsession";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreatePortalSession(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreatePortalSession(_response);
            throw _response;
        });
    }

    protected processCreatePortalSession(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    stripeWebHooks(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/pay/webhook";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processStripeWebHooks(_response);
        }, (_response) => {
            if (_response.status)
                return this.processStripeWebHooks(_response);
            throw _response;
        });
    }

    protected processStripeWebHooks(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    updatePlanPrice(selectedUserName: string, isAddOnSelected: boolean, isUpdateWithPrecancel: boolean, body: AppPackagePricing[]): ng.IPromise<LicenseAppPackage> {
        let url_ = this.baseUrl + "/api/pay/updateplanprice?";
        if (selectedUserName === undefined || selectedUserName === null)
            throw new Error("The parameter 'selectedUserName' must be defined and cannot be null.");
        else
            url_ += "selectedUserName=" + encodeURIComponent("" + selectedUserName) + "&";
        if (isAddOnSelected === undefined || isAddOnSelected === null)
            throw new Error("The parameter 'isAddOnSelected' must be defined and cannot be null.");
        else
            url_ += "isAddOnSelected=" + encodeURIComponent("" + isAddOnSelected) + "&";
        if (isUpdateWithPrecancel === undefined || isUpdateWithPrecancel === null)
            throw new Error("The parameter 'isUpdateWithPrecancel' must be defined and cannot be null.");
        else
            url_ += "isUpdateWithPrecancel=" + encodeURIComponent("" + isUpdateWithPrecancel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdatePlanPrice(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdatePlanPrice(_response);
            throw _response;
        });
    }

    protected processUpdatePlanPrice(response: any): ng.IPromise<LicenseAppPackage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseAppPackage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseAppPackage>(null as any);
    }

    /**
     * @return OK
     */
    cancelSubscription(subscriptionId: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/pay/cancelsubscription?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined and cannot be null.");
        else
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCancelSubscription(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCancelSubscription(_response);
            throw _response;
        });
    }

    protected processCancelSubscription(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    unCancelSubscription(subscriptionId: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/pay/uncancelsubscription?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined and cannot be null.");
        else
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUnCancelSubscription(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUnCancelSubscription(_response);
            throw _response;
        });
    }

    protected processUnCancelSubscription(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getSelectedPackageForCurrentuser(userId: number | null): ng.IPromise<LicenseAppPackage[]> {
        let url_ = this.baseUrl + "/api/pay/getselectedpackageforcurrentuser?";
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else if(userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSelectedPackageForCurrentuser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSelectedPackageForCurrentuser(_response);
            throw _response;
        });
    }

    protected processGetSelectedPackageForCurrentuser(response: any): ng.IPromise<LicenseAppPackage[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseAppPackage[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseAppPackage[]>(null as any);
    }

    /**
     * @return OK
     */
    getLicense(userName: string): ng.IPromise<LicenseAppPackage> {
        let url_ = this.baseUrl + "/api/pay/getlicense?";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetLicense(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetLicense(_response);
            throw _response;
        });
    }

    protected processGetLicense(response: any): ng.IPromise<LicenseAppPackage> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseAppPackage;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseAppPackage>(null as any);
    }

    /**
     * @return OK
     */
    assignLicense(userId: number, orgId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/pay/assignlicense?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined and cannot be null.");
        else
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAssignLicense(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAssignLicense(_response);
            throw _response;
        });
    }

    protected processAssignLicense(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    unAssignLicense(userId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/pay/unassignlicense?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUnAssignLicense(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUnAssignLicense(_response);
            throw _response;
        });
    }

    protected processUnAssignLicense(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePreCancelSubscription(selectedUserName: string, isAddOnSelected: boolean, isUpdateWithPrecancel: boolean, body: AppPackagePricing[]): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/pay/updateprecancelsubscription?";
        if (selectedUserName === undefined || selectedUserName === null)
            throw new Error("The parameter 'selectedUserName' must be defined and cannot be null.");
        else
            url_ += "selectedUserName=" + encodeURIComponent("" + selectedUserName) + "&";
        if (isAddOnSelected === undefined || isAddOnSelected === null)
            throw new Error("The parameter 'isAddOnSelected' must be defined and cannot be null.");
        else
            url_ += "isAddOnSelected=" + encodeURIComponent("" + isAddOnSelected) + "&";
        if (isUpdateWithPrecancel === undefined || isUpdateWithPrecancel === null)
            throw new Error("The parameter 'isUpdateWithPrecancel' must be defined and cannot be null.");
        else
            url_ += "isUpdateWithPrecancel=" + encodeURIComponent("" + isUpdateWithPrecancel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdatePreCancelSubscription(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdatePreCancelSubscription(_response);
            throw _response;
        });
    }

    protected processUpdatePreCancelSubscription(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getTotalUnassignedLicenses(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/pay/gettotalunassignedlicenses";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetTotalUnassignedLicenses(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetTotalUnassignedLicenses(_response);
            throw _response;
        });
    }

    protected processGetTotalUnassignedLicenses(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    assignCustomPrice(customPrice: string, numberOfLicenses: number, orgId: number, isAddOnSelected: boolean, isMonthlySubscription: boolean): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/pay/assigncustomprice?";
        if (customPrice === undefined || customPrice === null)
            throw new Error("The parameter 'customPrice' must be defined and cannot be null.");
        else
            url_ += "customPrice=" + encodeURIComponent("" + customPrice) + "&";
        if (numberOfLicenses === undefined || numberOfLicenses === null)
            throw new Error("The parameter 'numberOfLicenses' must be defined and cannot be null.");
        else
            url_ += "numberOfLicenses=" + encodeURIComponent("" + numberOfLicenses) + "&";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined and cannot be null.");
        else
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (isAddOnSelected === undefined || isAddOnSelected === null)
            throw new Error("The parameter 'isAddOnSelected' must be defined and cannot be null.");
        else
            url_ += "isAddOnSelected=" + encodeURIComponent("" + isAddOnSelected) + "&";
        if (isMonthlySubscription === undefined || isMonthlySubscription === null)
            throw new Error("The parameter 'isMonthlySubscription' must be defined and cannot be null.");
        else
            url_ += "isMonthlySubscription=" + encodeURIComponent("" + isMonthlySubscription) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAssignCustomPrice(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAssignCustomPrice(_response);
            throw _response;
        });
    }

    protected processAssignCustomPrice(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    assignStandardPrice(orgId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/pay/assignstandardprice?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined and cannot be null.");
        else
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAssignStandardPrice(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAssignStandardPrice(_response);
            throw _response;
        });
    }

    protected processAssignStandardPrice(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    offerLeadGeneratorLicense(body: LicenseAppPackage): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/pay/offerleadgeneratorlicense";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processOfferLeadGeneratorLicense(_response);
        }, (_response) => {
            if (_response.status)
                return this.processOfferLeadGeneratorLicense(_response);
            throw _response;
        });
    }

    protected processOfferLeadGeneratorLicense(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    offerCustomPrice(customPrice: string, numberOfLicenses: number, orgId: number, isAddOnSelected: boolean, isMonthlySubscription: boolean): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/pay/offercustomprice?";
        if (customPrice === undefined || customPrice === null)
            throw new Error("The parameter 'customPrice' must be defined and cannot be null.");
        else
            url_ += "customPrice=" + encodeURIComponent("" + customPrice) + "&";
        if (numberOfLicenses === undefined || numberOfLicenses === null)
            throw new Error("The parameter 'numberOfLicenses' must be defined and cannot be null.");
        else
            url_ += "numberOfLicenses=" + encodeURIComponent("" + numberOfLicenses) + "&";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined and cannot be null.");
        else
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (isAddOnSelected === undefined || isAddOnSelected === null)
            throw new Error("The parameter 'isAddOnSelected' must be defined and cannot be null.");
        else
            url_ += "isAddOnSelected=" + encodeURIComponent("" + isAddOnSelected) + "&";
        if (isMonthlySubscription === undefined || isMonthlySubscription === null)
            throw new Error("The parameter 'isMonthlySubscription' must be defined and cannot be null.");
        else
            url_ += "isMonthlySubscription=" + encodeURIComponent("" + isMonthlySubscription) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processOfferCustomPrice(_response);
        }, (_response) => {
            if (_response.status)
                return this.processOfferCustomPrice(_response);
            throw _response;
        });
    }

    protected processOfferCustomPrice(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getWhiteLabelPrice(frequency: PricingFrequencyEnum): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/pay/getwhitelabelprice?";
        if (frequency === undefined || frequency === null)
            throw new Error("The parameter 'frequency' must be defined and cannot be null.");
        else
            url_ += "frequency=" + encodeURIComponent("" + frequency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetWhiteLabelPrice(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetWhiteLabelPrice(_response);
            throw _response;
        });
    }

    protected processGetWhiteLabelPrice(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    isSubscriptionCancelable(subscriptionId: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/pay/issubscriptioncancelable?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined and cannot be null.");
        else
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsSubscriptionCancelable(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsSubscriptionCancelable(_response);
            throw _response;
        });
    }

    protected processIsSubscriptionCancelable(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    createCheckoutSessionForLeadGen(body: LicenseAppPackage): ng.IPromise<PaymentSessionDTO> {
        let url_ = this.baseUrl + "/api/pay/createcheckoutsessionforleadgen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateCheckoutSessionForLeadGen(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateCheckoutSessionForLeadGen(_response);
            throw _response;
        });
    }

    protected processCreateCheckoutSessionForLeadGen(response: any): ng.IPromise<PaymentSessionDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentSessionDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PaymentSessionDTO>(null as any);
    }

    /**
     * @return OK
     */
    cancelLeadGeneratorOffer(selectedleadGenPackageId: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/pay/cancelleadgeneratoroffer?";
        if (selectedleadGenPackageId === undefined || selectedleadGenPackageId === null)
            throw new Error("The parameter 'selectedleadGenPackageId' must be defined and cannot be null.");
        else
            url_ += "selectedleadGenPackageId=" + encodeURIComponent("" + selectedleadGenPackageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCancelLeadGeneratorOffer(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCancelLeadGeneratorOffer(_response);
            throw _response;
        });
    }

    protected processCancelLeadGeneratorOffer(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @param developmentInputId (optional) 
     * @return OK
     */
    createCheckoutSessionForCustomPrice(isAddOnSelected: boolean, selectedUserName: string, body: LicenseAppPackage, developmentInputId?: number | null | undefined): ng.IPromise<PaymentSessionDTO> {
        let url_ = this.baseUrl + "/api/pay/createcheckoutsessionforcustomprice?";
        if (isAddOnSelected === undefined || isAddOnSelected === null)
            throw new Error("The parameter 'isAddOnSelected' must be defined and cannot be null.");
        else
            url_ += "isAddOnSelected=" + encodeURIComponent("" + isAddOnSelected) + "&";
        if (selectedUserName === undefined || selectedUserName === null)
            throw new Error("The parameter 'selectedUserName' must be defined and cannot be null.");
        else
            url_ += "selectedUserName=" + encodeURIComponent("" + selectedUserName) + "&";
        if (developmentInputId !== undefined && developmentInputId !== null)
            url_ += "developmentInputId=" + encodeURIComponent("" + developmentInputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateCheckoutSessionForCustomPrice(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateCheckoutSessionForCustomPrice(_response);
            throw _response;
        });
    }

    protected processCreateCheckoutSessionForCustomPrice(response: any): ng.IPromise<PaymentSessionDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentSessionDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PaymentSessionDTO>(null as any);
    }

    /**
     * @return OK
     */
    getActivePackagePricingsForTrialLicense(userName: string): ng.IPromise<AppPackagePricing[]> {
        let url_ = this.baseUrl + "/api/pay/getactivepackagepricingsfortriallicense?";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetActivePackagePricingsForTrialLicense(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetActivePackagePricingsForTrialLicense(_response);
            throw _response;
        });
    }

    protected processGetActivePackagePricingsForTrialLicense(response: any): ng.IPromise<AppPackagePricing[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPackagePricing[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AppPackagePricing[]>(null as any);
    }
}

export class PostcodeLocationClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<PostcodeLocation[]> {
        let url_ = this.baseUrl + "/api/postcodelocation/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<PostcodeLocation[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostcodeLocation[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PostcodeLocation[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<PostcodeLocation> {
        let url_ = this.baseUrl + "/api/postcodelocation/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<PostcodeLocation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostcodeLocation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PostcodeLocation>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/postcodelocation/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<PostcodeLocationPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/postcodelocation/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<PostcodeLocationPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostcodeLocationPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PostcodeLocationPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<PostcodeLocationPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/postcodelocation/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<PostcodeLocationPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostcodeLocationPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PostcodeLocationPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: PostcodeLocation): ng.IPromise<PostcodeLocation> {
        let url_ = this.baseUrl + "/api/postcodelocation/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<PostcodeLocation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostcodeLocation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PostcodeLocation>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: PostcodeLocation): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/postcodelocation/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: PostcodeLocation[]): ng.IPromise<PostcodeLocation[]> {
        let url_ = this.baseUrl + "/api/postcodelocation/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<PostcodeLocation[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostcodeLocation[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PostcodeLocation[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: PostcodeLocation[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/postcodelocation/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/postcodelocation/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/postcodelocation/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class PostcodeLocationCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous49> {
        let url_ = this.baseUrl + "/odata/PostcodeLocationOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous49> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous49;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous49>(null as any);
    }

    /**
     * @return OK
     */
    post(body: PostcodeLocationInsert): ng.IPromise<PostcodeLocation> {
        let url_ = this.baseUrl + "/api/crud/postcodelocation/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<PostcodeLocation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostcodeLocation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PostcodeLocation>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: PostcodeLocationUpdate): ng.IPromise<PostcodeLocation> {
        let url_ = this.baseUrl + "/api/crud/postcodelocation/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<PostcodeLocation> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostcodeLocation;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PostcodeLocation>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/postcodelocation/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/postcodelocation/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProductClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    listBaseOnLender(lenderId: number): ng.IPromise<Product[]> {
        let url_ = this.baseUrl + "/api/product?";
        if (lenderId === undefined || lenderId === null)
            throw new Error("The parameter 'lenderId' must be defined and cannot be null.");
        else
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListBaseOnLender(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListBaseOnLender(_response);
            throw _response;
        });
    }

    protected processListBaseOnLender(response: any): ng.IPromise<Product[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Product[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Product[]>(null as any);
    }

    /**
     * @return OK
     */
    exportProductUnitTest(productId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/product/unittest?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportProductUnitTest(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportProductUnitTest(_response);
            throw _response;
        });
    }

    protected processExportProductUnitTest(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getLeadGeneratorName(): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/product/getLeadGeneratorName";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetLeadGeneratorName(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetLeadGeneratorName(_response);
            throw _response;
        });
    }

    protected processGetLeadGeneratorName(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return OK
     */
    isProductRefUnique(productRef: string, productId?: number | undefined): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/product/isProductRefUnique?";
        if (productRef === undefined || productRef === null)
            throw new Error("The parameter 'productRef' must be defined and cannot be null.");
        else
            url_ += "productRef=" + encodeURIComponent("" + productRef) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsProductRefUnique(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsProductRefUnique(_response);
            throw _response;
        });
    }

    protected processIsProductRefUnique(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyIDOW(body: Product): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/product/addUpdateReturnOnlyIDOW";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyIDOW(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyIDOW(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyIDOW(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeletedOW(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/product/markAsDeletedOW?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeletedOW(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeletedOW(_response);
            throw _response;
        });
    }

    protected processMarkAsDeletedOW(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getLastVerifiedDates(body: number[]): ng.IPromise<{ [key: string]: Date; }> {
        let url_ = this.baseUrl + "/api/product/getlastverifieddates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetLastVerifiedDates(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetLastVerifiedDates(_response);
            throw _response;
        });
    }

    protected processGetLastVerifiedDates(response: any): ng.IPromise<{ [key: string]: Date; }> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Date; };
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<{ [key: string]: Date; }>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<Product[]> {
        let url_ = this.baseUrl + "/api/product/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<Product[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Product[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Product[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<Product> {
        let url_ = this.baseUrl + "/api/product/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<Product> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Product;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Product>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/product/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ProductPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/product/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ProductPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ProductPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/product/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ProductPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: Product): ng.IPromise<Product> {
        let url_ = this.baseUrl + "/api/product/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<Product> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Product;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Product>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: Product): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/product/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: Product[]): ng.IPromise<Product[]> {
        let url_ = this.baseUrl + "/api/product/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<Product[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Product[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Product[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: Product[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/product/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/product/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/product/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProductCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous50> {
        let url_ = this.baseUrl + "/odata/ProductOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous50> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous50;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous50>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ProductInsert): ng.IPromise<Product> {
        let url_ = this.baseUrl + "/api/crud/product/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<Product> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Product;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Product>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ProductUpdate): ng.IPromise<Product> {
        let url_ = this.baseUrl + "/api/crud/product/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<Product> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Product;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Product>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/product/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/product/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProductRateClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<ProductRate[]> {
        let url_ = this.baseUrl + "/api/productrate/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<ProductRate[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductRate[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductRate[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<ProductRate> {
        let url_ = this.baseUrl + "/api/productrate/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<ProductRate> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductRate;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductRate>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/productrate/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ProductRatePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/productrate/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ProductRatePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductRatePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductRatePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ProductRatePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/productrate/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ProductRatePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductRatePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductRatePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: ProductRate): ng.IPromise<ProductRate> {
        let url_ = this.baseUrl + "/api/productrate/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<ProductRate> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductRate;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductRate>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: ProductRate): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/productrate/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: ProductRate[]): ng.IPromise<ProductRate[]> {
        let url_ = this.baseUrl + "/api/productrate/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<ProductRate[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductRate[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductRate[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: ProductRate[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/productrate/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/productrate/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/productrate/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProductRateCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous51> {
        let url_ = this.baseUrl + "/odata/ProductRateOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous51> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous51;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous51>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ProductRateInsert): ng.IPromise<ProductRate> {
        let url_ = this.baseUrl + "/api/crud/productrate/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<ProductRate> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductRate;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductRate>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ProductRateUpdate): ng.IPromise<ProductRate> {
        let url_ = this.baseUrl + "/api/crud/productrate/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<ProductRate> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductRate;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductRate>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/productrate/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/productrate/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProfileClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<Profile[]> {
        let url_ = this.baseUrl + "/api/profile/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<Profile[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Profile[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Profile[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<Profile> {
        let url_ = this.baseUrl + "/api/profile/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<Profile> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Profile;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Profile>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/profile/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ProfilePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/profile/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ProfilePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfilePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfilePageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ProfilePageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/profile/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ProfilePageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfilePageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfilePageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: Profile): ng.IPromise<Profile> {
        let url_ = this.baseUrl + "/api/profile/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<Profile> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Profile;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Profile>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: Profile): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/profile/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: Profile[]): ng.IPromise<Profile[]> {
        let url_ = this.baseUrl + "/api/profile/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<Profile[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Profile[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Profile[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: Profile[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/profile/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/profile/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/profile/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProfileAssetLiabilityItemClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<ProfileAssetLiabilityItem[]> {
        let url_ = this.baseUrl + "/api/profileassetliabilityitem/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<ProfileAssetLiabilityItem[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileAssetLiabilityItem[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileAssetLiabilityItem[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<ProfileAssetLiabilityItem> {
        let url_ = this.baseUrl + "/api/profileassetliabilityitem/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<ProfileAssetLiabilityItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileAssetLiabilityItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileAssetLiabilityItem>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/profileassetliabilityitem/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ProfileAssetLiabilityItemPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/profileassetliabilityitem/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ProfileAssetLiabilityItemPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileAssetLiabilityItemPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileAssetLiabilityItemPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ProfileAssetLiabilityItemPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/profileassetliabilityitem/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ProfileAssetLiabilityItemPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileAssetLiabilityItemPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileAssetLiabilityItemPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: ProfileAssetLiabilityItem): ng.IPromise<ProfileAssetLiabilityItem> {
        let url_ = this.baseUrl + "/api/profileassetliabilityitem/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<ProfileAssetLiabilityItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileAssetLiabilityItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileAssetLiabilityItem>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: ProfileAssetLiabilityItem): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/profileassetliabilityitem/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: ProfileAssetLiabilityItem[]): ng.IPromise<ProfileAssetLiabilityItem[]> {
        let url_ = this.baseUrl + "/api/profileassetliabilityitem/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<ProfileAssetLiabilityItem[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileAssetLiabilityItem[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileAssetLiabilityItem[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: ProfileAssetLiabilityItem[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/profileassetliabilityitem/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/profileassetliabilityitem/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/profileassetliabilityitem/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProfileAssetLiabilityItemCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous52> {
        let url_ = this.baseUrl + "/odata/ProfileAssetLiabilityItemOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous52> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous52;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous52>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ProfileAssetLiabilityItemInsert): ng.IPromise<ProfileAssetLiabilityItem> {
        let url_ = this.baseUrl + "/api/crud/profileassetliabilityitem/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<ProfileAssetLiabilityItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileAssetLiabilityItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileAssetLiabilityItem>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ProfileAssetLiabilityItemUpdate): ng.IPromise<ProfileAssetLiabilityItem> {
        let url_ = this.baseUrl + "/api/crud/profileassetliabilityitem/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<ProfileAssetLiabilityItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileAssetLiabilityItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileAssetLiabilityItem>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/profileassetliabilityitem/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/profileassetliabilityitem/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProfileCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous53> {
        let url_ = this.baseUrl + "/odata/ProfileOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous53> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous53;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous53>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ProfileInsert): ng.IPromise<Profile> {
        let url_ = this.baseUrl + "/api/crud/profile/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<Profile> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Profile;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Profile>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ProfileUpdate): ng.IPromise<Profile> {
        let url_ = this.baseUrl + "/api/crud/profile/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<Profile> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Profile;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Profile>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/profile/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/profile/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProfileQualificationClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<ProfileQualification[]> {
        let url_ = this.baseUrl + "/api/profilequalification/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<ProfileQualification[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileQualification[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileQualification[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<ProfileQualification> {
        let url_ = this.baseUrl + "/api/profilequalification/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<ProfileQualification> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileQualification;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileQualification>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/profilequalification/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ProfileQualificationPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/profilequalification/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ProfileQualificationPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileQualificationPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileQualificationPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ProfileQualificationPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/profilequalification/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ProfileQualificationPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileQualificationPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileQualificationPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: ProfileQualification): ng.IPromise<ProfileQualification> {
        let url_ = this.baseUrl + "/api/profilequalification/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<ProfileQualification> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileQualification;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileQualification>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: ProfileQualification): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/profilequalification/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: ProfileQualification[]): ng.IPromise<ProfileQualification[]> {
        let url_ = this.baseUrl + "/api/profilequalification/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<ProfileQualification[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileQualification[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileQualification[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: ProfileQualification[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/profilequalification/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/profilequalification/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/profilequalification/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProfileQualificationCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous54> {
        let url_ = this.baseUrl + "/odata/ProfileQualificationOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous54> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous54;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous54>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ProfileQualificationInsert): ng.IPromise<ProfileQualification> {
        let url_ = this.baseUrl + "/api/crud/profilequalification/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<ProfileQualification> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileQualification;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileQualification>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ProfileQualificationUpdate): ng.IPromise<ProfileQualification> {
        let url_ = this.baseUrl + "/api/crud/profilequalification/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<ProfileQualification> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileQualification;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProfileQualification>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/profilequalification/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/profilequalification/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProjectOwnershipClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<ProjectOwnership[]> {
        let url_ = this.baseUrl + "/api/projectownership/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<ProjectOwnership[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectOwnership[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProjectOwnership[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<ProjectOwnership> {
        let url_ = this.baseUrl + "/api/projectownership/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<ProjectOwnership> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectOwnership;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProjectOwnership>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/projectownership/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ProjectOwnershipPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/projectownership/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ProjectOwnershipPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectOwnershipPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProjectOwnershipPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ProjectOwnershipPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/projectownership/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ProjectOwnershipPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectOwnershipPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProjectOwnershipPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: ProjectOwnership): ng.IPromise<ProjectOwnership> {
        let url_ = this.baseUrl + "/api/projectownership/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<ProjectOwnership> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectOwnership;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProjectOwnership>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: ProjectOwnership): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/projectownership/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: ProjectOwnership[]): ng.IPromise<ProjectOwnership[]> {
        let url_ = this.baseUrl + "/api/projectownership/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<ProjectOwnership[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectOwnership[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProjectOwnership[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: ProjectOwnership[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/projectownership/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/projectownership/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/projectownership/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ProjectOwnershipCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous55> {
        let url_ = this.baseUrl + "/odata/ProjectOwnershipOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous55> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous55;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous55>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ProjectOwnershipInsert): ng.IPromise<ProjectOwnership> {
        let url_ = this.baseUrl + "/api/crud/projectownership/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<ProjectOwnership> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectOwnership;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProjectOwnership>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ProjectOwnershipUpdate): ng.IPromise<ProjectOwnership> {
        let url_ = this.baseUrl + "/api/crud/projectownership/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<ProjectOwnership> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectOwnership;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProjectOwnership>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/projectownership/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/projectownership/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class QualificationsClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<Qualifications[]> {
        let url_ = this.baseUrl + "/api/qualifications/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<Qualifications[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Qualifications[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Qualifications[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<Qualifications> {
        let url_ = this.baseUrl + "/api/qualifications/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<Qualifications> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Qualifications;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Qualifications>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/qualifications/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<QualificationsPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/qualifications/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<QualificationsPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QualificationsPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<QualificationsPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<QualificationsPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/qualifications/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<QualificationsPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QualificationsPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<QualificationsPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: Qualifications): ng.IPromise<Qualifications> {
        let url_ = this.baseUrl + "/api/qualifications/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<Qualifications> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Qualifications;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Qualifications>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: Qualifications): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/qualifications/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: Qualifications[]): ng.IPromise<Qualifications[]> {
        let url_ = this.baseUrl + "/api/qualifications/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<Qualifications[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Qualifications[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Qualifications[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: Qualifications[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/qualifications/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/qualifications/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/qualifications/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class QualificationsCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous56> {
        let url_ = this.baseUrl + "/odata/QualificationsOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous56> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous56;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous56>(null as any);
    }

    /**
     * @return OK
     */
    post(body: QualificationsInsert): ng.IPromise<Qualifications> {
        let url_ = this.baseUrl + "/api/crud/qualifications/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<Qualifications> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Qualifications;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Qualifications>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: QualificationsUpdate): ng.IPromise<Qualifications> {
        let url_ = this.baseUrl + "/api/crud/qualifications/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<Qualifications> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Qualifications;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Qualifications>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/qualifications/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/qualifications/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class RoleClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrentUser(): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/roles/getrolesiammemberof";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCurrentUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCurrentUser(_response);
            throw _response;
        });
    }

    protected processGetCurrentUser(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<ClaimGroup[]> {
        let url_ = this.baseUrl + "/api/roles/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<ClaimGroup[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClaimGroup[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ClaimGroup[]>(null as any);
    }
}

export class ScheduledJobLogClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<ScheduledJobLog[]> {
        let url_ = this.baseUrl + "/api/scheduledjoblog/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<ScheduledJobLog[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduledJobLog[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScheduledJobLog[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<ScheduledJobLog> {
        let url_ = this.baseUrl + "/api/scheduledjoblog/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<ScheduledJobLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduledJobLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScheduledJobLog>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/scheduledjoblog/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ScheduledJobLogPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/scheduledjoblog/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ScheduledJobLogPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduledJobLogPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScheduledJobLogPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ScheduledJobLogPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/scheduledjoblog/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ScheduledJobLogPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduledJobLogPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScheduledJobLogPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: ScheduledJobLog): ng.IPromise<ScheduledJobLog> {
        let url_ = this.baseUrl + "/api/scheduledjoblog/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<ScheduledJobLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduledJobLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScheduledJobLog>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: ScheduledJobLog): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/scheduledjoblog/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: ScheduledJobLog[]): ng.IPromise<ScheduledJobLog[]> {
        let url_ = this.baseUrl + "/api/scheduledjoblog/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<ScheduledJobLog[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduledJobLog[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScheduledJobLog[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: ScheduledJobLog[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/scheduledjoblog/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/scheduledjoblog/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/scheduledjoblog/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ScheduledJobLogCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous57> {
        let url_ = this.baseUrl + "/odata/ScheduledJobLogOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous57> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous57;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous57>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ScheduledJobLogInsert): ng.IPromise<ScheduledJobLog> {
        let url_ = this.baseUrl + "/api/crud/scheduledjoblog/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<ScheduledJobLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduledJobLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScheduledJobLog>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ScheduledJobLogUpdate): ng.IPromise<ScheduledJobLog> {
        let url_ = this.baseUrl + "/api/crud/scheduledjoblog/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<ScheduledJobLog> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduledJobLog;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScheduledJobLog>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/scheduledjoblog/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/scheduledjoblog/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class SelectedResultClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<SelectedResult[]> {
        let url_ = this.baseUrl + "/api/selectedresult/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<SelectedResult[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectedResult[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SelectedResult[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<SelectedResult> {
        let url_ = this.baseUrl + "/api/selectedresult/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<SelectedResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectedResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SelectedResult>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/selectedresult/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<SelectedResultPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/selectedresult/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<SelectedResultPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectedResultPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SelectedResultPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<SelectedResultPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/selectedresult/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<SelectedResultPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectedResultPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SelectedResultPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: SelectedResult): ng.IPromise<SelectedResult> {
        let url_ = this.baseUrl + "/api/selectedresult/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<SelectedResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectedResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SelectedResult>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: SelectedResult): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/selectedresult/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: SelectedResult[]): ng.IPromise<SelectedResult[]> {
        let url_ = this.baseUrl + "/api/selectedresult/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<SelectedResult[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectedResult[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SelectedResult[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: SelectedResult[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/selectedresult/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/selectedresult/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/selectedresult/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class SelectedResultCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous58> {
        let url_ = this.baseUrl + "/odata/SelectedResultOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous58> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous58;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous58>(null as any);
    }

    /**
     * @return OK
     */
    post(body: SelectedResultInsert): ng.IPromise<SelectedResult> {
        let url_ = this.baseUrl + "/api/crud/selectedresult/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<SelectedResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectedResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SelectedResult>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: SelectedResultUpdate): ng.IPromise<SelectedResult> {
        let url_ = this.baseUrl + "/api/crud/selectedresult/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<SelectedResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectedResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SelectedResult>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/selectedresult/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/selectedresult/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class SnapshotLenderClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<SnapshotLender[]> {
        let url_ = this.baseUrl + "/api/snapshotlender/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<SnapshotLender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotLender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotLender[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<SnapshotLender> {
        let url_ = this.baseUrl + "/api/snapshotlender/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<SnapshotLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotLender>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/snapshotlender/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<SnapshotLenderPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/snapshotlender/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<SnapshotLenderPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotLenderPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotLenderPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<SnapshotLenderPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/snapshotlender/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<SnapshotLenderPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotLenderPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotLenderPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: SnapshotLender): ng.IPromise<SnapshotLender> {
        let url_ = this.baseUrl + "/api/snapshotlender/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<SnapshotLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotLender>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: SnapshotLender): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/snapshotlender/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: SnapshotLender[]): ng.IPromise<SnapshotLender[]> {
        let url_ = this.baseUrl + "/api/snapshotlender/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<SnapshotLender[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotLender[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotLender[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: SnapshotLender[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/snapshotlender/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/snapshotlender/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/snapshotlender/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class SnapshotLenderCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous59> {
        let url_ = this.baseUrl + "/odata/SnapshotLenderOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous59> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous59;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous59>(null as any);
    }

    /**
     * @return OK
     */
    post(body: SnapshotLenderInsert): ng.IPromise<SnapshotLender> {
        let url_ = this.baseUrl + "/api/crud/snapshotlender/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<SnapshotLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotLender>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: SnapshotLenderUpdate): ng.IPromise<SnapshotLender> {
        let url_ = this.baseUrl + "/api/crud/snapshotlender/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<SnapshotLender> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotLender;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotLender>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/snapshotlender/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/snapshotlender/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class SnapshotProductClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<SnapshotProduct[]> {
        let url_ = this.baseUrl + "/api/snapshotproduct/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<SnapshotProduct[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotProduct[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotProduct[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<SnapshotProduct> {
        let url_ = this.baseUrl + "/api/snapshotproduct/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<SnapshotProduct> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotProduct;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotProduct>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/snapshotproduct/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<SnapshotProductPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/snapshotproduct/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<SnapshotProductPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotProductPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotProductPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<SnapshotProductPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/snapshotproduct/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<SnapshotProductPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotProductPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotProductPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: SnapshotProduct): ng.IPromise<SnapshotProduct> {
        let url_ = this.baseUrl + "/api/snapshotproduct/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<SnapshotProduct> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotProduct;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotProduct>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: SnapshotProduct): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/snapshotproduct/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: SnapshotProduct[]): ng.IPromise<SnapshotProduct[]> {
        let url_ = this.baseUrl + "/api/snapshotproduct/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<SnapshotProduct[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotProduct[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotProduct[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: SnapshotProduct[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/snapshotproduct/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/snapshotproduct/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/snapshotproduct/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class SnapshotProductCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous60> {
        let url_ = this.baseUrl + "/odata/SnapshotProductOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous60> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous60;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous60>(null as any);
    }

    /**
     * @return OK
     */
    post(body: SnapshotProductInsert): ng.IPromise<SnapshotProduct> {
        let url_ = this.baseUrl + "/api/crud/snapshotproduct/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<SnapshotProduct> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotProduct;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotProduct>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: SnapshotProductUpdate): ng.IPromise<SnapshotProduct> {
        let url_ = this.baseUrl + "/api/crud/snapshotproduct/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<SnapshotProduct> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotProduct;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotProduct>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/snapshotproduct/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/snapshotproduct/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class SnapshotSearchResultClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<SnapshotSearchResult[]> {
        let url_ = this.baseUrl + "/api/snapshotsearchresult/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<SnapshotSearchResult[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotSearchResult[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotSearchResult[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<SnapshotSearchResult> {
        let url_ = this.baseUrl + "/api/snapshotsearchresult/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<SnapshotSearchResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotSearchResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/snapshotsearchresult/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<SnapshotSearchResultPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/snapshotsearchresult/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<SnapshotSearchResultPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotSearchResultPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotSearchResultPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<SnapshotSearchResultPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/snapshotsearchresult/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<SnapshotSearchResultPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotSearchResultPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotSearchResultPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: SnapshotSearchResult): ng.IPromise<SnapshotSearchResult> {
        let url_ = this.baseUrl + "/api/snapshotsearchresult/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<SnapshotSearchResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotSearchResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: SnapshotSearchResult): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/snapshotsearchresult/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: SnapshotSearchResult[]): ng.IPromise<SnapshotSearchResult[]> {
        let url_ = this.baseUrl + "/api/snapshotsearchresult/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<SnapshotSearchResult[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotSearchResult[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotSearchResult[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: SnapshotSearchResult[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/snapshotsearchresult/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/snapshotsearchresult/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/snapshotsearchresult/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class SnapshotSearchResultCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous61> {
        let url_ = this.baseUrl + "/odata/SnapshotSearchResultOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous61> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous61;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous61>(null as any);
    }

    /**
     * @return OK
     */
    post(body: SnapshotSearchResultInsert): ng.IPromise<SnapshotSearchResult> {
        let url_ = this.baseUrl + "/api/crud/snapshotsearchresult/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<SnapshotSearchResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotSearchResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: SnapshotSearchResultUpdate): ng.IPromise<SnapshotSearchResult> {
        let url_ = this.baseUrl + "/api/crud/snapshotsearchresult/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<SnapshotSearchResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapshotSearchResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SnapshotSearchResult>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/snapshotsearchresult/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/snapshotsearchresult/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class StaticDataClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    amIATestSite(): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/static/amiatestsite";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAmIATestSite(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAmIATestSite(_response);
            throw _response;
        });
    }

    protected processAmIATestSite(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getHubspotDeveloperBookMeetingNoSearch(): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/static/gethubspotdeveloperbookmeetingnosearch";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetHubspotDeveloperBookMeetingNoSearch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetHubspotDeveloperBookMeetingNoSearch(_response);
            throw _response;
        });
    }

    protected processGetHubspotDeveloperBookMeetingNoSearch(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getHubspotDeveloperBookMeetingWithSearch(): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/static/gethubspotdeveloperbookmeetingwithsearch";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetHubspotDeveloperBookMeetingWithSearch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetHubspotDeveloperBookMeetingWithSearch(_response);
            throw _response;
        });
    }

    protected processGetHubspotDeveloperBookMeetingWithSearch(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getHubspotContactUsBookMeeting(): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/static/gethubspotcontactusbookmeeting";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetHubspotContactUsBookMeeting(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetHubspotContactUsBookMeeting(_response);
            throw _response;
        });
    }

    protected processGetHubspotContactUsBookMeeting(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getWhiteLabelledUrl(): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/static/getwhitelabelledurl";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetWhiteLabelledUrl(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetWhiteLabelledUrl(_response);
            throw _response;
        });
    }

    protected processGetWhiteLabelledUrl(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getShowBridgingLenderSnapshot(): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/static/getshowbridginglendersnapshot";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetShowBridgingLenderSnapshot(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetShowBridgingLenderSnapshot(_response);
            throw _response;
        });
    }

    protected processGetShowBridgingLenderSnapshot(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getShowBridgingEligibility(): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/static/getshowbridgingeligibility";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetShowBridgingEligibility(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetShowBridgingEligibility(_response);
            throw _response;
        });
    }

    protected processGetShowBridgingEligibility(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getCompanyContactUsEmailAddress(): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/static/getcompanycontactusemailaddress";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCompanyContactUsEmailAddress(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCompanyContactUsEmailAddress(_response);
            throw _response;
        });
    }

    protected processGetCompanyContactUsEmailAddress(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    isCommercialOwnerOccupiedActive(): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/static/iscommercialowneroccupiedactive";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsCommercialOwnerOccupiedActive(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsCommercialOwnerOccupiedActive(_response);
            throw _response;
        });
    }

    protected processIsCommercialOwnerOccupiedActive(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getReferralContactDetails(): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/static/getreferralcontactdetails";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetReferralContactDetails(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetReferralContactDetails(_response);
            throw _response;
        });
    }

    protected processGetReferralContactDetails(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getConnectNetworkOrgId(): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/static/getconnectnetworkorgid";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetConnectNetworkOrgId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetConnectNetworkOrgId(_response);
            throw _response;
        });
    }

    protected processGetConnectNetworkOrgId(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }
}

export class StreetAddressClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAddressByPostCode(postCode: string): ng.IPromise<PostalAddress> {
        let url_ = this.baseUrl + "/api/streetaddress/getAddressByPostCode?";
        if (postCode === undefined || postCode === null)
            throw new Error("The parameter 'postCode' must be defined and cannot be null.");
        else
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAddressByPostCode(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAddressByPostCode(_response);
            throw _response;
        });
    }

    protected processGetAddressByPostCode(response: any): ng.IPromise<PostalAddress> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostalAddress;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PostalAddress>(null as any);
    }

    /**
     * @return OK
     */
    getAddressList(searchTerm: string): ng.IPromise<AddressLookupDTO[]> {
        let url_ = this.baseUrl + "/api/streetaddress/getAddressList?";
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAddressList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAddressList(_response);
            throw _response;
        });
    }

    protected processGetAddressList(response: any): ng.IPromise<AddressLookupDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressLookupDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AddressLookupDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getPostCodeAddressList(postCodeId: string, searchTerm: string): ng.IPromise<AddressLookupDTO> {
        let url_ = this.baseUrl + "/api/streetaddress/getPostCodeAddressList?";
        if (postCodeId === undefined || postCodeId === null)
            throw new Error("The parameter 'postCodeId' must be defined and cannot be null.");
        else
            url_ += "postCodeId=" + encodeURIComponent("" + postCodeId) + "&";
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetPostCodeAddressList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetPostCodeAddressList(_response);
            throw _response;
        });
    }

    protected processGetPostCodeAddressList(response: any): ng.IPromise<AddressLookupDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressLookupDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<AddressLookupDTO>(null as any);
    }

    /**
     * @return OK
     */
    getFullAddress(addressId: string): ng.IPromise<PostalAddress> {
        let url_ = this.baseUrl + "/api/streetaddress/getFullAddress?";
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined and cannot be null.");
        else
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetFullAddress(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetFullAddress(_response);
            throw _response;
        });
    }

    protected processGetFullAddress(response: any): ng.IPromise<PostalAddress> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostalAddress;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PostalAddress>(null as any);
    }
}

export class TaskItemClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<TaskItem[]> {
        let url_ = this.baseUrl + "/api/taskitem/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<TaskItem[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskItem[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TaskItem[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<TaskItem> {
        let url_ = this.baseUrl + "/api/taskitem/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<TaskItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TaskItem>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/taskitem/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<TaskItemPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/taskitem/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<TaskItemPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskItemPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TaskItemPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<TaskItemPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/taskitem/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<TaskItemPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskItemPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TaskItemPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: TaskItem): ng.IPromise<TaskItem> {
        let url_ = this.baseUrl + "/api/taskitem/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<TaskItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TaskItem>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: TaskItem): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/taskitem/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: TaskItem[]): ng.IPromise<TaskItem[]> {
        let url_ = this.baseUrl + "/api/taskitem/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<TaskItem[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskItem[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TaskItem[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: TaskItem[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/taskitem/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/taskitem/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/taskitem/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class TaskItemCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous62> {
        let url_ = this.baseUrl + "/odata/TaskItemOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous62> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous62;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous62>(null as any);
    }

    /**
     * @return OK
     */
    post(body: TaskItemInsert): ng.IPromise<TaskItem> {
        let url_ = this.baseUrl + "/api/crud/taskitem/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<TaskItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TaskItem>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: TaskItemUpdate): ng.IPromise<TaskItem> {
        let url_ = this.baseUrl + "/api/crud/taskitem/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<TaskItem> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskItem;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TaskItem>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/taskitem/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/taskitem/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class TeamMemberClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<TeamMember[]> {
        let url_ = this.baseUrl + "/api/teammember/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<TeamMember[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamMember[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TeamMember[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<TeamMember> {
        let url_ = this.baseUrl + "/api/teammember/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<TeamMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TeamMember>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/teammember/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<TeamMemberPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/teammember/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<TeamMemberPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamMemberPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TeamMemberPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<TeamMemberPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/teammember/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<TeamMemberPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamMemberPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TeamMemberPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: TeamMember): ng.IPromise<TeamMember> {
        let url_ = this.baseUrl + "/api/teammember/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<TeamMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TeamMember>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: TeamMember): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/teammember/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: TeamMember[]): ng.IPromise<TeamMember[]> {
        let url_ = this.baseUrl + "/api/teammember/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<TeamMember[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamMember[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TeamMember[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: TeamMember[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/teammember/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/teammember/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/teammember/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class TeamMemberCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous63> {
        let url_ = this.baseUrl + "/odata/TeamMemberOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous63> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous63;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous63>(null as any);
    }

    /**
     * @return OK
     */
    post(body: TeamMemberInsert): ng.IPromise<TeamMember> {
        let url_ = this.baseUrl + "/api/crud/teammember/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<TeamMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TeamMember>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: TeamMemberUpdate): ng.IPromise<TeamMember> {
        let url_ = this.baseUrl + "/api/crud/teammember/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<TeamMember> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamMember;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<TeamMember>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/teammember/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/teammember/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ThirdPartyApiAccessKeyClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    list(): ng.IPromise<ThirdPartyApiAccessKey[]> {
        let url_ = this.baseUrl + "/api/thirdpartyapiaccesskey/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processList(_response);
            throw _response;
        });
    }

    protected processList(response: any): ng.IPromise<ThirdPartyApiAccessKey[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyApiAccessKey[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyApiAccessKey[]>(null as any);
    }

    /**
     * @return OK
     */
    fetch(id: number): ng.IPromise<ThirdPartyApiAccessKey> {
        let url_ = this.baseUrl + "/api/thirdpartyapiaccesskey/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFetch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFetch(_response);
            throw _response;
        });
    }

    protected processFetch(response: any): ng.IPromise<ThirdPartyApiAccessKey> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyApiAccessKey;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyApiAccessKey>(null as any);
    }

    /**
     * @return OK
     */
    count(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/thirdpartyapiaccesskey/count";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCount(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCount(_response);
            throw _response;
        });
    }

    protected processCount(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    listPaged(page: number | null, count?: number | null | undefined): ng.IPromise<ThirdPartyApiAccessKeyPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/thirdpartyapiaccesskey/paged?";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processListPaged(_response);
        }, (_response) => {
            if (_response.status)
                return this.processListPaged(_response);
            throw _response;
        });
    }

    protected processListPaged(response: any): ng.IPromise<ThirdPartyApiAccessKeyPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyApiAccessKeyPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyApiAccessKeyPageWithTotalCountDTO>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    pagedNeedle(needle: string, page: number | null, count?: number | null | undefined): ng.IPromise<ThirdPartyApiAccessKeyPageWithTotalCountDTO> {
        let url_ = this.baseUrl + "/api/thirdpartyapiaccesskey/pagedneedle?";
        if (needle === undefined || needle === null)
            throw new Error("The parameter 'needle' must be defined and cannot be null.");
        else
            url_ += "needle=" + encodeURIComponent("" + needle) + "&";
        if (page === undefined)
            throw new Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPagedNeedle(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPagedNeedle(_response);
            throw _response;
        });
    }

    protected processPagedNeedle(response: any): ng.IPromise<ThirdPartyApiAccessKeyPageWithTotalCountDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyApiAccessKeyPageWithTotalCountDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyApiAccessKeyPageWithTotalCountDTO>(null as any);
    }

    /**
     * @return OK
     */
    addUpdate(body: ThirdPartyApiAccessKey): ng.IPromise<ThirdPartyApiAccessKey> {
        let url_ = this.baseUrl + "/api/thirdpartyapiaccesskey/addupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdate(_response);
            throw _response;
        });
    }

    protected processAddUpdate(response: any): ng.IPromise<ThirdPartyApiAccessKey> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyApiAccessKey;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyApiAccessKey>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateReturnOnlyID(body: ThirdPartyApiAccessKey): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/thirdpartyapiaccesskey/addupdatereturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateReturnOnlyID(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateList(body: ThirdPartyApiAccessKey[]): ng.IPromise<ThirdPartyApiAccessKey[]> {
        let url_ = this.baseUrl + "/api/thirdpartyapiaccesskey/addupdatelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateList(_response);
            throw _response;
        });
    }

    protected processAddUpdateList(response: any): ng.IPromise<ThirdPartyApiAccessKey[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyApiAccessKey[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyApiAccessKey[]>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateListReturnOnlyID(body: ThirdPartyApiAccessKey[]): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/thirdpartyapiaccesskey/addupdatelistreturnonlyid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAddUpdateListReturnOnlyID(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAddUpdateListReturnOnlyID(_response);
            throw _response;
        });
    }

    protected processAddUpdateListReturnOnlyID(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return OK
     */
    remove(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/thirdpartyapiaccesskey/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemove(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemove(_response);
            throw _response;
        });
    }

    protected processRemove(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    markAsDeleted(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/thirdpartyapiaccesskey/markasdeleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkAsDeleted(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkAsDeleted(_response);
            throw _response;
        });
    }

    protected processMarkAsDeleted(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class ThirdPartyApiAccessKeyCrudClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) Filter the results
     * @param select (optional) Select specific fields
     * @param orderby (optional) Order the results
     * @param top (optional) Limit the number of results
     * @param skip (optional) Skip a number of results
     * @param count (optional) Include count of matching results
     * @param expand (optional) Expand related entities
     * @return OK
     */
    get(filter?: string | undefined, select?: string | undefined, orderby?: string | undefined, top?: number | undefined, skip?: number | undefined, count?: boolean | undefined, expand?: string | undefined): ng.IPromise<Anonymous64> {
        let url_ = this.baseUrl + "/odata/ThirdPartyApiAccessKeyOData?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json;odata.metadata=none;odata.streaming=true"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGet(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGet(_response);
            throw _response;
        });
    }

    protected processGet(response: any): ng.IPromise<Anonymous64> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous64;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Anonymous64>(null as any);
    }

    /**
     * @return OK
     */
    post(body: ThirdPartyApiAccessKeyInsert): ng.IPromise<ThirdPartyApiAccessKey> {
        let url_ = this.baseUrl + "/api/crud/thirdpartyapiaccesskey/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPost(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPost(_response);
            throw _response;
        });
    }

    protected processPost(response: any): ng.IPromise<ThirdPartyApiAccessKey> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyApiAccessKey;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyApiAccessKey>(null as any);
    }

    /**
     * @return OK
     */
    patch(body: ThirdPartyApiAccessKeyUpdate): ng.IPromise<ThirdPartyApiAccessKey> {
        let url_ = this.baseUrl + "/api/crud/thirdpartyapiaccesskey/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPatch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPatch(_response);
            throw _response;
        });
    }

    protected processPatch(response: any): ng.IPromise<ThirdPartyApiAccessKey> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThirdPartyApiAccessKey;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ThirdPartyApiAccessKey>(null as any);
    }

    /**
     * @return No Content
     */
    delete(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/crud/thirdpartyapiaccesskey/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelete(_response);
            throw _response;
        });
    }

    protected processDelete(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 204) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    softDelete(id: number): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/crud/thirdpartyapiaccesskey/softdelete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PATCH",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSoftDelete(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSoftDelete(_response);
            throw _response;
        });
    }

    protected processSoftDelete(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export class UserClient extends ClientBase {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        super();
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrentUser(): ng.IPromise<ApplicationUserDTO> {
        let url_ = this.baseUrl + "/api/users/me";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCurrentUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCurrentUser(_response);
            throw _response;
        });
    }

    protected processGetCurrentUser(response: any): ng.IPromise<ApplicationUserDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUserDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUserDTO>(null as any);
    }

    /**
     * @return OK
     */
    sendEventToHubspot(body: HubspotContactRequest): ng.IPromise<HubspotContact> {
        let url_ = this.baseUrl + "/api/users/sendeventtohubspot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendEventToHubspot(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendEventToHubspot(_response);
            throw _response;
        });
    }

    protected processSendEventToHubspot(response: any): ng.IPromise<HubspotContact> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HubspotContact;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<HubspotContact>(null as any);
    }

    /**
     * @return OK
     */
    getLicenseStatusText(selectedUserName: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/users/getlicensestatustext?";
        if (selectedUserName === undefined || selectedUserName === null)
            throw new Error("The parameter 'selectedUserName' must be defined and cannot be null.");
        else
            url_ += "selectedUserName=" + encodeURIComponent("" + selectedUserName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetLicenseStatusText(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetLicenseStatusText(_response);
            throw _response;
        });
    }

    protected processGetLicenseStatusText(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    clientRegistration(body: ClientRegistrationRequest): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/users/clientregistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processClientRegistration(_response);
        }, (_response) => {
            if (_response.status)
                return this.processClientRegistration(_response);
            throw _response;
        });
    }

    protected processClientRegistration(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    processUserRegistrationAndUpdate(id: number, newUser: boolean): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/users?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newUser === undefined || newUser === null)
            throw new Error("The parameter 'newUser' must be defined and cannot be null.");
        else
            url_ += "newUser=" + encodeURIComponent("" + newUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processProcessUserRegistrationAndUpdate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processProcessUserRegistrationAndUpdate(_response);
            throw _response;
        });
    }

    protected processProcessUserRegistrationAndUpdate(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    deleteUserAndPermissions(userName: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/users?";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDeleteUserAndPermissions(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDeleteUserAndPermissions(_response);
            throw _response;
        });
    }

    protected processDeleteUserAndPermissions(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    setBrokerOrgAdmin(brokerOrgId: number, organisationAdminId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/users/setBrokerOrgAdmin?";
        if (brokerOrgId === undefined || brokerOrgId === null)
            throw new Error("The parameter 'brokerOrgId' must be defined and cannot be null.");
        else
            url_ += "brokerOrgId=" + encodeURIComponent("" + brokerOrgId) + "&";
        if (organisationAdminId === undefined || organisationAdminId === null)
            throw new Error("The parameter 'organisationAdminId' must be defined and cannot be null.");
        else
            url_ += "organisationAdminId=" + encodeURIComponent("" + organisationAdminId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSetBrokerOrgAdmin(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSetBrokerOrgAdmin(_response);
            throw _response;
        });
    }

    protected processSetBrokerOrgAdmin(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    registerBrokerUsers(selectedUserName: string, body: ApplicationUser[]): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/users/registerbrokerusers?";
        if (selectedUserName === undefined || selectedUserName === null)
            throw new Error("The parameter 'selectedUserName' must be defined and cannot be null.");
        else
            url_ += "selectedUserName=" + encodeURIComponent("" + selectedUserName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRegisterBrokerUsers(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRegisterBrokerUsers(_response);
            throw _response;
        });
    }

    protected processRegisterBrokerUsers(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getCurrentUserPermissionForProductSearch(): ng.IPromise<GetCurrentUserPermissionForProductSearchResponse> {
        let url_ = this.baseUrl + "/api/users/getcurrentuserpermissionforproductsearch";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCurrentUserPermissionForProductSearch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCurrentUserPermissionForProductSearch(_response);
            throw _response;
        });
    }

    protected processGetCurrentUserPermissionForProductSearch(response: any): ng.IPromise<GetCurrentUserPermissionForProductSearchResponse> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCurrentUserPermissionForProductSearchResponse;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<GetCurrentUserPermissionForProductSearchResponse>(null as any);
    }

    /**
     * @return OK
     */
    getUserDetailsByEmailIfExists(email: string): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/users/getuserdetailsdyemailifexists?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetUserDetailsByEmailIfExists(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetUserDetailsByEmailIfExists(_response);
            throw _response;
        });
    }

    protected processGetUserDetailsByEmailIfExists(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    searchByEmail(searchTerm: string): ng.IPromise<ApplicationUser[]> {
        let url_ = this.baseUrl + "/api/users/searchbyemail?";
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSearchByEmail(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSearchByEmail(_response);
            throw _response;
        });
    }

    protected processSearchByEmail(response: any): ng.IPromise<ApplicationUser[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser[]>(null as any);
    }

    /**
     * @return OK
     */
    getUsersByLenderId(lenderId: number): ng.IPromise<ApplicationUser[]> {
        let url_ = this.baseUrl + "/api/users/getusersbylenderid?";
        if (lenderId === undefined || lenderId === null)
            throw new Error("The parameter 'lenderId' must be defined and cannot be null.");
        else
            url_ += "lenderId=" + encodeURIComponent("" + lenderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetUsersByLenderId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetUsersByLenderId(_response);
            throw _response;
        });
    }

    protected processGetUsersByLenderId(response: any): ng.IPromise<ApplicationUser[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser[]>(null as any);
    }

    /**
     * @return OK
     */
    getIntroducees(userId: number): ng.IPromise<ApplicationUser[]> {
        let url_ = this.baseUrl + "/api/users/introducees?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetIntroducees(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetIntroducees(_response);
            throw _response;
        });
    }

    protected processGetIntroducees(response: any): ng.IPromise<ApplicationUser[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser[]>(null as any);
    }

    /**
     * @return OK
     */
    getCurrentUserAutofill(): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/users/getcurrentuserautofill";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCurrentUserAutofill(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCurrentUserAutofill(_response);
            throw _response;
        });
    }

    protected processGetCurrentUserAutofill(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sendTestEmailToUsers(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/users/sendtestemailtousers";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendTestEmailToUsers(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendTestEmailToUsers(_response);
            throw _response;
        });
    }

    protected processSendTestEmailToUsers(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    hasCurrentUserGotEnterpriseLicense(): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/users/hascurrentusergotenterpriselicense";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processHasCurrentUserGotEnterpriseLicense(_response);
        }, (_response) => {
            if (_response.status)
                return this.processHasCurrentUserGotEnterpriseLicense(_response);
            throw _response;
        });
    }

    protected processHasCurrentUserGotEnterpriseLicense(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    registerEnterpriseUserAndSaveShortlisteResults(body: RegisterUserAndSaveShortListedResultsRequest): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/users/registerenterpriseuserandsaveshortlisteresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRegisterEnterpriseUserAndSaveShortlisteResults(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRegisterEnterpriseUserAndSaveShortlisteResults(_response);
            throw _response;
        });
    }

    protected processRegisterEnterpriseUserAndSaveShortlisteResults(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getUserByUserId(userId: number): ng.IPromise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/users/getuserbyuserid?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetUserByUserId(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetUserByUserId(_response);
            throw _response;
        });
    }

    protected processGetUserByUserId(response: any): ng.IPromise<ApplicationUser> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser>(null as any);
    }

    /**
     * @return OK
     */
    getUserSummariesForBrokerOrAdmin(): ng.IPromise<UserSimpleDTO[]> {
        let url_ = this.baseUrl + "/api/users/getusersummariesforbrokeroradmin";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetUserSummariesForBrokerOrAdmin(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetUserSummariesForBrokerOrAdmin(_response);
            throw _response;
        });
    }

    protected processGetUserSummariesForBrokerOrAdmin(response: any): ng.IPromise<UserSimpleDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSimpleDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<UserSimpleDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getCurrentUserLender(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/users/getcurrentuserlender";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCurrentUserLender(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCurrentUserLender(_response);
            throw _response;
        });
    }

    protected processGetCurrentUserLender(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    assignTrialLicenseToUser(licenseEndDate: string, selectedUserId: number, body: AppPackagePricing[]): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/users/assigntriallicensetouser?";
        if (licenseEndDate === undefined || licenseEndDate === null)
            throw new Error("The parameter 'licenseEndDate' must be defined and cannot be null.");
        else
            url_ += "licenseEndDate=" + encodeURIComponent("" + licenseEndDate) + "&";
        if (selectedUserId === undefined || selectedUserId === null)
            throw new Error("The parameter 'selectedUserId' must be defined and cannot be null.");
        else
            url_ += "selectedUserId=" + encodeURIComponent("" + selectedUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processAssignTrialLicenseToUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processAssignTrialLicenseToUser(_response);
            throw _response;
        });
    }

    protected processAssignTrialLicenseToUser(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sendTestEmail(recipientEmailAddress: string, emailSubject: string, emailMessage: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/users/sendtestemail?";
        if (recipientEmailAddress === undefined || recipientEmailAddress === null)
            throw new Error("The parameter 'recipientEmailAddress' must be defined and cannot be null.");
        else
            url_ += "recipientEmailAddress=" + encodeURIComponent("" + recipientEmailAddress) + "&";
        if (emailSubject === undefined || emailSubject === null)
            throw new Error("The parameter 'emailSubject' must be defined and cannot be null.");
        else
            url_ += "emailSubject=" + encodeURIComponent("" + emailSubject) + "&";
        if (emailMessage === undefined || emailMessage === null)
            throw new Error("The parameter 'emailMessage' must be defined and cannot be null.");
        else
            url_ += "emailMessage=" + encodeURIComponent("" + emailMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendTestEmail(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendTestEmail(_response);
            throw _response;
        });
    }

    protected processSendTestEmail(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getOrganisationNonAdminUsers(orgId: number): ng.IPromise<ApplicationUser[]> {
        let url_ = this.baseUrl + "/api/users/getorganisationnonadminusers?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined and cannot be null.");
        else
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOrganisationNonAdminUsers(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOrganisationNonAdminUsers(_response);
            throw _response;
        });
    }

    protected processGetOrganisationNonAdminUsers(response: any): ng.IPromise<ApplicationUser[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationUser[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ApplicationUser[]>(null as any);
    }

    /**
     * @return OK
     */
    getCurrentUserLicenseData(): ng.IPromise<LicenseDataDTO> {
        let url_ = this.baseUrl + "/api/users/getcurrentuserlicensedata";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCurrentUserLicenseData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCurrentUserLicenseData(_response);
            throw _response;
        });
    }

    protected processGetCurrentUserLicenseData(response: any): ng.IPromise<LicenseDataDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseDataDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LicenseDataDTO>(null as any);
    }

    /**
     * @return OK
     */
    getLenderAppraisals(): ng.IPromise<LenderAppraisal[]> {
        let url_ = this.baseUrl + "/api/users/getlenderappraisals";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetLenderAppraisals(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetLenderAppraisals(_response);
            throw _response;
        });
    }

    protected processGetLenderAppraisals(response: any): ng.IPromise<LenderAppraisal[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LenderAppraisal[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LenderAppraisal[]>(null as any);
    }

    /**
     * @return OK
     */
    resetForgottenPassword(userName: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/users/passwordreset?";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processResetForgottenPassword(_response);
        }, (_response) => {
            if (_response.status)
                return this.processResetForgottenPassword(_response);
            throw _response;
        });
    }

    protected processResetForgottenPassword(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    isRegisteredUser(email: string): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/users/isregistereduser?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsRegisteredUser(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsRegisteredUser(_response);
            throw _response;
        });
    }

    protected processIsRegisteredUser(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }
}

export enum ALItemTypeEnum {
    Other = 0,
    ResidentialProperty = 1,
    BTLProperty = 2,
    CommercialProperty = 3,
    OverseasProperty = 4,
    CashDeposits = 5,
    StocksShares = 6,
    VehicleBoat = 7,
    BusinessEquipment = 8,
    ArtJewellryAntique = 9,
    ResidentialPropertyLoan = 30,
    BTLPropertyLoan = 31,
    CommercialPropertyLoan = 32,
    OverseasPropertyLoan = 33,
    HPLease = 34,
    Overdraft = 35,
    OtherLoan = 36,
    PersonalGuarantee = 60,
}

export enum ALTypeEnum {
    Asset = 0,
    Liability = 1,
    PersonalGuarantee = 2,
}

export interface Account {
    emailAddressesOfAdmin: string;
    accountName: string;
    senderNameInEmail: string;
    server: string;
    port: number;
    user: string;
    password: string;
    smsUser: string;
    smsPassword: string;
    smsAccount: boolean;
    primaryEmailAccount: boolean;
    primarySMSAccount: boolean;
    nameOrTelNumberTextFrom: string;
    activebrandingAccount: boolean;
    webSiteTabTitle: string;
    webTitle: string;
    enableEmailTracking: boolean;
    runEmailAndTextsInTestMode: boolean;
    testEmailAddresses: string;
    useHangfire: boolean;
    webTitleImage: string;
    loginUserFgColour: string;
    loginUserBgColour: string;
    dashBoardItemFgColour: string;
    dashBoardItemBgColour: string;
    dashBoardStripeBgColour: string;
    saveBarFgColour: string;
    emailAddress: string;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** Account without database generated properties */
export interface AccountInsert {
    emailAddressesOfAdmin?: string;
    accountName?: string;
    senderNameInEmail?: string;
    server?: string;
    port?: number;
    user?: string;
    password?: string;
    smsUser?: string;
    smsPassword?: string;
    smsAccount?: boolean;
    primaryEmailAccount?: boolean;
    primarySMSAccount?: boolean;
    nameOrTelNumberTextFrom?: string;
    activebrandingAccount?: boolean;
    webSiteTabTitle?: string;
    webTitle?: string;
    enableEmailTracking?: boolean;
    runEmailAndTextsInTestMode?: boolean;
    testEmailAddresses?: string;
    useHangfire?: boolean;
    webTitleImage?: string;
    loginUserFgColour?: string;
    loginUserBgColour?: string;
    dashBoardItemFgColour?: string;
    dashBoardItemBgColour?: string;
    dashBoardStripeBgColour?: string;
    saveBarFgColour?: string;
    emailAddress?: string;
}

export interface AccountPageWithTotalCountDTO {
    list?: Account[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** Account with all properties optional except PKs */
export interface AccountUpdate {
    emailAddressesOfAdmin?: string;
    accountName?: string;
    senderNameInEmail?: string;
    server?: string;
    port?: number;
    user?: string;
    password?: string;
    smsUser?: string;
    smsPassword?: string;
    smsAccount?: boolean;
    primaryEmailAccount?: boolean;
    primarySMSAccount?: boolean;
    nameOrTelNumberTextFrom?: string;
    activebrandingAccount?: boolean;
    webSiteTabTitle?: string;
    webTitle?: string;
    enableEmailTracking?: boolean;
    runEmailAndTextsInTestMode?: boolean;
    testEmailAddresses?: string;
    useHangfire?: boolean;
    webTitleImage?: string;
    loginUserFgColour?: string;
    loginUserBgColour?: string;
    dashBoardItemFgColour?: string;
    dashBoardItemBgColour?: string;
    dashBoardStripeBgColour?: string;
    saveBarFgColour?: string;
    emailAddress?: string;
    id: number;
}

/** Account without PKs and database generated properties and with all properties optional */
export interface AccountUpdateWithoutPKs {
    emailAddressesOfAdmin?: string;
    accountName?: string;
    senderNameInEmail?: string;
    server?: string;
    port?: number;
    user?: string;
    password?: string;
    smsUser?: string;
    smsPassword?: string;
    smsAccount?: boolean;
    primaryEmailAccount?: boolean;
    primarySMSAccount?: boolean;
    nameOrTelNumberTextFrom?: string;
    activebrandingAccount?: boolean;
    webSiteTabTitle?: string;
    webTitle?: string;
    enableEmailTracking?: boolean;
    runEmailAndTextsInTestMode?: boolean;
    testEmailAddresses?: string;
    useHangfire?: boolean;
    webTitleImage?: string;
    loginUserFgColour?: string;
    loginUserBgColour?: string;
    dashBoardItemFgColour?: string;
    dashBoardItemBgColour?: string;
    dashBoardStripeBgColour?: string;
    saveBarFgColour?: string;
    emailAddress?: string;
}

export interface AddressLookupDTO {
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    addressLine4?: string;
    postCode?: string;
    id?: string;
    isPostCode?: boolean;
}

export enum AppClaimsEnum {
    AppFeature_Add = 0,
    AppFeature_Delete = 1,
    ApplicationUser_Add = 2,
    ApplicationUser_Delete = 3,
    ApplicationUserApplicationUserGroup_Add = 4,
    ApplicationUserApplicationUserGroup_Delete = 5,
    ApplicationUserGroup_Add = 6,
    ApplicationUserGroup_Delete = 7,
    ClaimEnumsInApplicationUser_Add = 8,
    ClaimEnumsInApplicationUser_Delete = 9,
    ClaimEnumsInApplicationUserGroup_Add = 10,
    ClaimEnumsInApplicationUserGroup_Delete = 11,
    ClaimEnumsInClaimGroup_Add = 12,
    ClaimEnumsInClaimGroup_Delete = 13,
    ClaimGroup_Add = 14,
    ClaimGroup_Delete = 15,
    ClaimGroupsInApplicationUser_Add = 16,
    ClaimGroupsInApplicationUser_Delete = 17,
    ClaimGroupsInApplicationUserGroup_Add = 18,
    ClaimGroupsInApplicationUserGroup_Delete = 19,
    ClaimGroupsInClaimGroup_Add = 20,
    ClaimGroupsInClaimGroup_Delete = 21,
    LoginRequest_Add = 22,
    LoginRequest_Delete = 23,
    WelcomeRequest_Add = 24,
    WelcomeRequest_Delete = 25,
    Admin_AllowRead = 26,
    Broker_AllowRead = 27,
    Client_AllowRead = 28,
    Introducer_AllowRead = 29,
    Lender_AllowRead = 30,
    Admin = 31,
    Account_Add = 32,
    Account_Delete = 33,
    AppPackage_Add = 34,
    AppPackage_Delete = 35,
    AppPackageFeature_Add = 36,
    AppPackageFeature_Delete = 37,
    AppPackagePricing_Add = 38,
    AppPackagePricing_Delete = 39,
    AppUserPermission_Add = 40,
    AppUserPermission_Delete = 41,
    AssetLiabilityItem_Add = 42,
    AssetLiabilityItem_Delete = 43,
    AuditLog_Add = 44,
    AuditLog_Delete = 45,
    BrickflowEventLog_Add = 46,
    BrickflowEventLog_Delete = 47,
    BridgingDeal_Add = 48,
    BridgingDeal_Delete = 49,
    Case_Add = 50,
    Case_Delete = 51,
    CaseLender_Add = 52,
    CaseLender_Delete = 53,
    CaseLenderMessage_Add = 54,
    CaseLenderMessage_Delete = 55,
    CaseLenderMessageTrack_Add = 56,
    CaseLenderMessageTrack_Delete = 57,
    CaseMember_Add = 58,
    CaseMember_Delete = 59,
    CaseNote_Add = 60,
    CaseNote_Delete = 61,
    Client_Add = 62,
    Client_Delete = 63,
    CommercialDeal_Add = 64,
    CommercialDeal_Delete = 65,
    ComparableProperty_Add = 66,
    ComparableProperty_Delete = 67,
    DataMultiOwner_ApplicationUser_Deal_Add = 68,
    DataMultiOwner_ApplicationUser_Deal_Delete = 69,
    DataMultiOwner_ApplicationUser_DealFileAttachment_Add = 70,
    DataMultiOwner_ApplicationUser_DealFileAttachment_Delete = 71,
    DataMultiOwner_ApplicationUser_DealLender_Add = 72,
    DataMultiOwner_ApplicationUser_DealLender_Delete = 73,
    DataMultiOwner_ApplicationUser_DealNote_Add = 74,
    DataMultiOwner_ApplicationUser_DealNote_Delete = 75,
    DataMultiOwner_ApplicationUser_DevelopmentInput_Add = 76,
    DataMultiOwner_ApplicationUser_DevelopmentInput_Delete = 77,
    DataMultiOwner_ApplicationUser_DevelopmentInputSchedule_Add = 78,
    DataMultiOwner_ApplicationUser_DevelopmentInputSchedule_Delete = 79,
    DataMultiOwner_ApplicationUser_DevelopmentTrackRecord_Add = 80,
    DataMultiOwner_ApplicationUser_DevelopmentTrackRecord_Delete = 81,
    DataMultiOwner_ApplicationUser_FeedBack_Add = 82,
    DataMultiOwner_ApplicationUser_FeedBack_Delete = 83,
    DataMultiOwner_ApplicationUser_FileAttachment_Add = 84,
    DataMultiOwner_ApplicationUser_FileAttachment_Delete = 85,
    DataMultiOwner_ApplicationUser_Introducer_Add = 86,
    DataMultiOwner_ApplicationUser_Introducer_Delete = 87,
    DataMultiOwner_ApplicationUser_Lender_Add = 88,
    DataMultiOwner_ApplicationUser_Lender_Delete = 89,
    DataMultiOwner_ApplicationUser_LenderResult_Add = 90,
    DataMultiOwner_ApplicationUser_LenderResult_Delete = 91,
    DataMultiOwner_ApplicationUser_Organisation_Add = 92,
    DataMultiOwner_ApplicationUser_Organisation_Delete = 93,
    DataMultiOwner_ApplicationUserGroup_Deal_Add = 94,
    DataMultiOwner_ApplicationUserGroup_Deal_Delete = 95,
    DataMultiOwner_ApplicationUserGroup_DealFileAttachment_Add = 96,
    DataMultiOwner_ApplicationUserGroup_DealFileAttachment_Delete = 97,
    DataMultiOwner_ApplicationUserGroup_DealLender_Add = 98,
    DataMultiOwner_ApplicationUserGroup_DealLender_Delete = 99,
    DataMultiOwner_ApplicationUserGroup_DealNote_Add = 100,
    DataMultiOwner_ApplicationUserGroup_DealNote_Delete = 101,
    DataMultiOwner_ApplicationUserGroup_DevelopmentInput_Add = 102,
    DataMultiOwner_ApplicationUserGroup_DevelopmentInput_Delete = 103,
    DataMultiOwner_ApplicationUserGroup_DevelopmentInputSchedule_Add = 104,
    DataMultiOwner_ApplicationUserGroup_DevelopmentInputSchedule_Delete = 105,
    DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecord_Add = 106,
    DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecord_Delete = 107,
    DataMultiOwner_ApplicationUserGroup_FeedBack_Add = 108,
    DataMultiOwner_ApplicationUserGroup_FeedBack_Delete = 109,
    DataMultiOwner_ApplicationUserGroup_FileAttachment_Add = 110,
    DataMultiOwner_ApplicationUserGroup_FileAttachment_Delete = 111,
    DataMultiOwner_ApplicationUserGroup_Introducer_Add = 112,
    DataMultiOwner_ApplicationUserGroup_Introducer_Delete = 113,
    DataMultiOwner_ApplicationUserGroup_Lender_Add = 114,
    DataMultiOwner_ApplicationUserGroup_Lender_Delete = 115,
    DataMultiOwner_ApplicationUserGroup_LenderResult_Add = 116,
    DataMultiOwner_ApplicationUserGroup_LenderResult_Delete = 117,
    DataMultiOwner_ApplicationUserGroup_Organisation_Add = 118,
    DataMultiOwner_ApplicationUserGroup_Organisation_Delete = 119,
    Deal_Add = 120,
    Deal_Delete = 121,
    DealClient_Add = 122,
    DealClient_Delete = 123,
    DealCompletion_Add = 126,
    DealCompletion_Delete = 127,
    DealFileAttachment_Add = 130,
    DealFileAttachment_Delete = 131,
    DealLender_Add = 132,
    DealLender_Delete = 133,
    DealLenderMessage_Add = 134,
    DealLenderMessage_Delete = 135,
    DealLenderMessageTrack_Add = 136,
    DealLenderMessageTrack_Delete = 137,
    DealNote_Add = 138,
    DealNote_Delete = 139,
    DealSchedule_Add = 140,
    DealSchedule_Delete = 141,
    DeveloperExitFinanceDevScheduleInput_Add = 142,
    DeveloperExitFinanceDevScheduleInput_Delete = 143,
    DeveloperExitFinanceLoanInput_Add = 144,
    DeveloperExitFinanceLoanInput_Delete = 145,
    DevelopmentFinanceDeal_Add = 148,
    DevelopmentFinanceDeal_Delete = 149,
    DevelopmentInput_Add = 150,
    DevelopmentInput_Delete = 151,
    DevelopmentInputSchedule_Add = 152,
    DevelopmentInputSchedule_Delete = 153,
    DevelopmentInputWithNoLogin_Add = 154,
    DevelopmentInputWithNoLogin_Delete = 155,
    DevelopmentTrackRecord_Add = 156,
    DevelopmentTrackRecord_Delete = 157,
    ExternalLinks_Add = 158,
    ExternalLinks_Delete = 159,
    FeedBack_Add = 160,
    FeedBack_Delete = 161,
    FileAttachment_Add = 162,
    FileAttachment_Delete = 163,
    Introducer_Add = 166,
    Introducer_Delete = 167,
    Invite_Add = 168,
    Invite_Delete = 169,
    Lender_Add = 170,
    Lender_Delete = 171,
    LenderOrganisation_Add = 172,
    LenderOrganisation_Delete = 173,
    LenderResult_Add = 174,
    LenderResult_Delete = 175,
    LicenseAppPackage_Add = 176,
    LicenseAppPackage_Delete = 177,
    LicenseMaster_Add = 178,
    LicenseMaster_Delete = 179,
    Organisation_Add = 180,
    Organisation_Delete = 181,
    OrganisationLink_Add = 182,
    OrganisationLink_Delete = 183,
    PostcodeLocation_Add = 184,
    PostcodeLocation_Delete = 185,
    Product_Add = 186,
    Product_Delete = 187,
    ProductRate_Add = 188,
    ProductRate_Delete = 189,
    Profile_Add = 190,
    Profile_Delete = 191,
    ProfileAssetLiabilityItem_Add = 192,
    ProfileAssetLiabilityItem_Delete = 193,
    ProjectOwnership_Add = 194,
    ProjectOwnership_Delete = 195,
    Qualifications_Add = 196,
    Qualifications_Delete = 197,
    ScheduledJobLog_Add = 198,
    ScheduledJobLog_Delete = 199,
    SelectedResult_Add = 200,
    SelectedResult_Delete = 201,
    SnapshotLender_Add = 202,
    SnapshotLender_Delete = 203,
    SnapshotProduct_Add = 204,
    SnapshotProduct_Delete = 205,
    SnapshotSearchResult_Add = 206,
    SnapshotSearchResult_Delete = 207,
    TaskItem_Add = 208,
    TaskItem_Delete = 209,
    TeamMember_Add = 210,
    TeamMember_Delete = 211,
    ThirdPartyApiAccessKey_Add = 212,
    ThirdPartyApiAccessKey_Delete = 213,
    ProfileQualification_Add = 214,
    ProfileQualification_Delete = 215,
    DataMultiOwner_ApplicationUser_Case_Add = 216,
    DataMultiOwner_ApplicationUser_Case_Delete = 217,
    DataMultiOwner_ApplicationUserGroup_Case_Add = 218,
    DataMultiOwner_ApplicationUserGroup_Case_Delete = 219,
    GlobalDataAdmin = 220,
    DataMultiOwner_ApplicationUser_CaseLender_Add = 221,
    DataMultiOwner_ApplicationUser_CaseLender_Delete = 222,
    DataMultiOwner_ApplicationUserGroup_CaseLender_Add = 223,
    DataMultiOwner_ApplicationUserGroup_CaseLender_Delete = 224,
    ExportProductUnitTest = 225,
}

export interface AppFeature {
    internalName: string;
    onScreenName: string;
    featureType: FeatureTypeEnum;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** AppFeature without database generated properties */
export interface AppFeatureInsert {
    internalName?: string;
    onScreenName?: string;
    featureType?: FeatureTypeEnum;
}

export interface AppFeaturePageWithTotalCountDTO {
    list?: AppFeature[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** AppFeature with all properties optional except PKs */
export interface AppFeatureUpdate {
    internalName?: string;
    onScreenName?: string;
    featureType?: FeatureTypeEnum;
    id: number;
}

/** AppFeature without PKs and database generated properties and with all properties optional */
export interface AppFeatureUpdateWithoutPKs {
    internalName?: string;
    onScreenName?: string;
    featureType?: FeatureTypeEnum;
}

export interface AppPackage {
    internalName: string;
    onScreenName: string;
    isInternalOnly: boolean;
    canDelete: boolean;
    promotionalTextHeading: string;
    promotionalTextDetail: string;
    roles: RoleFlagEnum;
    appPackagePricings?: AppPackagePricing[];
    isLeadGenerator: boolean;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

export interface AppPackageFeature {
    appPackage?: AppPackage;
    appFeature?: AppFeature;
    quantity: number;
    id: number;
    appPackageId: number;
    appFeatureId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** AppPackageFeature without database generated properties */
export interface AppPackageFeatureInsert {
    appPackage: AppPackageInsert | null;
    appFeature: AppFeatureInsert | null;
    quantity?: number;
    appPackageId: number;
    appFeatureId: number;
}

export interface AppPackageFeaturePageWithTotalCountDTO {
    list?: AppPackageFeature[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** AppPackageFeature with all properties optional except PKs */
export interface AppPackageFeatureUpdate {
    appPackage?: AppPackageUpdateWithoutPKs | null;
    appFeature?: AppFeatureUpdateWithoutPKs | null;
    quantity?: number;
    id: number;
    appPackageId?: number;
    appFeatureId?: number;
}

/** AppPackageFeature without PKs and database generated properties and with all properties optional */
export interface AppPackageFeatureUpdateWithoutPKs {
    appPackage?: AppPackageUpdateWithoutPKs | null;
    appFeature?: AppFeatureUpdateWithoutPKs | null;
    quantity?: number;
    appPackageId?: number;
    appFeatureId?: number;
}

/** AppPackage without database generated properties */
export interface AppPackageInsert {
    internalName?: string;
    onScreenName?: string;
    isInternalOnly?: boolean;
    canDelete?: boolean;
    promotionalTextHeading?: string;
    promotionalTextDetail?: string;
    roles?: RoleFlagEnum;
    appPackagePricings?: AppPackagePricingInsert[];
    isLeadGenerator?: boolean;
}

export interface AppPackagePageWithTotalCountDTO {
    list?: AppPackage[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface AppPackagePricing {
    appPackage?: AppPackage;
    canDelete: boolean;
    pricingFrequency: PricingFrequencyEnum;
    priceAmount: number;
    roles: RoleFlagEnum;
    freeDurationDays: number;
    quantity: number;
    startDateTime: Date;
    endDateTime: Date | null;
    contractLength: ContractLengthEnum;
    id: number;
    appPackageId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** AppPackagePricing without database generated properties */
export interface AppPackagePricingInsert {
    appPackage: AppPackageInsert | null;
    canDelete?: boolean;
    pricingFrequency?: PricingFrequencyEnum;
    priceAmount?: number;
    roles?: RoleFlagEnum;
    freeDurationDays?: number;
    quantity?: number;
    startDateTime?: Date;
    endDateTime?: Date | null;
    contractLength?: ContractLengthEnum;
    appPackageId: number;
}

export interface AppPackagePricingPageWithTotalCountDTO {
    list?: AppPackagePricing[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** AppPackagePricing with all properties optional except PKs */
export interface AppPackagePricingUpdate {
    appPackage?: AppPackageUpdateWithoutPKs | null;
    canDelete?: boolean;
    pricingFrequency?: PricingFrequencyEnum;
    priceAmount?: number;
    roles?: RoleFlagEnum;
    freeDurationDays?: number;
    quantity?: number;
    startDateTime?: Date;
    endDateTime?: Date | null;
    contractLength?: ContractLengthEnum;
    id: number;
    appPackageId?: number;
}

/** AppPackagePricing without PKs and database generated properties and with all properties optional */
export interface AppPackagePricingUpdateWithoutPKs {
    appPackage?: AppPackageUpdateWithoutPKs | null;
    canDelete?: boolean;
    pricingFrequency?: PricingFrequencyEnum;
    priceAmount?: number;
    roles?: RoleFlagEnum;
    freeDurationDays?: number;
    quantity?: number;
    startDateTime?: Date;
    endDateTime?: Date | null;
    contractLength?: ContractLengthEnum;
    appPackageId?: number;
}

/** AppPackage with all properties optional except PKs */
export interface AppPackageUpdate {
    internalName?: string;
    onScreenName?: string;
    isInternalOnly?: boolean;
    canDelete?: boolean;
    promotionalTextHeading?: string;
    promotionalTextDetail?: string;
    roles?: RoleFlagEnum;
    appPackagePricings?: AppPackagePricingUpdate[];
    isLeadGenerator?: boolean;
    id: number;
}

/** AppPackage without PKs and database generated properties and with all properties optional */
export interface AppPackageUpdateWithoutPKs {
    internalName?: string;
    onScreenName?: string;
    isInternalOnly?: boolean;
    canDelete?: boolean;
    promotionalTextHeading?: string;
    promotionalTextDetail?: string;
    roles?: RoleFlagEnum;
    appPackagePricings?: AppPackagePricingUpdate[];
    isLeadGenerator?: boolean;
}

export interface AppUserPermission {
    applicationUser?: ApplicationUser;
    appFeature?: AppFeature;
    licenseAppPackage?: LicenseAppPackage;
    id: number;
    applicationUserId: number;
    appFeatureId: number;
    licenseAppPackageId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** AppUserPermission without database generated properties */
export interface AppUserPermissionInsert {
    applicationUser: ApplicationUserInsert | null;
    appFeature: AppFeatureInsert | null;
    licenseAppPackage: LicenseAppPackageInsert | null;
    applicationUserId: number;
    appFeatureId: number;
    licenseAppPackageId: number;
}

export interface AppUserPermissionPageWithTotalCountDTO {
    list?: AppUserPermission[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** AppUserPermission with all properties optional except PKs */
export interface AppUserPermissionUpdate {
    applicationUser?: ApplicationUserUpdateWithoutPKs | null;
    appFeature?: AppFeatureUpdateWithoutPKs | null;
    licenseAppPackage?: LicenseAppPackageUpdateWithoutPKs | null;
    id: number;
    applicationUserId?: number;
    appFeatureId?: number;
    licenseAppPackageId?: number;
}

/** AppUserPermission without PKs and database generated properties and with all properties optional */
export interface AppUserPermissionUpdateWithoutPKs {
    applicationUser?: ApplicationUserUpdateWithoutPKs | null;
    appFeature?: AppFeatureUpdateWithoutPKs | null;
    licenseAppPackage?: LicenseAppPackageUpdateWithoutPKs | null;
    applicationUserId?: number;
    appFeatureId?: number;
    licenseAppPackageId?: number;
}

export enum ApplicantRoleEnum {
    Developer = 0,
    Introducer = 1,
    Broker = 2,
    Lender = 3,
    Agent = 4,
    Other = 5,
}

export interface ApplicationUser {
    introducerId: number | null;
    introducer?: Introducer | null;
    referrer: ReferrerEnum;
    referrerOther: string | null;
    location: LocationEnum;
    applicantDefinedRole: ApplicantRoleEnum;
    applicantDefinedRoleOther: string | null;
    agreedToTermsAndPP: boolean;
    lenderResultsTermsAgreed: boolean;
    temporaryAccount: boolean;
    newUserEmailJourneyStarted: boolean;
    lastLoginDate: Date | null;
    applicantDefinedRoleIntroducer: IntroducerTypeEnum | null;
    organisation?: Organisation | null;
    organisationId: number | null;
    isOrganisationAdmin: boolean;
    defaultBrokerOrganisation?: Organisation | null;
    defaultBrokerOrganisationId: number | null;
    profilePictureUrl: string | null;
    roleDescription: string | null;
    miniBio: string | null;
    organisationReferral?: Organisation | null;
    organisationReferralId: number | null;
    displayOrganisationAdminWelcomepage: boolean;
    licenseMaster?: LicenseMaster | null;
    licenseMasterId: number | null;
    isLegacyUser: boolean;
    representative: string | null;
    securityStamp: string | null;
    level: number;
    firstName: string | null;
    lastName: string | null;
    profile?: Profile | null;
    profileId: number | null;
    lenderId: number | null;
    lender?: Lender | null;
    lenderProductTypes: LenderProductTypeEnum | null;
    isLenderAdmin: boolean;
    showAutofill: boolean;
    sendLenderInsightsEmail: boolean;
    fullName: string;
    emailOptOut: boolean;
    lenderProductTypesText: string;
    hasActiveSubscription: boolean;
    hasActiveEnterpriseLicense: boolean;
    brokerDeals?: Deal[];
    brokerDevelopmentInputs?: DevelopmentInputAbstract[];
    connectDeals?: Deal[];
    lenderDeals?: Deal[];
    userDevelopmentInputs?: DevelopmentInputAbstract[];
    userLender?: Lender[];
    introducerCode: string | null;
    subscriptionStatus: LicenseMasterStatusEnum;
    orgUniqueRef: string | null;
    dealClientUniqueRef: string | null;
    inviteCode: string | null;
    isConnectUser: boolean;
    orgCode: string | null;
    features: string[] | null;
    id: number;
    oidcId: string;
    name: string;
    userName: string;
    email: string | null;
    phoneNumber: string | null;
    isEnabled: boolean;
    failedLoginAttempts: number;
    applicationUserApplicationUserGroups?: ApplicationUserApplicationUserGroup[];
    claimEnumsInApplicationUsers?: ClaimEnumsInApplicationUser[];
    claimGroupsInApplicationUsers?: ClaimGroupsInApplicationUser[];
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

export interface ApplicationUserApplicationUserGroup {
    id: number;
    name: string | null;
    isDeleted: boolean;
    applicationUser?: ApplicationUser | null;
    applicationUserId: number;
    applicationUserGroup?: ApplicationUserGroup | null;
    applicationUserGroupId: number;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

/** ApplicationUserApplicationUserGroup without database generated properties */
export interface ApplicationUserApplicationUserGroupInsert {
    name?: string | null;
    applicationUser?: ApplicationUserInsert | null;
    applicationUserId?: number;
    applicationUserGroup?: ApplicationUserGroupInsert | null;
    applicationUserGroupId?: number;
}

/** ApplicationUserApplicationUserGroup with all properties optional except PKs */
export interface ApplicationUserApplicationUserGroupUpdate {
    id: number;
    name?: string | null;
    applicationUser?: ApplicationUserUpdateWithoutPKs | null;
    applicationUserId?: number;
    applicationUserGroup?: ApplicationUserGroupUpdateWithoutPKs | null;
    applicationUserGroupId?: number;
}

/** ApplicationUserApplicationUserGroup without PKs and database generated properties and with all properties optional */
export interface ApplicationUserApplicationUserGroupUpdateWithoutPKs {
    name?: string | null;
    applicationUser?: ApplicationUserUpdateWithoutPKs | null;
    applicationUserId?: number;
    applicationUserGroup?: ApplicationUserGroupUpdateWithoutPKs | null;
    applicationUserGroupId?: number;
}

export interface ApplicationUserDTO {
    id?: number;
    oidcId: string | null;
    userName: string;
    name: string;
    email: string | null;
    phoneNumber?: string | null;
    isEnabled?: boolean;
    isLocked?: boolean;
}

export interface ApplicationUserGroup {
    id: number;
    name: string | null;
    isDeleted: boolean;
    applicationUserApplicationUserGroups?: ApplicationUserApplicationUserGroup[];
    claimEnumsInApplicationUserGroups?: ClaimEnumsInApplicationUserGroup[];
    claimGroupsInApplicationUserGroups?: ClaimGroupsInApplicationUserGroup[];
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

/** ApplicationUserGroup without database generated properties */
export interface ApplicationUserGroupInsert {
    name?: string | null;
    applicationUserApplicationUserGroups?: ApplicationUserApplicationUserGroupInsert[] | null;
    claimEnumsInApplicationUserGroups?: ClaimEnumsInApplicationUserGroupInsert[] | null;
    claimGroupsInApplicationUserGroups?: ClaimGroupsInApplicationUserGroupInsert[] | null;
}

export interface ApplicationUserGroupPageWithTotalCountDTO {
    list?: ApplicationUserGroup[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** ApplicationUserGroup with all properties optional except PKs */
export interface ApplicationUserGroupUpdate {
    id: number;
    name?: string | null;
    applicationUserApplicationUserGroups?: ApplicationUserApplicationUserGroupUpdate[] | null;
    claimEnumsInApplicationUserGroups?: ClaimEnumsInApplicationUserGroupUpdate[] | null;
    claimGroupsInApplicationUserGroups?: ClaimGroupsInApplicationUserGroupUpdate[] | null;
}

/** ApplicationUserGroup without PKs and database generated properties and with all properties optional */
export interface ApplicationUserGroupUpdateWithoutPKs {
    name?: string | null;
    applicationUserApplicationUserGroups?: ApplicationUserApplicationUserGroupUpdate[] | null;
    claimEnumsInApplicationUserGroups?: ClaimEnumsInApplicationUserGroupUpdate[] | null;
    claimGroupsInApplicationUserGroups?: ClaimGroupsInApplicationUserGroupUpdate[] | null;
}

/** ApplicationUser without database generated properties */
export interface ApplicationUserInsert {
    introducerId?: number | null;
    introducer?: IntroducerInsert | null;
    referrer?: ReferrerEnum;
    referrerOther?: string | null;
    location?: LocationEnum;
    applicantDefinedRole?: ApplicantRoleEnum;
    applicantDefinedRoleOther?: string | null;
    agreedToTermsAndPP?: boolean;
    lenderResultsTermsAgreed?: boolean;
    temporaryAccount?: boolean;
    newUserEmailJourneyStarted?: boolean;
    lastLoginDate?: Date | null;
    applicantDefinedRoleIntroducer?: IntroducerTypeEnum | null;
    organisation?: OrganisationInsert | null;
    organisationId?: number | null;
    isOrganisationAdmin?: boolean;
    defaultBrokerOrganisation?: OrganisationInsert | null;
    defaultBrokerOrganisationId?: number | null;
    profilePictureUrl?: string | null;
    roleDescription?: string | null;
    miniBio?: string | null;
    organisationReferral?: OrganisationInsert | null;
    organisationReferralId?: number | null;
    displayOrganisationAdminWelcomepage?: boolean;
    licenseMaster?: LicenseMasterInsert | null;
    licenseMasterId?: number | null;
    isLegacyUser?: boolean;
    representative?: string | null;
    securityStamp?: string | null;
    level?: number;
    firstName?: string | null;
    lastName?: string | null;
    profile?: ProfileInsert | null;
    profileId?: number | null;
    lenderId?: number | null;
    lender?: LenderInsert | null;
    lenderProductTypes?: LenderProductTypeEnum | null;
    isLenderAdmin?: boolean;
    showAutofill?: boolean;
    sendLenderInsightsEmail?: boolean;
    emailOptOut?: boolean;
    password?: string | null;
    brokerDeals?: DealInsert[] | null;
    brokerDevelopmentInputs?: DevelopmentInputAbstractInsert[] | null;
    connectDeals?: DealInsert[] | null;
    lenderDeals?: DealInsert[] | null;
    userDevelopmentInputs?: DevelopmentInputAbstractInsert[] | null;
    userLender?: LenderInsert[] | null;
    oidcId: string;
    name: string;
    userName: string;
    email?: string | null;
    phoneNumber?: string | null;
    isEnabled?: boolean;
    failedLoginAttempts?: number;
    applicationUserApplicationUserGroups?: ApplicationUserApplicationUserGroupInsert[] | null;
    claimEnumsInApplicationUsers?: ClaimEnumsInApplicationUserInsert[] | null;
    claimGroupsInApplicationUsers?: ClaimGroupsInApplicationUserInsert[] | null;
}

export interface ApplicationUserPageWithTotalCountDTO {
    list?: ApplicationUser[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** ApplicationUser with all properties optional except PKs */
export interface ApplicationUserUpdate {
    introducerId?: number | null;
    introducer?: IntroducerUpdateWithoutPKs | null;
    referrer?: ReferrerEnum;
    referrerOther?: string | null;
    location?: LocationEnum;
    applicantDefinedRole?: ApplicantRoleEnum;
    applicantDefinedRoleOther?: string | null;
    agreedToTermsAndPP?: boolean;
    lenderResultsTermsAgreed?: boolean;
    temporaryAccount?: boolean;
    newUserEmailJourneyStarted?: boolean;
    lastLoginDate?: Date | null;
    applicantDefinedRoleIntroducer?: IntroducerTypeEnum | null;
    organisation?: OrganisationUpdateWithoutPKs | null;
    organisationId?: number | null;
    isOrganisationAdmin?: boolean;
    defaultBrokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    defaultBrokerOrganisationId?: number | null;
    profilePictureUrl?: string | null;
    roleDescription?: string | null;
    miniBio?: string | null;
    organisationReferral?: OrganisationUpdateWithoutPKs | null;
    organisationReferralId?: number | null;
    displayOrganisationAdminWelcomepage?: boolean;
    licenseMaster?: LicenseMasterUpdateWithoutPKs | null;
    licenseMasterId?: number | null;
    isLegacyUser?: boolean;
    representative?: string | null;
    securityStamp?: string | null;
    level?: number;
    firstName?: string | null;
    lastName?: string | null;
    profile?: ProfileUpdateWithoutPKs | null;
    profileId?: number | null;
    lenderId?: number | null;
    lender?: LenderUpdateWithoutPKs | null;
    lenderProductTypes?: LenderProductTypeEnum | null;
    isLenderAdmin?: boolean;
    showAutofill?: boolean;
    sendLenderInsightsEmail?: boolean;
    emailOptOut?: boolean;
    password?: string | null;
    brokerDeals?: DealUpdate[] | null;
    brokerDevelopmentInputs?: DevelopmentInputAbstractUpdate[] | null;
    connectDeals?: DealUpdate[] | null;
    lenderDeals?: DealUpdate[] | null;
    userDevelopmentInputs?: DevelopmentInputAbstractUpdate[] | null;
    userLender?: LenderUpdate[] | null;
    id: number;
    oidcId?: string;
    name?: string;
    userName?: string;
    email?: string | null;
    phoneNumber?: string | null;
    isEnabled?: boolean;
    failedLoginAttempts?: number;
    applicationUserApplicationUserGroups?: ApplicationUserApplicationUserGroupUpdate[] | null;
    claimEnumsInApplicationUsers?: ClaimEnumsInApplicationUserUpdate[] | null;
    claimGroupsInApplicationUsers?: ClaimGroupsInApplicationUserUpdate[] | null;
}

/** ApplicationUser without PKs and database generated properties and with all properties optional */
export interface ApplicationUserUpdateWithoutPKs {
    introducerId?: number | null;
    introducer?: IntroducerUpdateWithoutPKs | null;
    referrer?: ReferrerEnum;
    referrerOther?: string | null;
    location?: LocationEnum;
    applicantDefinedRole?: ApplicantRoleEnum;
    applicantDefinedRoleOther?: string | null;
    agreedToTermsAndPP?: boolean;
    lenderResultsTermsAgreed?: boolean;
    temporaryAccount?: boolean;
    newUserEmailJourneyStarted?: boolean;
    lastLoginDate?: Date | null;
    applicantDefinedRoleIntroducer?: IntroducerTypeEnum | null;
    organisation?: OrganisationUpdateWithoutPKs | null;
    organisationId?: number | null;
    isOrganisationAdmin?: boolean;
    defaultBrokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    defaultBrokerOrganisationId?: number | null;
    profilePictureUrl?: string | null;
    roleDescription?: string | null;
    miniBio?: string | null;
    organisationReferral?: OrganisationUpdateWithoutPKs | null;
    organisationReferralId?: number | null;
    displayOrganisationAdminWelcomepage?: boolean;
    licenseMaster?: LicenseMasterUpdateWithoutPKs | null;
    licenseMasterId?: number | null;
    isLegacyUser?: boolean;
    representative?: string | null;
    securityStamp?: string | null;
    level?: number;
    firstName?: string | null;
    lastName?: string | null;
    profile?: ProfileUpdateWithoutPKs | null;
    profileId?: number | null;
    lenderId?: number | null;
    lender?: LenderUpdateWithoutPKs | null;
    lenderProductTypes?: LenderProductTypeEnum | null;
    isLenderAdmin?: boolean;
    showAutofill?: boolean;
    sendLenderInsightsEmail?: boolean;
    emailOptOut?: boolean;
    password?: string | null;
    brokerDeals?: DealUpdate[] | null;
    brokerDevelopmentInputs?: DevelopmentInputAbstractUpdate[] | null;
    connectDeals?: DealUpdate[] | null;
    lenderDeals?: DealUpdate[] | null;
    userDevelopmentInputs?: DevelopmentInputAbstractUpdate[] | null;
    userLender?: LenderUpdate[] | null;
    oidcId?: string;
    name?: string;
    userName?: string;
    email?: string | null;
    phoneNumber?: string | null;
    isEnabled?: boolean;
    failedLoginAttempts?: number;
    applicationUserApplicationUserGroups?: ApplicationUserApplicationUserGroupUpdate[] | null;
    claimEnumsInApplicationUsers?: ClaimEnumsInApplicationUserUpdate[] | null;
    claimGroupsInApplicationUsers?: ClaimGroupsInApplicationUserUpdate[] | null;
}

export interface ApplicationUsersToApplicationUserGroupsDTO {
    applicationUsersGroups?: number[];
    applicationUsersToAdd?: number[];
    applicationUsersToRemove?: number[];
    removeExistingUnMentioned?: boolean;
}

export interface AppraisalData {
    appraisalId?: number;
    isDeal?: boolean;
    brokerUserId?: number;
}

export enum AppraisalModuleEnum {
    Overview = 0,
    Borrower = 1,
    Property = 2,
    Loan = 3,
}

export enum AreaUnitEnum {
    SquareMeters = 0,
    SquareFeet = 1,
}

export interface AssetLiabilityItem {
    caseMember?: CaseMember;
    alType: ALTypeEnum;
    alItemType: ALItemTypeEnum;
    description: string;
    value: number;
    startDate: Date | null;
    endDate: Date | null;
    id: number;
    caseMemberId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** AssetLiabilityItem without database generated properties */
export interface AssetLiabilityItemInsert {
    caseMember: CaseMemberInsert | null;
    alType?: ALTypeEnum;
    alItemType?: ALItemTypeEnum;
    description?: string;
    value?: number;
    startDate?: Date | null;
    endDate?: Date | null;
    caseMemberId: number;
}

export interface AssetLiabilityItemPageWithTotalCountDTO {
    list?: AssetLiabilityItem[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** AssetLiabilityItem with all properties optional except PKs */
export interface AssetLiabilityItemUpdate {
    caseMember?: CaseMemberUpdateWithoutPKs | null;
    alType?: ALTypeEnum;
    alItemType?: ALItemTypeEnum;
    description?: string;
    value?: number;
    startDate?: Date | null;
    endDate?: Date | null;
    id: number;
    caseMemberId?: number;
}

/** AssetLiabilityItem without PKs and database generated properties and with all properties optional */
export interface AssetLiabilityItemUpdateWithoutPKs {
    caseMember?: CaseMemberUpdateWithoutPKs | null;
    alType?: ALTypeEnum;
    alItemType?: ALItemTypeEnum;
    description?: string;
    value?: number;
    startDate?: Date | null;
    endDate?: Date | null;
    caseMemberId?: number;
}

export interface AssignBrokerToDealRequest {
    dealId?: number;
    brokerUserId?: number;
}

export interface AssignBrokerToDealResponse {
    isSuccess?: boolean;
}

export interface AssignLenderToDealRequest {
    dealId?: number;
    lenderId?: number;
    lenderUserId?: number;
}

export interface AssignLenderToDealResponse {
    isSuccess?: boolean;
}

export interface AuditLog {
    severity: AuditLogSeverityEnum;
    logType: AuditLogTypeEnum;
    userName: string;
    event: string;
    info: string;
    note: string;
    param1: string;
    param2: string;
    param3: string;
    param4: string;
    param5: string;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** AuditLog without database generated properties */
export interface AuditLogInsert {
    severity?: AuditLogSeverityEnum;
    logType?: AuditLogTypeEnum;
    userName?: string;
    event?: string;
    info?: string;
    note?: string;
    param1?: string;
    param2?: string;
    param3?: string;
    param4?: string;
    param5?: string;
}

export interface AuditLogPageWithTotalCountDTO {
    list?: AuditLog[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export enum AuditLogSeverityEnum {
    Info = 0,
    Warning = 1,
    Error = 2,
    Critical = 3,
}

export enum AuditLogTypeEnum {
    General = 0,
    Email = 1,
    API = 2,
    User = 3,
    Introducer = 4,
    HubSpot = 5,
    Case = 6,
    Search = 7,
    Payment = 8,
    Delete = 9,
    Deal = 10,
    Client = 11,
    ScheduledJob = 12,
    Organisation = 13,
    License = 14,
    FeedBack = 15,
    LenderReferral = 16,
    EventLog = 17,
    CRMIntegration = 18,
    ProductApi = 19,
}

/** AuditLog with all properties optional except PKs */
export interface AuditLogUpdate {
    severity?: AuditLogSeverityEnum;
    logType?: AuditLogTypeEnum;
    userName?: string;
    event?: string;
    info?: string;
    note?: string;
    param1?: string;
    param2?: string;
    param3?: string;
    param4?: string;
    param5?: string;
    id: number;
}

/** AuditLog without PKs and database generated properties and with all properties optional */
export interface AuditLogUpdateWithoutPKs {
    severity?: AuditLogSeverityEnum;
    logType?: AuditLogTypeEnum;
    userName?: string;
    event?: string;
    info?: string;
    note?: string;
    param1?: string;
    param2?: string;
    param3?: string;
    param4?: string;
    param5?: string;
}

export interface AuthDTO {
    token: string;
    expiresIn?: number;
    applicationUser: ApplicationUserDTO;
}

export interface AuthErrorDetails {
    title?: string;
    details?: string;
    context?: string;
}

export interface BaseDataMultiOwner {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

/** BaseDataMultiOwner without database generated properties */
export interface BaseDataMultiOwnerInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
}

/** BaseDataMultiOwner with all properties optional except PKs */
export interface BaseDataMultiOwnerUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
}

/** BaseDataMultiOwner without PKs and database generated properties and with all properties optional */
export interface BaseDataMultiOwnerUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
}

export enum BillingFrequencyEnum {
    Monthly = 1,
    Yearly = 2,
    OneOff = 3,
    None = 4,
}

export enum BorrowingEntityTypeEnum {
    None = 0,
    Individual = 1,
    Company = 2,
    SoleTrader = 4,
    Partnership = 8,
    LLP = 16,
    Trust = 32,
    SIPPOrSSAS = 64,
    OverseasCo = 128,
}

export interface BrickflowEventLog {
    orgId: number | null;
    userName: string | null;
    orgCode: string;
    identifier: string;
    ipAddress: string;
    eventType: EventLogEnum;
    userRole: string | null;
    organisationLinkId: number | null;
    dealId: number | null;
    developmentInputWithNoLoginUniqueRef: string | null;
    clientId: number | null;
    productType: ProductTypeEnum;
    param1: string | null;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
}

/** BrickflowEventLog without database generated properties */
export interface BrickflowEventLogInsert {
    orgId?: number | null;
    userName?: string | null;
    orgCode?: string;
    identifier?: string;
    ipAddress?: string;
    eventType?: EventLogEnum;
    userRole?: string | null;
    organisationLinkId?: number | null;
    dealId?: number | null;
    developmentInputWithNoLoginUniqueRef?: string | null;
    clientId?: number | null;
    productType?: ProductTypeEnum;
    param1?: string | null;
}

export interface BrickflowEventLogPageWithTotalCountDTO {
    list?: BrickflowEventLog[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** BrickflowEventLog with all properties optional except PKs */
export interface BrickflowEventLogUpdate {
    orgId?: number | null;
    userName?: string | null;
    orgCode?: string;
    identifier?: string;
    ipAddress?: string;
    eventType?: EventLogEnum;
    userRole?: string | null;
    organisationLinkId?: number | null;
    dealId?: number | null;
    developmentInputWithNoLoginUniqueRef?: string | null;
    clientId?: number | null;
    productType?: ProductTypeEnum;
    param1?: string | null;
    id: number;
}

/** BrickflowEventLog without PKs and database generated properties and with all properties optional */
export interface BrickflowEventLogUpdateWithoutPKs {
    orgId?: number | null;
    userName?: string | null;
    orgCode?: string;
    identifier?: string;
    ipAddress?: string;
    eventType?: EventLogEnum;
    userRole?: string | null;
    organisationLinkId?: number | null;
    dealId?: number | null;
    developmentInputWithNoLoginUniqueRef?: string | null;
    clientId?: number | null;
    productType?: ProductTypeEnum;
    param1?: string | null;
}

export interface BridgingDeal {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold: boolean;
    name: string;
    uniqueRef: string;
    brokerUser?: ApplicationUser | null;
    brokerOrganisation?: Organisation | null;
    planningPermissionType: PlanningPermissionTypeEnum;
    productType: ProductTypeEnum;
    productFamily: ProductFamilyEnum;
    status: CaseStatusEnum;
    applicationFee: number;
    isApplicationFeePaid: number;
    dealClients?: DealClient[];
    dealLenders?: DealLender[];
    attachments?: DealFileAttachment[];
    dealNotes?: DealNote[];
    dealSchedules?: DealSchedule[];
    /** External Reference */
    externalRef: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq: number;
    /** Loan Required(LoanReq) */
    netLoanRequired: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy: ExitStrategyEnum | null;
    exitStrategyOther: string;
    /** Property Location */
    locations: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses: number | null;
    /** How many flats? */
    howManyFlats: number | null;
    /** Class Uses */
    classUses: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts: number;
    /** Build Costs(BuildCosts) */
    buildCosts: number;
    /** Continguency(Contingency) */
    contingency: number;
    /** Completion Date(CompletionDate) */
    completionDate: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts: number;
    parentCaseToAssoicateWithOnCreation: number | null;
    f_IsFirstTimeDeveloper: boolean | null;
    f_NumberOfPreviousDevelopments: PreviousDevelopmentsEnum | null;
    f_IsPersonalName: boolean | null;
    f_IsOffshoreCompany: boolean | null;
    f_IsMainShareholderOverseas: boolean | null;
    f_PersonalGuaranteeLevel: number | null;
    f_IsGradeOneListed: boolean | null;
    f_IsGradeTwoListed: boolean | null;
    f_MaxHouseSalesPrice: number | null;
    f_MaxFlatUnitPrice: number | null;
    f_MaxSqFtSalePrice: number | null;
    f_MaxSqFtSalePriceFlats: number | null;
    f_MaxPercCommercialForMixedUse: number | null;
    f_MaxNumberOfUnits: number | null;
    f_IsChargeOnAdditionalProperty: boolean | null;
    f_IsFixedRate: boolean | null;
    personalGuaranteeMin: number | null;
    personalGuaranteeMax: number | null;
    f_IsTimberFrameConstruction: boolean | null;
    f_IsConcreteConstruction: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction: string;
    /** Pension Type */
    pensionType: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners: number;
    /** Excluded Lenders */
    excludedLenders: string;
    isCaseOverviewSectionComplete: boolean;
    submitTsAndCs: boolean;
    siteDetails: string;
    solicitorDetails: string;
    accountantDetails: string;
    nameOfUKLimitedLiabilityCompany: string;
    ukLimitedLiabilityPartnershipNumber: string;
    previousLenders: string;
    propertyTenure: TenureEnum | null;
    gdv: number | null;
    ltc: number | null;
    ltgdv: number | null;
    chargeRequired: ChargeTypeEnum;
    currentvalue: number | null;
    hasPendingSubmitWithCriteriaChange: boolean;
    maxLoanRequired: boolean;
    additionalSecurity: boolean;
    additionalSecurityInfo: string;
    organisationLink?: OrganisationLink | null;
    leadSourceUrl: string;
    ownOrPurchase: OwnOrPurchaseEnum | null;
    isFamilyInResidence: YesNoMaybe | null;
    loanCompletionType: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete: boolean | null;
    isPropertySectionComplete: boolean | null;
    isLoanSectionComplete: boolean | null;
    f_IsRetypedValuation: boolean | null;
    projectDescription: string;
    isTenantedBuilding: boolean | null;
    numberOfTenancies: number | null;
    yearsLeftOnLease: number | null;
    propertyAddress: PostalAddress;
    showLenderInfoBrokerOverride: boolean;
    postcodeSearchString: string;
    lenderUser?: ApplicationUser | null;
    planningStatusAtEndOfLoan: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy: boolean | null;
    companyCcjOrBankruptcyDetail: string;
    sortBy: SortByEnum;
    brokerCommissionPercent: number | null;
    originatorRoleType: OriginatorRoleTypeEnum;
    originatorOrganisationId: number | null;
    originatorLenderId: number | null;
    sourceType: DealSourceTypeEnum;
    lenderReferralUserId: number | null;
    lenderReferralLenderId: number | null;
    brokerPhoneNumber: string;
    f_HasAdverseCredit: boolean | null;
    f_MaxCommercialFloorspace: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect: boolean;
    connectUser?: ApplicationUser | null;
    isPreConnectArchived: boolean;
    f_PersonalGuaranteeMin: number | null;
    f_PersonalGuaranteeMax: number | null;
    brokerUserFullName: string;
    brokerOrganisationName: string;
    brokerUserEmail: string;
    hasOwnOrPurchase: boolean;
    hasPostcode: boolean;
    propertyValue: number;
    dealClient: DealClient;
    hasIsFamilyInResidence: boolean;
    originalPurchasePrice: number;
    id: number;
    brokerUserId: number | null;
    brokerOrganisationId: number | null;
    organisationLinkId: number | null;
    lenderUserId: number | null;
    connectUserId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_Deal[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_Deal[];
    landOrProperty: LandOrPropertyEnum | null;
    buildingCondition: ConditionEnum | null;
    estimatedSpending: number | null;
    interestService: InterestServicedorRolledEnum | null;
    sourceOfIncome: SourceOfIncomeEnum | null;
    f_IsShariaLoan: boolean | null;
    f_IsSyndicationLoan: boolean | null;
    f_IsNonUkCompany: boolean | null;
    f_IsReBridge: boolean | null;
    f_IsUkCompany: boolean | null;
    f_IsOverseasClient: boolean | null;
    f_IsBank: boolean | null;
    f_BasisOfInterestRate: InterestRateBasis | null;
    planningStatusAtStartOfLoan: PlanningPermissionTypeEnum | null;
    loanPurpose: LoanPurposeEnum | null;
    loanPurposeDescription: string;
    grossAnnualRentalReceipts: number | null;
    hasCompletionDate: YesNoMaybe | null;
    isPropertyImprovementDuringLoanTerm: boolean | null;
    isExistingPlanChange: boolean | null;
    existingPlanningChangeType: ExistingPlanningChangeTypeEnum | null;
    buildingCostTodate: number | null;
    planForLandOrPropertyDescription: string;
    refinancedUnits: number | null;
    buildStage: BuildStageEnum | null;
    f_IsServicedInterest: boolean | null;
    f_IsTitleInsurance: boolean | null;
    f_IsIndemnityInsurance: boolean | null;
    refurbishmentLevel: RefurbishmentLevelEnum | null;
    f_IsBelowMarketValue: boolean | null;
    f_IsAutomatedValuationModel: boolean | null;
    f_IsAuctionPurchase: boolean | null;
    f_ValuationMethod: ValuationMethodEnum | null;
    comparisonList: BridgingLenderResultSummaryDTO[];
    hasLandOrProperty: boolean;
}

/** BridgingDeal without database generated properties */
export interface BridgingDealInsert {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserInsert | null;
    brokerOrganisation?: OrganisationInsert | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientInsert[];
    dealLenders?: DealLenderInsert[];
    attachments?: DealFileAttachmentInsert[];
    dealNotes?: DealNoteInsert[];
    dealSchedules?: DealScheduleInsert[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkInsert | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserInsert | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserInsert | null;
    isPreConnectArchived?: boolean;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealInsert[];
    landOrProperty?: LandOrPropertyEnum | null;
    buildingCondition?: ConditionEnum | null;
    estimatedSpending?: number | null;
    interestService?: InterestServicedorRolledEnum | null;
    sourceOfIncome?: SourceOfIncomeEnum | null;
    f_IsShariaLoan?: boolean | null;
    f_IsSyndicationLoan?: boolean | null;
    f_IsNonUkCompany?: boolean | null;
    f_IsReBridge?: boolean | null;
    f_IsUkCompany?: boolean | null;
    f_IsOverseasClient?: boolean | null;
    f_IsBank?: boolean | null;
    f_BasisOfInterestRate?: InterestRateBasis | null;
    planningStatusAtStartOfLoan?: PlanningPermissionTypeEnum | null;
    loanPurpose?: LoanPurposeEnum | null;
    loanPurposeDescription?: string;
    grossAnnualRentalReceipts?: number | null;
    hasCompletionDate?: YesNoMaybe | null;
    isPropertyImprovementDuringLoanTerm?: boolean | null;
    isExistingPlanChange?: boolean | null;
    existingPlanningChangeType?: ExistingPlanningChangeTypeEnum | null;
    buildingCostTodate?: number | null;
    planForLandOrPropertyDescription?: string;
    refinancedUnits?: number | null;
    buildStage?: BuildStageEnum | null;
    f_IsServicedInterest?: boolean | null;
    f_IsTitleInsurance?: boolean | null;
    f_IsIndemnityInsurance?: boolean | null;
    refurbishmentLevel?: RefurbishmentLevelEnum | null;
    f_IsBelowMarketValue?: boolean | null;
    f_IsAutomatedValuationModel?: boolean | null;
    f_IsAuctionPurchase?: boolean | null;
    f_ValuationMethod?: ValuationMethodEnum | null;
}

export interface BridgingDealPageWithTotalCountDTO {
    list?: BridgingDeal[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** BridgingDeal with all properties optional except PKs */
export interface BridgingDealUpdate {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientUpdate[];
    dealLenders?: DealLenderUpdate[];
    attachments?: DealFileAttachmentUpdate[];
    dealNotes?: DealNoteUpdate[];
    dealSchedules?: DealScheduleUpdate[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserUpdateWithoutPKs | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserUpdateWithoutPKs | null;
    isPreConnectArchived?: boolean;
    id: number;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealUpdate[];
    landOrProperty?: LandOrPropertyEnum | null;
    buildingCondition?: ConditionEnum | null;
    estimatedSpending?: number | null;
    interestService?: InterestServicedorRolledEnum | null;
    sourceOfIncome?: SourceOfIncomeEnum | null;
    f_IsShariaLoan?: boolean | null;
    f_IsSyndicationLoan?: boolean | null;
    f_IsNonUkCompany?: boolean | null;
    f_IsReBridge?: boolean | null;
    f_IsUkCompany?: boolean | null;
    f_IsOverseasClient?: boolean | null;
    f_IsBank?: boolean | null;
    f_BasisOfInterestRate?: InterestRateBasis | null;
    planningStatusAtStartOfLoan?: PlanningPermissionTypeEnum | null;
    loanPurpose?: LoanPurposeEnum | null;
    loanPurposeDescription?: string;
    grossAnnualRentalReceipts?: number | null;
    hasCompletionDate?: YesNoMaybe | null;
    isPropertyImprovementDuringLoanTerm?: boolean | null;
    isExistingPlanChange?: boolean | null;
    existingPlanningChangeType?: ExistingPlanningChangeTypeEnum | null;
    buildingCostTodate?: number | null;
    planForLandOrPropertyDescription?: string;
    refinancedUnits?: number | null;
    buildStage?: BuildStageEnum | null;
    f_IsServicedInterest?: boolean | null;
    f_IsTitleInsurance?: boolean | null;
    f_IsIndemnityInsurance?: boolean | null;
    refurbishmentLevel?: RefurbishmentLevelEnum | null;
    f_IsBelowMarketValue?: boolean | null;
    f_IsAutomatedValuationModel?: boolean | null;
    f_IsAuctionPurchase?: boolean | null;
    f_ValuationMethod?: ValuationMethodEnum | null;
}

/** BridgingDeal without PKs and database generated properties and with all properties optional */
export interface BridgingDealUpdateWithoutPKs {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientUpdate[];
    dealLenders?: DealLenderUpdate[];
    attachments?: DealFileAttachmentUpdate[];
    dealNotes?: DealNoteUpdate[];
    dealSchedules?: DealScheduleUpdate[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserUpdateWithoutPKs | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserUpdateWithoutPKs | null;
    isPreConnectArchived?: boolean;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealUpdate[];
    landOrProperty?: LandOrPropertyEnum | null;
    buildingCondition?: ConditionEnum | null;
    estimatedSpending?: number | null;
    interestService?: InterestServicedorRolledEnum | null;
    sourceOfIncome?: SourceOfIncomeEnum | null;
    f_IsShariaLoan?: boolean | null;
    f_IsSyndicationLoan?: boolean | null;
    f_IsNonUkCompany?: boolean | null;
    f_IsReBridge?: boolean | null;
    f_IsUkCompany?: boolean | null;
    f_IsOverseasClient?: boolean | null;
    f_IsBank?: boolean | null;
    f_BasisOfInterestRate?: InterestRateBasis | null;
    planningStatusAtStartOfLoan?: PlanningPermissionTypeEnum | null;
    loanPurpose?: LoanPurposeEnum | null;
    loanPurposeDescription?: string;
    grossAnnualRentalReceipts?: number | null;
    hasCompletionDate?: YesNoMaybe | null;
    isPropertyImprovementDuringLoanTerm?: boolean | null;
    isExistingPlanChange?: boolean | null;
    existingPlanningChangeType?: ExistingPlanningChangeTypeEnum | null;
    buildingCostTodate?: number | null;
    planForLandOrPropertyDescription?: string;
    refinancedUnits?: number | null;
    buildStage?: BuildStageEnum | null;
    f_IsServicedInterest?: boolean | null;
    f_IsTitleInsurance?: boolean | null;
    f_IsIndemnityInsurance?: boolean | null;
    refurbishmentLevel?: RefurbishmentLevelEnum | null;
    f_IsBelowMarketValue?: boolean | null;
    f_IsAutomatedValuationModel?: boolean | null;
    f_IsAuctionPurchase?: boolean | null;
    f_ValuationMethod?: ValuationMethodEnum | null;
}

export interface BridgingLenderResultSummaryDTO {
    productFamily?: ProductFamilyEnum;
    id?: number;
    grossLoan?: number;
    loanToCostGross?: number;
    netLoan?: number;
    loanToValueNet?: number;
    equityOrDeposit?: number;
    profit?: number | null;
    loanTerm?: number;
    lenderLogo?: string;
    loanLabel?: string;
    productID?: number | null;
    lenderID?: number;
    lenderName?: string;
    snapshot?: string;
    interest?: number;
    annualInterest?: number;
    monthlyInterest?: number;
    arrangementFee?: number;
    exitFee?: number;
    trueMonthlyCost?: number;
    additionalProductInfo?: string;
    selectedRowNumber?: number;
    isMatching?: boolean;
    isLargest?: boolean;
    isHighestROCE?: boolean;
    isLowestTrueMonthlyCost?: boolean;
    isDealLender?: boolean;
    dealLenderStatus?: CaseLenderStateEnum | null;
    debug1Flag?: boolean;
    debug1Info?: string;
    lenderInternalUrl?: string;
    logoURL?: string;
    avgLenderResponseTime?: number | null;
    productSourceType?: ProductSourceTypeEnum;
    externalProductId?: string | null;
    loanInterest?: number;
    totalCost?: number;
    roce?: number;
    buildLoan?: number;
    landLoan?: number;
    loanToCostNet?: number;
    loanToCostLender?: number;
    lenderCosts?: number;
    buildLoanPercOfBuildCost?: number | null;
    landLoanPercOfLandCost?: number | null;
    isRegulatedBridging?: boolean;
}

export interface BridgingSearchResultsResponse {
    criteria?: BridgingDeal | null;
    results?: BridgingLenderResultSummaryDTO[] | null;
    hideDeal?: boolean;
    hasNoAccessToDeal?: boolean;
}

export interface BridgingSubmitOfferRequest {
    dealLender?: DealLender;
    dealLenderStatus?: CaseLenderStateEnum;
}

export interface BridgingSubmitOfferResponse {
    dealLenderStatus?: CaseLenderStateEnum;
    dealBrokerName?: string;
    dealBrokerOrganisationName?: string;
}

export interface BrokerAppraisal {
    appraisalId?: number;
    appraisalName?: string;
    isDeal?: boolean;
    appraisalLenders?: BrokerAppraisalLender[];
}

export interface BrokerAppraisalLender {
    lenderName?: string;
    lenderId?: number;
}

export interface BrokerAppraisalMessageResponse {
    brokerAppraisals?: BrokerAppraisal[];
}

export enum BrokerNetworkEnum {
    None = 0,
    ConnectIFA = 1,
    Synergy = 2,
    NewLeafDistribution = 4,
    Fiducia = 8,
    RosemountFinancialSolutions = 16,
    StJamesPlace = 32,
    Primis = 64,
    Quilter = 128,
    Stonebridge = 256,
    Openwork = 512,
    HLPartnership = 1024,
    TheRightMortgageLimited = 2048,
    PlanWealthManagement = 4096,
    Sesame = 8192,
    TheOnLinePartnershipLtd = 16384,
    MortgageAdviceBureau = 32768,
    SenseNetwork = 65536,
    MortgageIntelligenceLtd = 131072,
    ValidPathLimited = 262144,
    BestPracticeIFAGroupLimited = 524288,
    WhiteRoseFinanceGroupLimited = 1048576,
    TMGDirectLimited = 2097152,
    BeneficialLimited = 4194304,
    JulianHarris = 8388608,
    DragonBrokersLimited = 16777216,
    JohnCharcolLimited = 33554432,
    CornerstoneFinancial = 67108864,
    CorbelPartners = 134217728,
    RichdaleBrokers = 268435456,
    PJFinancialLtd = 536870912,
    JLMMortgageNetwork = 1073741824,
    IngrandFinancial = -2147483648,
}

export enum BuildProcurementTypeEnum {
    DesignAndBuildContract = 1,
    TraditionalContract = 2,
    SelfManaged = 3,
}

export enum BuildStageEnum {
    None = 0,
    PracticalCompletion = 1,
    WindAndWaterTight = 2,
    PreWindAndWaterTight = 3,
}

export enum CRMEnum {
    None = 0,
    OMS = 1,
    Finova = 2,
    BATSoftware = 4,
    Acre = 8,
    Smart365 = 16,
    Salesforce = 32,
    Pipedrive = 64,
    Zoho = 128,
}

export interface Case {
    developmentInput?: DevelopmentInput | null;
    developmentExperience?: ProjectOwnership | null;
    productResultList: number | null;
    product?: Product | null;
    startingProduct?: Product | null;
    ownerUser: string;
    paid: boolean;
    payPalPaymentId: string | null;
    caseStatus: CaseStatusEnum;
    caseOverviewComplete: boolean;
    developerExperienceComplete: boolean;
    developmentAppraisalComplete: boolean;
    developmentScheduleComplete: boolean;
    applicationDetailsComplete: boolean;
    attachments?: FileAttachment[];
    caseNotes?: CaseNote[];
    links?: ExternalLinks[];
    preAppSubmitted: boolean;
    caseOverview: string;
    teamMembers?: TeamMember[];
    comparables?: ComparableProperty[];
    caseLenders?: CaseLender[];
    planningURL: string;
    planningLocalAuthority: string;
    planningReference: string;
    planningDescription: string;
    planningComplete: boolean;
    teamMemberComplete: boolean;
    comparablePropertiesComplete: boolean;
    brokerOrganisation?: Organisation | null;
    owners?: CaseMember[];
    profilesComplete: boolean;
    planningPermissionType: PlanningPermissionTypeEnum;
    purchaseProcessType: PurchaseProcessTypeEnum;
    planningResponsibility: PlanningResponsibilityEnum;
    planningResponsibilityDetail: string;
    siteDescriptionOnCompletion: string;
    guaranteeDescription: string;
    buildProcurementType: BuildProcurementTypeEnum;
    buildProcurementDescription: string;
    depositDescription: string;
    hasSetCompletionDate: boolean;
    completionDate: Date | null;
    furtherInformation: string;
    applicationFee: number;
    isApplicationFeePaid: number;
    siteDetails: string;
    solicitorDetails: string;
    accountantDetails: string;
    submitTsAndCs: boolean;
    executiveSummary: string;
    brokerUser?: ApplicationUser | null;
    hasPendingSubmitWithCriteriaChange: boolean;
    brokerCommissionPercent: number | null;
    brokerPhoneNumber: string;
    id: number;
    developmentInputId: number | null;
    developmentExperienceId: number | null;
    productId: number | null;
    startingProductId: number | null;
    brokerOrganisationId: number | null;
    brokerUserId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_Case[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_Case[];
}

export enum CaseAccessLevelEnum {
    Hidden = 0,
    ReadOnly = 1,
    FullAccess = 10,
}

export interface CaseChangedMessageDTO {
    caseState?: CaseStatusEnum;
}

/** Case without database generated properties */
export interface CaseInsert {
    developmentInput?: DevelopmentInputInsert | null;
    developmentExperience?: ProjectOwnershipInsert | null;
    productResultList?: number | null;
    product?: ProductInsert | null;
    startingProduct?: ProductInsert | null;
    ownerUser?: string;
    paid?: boolean;
    payPalPaymentId?: string | null;
    caseStatus?: CaseStatusEnum;
    caseOverviewComplete?: boolean;
    developerExperienceComplete?: boolean;
    developmentAppraisalComplete?: boolean;
    developmentScheduleComplete?: boolean;
    applicationDetailsComplete?: boolean;
    attachments?: FileAttachmentInsert[];
    caseNotes?: CaseNoteInsert[];
    links?: ExternalLinksInsert[];
    preAppSubmitted?: boolean;
    caseOverview?: string;
    teamMembers?: TeamMemberInsert[];
    comparables?: ComparablePropertyInsert[];
    caseLenders?: CaseLenderInsert[];
    planningURL?: string;
    planningLocalAuthority?: string;
    planningReference?: string;
    planningDescription?: string;
    planningComplete?: boolean;
    teamMemberComplete?: boolean;
    comparablePropertiesComplete?: boolean;
    brokerOrganisation?: OrganisationInsert | null;
    owners?: CaseMemberInsert[];
    profilesComplete?: boolean;
    planningPermissionType?: PlanningPermissionTypeEnum;
    purchaseProcessType?: PurchaseProcessTypeEnum;
    planningResponsibility?: PlanningResponsibilityEnum;
    planningResponsibilityDetail?: string;
    siteDescriptionOnCompletion?: string;
    guaranteeDescription?: string;
    buildProcurementType?: BuildProcurementTypeEnum;
    buildProcurementDescription?: string;
    depositDescription?: string;
    hasSetCompletionDate?: boolean;
    completionDate?: Date | null;
    furtherInformation?: string;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    submitTsAndCs?: boolean;
    executiveSummary?: string;
    brokerUser?: ApplicationUserInsert | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    brokerCommissionPercent?: number | null;
    brokerPhoneNumber?: string;
    developmentInputId?: number | null;
    developmentExperienceId?: number | null;
    productId?: number | null;
    startingProductId?: number | null;
    brokerOrganisationId?: number | null;
    brokerUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_CaseInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_CaseInsert[];
}

export interface CaseLender {
    case?: Case;
    lender?: Lender;
    productRef: string;
    caseLenderState: CaseLenderStateEnum;
    originalTotalGrossLoan: number | null;
    totalGrossLoan: number;
    originalBuildLoan: number | null;
    buildLoan: number;
    originalLandLoan: number | null;
    landLoan: number;
    lenderArrangementFee: number;
    originalLenderArrangementFeePercent: number;
    lenderArrangementFeePercent: number;
    originalInterestRate: number;
    interestRate: number;
    interestCoverAllocation: number;
    lenderExitFee: number;
    originalLenderExitFeePercent: number;
    lenderExitFeePercent: number;
    originalProfessionalFeesEstimate: number | null;
    professionalFeesEstimate: number;
    lenderComments: string;
    borrowerComments: string;
    lenderRejectReason: string;
    lenderAdditionalRequirements: string;
    originalGDV: number;
    originalBuildTerm: number;
    originalLoanTerm: number;
    originalNetLoan: number | null;
    originalTotalLenderCosts: number | null;
    originalTrueMonthlyCost: number | null;
    originalDeposit: number | null;
    originalProfit: number | null;
    originalROCE: number | null;
    isBidAccepted: boolean | null;
    lenderRequiresSiteVisit: boolean;
    lenderRequiresInPersonMeeting: boolean;
    lenderRequiresVideoMeeting: boolean;
    lenderHasOwnDeclaration: boolean;
    lenderRequiresProofOfIncome: boolean;
    lenderRequiresIncomeAndExpenditure: boolean;
    contactName: string;
    contactEmail: string;
    contactWorkPhoneNumber: string;
    contactMobilePhoneNumber: string;
    applyTsAndCs: boolean;
    product?: Product | null;
    interestRateType: InterestRateTypeEnum;
    basisOfInterestRate: string;
    dipDateSubmittedToLender: Date | null;
    dipDateLenderResponded: Date | null;
    dipDateResubmittedToLender: Date | null;
    dipDateLenderWithdrew: Date | null;
    latestMessageDateFromBroker: Date | null;
    latestMessageDateFromLender: Date | null;
    isLenderReviewComplete: boolean;
    isBrokerReviewComplete: boolean;
    preferredLenderContactEmail: string;
    assignedLenderUserId: number | null;
    totalUnreadCaseLenderMessages: number | null;
    lenderLogo: string;
    lenderName: string;
    caseLenderMessage: CaseLenderMessage[];
    loanLabel: string;
    isLenderInActive: boolean;
    lenderUserIds: number[];
    id: number;
    caseId: number;
    lenderId: number;
    productId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_CaseLender[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_CaseLender[];
}

export interface CaseLenderChangedMessageDTO {
    caseLenderState?: CaseLenderStateEnum;
    dealBrokerName?: string;
    dealBrokerOrganisationName?: string;
    isReferredToConnect?: boolean | null;
    dealStatus?: CaseStatusEnum | null;
}

/** CaseLender without database generated properties */
export interface CaseLenderInsert {
    case: CaseInsert | null;
    lender: LenderInsert | null;
    productRef?: string;
    caseLenderState?: CaseLenderStateEnum;
    originalTotalGrossLoan?: number | null;
    totalGrossLoan?: number;
    originalBuildLoan?: number | null;
    buildLoan?: number;
    originalLandLoan?: number | null;
    landLoan?: number;
    lenderArrangementFee?: number;
    originalLenderArrangementFeePercent?: number;
    lenderArrangementFeePercent?: number;
    originalInterestRate?: number;
    interestRate?: number;
    interestCoverAllocation?: number;
    lenderExitFee?: number;
    originalLenderExitFeePercent?: number;
    lenderExitFeePercent?: number;
    originalProfessionalFeesEstimate?: number | null;
    professionalFeesEstimate?: number;
    lenderComments?: string;
    borrowerComments?: string;
    lenderRejectReason?: string;
    lenderAdditionalRequirements?: string;
    originalGDV?: number;
    originalBuildTerm?: number;
    originalLoanTerm?: number;
    originalNetLoan?: number | null;
    originalTotalLenderCosts?: number | null;
    originalTrueMonthlyCost?: number | null;
    originalDeposit?: number | null;
    originalProfit?: number | null;
    originalROCE?: number | null;
    isBidAccepted?: boolean | null;
    lenderRequiresSiteVisit?: boolean;
    lenderRequiresInPersonMeeting?: boolean;
    lenderRequiresVideoMeeting?: boolean;
    lenderHasOwnDeclaration?: boolean;
    lenderRequiresProofOfIncome?: boolean;
    lenderRequiresIncomeAndExpenditure?: boolean;
    contactName?: string;
    contactEmail?: string;
    contactWorkPhoneNumber?: string;
    contactMobilePhoneNumber?: string;
    applyTsAndCs?: boolean;
    product?: ProductInsert | null;
    interestRateType?: InterestRateTypeEnum;
    basisOfInterestRate?: string;
    dipDateSubmittedToLender?: Date | null;
    dipDateLenderResponded?: Date | null;
    dipDateResubmittedToLender?: Date | null;
    dipDateLenderWithdrew?: Date | null;
    latestMessageDateFromBroker?: Date | null;
    latestMessageDateFromLender?: Date | null;
    isLenderReviewComplete?: boolean;
    isBrokerReviewComplete?: boolean;
    preferredLenderContactEmail?: string;
    assignedLenderUserId?: number | null;
    caseId: number;
    lenderId: number;
    productId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_CaseLenderInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_CaseLenderInsert[];
}

export interface CaseLenderMessage {
    user?: ApplicationUser | null;
    message: string;
    caseId: number;
    caseLender?: CaseLender;
    messageReadDateTime: Date | null;
    senderRole: MessageRoleEnum;
    recipientRoles: MessageRoleEnum;
    organisationLogo: string;
    userFullName: string;
    id: number;
    userId: number | null;
    caseLenderId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** CaseLenderMessage without database generated properties */
export interface CaseLenderMessageInsert {
    user?: ApplicationUserInsert | null;
    message?: string;
    caseId?: number;
    caseLender: CaseLenderInsert | null;
    messageReadDateTime?: Date | null;
    senderRole?: MessageRoleEnum;
    recipientRoles?: MessageRoleEnum;
    userId?: number | null;
    caseLenderId: number;
}

export interface CaseLenderMessagePageWithTotalCountDTO {
    list?: CaseLenderMessage[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface CaseLenderMessageTrack {
    user?: ApplicationUser | null;
    readDateTime: Date | null;
    caseLenderMessage?: CaseLenderMessage;
    id: number;
    userId: number | null;
    caseLenderMessageId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** CaseLenderMessageTrack without database generated properties */
export interface CaseLenderMessageTrackInsert {
    user?: ApplicationUserInsert | null;
    readDateTime?: Date | null;
    caseLenderMessage: CaseLenderMessageInsert | null;
    userId?: number | null;
    caseLenderMessageId: number;
}

export interface CaseLenderMessageTrackPageWithTotalCountDTO {
    list?: CaseLenderMessageTrack[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** CaseLenderMessageTrack with all properties optional except PKs */
export interface CaseLenderMessageTrackUpdate {
    user?: ApplicationUserUpdateWithoutPKs | null;
    readDateTime?: Date | null;
    caseLenderMessage?: CaseLenderMessageUpdateWithoutPKs | null;
    id: number;
    userId?: number | null;
    caseLenderMessageId?: number;
}

/** CaseLenderMessageTrack without PKs and database generated properties and with all properties optional */
export interface CaseLenderMessageTrackUpdateWithoutPKs {
    user?: ApplicationUserUpdateWithoutPKs | null;
    readDateTime?: Date | null;
    caseLenderMessage?: CaseLenderMessageUpdateWithoutPKs | null;
    userId?: number | null;
    caseLenderMessageId?: number;
}

/** CaseLenderMessage with all properties optional except PKs */
export interface CaseLenderMessageUpdate {
    user?: ApplicationUserUpdateWithoutPKs | null;
    message?: string;
    caseId?: number;
    caseLender?: CaseLenderUpdateWithoutPKs | null;
    messageReadDateTime?: Date | null;
    senderRole?: MessageRoleEnum;
    recipientRoles?: MessageRoleEnum;
    id: number;
    userId?: number | null;
    caseLenderId?: number;
}

/** CaseLenderMessage without PKs and database generated properties and with all properties optional */
export interface CaseLenderMessageUpdateWithoutPKs {
    user?: ApplicationUserUpdateWithoutPKs | null;
    message?: string;
    caseId?: number;
    caseLender?: CaseLenderUpdateWithoutPKs | null;
    messageReadDateTime?: Date | null;
    senderRole?: MessageRoleEnum;
    recipientRoles?: MessageRoleEnum;
    userId?: number | null;
    caseLenderId?: number;
}

export interface CaseLenderPageWithTotalCountDTO {
    list?: CaseLender[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export enum CaseLenderStateEnum {
    Shortlisted = 0,
    Received = 1,
    Offered = 2,
    Rejected = 3,
    Withdrawn = 4,
    Cancelled = 5,
    Applied = 10,
    SentToPackager = 11,
}

/** CaseLender with all properties optional except PKs */
export interface CaseLenderUpdate {
    case?: CaseUpdateWithoutPKs | null;
    lender?: LenderUpdateWithoutPKs | null;
    productRef?: string;
    caseLenderState?: CaseLenderStateEnum;
    originalTotalGrossLoan?: number | null;
    totalGrossLoan?: number;
    originalBuildLoan?: number | null;
    buildLoan?: number;
    originalLandLoan?: number | null;
    landLoan?: number;
    lenderArrangementFee?: number;
    originalLenderArrangementFeePercent?: number;
    lenderArrangementFeePercent?: number;
    originalInterestRate?: number;
    interestRate?: number;
    interestCoverAllocation?: number;
    lenderExitFee?: number;
    originalLenderExitFeePercent?: number;
    lenderExitFeePercent?: number;
    originalProfessionalFeesEstimate?: number | null;
    professionalFeesEstimate?: number;
    lenderComments?: string;
    borrowerComments?: string;
    lenderRejectReason?: string;
    lenderAdditionalRequirements?: string;
    originalGDV?: number;
    originalBuildTerm?: number;
    originalLoanTerm?: number;
    originalNetLoan?: number | null;
    originalTotalLenderCosts?: number | null;
    originalTrueMonthlyCost?: number | null;
    originalDeposit?: number | null;
    originalProfit?: number | null;
    originalROCE?: number | null;
    isBidAccepted?: boolean | null;
    lenderRequiresSiteVisit?: boolean;
    lenderRequiresInPersonMeeting?: boolean;
    lenderRequiresVideoMeeting?: boolean;
    lenderHasOwnDeclaration?: boolean;
    lenderRequiresProofOfIncome?: boolean;
    lenderRequiresIncomeAndExpenditure?: boolean;
    contactName?: string;
    contactEmail?: string;
    contactWorkPhoneNumber?: string;
    contactMobilePhoneNumber?: string;
    applyTsAndCs?: boolean;
    product?: ProductUpdateWithoutPKs | null;
    interestRateType?: InterestRateTypeEnum;
    basisOfInterestRate?: string;
    dipDateSubmittedToLender?: Date | null;
    dipDateLenderResponded?: Date | null;
    dipDateResubmittedToLender?: Date | null;
    dipDateLenderWithdrew?: Date | null;
    latestMessageDateFromBroker?: Date | null;
    latestMessageDateFromLender?: Date | null;
    isLenderReviewComplete?: boolean;
    isBrokerReviewComplete?: boolean;
    preferredLenderContactEmail?: string;
    assignedLenderUserId?: number | null;
    id: number;
    caseId?: number;
    lenderId?: number;
    productId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_CaseLenderUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_CaseLenderUpdate[];
}

/** CaseLender without PKs and database generated properties and with all properties optional */
export interface CaseLenderUpdateWithoutPKs {
    case?: CaseUpdateWithoutPKs | null;
    lender?: LenderUpdateWithoutPKs | null;
    productRef?: string;
    caseLenderState?: CaseLenderStateEnum;
    originalTotalGrossLoan?: number | null;
    totalGrossLoan?: number;
    originalBuildLoan?: number | null;
    buildLoan?: number;
    originalLandLoan?: number | null;
    landLoan?: number;
    lenderArrangementFee?: number;
    originalLenderArrangementFeePercent?: number;
    lenderArrangementFeePercent?: number;
    originalInterestRate?: number;
    interestRate?: number;
    interestCoverAllocation?: number;
    lenderExitFee?: number;
    originalLenderExitFeePercent?: number;
    lenderExitFeePercent?: number;
    originalProfessionalFeesEstimate?: number | null;
    professionalFeesEstimate?: number;
    lenderComments?: string;
    borrowerComments?: string;
    lenderRejectReason?: string;
    lenderAdditionalRequirements?: string;
    originalGDV?: number;
    originalBuildTerm?: number;
    originalLoanTerm?: number;
    originalNetLoan?: number | null;
    originalTotalLenderCosts?: number | null;
    originalTrueMonthlyCost?: number | null;
    originalDeposit?: number | null;
    originalProfit?: number | null;
    originalROCE?: number | null;
    isBidAccepted?: boolean | null;
    lenderRequiresSiteVisit?: boolean;
    lenderRequiresInPersonMeeting?: boolean;
    lenderRequiresVideoMeeting?: boolean;
    lenderHasOwnDeclaration?: boolean;
    lenderRequiresProofOfIncome?: boolean;
    lenderRequiresIncomeAndExpenditure?: boolean;
    contactName?: string;
    contactEmail?: string;
    contactWorkPhoneNumber?: string;
    contactMobilePhoneNumber?: string;
    applyTsAndCs?: boolean;
    product?: ProductUpdateWithoutPKs | null;
    interestRateType?: InterestRateTypeEnum;
    basisOfInterestRate?: string;
    dipDateSubmittedToLender?: Date | null;
    dipDateLenderResponded?: Date | null;
    dipDateResubmittedToLender?: Date | null;
    dipDateLenderWithdrew?: Date | null;
    latestMessageDateFromBroker?: Date | null;
    latestMessageDateFromLender?: Date | null;
    isLenderReviewComplete?: boolean;
    isBrokerReviewComplete?: boolean;
    preferredLenderContactEmail?: string;
    assignedLenderUserId?: number | null;
    caseId?: number;
    lenderId?: number;
    productId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_CaseLenderUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_CaseLenderUpdate[];
}

export interface CaseMember {
    /** Order */
    order: number;
    /** First Name */
    firstName: string;
    /** Surname */
    surname: string;
    /** Email */
    email: string;
    /** Ownership Percentage */
    ownershipPercentage: number;
    /** Developed Property Before */
    developedPropertyBefore: boolean;
    /** How many development projects have they completed in there own name */
    developedPropertyBeforeNumber: number;
    /** Developed Property Before Estimate of Number or Actual */
    developedPropertyEstimate: boolean;
    /** How many residential development projects have they completed */
    developedResidentialPropertyCompletedNumber: number;
    /** How many commercial development projects have they completed */
    developedCommercialPropertyCompletedNumber: number;
    /** Professions worked in */
    professionsWorkedIn: ProfessionsEnum;
    /** # Years worked as architect */
    yearsWorkedInProfessionsListArchitect: number;
    /** # Years worked as Builder */
    yearsWorkedInProfessionsListBuilder: number;
    /** # Years worked as Carpenter */
    yearsWorkedInProfessionsListCarpenter: number;
    /** # Years worked as Electrician */
    yearsWorkedInProfessionsListElectrician: number;
    /** # Years worked as Planner */
    yearsWorkedInProfessionsListPlanner: number;
    /** # Years worked as Project Manager */
    yearsWorkedInProfessionsListProjectManager: number;
    /** # Years worked as Estate Agency */
    yearsWorkedInProfessionsListEstateAgency: number;
    /** # Years worked as Property Surveyor */
    yearsWorkedInProfessionsListPropertySurveyor: number;
    /** # Years worked as Quantity Surveyor */
    yearsWorkedInProfessionsListQuantitySurveyor: number;
    /** # Years worked as Structural Engineer */
    yearsWorkedInProfessionsListStructuralEngineer: number;
    /** Professional Qualifications */
    professionalQualifications: string;
    /** SKills In Order */
    sKillsInOrder: string;
    /** Length Of Time Been Developer */
    lengthOfTimeBeenDeveloper: number;
    /** Date Of Birth */
    dateOfBirth: Date | null;
    postalAddress: PostalAddress;
    case?: Case | null;
    qualifications?: Qualifications[];
    assetLiabilityItems?: AssetLiabilityItem[];
    phoneNumber: string;
    isApplicant: boolean;
    isPrimary: boolean;
    user?: ApplicationUser | null;
    uniqueRef: string;
    accessLevel: CaseAccessLevelEnum;
    isVerified: boolean;
    furtherInformation: string;
    hasCreditRefused: boolean | null;
    creditRefusedDetail: string;
    hasCreditConviction: boolean | null;
    creditConvictionDetails: string;
    hasCreditBankrupt: boolean | null;
    creditBankruptDetail: string;
    hasCreditCcj: boolean | null;
    creditCcjDetail: string;
    hasCreditDefaulted: boolean | null;
    creditDefaultedDetail: string;
    hasCreditRepossessed: boolean | null;
    creditRepossessedDetail: string;
    hasCreditStepInRightsExercised: boolean | null;
    creditStepInRightsExercisedDetail: string;
    hasCreditSanctioned: boolean | null;
    creditSanctionedDetail: string;
    hasCreditRelated: boolean | null;
    creditRelatedDetail: string;
    hasCreditWelfare: boolean | null;
    creditWelfareDetail: string;
    addressHistory: string;
    nationality: string;
    ukResident: boolean | null;
    visaStatus: string;
    yearsInUK: number | null;
    currentAddressFrom: Date | null;
    sendCaseUpdates: boolean;
    id: number;
    caseId: number | null;
    userId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** CaseMember without database generated properties */
export interface CaseMemberInsert {
    /** Order */
    order?: number;
    /** First Name */
    firstName?: string;
    /** Surname */
    surname?: string;
    /** Email */
    email?: string;
    /** Ownership Percentage */
    ownershipPercentage?: number;
    /** Developed Property Before */
    developedPropertyBefore?: boolean;
    /** How many development projects have they completed in there own name */
    developedPropertyBeforeNumber?: number;
    /** Developed Property Before Estimate of Number or Actual */
    developedPropertyEstimate?: boolean;
    /** How many residential development projects have they completed */
    developedResidentialPropertyCompletedNumber?: number;
    /** How many commercial development projects have they completed */
    developedCommercialPropertyCompletedNumber?: number;
    /** Professions worked in */
    professionsWorkedIn?: ProfessionsEnum;
    /** # Years worked as architect */
    yearsWorkedInProfessionsListArchitect?: number;
    /** # Years worked as Builder */
    yearsWorkedInProfessionsListBuilder?: number;
    /** # Years worked as Carpenter */
    yearsWorkedInProfessionsListCarpenter?: number;
    /** # Years worked as Electrician */
    yearsWorkedInProfessionsListElectrician?: number;
    /** # Years worked as Planner */
    yearsWorkedInProfessionsListPlanner?: number;
    /** # Years worked as Project Manager */
    yearsWorkedInProfessionsListProjectManager?: number;
    /** # Years worked as Estate Agency */
    yearsWorkedInProfessionsListEstateAgency?: number;
    /** # Years worked as Property Surveyor */
    yearsWorkedInProfessionsListPropertySurveyor?: number;
    /** # Years worked as Quantity Surveyor */
    yearsWorkedInProfessionsListQuantitySurveyor?: number;
    /** # Years worked as Structural Engineer */
    yearsWorkedInProfessionsListStructuralEngineer?: number;
    /** Professional Qualifications */
    professionalQualifications?: string;
    /** SKills In Order */
    sKillsInOrder?: string;
    /** Length Of Time Been Developer */
    lengthOfTimeBeenDeveloper?: number;
    /** Date Of Birth */
    dateOfBirth?: Date | null;
    postalAddress: PostalAddress;
    case?: CaseInsert | null;
    qualifications?: QualificationsInsert[];
    assetLiabilityItems?: AssetLiabilityItemInsert[];
    phoneNumber?: string;
    isApplicant?: boolean;
    isPrimary?: boolean;
    user?: ApplicationUserInsert | null;
    uniqueRef?: string;
    accessLevel?: CaseAccessLevelEnum;
    isVerified?: boolean;
    furtherInformation?: string;
    hasCreditRefused?: boolean | null;
    creditRefusedDetail?: string;
    hasCreditConviction?: boolean | null;
    creditConvictionDetails?: string;
    hasCreditBankrupt?: boolean | null;
    creditBankruptDetail?: string;
    hasCreditCcj?: boolean | null;
    creditCcjDetail?: string;
    hasCreditDefaulted?: boolean | null;
    creditDefaultedDetail?: string;
    hasCreditRepossessed?: boolean | null;
    creditRepossessedDetail?: string;
    hasCreditStepInRightsExercised?: boolean | null;
    creditStepInRightsExercisedDetail?: string;
    hasCreditSanctioned?: boolean | null;
    creditSanctionedDetail?: string;
    hasCreditRelated?: boolean | null;
    creditRelatedDetail?: string;
    hasCreditWelfare?: boolean | null;
    creditWelfareDetail?: string;
    addressHistory?: string;
    nationality?: string;
    ukResident?: boolean | null;
    visaStatus?: string;
    yearsInUK?: number | null;
    currentAddressFrom?: Date | null;
    sendCaseUpdates?: boolean;
    caseId?: number | null;
    userId?: number | null;
}

export interface CaseMemberPageWithTotalCountDTO {
    list?: CaseMember[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** CaseMember with all properties optional except PKs */
export interface CaseMemberUpdate {
    /** Order */
    order?: number;
    /** First Name */
    firstName?: string;
    /** Surname */
    surname?: string;
    /** Email */
    email?: string;
    /** Ownership Percentage */
    ownershipPercentage?: number;
    /** Developed Property Before */
    developedPropertyBefore?: boolean;
    /** How many development projects have they completed in there own name */
    developedPropertyBeforeNumber?: number;
    /** Developed Property Before Estimate of Number or Actual */
    developedPropertyEstimate?: boolean;
    /** How many residential development projects have they completed */
    developedResidentialPropertyCompletedNumber?: number;
    /** How many commercial development projects have they completed */
    developedCommercialPropertyCompletedNumber?: number;
    /** Professions worked in */
    professionsWorkedIn?: ProfessionsEnum;
    /** # Years worked as architect */
    yearsWorkedInProfessionsListArchitect?: number;
    /** # Years worked as Builder */
    yearsWorkedInProfessionsListBuilder?: number;
    /** # Years worked as Carpenter */
    yearsWorkedInProfessionsListCarpenter?: number;
    /** # Years worked as Electrician */
    yearsWorkedInProfessionsListElectrician?: number;
    /** # Years worked as Planner */
    yearsWorkedInProfessionsListPlanner?: number;
    /** # Years worked as Project Manager */
    yearsWorkedInProfessionsListProjectManager?: number;
    /** # Years worked as Estate Agency */
    yearsWorkedInProfessionsListEstateAgency?: number;
    /** # Years worked as Property Surveyor */
    yearsWorkedInProfessionsListPropertySurveyor?: number;
    /** # Years worked as Quantity Surveyor */
    yearsWorkedInProfessionsListQuantitySurveyor?: number;
    /** # Years worked as Structural Engineer */
    yearsWorkedInProfessionsListStructuralEngineer?: number;
    /** Professional Qualifications */
    professionalQualifications?: string;
    /** SKills In Order */
    sKillsInOrder?: string;
    /** Length Of Time Been Developer */
    lengthOfTimeBeenDeveloper?: number;
    /** Date Of Birth */
    dateOfBirth?: Date | null;
    postalAddress?: PostalAddress;
    case?: CaseUpdateWithoutPKs | null;
    qualifications?: QualificationsUpdate[];
    assetLiabilityItems?: AssetLiabilityItemUpdate[];
    phoneNumber?: string;
    isApplicant?: boolean;
    isPrimary?: boolean;
    user?: ApplicationUserUpdateWithoutPKs | null;
    uniqueRef?: string;
    accessLevel?: CaseAccessLevelEnum;
    isVerified?: boolean;
    furtherInformation?: string;
    hasCreditRefused?: boolean | null;
    creditRefusedDetail?: string;
    hasCreditConviction?: boolean | null;
    creditConvictionDetails?: string;
    hasCreditBankrupt?: boolean | null;
    creditBankruptDetail?: string;
    hasCreditCcj?: boolean | null;
    creditCcjDetail?: string;
    hasCreditDefaulted?: boolean | null;
    creditDefaultedDetail?: string;
    hasCreditRepossessed?: boolean | null;
    creditRepossessedDetail?: string;
    hasCreditStepInRightsExercised?: boolean | null;
    creditStepInRightsExercisedDetail?: string;
    hasCreditSanctioned?: boolean | null;
    creditSanctionedDetail?: string;
    hasCreditRelated?: boolean | null;
    creditRelatedDetail?: string;
    hasCreditWelfare?: boolean | null;
    creditWelfareDetail?: string;
    addressHistory?: string;
    nationality?: string;
    ukResident?: boolean | null;
    visaStatus?: string;
    yearsInUK?: number | null;
    currentAddressFrom?: Date | null;
    sendCaseUpdates?: boolean;
    id: number;
    caseId?: number | null;
    userId?: number | null;
}

/** CaseMember without PKs and database generated properties and with all properties optional */
export interface CaseMemberUpdateWithoutPKs {
    /** Order */
    order?: number;
    /** First Name */
    firstName?: string;
    /** Surname */
    surname?: string;
    /** Email */
    email?: string;
    /** Ownership Percentage */
    ownershipPercentage?: number;
    /** Developed Property Before */
    developedPropertyBefore?: boolean;
    /** How many development projects have they completed in there own name */
    developedPropertyBeforeNumber?: number;
    /** Developed Property Before Estimate of Number or Actual */
    developedPropertyEstimate?: boolean;
    /** How many residential development projects have they completed */
    developedResidentialPropertyCompletedNumber?: number;
    /** How many commercial development projects have they completed */
    developedCommercialPropertyCompletedNumber?: number;
    /** Professions worked in */
    professionsWorkedIn?: ProfessionsEnum;
    /** # Years worked as architect */
    yearsWorkedInProfessionsListArchitect?: number;
    /** # Years worked as Builder */
    yearsWorkedInProfessionsListBuilder?: number;
    /** # Years worked as Carpenter */
    yearsWorkedInProfessionsListCarpenter?: number;
    /** # Years worked as Electrician */
    yearsWorkedInProfessionsListElectrician?: number;
    /** # Years worked as Planner */
    yearsWorkedInProfessionsListPlanner?: number;
    /** # Years worked as Project Manager */
    yearsWorkedInProfessionsListProjectManager?: number;
    /** # Years worked as Estate Agency */
    yearsWorkedInProfessionsListEstateAgency?: number;
    /** # Years worked as Property Surveyor */
    yearsWorkedInProfessionsListPropertySurveyor?: number;
    /** # Years worked as Quantity Surveyor */
    yearsWorkedInProfessionsListQuantitySurveyor?: number;
    /** # Years worked as Structural Engineer */
    yearsWorkedInProfessionsListStructuralEngineer?: number;
    /** Professional Qualifications */
    professionalQualifications?: string;
    /** SKills In Order */
    sKillsInOrder?: string;
    /** Length Of Time Been Developer */
    lengthOfTimeBeenDeveloper?: number;
    /** Date Of Birth */
    dateOfBirth?: Date | null;
    postalAddress?: PostalAddress;
    case?: CaseUpdateWithoutPKs | null;
    qualifications?: QualificationsUpdate[];
    assetLiabilityItems?: AssetLiabilityItemUpdate[];
    phoneNumber?: string;
    isApplicant?: boolean;
    isPrimary?: boolean;
    user?: ApplicationUserUpdateWithoutPKs | null;
    uniqueRef?: string;
    accessLevel?: CaseAccessLevelEnum;
    isVerified?: boolean;
    furtherInformation?: string;
    hasCreditRefused?: boolean | null;
    creditRefusedDetail?: string;
    hasCreditConviction?: boolean | null;
    creditConvictionDetails?: string;
    hasCreditBankrupt?: boolean | null;
    creditBankruptDetail?: string;
    hasCreditCcj?: boolean | null;
    creditCcjDetail?: string;
    hasCreditDefaulted?: boolean | null;
    creditDefaultedDetail?: string;
    hasCreditRepossessed?: boolean | null;
    creditRepossessedDetail?: string;
    hasCreditStepInRightsExercised?: boolean | null;
    creditStepInRightsExercisedDetail?: string;
    hasCreditSanctioned?: boolean | null;
    creditSanctionedDetail?: string;
    hasCreditRelated?: boolean | null;
    creditRelatedDetail?: string;
    hasCreditWelfare?: boolean | null;
    creditWelfareDetail?: string;
    addressHistory?: string;
    nationality?: string;
    ukResident?: boolean | null;
    visaStatus?: string;
    yearsInUK?: number | null;
    currentAddressFrom?: Date | null;
    sendCaseUpdates?: boolean;
    caseId?: number | null;
    userId?: number | null;
}

export interface CaseNote {
    user?: ApplicationUser | null;
    noteText: string;
    case?: Case;
    id: number;
    userId: number | null;
    caseId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** CaseNote without database generated properties */
export interface CaseNoteInsert {
    user?: ApplicationUserInsert | null;
    noteText?: string;
    case: CaseInsert | null;
    userId?: number | null;
    caseId: number;
}

export interface CaseNotePageWithTotalCountDTO {
    list?: CaseNote[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** CaseNote with all properties optional except PKs */
export interface CaseNoteUpdate {
    user?: ApplicationUserUpdateWithoutPKs | null;
    noteText?: string;
    case?: CaseUpdateWithoutPKs | null;
    id: number;
    userId?: number | null;
    caseId?: number;
}

/** CaseNote without PKs and database generated properties and with all properties optional */
export interface CaseNoteUpdateWithoutPKs {
    user?: ApplicationUserUpdateWithoutPKs | null;
    noteText?: string;
    case?: CaseUpdateWithoutPKs | null;
    userId?: number | null;
    caseId?: number;
}

export interface CasePageWithTotalCountDTO {
    list?: Case[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export enum CaseStatusEnum {
    NewCase = 0,
    InProgress = 1,
    UnderReview = 2,
    ReadyToSubmit = 3,
    SubmittedToLendersForHoT = 4,
    Applied = 5,
    Completed = 6,
    Dormant = 7,
    SubmittedToLendersPendingReview = 9,
    CreditApproved = 10,
    WithProfessionals = 11,
    ReadyToReSubmit = 12,
    SentToPackager = 13,
    Search = 999,
}

export interface CaseSummaryDTO {
    clientFirstName?: string;
    clientSurname?: string;
    clientEmail?: string;
    clientPhoneNumber?: string;
    caseName?: string;
    caseStatus?: CaseStatusEnum;
    developmentInputId?: number | null;
    caseID?: number | null;
    dealID?: number | null;
    client?: string;
    propertyType?: PropertyTypeEnum | null;
    location?: LocationEnum;
    landCost?: number | null;
    buildCost?: number | null;
    gdv?: number | null;
    lastUpdatedDateTime?: Date | null;
    uniqueRef?: string;
    brokerOrgName?: string;
    caseLenderState?: CaseLenderStateEnum;
    hasShortlist?: boolean;
    isOwner?: boolean;
    ownerUser?: string;
    isDevInputWithNoLogin?: boolean;
    isInvitedToCase?: boolean;
    isBidAccepted?: boolean;
    isInvitedAndHasReadonlyAccess?: boolean;
    brokerUserId?: number | null;
    brokerFullName?: string;
    productType?: ProductTypeEnum;
    organisationLinkName?: string;
    currentValue?: number | null;
    purchasePrice?: number | null;
    loanTerm?: number | null;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    maxLoanRequired?: boolean;
    netLoanRequired?: number | null;
    refinancedUnits?: number | null;
    lenderName?: string;
    loanRepaymentType?: LoanRepaymentTypeEnum | null;
    readonly loanRepaymentTypeText?: string;
    fixedRateTerm?: FixedRateTermEnum | null;
    readonly fixedRateTermText?: string;
    mortgageInterestType?: InterestRateTypeEnum | null;
    preferredLenderContactEmail?: string;
    lenderReferralUserDetails?: string;
    assignedLenderUserId?: number;
    isRegulatedBridging?: boolean;
    totalUnreadMessages?: number | null;
    dealLenderId?: number | null;
    shortReferredText?: string;
    referredText?: string;
    isReadOnly?: boolean;
    isReferredToConnect?: boolean;
    connectUserId?: number | null;
    isPreConnectArchived?: boolean;
}

/** Case with all properties optional except PKs */
export interface CaseUpdate {
    developmentInput?: DevelopmentInputUpdateWithoutPKs | null;
    developmentExperience?: ProjectOwnershipUpdateWithoutPKs | null;
    productResultList?: number | null;
    product?: ProductUpdateWithoutPKs | null;
    startingProduct?: ProductUpdateWithoutPKs | null;
    ownerUser?: string;
    paid?: boolean;
    payPalPaymentId?: string | null;
    caseStatus?: CaseStatusEnum;
    caseOverviewComplete?: boolean;
    developerExperienceComplete?: boolean;
    developmentAppraisalComplete?: boolean;
    developmentScheduleComplete?: boolean;
    applicationDetailsComplete?: boolean;
    attachments?: FileAttachmentUpdate[];
    caseNotes?: CaseNoteUpdate[];
    links?: ExternalLinksUpdate[];
    preAppSubmitted?: boolean;
    caseOverview?: string;
    teamMembers?: TeamMemberUpdate[];
    comparables?: ComparablePropertyUpdate[];
    caseLenders?: CaseLenderUpdate[];
    planningURL?: string;
    planningLocalAuthority?: string;
    planningReference?: string;
    planningDescription?: string;
    planningComplete?: boolean;
    teamMemberComplete?: boolean;
    comparablePropertiesComplete?: boolean;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    owners?: CaseMemberUpdate[];
    profilesComplete?: boolean;
    planningPermissionType?: PlanningPermissionTypeEnum;
    purchaseProcessType?: PurchaseProcessTypeEnum;
    planningResponsibility?: PlanningResponsibilityEnum;
    planningResponsibilityDetail?: string;
    siteDescriptionOnCompletion?: string;
    guaranteeDescription?: string;
    buildProcurementType?: BuildProcurementTypeEnum;
    buildProcurementDescription?: string;
    depositDescription?: string;
    hasSetCompletionDate?: boolean;
    completionDate?: Date | null;
    furtherInformation?: string;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    submitTsAndCs?: boolean;
    executiveSummary?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    brokerCommissionPercent?: number | null;
    brokerPhoneNumber?: string;
    id: number;
    developmentInputId?: number | null;
    developmentExperienceId?: number | null;
    productId?: number | null;
    startingProductId?: number | null;
    brokerOrganisationId?: number | null;
    brokerUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_CaseUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_CaseUpdate[];
}

/** Case without PKs and database generated properties and with all properties optional */
export interface CaseUpdateWithoutPKs {
    developmentInput?: DevelopmentInputUpdateWithoutPKs | null;
    developmentExperience?: ProjectOwnershipUpdateWithoutPKs | null;
    productResultList?: number | null;
    product?: ProductUpdateWithoutPKs | null;
    startingProduct?: ProductUpdateWithoutPKs | null;
    ownerUser?: string;
    paid?: boolean;
    payPalPaymentId?: string | null;
    caseStatus?: CaseStatusEnum;
    caseOverviewComplete?: boolean;
    developerExperienceComplete?: boolean;
    developmentAppraisalComplete?: boolean;
    developmentScheduleComplete?: boolean;
    applicationDetailsComplete?: boolean;
    attachments?: FileAttachmentUpdate[];
    caseNotes?: CaseNoteUpdate[];
    links?: ExternalLinksUpdate[];
    preAppSubmitted?: boolean;
    caseOverview?: string;
    teamMembers?: TeamMemberUpdate[];
    comparables?: ComparablePropertyUpdate[];
    caseLenders?: CaseLenderUpdate[];
    planningURL?: string;
    planningLocalAuthority?: string;
    planningReference?: string;
    planningDescription?: string;
    planningComplete?: boolean;
    teamMemberComplete?: boolean;
    comparablePropertiesComplete?: boolean;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    owners?: CaseMemberUpdate[];
    profilesComplete?: boolean;
    planningPermissionType?: PlanningPermissionTypeEnum;
    purchaseProcessType?: PurchaseProcessTypeEnum;
    planningResponsibility?: PlanningResponsibilityEnum;
    planningResponsibilityDetail?: string;
    siteDescriptionOnCompletion?: string;
    guaranteeDescription?: string;
    buildProcurementType?: BuildProcurementTypeEnum;
    buildProcurementDescription?: string;
    depositDescription?: string;
    hasSetCompletionDate?: boolean;
    completionDate?: Date | null;
    furtherInformation?: string;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    submitTsAndCs?: boolean;
    executiveSummary?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    brokerCommissionPercent?: number | null;
    brokerPhoneNumber?: string;
    developmentInputId?: number | null;
    developmentExperienceId?: number | null;
    productId?: number | null;
    startingProductId?: number | null;
    brokerOrganisationId?: number | null;
    brokerUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_CaseUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_CaseUpdate[];
}

export enum ChargeTypeEnum {
    None = 0,
    FirstCharge = 1,
    SecondCharge = 2,
}

export interface ClaimBaseDTO {
    claimType?: CustomClaimsTypesEnum;
    claimValue?: number;
    priorityOfPermission?: number;
    allow?: boolean;
}

export interface ClaimEnumsInApplicationUser {
    id: number;
    claimType: CustomClaimsTypesEnum;
    claimValue: number;
    priorityOfPermission: number;
    allow: boolean;
    recordId: number;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: ApplicationUser;
}

export interface ClaimEnumsInApplicationUserGroup {
    id: number;
    claimType: CustomClaimsTypesEnum;
    claimValue: number;
    priorityOfPermission: number;
    allow: boolean;
    recordId: number;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: ApplicationUserGroup;
}

/** ClaimEnumsInApplicationUserGroup without database generated properties */
export interface ClaimEnumsInApplicationUserGroupInsert {
    claimType?: CustomClaimsTypesEnum;
    claimValue?: number;
    priorityOfPermission?: number;
    allow?: boolean;
    recordId?: number;
    record: ApplicationUserGroupInsert;
}

/** ClaimEnumsInApplicationUserGroup with all properties optional except PKs */
export interface ClaimEnumsInApplicationUserGroupUpdate {
    id: number;
    claimType?: CustomClaimsTypesEnum;
    claimValue?: number;
    priorityOfPermission?: number;
    allow?: boolean;
    recordId?: number;
    record?: ApplicationUserGroupUpdateWithoutPKs;
}

/** ClaimEnumsInApplicationUserGroup without PKs and database generated properties and with all properties optional */
export interface ClaimEnumsInApplicationUserGroupUpdateWithoutPKs {
    claimType?: CustomClaimsTypesEnum;
    claimValue?: number;
    priorityOfPermission?: number;
    allow?: boolean;
    recordId?: number;
    record?: ApplicationUserGroupUpdateWithoutPKs;
}

/** ClaimEnumsInApplicationUser without database generated properties */
export interface ClaimEnumsInApplicationUserInsert {
    claimType?: CustomClaimsTypesEnum;
    claimValue?: number;
    priorityOfPermission?: number;
    allow?: boolean;
    recordId?: number;
    record: ApplicationUserInsert;
}

/** ClaimEnumsInApplicationUser with all properties optional except PKs */
export interface ClaimEnumsInApplicationUserUpdate {
    id: number;
    claimType?: CustomClaimsTypesEnum;
    claimValue?: number;
    priorityOfPermission?: number;
    allow?: boolean;
    recordId?: number;
    record?: ApplicationUserUpdateWithoutPKs;
}

/** ClaimEnumsInApplicationUser without PKs and database generated properties and with all properties optional */
export interface ClaimEnumsInApplicationUserUpdateWithoutPKs {
    claimType?: CustomClaimsTypesEnum;
    claimValue?: number;
    priorityOfPermission?: number;
    allow?: boolean;
    recordId?: number;
    record?: ApplicationUserUpdateWithoutPKs;
}

export interface ClaimEnumsInClaimGroup {
    id: number;
    claimType: CustomClaimsTypesEnum;
    claimValue: number;
    priorityOfPermission: number;
    allow: boolean;
    recordId: number;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: ClaimGroup;
}

/** ClaimEnumsInClaimGroup without database generated properties */
export interface ClaimEnumsInClaimGroupInsert {
    claimType?: CustomClaimsTypesEnum;
    claimValue?: number;
    priorityOfPermission?: number;
    allow?: boolean;
    recordId?: number;
    record: ClaimGroupInsert;
}

/** ClaimEnumsInClaimGroup with all properties optional except PKs */
export interface ClaimEnumsInClaimGroupUpdate {
    id: number;
    claimType?: CustomClaimsTypesEnum;
    claimValue?: number;
    priorityOfPermission?: number;
    allow?: boolean;
    recordId?: number;
    record?: ClaimGroupUpdateWithoutPKs;
}

/** ClaimEnumsInClaimGroup without PKs and database generated properties and with all properties optional */
export interface ClaimEnumsInClaimGroupUpdateWithoutPKs {
    claimType?: CustomClaimsTypesEnum;
    claimValue?: number;
    priorityOfPermission?: number;
    allow?: boolean;
    recordId?: number;
    record?: ClaimGroupUpdateWithoutPKs;
}

export interface ClaimEnumsToAddUpdateDeleteDTO {
    claimSets?: number[];
    claimBaseToAddUpdate?: ClaimBaseDTO[];
    claimEnumsToRemoveValue?: number[];
    removeExistingUnMentionedClaimBase?: boolean;
}

export interface ClaimGroup {
    id: number;
    name: string;
    builtInGroup: boolean;
    claimEnumsInClaimGroups?: ClaimEnumsInClaimGroup[];
    claimGroupsInApplicationUserGroups?: ClaimGroupsInApplicationUserGroup[];
    claimGroupsInApplicationUsers?: ClaimGroupsInApplicationUser[];
    claimGroupsInClaimGroups?: ClaimGroupsInClaimGroup[];
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

export interface ClaimGroupAddUpdateDeleteDTO {
    claimGroupSets?: number[];
    claimGroupsToAddUpdate?: ClaimGroup[];
    claimGroupsToRemove?: number[];
    removeExistingUnMentionedClaimGroups?: boolean;
}

/** ClaimGroup without database generated properties */
export interface ClaimGroupInsert {
    name: string;
    builtInGroup?: boolean;
    claimEnumsInClaimGroups?: ClaimEnumsInClaimGroupInsert[] | null;
    claimGroupsInApplicationUserGroups?: ClaimGroupsInApplicationUserGroupInsert[] | null;
    claimGroupsInApplicationUsers?: ClaimGroupsInApplicationUserInsert[] | null;
    claimGroupsInClaimGroups?: ClaimGroupsInClaimGroupInsert[] | null;
}

export interface ClaimGroupPageWithTotalCountDTO {
    list?: ClaimGroup[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** ClaimGroup with all properties optional except PKs */
export interface ClaimGroupUpdate {
    id: number;
    name?: string;
    builtInGroup?: boolean;
    claimEnumsInClaimGroups?: ClaimEnumsInClaimGroupUpdate[] | null;
    claimGroupsInApplicationUserGroups?: ClaimGroupsInApplicationUserGroupUpdate[] | null;
    claimGroupsInApplicationUsers?: ClaimGroupsInApplicationUserUpdate[] | null;
    claimGroupsInClaimGroups?: ClaimGroupsInClaimGroupUpdate[] | null;
}

/** ClaimGroup without PKs and database generated properties and with all properties optional */
export interface ClaimGroupUpdateWithoutPKs {
    name?: string;
    builtInGroup?: boolean;
    claimEnumsInClaimGroups?: ClaimEnumsInClaimGroupUpdate[] | null;
    claimGroupsInApplicationUserGroups?: ClaimGroupsInApplicationUserGroupUpdate[] | null;
    claimGroupsInApplicationUsers?: ClaimGroupsInApplicationUserUpdate[] | null;
    claimGroupsInClaimGroups?: ClaimGroupsInClaimGroupUpdate[] | null;
}

export interface ClaimGroupsInApplicationUser {
    id: number;
    claimGroup?: ClaimGroup;
    claimGroupId: number;
    record?: ApplicationUser;
    recordId: number;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

export interface ClaimGroupsInApplicationUserGroup {
    id: number;
    claimGroup?: ClaimGroup;
    claimGroupId: number;
    record?: ApplicationUserGroup;
    recordId: number;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

/** ClaimGroupsInApplicationUserGroup without database generated properties */
export interface ClaimGroupsInApplicationUserGroupInsert {
    claimGroup: ClaimGroupInsert;
    claimGroupId?: number;
    record: ApplicationUserGroupInsert;
    recordId?: number;
}

/** ClaimGroupsInApplicationUserGroup with all properties optional except PKs */
export interface ClaimGroupsInApplicationUserGroupUpdate {
    id: number;
    claimGroup?: ClaimGroupUpdateWithoutPKs;
    claimGroupId?: number;
    record?: ApplicationUserGroupUpdateWithoutPKs;
    recordId?: number;
}

/** ClaimGroupsInApplicationUserGroup without PKs and database generated properties and with all properties optional */
export interface ClaimGroupsInApplicationUserGroupUpdateWithoutPKs {
    claimGroup?: ClaimGroupUpdateWithoutPKs;
    claimGroupId?: number;
    record?: ApplicationUserGroupUpdateWithoutPKs;
    recordId?: number;
}

/** ClaimGroupsInApplicationUser without database generated properties */
export interface ClaimGroupsInApplicationUserInsert {
    claimGroup: ClaimGroupInsert;
    claimGroupId?: number;
    record: ApplicationUserInsert;
    recordId?: number;
}

/** ClaimGroupsInApplicationUser with all properties optional except PKs */
export interface ClaimGroupsInApplicationUserUpdate {
    id: number;
    claimGroup?: ClaimGroupUpdateWithoutPKs;
    claimGroupId?: number;
    record?: ApplicationUserUpdateWithoutPKs;
    recordId?: number;
}

/** ClaimGroupsInApplicationUser without PKs and database generated properties and with all properties optional */
export interface ClaimGroupsInApplicationUserUpdateWithoutPKs {
    claimGroup?: ClaimGroupUpdateWithoutPKs;
    claimGroupId?: number;
    record?: ApplicationUserUpdateWithoutPKs;
    recordId?: number;
}

export interface ClaimGroupsInClaimGroup {
    id: number;
    claimGroup?: ClaimGroup;
    claimGroupId: number;
    record?: ClaimGroup;
    recordId: number;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

/** ClaimGroupsInClaimGroup without database generated properties */
export interface ClaimGroupsInClaimGroupInsert {
    claimGroup: ClaimGroupInsert;
    claimGroupId?: number;
    record: ClaimGroupInsert;
    recordId?: number;
}

/** ClaimGroupsInClaimGroup with all properties optional except PKs */
export interface ClaimGroupsInClaimGroupUpdate {
    id: number;
    claimGroup?: ClaimGroupUpdateWithoutPKs;
    claimGroupId?: number;
    record?: ClaimGroupUpdateWithoutPKs;
    recordId?: number;
}

/** ClaimGroupsInClaimGroup without PKs and database generated properties and with all properties optional */
export interface ClaimGroupsInClaimGroupUpdateWithoutPKs {
    claimGroup?: ClaimGroupUpdateWithoutPKs;
    claimGroupId?: number;
    record?: ClaimGroupUpdateWithoutPKs;
    recordId?: number;
}

export enum ClassUseEnum {
    A1E = 2,
    A2E = 4,
    A3E = 8,
    A4Sui = 16,
    A5Sui = 32,
    B1E = 64,
    B2 = 128,
    B8 = 256,
    C1 = 512,
    C2 = 1024,
    C3 = 2048,
    C4 = 4096,
    D1Ee = 8192,
    D2Ed = 16384,
    C2A = 32768,
    D1Ef = 65536,
    D1F1 = 131072,
    D2F2c = 264144,
    D2F2d = 524288,
    C5 = 1048576,
    E = 2097152,
    F1 = 4194304,
    F2 = 8388608,
    SuiGenerisUnique = 16777216,
}

export interface Client {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
    clientUserId: number | null;
    brokerOrganisation?: Organisation | null;
    dateOfBirth: Date | null;
    postalAddress: PostalAddress;
    id: number;
    brokerOrganisationId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** Client without database generated properties */
export interface ClientInsert {
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    email?: string;
    clientUserId?: number | null;
    brokerOrganisation?: OrganisationInsert | null;
    dateOfBirth?: Date | null;
    postalAddress: PostalAddress;
    brokerOrganisationId?: number | null;
}

export interface ClientPageWithTotalCountDTO {
    list?: Client[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface ClientRegistrationRequest {
    user: ApplicationUser;
    password: string;
    inviteCode?: string | null;
    orgUniqueRef?: string;
    dealClientUniqueRef?: string | null;
}

/** Client with all properties optional except PKs */
export interface ClientUpdate {
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    email?: string;
    clientUserId?: number | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    dateOfBirth?: Date | null;
    postalAddress?: PostalAddress;
    id: number;
    brokerOrganisationId?: number | null;
}

/** Client without PKs and database generated properties and with all properties optional */
export interface ClientUpdateWithoutPKs {
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    email?: string;
    clientUserId?: number | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    dateOfBirth?: Date | null;
    postalAddress?: PostalAddress;
    brokerOrganisationId?: number | null;
}

export enum CofEnum {
    None = 0,
    Base = 1,
    Libor1Month = 2,
    Libor3Month = 3,
    Other = 4,
    Sonia = 5,
    OwnSVR = 6,
}

export interface CommercialDeal {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold: boolean;
    name: string;
    uniqueRef: string;
    brokerUser?: ApplicationUser | null;
    brokerOrganisation?: Organisation | null;
    planningPermissionType: PlanningPermissionTypeEnum;
    productType: ProductTypeEnum;
    productFamily: ProductFamilyEnum;
    status: CaseStatusEnum;
    applicationFee: number;
    isApplicationFeePaid: number;
    dealClients?: DealClient[];
    dealLenders?: DealLender[];
    attachments?: DealFileAttachment[];
    dealNotes?: DealNote[];
    dealSchedules?: DealSchedule[];
    /** External Reference */
    externalRef: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq: number;
    /** Loan Required(LoanReq) */
    netLoanRequired: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy: ExitStrategyEnum | null;
    exitStrategyOther: string;
    /** Property Location */
    locations: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses: number | null;
    /** How many flats? */
    howManyFlats: number | null;
    /** Class Uses */
    classUses: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts: number;
    /** Build Costs(BuildCosts) */
    buildCosts: number;
    /** Continguency(Contingency) */
    contingency: number;
    /** Completion Date(CompletionDate) */
    completionDate: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts: number;
    parentCaseToAssoicateWithOnCreation: number | null;
    f_IsFirstTimeDeveloper: boolean | null;
    f_NumberOfPreviousDevelopments: PreviousDevelopmentsEnum | null;
    f_IsPersonalName: boolean | null;
    f_IsOffshoreCompany: boolean | null;
    f_IsMainShareholderOverseas: boolean | null;
    f_PersonalGuaranteeLevel: number | null;
    f_IsGradeOneListed: boolean | null;
    f_IsGradeTwoListed: boolean | null;
    f_MaxHouseSalesPrice: number | null;
    f_MaxFlatUnitPrice: number | null;
    f_MaxSqFtSalePrice: number | null;
    f_MaxSqFtSalePriceFlats: number | null;
    f_MaxPercCommercialForMixedUse: number | null;
    f_MaxNumberOfUnits: number | null;
    f_IsChargeOnAdditionalProperty: boolean | null;
    f_IsFixedRate: boolean | null;
    personalGuaranteeMin: number | null;
    personalGuaranteeMax: number | null;
    f_IsTimberFrameConstruction: boolean | null;
    f_IsConcreteConstruction: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction: string;
    /** Pension Type */
    pensionType: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners: number;
    /** Excluded Lenders */
    excludedLenders: string;
    isCaseOverviewSectionComplete: boolean;
    submitTsAndCs: boolean;
    siteDetails: string;
    solicitorDetails: string;
    accountantDetails: string;
    nameOfUKLimitedLiabilityCompany: string;
    ukLimitedLiabilityPartnershipNumber: string;
    previousLenders: string;
    propertyTenure: TenureEnum | null;
    gdv: number | null;
    ltc: number | null;
    ltgdv: number | null;
    chargeRequired: ChargeTypeEnum;
    currentvalue: number | null;
    hasPendingSubmitWithCriteriaChange: boolean;
    maxLoanRequired: boolean;
    additionalSecurity: boolean;
    additionalSecurityInfo: string;
    organisationLink?: OrganisationLink | null;
    leadSourceUrl: string;
    ownOrPurchase: OwnOrPurchaseEnum | null;
    isFamilyInResidence: YesNoMaybe | null;
    loanCompletionType: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete: boolean | null;
    isPropertySectionComplete: boolean | null;
    isLoanSectionComplete: boolean | null;
    f_IsRetypedValuation: boolean | null;
    projectDescription: string;
    isTenantedBuilding: boolean | null;
    numberOfTenancies: number | null;
    yearsLeftOnLease: number | null;
    propertyAddress: PostalAddress;
    showLenderInfoBrokerOverride: boolean;
    postcodeSearchString: string;
    lenderUser?: ApplicationUser | null;
    planningStatusAtEndOfLoan: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy: boolean | null;
    companyCcjOrBankruptcyDetail: string;
    sortBy: SortByEnum;
    brokerCommissionPercent: number | null;
    originatorRoleType: OriginatorRoleTypeEnum;
    originatorOrganisationId: number | null;
    originatorLenderId: number | null;
    sourceType: DealSourceTypeEnum;
    lenderReferralUserId: number | null;
    lenderReferralLenderId: number | null;
    brokerPhoneNumber: string;
    f_HasAdverseCredit: boolean | null;
    f_MaxCommercialFloorspace: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect: boolean;
    connectUser?: ApplicationUser | null;
    isPreConnectArchived: boolean;
    f_PersonalGuaranteeMin: number | null;
    f_PersonalGuaranteeMax: number | null;
    brokerUserFullName: string;
    brokerOrganisationName: string;
    brokerUserEmail: string;
    hasOwnOrPurchase: boolean;
    hasPostcode: boolean;
    propertyValue: number;
    dealClient: DealClient;
    hasIsFamilyInResidence: boolean;
    originalPurchasePrice: number;
    id: number;
    brokerUserId: number | null;
    brokerOrganisationId: number | null;
    organisationLinkId: number | null;
    lenderUserId: number | null;
    connectUserId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_Deal[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_Deal[];
    currentPropertyType: PropertyTypeEnum | null;
    timeLeftOnLease: TimeLeftOnLeaseEnum | null;
    grossMonthlyRentalIncome: number | null;
    loanRepaymentType: LoanRepaymentTypeEnum | null;
    fixedRateTerm: FixedRateTermEnum | null;
    bedroomCount: number | null;
    unitCount: number | null;
    mortgageInterestType: InterestRateTypeEnum | null;
    borrowingEntityType: BorrowingEntityTypeEnum | null;
    f_MinOwnershipPeriod: number | null;
    f_MaxIndividualUnitPrice: number | null;
    f_MaxNumberOfBedrooms: number | null;
    f_IsInterestOnly: boolean | null;
    f_IsCapitalAndRepayment: boolean | null;
    f_AcceptableEPCRating: EPCRatingTypeEnum | null;
    f_EWS1AcceptableType: EWS1GradeTypeEnum | null;
    f_MaxAgeAtEndOfMortgageTerm: number | null;
    f_MaxAgeAtStartOfMortgageTerm: number | null;
    leaseDetails: string;
    tradingPeriod: TradingPeriodEnum | null;
    adjustedAnnualEBITDA: number | null;
    tradingStartDate: Date | null;
    businessType: string;
    includesArrangementFee: boolean;
    loanToValue: number | null;
    arrangementFee: number | null;
    interestRate: number | null;
    comparisonList: CommercialLenderResultSummaryDTO[];
}

/** CommercialDeal without database generated properties */
export interface CommercialDealInsert {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserInsert | null;
    brokerOrganisation?: OrganisationInsert | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientInsert[];
    dealLenders?: DealLenderInsert[];
    attachments?: DealFileAttachmentInsert[];
    dealNotes?: DealNoteInsert[];
    dealSchedules?: DealScheduleInsert[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkInsert | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserInsert | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserInsert | null;
    isPreConnectArchived?: boolean;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealInsert[];
    currentPropertyType?: PropertyTypeEnum | null;
    timeLeftOnLease?: TimeLeftOnLeaseEnum | null;
    grossMonthlyRentalIncome?: number | null;
    loanRepaymentType?: LoanRepaymentTypeEnum | null;
    fixedRateTerm?: FixedRateTermEnum | null;
    bedroomCount?: number | null;
    unitCount?: number | null;
    mortgageInterestType?: InterestRateTypeEnum | null;
    borrowingEntityType?: BorrowingEntityTypeEnum | null;
    f_MinOwnershipPeriod?: number | null;
    f_MaxIndividualUnitPrice?: number | null;
    f_MaxNumberOfBedrooms?: number | null;
    f_IsInterestOnly?: boolean | null;
    f_IsCapitalAndRepayment?: boolean | null;
    f_AcceptableEPCRating?: EPCRatingTypeEnum | null;
    f_EWS1AcceptableType?: EWS1GradeTypeEnum | null;
    f_MaxAgeAtEndOfMortgageTerm?: number | null;
    f_MaxAgeAtStartOfMortgageTerm?: number | null;
    leaseDetails?: string;
    tradingPeriod?: TradingPeriodEnum | null;
    adjustedAnnualEBITDA?: number | null;
    tradingStartDate?: Date | null;
    businessType?: string;
    includesArrangementFee?: boolean;
}

export interface CommercialDealPageWithTotalCountDTO {
    list?: CommercialDeal[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** CommercialDeal with all properties optional except PKs */
export interface CommercialDealUpdate {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientUpdate[];
    dealLenders?: DealLenderUpdate[];
    attachments?: DealFileAttachmentUpdate[];
    dealNotes?: DealNoteUpdate[];
    dealSchedules?: DealScheduleUpdate[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserUpdateWithoutPKs | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserUpdateWithoutPKs | null;
    isPreConnectArchived?: boolean;
    id: number;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealUpdate[];
    currentPropertyType?: PropertyTypeEnum | null;
    timeLeftOnLease?: TimeLeftOnLeaseEnum | null;
    grossMonthlyRentalIncome?: number | null;
    loanRepaymentType?: LoanRepaymentTypeEnum | null;
    fixedRateTerm?: FixedRateTermEnum | null;
    bedroomCount?: number | null;
    unitCount?: number | null;
    mortgageInterestType?: InterestRateTypeEnum | null;
    borrowingEntityType?: BorrowingEntityTypeEnum | null;
    f_MinOwnershipPeriod?: number | null;
    f_MaxIndividualUnitPrice?: number | null;
    f_MaxNumberOfBedrooms?: number | null;
    f_IsInterestOnly?: boolean | null;
    f_IsCapitalAndRepayment?: boolean | null;
    f_AcceptableEPCRating?: EPCRatingTypeEnum | null;
    f_EWS1AcceptableType?: EWS1GradeTypeEnum | null;
    f_MaxAgeAtEndOfMortgageTerm?: number | null;
    f_MaxAgeAtStartOfMortgageTerm?: number | null;
    leaseDetails?: string;
    tradingPeriod?: TradingPeriodEnum | null;
    adjustedAnnualEBITDA?: number | null;
    tradingStartDate?: Date | null;
    businessType?: string;
    includesArrangementFee?: boolean;
}

/** CommercialDeal without PKs and database generated properties and with all properties optional */
export interface CommercialDealUpdateWithoutPKs {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientUpdate[];
    dealLenders?: DealLenderUpdate[];
    attachments?: DealFileAttachmentUpdate[];
    dealNotes?: DealNoteUpdate[];
    dealSchedules?: DealScheduleUpdate[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserUpdateWithoutPKs | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserUpdateWithoutPKs | null;
    isPreConnectArchived?: boolean;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealUpdate[];
    currentPropertyType?: PropertyTypeEnum | null;
    timeLeftOnLease?: TimeLeftOnLeaseEnum | null;
    grossMonthlyRentalIncome?: number | null;
    loanRepaymentType?: LoanRepaymentTypeEnum | null;
    fixedRateTerm?: FixedRateTermEnum | null;
    bedroomCount?: number | null;
    unitCount?: number | null;
    mortgageInterestType?: InterestRateTypeEnum | null;
    borrowingEntityType?: BorrowingEntityTypeEnum | null;
    f_MinOwnershipPeriod?: number | null;
    f_MaxIndividualUnitPrice?: number | null;
    f_MaxNumberOfBedrooms?: number | null;
    f_IsInterestOnly?: boolean | null;
    f_IsCapitalAndRepayment?: boolean | null;
    f_AcceptableEPCRating?: EPCRatingTypeEnum | null;
    f_EWS1AcceptableType?: EWS1GradeTypeEnum | null;
    f_MaxAgeAtEndOfMortgageTerm?: number | null;
    f_MaxAgeAtStartOfMortgageTerm?: number | null;
    leaseDetails?: string;
    tradingPeriod?: TradingPeriodEnum | null;
    adjustedAnnualEBITDA?: number | null;
    tradingStartDate?: Date | null;
    businessType?: string;
    includesArrangementFee?: boolean;
}

export interface CommercialLenderResultSummaryDTO {
    productFamily?: ProductFamilyEnum;
    id?: number;
    grossLoan?: number;
    loanToCostGross?: number;
    netLoan?: number;
    loanToValueNet?: number;
    equityOrDeposit?: number;
    profit?: number | null;
    loanTerm?: number;
    lenderLogo?: string;
    loanLabel?: string;
    productID?: number | null;
    lenderID?: number;
    lenderName?: string;
    snapshot?: string;
    interest?: number;
    annualInterest?: number;
    monthlyInterest?: number;
    arrangementFee?: number;
    exitFee?: number;
    trueMonthlyCost?: number;
    additionalProductInfo?: string;
    selectedRowNumber?: number;
    isMatching?: boolean;
    isLargest?: boolean;
    isHighestROCE?: boolean;
    isLowestTrueMonthlyCost?: boolean;
    isDealLender?: boolean;
    dealLenderStatus?: CaseLenderStateEnum | null;
    debug1Flag?: boolean;
    debug1Info?: string;
    lenderInternalUrl?: string;
    logoURL?: string;
    avgLenderResponseTime?: number | null;
    productSourceType?: ProductSourceTypeEnum;
    externalProductId?: string | null;
    monthlyPayment?: number;
    arrangementFeePercOfValue?: number | null;
    loanToValue?: number;
    loanRepaymentType?: LoanRepaymentTypeEnum | null;
    mortgageInterestType?: string;
    propertyValue?: number;
    isFixedRate?: YesNoMaybe;
    fixedRateTerm?: FixedRateTermEnum;
    borrowingEntity?: BorrowingEntityTypeEnum | null;
    readonly fixedRateTermText?: string;
    readonly loanRepaymentTypeText?: string;
    readonly borrowingEntityText?: string;
}

export interface CommercialSearchResultsResponse {
    criteria?: CommercialDeal | null;
    results?: CommercialLenderResultSummaryDTO[] | null;
    hideDeal?: boolean;
    hasNoAccessToDeal?: boolean;
}

export interface ComparableProperty {
    case?: Case | null;
    propType: string;
    url: string;
    note: string;
    value: number;
    comments: string;
    isGoodComparable: boolean;
    id: number;
    caseId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** ComparableProperty without database generated properties */
export interface ComparablePropertyInsert {
    case?: CaseInsert | null;
    propType?: string;
    url?: string;
    note?: string;
    value?: number;
    comments?: string;
    isGoodComparable?: boolean;
    caseId?: number | null;
}

export interface ComparablePropertyPageWithTotalCountDTO {
    list?: ComparableProperty[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** ComparableProperty with all properties optional except PKs */
export interface ComparablePropertyUpdate {
    case?: CaseUpdateWithoutPKs | null;
    propType?: string;
    url?: string;
    note?: string;
    value?: number;
    comments?: string;
    isGoodComparable?: boolean;
    id: number;
    caseId?: number | null;
}

/** ComparableProperty without PKs and database generated properties and with all properties optional */
export interface ComparablePropertyUpdateWithoutPKs {
    case?: CaseUpdateWithoutPKs | null;
    propType?: string;
    url?: string;
    note?: string;
    value?: number;
    comments?: string;
    isGoodComparable?: boolean;
    caseId?: number | null;
}

export enum ConditionEnum {
    Good = 1,
    Fair = 2,
    Poor = 3,
}

export enum ContractLengthEnum {
    None = 0,
    Yearly = 1,
    TwoYearly = 2,
}

export enum CustomClaimsTypesEnum {
    ServerClaim = 1,
    UXClaim = 2,
    TableClaim = 4,
}

export interface CustomClaimsTypesEnumStringInt32DictionaryListTuple {
    item1: CustomClaimsTypesEnum;
    item2: { [key: string]: number; }[] | null;
}

export interface CustomClaimsTypesEnumStringInt32DictionaryStringTupleListTuple {
    item1: CustomClaimsTypesEnum;
    item2: StringInt32DictionaryStringTuple[] | null;
}

export interface DataMultiOwner_ApplicationUserGroup_Case {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: Case;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_Case without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_CaseInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: CaseInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

export interface DataMultiOwner_ApplicationUserGroup_CaseLender {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: CaseLender;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_CaseLender without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_CaseLenderInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: CaseLenderInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

/** DataMultiOwner_ApplicationUserGroup_CaseLender with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_CaseLenderUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: CaseLenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_CaseLender without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_CaseLenderUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: CaseLenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_Case with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_CaseUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: CaseUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_Case without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_CaseUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: CaseUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUserGroup_Deal {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: Deal;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

export interface DataMultiOwner_ApplicationUserGroup_DealFileAttachment {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DealFileAttachment;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_DealFileAttachment without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_DealFileAttachmentInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DealFileAttachmentInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

/** DataMultiOwner_ApplicationUserGroup_DealFileAttachment with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_DealFileAttachmentUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealFileAttachmentUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_DealFileAttachment without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_DealFileAttachmentUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealFileAttachmentUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_Deal without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_DealInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DealInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

export interface DataMultiOwner_ApplicationUserGroup_DealLender {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DealLender;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_DealLender without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_DealLenderInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DealLenderInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

/** DataMultiOwner_ApplicationUserGroup_DealLender with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_DealLenderUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealLenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_DealLender without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_DealLenderUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealLenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUserGroup_DealNote {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DealNote;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_DealNote without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_DealNoteInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DealNoteInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

/** DataMultiOwner_ApplicationUserGroup_DealNote with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_DealNoteUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealNoteUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_DealNote without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_DealNoteUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealNoteUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_Deal with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_DealUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_Deal without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_DealUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUserGroup_DevelopmentInput {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DevelopmentInput;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_DevelopmentInput without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_DevelopmentInputInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DevelopmentInputInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

export interface DataMultiOwner_ApplicationUserGroup_DevelopmentInputSchedule {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DevelopmentInputSchedule;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_DevelopmentInputSchedule without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_DevelopmentInputScheduleInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DevelopmentInputScheduleInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

/** DataMultiOwner_ApplicationUserGroup_DevelopmentInputSchedule with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_DevelopmentInputScheduleUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentInputScheduleUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_DevelopmentInputSchedule without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_DevelopmentInputScheduleUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentInputScheduleUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_DevelopmentInput with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_DevelopmentInputUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentInputUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_DevelopmentInput without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_DevelopmentInputUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentInputUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecord {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DevelopmentTrackRecord;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecord without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecordInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DevelopmentTrackRecordInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

/** DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecord with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecordUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentTrackRecordUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecord without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecordUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentTrackRecordUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUserGroup_FeedBack {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: FeedBack;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_FeedBack without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_FeedBackInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: FeedBackInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

/** DataMultiOwner_ApplicationUserGroup_FeedBack with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_FeedBackUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: FeedBackUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_FeedBack without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_FeedBackUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: FeedBackUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUserGroup_FileAttachment {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: FileAttachment;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_FileAttachment without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_FileAttachmentInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: FileAttachmentInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

/** DataMultiOwner_ApplicationUserGroup_FileAttachment with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_FileAttachmentUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: FileAttachmentUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_FileAttachment without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_FileAttachmentUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: FileAttachmentUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUserGroup_Introducer {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: Introducer;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_Introducer without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_IntroducerInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: IntroducerInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

/** DataMultiOwner_ApplicationUserGroup_Introducer with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_IntroducerUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: IntroducerUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_Introducer without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_IntroducerUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: IntroducerUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUserGroup_Lender {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: Lender;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_Lender without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_LenderInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: LenderInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

export interface DataMultiOwner_ApplicationUserGroup_LenderResult {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: LenderResult;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_LenderResult without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_LenderResultInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: LenderResultInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

/** DataMultiOwner_ApplicationUserGroup_LenderResult with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_LenderResultUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: LenderResultUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_LenderResult without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_LenderResultUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: LenderResultUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_Lender with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_LenderUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: LenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_Lender without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_LenderUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: LenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUserGroup_Organisation {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: Organisation;
    appUserOrAppUserGroup?: ApplicationUserGroup;
}

/** DataMultiOwner_ApplicationUserGroup_Organisation without database generated properties */
export interface DataMultiOwner_ApplicationUserGroup_OrganisationInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: OrganisationInsert;
    appUserOrAppUserGroup: ApplicationUserGroupInsert;
}

/** DataMultiOwner_ApplicationUserGroup_Organisation with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUserGroup_OrganisationUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: OrganisationUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUserGroup_Organisation without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUserGroup_OrganisationUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: OrganisationUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserGroupUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUser_Case {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: Case;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_Case without database generated properties */
export interface DataMultiOwner_ApplicationUser_CaseInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: CaseInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

export interface DataMultiOwner_ApplicationUser_CaseLender {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: CaseLender;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_CaseLender without database generated properties */
export interface DataMultiOwner_ApplicationUser_CaseLenderInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: CaseLenderInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

/** DataMultiOwner_ApplicationUser_CaseLender with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_CaseLenderUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: CaseLenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_CaseLender without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_CaseLenderUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: CaseLenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_Case with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_CaseUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: CaseUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_Case without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_CaseUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: CaseUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUser_Deal {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: Deal;
    appUserOrAppUserGroup?: ApplicationUser;
}

export interface DataMultiOwner_ApplicationUser_DealFileAttachment {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DealFileAttachment;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_DealFileAttachment without database generated properties */
export interface DataMultiOwner_ApplicationUser_DealFileAttachmentInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DealFileAttachmentInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

/** DataMultiOwner_ApplicationUser_DealFileAttachment with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_DealFileAttachmentUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealFileAttachmentUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_DealFileAttachment without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_DealFileAttachmentUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealFileAttachmentUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_Deal without database generated properties */
export interface DataMultiOwner_ApplicationUser_DealInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DealInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

export interface DataMultiOwner_ApplicationUser_DealLender {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DealLender;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_DealLender without database generated properties */
export interface DataMultiOwner_ApplicationUser_DealLenderInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DealLenderInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

/** DataMultiOwner_ApplicationUser_DealLender with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_DealLenderUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealLenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_DealLender without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_DealLenderUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealLenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUser_DealNote {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DealNote;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_DealNote without database generated properties */
export interface DataMultiOwner_ApplicationUser_DealNoteInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DealNoteInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

/** DataMultiOwner_ApplicationUser_DealNote with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_DealNoteUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealNoteUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_DealNote without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_DealNoteUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealNoteUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_Deal with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_DealUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_Deal without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_DealUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DealUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUser_DevelopmentInput {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DevelopmentInput;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_DevelopmentInput without database generated properties */
export interface DataMultiOwner_ApplicationUser_DevelopmentInputInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DevelopmentInputInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

export interface DataMultiOwner_ApplicationUser_DevelopmentInputSchedule {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DevelopmentInputSchedule;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_DevelopmentInputSchedule without database generated properties */
export interface DataMultiOwner_ApplicationUser_DevelopmentInputScheduleInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DevelopmentInputScheduleInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

/** DataMultiOwner_ApplicationUser_DevelopmentInputSchedule with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_DevelopmentInputScheduleUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentInputScheduleUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_DevelopmentInputSchedule without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_DevelopmentInputScheduleUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentInputScheduleUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_DevelopmentInput with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_DevelopmentInputUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentInputUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_DevelopmentInput without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_DevelopmentInputUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentInputUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUser_DevelopmentTrackRecord {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: DevelopmentTrackRecord;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_DevelopmentTrackRecord without database generated properties */
export interface DataMultiOwner_ApplicationUser_DevelopmentTrackRecordInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: DevelopmentTrackRecordInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

/** DataMultiOwner_ApplicationUser_DevelopmentTrackRecord with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_DevelopmentTrackRecordUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentTrackRecordUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_DevelopmentTrackRecord without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_DevelopmentTrackRecordUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: DevelopmentTrackRecordUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUser_FeedBack {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: FeedBack;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_FeedBack without database generated properties */
export interface DataMultiOwner_ApplicationUser_FeedBackInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: FeedBackInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

/** DataMultiOwner_ApplicationUser_FeedBack with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_FeedBackUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: FeedBackUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_FeedBack without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_FeedBackUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: FeedBackUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUser_FileAttachment {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: FileAttachment;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_FileAttachment without database generated properties */
export interface DataMultiOwner_ApplicationUser_FileAttachmentInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: FileAttachmentInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

/** DataMultiOwner_ApplicationUser_FileAttachment with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_FileAttachmentUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: FileAttachmentUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_FileAttachment without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_FileAttachmentUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: FileAttachmentUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUser_Introducer {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: Introducer;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_Introducer without database generated properties */
export interface DataMultiOwner_ApplicationUser_IntroducerInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: IntroducerInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

/** DataMultiOwner_ApplicationUser_Introducer with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_IntroducerUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: IntroducerUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_Introducer without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_IntroducerUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: IntroducerUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUser_Lender {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: Lender;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_Lender without database generated properties */
export interface DataMultiOwner_ApplicationUser_LenderInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: LenderInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

export interface DataMultiOwner_ApplicationUser_LenderResult {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: LenderResult;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_LenderResult without database generated properties */
export interface DataMultiOwner_ApplicationUser_LenderResultInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: LenderResultInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

/** DataMultiOwner_ApplicationUser_LenderResult with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_LenderResultUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: LenderResultUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_LenderResult without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_LenderResultUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: LenderResultUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_Lender with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_LenderUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: LenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_Lender without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_LenderUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: LenderUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

export interface DataMultiOwner_ApplicationUser_Organisation {
    id: number;
    recordId: number;
    appUserOrAppUserGroupId: number;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
    record?: Organisation;
    appUserOrAppUserGroup?: ApplicationUser;
}

/** DataMultiOwner_ApplicationUser_Organisation without database generated properties */
export interface DataMultiOwner_ApplicationUser_OrganisationInsert {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record: OrganisationInsert;
    appUserOrAppUserGroup: ApplicationUserInsert;
}

/** DataMultiOwner_ApplicationUser_Organisation with all properties optional except PKs */
export interface DataMultiOwner_ApplicationUser_OrganisationUpdate {
    id: number;
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: OrganisationUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

/** DataMultiOwner_ApplicationUser_Organisation without PKs and database generated properties and with all properties optional */
export interface DataMultiOwner_ApplicationUser_OrganisationUpdateWithoutPKs {
    recordId?: number;
    appUserOrAppUserGroupId?: number;
    permTypes?: PermissionTypesOnDataEnum;
    record?: OrganisationUpdateWithoutPKs;
    appUserOrAppUserGroup?: ApplicationUserUpdateWithoutPKs;
}

export interface DataRecordAddUpdateDeletePermissionTableSubListDTO {
    tableName: string;
    recordIdsInSetToApplyPermissionsTo?: number[];
    recordIdsInSetToRemovePermissionsFrom?: number[];
}

export interface Deal {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold: boolean;
    name: string;
    uniqueRef: string;
    brokerUser?: ApplicationUser | null;
    brokerOrganisation?: Organisation | null;
    planningPermissionType: PlanningPermissionTypeEnum;
    productType: ProductTypeEnum;
    productFamily: ProductFamilyEnum;
    status: CaseStatusEnum;
    applicationFee: number;
    isApplicationFeePaid: number;
    dealClients?: DealClient[];
    dealLenders?: DealLender[];
    attachments?: DealFileAttachment[];
    dealNotes?: DealNote[];
    dealSchedules?: DealSchedule[];
    /** External Reference */
    externalRef: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq: number;
    /** Loan Required(LoanReq) */
    netLoanRequired: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy: ExitStrategyEnum | null;
    exitStrategyOther: string;
    /** Property Location */
    locations: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses: number | null;
    /** How many flats? */
    howManyFlats: number | null;
    /** Class Uses */
    classUses: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts: number;
    /** Build Costs(BuildCosts) */
    buildCosts: number;
    /** Continguency(Contingency) */
    contingency: number;
    /** Completion Date(CompletionDate) */
    completionDate: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts: number;
    parentCaseToAssoicateWithOnCreation: number | null;
    f_IsFirstTimeDeveloper: boolean | null;
    f_NumberOfPreviousDevelopments: PreviousDevelopmentsEnum | null;
    f_IsPersonalName: boolean | null;
    f_IsOffshoreCompany: boolean | null;
    f_IsMainShareholderOverseas: boolean | null;
    f_PersonalGuaranteeLevel: number | null;
    f_IsGradeOneListed: boolean | null;
    f_IsGradeTwoListed: boolean | null;
    f_MaxHouseSalesPrice: number | null;
    f_MaxFlatUnitPrice: number | null;
    f_MaxSqFtSalePrice: number | null;
    f_MaxSqFtSalePriceFlats: number | null;
    f_MaxPercCommercialForMixedUse: number | null;
    f_MaxNumberOfUnits: number | null;
    f_IsChargeOnAdditionalProperty: boolean | null;
    f_IsFixedRate: boolean | null;
    personalGuaranteeMin: number | null;
    personalGuaranteeMax: number | null;
    f_IsTimberFrameConstruction: boolean | null;
    f_IsConcreteConstruction: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction: string;
    /** Pension Type */
    pensionType: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners: number;
    /** Excluded Lenders */
    excludedLenders: string;
    isCaseOverviewSectionComplete: boolean;
    submitTsAndCs: boolean;
    siteDetails: string;
    solicitorDetails: string;
    accountantDetails: string;
    nameOfUKLimitedLiabilityCompany: string;
    ukLimitedLiabilityPartnershipNumber: string;
    previousLenders: string;
    propertyTenure: TenureEnum | null;
    gdv: number | null;
    ltc: number | null;
    ltgdv: number | null;
    chargeRequired: ChargeTypeEnum;
    currentvalue: number | null;
    hasPendingSubmitWithCriteriaChange: boolean;
    maxLoanRequired: boolean;
    additionalSecurity: boolean;
    additionalSecurityInfo: string;
    organisationLink?: OrganisationLink | null;
    leadSourceUrl: string;
    ownOrPurchase: OwnOrPurchaseEnum | null;
    isFamilyInResidence: YesNoMaybe | null;
    loanCompletionType: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete: boolean | null;
    isPropertySectionComplete: boolean | null;
    isLoanSectionComplete: boolean | null;
    f_IsRetypedValuation: boolean | null;
    projectDescription: string;
    isTenantedBuilding: boolean | null;
    numberOfTenancies: number | null;
    yearsLeftOnLease: number | null;
    propertyAddress: PostalAddress;
    showLenderInfoBrokerOverride: boolean;
    postcodeSearchString: string;
    lenderUser?: ApplicationUser | null;
    planningStatusAtEndOfLoan: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy: boolean | null;
    companyCcjOrBankruptcyDetail: string;
    sortBy: SortByEnum;
    brokerCommissionPercent: number | null;
    originatorRoleType: OriginatorRoleTypeEnum;
    originatorOrganisationId: number | null;
    originatorLenderId: number | null;
    sourceType: DealSourceTypeEnum;
    lenderReferralUserId: number | null;
    lenderReferralLenderId: number | null;
    brokerPhoneNumber: string;
    f_HasAdverseCredit: boolean | null;
    f_MaxCommercialFloorspace: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect: boolean;
    connectUser?: ApplicationUser | null;
    isPreConnectArchived: boolean;
    f_PersonalGuaranteeMin: number | null;
    f_PersonalGuaranteeMax: number | null;
    brokerUserFullName: string;
    brokerOrganisationName: string;
    brokerUserEmail: string;
    hasOwnOrPurchase: boolean;
    hasPostcode: boolean;
    propertyValue: number;
    dealClient: DealClient;
    hasIsFamilyInResidence: boolean;
    originalPurchasePrice: number;
    id: number;
    brokerUserId: number | null;
    brokerOrganisationId: number | null;
    organisationLinkId: number | null;
    lenderUserId: number | null;
    connectUserId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_Deal[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_Deal[];
}

export interface DealClient {
    deal?: Deal;
    client?: Client;
    uniqueRef: string;
    expiryDate: Date | null;
    accessLevel: CaseAccessLevelEnum;
    profile?: Profile | null;
    showLenderNamesAndLogos: boolean | null;
    ownershipPercentage: number;
    isApplicant: boolean;
    isPrimary: boolean;
    isVerified: boolean;
    ownershipRole: OwnershipRoleEnum;
    isOwner: boolean;
    sendCaseUpdates: boolean;
    id: number;
    dealId: number;
    clientId: number;
    profileId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** DealClient without database generated properties */
export interface DealClientInsert {
    deal: DealInsert | null;
    client: ClientInsert | null;
    uniqueRef?: string;
    expiryDate?: Date | null;
    accessLevel?: CaseAccessLevelEnum;
    profile?: ProfileInsert | null;
    showLenderNamesAndLogos?: boolean | null;
    ownershipPercentage?: number;
    isApplicant?: boolean;
    isPrimary?: boolean;
    isVerified?: boolean;
    ownershipRole?: OwnershipRoleEnum;
    isOwner?: boolean;
    sendCaseUpdates?: boolean;
    dealId: number;
    clientId: number;
    profileId?: number | null;
}

export interface DealClientPageWithTotalCountDTO {
    list?: DealClient[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DealClient with all properties optional except PKs */
export interface DealClientUpdate {
    deal?: DealUpdateWithoutPKs | null;
    client?: ClientUpdateWithoutPKs | null;
    uniqueRef?: string;
    expiryDate?: Date | null;
    accessLevel?: CaseAccessLevelEnum;
    profile?: ProfileUpdateWithoutPKs | null;
    showLenderNamesAndLogos?: boolean | null;
    ownershipPercentage?: number;
    isApplicant?: boolean;
    isPrimary?: boolean;
    isVerified?: boolean;
    ownershipRole?: OwnershipRoleEnum;
    isOwner?: boolean;
    sendCaseUpdates?: boolean;
    id: number;
    dealId?: number;
    clientId?: number;
    profileId?: number | null;
}

/** DealClient without PKs and database generated properties and with all properties optional */
export interface DealClientUpdateWithoutPKs {
    deal?: DealUpdateWithoutPKs | null;
    client?: ClientUpdateWithoutPKs | null;
    uniqueRef?: string;
    expiryDate?: Date | null;
    accessLevel?: CaseAccessLevelEnum;
    profile?: ProfileUpdateWithoutPKs | null;
    showLenderNamesAndLogos?: boolean | null;
    ownershipPercentage?: number;
    isApplicant?: boolean;
    isPrimary?: boolean;
    isVerified?: boolean;
    ownershipRole?: OwnershipRoleEnum;
    isOwner?: boolean;
    sendCaseUpdates?: boolean;
    dealId?: number;
    clientId?: number;
    profileId?: number | null;
}

export interface DealCompletion {
    appraisalId: number;
    appraisalType: string;
    completionDate: Date;
    grossLoanAmount: number;
    borrowerName: string;
    dealAddress: string;
    lender?: Lender;
    id: number;
    lenderId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** DealCompletion without database generated properties */
export interface DealCompletionInsert {
    appraisalId?: number;
    appraisalType?: string;
    completionDate?: Date;
    grossLoanAmount?: number;
    borrowerName?: string;
    dealAddress?: string;
    lender: LenderInsert | null;
    lenderId: number;
}

export interface DealCompletionPageWithTotalCountDTO {
    list?: DealCompletion[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DealCompletion with all properties optional except PKs */
export interface DealCompletionUpdate {
    appraisalId?: number;
    appraisalType?: string;
    completionDate?: Date;
    grossLoanAmount?: number;
    borrowerName?: string;
    dealAddress?: string;
    lender?: LenderUpdateWithoutPKs | null;
    id: number;
    lenderId?: number;
}

/** DealCompletion without PKs and database generated properties and with all properties optional */
export interface DealCompletionUpdateWithoutPKs {
    appraisalId?: number;
    appraisalType?: string;
    completionDate?: Date;
    grossLoanAmount?: number;
    borrowerName?: string;
    dealAddress?: string;
    lender?: LenderUpdateWithoutPKs | null;
    lenderId?: number;
}

export interface DealFileAttachment {
    deal?: Deal;
    dealLenderId: number | null;
    user?: ApplicationUser | null;
    fileLocation: string;
    fileName: string;
    module: ModuleEnum;
    dealClientId: number | null;
    tempURL: string;
    tempUploadURL: string;
    userName: string;
    id: number;
    dealId: number;
    userId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealFileAttachment[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealFileAttachment[];
}

/** DealFileAttachment without database generated properties */
export interface DealFileAttachmentInsert {
    deal: DealInsert | null;
    dealLenderId?: number | null;
    user?: ApplicationUserInsert | null;
    fileLocation?: string;
    fileName?: string;
    module?: ModuleEnum;
    dealClientId?: number | null;
    dealId: number;
    userId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealFileAttachmentInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealFileAttachmentInsert[];
}

export interface DealFileAttachmentPageWithTotalCountDTO {
    list?: DealFileAttachment[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DealFileAttachment with all properties optional except PKs */
export interface DealFileAttachmentUpdate {
    deal?: DealUpdateWithoutPKs | null;
    dealLenderId?: number | null;
    user?: ApplicationUserUpdateWithoutPKs | null;
    fileLocation?: string;
    fileName?: string;
    module?: ModuleEnum;
    dealClientId?: number | null;
    id: number;
    dealId?: number;
    userId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealFileAttachmentUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealFileAttachmentUpdate[];
}

/** DealFileAttachment without PKs and database generated properties and with all properties optional */
export interface DealFileAttachmentUpdateWithoutPKs {
    deal?: DealUpdateWithoutPKs | null;
    dealLenderId?: number | null;
    user?: ApplicationUserUpdateWithoutPKs | null;
    fileLocation?: string;
    fileName?: string;
    module?: ModuleEnum;
    dealClientId?: number | null;
    dealId?: number;
    userId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealFileAttachmentUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealFileAttachmentUpdate[];
}

/** Deal without database generated properties */
export interface DealInsert {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserInsert | null;
    brokerOrganisation?: OrganisationInsert | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientInsert[];
    dealLenders?: DealLenderInsert[];
    attachments?: DealFileAttachmentInsert[];
    dealNotes?: DealNoteInsert[];
    dealSchedules?: DealScheduleInsert[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkInsert | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserInsert | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserInsert | null;
    isPreConnectArchived?: boolean;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealInsert[];
}

export interface DealLender {
    deal?: Deal;
    lender?: Lender;
    product?: Product | null;
    externalProductId: string | null;
    productSourceType: ProductSourceTypeEnum;
    productRef: string | null;
    uniqueRef: string | null;
    status: CaseLenderStateEnum;
    originalTotalGrossLoan: number | null;
    totalGrossLoan: number | null;
    originalBuildLoan: number | null;
    buildLoan: number | null;
    originalLandLoan: number | null;
    landLoan: number | null;
    lenderArrangementFee: number | null;
    originalLenderArrangementFeePercent: number;
    lenderArrangementFeePercent: number | null;
    originalInterestRate: number;
    interestRate: number | null;
    interestCoverAllocation: number;
    lenderExitFee: number | null;
    originalLenderExitFeePercent: number;
    lenderExitFeePercent: number | null;
    originalProfessionalFeesEstimate: number | null;
    professionalFeesEstimate: number | null;
    lenderComments: string | null;
    borrowerComments: string | null;
    lenderRejectReason: string | null;
    lenderAdditionalRequirements: string | null;
    originalGDV: number;
    originalBuildTerm: number;
    originalLoanTerm: number;
    originalNetLoan: number | null;
    originalTotalLenderCosts: number | null;
    originalTrueMonthlyCost: number | null;
    originalDeposit: number | null;
    originalProfit: number | null;
    originalROCE: number | null;
    isBidAccepted: boolean | null;
    lenderRequiresSiteVisit: boolean;
    lenderRequiresInPersonMeeting: boolean;
    lenderRequiresVideoMeeting: boolean;
    lenderHasOwnDeclaration: boolean;
    lenderRequiresProofOfIncome: boolean;
    lenderRequiresIncomeAndExpenditure: boolean;
    contactName: string | null;
    contactEmail: string | null;
    contactWorkPhoneNumber: string | null;
    contactMobilePhoneNumber: string | null;
    applyTsAndCs: boolean;
    lenderRequiresAssetAndLiabilitiesDocument: boolean;
    lenderRequiresFCARegisteredBroker: boolean;
    isPrimaryProduct: boolean;
    monthlyInterestRate: number;
    minimumInterestPeriod: number | null;
    totalNetLoan: number | null;
    interestRateType: InterestRateTypeEnum;
    basisOfInterestRate: string | null;
    dipDateSubmittedToLender: Date | null;
    dipDateLenderResponded: Date | null;
    dipDateResubmittedToLender: Date | null;
    dipDateLenderWithdrew: Date | null;
    latestMessageDateFromBroker: Date | null;
    latestMessageDateFromLender: Date | null;
    isLenderReviewComplete: boolean;
    isBrokerReviewComplete: boolean;
    loanToValue: number;
    originalLoanToValue: number | null;
    mortgageInterestType: InterestRateTypeEnum | null;
    originalMortgageInterestType: InterestRateTypeEnum | null;
    loanRepaymentType: LoanRepaymentTypeEnum | null;
    originalLoanRepaymentType: LoanRepaymentTypeEnum | null;
    monthlyMortgagePayment: number;
    originalMonthlyMortgagePayment: number | null;
    earlyRepaymentCharge: string | null;
    equityOrDeposit: number;
    lenderRequiresRegisteredBroker: boolean;
    loanTerm: number;
    productDuration: number | null;
    buildTerm: number | null;
    preferredLenderContactEmail: string | null;
    assignedLenderUserId: number | null;
    hasAppliedInLenderPortal: boolean;
    lenderPortalBorrowerFullName: string | null;
    lenderPortalBorrowerPhoneNumber: string | null;
    lenderPortalBorrowerEmail: string | null;
    lenderPortalApplyUserName: string | null;
    lenderPortalApplyDateTime: Date | null;
    lenderResponseTimeInSeconds: number | null;
    submittedToDealLockerDateTime: Date | null;
    deallockerIntegrationStatus: DeallockerIntergrationStatusEnum | null;
    minShareholderDepositPercent: number | null;
    minShareholderDeposit: number | null;
    isLegacy: boolean;
    dealLenderMessage: DealLenderMessage[];
    lenderUserIds: number[];
    lenderName: string | null;
    lenderLogo: string | null;
    totalUnreadDealLenderMessages: number | null;
    isValidDealForDeallocker: boolean;
    isConnectReferralOnly: boolean;
    isLenderInActive: boolean;
    id: number;
    dealId: number;
    lenderId: number;
    productId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealLender[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealLender[];
}

/** DealLender without database generated properties */
export interface DealLenderInsert {
    deal: DealInsert | null;
    lender: LenderInsert | null;
    product?: ProductInsert | null;
    externalProductId?: string | null;
    productSourceType?: ProductSourceTypeEnum;
    productRef?: string | null;
    uniqueRef?: string | null;
    status?: CaseLenderStateEnum;
    originalTotalGrossLoan?: number | null;
    totalGrossLoan?: number | null;
    originalBuildLoan?: number | null;
    buildLoan?: number | null;
    originalLandLoan?: number | null;
    landLoan?: number | null;
    lenderArrangementFee?: number | null;
    originalLenderArrangementFeePercent?: number;
    lenderArrangementFeePercent?: number | null;
    originalInterestRate?: number;
    interestRate?: number | null;
    interestCoverAllocation?: number;
    lenderExitFee?: number | null;
    originalLenderExitFeePercent?: number;
    lenderExitFeePercent?: number | null;
    originalProfessionalFeesEstimate?: number | null;
    professionalFeesEstimate?: number | null;
    lenderComments?: string | null;
    borrowerComments?: string | null;
    lenderRejectReason?: string | null;
    lenderAdditionalRequirements?: string | null;
    originalGDV?: number;
    originalBuildTerm?: number;
    originalLoanTerm?: number;
    originalNetLoan?: number | null;
    originalTotalLenderCosts?: number | null;
    originalTrueMonthlyCost?: number | null;
    originalDeposit?: number | null;
    originalProfit?: number | null;
    originalROCE?: number | null;
    isBidAccepted?: boolean | null;
    lenderRequiresSiteVisit?: boolean;
    lenderRequiresInPersonMeeting?: boolean;
    lenderRequiresVideoMeeting?: boolean;
    lenderHasOwnDeclaration?: boolean;
    lenderRequiresProofOfIncome?: boolean;
    lenderRequiresIncomeAndExpenditure?: boolean;
    contactName?: string | null;
    contactEmail?: string | null;
    contactWorkPhoneNumber?: string | null;
    contactMobilePhoneNumber?: string | null;
    applyTsAndCs?: boolean;
    lenderRequiresAssetAndLiabilitiesDocument?: boolean;
    lenderRequiresFCARegisteredBroker?: boolean;
    isPrimaryProduct?: boolean;
    monthlyInterestRate?: number;
    minimumInterestPeriod?: number | null;
    totalNetLoan?: number | null;
    interestRateType?: InterestRateTypeEnum;
    basisOfInterestRate?: string | null;
    dipDateSubmittedToLender?: Date | null;
    dipDateLenderResponded?: Date | null;
    dipDateResubmittedToLender?: Date | null;
    dipDateLenderWithdrew?: Date | null;
    latestMessageDateFromBroker?: Date | null;
    latestMessageDateFromLender?: Date | null;
    isLenderReviewComplete?: boolean;
    isBrokerReviewComplete?: boolean;
    loanToValue?: number;
    originalLoanToValue?: number | null;
    mortgageInterestType?: InterestRateTypeEnum | null;
    originalMortgageInterestType?: InterestRateTypeEnum | null;
    loanRepaymentType?: LoanRepaymentTypeEnum | null;
    originalLoanRepaymentType?: LoanRepaymentTypeEnum | null;
    monthlyMortgagePayment?: number;
    originalMonthlyMortgagePayment?: number | null;
    earlyRepaymentCharge?: string | null;
    equityOrDeposit?: number;
    lenderRequiresRegisteredBroker?: boolean;
    loanTerm?: number;
    productDuration?: number | null;
    buildTerm?: number | null;
    preferredLenderContactEmail?: string | null;
    assignedLenderUserId?: number | null;
    hasAppliedInLenderPortal?: boolean;
    lenderPortalBorrowerFullName?: string | null;
    lenderPortalBorrowerPhoneNumber?: string | null;
    lenderPortalBorrowerEmail?: string | null;
    lenderPortalApplyUserName?: string | null;
    lenderPortalApplyDateTime?: Date | null;
    lenderResponseTimeInSeconds?: number | null;
    submittedToDealLockerDateTime?: Date | null;
    deallockerIntegrationStatus?: DeallockerIntergrationStatusEnum | null;
    minShareholderDepositPercent?: number | null;
    minShareholderDeposit?: number | null;
    dealId: number;
    lenderId: number;
    productId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealLenderInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealLenderInsert[];
}

export interface DealLenderMessage {
    deal?: Deal;
    senderUser?: ApplicationUser;
    dealLender?: DealLender;
    message: string;
    readDateTime: Date | null;
    senderRole: MessageRoleEnum;
    recipientRoles: MessageRoleEnum;
    organisationLogo: string;
    userFullName: string;
    id: number;
    dealId: number;
    senderUserId: number;
    dealLenderId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** DealLenderMessage without database generated properties */
export interface DealLenderMessageInsert {
    deal: DealInsert | null;
    senderUser: ApplicationUserInsert | null;
    dealLender: DealLenderInsert | null;
    message?: string;
    readDateTime?: Date | null;
    senderRole?: MessageRoleEnum;
    recipientRoles?: MessageRoleEnum;
    dealId: number;
    senderUserId: number;
    dealLenderId: number;
}

export interface DealLenderMessagePageWithTotalCountDTO {
    list?: DealLenderMessage[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface DealLenderMessageTrack {
    user?: ApplicationUser | null;
    readDateTime: Date | null;
    dealLenderMessage?: DealLenderMessage;
    id: number;
    userId: number | null;
    dealLenderMessageId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** DealLenderMessageTrack without database generated properties */
export interface DealLenderMessageTrackInsert {
    user?: ApplicationUserInsert | null;
    readDateTime?: Date | null;
    dealLenderMessage: DealLenderMessageInsert | null;
    userId?: number | null;
    dealLenderMessageId: number;
}

export interface DealLenderMessageTrackPageWithTotalCountDTO {
    list?: DealLenderMessageTrack[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DealLenderMessageTrack with all properties optional except PKs */
export interface DealLenderMessageTrackUpdate {
    user?: ApplicationUserUpdateWithoutPKs | null;
    readDateTime?: Date | null;
    dealLenderMessage?: DealLenderMessageUpdateWithoutPKs | null;
    id: number;
    userId?: number | null;
    dealLenderMessageId?: number;
}

/** DealLenderMessageTrack without PKs and database generated properties and with all properties optional */
export interface DealLenderMessageTrackUpdateWithoutPKs {
    user?: ApplicationUserUpdateWithoutPKs | null;
    readDateTime?: Date | null;
    dealLenderMessage?: DealLenderMessageUpdateWithoutPKs | null;
    userId?: number | null;
    dealLenderMessageId?: number;
}

/** DealLenderMessage with all properties optional except PKs */
export interface DealLenderMessageUpdate {
    deal?: DealUpdateWithoutPKs | null;
    senderUser?: ApplicationUserUpdateWithoutPKs | null;
    dealLender?: DealLenderUpdateWithoutPKs | null;
    message?: string;
    readDateTime?: Date | null;
    senderRole?: MessageRoleEnum;
    recipientRoles?: MessageRoleEnum;
    id: number;
    dealId?: number;
    senderUserId?: number;
    dealLenderId?: number;
}

/** DealLenderMessage without PKs and database generated properties and with all properties optional */
export interface DealLenderMessageUpdateWithoutPKs {
    deal?: DealUpdateWithoutPKs | null;
    senderUser?: ApplicationUserUpdateWithoutPKs | null;
    dealLender?: DealLenderUpdateWithoutPKs | null;
    message?: string;
    readDateTime?: Date | null;
    senderRole?: MessageRoleEnum;
    recipientRoles?: MessageRoleEnum;
    dealId?: number;
    senderUserId?: number;
    dealLenderId?: number;
}

export interface DealLenderPageWithTotalCountDTO {
    list?: DealLender[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DealLender with all properties optional except PKs */
export interface DealLenderUpdate {
    deal?: DealUpdateWithoutPKs | null;
    lender?: LenderUpdateWithoutPKs | null;
    product?: ProductUpdateWithoutPKs | null;
    externalProductId?: string | null;
    productSourceType?: ProductSourceTypeEnum;
    productRef?: string | null;
    uniqueRef?: string | null;
    status?: CaseLenderStateEnum;
    originalTotalGrossLoan?: number | null;
    totalGrossLoan?: number | null;
    originalBuildLoan?: number | null;
    buildLoan?: number | null;
    originalLandLoan?: number | null;
    landLoan?: number | null;
    lenderArrangementFee?: number | null;
    originalLenderArrangementFeePercent?: number;
    lenderArrangementFeePercent?: number | null;
    originalInterestRate?: number;
    interestRate?: number | null;
    interestCoverAllocation?: number;
    lenderExitFee?: number | null;
    originalLenderExitFeePercent?: number;
    lenderExitFeePercent?: number | null;
    originalProfessionalFeesEstimate?: number | null;
    professionalFeesEstimate?: number | null;
    lenderComments?: string | null;
    borrowerComments?: string | null;
    lenderRejectReason?: string | null;
    lenderAdditionalRequirements?: string | null;
    originalGDV?: number;
    originalBuildTerm?: number;
    originalLoanTerm?: number;
    originalNetLoan?: number | null;
    originalTotalLenderCosts?: number | null;
    originalTrueMonthlyCost?: number | null;
    originalDeposit?: number | null;
    originalProfit?: number | null;
    originalROCE?: number | null;
    isBidAccepted?: boolean | null;
    lenderRequiresSiteVisit?: boolean;
    lenderRequiresInPersonMeeting?: boolean;
    lenderRequiresVideoMeeting?: boolean;
    lenderHasOwnDeclaration?: boolean;
    lenderRequiresProofOfIncome?: boolean;
    lenderRequiresIncomeAndExpenditure?: boolean;
    contactName?: string | null;
    contactEmail?: string | null;
    contactWorkPhoneNumber?: string | null;
    contactMobilePhoneNumber?: string | null;
    applyTsAndCs?: boolean;
    lenderRequiresAssetAndLiabilitiesDocument?: boolean;
    lenderRequiresFCARegisteredBroker?: boolean;
    isPrimaryProduct?: boolean;
    monthlyInterestRate?: number;
    minimumInterestPeriod?: number | null;
    totalNetLoan?: number | null;
    interestRateType?: InterestRateTypeEnum;
    basisOfInterestRate?: string | null;
    dipDateSubmittedToLender?: Date | null;
    dipDateLenderResponded?: Date | null;
    dipDateResubmittedToLender?: Date | null;
    dipDateLenderWithdrew?: Date | null;
    latestMessageDateFromBroker?: Date | null;
    latestMessageDateFromLender?: Date | null;
    isLenderReviewComplete?: boolean;
    isBrokerReviewComplete?: boolean;
    loanToValue?: number;
    originalLoanToValue?: number | null;
    mortgageInterestType?: InterestRateTypeEnum | null;
    originalMortgageInterestType?: InterestRateTypeEnum | null;
    loanRepaymentType?: LoanRepaymentTypeEnum | null;
    originalLoanRepaymentType?: LoanRepaymentTypeEnum | null;
    monthlyMortgagePayment?: number;
    originalMonthlyMortgagePayment?: number | null;
    earlyRepaymentCharge?: string | null;
    equityOrDeposit?: number;
    lenderRequiresRegisteredBroker?: boolean;
    loanTerm?: number;
    productDuration?: number | null;
    buildTerm?: number | null;
    preferredLenderContactEmail?: string | null;
    assignedLenderUserId?: number | null;
    hasAppliedInLenderPortal?: boolean;
    lenderPortalBorrowerFullName?: string | null;
    lenderPortalBorrowerPhoneNumber?: string | null;
    lenderPortalBorrowerEmail?: string | null;
    lenderPortalApplyUserName?: string | null;
    lenderPortalApplyDateTime?: Date | null;
    lenderResponseTimeInSeconds?: number | null;
    submittedToDealLockerDateTime?: Date | null;
    deallockerIntegrationStatus?: DeallockerIntergrationStatusEnum | null;
    minShareholderDepositPercent?: number | null;
    minShareholderDeposit?: number | null;
    id: number;
    dealId?: number;
    lenderId?: number;
    productId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealLenderUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealLenderUpdate[];
}

/** DealLender without PKs and database generated properties and with all properties optional */
export interface DealLenderUpdateWithoutPKs {
    deal?: DealUpdateWithoutPKs | null;
    lender?: LenderUpdateWithoutPKs | null;
    product?: ProductUpdateWithoutPKs | null;
    externalProductId?: string | null;
    productSourceType?: ProductSourceTypeEnum;
    productRef?: string | null;
    uniqueRef?: string | null;
    status?: CaseLenderStateEnum;
    originalTotalGrossLoan?: number | null;
    totalGrossLoan?: number | null;
    originalBuildLoan?: number | null;
    buildLoan?: number | null;
    originalLandLoan?: number | null;
    landLoan?: number | null;
    lenderArrangementFee?: number | null;
    originalLenderArrangementFeePercent?: number;
    lenderArrangementFeePercent?: number | null;
    originalInterestRate?: number;
    interestRate?: number | null;
    interestCoverAllocation?: number;
    lenderExitFee?: number | null;
    originalLenderExitFeePercent?: number;
    lenderExitFeePercent?: number | null;
    originalProfessionalFeesEstimate?: number | null;
    professionalFeesEstimate?: number | null;
    lenderComments?: string | null;
    borrowerComments?: string | null;
    lenderRejectReason?: string | null;
    lenderAdditionalRequirements?: string | null;
    originalGDV?: number;
    originalBuildTerm?: number;
    originalLoanTerm?: number;
    originalNetLoan?: number | null;
    originalTotalLenderCosts?: number | null;
    originalTrueMonthlyCost?: number | null;
    originalDeposit?: number | null;
    originalProfit?: number | null;
    originalROCE?: number | null;
    isBidAccepted?: boolean | null;
    lenderRequiresSiteVisit?: boolean;
    lenderRequiresInPersonMeeting?: boolean;
    lenderRequiresVideoMeeting?: boolean;
    lenderHasOwnDeclaration?: boolean;
    lenderRequiresProofOfIncome?: boolean;
    lenderRequiresIncomeAndExpenditure?: boolean;
    contactName?: string | null;
    contactEmail?: string | null;
    contactWorkPhoneNumber?: string | null;
    contactMobilePhoneNumber?: string | null;
    applyTsAndCs?: boolean;
    lenderRequiresAssetAndLiabilitiesDocument?: boolean;
    lenderRequiresFCARegisteredBroker?: boolean;
    isPrimaryProduct?: boolean;
    monthlyInterestRate?: number;
    minimumInterestPeriod?: number | null;
    totalNetLoan?: number | null;
    interestRateType?: InterestRateTypeEnum;
    basisOfInterestRate?: string | null;
    dipDateSubmittedToLender?: Date | null;
    dipDateLenderResponded?: Date | null;
    dipDateResubmittedToLender?: Date | null;
    dipDateLenderWithdrew?: Date | null;
    latestMessageDateFromBroker?: Date | null;
    latestMessageDateFromLender?: Date | null;
    isLenderReviewComplete?: boolean;
    isBrokerReviewComplete?: boolean;
    loanToValue?: number;
    originalLoanToValue?: number | null;
    mortgageInterestType?: InterestRateTypeEnum | null;
    originalMortgageInterestType?: InterestRateTypeEnum | null;
    loanRepaymentType?: LoanRepaymentTypeEnum | null;
    originalLoanRepaymentType?: LoanRepaymentTypeEnum | null;
    monthlyMortgagePayment?: number;
    originalMonthlyMortgagePayment?: number | null;
    earlyRepaymentCharge?: string | null;
    equityOrDeposit?: number;
    lenderRequiresRegisteredBroker?: boolean;
    loanTerm?: number;
    productDuration?: number | null;
    buildTerm?: number | null;
    preferredLenderContactEmail?: string | null;
    assignedLenderUserId?: number | null;
    hasAppliedInLenderPortal?: boolean;
    lenderPortalBorrowerFullName?: string | null;
    lenderPortalBorrowerPhoneNumber?: string | null;
    lenderPortalBorrowerEmail?: string | null;
    lenderPortalApplyUserName?: string | null;
    lenderPortalApplyDateTime?: Date | null;
    lenderResponseTimeInSeconds?: number | null;
    submittedToDealLockerDateTime?: Date | null;
    deallockerIntegrationStatus?: DeallockerIntergrationStatusEnum | null;
    minShareholderDepositPercent?: number | null;
    minShareholderDeposit?: number | null;
    dealId?: number;
    lenderId?: number;
    productId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealLenderUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealLenderUpdate[];
}

export interface DealNote {
    user?: ApplicationUser | null;
    noteText: string;
    deal?: Deal;
    id: number;
    userId: number | null;
    dealId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealNote[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealNote[];
}

/** DealNote without database generated properties */
export interface DealNoteInsert {
    user?: ApplicationUserInsert | null;
    noteText?: string;
    deal: DealInsert | null;
    userId?: number | null;
    dealId: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealNoteInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealNoteInsert[];
}

export interface DealNotePageWithTotalCountDTO {
    list?: DealNote[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DealNote with all properties optional except PKs */
export interface DealNoteUpdate {
    user?: ApplicationUserUpdateWithoutPKs | null;
    noteText?: string;
    deal?: DealUpdateWithoutPKs | null;
    id: number;
    userId?: number | null;
    dealId?: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealNoteUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealNoteUpdate[];
}

/** DealNote without PKs and database generated properties and with all properties optional */
export interface DealNoteUpdateWithoutPKs {
    user?: ApplicationUserUpdateWithoutPKs | null;
    noteText?: string;
    deal?: DealUpdateWithoutPKs | null;
    userId?: number | null;
    dealId?: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealNoteUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealNoteUpdate[];
}

export interface DealPageWithTotalCountDTO {
    list?: Deal[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface DealSchedule {
    description: ScheduleDescriptionTypeEnum;
    bedCount: number;
    tenure: TenureEnum;
    salesPrice: number;
    area: number;
    preAgreement: PreAgreementEnum;
    annualRent: number;
    scheduleType: ScheduleTypeEnum;
    deal?: Deal;
    id: number;
    dealId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** DealSchedule without database generated properties */
export interface DealScheduleInsert {
    description?: ScheduleDescriptionTypeEnum;
    bedCount?: number;
    tenure?: TenureEnum;
    salesPrice?: number;
    area?: number;
    preAgreement?: PreAgreementEnum;
    annualRent?: number;
    scheduleType?: ScheduleTypeEnum;
    deal: DealInsert | null;
    dealId: number;
}

export interface DealSchedulePageWithTotalCountDTO {
    list?: DealSchedule[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DealSchedule with all properties optional except PKs */
export interface DealScheduleUpdate {
    description?: ScheduleDescriptionTypeEnum;
    bedCount?: number;
    tenure?: TenureEnum;
    salesPrice?: number;
    area?: number;
    preAgreement?: PreAgreementEnum;
    annualRent?: number;
    scheduleType?: ScheduleTypeEnum;
    deal?: DealUpdateWithoutPKs | null;
    id: number;
    dealId?: number;
}

/** DealSchedule without PKs and database generated properties and with all properties optional */
export interface DealScheduleUpdateWithoutPKs {
    description?: ScheduleDescriptionTypeEnum;
    bedCount?: number;
    tenure?: TenureEnum;
    salesPrice?: number;
    area?: number;
    preAgreement?: PreAgreementEnum;
    annualRent?: number;
    scheduleType?: ScheduleTypeEnum;
    deal?: DealUpdateWithoutPKs | null;
    dealId?: number;
}

export enum DealSourceTypeEnum {
    Unknown = 0,
    Application = 1,
    WhitelabelApplication = 2,
    IFrameEnterprise = 3,
    IFrameUniqueLink = 4,
    UniqueLink = 5,
    Enterprise = 6,
    Api = 7,
    WidgetUniqueLink = 8,
    WidgetEnterprise = 9,
}

export interface DealSummaryDTO {
    id?: number;
    name?: string;
    productFamily?: ProductFamilyEnum;
    productType?: ProductTypeEnum;
    isConnectUser?: boolean;
    isReferredToConnect?: boolean;
    status?: CaseStatusEnum;
}

/** Deal with all properties optional except PKs */
export interface DealUpdate {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientUpdate[];
    dealLenders?: DealLenderUpdate[];
    attachments?: DealFileAttachmentUpdate[];
    dealNotes?: DealNoteUpdate[];
    dealSchedules?: DealScheduleUpdate[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserUpdateWithoutPKs | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserUpdateWithoutPKs | null;
    isPreConnectArchived?: boolean;
    id: number;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealUpdate[];
}

/** Deal without PKs and database generated properties and with all properties optional */
export interface DealUpdateWithoutPKs {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientUpdate[];
    dealLenders?: DealLenderUpdate[];
    attachments?: DealFileAttachmentUpdate[];
    dealNotes?: DealNoteUpdate[];
    dealSchedules?: DealScheduleUpdate[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserUpdateWithoutPKs | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserUpdateWithoutPKs | null;
    isPreConnectArchived?: boolean;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealUpdate[];
}

export enum DeallockerIntergrationStatusEnum {
    InProgress = 1,
    Error = 2,
    Success = 3,
}

export enum DeductorPayEnum {
    None = 0,
    DeductFromLoan = 1,
    PaidSeparatley = 2,
}

export interface DevFinanceSearchResultsResponse {
    criteria?: DevelopmentFinanceDeal | null;
    results?: LenderResultSummaryDTO[] | null;
    hideDeal?: boolean;
    hasNoAccessToDeal?: boolean;
}

export interface DeveloperExitFinanceDevScheduleInput {
    /** Property Type */
    propertyType: PropertyTypeEnum;
    /** Schedule Type */
    scheduleType: ScheduleTypeEnum;
    /** Square Footage */
    squareFootage: number;
    /** Number Of Units */
    numberOfUnits: number;
    /** Description */
    description: string;
    /** Type */
    type: UnitTypeEnum;
    /** Number Of Beds */
    numberOfBeds: number | null;
    /** Sales Price */
    salesPrice: number;
    /** Annual Rent */
    annualRent: number;
    /** Monthly Rent */
    monthlyRent: number;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** DeveloperExitFinanceDevScheduleInput without database generated properties */
export interface DeveloperExitFinanceDevScheduleInputInsert {
    /** Property Type */
    propertyType?: PropertyTypeEnum;
    /** Schedule Type */
    scheduleType?: ScheduleTypeEnum;
    /** Square Footage */
    squareFootage?: number;
    /** Number Of Units */
    numberOfUnits?: number;
    /** Description */
    description?: string;
    /** Type */
    type?: UnitTypeEnum;
    /** Number Of Beds */
    numberOfBeds?: number | null;
    /** Sales Price */
    salesPrice?: number;
    /** Annual Rent */
    annualRent?: number;
    /** Monthly Rent */
    monthlyRent?: number;
}

export interface DeveloperExitFinanceDevScheduleInputPageWithTotalCountDTO {
    list?: DeveloperExitFinanceDevScheduleInput[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DeveloperExitFinanceDevScheduleInput with all properties optional except PKs */
export interface DeveloperExitFinanceDevScheduleInputUpdate {
    /** Property Type */
    propertyType?: PropertyTypeEnum;
    /** Schedule Type */
    scheduleType?: ScheduleTypeEnum;
    /** Square Footage */
    squareFootage?: number;
    /** Number Of Units */
    numberOfUnits?: number;
    /** Description */
    description?: string;
    /** Type */
    type?: UnitTypeEnum;
    /** Number Of Beds */
    numberOfBeds?: number | null;
    /** Sales Price */
    salesPrice?: number;
    /** Annual Rent */
    annualRent?: number;
    /** Monthly Rent */
    monthlyRent?: number;
    id: number;
}

/** DeveloperExitFinanceDevScheduleInput without PKs and database generated properties and with all properties optional */
export interface DeveloperExitFinanceDevScheduleInputUpdateWithoutPKs {
    /** Property Type */
    propertyType?: PropertyTypeEnum;
    /** Schedule Type */
    scheduleType?: ScheduleTypeEnum;
    /** Square Footage */
    squareFootage?: number;
    /** Number Of Units */
    numberOfUnits?: number;
    /** Description */
    description?: string;
    /** Type */
    type?: UnitTypeEnum;
    /** Number Of Beds */
    numberOfBeds?: number | null;
    /** Sales Price */
    salesPrice?: number;
    /** Annual Rent */
    annualRent?: number;
    /** Monthly Rent */
    monthlyRent?: number;
}

export interface DeveloperExitFinanceLoanInput {
    /** Term Required */
    cI_Dev_LoanTermReq: number;
    /** Loan Required */
    cI_Dev_LoanReq: number;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** DeveloperExitFinanceLoanInput without database generated properties */
export interface DeveloperExitFinanceLoanInputInsert {
    /** Term Required */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required */
    cI_Dev_LoanReq?: number;
}

export interface DeveloperExitFinanceLoanInputPageWithTotalCountDTO {
    list?: DeveloperExitFinanceLoanInput[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DeveloperExitFinanceLoanInput with all properties optional except PKs */
export interface DeveloperExitFinanceLoanInputUpdate {
    /** Term Required */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required */
    cI_Dev_LoanReq?: number;
    id: number;
}

/** DeveloperExitFinanceLoanInput without PKs and database generated properties and with all properties optional */
export interface DeveloperExitFinanceLoanInputUpdateWithoutPKs {
    /** Term Required */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required */
    cI_Dev_LoanReq?: number;
}

export interface DevelopmentFinanceDeal {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold: boolean;
    name: string;
    uniqueRef: string;
    brokerUser?: ApplicationUser | null;
    brokerOrganisation?: Organisation | null;
    planningPermissionType: PlanningPermissionTypeEnum;
    productType: ProductTypeEnum;
    productFamily: ProductFamilyEnum;
    status: CaseStatusEnum;
    applicationFee: number;
    isApplicationFeePaid: number;
    dealClients?: DealClient[];
    dealLenders?: DealLender[];
    attachments?: DealFileAttachment[];
    dealNotes?: DealNote[];
    dealSchedules?: DealSchedule[];
    /** External Reference */
    externalRef: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq: number;
    /** Loan Required(LoanReq) */
    netLoanRequired: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy: ExitStrategyEnum | null;
    exitStrategyOther: string;
    /** Property Location */
    locations: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses: number | null;
    /** How many flats? */
    howManyFlats: number | null;
    /** Class Uses */
    classUses: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts: number;
    /** Build Costs(BuildCosts) */
    buildCosts: number;
    /** Continguency(Contingency) */
    contingency: number;
    /** Completion Date(CompletionDate) */
    completionDate: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts: number;
    parentCaseToAssoicateWithOnCreation: number | null;
    f_IsFirstTimeDeveloper: boolean | null;
    f_NumberOfPreviousDevelopments: PreviousDevelopmentsEnum | null;
    f_IsPersonalName: boolean | null;
    f_IsOffshoreCompany: boolean | null;
    f_IsMainShareholderOverseas: boolean | null;
    f_PersonalGuaranteeLevel: number | null;
    f_IsGradeOneListed: boolean | null;
    f_IsGradeTwoListed: boolean | null;
    f_MaxHouseSalesPrice: number | null;
    f_MaxFlatUnitPrice: number | null;
    f_MaxSqFtSalePrice: number | null;
    f_MaxSqFtSalePriceFlats: number | null;
    f_MaxPercCommercialForMixedUse: number | null;
    f_MaxNumberOfUnits: number | null;
    f_IsChargeOnAdditionalProperty: boolean | null;
    f_IsFixedRate: boolean | null;
    personalGuaranteeMin: number | null;
    personalGuaranteeMax: number | null;
    f_IsTimberFrameConstruction: boolean | null;
    f_IsConcreteConstruction: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction: string;
    /** Pension Type */
    pensionType: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners: number;
    /** Excluded Lenders */
    excludedLenders: string;
    isCaseOverviewSectionComplete: boolean;
    submitTsAndCs: boolean;
    siteDetails: string;
    solicitorDetails: string;
    accountantDetails: string;
    nameOfUKLimitedLiabilityCompany: string;
    ukLimitedLiabilityPartnershipNumber: string;
    previousLenders: string;
    propertyTenure: TenureEnum | null;
    gdv: number | null;
    ltc: number | null;
    ltgdv: number | null;
    chargeRequired: ChargeTypeEnum;
    currentvalue: number | null;
    hasPendingSubmitWithCriteriaChange: boolean;
    maxLoanRequired: boolean;
    additionalSecurity: boolean;
    additionalSecurityInfo: string;
    organisationLink?: OrganisationLink | null;
    leadSourceUrl: string;
    ownOrPurchase: OwnOrPurchaseEnum | null;
    isFamilyInResidence: YesNoMaybe | null;
    loanCompletionType: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete: boolean | null;
    isPropertySectionComplete: boolean | null;
    isLoanSectionComplete: boolean | null;
    f_IsRetypedValuation: boolean | null;
    projectDescription: string;
    isTenantedBuilding: boolean | null;
    numberOfTenancies: number | null;
    yearsLeftOnLease: number | null;
    propertyAddress: PostalAddress;
    showLenderInfoBrokerOverride: boolean;
    postcodeSearchString: string;
    lenderUser?: ApplicationUser | null;
    planningStatusAtEndOfLoan: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy: boolean | null;
    companyCcjOrBankruptcyDetail: string;
    sortBy: SortByEnum;
    brokerCommissionPercent: number | null;
    originatorRoleType: OriginatorRoleTypeEnum;
    originatorOrganisationId: number | null;
    originatorLenderId: number | null;
    sourceType: DealSourceTypeEnum;
    lenderReferralUserId: number | null;
    lenderReferralLenderId: number | null;
    brokerPhoneNumber: string;
    f_HasAdverseCredit: boolean | null;
    f_MaxCommercialFloorspace: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect: boolean;
    connectUser?: ApplicationUser | null;
    isPreConnectArchived: boolean;
    f_PersonalGuaranteeMin: number | null;
    f_PersonalGuaranteeMax: number | null;
    brokerUserFullName: string;
    brokerOrganisationName: string;
    brokerUserEmail: string;
    hasOwnOrPurchase: boolean;
    hasPostcode: boolean;
    propertyValue: number;
    dealClient: DealClient;
    hasIsFamilyInResidence: boolean;
    originalPurchasePrice: number;
    id: number;
    brokerUserId: number | null;
    brokerOrganisationId: number | null;
    organisationLinkId: number | null;
    lenderUserId: number | null;
    connectUserId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_Deal[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_Deal[];
    /** Do you own the property(DoYouOwnTheProperty) */
    doYouOwnTheProperty: boolean;
    /** Section 106 and CIL(S106CIL) */
    s106CIL: number | null;
    /** Upfront Proffesional Fees Planning Architect(ProfessionalPlanning) */
    professionalPlanning: number | null;
    /** OnGoing Proffesional Fees Planning Architect(ProfQS) */
    professionalQS: number | null;
    /** Commercial GDV(CommercialGDV) */
    commercialGDV: number | null;
    /** Build Term(BuildTerm) */
    buildTerm: number;
    totalBuildCostsAdj: number | null;
    /** Total Project Costs(TotalProjectCosts) */
    totalProjectCosts: number | null;
    /** Legal Fees (PurchaseLegalFees) */
    purchaseLegalFees: number | null;
    /** Project Management(BuildProjectManagement) */
    buildProjectManagement: number | null;
    /** Demolition(BuildDemolition) */
    buildDemolition: number | null;
    /** Mechanical & Engineering(BuildMechEngineering) */
    buildMechEngineering: number | null;
    /** Structural Engineer(BuildStructuralEngineering) */
    buildStructuralEngineering: number | null;
    /** Party Wall(BuildPartyWall) */
    buildPartyWall: number | null;
    /** Warranty(BuildWarranty) */
    buildWarranty: number | null;
    /** Landscaping(BuildLandscaping) */
    buildLandscaping: number | null;
    /** Use a breakdown of build costs? */
    hasBuildCostsBreakdown: boolean | null;
    /** Sales Dressing Costs(SalesDressingCosts) */
    salesDressingCosts: number | null;
    /** Sales Agent Fees(SalesAgentFees) */
    salesAgentFees: number | null;
    /** Sales Legal Fees(SalesLegalFees) */
    salesLegalFees: number | null;
    /** Sales Area Units(AreaUnit) */
    areaUnit: AreaUnitEnum | null;
    /** Sales Area(AreaSalesAreaResidential) */
    areaSalesAreaResidential: number | null;
    /** Sales Area(AreaSalesAreaCommercial) */
    areaSalesAreaCommercial: number | null;
    /** Acquisition Area(AreaAcquisition) */
    areaAcquisition: number | null;
    /** Build Costs Per Area(BuildCostPerArea) */
    buildCostPerArea: number | null;
    /** Do you have a pre-let agreement(HasPreLetOrPreSaleAgreement) */
    hasPreLetOrPreSaleAgreement: boolean | null;
    /** Stamp Duty(StampDutyLandTax) */
    stampDutyLandTax: number | null;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase: number | null;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount: number | null;
    f_IsModular: boolean | null;
    f_IsAirRights: boolean | null;
    f_IsPermittedDevelopmentScheme: boolean | null;
    f_IsWorkStarted: boolean | null;
    f_ShareholderDepositRequired: number | null;
    grossInternalAreaKnown: boolean | null;
    isPlanningSectionComplete: boolean | null;
    isBuildProcurementSectionComplete: boolean | null;
    isFurtherInfoSectionComplete: boolean | null;
    planningResponsibility: number | null;
    planningProcessFurtherInfo: string | null;
    howWillSiteLookOnLoanCompletion: string | null;
    buildProcurementType: BuildProcurementTypeEnum | null;
    buildProcurementDetail: string | null;
    includesContingency: boolean | null;
    furtherInformation: string | null;
    depositDescription: string | null;
    guaranteeDescription: string | null;
    hasSetCompletionDate: boolean | null;
    searchPreferenceLoanSize: number | null;
    searchPreferencePricing: number | null;
    searchPreferenceCompletionSpeed: number | null;
    searchPreferenceCustomerService: number | null;
    hasProfessionalCostsBreakdown: boolean | null;
    planningCosts: number | null;
    projectManagementCosts: number | null;
    s106CILCosts: number | null;
    clientQSCosts: number | null;
    mechanicalEngineeringCosts: number | null;
    structuralEngineeringCosts: number | null;
    partyWallCosts: number | null;
    warrantyCosts: number | null;
    landscapingCosts: number | null;
    otherProfessionalCosts: number | null;
    otherProfessionalCostsDescription: string | null;
    marketingCosts: number | null;
    hasPropertyScheduleBreakdown: boolean | null;
    demolitionCosts: number | null;
    howManyCommercialUnits: number | null;
    isLegacy: boolean;
    comparisonList: LenderResultSummaryDTO[];
}

/** DevelopmentFinanceDeal without database generated properties */
export interface DevelopmentFinanceDealInsert {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserInsert | null;
    brokerOrganisation?: OrganisationInsert | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientInsert[];
    dealLenders?: DealLenderInsert[];
    attachments?: DealFileAttachmentInsert[];
    dealNotes?: DealNoteInsert[];
    dealSchedules?: DealScheduleInsert[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkInsert | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserInsert | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserInsert | null;
    isPreConnectArchived?: boolean;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealInsert[];
    /** Do you own the property(DoYouOwnTheProperty) */
    doYouOwnTheProperty?: boolean;
    /** Commercial GDV(CommercialGDV) */
    commercialGDV?: number | null;
    /** Build Term(BuildTerm) */
    buildTerm?: number;
    totalBuildCostsAdj?: number | null;
    /** Total Project Costs(TotalProjectCosts) */
    totalProjectCosts?: number | null;
    /** Legal Fees (PurchaseLegalFees) */
    purchaseLegalFees?: number | null;
    /** Sales Dressing Costs(SalesDressingCosts) */
    salesDressingCosts?: number | null;
    /** Sales Agent Fees(SalesAgentFees) */
    salesAgentFees?: number | null;
    /** Sales Legal Fees(SalesLegalFees) */
    salesLegalFees?: number | null;
    /** Sales Area Units(AreaUnit) */
    areaUnit?: AreaUnitEnum | null;
    /** Sales Area(AreaSalesAreaResidential) */
    areaSalesAreaResidential?: number | null;
    /** Sales Area(AreaSalesAreaCommercial) */
    areaSalesAreaCommercial?: number | null;
    /** Acquisition Area(AreaAcquisition) */
    areaAcquisition?: number | null;
    /** Build Costs Per Area(BuildCostPerArea) */
    buildCostPerArea?: number | null;
    /** Do you have a pre-let agreement(HasPreLetOrPreSaleAgreement) */
    hasPreLetOrPreSaleAgreement?: boolean | null;
    /** Stamp Duty(StampDutyLandTax) */
    stampDutyLandTax?: number | null;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number | null;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsWorkStarted?: boolean | null;
    f_ShareholderDepositRequired?: number | null;
    grossInternalAreaKnown?: boolean | null;
    isPlanningSectionComplete?: boolean | null;
    isBuildProcurementSectionComplete?: boolean | null;
    isFurtherInfoSectionComplete?: boolean | null;
    planningResponsibility?: number | null;
    planningProcessFurtherInfo?: string | null;
    howWillSiteLookOnLoanCompletion?: string | null;
    buildProcurementType?: BuildProcurementTypeEnum | null;
    buildProcurementDetail?: string | null;
    includesContingency?: boolean | null;
    furtherInformation?: string | null;
    depositDescription?: string | null;
    guaranteeDescription?: string | null;
    hasSetCompletionDate?: boolean | null;
    searchPreferenceLoanSize?: number | null;
    searchPreferencePricing?: number | null;
    searchPreferenceCompletionSpeed?: number | null;
    searchPreferenceCustomerService?: number | null;
    hasProfessionalCostsBreakdown?: boolean | null;
    planningCosts?: number | null;
    projectManagementCosts?: number | null;
    s106CILCosts?: number | null;
    clientQSCosts?: number | null;
    mechanicalEngineeringCosts?: number | null;
    structuralEngineeringCosts?: number | null;
    partyWallCosts?: number | null;
    warrantyCosts?: number | null;
    landscapingCosts?: number | null;
    otherProfessionalCosts?: number | null;
    otherProfessionalCostsDescription?: string | null;
    marketingCosts?: number | null;
    hasPropertyScheduleBreakdown?: boolean | null;
    demolitionCosts?: number | null;
    howManyCommercialUnits?: number | null;
}

export interface DevelopmentFinanceDealPageWithTotalCountDTO {
    list?: DevelopmentFinanceDeal[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DevelopmentFinanceDeal with all properties optional except PKs */
export interface DevelopmentFinanceDealUpdate {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientUpdate[];
    dealLenders?: DealLenderUpdate[];
    attachments?: DealFileAttachmentUpdate[];
    dealNotes?: DealNoteUpdate[];
    dealSchedules?: DealScheduleUpdate[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserUpdateWithoutPKs | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserUpdateWithoutPKs | null;
    isPreConnectArchived?: boolean;
    id: number;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealUpdate[];
    /** Do you own the property(DoYouOwnTheProperty) */
    doYouOwnTheProperty?: boolean;
    /** Commercial GDV(CommercialGDV) */
    commercialGDV?: number | null;
    /** Build Term(BuildTerm) */
    buildTerm?: number;
    totalBuildCostsAdj?: number | null;
    /** Total Project Costs(TotalProjectCosts) */
    totalProjectCosts?: number | null;
    /** Legal Fees (PurchaseLegalFees) */
    purchaseLegalFees?: number | null;
    /** Sales Dressing Costs(SalesDressingCosts) */
    salesDressingCosts?: number | null;
    /** Sales Agent Fees(SalesAgentFees) */
    salesAgentFees?: number | null;
    /** Sales Legal Fees(SalesLegalFees) */
    salesLegalFees?: number | null;
    /** Sales Area Units(AreaUnit) */
    areaUnit?: AreaUnitEnum | null;
    /** Sales Area(AreaSalesAreaResidential) */
    areaSalesAreaResidential?: number | null;
    /** Sales Area(AreaSalesAreaCommercial) */
    areaSalesAreaCommercial?: number | null;
    /** Acquisition Area(AreaAcquisition) */
    areaAcquisition?: number | null;
    /** Build Costs Per Area(BuildCostPerArea) */
    buildCostPerArea?: number | null;
    /** Do you have a pre-let agreement(HasPreLetOrPreSaleAgreement) */
    hasPreLetOrPreSaleAgreement?: boolean | null;
    /** Stamp Duty(StampDutyLandTax) */
    stampDutyLandTax?: number | null;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number | null;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsWorkStarted?: boolean | null;
    f_ShareholderDepositRequired?: number | null;
    grossInternalAreaKnown?: boolean | null;
    isPlanningSectionComplete?: boolean | null;
    isBuildProcurementSectionComplete?: boolean | null;
    isFurtherInfoSectionComplete?: boolean | null;
    planningResponsibility?: number | null;
    planningProcessFurtherInfo?: string | null;
    howWillSiteLookOnLoanCompletion?: string | null;
    buildProcurementType?: BuildProcurementTypeEnum | null;
    buildProcurementDetail?: string | null;
    includesContingency?: boolean | null;
    furtherInformation?: string | null;
    depositDescription?: string | null;
    guaranteeDescription?: string | null;
    hasSetCompletionDate?: boolean | null;
    searchPreferenceLoanSize?: number | null;
    searchPreferencePricing?: number | null;
    searchPreferenceCompletionSpeed?: number | null;
    searchPreferenceCustomerService?: number | null;
    hasProfessionalCostsBreakdown?: boolean | null;
    planningCosts?: number | null;
    projectManagementCosts?: number | null;
    s106CILCosts?: number | null;
    clientQSCosts?: number | null;
    mechanicalEngineeringCosts?: number | null;
    structuralEngineeringCosts?: number | null;
    partyWallCosts?: number | null;
    warrantyCosts?: number | null;
    landscapingCosts?: number | null;
    otherProfessionalCosts?: number | null;
    otherProfessionalCostsDescription?: string | null;
    marketingCosts?: number | null;
    hasPropertyScheduleBreakdown?: boolean | null;
    demolitionCosts?: number | null;
    howManyCommercialUnits?: number | null;
}

/** DevelopmentFinanceDeal without PKs and database generated properties and with all properties optional */
export interface DevelopmentFinanceDealUpdateWithoutPKs {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    name?: string;
    uniqueRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    status?: CaseStatusEnum;
    applicationFee?: number;
    isApplicationFeePaid?: number;
    dealClients?: DealClientUpdate[];
    dealLenders?: DealLenderUpdate[];
    attachments?: DealFileAttachmentUpdate[];
    dealNotes?: DealNoteUpdate[];
    dealSchedules?: DealScheduleUpdate[];
    /** External Reference */
    externalRef?: string;
    /** Date of original Purchase(OriginalPurchaseDate) */
    originalPurchaseDate?: Date | null;
    /** Do you have a pre-let agreement(HasPreLetAgreement) */
    hasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(HasPreSaleAgreement) */
    hasPreSaleAgreement?: boolean;
    /** Loan Term(LoanTermReq) */
    loanTermReq?: number;
    /** Loan Required(LoanReq) */
    netLoanRequired?: number | null;
    /** Exit Strategy(ExitStrategy) */
    exitStrategy?: ExitStrategyEnum | null;
    exitStrategyOther?: string;
    /** Property Location */
    locations?: LocationEnum;
    /** End Property Type(EndPropertyType) */
    endPropertyType?: PropertyTypeEnum | null;
    /** End Property Type Detail(PropertyTypeDetail) */
    propertyTypeDetail?: PropertyTypeDetailEnum | null;
    /** How many houses? */
    howManyHouses?: number | null;
    /** How many flats? */
    howManyFlats?: number | null;
    /** Class Uses */
    classUses?: ClassUseEnum;
    /** Do you have a mortgage (HasExistingMortgage) */
    isMortgaged?: boolean;
    /** Existing Mortgage Balance (ExistingMortgageBalance) */
    mortgageCurrentBalance?: number;
    /** Who is the Lender (ExistingLender) */
    mortgageCurrentLender?: string;
    /** Purchase Price / Value(PurchasePrice) */
    purchasePrice?: number;
    /** Other Fees(PurchaseOtherFees) */
    purchaseOtherFees?: number | null;
    /** Additional Land Costs(LandTotalOtherCosts) */
    landTotalOtherCosts?: number;
    /** Other Build Costs(BuildOtherCosts) */
    buildOtherCosts?: number;
    /** Other Build Costs Description(BuildOtherCostsDescription) */
    buildOtherCostsDescription?: string;
    /** Additional Ongoing Costs(AdditionalOngoingCosts) */
    additionalOngoingCosts?: number;
    /** Build Costs(BuildCosts) */
    buildCosts?: number;
    /** Continguency(Contingency) */
    contingency?: number;
    /** Completion Date(CompletionDate) */
    completionDate?: Date | null;
    /** Purchase Costs(PurchaseCosts) */
    purchaseCosts?: number;
    parentCaseToAssoicateWithOnCreation?: number | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    personalGuaranteeMin?: number | null;
    personalGuaranteeMax?: number | null;
    f_IsTimberFrameConstruction?: boolean | null;
    f_IsConcreteConstruction?: boolean | null;
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    /** Excluded Lenders */
    excludedLenders?: string;
    isCaseOverviewSectionComplete?: boolean;
    submitTsAndCs?: boolean;
    siteDetails?: string;
    solicitorDetails?: string;
    accountantDetails?: string;
    nameOfUKLimitedLiabilityCompany?: string;
    ukLimitedLiabilityPartnershipNumber?: string;
    previousLenders?: string;
    propertyTenure?: TenureEnum | null;
    gdv?: number | null;
    ltc?: number | null;
    ltgdv?: number | null;
    chargeRequired?: ChargeTypeEnum;
    currentvalue?: number | null;
    hasPendingSubmitWithCriteriaChange?: boolean;
    maxLoanRequired?: boolean;
    additionalSecurity?: boolean;
    additionalSecurityInfo?: string;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    isFamilyInResidence?: YesNoMaybe | null;
    loanCompletionType?: LoanCompletionTypeEnum | null;
    isBorrowerSectionComplete?: boolean | null;
    isPropertySectionComplete?: boolean | null;
    isLoanSectionComplete?: boolean | null;
    f_IsRetypedValuation?: boolean | null;
    projectDescription?: string;
    isTenantedBuilding?: boolean | null;
    numberOfTenancies?: number | null;
    yearsLeftOnLease?: number | null;
    propertyAddress?: PostalAddress;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    lenderUser?: ApplicationUserUpdateWithoutPKs | null;
    planningStatusAtEndOfLoan?: PlanningPermissionTypeEnum | null;
    hasCompanyCcjOrBankruptcy?: boolean | null;
    companyCcjOrBankruptcyDetail?: string;
    sortBy?: SortByEnum;
    brokerCommissionPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    lenderReferralUserId?: number | null;
    lenderReferralLenderId?: number | null;
    brokerPhoneNumber?: string;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isReferredToConnect?: boolean;
    connectUser?: ApplicationUserUpdateWithoutPKs | null;
    isPreConnectArchived?: boolean;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    lenderUserId?: number | null;
    connectUserId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DealUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DealUpdate[];
    /** Do you own the property(DoYouOwnTheProperty) */
    doYouOwnTheProperty?: boolean;
    /** Commercial GDV(CommercialGDV) */
    commercialGDV?: number | null;
    /** Build Term(BuildTerm) */
    buildTerm?: number;
    totalBuildCostsAdj?: number | null;
    /** Total Project Costs(TotalProjectCosts) */
    totalProjectCosts?: number | null;
    /** Legal Fees (PurchaseLegalFees) */
    purchaseLegalFees?: number | null;
    /** Sales Dressing Costs(SalesDressingCosts) */
    salesDressingCosts?: number | null;
    /** Sales Agent Fees(SalesAgentFees) */
    salesAgentFees?: number | null;
    /** Sales Legal Fees(SalesLegalFees) */
    salesLegalFees?: number | null;
    /** Sales Area Units(AreaUnit) */
    areaUnit?: AreaUnitEnum | null;
    /** Sales Area(AreaSalesAreaResidential) */
    areaSalesAreaResidential?: number | null;
    /** Sales Area(AreaSalesAreaCommercial) */
    areaSalesAreaCommercial?: number | null;
    /** Acquisition Area(AreaAcquisition) */
    areaAcquisition?: number | null;
    /** Build Costs Per Area(BuildCostPerArea) */
    buildCostPerArea?: number | null;
    /** Do you have a pre-let agreement(HasPreLetOrPreSaleAgreement) */
    hasPreLetOrPreSaleAgreement?: boolean | null;
    /** Stamp Duty(StampDutyLandTax) */
    stampDutyLandTax?: number | null;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number | null;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsWorkStarted?: boolean | null;
    f_ShareholderDepositRequired?: number | null;
    grossInternalAreaKnown?: boolean | null;
    isPlanningSectionComplete?: boolean | null;
    isBuildProcurementSectionComplete?: boolean | null;
    isFurtherInfoSectionComplete?: boolean | null;
    planningResponsibility?: number | null;
    planningProcessFurtherInfo?: string | null;
    howWillSiteLookOnLoanCompletion?: string | null;
    buildProcurementType?: BuildProcurementTypeEnum | null;
    buildProcurementDetail?: string | null;
    includesContingency?: boolean | null;
    furtherInformation?: string | null;
    depositDescription?: string | null;
    guaranteeDescription?: string | null;
    hasSetCompletionDate?: boolean | null;
    searchPreferenceLoanSize?: number | null;
    searchPreferencePricing?: number | null;
    searchPreferenceCompletionSpeed?: number | null;
    searchPreferenceCustomerService?: number | null;
    hasProfessionalCostsBreakdown?: boolean | null;
    planningCosts?: number | null;
    projectManagementCosts?: number | null;
    s106CILCosts?: number | null;
    clientQSCosts?: number | null;
    mechanicalEngineeringCosts?: number | null;
    structuralEngineeringCosts?: number | null;
    partyWallCosts?: number | null;
    warrantyCosts?: number | null;
    landscapingCosts?: number | null;
    otherProfessionalCosts?: number | null;
    otherProfessionalCostsDescription?: string | null;
    marketingCosts?: number | null;
    hasPropertyScheduleBreakdown?: boolean | null;
    demolitionCosts?: number | null;
    howManyCommercialUnits?: number | null;
}

export interface DevelopmentInput {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend: string;
    /** Property Location */
    cI_Dev_Locations: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV: number;
    /** Percent Commercial */
    cI_PercentCommercial: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency: number;
    /** Total GDV(CI_GDV) */
    cI_GDV: number;
    /** Houses GDV */
    houses_GDV: number | null;
    /** Flats GDV */
    flats_GDV: number | null;
    /** Parking GDV */
    parking_GDV: number | null;
    /** Commercial GDV */
    commercial_GDV: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra: number;
    user?: ApplicationUser | null;
    cI_Mezz_QS_Initial: number | null;
    cI_Mezz_Val_Initial: number | null;
    cI_Mezz_FixedFee_Other: number | null;
    dev_TotLndCostAdj: number | null;
    dev_TotBuildCostsAdj: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts: number | null;
    name: string;
    searchName: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts: number;
    isFullCase: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid: number;
    /** Class Uses */
    dI_Dev_ClassUses: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate: RatePreferenceEnum;
    cI_GDVCalculated: number | null;
    cI_UseGDVCalculated: boolean;
    /** Lease Length (Years) */
    leaseLengthYears: number;
    /** Case Notes */
    caseNotes: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType: number;
    /** External Reference */
    externalRef: string;
    /** Introduced Search status */
    introducedSearchStatus: number | null;
    uniqueRef: string;
    introducerDetails: string;
    introduceeFirstName: string;
    introduceeSurname: string;
    introduceeEmail: string;
    introduceePhone: string;
    introduceeExternalRef: string;
    brokerUser?: ApplicationUser | null;
    brokerOrganisation?: Organisation | null;
    f_IsFirstTimeDeveloper: boolean | null;
    f_NumberOfPreviousDevelopments: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired: number | null;
    f_IsPersonalName: boolean | null;
    f_IsOffshoreCompany: boolean | null;
    f_IsMainShareholderOverseas: boolean | null;
    f_PersonalGuaranteeLevel: number | null;
    f_IsModular: boolean | null;
    f_IsAirRights: boolean | null;
    f_IsPermittedDevelopmentScheme: boolean | null;
    f_IsGradeOneListed: boolean | null;
    f_IsGradeTwoListed: boolean | null;
    f_MaxHouseSalesPrice: number | null;
    f_MaxFlatUnitPrice: number | null;
    f_MaxSqFtSalePrice: number | null;
    f_MaxSqFtSalePriceFlats: number | null;
    f_MaxPercCommercialForMixedUse: number | null;
    f_IsWorkStarted: boolean | null;
    f_MaxNumberOfUnits: number | null;
    f_IsChargeOnAdditionalProperty: boolean | null;
    f_IsFixedRate: boolean | null;
    f_InterestRateBasis: InterestRateBasis | null;
    f_IsBank: boolean | null;
    showLenderNamesToBorrower: boolean | null;
    /** How many houses? */
    howManyHouses: number;
    /** How many flats? */
    howManyFlats: number;
    organisationLink?: OrganisationLink | null;
    leadSourceUrl: string;
    showLenderInfoBrokerOverride: boolean;
    postcodeSearchString: string;
    sortBy: SortByEnum;
    f_HasAdverseCredit: boolean | null;
    f_MaxCommercialFloorspace: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived: boolean;
    saveQueryAndResults: boolean;
    userId: number | null;
    brokerUserId: number | null;
    brokerOrganisationId: number | null;
    organisationLinkId: number | null;
    /** Street address of the property */
    dI_StreetAddress: PostalAddress;
    developmentSchedules?: DevelopmentInputSchedule[];
    ownerUser: string;
    selectedResults?: SelectedResult[];
    /** How many units? */
    howManyUnits: number;
    /** How many blocks? */
    howManyBlocks: number;
    /** How many storeys in tallest block? */
    howManyStoreysInTallestBlock: number;
    /** Parking sold separately? */
    parkingSoldSeparately: boolean;
    /** How many parking spaces? */
    howManyParkingSpaces: number;
    introducer?: Introducer | null;
    howManyCommunalAreas: number;
    includeMezzanineFinance: boolean;
    searchPreferenceLoanSize: number;
    searchPreferencePricing: number;
    searchPreferenceCompletionSpeed: number;
    searchPreferenceCustomerService: number;
    lenderUserId: number | null;
    dealId: number | null;
    caseId: number;
    referralOrgCode: string;
    isRegulated: boolean | null;
    productType: ProductTypeEnum | null;
    ownershipDurationPeriod: number;
    comparisonList: LenderResultMinimalDTO[];
    caseStatus: CaseStatusEnum;
    saveCase: boolean;
    hasPostcode: boolean;
    selectedProduct: number;
    id: number;
    introducerId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentInput[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentInput[];
}

export interface DevelopmentInputAbstract {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend: string;
    /** Property Location */
    cI_Dev_Locations: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV: number;
    /** Percent Commercial */
    cI_PercentCommercial: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency: number;
    /** Total GDV(CI_GDV) */
    cI_GDV: number;
    /** Houses GDV */
    houses_GDV: number | null;
    /** Flats GDV */
    flats_GDV: number | null;
    /** Parking GDV */
    parking_GDV: number | null;
    /** Commercial GDV */
    commercial_GDV: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra: number;
    user?: ApplicationUser | null;
    cI_Mezz_QS_Initial: number | null;
    cI_Mezz_Val_Initial: number | null;
    cI_Mezz_FixedFee_Other: number | null;
    dev_TotLndCostAdj: number | null;
    dev_TotBuildCostsAdj: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts: number | null;
    name: string;
    searchName: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts: number;
    isFullCase: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid: number;
    /** Class Uses */
    dI_Dev_ClassUses: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate: RatePreferenceEnum;
    cI_GDVCalculated: number | null;
    cI_UseGDVCalculated: boolean;
    /** Lease Length (Years) */
    leaseLengthYears: number;
    /** Case Notes */
    caseNotes: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType: number;
    /** External Reference */
    externalRef: string;
    /** Introduced Search status */
    introducedSearchStatus: number | null;
    uniqueRef: string;
    introducerDetails: string;
    introduceeFirstName: string;
    introduceeSurname: string;
    introduceeEmail: string;
    introduceePhone: string;
    introduceeExternalRef: string;
    brokerUser?: ApplicationUser | null;
    brokerOrganisation?: Organisation | null;
    f_IsFirstTimeDeveloper: boolean | null;
    f_NumberOfPreviousDevelopments: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired: number | null;
    f_IsPersonalName: boolean | null;
    f_IsOffshoreCompany: boolean | null;
    f_IsMainShareholderOverseas: boolean | null;
    f_PersonalGuaranteeLevel: number | null;
    f_IsModular: boolean | null;
    f_IsAirRights: boolean | null;
    f_IsPermittedDevelopmentScheme: boolean | null;
    f_IsGradeOneListed: boolean | null;
    f_IsGradeTwoListed: boolean | null;
    f_MaxHouseSalesPrice: number | null;
    f_MaxFlatUnitPrice: number | null;
    f_MaxSqFtSalePrice: number | null;
    f_MaxSqFtSalePriceFlats: number | null;
    f_MaxPercCommercialForMixedUse: number | null;
    f_IsWorkStarted: boolean | null;
    f_MaxNumberOfUnits: number | null;
    f_IsChargeOnAdditionalProperty: boolean | null;
    f_IsFixedRate: boolean | null;
    f_InterestRateBasis: InterestRateBasis | null;
    f_IsBank: boolean | null;
    showLenderNamesToBorrower: boolean | null;
    /** How many houses? */
    howManyHouses: number;
    /** How many flats? */
    howManyFlats: number;
    organisationLink?: OrganisationLink | null;
    leadSourceUrl: string;
    showLenderInfoBrokerOverride: boolean;
    postcodeSearchString: string;
    sortBy: SortByEnum;
    f_HasAdverseCredit: boolean | null;
    f_MaxCommercialFloorspace: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived: boolean;
    saveQueryAndResults: boolean;
    id: number;
    userId: number | null;
    brokerUserId: number | null;
    brokerOrganisationId: number | null;
    organisationLinkId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** DevelopmentInputAbstract without database generated properties */
export interface DevelopmentInputAbstractInsert {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty?: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement?: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch?: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP?: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice?: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue?: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort?: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal?: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend?: string;
    /** Property Location */
    cI_Dev_Locations?: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType?: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail?: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV?: number;
    /** Percent Commercial */
    cI_PercentCommercial?: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT?: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts?: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL?: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning?: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS?: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting?: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency?: number;
    /** Total GDV(CI_GDV) */
    cI_GDV?: number;
    /** Houses GDV */
    houses_GDV?: number | null;
    /** Flats GDV */
    flats_GDV?: number | null;
    /** Parking GDV */
    parking_GDV?: number | null;
    /** Commercial GDV */
    commercial_GDV?: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy?: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm?: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm?: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq?: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts?: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees?: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra?: number;
    user?: ApplicationUserInsert | null;
    cI_Mezz_QS_Initial?: number | null;
    cI_Mezz_Val_Initial?: number | null;
    cI_Mezz_FixedFee_Other?: number | null;
    dev_TotLndCostAdj?: number | null;
    dev_TotBuildCostsAdj?: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts?: number | null;
    name?: string;
    searchName?: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs?: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts?: number;
    isFullCase?: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue?: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees?: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees?: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees?: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid?: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid?: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid?: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid?: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid?: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid?: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid?: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid?: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid?: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid?: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts?: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts?: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts?: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts?: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid?: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid?: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid?: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid?: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid?: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid?: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid?: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid?: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid?: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid?: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid?: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid?: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost?: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag?: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition?: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng?: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng?: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall?: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty?: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping?: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts?: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription?: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid?: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid?: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid?: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid?: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid?: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid?: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid?: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid?: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid?: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid?: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid?: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid?: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts?: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid?: number;
    /** Class Uses */
    dI_Dev_ClassUses?: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid?: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid?: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid?: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid?: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid?: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid?: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid?: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid?: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid?: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid?: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid?: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid?: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing?: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees?: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent?: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts?: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV?: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit?: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential?: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial?: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition?: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild?: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal?: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea?: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales?: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin?: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate?: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate?: RatePreferenceEnum;
    cI_GDVCalculated?: number | null;
    cI_UseGDVCalculated?: boolean;
    /** Lease Length (Years) */
    leaseLengthYears?: number;
    /** Case Notes */
    caseNotes?: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion?: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType?: number;
    /** External Reference */
    externalRef?: string;
    /** Introduced Search status */
    introducedSearchStatus?: number | null;
    uniqueRef?: string;
    introducerDetails?: string;
    introduceeFirstName?: string;
    introduceeSurname?: string;
    introduceeEmail?: string;
    introduceePhone?: string;
    introduceeExternalRef?: string;
    brokerUser?: ApplicationUserInsert | null;
    brokerOrganisation?: OrganisationInsert | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired?: number | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_IsWorkStarted?: boolean | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    f_InterestRateBasis?: InterestRateBasis | null;
    f_IsBank?: boolean | null;
    showLenderNamesToBorrower?: boolean | null;
    /** How many houses? */
    howManyHouses?: number;
    /** How many flats? */
    howManyFlats?: number;
    organisationLink?: OrganisationLinkInsert | null;
    leadSourceUrl?: string;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    sortBy?: SortByEnum;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived?: boolean;
    userId?: number | null;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
}

/** DevelopmentInputAbstract with all properties optional except PKs */
export interface DevelopmentInputAbstractUpdate {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty?: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement?: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch?: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP?: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice?: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue?: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort?: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal?: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend?: string;
    /** Property Location */
    cI_Dev_Locations?: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType?: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail?: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV?: number;
    /** Percent Commercial */
    cI_PercentCommercial?: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT?: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts?: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL?: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning?: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS?: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting?: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency?: number;
    /** Total GDV(CI_GDV) */
    cI_GDV?: number;
    /** Houses GDV */
    houses_GDV?: number | null;
    /** Flats GDV */
    flats_GDV?: number | null;
    /** Parking GDV */
    parking_GDV?: number | null;
    /** Commercial GDV */
    commercial_GDV?: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy?: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm?: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm?: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq?: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts?: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees?: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra?: number;
    user?: ApplicationUserUpdateWithoutPKs | null;
    cI_Mezz_QS_Initial?: number | null;
    cI_Mezz_Val_Initial?: number | null;
    cI_Mezz_FixedFee_Other?: number | null;
    dev_TotLndCostAdj?: number | null;
    dev_TotBuildCostsAdj?: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts?: number | null;
    name?: string;
    searchName?: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs?: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts?: number;
    isFullCase?: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue?: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees?: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees?: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees?: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid?: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid?: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid?: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid?: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid?: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid?: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid?: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid?: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid?: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid?: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts?: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts?: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts?: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts?: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid?: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid?: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid?: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid?: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid?: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid?: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid?: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid?: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid?: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid?: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid?: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid?: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost?: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag?: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition?: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng?: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng?: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall?: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty?: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping?: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts?: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription?: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid?: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid?: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid?: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid?: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid?: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid?: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid?: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid?: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid?: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid?: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid?: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid?: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts?: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid?: number;
    /** Class Uses */
    dI_Dev_ClassUses?: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid?: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid?: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid?: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid?: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid?: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid?: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid?: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid?: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid?: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid?: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid?: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid?: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing?: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees?: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent?: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts?: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV?: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit?: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential?: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial?: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition?: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild?: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal?: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea?: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales?: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin?: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate?: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate?: RatePreferenceEnum;
    cI_GDVCalculated?: number | null;
    cI_UseGDVCalculated?: boolean;
    /** Lease Length (Years) */
    leaseLengthYears?: number;
    /** Case Notes */
    caseNotes?: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion?: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType?: number;
    /** External Reference */
    externalRef?: string;
    /** Introduced Search status */
    introducedSearchStatus?: number | null;
    uniqueRef?: string;
    introducerDetails?: string;
    introduceeFirstName?: string;
    introduceeSurname?: string;
    introduceeEmail?: string;
    introduceePhone?: string;
    introduceeExternalRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired?: number | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_IsWorkStarted?: boolean | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    f_InterestRateBasis?: InterestRateBasis | null;
    f_IsBank?: boolean | null;
    showLenderNamesToBorrower?: boolean | null;
    /** How many houses? */
    howManyHouses?: number;
    /** How many flats? */
    howManyFlats?: number;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    sortBy?: SortByEnum;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived?: boolean;
    id: number;
    userId?: number | null;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
}

/** DevelopmentInputAbstract without PKs and database generated properties and with all properties optional */
export interface DevelopmentInputAbstractUpdateWithoutPKs {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty?: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement?: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch?: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP?: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice?: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue?: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort?: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal?: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend?: string;
    /** Property Location */
    cI_Dev_Locations?: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType?: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail?: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV?: number;
    /** Percent Commercial */
    cI_PercentCommercial?: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT?: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts?: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL?: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning?: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS?: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting?: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency?: number;
    /** Total GDV(CI_GDV) */
    cI_GDV?: number;
    /** Houses GDV */
    houses_GDV?: number | null;
    /** Flats GDV */
    flats_GDV?: number | null;
    /** Parking GDV */
    parking_GDV?: number | null;
    /** Commercial GDV */
    commercial_GDV?: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy?: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm?: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm?: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq?: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts?: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees?: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra?: number;
    user?: ApplicationUserUpdateWithoutPKs | null;
    cI_Mezz_QS_Initial?: number | null;
    cI_Mezz_Val_Initial?: number | null;
    cI_Mezz_FixedFee_Other?: number | null;
    dev_TotLndCostAdj?: number | null;
    dev_TotBuildCostsAdj?: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts?: number | null;
    name?: string;
    searchName?: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs?: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts?: number;
    isFullCase?: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue?: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees?: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees?: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees?: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid?: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid?: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid?: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid?: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid?: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid?: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid?: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid?: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid?: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid?: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts?: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts?: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts?: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts?: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid?: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid?: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid?: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid?: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid?: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid?: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid?: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid?: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid?: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid?: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid?: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid?: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost?: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag?: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition?: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng?: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng?: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall?: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty?: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping?: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts?: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription?: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid?: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid?: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid?: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid?: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid?: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid?: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid?: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid?: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid?: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid?: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid?: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid?: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts?: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid?: number;
    /** Class Uses */
    dI_Dev_ClassUses?: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid?: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid?: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid?: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid?: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid?: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid?: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid?: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid?: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid?: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid?: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid?: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid?: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing?: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees?: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent?: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts?: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV?: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit?: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential?: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial?: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition?: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild?: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal?: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea?: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales?: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin?: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate?: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate?: RatePreferenceEnum;
    cI_GDVCalculated?: number | null;
    cI_UseGDVCalculated?: boolean;
    /** Lease Length (Years) */
    leaseLengthYears?: number;
    /** Case Notes */
    caseNotes?: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion?: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType?: number;
    /** External Reference */
    externalRef?: string;
    /** Introduced Search status */
    introducedSearchStatus?: number | null;
    uniqueRef?: string;
    introducerDetails?: string;
    introduceeFirstName?: string;
    introduceeSurname?: string;
    introduceeEmail?: string;
    introduceePhone?: string;
    introduceeExternalRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired?: number | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_IsWorkStarted?: boolean | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    f_InterestRateBasis?: InterestRateBasis | null;
    f_IsBank?: boolean | null;
    showLenderNamesToBorrower?: boolean | null;
    /** How many houses? */
    howManyHouses?: number;
    /** How many flats? */
    howManyFlats?: number;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    sortBy?: SortByEnum;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived?: boolean;
    userId?: number | null;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
}

export interface DevelopmentInputDTO {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    readonly dI_OwnedForMoreThanThreshold?: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty?: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement?: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch?: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP?: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice?: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue?: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort?: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal?: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend?: string;
    /** Property Location */
    cI_Dev_Locations?: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType?: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail?: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV?: number;
    /** Percent Commercial */
    cI_PercentCommercial?: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT?: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts?: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL?: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning?: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS?: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting?: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency?: number;
    /** Total GDV(CI_GDV) */
    cI_GDV?: number;
    /** Houses GDV */
    houses_GDV?: number | null;
    /** Flats GDV */
    flats_GDV?: number | null;
    /** Parking GDV */
    parking_GDV?: number | null;
    /** Commercial GDV */
    commercial_GDV?: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy?: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm?: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm?: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq?: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts?: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees?: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra?: number;
    user?: ApplicationUser | null;
    cI_Mezz_QS_Initial?: number | null;
    cI_Mezz_Val_Initial?: number | null;
    cI_Mezz_FixedFee_Other?: number | null;
    dev_TotLndCostAdj?: number | null;
    dev_TotBuildCostsAdj?: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts?: number | null;
    name?: string;
    searchName?: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs?: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts?: number;
    isFullCase?: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue?: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees?: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees?: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees?: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid?: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid?: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid?: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid?: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid?: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid?: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid?: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid?: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid?: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid?: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts?: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts?: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts?: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts?: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid?: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid?: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid?: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid?: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid?: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid?: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid?: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid?: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid?: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid?: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid?: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid?: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost?: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag?: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition?: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng?: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng?: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall?: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty?: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping?: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts?: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription?: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid?: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid?: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid?: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid?: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid?: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid?: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid?: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid?: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid?: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid?: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid?: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid?: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts?: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid?: number;
    /** Class Uses */
    dI_Dev_ClassUses?: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid?: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid?: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid?: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid?: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid?: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid?: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid?: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid?: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid?: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid?: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid?: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid?: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing?: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees?: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent?: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts?: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV?: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit?: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential?: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial?: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition?: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild?: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal?: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea?: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales?: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin?: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate?: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate?: RatePreferenceEnum;
    cI_GDVCalculated?: number | null;
    cI_UseGDVCalculated?: boolean;
    /** Lease Length (Years) */
    leaseLengthYears?: number;
    /** Case Notes */
    caseNotes?: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion?: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType?: number;
    /** External Reference */
    externalRef?: string;
    /** Introduced Search status */
    introducedSearchStatus?: number | null;
    uniqueRef?: string;
    introducerDetails?: string;
    introduceeFirstName?: string;
    introduceeSurname?: string;
    introduceeEmail?: string;
    introduceePhone?: string;
    introduceeExternalRef?: string;
    brokerUser?: ApplicationUser | null;
    brokerOrganisation?: Organisation | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired?: number | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_IsWorkStarted?: boolean | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    f_InterestRateBasis?: InterestRateBasis | null;
    f_IsBank?: boolean | null;
    showLenderNamesToBorrower?: boolean | null;
    /** How many houses? */
    howManyHouses?: number;
    /** How many flats? */
    howManyFlats?: number;
    organisationLink?: OrganisationLink | null;
    leadSourceUrl?: string;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    sortBy?: SortByEnum;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived?: boolean;
    saveQueryAndResults?: boolean;
    id?: number;
    userId?: number | null;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    isDeleted?: boolean;
    createdDateTime?: Date | null;
    lastUpdatedDateTime?: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId?: number | null;
    createdUserId?: number | null;
    createdUser?: ApplicationUser | null;
    dI_StreetAddress?: PostalAddress;
    ownerUser?: string;
    howManyUnits?: number;
    howManyBlocks?: number;
    howManyStoreysInTallestBlock?: number;
    howManyCommunalAreas?: number;
    parkingSoldSeparately?: boolean;
    howManyParkingSpaces?: number;
    introducerId?: number | null;
    includeMezzanineFinance?: boolean;
    searchPreferenceLoanSize?: number;
    searchPreferencePricing?: number;
    searchPreferenceCompletionSpeed?: number;
    searchPreferenceCustomerService?: number;
    selectedResults?: SelectedResult[];
    caseId?: number | null;
    caseStatus?: CaseStatusEnum;
    referralOrgCode?: string;
    comparisonList?: LenderResultMinimalDTO[];
    readonly hasPostcode?: boolean;
    lenderUserId?: number;
    isRegulated?: boolean | null;
    productType?: ProductTypeEnum | null;
}

/** DevelopmentInput without database generated properties */
export interface DevelopmentInputInsert {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty?: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement?: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch?: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP?: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice?: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue?: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort?: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal?: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend?: string;
    /** Property Location */
    cI_Dev_Locations?: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType?: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail?: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV?: number;
    /** Percent Commercial */
    cI_PercentCommercial?: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT?: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts?: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL?: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning?: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS?: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting?: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency?: number;
    /** Total GDV(CI_GDV) */
    cI_GDV?: number;
    /** Houses GDV */
    houses_GDV?: number | null;
    /** Flats GDV */
    flats_GDV?: number | null;
    /** Parking GDV */
    parking_GDV?: number | null;
    /** Commercial GDV */
    commercial_GDV?: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy?: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm?: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm?: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq?: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts?: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees?: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra?: number;
    user?: ApplicationUserInsert | null;
    cI_Mezz_QS_Initial?: number | null;
    cI_Mezz_Val_Initial?: number | null;
    cI_Mezz_FixedFee_Other?: number | null;
    dev_TotLndCostAdj?: number | null;
    dev_TotBuildCostsAdj?: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts?: number | null;
    name?: string;
    searchName?: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs?: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts?: number;
    isFullCase?: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue?: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees?: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees?: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees?: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid?: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid?: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid?: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid?: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid?: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid?: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid?: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid?: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid?: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid?: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts?: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts?: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts?: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts?: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid?: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid?: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid?: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid?: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid?: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid?: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid?: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid?: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid?: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid?: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid?: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid?: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost?: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag?: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition?: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng?: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng?: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall?: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty?: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping?: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts?: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription?: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid?: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid?: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid?: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid?: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid?: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid?: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid?: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid?: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid?: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid?: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid?: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid?: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts?: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid?: number;
    /** Class Uses */
    dI_Dev_ClassUses?: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid?: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid?: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid?: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid?: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid?: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid?: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid?: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid?: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid?: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid?: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid?: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid?: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing?: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees?: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent?: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts?: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV?: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit?: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential?: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial?: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition?: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild?: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal?: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea?: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales?: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin?: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate?: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate?: RatePreferenceEnum;
    cI_GDVCalculated?: number | null;
    cI_UseGDVCalculated?: boolean;
    /** Lease Length (Years) */
    leaseLengthYears?: number;
    /** Case Notes */
    caseNotes?: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion?: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType?: number;
    /** External Reference */
    externalRef?: string;
    /** Introduced Search status */
    introducedSearchStatus?: number | null;
    uniqueRef?: string;
    introducerDetails?: string;
    introduceeFirstName?: string;
    introduceeSurname?: string;
    introduceeEmail?: string;
    introduceePhone?: string;
    introduceeExternalRef?: string;
    brokerUser?: ApplicationUserInsert | null;
    brokerOrganisation?: OrganisationInsert | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired?: number | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_IsWorkStarted?: boolean | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    f_InterestRateBasis?: InterestRateBasis | null;
    f_IsBank?: boolean | null;
    showLenderNamesToBorrower?: boolean | null;
    /** How many houses? */
    howManyHouses?: number;
    /** How many flats? */
    howManyFlats?: number;
    organisationLink?: OrganisationLinkInsert | null;
    leadSourceUrl?: string;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    sortBy?: SortByEnum;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived?: boolean;
    userId?: number | null;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    /** Street address of the property */
    dI_StreetAddress?: PostalAddress;
    developmentSchedules?: DevelopmentInputScheduleInsert[];
    ownerUser?: string;
    selectedResults?: SelectedResultInsert[];
    /** How many units? */
    howManyUnits?: number;
    /** How many blocks? */
    howManyBlocks?: number;
    /** How many storeys in tallest block? */
    howManyStoreysInTallestBlock?: number;
    /** Parking sold separately? */
    parkingSoldSeparately?: boolean;
    /** How many parking spaces? */
    howManyParkingSpaces?: number;
    introducer?: IntroducerInsert | null;
    howManyCommunalAreas?: number;
    includeMezzanineFinance?: boolean;
    searchPreferenceLoanSize?: number;
    searchPreferencePricing?: number;
    searchPreferenceCompletionSpeed?: number;
    searchPreferenceCustomerService?: number;
    lenderUserId?: number | null;
    dealId?: number | null;
    introducerId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentInputInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentInputInsert[];
}

export interface DevelopmentInputPageWithTotalCountDTO {
    list?: DevelopmentInput[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface DevelopmentInputSchedule {
    developmentInput?: DevelopmentInput;
    /** Order Id */
    orderId: number;
    /** LocationIdentifier */
    locationIdentifier: string;
    /** Description */
    description: string;
    /** #Beds */
    numberOfBeds: number | null;
    /** #Baths */
    numberOfBaths: number | null;
    flatStorey: number | null;
    /** PostCode */
    postCode: string;
    /** City */
    city: string;
    /** Type */
    type: UnitTypeEnum;
    /** Quantity */
    numberOfUnits: number;
    /** Area */
    area: number;
    /** Sales Price */
    salesPrice: number;
    /** Note */
    note: string;
    /** Tenure */
    tenure: TenureEnum;
    /** Class Use */
    classUse: ClassUseEnum;
    /** Pre let / sold */
    preAgreement: PreAgreementEnum;
    /** Company Name */
    companyName: string;
    /** Company Number */
    companyNumber: number;
    /** Length Of Let (Years) */
    lengthOfLetYears: number;
    /** Has Break Clause */
    hasBreakClause: boolean;
    /** Break Clause Length(Years) */
    breakClauseLengthInYears: number;
    /** Annual Rent */
    annualRent: number;
    /** Annual Rent Actual or Estimated */
    annualRentActualOrEstimated: number;
    /** Date Sold */
    dateSold: Date | null;
    /** Area Units(DI_AreaUnit) */
    areaUnit: AreaUnitEnum;
    /** Schedule Type */
    scheduleType: ScheduleTypeEnum;
    /** Balcony (Yes /No)? */
    hasBalcany: boolean;
    monthlyRent: number;
    id: number;
    developmentInputId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentInputSchedule[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentInputSchedule[];
}

/** DevelopmentInputSchedule without database generated properties */
export interface DevelopmentInputScheduleInsert {
    developmentInput: DevelopmentInputInsert | null;
    /** Order Id */
    orderId?: number;
    /** LocationIdentifier */
    locationIdentifier?: string;
    /** Description */
    description?: string;
    /** #Beds */
    numberOfBeds?: number | null;
    /** #Baths */
    numberOfBaths?: number | null;
    flatStorey?: number | null;
    /** PostCode */
    postCode?: string;
    /** City */
    city?: string;
    /** Type */
    type?: UnitTypeEnum;
    /** Quantity */
    numberOfUnits?: number;
    /** Area */
    area?: number;
    /** Sales Price */
    salesPrice?: number;
    /** Note */
    note?: string;
    /** Tenure */
    tenure?: TenureEnum;
    /** Class Use */
    classUse?: ClassUseEnum;
    /** Pre let / sold */
    preAgreement?: PreAgreementEnum;
    /** Company Name */
    companyName?: string;
    /** Company Number */
    companyNumber?: number;
    /** Length Of Let (Years) */
    lengthOfLetYears?: number;
    /** Has Break Clause */
    hasBreakClause?: boolean;
    /** Break Clause Length(Years) */
    breakClauseLengthInYears?: number;
    /** Annual Rent */
    annualRent?: number;
    /** Annual Rent Actual or Estimated */
    annualRentActualOrEstimated?: number;
    /** Date Sold */
    dateSold?: Date | null;
    /** Area Units(DI_AreaUnit) */
    areaUnit?: AreaUnitEnum;
    /** Schedule Type */
    scheduleType?: ScheduleTypeEnum;
    /** Balcony (Yes /No)? */
    hasBalcany?: boolean;
    monthlyRent?: number;
    developmentInputId: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentInputScheduleInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentInputScheduleInsert[];
}

export interface DevelopmentInputSchedulePageWithTotalCountDTO {
    list?: DevelopmentInputSchedule[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DevelopmentInputSchedule with all properties optional except PKs */
export interface DevelopmentInputScheduleUpdate {
    developmentInput?: DevelopmentInputUpdateWithoutPKs | null;
    /** Order Id */
    orderId?: number;
    /** LocationIdentifier */
    locationIdentifier?: string;
    /** Description */
    description?: string;
    /** #Beds */
    numberOfBeds?: number | null;
    /** #Baths */
    numberOfBaths?: number | null;
    flatStorey?: number | null;
    /** PostCode */
    postCode?: string;
    /** City */
    city?: string;
    /** Type */
    type?: UnitTypeEnum;
    /** Quantity */
    numberOfUnits?: number;
    /** Area */
    area?: number;
    /** Sales Price */
    salesPrice?: number;
    /** Note */
    note?: string;
    /** Tenure */
    tenure?: TenureEnum;
    /** Class Use */
    classUse?: ClassUseEnum;
    /** Pre let / sold */
    preAgreement?: PreAgreementEnum;
    /** Company Name */
    companyName?: string;
    /** Company Number */
    companyNumber?: number;
    /** Length Of Let (Years) */
    lengthOfLetYears?: number;
    /** Has Break Clause */
    hasBreakClause?: boolean;
    /** Break Clause Length(Years) */
    breakClauseLengthInYears?: number;
    /** Annual Rent */
    annualRent?: number;
    /** Annual Rent Actual or Estimated */
    annualRentActualOrEstimated?: number;
    /** Date Sold */
    dateSold?: Date | null;
    /** Area Units(DI_AreaUnit) */
    areaUnit?: AreaUnitEnum;
    /** Schedule Type */
    scheduleType?: ScheduleTypeEnum;
    /** Balcony (Yes /No)? */
    hasBalcany?: boolean;
    monthlyRent?: number;
    id: number;
    developmentInputId?: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentInputScheduleUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentInputScheduleUpdate[];
}

/** DevelopmentInputSchedule without PKs and database generated properties and with all properties optional */
export interface DevelopmentInputScheduleUpdateWithoutPKs {
    developmentInput?: DevelopmentInputUpdateWithoutPKs | null;
    /** Order Id */
    orderId?: number;
    /** LocationIdentifier */
    locationIdentifier?: string;
    /** Description */
    description?: string;
    /** #Beds */
    numberOfBeds?: number | null;
    /** #Baths */
    numberOfBaths?: number | null;
    flatStorey?: number | null;
    /** PostCode */
    postCode?: string;
    /** City */
    city?: string;
    /** Type */
    type?: UnitTypeEnum;
    /** Quantity */
    numberOfUnits?: number;
    /** Area */
    area?: number;
    /** Sales Price */
    salesPrice?: number;
    /** Note */
    note?: string;
    /** Tenure */
    tenure?: TenureEnum;
    /** Class Use */
    classUse?: ClassUseEnum;
    /** Pre let / sold */
    preAgreement?: PreAgreementEnum;
    /** Company Name */
    companyName?: string;
    /** Company Number */
    companyNumber?: number;
    /** Length Of Let (Years) */
    lengthOfLetYears?: number;
    /** Has Break Clause */
    hasBreakClause?: boolean;
    /** Break Clause Length(Years) */
    breakClauseLengthInYears?: number;
    /** Annual Rent */
    annualRent?: number;
    /** Annual Rent Actual or Estimated */
    annualRentActualOrEstimated?: number;
    /** Date Sold */
    dateSold?: Date | null;
    /** Area Units(DI_AreaUnit) */
    areaUnit?: AreaUnitEnum;
    /** Schedule Type */
    scheduleType?: ScheduleTypeEnum;
    /** Balcony (Yes /No)? */
    hasBalcany?: boolean;
    monthlyRent?: number;
    developmentInputId?: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentInputScheduleUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentInputScheduleUpdate[];
}

/** DevelopmentInput with all properties optional except PKs */
export interface DevelopmentInputUpdate {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty?: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement?: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch?: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP?: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice?: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue?: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort?: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal?: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend?: string;
    /** Property Location */
    cI_Dev_Locations?: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType?: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail?: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV?: number;
    /** Percent Commercial */
    cI_PercentCommercial?: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT?: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts?: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL?: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning?: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS?: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting?: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency?: number;
    /** Total GDV(CI_GDV) */
    cI_GDV?: number;
    /** Houses GDV */
    houses_GDV?: number | null;
    /** Flats GDV */
    flats_GDV?: number | null;
    /** Parking GDV */
    parking_GDV?: number | null;
    /** Commercial GDV */
    commercial_GDV?: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy?: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm?: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm?: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq?: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts?: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees?: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra?: number;
    user?: ApplicationUserUpdateWithoutPKs | null;
    cI_Mezz_QS_Initial?: number | null;
    cI_Mezz_Val_Initial?: number | null;
    cI_Mezz_FixedFee_Other?: number | null;
    dev_TotLndCostAdj?: number | null;
    dev_TotBuildCostsAdj?: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts?: number | null;
    name?: string;
    searchName?: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs?: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts?: number;
    isFullCase?: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue?: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees?: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees?: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees?: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid?: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid?: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid?: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid?: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid?: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid?: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid?: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid?: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid?: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid?: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts?: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts?: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts?: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts?: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid?: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid?: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid?: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid?: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid?: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid?: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid?: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid?: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid?: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid?: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid?: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid?: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost?: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag?: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition?: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng?: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng?: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall?: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty?: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping?: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts?: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription?: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid?: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid?: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid?: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid?: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid?: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid?: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid?: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid?: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid?: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid?: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid?: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid?: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts?: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid?: number;
    /** Class Uses */
    dI_Dev_ClassUses?: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid?: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid?: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid?: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid?: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid?: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid?: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid?: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid?: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid?: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid?: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid?: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid?: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing?: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees?: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent?: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts?: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV?: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit?: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential?: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial?: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition?: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild?: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal?: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea?: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales?: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin?: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate?: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate?: RatePreferenceEnum;
    cI_GDVCalculated?: number | null;
    cI_UseGDVCalculated?: boolean;
    /** Lease Length (Years) */
    leaseLengthYears?: number;
    /** Case Notes */
    caseNotes?: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion?: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType?: number;
    /** External Reference */
    externalRef?: string;
    /** Introduced Search status */
    introducedSearchStatus?: number | null;
    uniqueRef?: string;
    introducerDetails?: string;
    introduceeFirstName?: string;
    introduceeSurname?: string;
    introduceeEmail?: string;
    introduceePhone?: string;
    introduceeExternalRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired?: number | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_IsWorkStarted?: boolean | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    f_InterestRateBasis?: InterestRateBasis | null;
    f_IsBank?: boolean | null;
    showLenderNamesToBorrower?: boolean | null;
    /** How many houses? */
    howManyHouses?: number;
    /** How many flats? */
    howManyFlats?: number;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    sortBy?: SortByEnum;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived?: boolean;
    userId?: number | null;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    /** Street address of the property */
    dI_StreetAddress?: PostalAddress;
    developmentSchedules?: DevelopmentInputScheduleUpdate[];
    ownerUser?: string;
    selectedResults?: SelectedResultUpdate[];
    /** How many units? */
    howManyUnits?: number;
    /** How many blocks? */
    howManyBlocks?: number;
    /** How many storeys in tallest block? */
    howManyStoreysInTallestBlock?: number;
    /** Parking sold separately? */
    parkingSoldSeparately?: boolean;
    /** How many parking spaces? */
    howManyParkingSpaces?: number;
    introducer?: IntroducerUpdateWithoutPKs | null;
    howManyCommunalAreas?: number;
    includeMezzanineFinance?: boolean;
    searchPreferenceLoanSize?: number;
    searchPreferencePricing?: number;
    searchPreferenceCompletionSpeed?: number;
    searchPreferenceCustomerService?: number;
    lenderUserId?: number | null;
    dealId?: number | null;
    id: number;
    introducerId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentInputUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentInputUpdate[];
}

/** DevelopmentInput without PKs and database generated properties and with all properties optional */
export interface DevelopmentInputUpdateWithoutPKs {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty?: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement?: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch?: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP?: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice?: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue?: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort?: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal?: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend?: string;
    /** Property Location */
    cI_Dev_Locations?: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType?: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail?: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV?: number;
    /** Percent Commercial */
    cI_PercentCommercial?: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT?: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts?: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL?: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning?: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS?: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting?: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency?: number;
    /** Total GDV(CI_GDV) */
    cI_GDV?: number;
    /** Houses GDV */
    houses_GDV?: number | null;
    /** Flats GDV */
    flats_GDV?: number | null;
    /** Parking GDV */
    parking_GDV?: number | null;
    /** Commercial GDV */
    commercial_GDV?: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy?: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm?: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm?: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq?: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts?: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees?: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra?: number;
    user?: ApplicationUserUpdateWithoutPKs | null;
    cI_Mezz_QS_Initial?: number | null;
    cI_Mezz_Val_Initial?: number | null;
    cI_Mezz_FixedFee_Other?: number | null;
    dev_TotLndCostAdj?: number | null;
    dev_TotBuildCostsAdj?: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts?: number | null;
    name?: string;
    searchName?: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs?: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts?: number;
    isFullCase?: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue?: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees?: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees?: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees?: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid?: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid?: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid?: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid?: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid?: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid?: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid?: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid?: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid?: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid?: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts?: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts?: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts?: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts?: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid?: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid?: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid?: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid?: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid?: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid?: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid?: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid?: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid?: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid?: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid?: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid?: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost?: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag?: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition?: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng?: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng?: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall?: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty?: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping?: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts?: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription?: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid?: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid?: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid?: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid?: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid?: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid?: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid?: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid?: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid?: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid?: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid?: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid?: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts?: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid?: number;
    /** Class Uses */
    dI_Dev_ClassUses?: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid?: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid?: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid?: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid?: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid?: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid?: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid?: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid?: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid?: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid?: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid?: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid?: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing?: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees?: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent?: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts?: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV?: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit?: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential?: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial?: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition?: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild?: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal?: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea?: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales?: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin?: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate?: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate?: RatePreferenceEnum;
    cI_GDVCalculated?: number | null;
    cI_UseGDVCalculated?: boolean;
    /** Lease Length (Years) */
    leaseLengthYears?: number;
    /** Case Notes */
    caseNotes?: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion?: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType?: number;
    /** External Reference */
    externalRef?: string;
    /** Introduced Search status */
    introducedSearchStatus?: number | null;
    uniqueRef?: string;
    introducerDetails?: string;
    introduceeFirstName?: string;
    introduceeSurname?: string;
    introduceeEmail?: string;
    introduceePhone?: string;
    introduceeExternalRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired?: number | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_IsWorkStarted?: boolean | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    f_InterestRateBasis?: InterestRateBasis | null;
    f_IsBank?: boolean | null;
    showLenderNamesToBorrower?: boolean | null;
    /** How many houses? */
    howManyHouses?: number;
    /** How many flats? */
    howManyFlats?: number;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    sortBy?: SortByEnum;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived?: boolean;
    userId?: number | null;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    /** Street address of the property */
    dI_StreetAddress?: PostalAddress;
    developmentSchedules?: DevelopmentInputScheduleUpdate[];
    ownerUser?: string;
    selectedResults?: SelectedResultUpdate[];
    /** How many units? */
    howManyUnits?: number;
    /** How many blocks? */
    howManyBlocks?: number;
    /** How many storeys in tallest block? */
    howManyStoreysInTallestBlock?: number;
    /** Parking sold separately? */
    parkingSoldSeparately?: boolean;
    /** How many parking spaces? */
    howManyParkingSpaces?: number;
    introducer?: IntroducerUpdateWithoutPKs | null;
    howManyCommunalAreas?: number;
    includeMezzanineFinance?: boolean;
    searchPreferenceLoanSize?: number;
    searchPreferencePricing?: number;
    searchPreferenceCompletionSpeed?: number;
    searchPreferenceCustomerService?: number;
    lenderUserId?: number | null;
    dealId?: number | null;
    introducerId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentInputUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentInputUpdate[];
}

export interface DevelopmentInputWithNoLogin {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend: string;
    /** Property Location */
    cI_Dev_Locations: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV: number;
    /** Percent Commercial */
    cI_PercentCommercial: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency: number;
    /** Total GDV(CI_GDV) */
    cI_GDV: number;
    /** Houses GDV */
    houses_GDV: number | null;
    /** Flats GDV */
    flats_GDV: number | null;
    /** Parking GDV */
    parking_GDV: number | null;
    /** Commercial GDV */
    commercial_GDV: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra: number;
    user?: ApplicationUser | null;
    cI_Mezz_QS_Initial: number | null;
    cI_Mezz_Val_Initial: number | null;
    cI_Mezz_FixedFee_Other: number | null;
    dev_TotLndCostAdj: number | null;
    dev_TotBuildCostsAdj: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts: number | null;
    name: string;
    searchName: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts: number;
    isFullCase: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid: number;
    /** Class Uses */
    dI_Dev_ClassUses: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate: RatePreferenceEnum;
    cI_GDVCalculated: number | null;
    cI_UseGDVCalculated: boolean;
    /** Lease Length (Years) */
    leaseLengthYears: number;
    /** Case Notes */
    caseNotes: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType: number;
    /** External Reference */
    externalRef: string;
    /** Introduced Search status */
    introducedSearchStatus: number | null;
    uniqueRef: string;
    introducerDetails: string;
    introduceeFirstName: string;
    introduceeSurname: string;
    introduceeEmail: string;
    introduceePhone: string;
    introduceeExternalRef: string;
    brokerUser?: ApplicationUser | null;
    brokerOrganisation?: Organisation | null;
    f_IsFirstTimeDeveloper: boolean | null;
    f_NumberOfPreviousDevelopments: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired: number | null;
    f_IsPersonalName: boolean | null;
    f_IsOffshoreCompany: boolean | null;
    f_IsMainShareholderOverseas: boolean | null;
    f_PersonalGuaranteeLevel: number | null;
    f_IsModular: boolean | null;
    f_IsAirRights: boolean | null;
    f_IsPermittedDevelopmentScheme: boolean | null;
    f_IsGradeOneListed: boolean | null;
    f_IsGradeTwoListed: boolean | null;
    f_MaxHouseSalesPrice: number | null;
    f_MaxFlatUnitPrice: number | null;
    f_MaxSqFtSalePrice: number | null;
    f_MaxSqFtSalePriceFlats: number | null;
    f_MaxPercCommercialForMixedUse: number | null;
    f_IsWorkStarted: boolean | null;
    f_MaxNumberOfUnits: number | null;
    f_IsChargeOnAdditionalProperty: boolean | null;
    f_IsFixedRate: boolean | null;
    f_InterestRateBasis: InterestRateBasis | null;
    f_IsBank: boolean | null;
    showLenderNamesToBorrower: boolean | null;
    /** How many houses? */
    howManyHouses: number;
    /** How many flats? */
    howManyFlats: number;
    organisationLink?: OrganisationLink | null;
    leadSourceUrl: string;
    showLenderInfoBrokerOverride: boolean;
    postcodeSearchString: string;
    sortBy: SortByEnum;
    f_HasAdverseCredit: boolean | null;
    f_MaxCommercialFloorspace: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived: boolean;
    saveQueryAndResults: boolean;
    userId: number | null;
    brokerUserId: number | null;
    brokerOrganisationId: number | null;
    organisationLinkId: number | null;
    ownerUser: string;
    ipAddressOfUser: string;
    introducer?: Introducer | null;
    selectedResults: SelectedResultDTO[];
    saveCase: boolean;
    id: number;
    introducerId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** DevelopmentInputWithNoLogin without database generated properties */
export interface DevelopmentInputWithNoLoginInsert {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty?: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement?: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch?: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP?: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice?: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue?: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort?: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal?: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend?: string;
    /** Property Location */
    cI_Dev_Locations?: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType?: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail?: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV?: number;
    /** Percent Commercial */
    cI_PercentCommercial?: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT?: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts?: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL?: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning?: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS?: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting?: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency?: number;
    /** Total GDV(CI_GDV) */
    cI_GDV?: number;
    /** Houses GDV */
    houses_GDV?: number | null;
    /** Flats GDV */
    flats_GDV?: number | null;
    /** Parking GDV */
    parking_GDV?: number | null;
    /** Commercial GDV */
    commercial_GDV?: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy?: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm?: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm?: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq?: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts?: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees?: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra?: number;
    user?: ApplicationUserInsert | null;
    cI_Mezz_QS_Initial?: number | null;
    cI_Mezz_Val_Initial?: number | null;
    cI_Mezz_FixedFee_Other?: number | null;
    dev_TotLndCostAdj?: number | null;
    dev_TotBuildCostsAdj?: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts?: number | null;
    name?: string;
    searchName?: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs?: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts?: number;
    isFullCase?: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue?: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees?: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees?: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees?: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid?: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid?: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid?: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid?: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid?: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid?: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid?: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid?: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid?: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid?: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts?: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts?: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts?: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts?: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid?: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid?: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid?: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid?: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid?: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid?: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid?: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid?: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid?: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid?: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid?: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid?: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost?: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag?: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition?: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng?: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng?: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall?: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty?: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping?: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts?: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription?: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid?: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid?: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid?: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid?: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid?: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid?: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid?: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid?: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid?: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid?: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid?: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid?: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts?: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid?: number;
    /** Class Uses */
    dI_Dev_ClassUses?: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid?: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid?: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid?: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid?: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid?: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid?: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid?: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid?: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid?: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid?: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid?: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid?: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing?: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees?: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent?: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts?: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV?: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit?: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential?: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial?: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition?: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild?: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal?: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea?: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales?: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin?: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate?: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate?: RatePreferenceEnum;
    cI_GDVCalculated?: number | null;
    cI_UseGDVCalculated?: boolean;
    /** Lease Length (Years) */
    leaseLengthYears?: number;
    /** Case Notes */
    caseNotes?: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion?: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType?: number;
    /** External Reference */
    externalRef?: string;
    /** Introduced Search status */
    introducedSearchStatus?: number | null;
    uniqueRef?: string;
    introducerDetails?: string;
    introduceeFirstName?: string;
    introduceeSurname?: string;
    introduceeEmail?: string;
    introduceePhone?: string;
    introduceeExternalRef?: string;
    brokerUser?: ApplicationUserInsert | null;
    brokerOrganisation?: OrganisationInsert | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired?: number | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_IsWorkStarted?: boolean | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    f_InterestRateBasis?: InterestRateBasis | null;
    f_IsBank?: boolean | null;
    showLenderNamesToBorrower?: boolean | null;
    /** How many houses? */
    howManyHouses?: number;
    /** How many flats? */
    howManyFlats?: number;
    organisationLink?: OrganisationLinkInsert | null;
    leadSourceUrl?: string;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    sortBy?: SortByEnum;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived?: boolean;
    userId?: number | null;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    ownerUser?: string;
    ipAddressOfUser?: string;
    introducer?: IntroducerInsert | null;
    introducerId?: number | null;
}

export interface DevelopmentInputWithNoLoginPageWithTotalCountDTO {
    list?: DevelopmentInputWithNoLogin[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DevelopmentInputWithNoLogin with all properties optional except PKs */
export interface DevelopmentInputWithNoLoginUpdate {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty?: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement?: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch?: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP?: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice?: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue?: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort?: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal?: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend?: string;
    /** Property Location */
    cI_Dev_Locations?: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType?: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail?: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV?: number;
    /** Percent Commercial */
    cI_PercentCommercial?: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT?: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts?: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL?: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning?: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS?: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting?: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency?: number;
    /** Total GDV(CI_GDV) */
    cI_GDV?: number;
    /** Houses GDV */
    houses_GDV?: number | null;
    /** Flats GDV */
    flats_GDV?: number | null;
    /** Parking GDV */
    parking_GDV?: number | null;
    /** Commercial GDV */
    commercial_GDV?: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy?: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm?: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm?: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq?: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts?: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees?: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra?: number;
    user?: ApplicationUserUpdateWithoutPKs | null;
    cI_Mezz_QS_Initial?: number | null;
    cI_Mezz_Val_Initial?: number | null;
    cI_Mezz_FixedFee_Other?: number | null;
    dev_TotLndCostAdj?: number | null;
    dev_TotBuildCostsAdj?: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts?: number | null;
    name?: string;
    searchName?: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs?: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts?: number;
    isFullCase?: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue?: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees?: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees?: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees?: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid?: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid?: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid?: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid?: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid?: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid?: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid?: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid?: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid?: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid?: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts?: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts?: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts?: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts?: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid?: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid?: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid?: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid?: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid?: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid?: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid?: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid?: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid?: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid?: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid?: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid?: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost?: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag?: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition?: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng?: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng?: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall?: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty?: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping?: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts?: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription?: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid?: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid?: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid?: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid?: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid?: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid?: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid?: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid?: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid?: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid?: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid?: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid?: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts?: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid?: number;
    /** Class Uses */
    dI_Dev_ClassUses?: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid?: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid?: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid?: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid?: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid?: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid?: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid?: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid?: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid?: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid?: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid?: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid?: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing?: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees?: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent?: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts?: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV?: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit?: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential?: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial?: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition?: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild?: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal?: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea?: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales?: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin?: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate?: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate?: RatePreferenceEnum;
    cI_GDVCalculated?: number | null;
    cI_UseGDVCalculated?: boolean;
    /** Lease Length (Years) */
    leaseLengthYears?: number;
    /** Case Notes */
    caseNotes?: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion?: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType?: number;
    /** External Reference */
    externalRef?: string;
    /** Introduced Search status */
    introducedSearchStatus?: number | null;
    uniqueRef?: string;
    introducerDetails?: string;
    introduceeFirstName?: string;
    introduceeSurname?: string;
    introduceeEmail?: string;
    introduceePhone?: string;
    introduceeExternalRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired?: number | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_IsWorkStarted?: boolean | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    f_InterestRateBasis?: InterestRateBasis | null;
    f_IsBank?: boolean | null;
    showLenderNamesToBorrower?: boolean | null;
    /** How many houses? */
    howManyHouses?: number;
    /** How many flats? */
    howManyFlats?: number;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    sortBy?: SortByEnum;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived?: boolean;
    userId?: number | null;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    ownerUser?: string;
    ipAddressOfUser?: string;
    introducer?: IntroducerUpdateWithoutPKs | null;
    id: number;
    introducerId?: number | null;
}

/** DevelopmentInputWithNoLogin without PKs and database generated properties and with all properties optional */
export interface DevelopmentInputWithNoLoginUpdateWithoutPKs {
    /** Have you owned to property for over three years(DI_OwnedForMoreThanThreshold) */
    dI_OwnedForMoreThanThreshold?: boolean;
    /** Do you own the property(CI_Dev_DoYouOwnTheProperty) */
    cI_Dev_DoYouOwnTheProperty?: boolean;
    /** Do you have a pre-let agreement(CI_Dev_HasPreLetAgreement) */
    cI_Dev_HasPreLetAgreement?: boolean;
    /** Do you have a pre-sale agreement(CI_Dev_HasPreSaleAgreement) */
    cI_Dev_HasPreSaleAgreement?: boolean;
    /** Date of original Purchase(CI_Dev_DateOfOrigPurch) */
    cI_Dev_DateOfOrigPurch?: Date | null;
    /** Original Purchase Price(CI_Dev_OrigPP) */
    cI_Dev_OrigPP?: number;
    /** Purchase Price / Value(DI_PurchasePrice) */
    dI_PurchasePrice?: number;
    /** Current Value(CI_Dev_CurrentLandValue) */
    cI_Dev_CurrentLandValue?: number;
    /** Do you have a mortgage (CI_Dev_ExistMort) */
    cI_Dev_ExistMort?: boolean;
    /** Existing Mortgage Balance (CI_Dev_ExistMortBal) */
    cI_Dev_ExistMortBal?: number;
    /** Who is the Lender (CI_Dev_ExistLend) */
    cI_Dev_ExistLend?: string;
    /** Property Location */
    cI_Dev_Locations?: LocationEnum;
    /** End Property Type(CI_EndPropType) */
    cI_EndPropType?: PropertyTypeEnum;
    /** End Property Type Detail */
    cI_PropTypeDetail?: PropertyTypeDetailEnum;
    /** Commercial GDV */
    cI_CommercialGDV?: number;
    /** Percent Commercial */
    cI_PercentCommercial?: number;
    /** Stamp Duty(CI_Dev_SDLT) */
    cI_Dev_SDLT?: number;
    /** Build Costs(CI_Dev_BuildCosts) */
    cI_Dev_BuildCosts?: number;
    /** Section 106 and CIL(CI_Dev_S106CIL) */
    cI_Dev_S106CIL?: number;
    /** Upfront Proffesional Fees Planning Architect(CI_Dev_ProfPlanning) */
    cI_Dev_ProfPlanning?: number;
    /** OnGoing Proffesional Fees Planning Architect(CI_Dev_ProfQS) */
    cI_Dev_ProfQS?: number;
    /** Marketing(CI_Dev_Mkting) */
    cI_Dev_Mkting?: number;
    /** Continguency(CI_Dev_Contingency) */
    cI_Dev_Contingency?: number;
    /** Total GDV(CI_GDV) */
    cI_GDV?: number;
    /** Houses GDV */
    houses_GDV?: number | null;
    /** Flats GDV */
    flats_GDV?: number | null;
    /** Parking GDV */
    parking_GDV?: number | null;
    /** Commercial GDV */
    commercial_GDV?: number | null;
    /** Exit Strategy(CI_Dev_ExitStrategy) */
    cI_Dev_ExitStrategy?: ExitStrategyEnum;
    /** Build Term(CI_Dev_BuildTerm) */
    cI_Dev_BuildTerm?: number;
    /** Delay Before Build Commences(CI_Dev_DelayInBuildTerm) */
    cI_Dev_DelayInBuildTerm?: number;
    /** Loan Term(CI_Dev_LoanTermReq) */
    cI_Dev_LoanTermReq?: number;
    /** Loan Required(CI_Dev_LoanReq) */
    cI_Dev_LoanReq?: number;
    /** Estate Agent Costs(CI_Dev_EACosts) */
    cI_Dev_EACosts?: number;
    /** Legal Sales Fees(CI_Dev_LegalSalesFees) */
    cI_Dev_LegalSalesFees?: number;
    /** Original Purchas Price Extra(CI_Dev_OrigPPExtra) */
    cI_Dev_OrigPPExtra?: number;
    user?: ApplicationUserUpdateWithoutPKs | null;
    cI_Mezz_QS_Initial?: number | null;
    cI_Mezz_Val_Initial?: number | null;
    cI_Mezz_FixedFee_Other?: number | null;
    dev_TotLndCostAdj?: number | null;
    dev_TotBuildCostsAdj?: number | null;
    /** Total Project Costs(CI_Dev_TotProjCosts) */
    cI_Dev_TotProjCosts?: number | null;
    name?: string;
    searchName?: string;
    /** Additional Land Costs(CI_Land_Total_other_Costs) */
    cI_Land_Total_other_Costs?: number;
    /** Additional Ongoing Costs(CI_Dev_AdditionalOngoingCosts) */
    cI_Dev_AdditionalOngoingCosts?: number;
    isFullCase?: boolean;
    /** Purchase Price / Value(Dev_LandValue) */
    dev_LandValue?: number | null;
    /** Agent Fees (DI_PurchaseAgentFees) */
    dI_PurchaseAgentFees?: number | null;
    /** Legal Fees (DI_PurchaseLegalFees) */
    dI_PurchaseLegalFees?: number | null;
    /** Other Fees(DI_PurchaseOtherFees) */
    dI_PurchaseOtherFees?: number | null;
    /** Purchase Price / Value Paid(Dev_LandValue_Paid) */
    dev_LandValue_Paid?: number;
    /** SDLT Paid (CI_Dev_SDLT_Paid) */
    cI_Dev_SDLT_Paid?: number;
    /** Agent Fees Paid(DI_PurchaseAgentFees_Paid) */
    dI_PurchaseAgentFees_Paid?: number;
    /** Legal Fees Paid(DI_PurchaseLegalFees_Paid) */
    dI_PurchaseLegalFees_Paid?: number;
    /** Other Fees Paid(DI_PurchaseOtherFees_Paid) */
    dI_PurchaseOtherFees_Paid?: number;
    /** Purchase Price / Value Date Paid(Dev_LandValue_DatePaid) */
    dev_LandValue_DatePaid?: Date | null;
    /** SDLT DatePaid(CI_Dev_SDLT_DatePaid) */
    cI_Dev_SDLT_DatePaid?: Date | null;
    /** Agent Fees Date Paid(DI_PurchaseAgentFees_DatePaid) */
    dI_PurchaseAgentFees_DatePaid?: Date | null;
    /** Legal Fees Date Paid(DI_PurchaseLegalFees_DatePaid) */
    dI_PurchaseLegalFees_DatePaid?: Date | null;
    /** Other Fees Date Paid(DI_PurchaseOtherFees_DatePaid) */
    dI_PurchaseOtherFees_DatePaid?: Date | null;
    /** Mortgage Costs(DI_OwnMortgageCosts) */
    dI_OwnMortgageCosts?: number;
    /** Refurbishment Costs(DI_OwnRefurbishmentCosts) */
    dI_OwnRefurbishmentCosts?: number;
    /** Purchase Price / Value(DI_OwnManagementCosts) */
    dI_OwnManagementCosts?: number;
    /** Other Ownership Costs(DI_OwnOtherCosts) */
    dI_OwnOtherCosts?: number;
    /** Original Purchase Price Paid(CI_Dev_OrigPP_Paid) */
    cI_Dev_OrigPP_Paid?: number;
    /** Current Value Paid(CI_Dev_CurrentLandValue_Paid) */
    cI_Dev_CurrentLandValue_Paid?: number;
    /** Current Mortgage Balance Paid(CI_Dev_ExistMortBal_Paid) */
    cI_Dev_ExistMortBal_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnMortgageCosts_Paid) */
    dI_OwnMortgageCosts_Paid?: number;
    /** Refurbishment Costs Paid(DI_OwnRefurbishmentCosts_Paid) */
    dI_OwnRefurbishmentCosts_Paid?: number;
    /** Mortgage Costs Paid(DI_OwnManagementCosts_Paid) */
    dI_OwnManagementCosts_Paid?: number;
    /** Other Ownership Costs Paid(DI_OwnOtherCosts_Paid) */
    dI_OwnOtherCosts_Paid?: number;
    /** Total Purchase Cost Paid(Dev_TotLndCostAdj_Paid) */
    dev_TotLndCostAdj_Paid?: number;
    /** Original Purchase Price Paid Date(CI_Dev_OrigPP_DatePaid) */
    cI_Dev_OrigPP_DatePaid?: Date | null;
    /** Current Value Paid Date(CI_Dev_CurrentLandValue_DatePaid) */
    cI_Dev_CurrentLandValue_DatePaid?: Date | null;
    /** Current Mortgage Balance Paid Date(CI_Dev_ExistMortBal_DatePaid) */
    cI_Dev_ExistMortBal_DatePaid?: Date | null;
    /** Mortgage Costs Paid Date(DI_OwnMortgageCosts_DatePaid) */
    dI_OwnMortgageCosts_DatePaid?: Date | null;
    /** Refurbishment Costs Paid Date(DI_OwnRefurbishmentCosts_DatePaid) */
    dI_OwnRefurbishmentCosts_DatePaid?: Date | null;
    /** Mangement Costs Paid Date(DI_OwnManagementCosts_DatePaid) */
    dI_OwnManagementCosts_DatePaid?: Date | null;
    /** Other Ownership Costs Paid Date(DI_OwnOtherCosts_DatePaid) */
    dI_OwnOtherCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**)(DI_ContingencyCost) */
    dI_ContingencyCost?: number;
    /** Project Management(DI_BuildProjectManag) */
    dI_BuildProjectManag?: number;
    /** Demolition(DI_BuildDemolition) */
    dI_BuildDemolition?: number;
    /** Mechanical & Engineering(DI_BuildMechEng) */
    dI_BuildMechEng?: number;
    /** Structural Engineer(DI_BuildStrucEng) */
    dI_BuildStrucEng?: number;
    /** Party Wall(DI_BuildPartyWall) */
    dI_BuildPartyWall?: number;
    /** Warranty(DI_BuildWarranty) */
    dI_BuildWarranty?: number;
    /** Landscaping(DI_BuildLandscaping) */
    dI_BuildLandscaping?: number;
    /** Other Build Costs(DI_BuildOtherCosts) */
    dI_BuildOtherCosts?: number;
    /** Other Build Costs Description(DI_BuildOtherCostsDescription) */
    dI_BuildOtherCostsDescription?: string;
    /** Planning Costs / Architect Paid(CI_Dev_ProfPlanning_Paid) */
    cI_Dev_ProfPlanning_Paid?: number;
    /** Build Cost Paid(CI_Dev_BuildCosts_Paid) */
    cI_Dev_BuildCosts_Paid?: number;
    /** Contingency (min of 5%**) Paid(DI_ContingencyCost_Paid) */
    dI_ContingencyCost_Paid?: number;
    /** Client QS Paid(CI_Dev_ProfQS_Paid) */
    cI_Dev_ProfQS_Paid?: number;
    /** Project Management Paid(DI_BuildProjectManag_Paid) */
    dI_BuildProjectManag_Paid?: number;
    /** S106/CIL Paid(CI_Dev_S106CIL_Paid) */
    cI_Dev_S106CIL_Paid?: number;
    /** Demolition Paid(DI_BuildDemolition_Paid) */
    dI_BuildDemolition_Paid?: number;
    /** Mechanical & Engineering Paid(DI_BuildMechEng_Paid) */
    dI_BuildMechEng_Paid?: number;
    /** Structural Engineer Paid(DI_BuildStrucEng_Paid) */
    dI_BuildStrucEng_Paid?: number;
    /** Party Wall Paid(DI_BuildPartyWall_Paid) */
    dI_BuildPartyWall_Paid?: number;
    /** Warranty Paid(DI_BuildWarranty_Paid) */
    dI_BuildWarranty_Paid?: number;
    /** Landscaping Paid(DI_BuildLandscaping_Paid) */
    dI_BuildLandscaping_Paid?: number;
    /** Use a breakdown of build costs? */
    dI_BreakDownBuildCosts?: boolean;
    /** Other Build Costs Paid(DI_BuildOtherCosts_Paid) */
    dI_BuildOtherCosts_Paid?: number;
    /** Class Uses */
    dI_Dev_ClassUses?: number;
    /** Planning Costs / Architect Paid Date(CI_Dev_ProfPlanning_DatePaid) */
    cI_Dev_ProfPlanning_DatePaid?: Date | null;
    /** Build Cost Paid Date(CI_Dev_BuildCosts_DatePaid) */
    cI_Dev_BuildCosts_DatePaid?: Date | null;
    /** Contingency (min of 5%**) Paid Date(DI_ContingencyCost_DatePaid) */
    dI_ContingencyCost_DatePaid?: Date | null;
    /** Client QS Paid Date(CI_Dev_ProfQS_DatePaid) */
    cI_Dev_ProfQS_DatePaid?: Date | null;
    /** Project Management Paid Date(DI_BuildProjectManag_DatePaid) */
    dI_BuildProjectManag_DatePaid?: Date | null;
    /** S106/CIL Paid Date(CI_Dev_S106CIL_DatePaid) */
    cI_Dev_S106CIL_DatePaid?: Date | null;
    /** Demolition Paid Date(DI_BuildDemolition_DatePaid) */
    dI_BuildDemolition_DatePaid?: Date | null;
    /** Mechanical & Engineering Paid Date(DI_BuildMechEng_DatePaid) */
    dI_BuildMechEng_DatePaid?: Date | null;
    /** Structural Engineer Paid Date(DI_BuildStrucEng_DatePaid) */
    dI_BuildStrucEng_DatePaid?: Date | null;
    /** Party Wall Paid Date(DI_BuildPartyWall_DatePaid) */
    dI_BuildPartyWall_DatePaid?: Date | null;
    /** Warranty Paid Date(DI_BuildWarranty_DatePaid) */
    dI_BuildWarranty_DatePaid?: Date | null;
    /** Landscaping Paid Date(DI_BuildLandscaping_DatePaid) */
    dI_BuildLandscaping_DatePaid?: Date | null;
    /** Other Build Costs Paid Date(DI_BuildOtherCosts_DatePaid) */
    dI_BuildOtherCosts_DatePaid?: Date | null;
    /** Sales Dressing Costs(DI_Sales_Dressing) */
    dI_Sales_Dressing?: number;
    /** Sales Agent Fees(DC_SalesAgentFees) */
    dC_SalesAgentFees?: number;
    /** Sales Legal Fees(DC_SalesLegalFeesPercent) */
    dC_SalesLegalFeesPercent?: number;
    /** Sales Total Sales Costs(DC_SalesTotCosts) */
    dC_SalesTotCosts?: number;
    /** NDV (Mezz_GDV) */
    mezz_GDV?: number | null;
    /** Sales Area Units(DI_AreaUnit) */
    dI_AreaUnit?: AreaUnitEnum;
    /** Sales Area(DI_AreaSalesAreaResidential) */
    dI_AreaSalesAreaResidential?: number;
    /** Sales Area(DI_AreaSalesArea Commercial) */
    dI_AreaSalesAreaCommercial?: number;
    /** Acquisition Area(DC_AreaAcquisition) */
    dC_AreaAcquisition?: number;
    /** Build Area(DC_AreaBuild) */
    dC_AreaBuild?: number;
    /** Total Area(DC_AreaTotal) */
    dC_AreaTotal?: number;
    /** Build Costs Per Area */
    dC_BuildCostPerArea?: number;
    /** Sales Area(DC_AreaSales) */
    dC_AreaSales?: number;
    /** Lender Margin(DI_LenderMargin) */
    dI_LenderMargin?: number;
    /** Reference Rate(DI_RefRate) */
    dI_RefRate?: CofEnum;
    /** Combined Rate(CombinedRate) */
    combinedRate?: RatePreferenceEnum;
    cI_GDVCalculated?: number | null;
    cI_UseGDVCalculated?: boolean;
    /** Lease Length (Years) */
    leaseLengthYears?: number;
    /** Case Notes */
    caseNotes?: string;
    /** Will you have planning permission before or on completion of this loan? */
    ppBeforeLoanCompletion?: boolean;
    /** PayingVATOnLandPurchase */
    payingVATOnLandPurchase?: number;
    /** LandPurchaseVatAmount */
    landPurchaseVatAmount?: number;
    /** New Build / Conversion / Permitted Development / Refurb */
    projectType?: number;
    /** External Reference */
    externalRef?: string;
    /** Introduced Search status */
    introducedSearchStatus?: number | null;
    uniqueRef?: string;
    introducerDetails?: string;
    introduceeFirstName?: string;
    introduceeSurname?: string;
    introduceeEmail?: string;
    introduceePhone?: string;
    introduceeExternalRef?: string;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerOrganisation?: OrganisationUpdateWithoutPKs | null;
    f_IsFirstTimeDeveloper?: boolean | null;
    f_NumberOfPreviousDevelopments?: PreviousDevelopmentsEnum | null;
    f_ShareholderDepositRequired?: number | null;
    f_IsPersonalName?: boolean | null;
    f_IsOffshoreCompany?: boolean | null;
    f_IsMainShareholderOverseas?: boolean | null;
    f_PersonalGuaranteeLevel?: number | null;
    f_IsModular?: boolean | null;
    f_IsAirRights?: boolean | null;
    f_IsPermittedDevelopmentScheme?: boolean | null;
    f_IsGradeOneListed?: boolean | null;
    f_IsGradeTwoListed?: boolean | null;
    f_MaxHouseSalesPrice?: number | null;
    f_MaxFlatUnitPrice?: number | null;
    f_MaxSqFtSalePrice?: number | null;
    f_MaxSqFtSalePriceFlats?: number | null;
    f_MaxPercCommercialForMixedUse?: number | null;
    f_IsWorkStarted?: boolean | null;
    f_MaxNumberOfUnits?: number | null;
    f_IsChargeOnAdditionalProperty?: boolean | null;
    f_IsFixedRate?: boolean | null;
    f_InterestRateBasis?: InterestRateBasis | null;
    f_IsBank?: boolean | null;
    showLenderNamesToBorrower?: boolean | null;
    /** How many houses? */
    howManyHouses?: number;
    /** How many flats? */
    howManyFlats?: number;
    organisationLink?: OrganisationLinkUpdateWithoutPKs | null;
    leadSourceUrl?: string;
    showLenderInfoBrokerOverride?: boolean;
    postcodeSearchString?: string;
    sortBy?: SortByEnum;
    f_HasAdverseCredit?: boolean | null;
    f_MaxCommercialFloorspace?: MaxCommercialFloorspaceEnum | null;
    isPreConnectArchived?: boolean;
    userId?: number | null;
    brokerUserId?: number | null;
    brokerOrganisationId?: number | null;
    organisationLinkId?: number | null;
    ownerUser?: string;
    ipAddressOfUser?: string;
    introducer?: IntroducerUpdateWithoutPKs | null;
    introducerId?: number | null;
}

export interface DevelopmentTrackRecord {
    /** Was this project (drop down to list New Build / Conversion / Permitted Development / Refurb) */
    developmentTrackRecordType: number | null;
    /** Address */
    postalAddress: PostalAddress;
    /** Acquistion Date */
    acquistionDate: Date | null;
    /** Acquistion Costs */
    acquistionCosts: number | null;
    /** Gross Internal Area */
    developmentAreas: string;
    /** Area Unit */
    areaUnit: AreaUnitEnum;
    /** Build Costs */
    buildCosts: number | null;
    /** Build Time */
    buildTime: number;
    /** GDV */
    gdv: number | null;
    /** Sold On Exit */
    soldOnExit: boolean;
    /** Description Of Works */
    descriptionOfWorks: string;
    /** Development track record # */
    developmentTrackRecordNumber: number;
    /** DidYouUseDevelopmentFinance */
    didYouUseDevelopmentFinance: boolean;
    /** Were you one of the owners or an employee? */
    ownerOrEmployee: OwnerOrEmployeeEnum;
    /** WhatWasYourRole */
    whatWasYourRole: string;
    /** DevelopmentFinanceLenderName */
    developmentFinanceLenderName: string;
    developmentExperience?: ProjectOwnership;
    id: number;
    developmentExperienceId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentTrackRecord[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecord[];
}

/** DevelopmentTrackRecord without database generated properties */
export interface DevelopmentTrackRecordInsert {
    /** Was this project (drop down to list New Build / Conversion / Permitted Development / Refurb) */
    developmentTrackRecordType?: number | null;
    /** Address */
    postalAddress: PostalAddress;
    /** Acquistion Date */
    acquistionDate?: Date | null;
    /** Acquistion Costs */
    acquistionCosts?: number | null;
    /** Gross Internal Area */
    developmentAreas?: string;
    /** Area Unit */
    areaUnit?: AreaUnitEnum;
    /** Build Costs */
    buildCosts?: number | null;
    /** Build Time */
    buildTime?: number;
    /** GDV */
    gdv?: number | null;
    /** Sold On Exit */
    soldOnExit?: boolean;
    /** Description Of Works */
    descriptionOfWorks?: string;
    /** Development track record # */
    developmentTrackRecordNumber?: number;
    /** DidYouUseDevelopmentFinance */
    didYouUseDevelopmentFinance?: boolean;
    /** Were you one of the owners or an employee? */
    ownerOrEmployee?: OwnerOrEmployeeEnum;
    /** WhatWasYourRole */
    whatWasYourRole?: string;
    /** DevelopmentFinanceLenderName */
    developmentFinanceLenderName?: string;
    developmentExperience: ProjectOwnershipInsert | null;
    developmentExperienceId: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentTrackRecordInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecordInsert[];
}

export interface DevelopmentTrackRecordPageWithTotalCountDTO {
    list?: DevelopmentTrackRecord[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** DevelopmentTrackRecord with all properties optional except PKs */
export interface DevelopmentTrackRecordUpdate {
    /** Was this project (drop down to list New Build / Conversion / Permitted Development / Refurb) */
    developmentTrackRecordType?: number | null;
    /** Address */
    postalAddress?: PostalAddress;
    /** Acquistion Date */
    acquistionDate?: Date | null;
    /** Acquistion Costs */
    acquistionCosts?: number | null;
    /** Gross Internal Area */
    developmentAreas?: string;
    /** Area Unit */
    areaUnit?: AreaUnitEnum;
    /** Build Costs */
    buildCosts?: number | null;
    /** Build Time */
    buildTime?: number;
    /** GDV */
    gdv?: number | null;
    /** Sold On Exit */
    soldOnExit?: boolean;
    /** Description Of Works */
    descriptionOfWorks?: string;
    /** Development track record # */
    developmentTrackRecordNumber?: number;
    /** DidYouUseDevelopmentFinance */
    didYouUseDevelopmentFinance?: boolean;
    /** Were you one of the owners or an employee? */
    ownerOrEmployee?: OwnerOrEmployeeEnum;
    /** WhatWasYourRole */
    whatWasYourRole?: string;
    /** DevelopmentFinanceLenderName */
    developmentFinanceLenderName?: string;
    developmentExperience?: ProjectOwnershipUpdateWithoutPKs | null;
    id: number;
    developmentExperienceId?: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentTrackRecordUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecordUpdate[];
}

/** DevelopmentTrackRecord without PKs and database generated properties and with all properties optional */
export interface DevelopmentTrackRecordUpdateWithoutPKs {
    /** Was this project (drop down to list New Build / Conversion / Permitted Development / Refurb) */
    developmentTrackRecordType?: number | null;
    /** Address */
    postalAddress?: PostalAddress;
    /** Acquistion Date */
    acquistionDate?: Date | null;
    /** Acquistion Costs */
    acquistionCosts?: number | null;
    /** Gross Internal Area */
    developmentAreas?: string;
    /** Area Unit */
    areaUnit?: AreaUnitEnum;
    /** Build Costs */
    buildCosts?: number | null;
    /** Build Time */
    buildTime?: number;
    /** GDV */
    gdv?: number | null;
    /** Sold On Exit */
    soldOnExit?: boolean;
    /** Description Of Works */
    descriptionOfWorks?: string;
    /** Development track record # */
    developmentTrackRecordNumber?: number;
    /** DidYouUseDevelopmentFinance */
    didYouUseDevelopmentFinance?: boolean;
    /** Were you one of the owners or an employee? */
    ownerOrEmployee?: OwnerOrEmployeeEnum;
    /** WhatWasYourRole */
    whatWasYourRole?: string;
    /** DevelopmentFinanceLenderName */
    developmentFinanceLenderName?: string;
    developmentExperience?: ProjectOwnershipUpdateWithoutPKs | null;
    developmentExperienceId?: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_DevelopmentTrackRecordUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_DevelopmentTrackRecordUpdate[];
}

export enum EPCRatingTypeEnum {
    None = 0,
    A = 1,
    B = 2,
    C = 4,
    AtoC = 7,
    D = 8,
    E = 16,
    DtoE = 24,
    AboveE = 32,
}

export enum EWS1GradeTypeEnum {
    None = 0,
    A = 1,
    B = 2,
}

export enum EdmContainerElementKind {
    None = 0,
    EntitySet = 1,
    ActionImport = 2,
    FunctionImport = 3,
    Singleton = 4,
}

export enum EdmExpressionKind {
    None = 0,
    BinaryConstant = 1,
    BooleanConstant = 2,
    DateTimeOffsetConstant = 3,
    DecimalConstant = 4,
    FloatingConstant = 5,
    GuidConstant = 6,
    IntegerConstant = 7,
    StringConstant = 8,
    DurationConstant = 9,
    Null = 10,
    Record = 11,
    Collection = 12,
    Path = 13,
    If = 14,
    Cast = 15,
    IsOf = 16,
    FunctionApplication = 17,
    LabeledExpressionReference = 18,
    Labeled = 19,
    PropertyPath = 20,
    NavigationPropertyPath = 21,
    DateConstant = 22,
    TimeOfDayConstant = 23,
    EnumMember = 24,
    AnnotationPath = 25,
}

export enum EdmSchemaElementKind {
    None = 0,
    TypeDefinition = 1,
    Term = 2,
    Action = 3,
    EntityContainer = 4,
    Function = 5,
}

export enum EdmTypeKind {
    None = 0,
    Primitive = 1,
    Entity = 2,
    Complex = 3,
    Collection = 4,
    EntityReference = 5,
    Enum = 6,
    TypeDefinition = 7,
    Untyped = 8,
    Path = 9,
}

export enum EmploymentEnum {
    None = 0,
    Employed = 1,
    SelfEmployed = 2,
}

export interface EntityWithPermissionsDTO {
    usersWithPermission: UserPermissionTypeDTO[];
    userGroupsWithPermission: UserPermissionTypeDTO[];
    rowId: number;
    rowDisplayName: string | null;
}

export enum EventLogEnum {
    None = 0,
    PageLoad = 1,
    Save = 2,
    Shortlisting = 3,
    Export = 4,
    LenderReferral = 5,
    EnterpriseUserRegistration = 6,
    EnterpriseUserLogin = 7,
    Deallocker = 8,
    Search = 9,
    SubmitDIP = 10,
    ApplyToLender = 11,
    Connect = 12,
    DealCompletion = 13,
}

export enum ExistingPlanningChangeTypeEnum {
    None = 0,
    EnhancedPlanningOnExistingBuilding = 1,
    PermittedDevelopmentOnExistingBuilding = 2,
    BrandNewPlanningApplication = 3,
}

export enum ExitFeeChargedOnEnum {
    None = 0,
    Loan = 1,
    GDV = 2,
}

export enum ExitStrategyEnum {
    None = 0,
    Sale = 1,
    Refinance = 2,
    Other = 4,
    PartSalePartRefinance = 8,
    SaleOfAlternativeAsset = 16,
}

export interface ExternalLinks {
    link: string;
    linkType: ExternalLinksEnum;
    description: string;
    case?: Case;
    id: number;
    caseId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

export enum ExternalLinksEnum {
    Misc = 0,
    Youtube = 1,
}

/** ExternalLinks without database generated properties */
export interface ExternalLinksInsert {
    link?: string;
    linkType?: ExternalLinksEnum;
    description?: string;
    case: CaseInsert | null;
    caseId: number;
}

export interface ExternalLinksPageWithTotalCountDTO {
    list?: ExternalLinks[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** ExternalLinks with all properties optional except PKs */
export interface ExternalLinksUpdate {
    link?: string;
    linkType?: ExternalLinksEnum;
    description?: string;
    case?: CaseUpdateWithoutPKs | null;
    id: number;
    caseId?: number;
}

/** ExternalLinks without PKs and database generated properties and with all properties optional */
export interface ExternalLinksUpdateWithoutPKs {
    link?: string;
    linkType?: ExternalLinksEnum;
    description?: string;
    case?: CaseUpdateWithoutPKs | null;
    caseId?: number;
}

export enum FeatureTypeEnum {
    Module = 1,
    Standalone = 2,
}

export interface FeedBack {
    lender?: Lender | null;
    reviewerUser?: ApplicationUser;
    brokerUser?: ApplicationUser | null;
    responseUser?: ApplicationUser | null;
    organisation?: Organisation | null;
    isLenderFeedback: boolean;
    isBrokerFeedback: boolean;
    ratingCustomerService: number;
    ratingSpeed: number;
    ratingUnderwritingFlexibility: number;
    ratingPresentation: number;
    ratingResponsiveness: number;
    ratingKnowledge: number;
    hasSpoken: boolean;
    isAnonymous: boolean;
    feedbackText: string;
    feedBackDateTime: Date | null;
    responseText: string;
    responseDateTime: Date | null;
    id: number;
    lenderId: number | null;
    reviewerUserId: number;
    brokerUserId: number | null;
    responseUserId: number | null;
    organisationId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_FeedBack[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_FeedBack[];
}

/** FeedBack without database generated properties */
export interface FeedBackInsert {
    lender?: LenderInsert | null;
    reviewerUser: ApplicationUserInsert | null;
    brokerUser?: ApplicationUserInsert | null;
    responseUser?: ApplicationUserInsert | null;
    organisation?: OrganisationInsert | null;
    isLenderFeedback?: boolean;
    isBrokerFeedback?: boolean;
    ratingCustomerService?: number;
    ratingSpeed?: number;
    ratingUnderwritingFlexibility?: number;
    ratingPresentation?: number;
    ratingResponsiveness?: number;
    ratingKnowledge?: number;
    hasSpoken?: boolean;
    isAnonymous?: boolean;
    feedbackText?: string;
    feedBackDateTime?: Date | null;
    responseText?: string;
    responseDateTime?: Date | null;
    lenderId?: number | null;
    reviewerUserId: number;
    brokerUserId?: number | null;
    responseUserId?: number | null;
    organisationId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_FeedBackInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_FeedBackInsert[];
}

export interface FeedBackMessageRequest {
    feedBackId?: number;
    dealLeanderId?: number;
    isDeal?: boolean;
}

export interface FeedBackMessageResponse {
    feedBackDTO?: FeedBack;
    reviewerFullName?: string;
    reviewerOrganisationName?: string;
    reviewerOrganisationUrl?: string;
    reviewerProfileUrl?: string;
    reviewerInitil?: string;
    dealName?: string;
    responseUserOrgName?: string;
}

export interface FeedBackPageWithTotalCountDTO {
    list?: FeedBack[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** FeedBack with all properties optional except PKs */
export interface FeedBackUpdate {
    lender?: LenderUpdateWithoutPKs | null;
    reviewerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    responseUser?: ApplicationUserUpdateWithoutPKs | null;
    organisation?: OrganisationUpdateWithoutPKs | null;
    isLenderFeedback?: boolean;
    isBrokerFeedback?: boolean;
    ratingCustomerService?: number;
    ratingSpeed?: number;
    ratingUnderwritingFlexibility?: number;
    ratingPresentation?: number;
    ratingResponsiveness?: number;
    ratingKnowledge?: number;
    hasSpoken?: boolean;
    isAnonymous?: boolean;
    feedbackText?: string;
    feedBackDateTime?: Date | null;
    responseText?: string;
    responseDateTime?: Date | null;
    id: number;
    lenderId?: number | null;
    reviewerUserId?: number;
    brokerUserId?: number | null;
    responseUserId?: number | null;
    organisationId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_FeedBackUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_FeedBackUpdate[];
}

/** FeedBack without PKs and database generated properties and with all properties optional */
export interface FeedBackUpdateWithoutPKs {
    lender?: LenderUpdateWithoutPKs | null;
    reviewerUser?: ApplicationUserUpdateWithoutPKs | null;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    responseUser?: ApplicationUserUpdateWithoutPKs | null;
    organisation?: OrganisationUpdateWithoutPKs | null;
    isLenderFeedback?: boolean;
    isBrokerFeedback?: boolean;
    ratingCustomerService?: number;
    ratingSpeed?: number;
    ratingUnderwritingFlexibility?: number;
    ratingPresentation?: number;
    ratingResponsiveness?: number;
    ratingKnowledge?: number;
    hasSpoken?: boolean;
    isAnonymous?: boolean;
    feedbackText?: string;
    feedBackDateTime?: Date | null;
    responseText?: string;
    responseDateTime?: Date | null;
    lenderId?: number | null;
    reviewerUserId?: number;
    brokerUserId?: number | null;
    responseUserId?: number | null;
    organisationId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_FeedBackUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_FeedBackUpdate[];
}

export interface FetchDealRequest {
    dealId?: number;
    productFamily?: ProductFamilyEnum;
    isCaseDashboardCall?: boolean;
}

export interface FetchDealResponse {
    bridgingDeal?: BridgingDeal | null;
    commercialDeal?: CommercialDeal | null;
    devFinanceDeal?: DevelopmentFinanceDeal | null;
    hideBridgingDeal?: boolean;
    hideCommercialDeal?: boolean;
    totalUnreadDealLenderMessages?: number | null;
    shortlistedLendersName?: string | null;
    selectedLendersName?: string | null;
    shortlistedLendersId?: number[];
    isReadOnlyDealForBroker?: boolean;
    referredPackagerText?: string | null;
}

export interface FileAttachment {
    user?: ApplicationUser | null;
    fileLocation: string;
    fileName: string;
    case?: Case;
    module: ModuleEnum;
    caseLenderId: number | null;
    tempURL: string;
    tempUploadURL: string;
    userName: string;
    id: number;
    userId: number | null;
    caseId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_FileAttachment[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_FileAttachment[];
}

/** FileAttachment without database generated properties */
export interface FileAttachmentInsert {
    user?: ApplicationUserInsert | null;
    fileLocation?: string;
    fileName?: string;
    case: CaseInsert | null;
    module?: ModuleEnum;
    caseLenderId?: number | null;
    userId?: number | null;
    caseId: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_FileAttachmentInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_FileAttachmentInsert[];
}

export interface FileAttachmentPageWithTotalCountDTO {
    list?: FileAttachment[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** FileAttachment with all properties optional except PKs */
export interface FileAttachmentUpdate {
    user?: ApplicationUserUpdateWithoutPKs | null;
    fileLocation?: string;
    fileName?: string;
    case?: CaseUpdateWithoutPKs | null;
    module?: ModuleEnum;
    caseLenderId?: number | null;
    id: number;
    userId?: number | null;
    caseId?: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_FileAttachmentUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_FileAttachmentUpdate[];
}

/** FileAttachment without PKs and database generated properties and with all properties optional */
export interface FileAttachmentUpdateWithoutPKs {
    user?: ApplicationUserUpdateWithoutPKs | null;
    fileLocation?: string;
    fileName?: string;
    case?: CaseUpdateWithoutPKs | null;
    module?: ModuleEnum;
    caseLenderId?: number | null;
    userId?: number | null;
    caseId?: number;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_FileAttachmentUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_FileAttachmentUpdate[];
}

export enum FixedRateTermEnum {
    None = 0,
    TwoYear = 1,
    FiveYear = 2,
    TenYear = 3,
    ThreeYear = 4,
    SevenYear = 5,
    FifteenYear = 6,
}

export interface GetCasesForUserRequest {
    productType?: ProductTypeEnum;
    productFamily?: ProductFamilyEnum;
    userName?: string;
    searchText?: string;
    statusFilter?: CaseStatusEnum | null;
    limit?: number;
    dipStatus?: CaseLenderStateEnum | null;
}

export interface GetCurrentUserPermissionForProductSearchResponse {
    hasDevFinanceSearchPermission?: boolean;
    hasBridgingSearchPermission?: boolean;
    hasCommercialSearchPermission?: boolean;
    isLender?: boolean;
    orgId?: number | null;
}

export interface GetRegionByPostcodeResponse {
    location?: LocationEnum | null;
    postCodeErrorMessage?: string;
}

export interface GetSearchResultsCountByUniqueRefAndLogPageLoadEventResponse {
    totalResultsCount?: number;
    dealUniqueLinkId?: number | null;
    dealUniqueLinkLogoUrl?: string;
    enterpriseClient?: Client;
    dealName?: string;
    organisation?: Organisation;
}

export interface GetSearchesForUserRequest {
    productType?: ProductTypeEnum;
    userName?: string;
    searchText?: string;
    statusFilter?: CaseStatusEnum | null;
    limit?: number;
    productFamily?: ProductFamilyEnum;
}

export interface GetSearchesForUserResponse {
    results?: CaseSummaryDTO[];
}

export interface GetSelectedProductLendersNameAndIdResponse {
    lendersId?: number[];
    lendersName?: string;
}

export interface GetShareholderEmailAndSecurityQuestionsResponse {
    email?: string;
    securityQuestions?: SecurityQuestionEnum;
}

export enum GuaranteeEnum {
    None = 0,
    Personal = 1,
    Corporate = 2,
    Either = 3,
}

export interface HubspotContact {
    createdate?: Date;
    ownerId?: number | null;
    lastmodifieddate?: Date;
    id?: number | null;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    website?: string | null;
    company?: string | null;
    phone?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    associatedCompanyId?: number | null;
}

export interface HubspotContactRequest {
    user?: HubspotUserDTO | null;
    page?: string;
    login?: boolean;
    orgCode?: string;
    role?: UserRoleEnum;
    organisationLinkId?: number;
    productType?: ProductTypeEnum;
    dealId?: number;
    developmentInputWithNoLoginUniqueRef?: string;
    clientId?: number;
}

export interface HubspotUserDTO {
    id?: number | null;
    userName?: string | null;
    organisationReferralId?: number | null;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    applicantDefinedRole?: ApplicantRoleEnum;
    introducerId?: number | null;
    location?: LocationEnum;
    applicantDefinedRoleIntroducer?: IntroducerTypeEnum | null;
    referrer?: ReferrerEnum;
    applicantDefinedRoleOther?: string | null;
}

export interface IEdmDirectValueAnnotationsManager {
}

export interface IEdmEntityContainer {
    readonly name?: string | null;
    readonly schemaElementKind?: EdmSchemaElementKind;
    readonly namespace?: string | null;
    readonly elements?: IEdmEntityContainerElement[] | null;
}

export interface IEdmEntityContainerElement {
    readonly name?: string | null;
    readonly containerElementKind?: EdmContainerElementKind;
    readonly container?: IEdmEntityContainer | null;
}

export interface IEdmExpression {
    readonly expressionKind?: EdmExpressionKind;
}

export interface IEdmModel {
    readonly schemaElements?: IEdmSchemaElement[] | null;
    readonly vocabularyAnnotations?: IEdmVocabularyAnnotation[] | null;
    readonly referencedModels?: IEdmModel[] | null;
    readonly declaredNamespaces?: string[] | null;
    readonly directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager | null;
    readonly entityContainer?: IEdmEntityContainer | null;
}

export interface IEdmSchemaElement {
    readonly name?: string | null;
    readonly schemaElementKind?: EdmSchemaElementKind;
    readonly namespace?: string | null;
}

export interface IEdmTerm {
    readonly name?: string | null;
    readonly schemaElementKind?: EdmSchemaElementKind;
    readonly namespace?: string | null;
    readonly type?: IEdmTypeReference | null;
    readonly appliesTo?: string | null;
    readonly defaultValue?: string | null;
}

export interface IEdmType {
    readonly typeKind?: EdmTypeKind;
}

export interface IEdmTypeReference {
    readonly isNullable?: boolean;
    readonly definition?: IEdmType | null;
}

export interface IEdmVocabularyAnnotatable {
}

export interface IEdmVocabularyAnnotation {
    readonly qualifier?: string | null;
    readonly term?: IEdmTerm | null;
    readonly target?: IEdmVocabularyAnnotatable | null;
    readonly value?: IEdmExpression | null;
    readonly usesDefault?: boolean;
}

export interface ImportProductResponse {
    succeeded?: boolean;
    message?: string;
    productsDisabled?: number;
    productsUpdated?: number;
    productsAdded?: number;
    lendersAdded?: number;
}

export enum InterestRateBasis {
    None = 0,
    BaseRate = 1,
    LendersOwnSVR = 2,
    Sonia = 3,
}

export enum InterestRateTypeEnum {
    None = 0,
    Fixed = 1,
    Variable = 2,
}

export enum InterestServicedorRolledEnum {
    None = 0,
    Serviced = 1,
    Rolled = 2,
}

export interface Introducer {
    user?: ApplicationUser | null;
    introducerCode: string;
    isIndividual: boolean;
    introducerType: IntroducerTypeEnum;
    introducerTypeOther: string;
    companyName: string;
    companyURL: string;
    introducedUsers?: ApplicationUser[];
    introducedDevelopmentInputs?: DevelopmentInput[];
    introducedDevelopmentInputsWithNoLogin?: DevelopmentInputWithNoLogin[];
    id: number;
    userId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_Introducer[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_Introducer[];
}

/** Introducer without database generated properties */
export interface IntroducerInsert {
    user?: ApplicationUserInsert | null;
    introducerCode?: string;
    isIndividual?: boolean;
    introducerType?: IntroducerTypeEnum;
    introducerTypeOther?: string;
    companyName?: string;
    companyURL?: string;
    introducedUsers?: ApplicationUserInsert[];
    introducedDevelopmentInputs?: DevelopmentInputInsert[];
    introducedDevelopmentInputsWithNoLogin?: DevelopmentInputWithNoLoginInsert[];
    userId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_IntroducerInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_IntroducerInsert[];
}

export interface IntroducerPageWithTotalCountDTO {
    list?: Introducer[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface IntroducerSimpleDTO {
    id?: number;
    isDeleted?: boolean;
    createdDateTime?: Date | null;
    lastUpdatedDateTime?: Date | null;
}

export enum IntroducerTypeEnum {
    Accountant = 1,
    Architect = 2,
    Broker = 3,
    Builder = 4,
    Developer = 5,
    EstateOrLandAgent = 6,
    IFA = 7,
    ProjectManager = 8,
    PropertyManager = 9,
    QuantitySurveyor = 10,
    Solicitor = 11,
    Trustee = 12,
    Other = 13,
    Auctioneer = 14,
    StructuralEngineer = 15,
}

/** Introducer with all properties optional except PKs */
export interface IntroducerUpdate {
    user?: ApplicationUserUpdateWithoutPKs | null;
    introducerCode?: string;
    isIndividual?: boolean;
    introducerType?: IntroducerTypeEnum;
    introducerTypeOther?: string;
    companyName?: string;
    companyURL?: string;
    introducedUsers?: ApplicationUserUpdate[];
    introducedDevelopmentInputs?: DevelopmentInputUpdate[];
    introducedDevelopmentInputsWithNoLogin?: DevelopmentInputWithNoLoginUpdate[];
    id: number;
    userId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_IntroducerUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_IntroducerUpdate[];
}

/** Introducer without PKs and database generated properties and with all properties optional */
export interface IntroducerUpdateWithoutPKs {
    user?: ApplicationUserUpdateWithoutPKs | null;
    introducerCode?: string;
    isIndividual?: boolean;
    introducerType?: IntroducerTypeEnum;
    introducerTypeOther?: string;
    companyName?: string;
    companyURL?: string;
    introducedUsers?: ApplicationUserUpdate[];
    introducedDevelopmentInputs?: DevelopmentInputUpdate[];
    introducedDevelopmentInputsWithNoLogin?: DevelopmentInputWithNoLoginUpdate[];
    userId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_IntroducerUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_IntroducerUpdate[];
}

export interface Invite {
    guid: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    inviteerUserId: number;
    userId: number | null;
    status: StatusEnum;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** Invite without database generated properties */
export interface InviteInsert {
    guid?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    inviteerUserId?: number;
    userId?: number | null;
    status?: StatusEnum;
}

export interface InvitePageWithTotalCountDTO {
    list?: Invite[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** Invite with all properties optional except PKs */
export interface InviteUpdate {
    guid?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    inviteerUserId?: number;
    userId?: number | null;
    status?: StatusEnum;
    id: number;
}

/** Invite without PKs and database generated properties and with all properties optional */
export interface InviteUpdateWithoutPKs {
    guid?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    inviteerUserId?: number;
    userId?: number | null;
    status?: StatusEnum;
}

export interface InvitedBrokerDTO {
    firstName?: string;
    email?: string;
}

export interface InvitedUserRequest {
    userId?: number;
    dealId?: number;
}

export interface InvitedUserResponse {
    isInvited?: boolean;
    dealAccessLevel?: CaseAccessLevelEnum;
}

export enum LandOrPropertyEnum {
    None = 0,
    Land = 1,
    Property = 2,
}

export enum LegalFeeTypeEnum {
    None = 0,
    GrossLoan = 1,
    LandValueCost = 2,
    FlatRate = 3,
}

export interface Lender {
    /** Lender Name */
    name: string;
    lenderGenericName: string;
    ratingCustomerService: number | null;
    ratingSpeed: number | null;
    ratingFlexibility: number | null;
    ratingUserRating: number | null;
    products?: Product[];
    user?: ApplicationUser | null;
    logoURL: string | null;
    isBank: boolean | null;
    lenderApplicationUsers?: ApplicationUser[];
    internalUrl: string;
    hasLiveMarketSearch: boolean;
    hasDevelopmentFinanceSearch: boolean;
    hasBridgingSearch: boolean;
    hasCommercialSearch: boolean;
    preferredPackagersText: string;
    isLenderReferralActive: boolean;
    usePortalUrl: boolean;
    portalUrl: string;
    portalUrlActiveDateTime: Date | null;
    sendLenderInsightsEmail: boolean;
    bridgingFamilySnapshot: string;
    bridgingFamilyAdditionalInfo: string;
    commercialFamilySnapshot: string;
    commercialFamilyAdditionalInfo: string;
    developmentFinanceFamilySnapshot: string;
    developmentFinanceFamilyAdditionalInfo: string;
    isConnectLender: boolean;
    isConnectReferralOnly: boolean;
    avgResponseTimeDevFinance: number | null;
    avgResponseTimeBridging: number | null;
    avgResponseTimeCommercial: number | null;
    avgResponseTimeOverall: number | null;
    medianResponseTimeDevFinance: number | null;
    medianResponseTimeBridging: number | null;
    medianResponseTimeCommercial: number | null;
    medianResponseTimeOverall: number | null;
    isProfessionalServicesEnabled: boolean;
    id: number;
    userId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_Lender[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_Lender[];
}

export interface LenderAppraisal {
    dealId?: number;
    dealName?: string;
}

export interface LenderInfo {
    lenderId?: number;
    lenderName?: string;
    lenderUsers?: string;
    preferredLenderContactEmail?: string;
}

/** Lender without database generated properties */
export interface LenderInsert {
    /** Lender Name */
    name?: string;
    lenderGenericName?: string;
    ratingCustomerService?: number | null;
    ratingSpeed?: number | null;
    ratingFlexibility?: number | null;
    ratingUserRating?: number | null;
    products?: ProductInsert[];
    user?: ApplicationUserInsert | null;
    logoURL?: string | null;
    isBank?: boolean | null;
    lenderApplicationUsers?: ApplicationUserInsert[];
    internalUrl?: string;
    hasLiveMarketSearch?: boolean;
    hasDevelopmentFinanceSearch?: boolean;
    hasBridgingSearch?: boolean;
    hasCommercialSearch?: boolean;
    preferredPackagersText?: string;
    isLenderReferralActive?: boolean;
    usePortalUrl?: boolean;
    portalUrl?: string;
    portalUrlActiveDateTime?: Date | null;
    sendLenderInsightsEmail?: boolean;
    bridgingFamilySnapshot?: string;
    bridgingFamilyAdditionalInfo?: string;
    commercialFamilySnapshot?: string;
    commercialFamilyAdditionalInfo?: string;
    developmentFinanceFamilySnapshot?: string;
    developmentFinanceFamilyAdditionalInfo?: string;
    isConnectLender?: boolean;
    isConnectReferralOnly?: boolean;
    avgResponseTimeDevFinance?: number | null;
    avgResponseTimeBridging?: number | null;
    avgResponseTimeCommercial?: number | null;
    avgResponseTimeOverall?: number | null;
    medianResponseTimeDevFinance?: number | null;
    medianResponseTimeBridging?: number | null;
    medianResponseTimeCommercial?: number | null;
    medianResponseTimeOverall?: number | null;
    isProfessionalServicesEnabled?: boolean;
    userId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_LenderInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_LenderInsert[];
}

export interface LenderOrganisation {
    organisation?: Organisation;
    lender?: Lender;
    id: number;
    organisationId: number;
    lenderId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** LenderOrganisation without database generated properties */
export interface LenderOrganisationInsert {
    organisation: OrganisationInsert | null;
    lender: LenderInsert | null;
    organisationId: number;
    lenderId: number;
}

export interface LenderOrganisationPageWithTotalCountDTO {
    list?: LenderOrganisation[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** LenderOrganisation with all properties optional except PKs */
export interface LenderOrganisationUpdate {
    organisation?: OrganisationUpdateWithoutPKs | null;
    lender?: LenderUpdateWithoutPKs | null;
    id: number;
    organisationId?: number;
    lenderId?: number;
}

/** LenderOrganisation without PKs and database generated properties and with all properties optional */
export interface LenderOrganisationUpdateWithoutPKs {
    organisation?: OrganisationUpdateWithoutPKs | null;
    lender?: LenderUpdateWithoutPKs | null;
    organisationId?: number;
    lenderId?: number;
}

export interface LenderPageWithTotalCountDTO {
    list?: Lender[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface LenderProductPairDTO {
    lenderId?: number;
    productId?: number;
    externalProductId?: string;
    productSourceType?: ProductSourceTypeEnum;
}

export enum LenderProductTypeEnum {
    None = 0,
    All = 1,
    DevelopmentFinance = 2,
    BridgingFinance = 4,
    CommercialMortgages = 8,
}

export interface LenderResult {
    dev_BuildCostContingencyAdj: number | null;
    dev_S106CIL: number | null;
    dev_ProfFeesPlanning: number | null;
    dev_ProfFeesQS: number | null;
    dev_MinContAdj: number | null;
    dev_MaxContAdj: number | null;
    dev_Marketing: number | null;
    dev_SDLT: number | null;
    dev_PurchaseCosts: number | null;
    dev_ClientSalesPeriod: number | null;
    dev_SalesPeriodAdj: number | null;
    dev_CumulativeIntRate: number | null;
    dev_GDV_MaxLoanAvail: number | null;
    dev_GDV_LenderArrFeeIncBrokFee: number | null;
    dev_GDV_ArrFeeIncBrokFeeInt: number | null;
    dev_GDV_BuildCostPerMonth: number | null;
    dev_GDV_TotBuildCostOverBuildTermIncInt: number | null;
    dev_GDV_TotBuildCostOverLoanTermIncInt: number | null;
    dev_GDV_IntOnBuild: number | null;
    dev_GDV_LoanRemainPreLenderProfFees: number | null;
    interestOnFeesAbove: number | null;
    dev_GDV_FixedProfFeesIncInt: number | null;
    dev_GDV_LandLoanIncInt: number | null;
    dev_GDV_LandLoan: number | null;
    dev_GDV_MonitorQSIncIntOverBuildT: number | null;
    dev_GDV_MonitorQSOverLoanT: number | null;
    dev_TotalOtherFees: number | null;
    dev_TotOtherFeesOverBuildTerm: number | null;
    dev_TBCAandOFBuildTerm: number | null;
    dev_TBCAandOFLoanTerm: number | null;
    dev_TotProjCosts: number | null;
    dev_QSCostPerVisit: number | null;
    dev_LTCtoTotProjCosts: number | null;
    dev_Working1: number | null;
    dev_LenderIncBrokPlusLegal: number | null;
    dev_Working3Part2: number | null;
    dev_Working3Part3: number | null;
    dev_Working3: number | null;
    dev_Working2: number | null;
    dev_LandLoan: number | null;
    dev_LandLoanInt: number | null;
    dev_Prf_TotLoanInt: number | null;
    dev_Prf_ArrFee: number | null;
    dev_GDV_GrossLoan: number | null;
    dev_GDV_TotInt: number | null;
    dev_TotBuildAdjPlusOtherFees: number | null;
    dev_Prf_TotLoanWOArrFeeIncAFInt: number | null;
    dev_Prf_ArrFeeIncInterest: number | null;
    dev_Prf_TotalGrossLoan: number | null;
    dev_Prf_90PercLTC: number | null;
    dev_Prf_2PercArrFee: number | null;
    dev_TotIntLTC: number | null;
    dev_GrossLoanLTC: number | null;
    dev_Mez_LTCMezAvailAftMezCosts: number | null;
    dev_Prf_LenderProfFees: number | null;
    dev_GDV_LandLoanInt: number | null;
    dev_EAActlCosts: number | null;
    dev_SalesLegalActlCosts: number | null;
    dev_TtlSalesFees: number | null;
    dev_NDV: number | null;
    dev_Mez_ArrFeeOnMxPsbNetLoanAftSEC: number | null;
    dev_ValFee_LandCost: number | null;
    dev_ValFee_GDV: number | null;
    dev_QSInitialFeeBuildCosts: number | null;
    dev_LenderLegalAndQSGrossLoan: number | null;
    dev_LoanReq_BuildLoan: number | null;
    dev_LoanReq_LandLoan: number | null;
    dev_LoanReq_TotNetLoan: number | null;
    dev_LoanReq_TotOtherFees: number | null;
    dev_LoanReq_IntOnTotOtherFees: number | null;
    dev_LoanReq_QSCosts: number | null;
    dev_LoanReq_BuildLoanPlusQSCPV: number | null;
    dev_LoanReq_TBCAandOFBuildTerm: number | null;
    dev_LoanReq_TBCAandOFLoanTerm: number | null;
    dev_LoanReq_IntOnBCAndQS: number | null;
    dev_LoanReq_LandLoanInt: number | null;
    dev_LoanReq_ArrFee: number | null;
    dev_LoanReq_ArrFeeInt: number | null;
    dev_LoanReq_GrossLoanAftArrFee: number | null;
    dev_LoanReq_LenderArrFeeandProfFees: number | null;
    dev_LoanReq_LoanInt: number | null;
    dev_LoanReq_GrossLoan: number | null;
    dev_LoanReq_GrossLoanClientRequest: number | null;
    dev_LoanReq_EquityShortfallBuildLoan: number | null;
    dev_LoanReq_Mez_TotOtherFees: number | null;
    dev_LoanReq_Mez_IntOnTotOtherFees: number | null;
    dev_Mez_CumulativeIntRate2: number | null;
    dev_TotalOtherFeesWithDelayedStart: number | null;
    dev_LTCGrossLoanCorrect: boolean | null;
    seniorProduct?: Product;
    mezzProduct?: Product | null;
    developmentInput?: DevelopmentInput | null;
    dev_LoanReq_GrossSnrAftConstrMax: number | null;
    dev_LoanReq_SnrIntAftConstrMax: number | null;
    dev_LoanReq_SnrArrAndProfFeesAftConstrMax: number | null;
    dev_GDV_ArrFee: number | null;
    dev_GDV_ExitFee: number | null;
    dev_LTC_ArrFee: number | null;
    dev_LTC_ExitFee: number | null;
    dev_GDV_ProfFees: number | null;
    dev_LTC_ProfFees: number | null;
    dev_LoanReq_ProfFees: number | null;
    dev_LoanReq_ExitFee: number | null;
    dev_LLAvail_BuildLoan: number | null;
    dev_LLAvail_LandLoan: number | null;
    dev_LLAvail_Int: number | null;
    dev_LLAvail_LenderArrFee: number | null;
    dev_LLAvail_ProfFees: number | null;
    dev_LLAvail_GrossSnrLoan: number | null;
    dev_LLAvail_ExitFee: number | null;
    dev_LTC_TotFundCosts: number | null;
    dev_GDV_TotFundCosts: number | null;
    dev_LoanReq_TotFundCosts: number | null;
    dev_LLAvail_TotFundCosts: number | null;
    cT_LoanReq_TotLoanCosts: number | null;
    cT_LoanReq_Profit: number | null;
    cT_LLAvail_NetLoan: number | null;
    cT_LLAvail_TotLoanCosts: number | null;
    cT_LLAvail_EquityReq: number | null;
    cT_LLAvail_Profit: number | null;
    cT_LLAvail_ROCE: number | null;
    dev_LoanReq_LegalFees: number | null;
    dev_LoanReq_LenderArrFee: number | null;
    lI_Dev_TotRate: number | null;
    lI_Dev_ExitFee: number | null;
    lI_Dev_ArrFeeIncBrokFee: number | null;
    lI_Dev_ArrFeeBase: number | null;
    lI_LoanProduct: ProductTypeEnum;
    lI_Dev_MaxLTGDV: number | null;
    lI_Dev_MaxLTC: number | null;
    debugstring: string;
    dev_LandValue: number | null;
    dev_LandLoanConst_LandLoan: number | null;
    dev_LandLoanConst_TotNetLoan: number | null;
    dev_LandLoanConst_IntOnTotOtherFees: number | null;
    dev_TotBuildCostsAdjPlusQSCPV: number | null;
    dev_LandLoanConst_TBCAandOFBuildTerm: number | null;
    dev_LandLoanConst_TBCAandOFLoanTerm: number | null;
    dev_LandLoanConst_IntOnBCAndQS: number | null;
    dev_LandLoanConst_LandLoanInt: number | null;
    dev_LandLoanConst_GrossLoanBefArrFee: number | null;
    dev_LandLoanConst_LegalFees: number | null;
    dev_LandLoanConst_ArrFee: number | null;
    dev_LandLoanConst_ArrFeeInt: number | null;
    dev_LandLoanConst_GrossLoanAftArrFee: number | null;
    dev_LandLoanConst_ProfFees: number | null;
    dev_LandLoanConst_LoanInt: number | null;
    dev_LandLoanConst_ExitFee: number | null;
    dev_LandLoanConst_BuildLoanPlusQSCPV: number | null;
    lenderName: string;
    bnfC_Adjt_IntOnLndLoan: number | null;
    bnfC_Adj_Tot_forBuilAndQS: number | null;
    bnfC_Adj_SalPerInt: number | null;
    bnfC_Adj_ValBefoSalPer: number | null;
    bnfC_Adj_BuiAndQsperMon: number | null;
    bnfC_Adj_MonCoved: number | null;
    bnfC_Adj_FullMonCov: number | null;
    bnfC_Adj_BuiQSAndInt: number | null;
    bnfC_Adj_BuildLoan: number | null;
    bnfC_Adj_Int_on_BuiAnsQs: number | null;
    bnfC_Adj_Bal: number | null;
    bnfC_Adj_BalanceAssInt: number | null;
    bnfC_Adj_PartMonBal: number | null;
    bnfC_Build: number | null;
    bnfC_Exit: number | null;
    bnfC_Gross: number | null;
    bnfC_Inter: number | null;
    bnfC_LendFees: number | null;
    bnfC_ProfFees: number | null;
    bnfC_TotNet: number | null;
    finOff_Exit: number | null;
    bnfC_Land: number | null;
    dev_LandLoanConst_LenderFees: number | null;
    d1LLC_LenderFees: number | null;
    d1LLC_ProfFees: number | null;
    d1LLC_TotNet: number | null;
    d1LLC_ExitFee: number | null;
    d1LLC_Gross: number | null;
    dev_LoanReq_No_Months_Covered: number | null;
    dev_LoanReq_Whole_MonthsCovered: number | null;
    dev_LoanReq_BuildAndQSAndInterest_FullMonths: number | null;
    dev_LoanReq_PartMonthBuild: number | null;
    dev_LoanReq_InterestOnPartMonth: number | null;
    dev_LoanReq_QS_inMonthNotFullyCovered: number | null;
    dev_LoanReq_BalanceOfBuild: number | null;
    dev_LoanReq_InterestOnBal_OfBuild: number | null;
    dev_LoanReq_Interest_InSalesPeriod: number | null;
    senior_Final_Gross: number | null;
    senior_Final_Exit: number | null;
    senior_Final_Total: number | null;
    senior_Final_ProfFees: number | null;
    senior_Final_LenderFees: number | null;
    senior_Final_Interest: number | null;
    senior_Final_Land: number | null;
    senior_Final_Build: number | null;
    mezz_LTC_A: number | null;
    mezz_LTC_B: number | null;
    mezz_LTC_QS_Part_Month: number | null;
    mezz_LTC_QS_Part_Interest: number | null;
    mezz_LTC_Remain_Mths: number | null;
    mezz_LTC_QS_on_Rem_mths: number | null;
    mezz_LTC_Int_OnQS_Rem_Mths: number | null;
    mezz_LTC_QS_Int_SalsPeriod: number | null;
    mezz_LTC_OnePlusCiF: number | null;
    mezz_LTC_C: number | null;
    mezz_LTC_D: number | null;
    mezz_LTC_Calac_One: number | null;
    mezz_LTC_Calc_Two: number | null;
    mezz_LTC_ML: number | null;
    mezz_LTC_ML_Int: number | null;
    mezz_LTC_MQS: number | null;
    mezz_LTC_MQS_Int: number | null;
    mezz_LTC_MF: number | null;
    mezz_LTC_MF_Int: number | null;
    mezz_LTC_Total: number | null;
    mezz_GDV: number | null;
    mezz_GDV_Remaining: number | null;
    mezz_Lowest_Total: number | null;
    mezz_Lowest_QS_And_Int: number | null;
    mezz_Lowest_MF: number | null;
    mezz_Lowest_MF_Int: number | null;
    mezz_Lowest_Build_Part_Month: number | null;
    mezz_Lowest_Build_Part_Month_Int: number | null;
    mezz_Lowest_Build_Full_Months: number | null;
    mezz_Lowest_Build_Full_Months_Int: number | null;
    mezz_Lowest_Remaining: number | null;
    mezz_Lowest_Land_Loan: number | null;
    mezz_Lowest_Land_Loan_Int: number | null;
    lowest_Mezz_Interest: number | null;
    lowest_Mezz_Total: number | null;
    lowest_Mezz_Exit: number | null;
    lowest_Mezz_Gross: number | null;
    mezz_Equity_Const_Fees: number | null;
    mezz_Equity_Const_Tot_Sen_Cost: number | null;
    mezz_Equity_Const_MezzFees: number | null;
    mezz_Equity_Const_SubTot: number | null;
    mezz_Equity_Const_SeniorLimit: number | null;
    mezz_Equity_Const_MezLimit: number | null;
    mezz_Equity_Const_Adjsted: number | null;
    mezz_Equity_Calc_Land: number | null;
    mezz_Equity_Calc_Mezz_Build: number | null;
    mezz_Equity_Calc_Mezz_BuildInt: number | null;
    mezz_Equity_Calc_MezzLand: number | null;
    mezz_Equity_Calc_MezzInt: number | null;
    mezz_Equity_Calc_TotExcl_Arrangmt: number | null;
    mezz_Equity_Calc_MezzLender: number | null;
    mezz_Equity_Calc_MezzLenderInt: number | null;
    mezz_Equity_Calc_Gross: number | null;
    mez_Snr_Equity_Const_Int: number | null;
    mez_Snr_Equity_Const_Total: number | null;
    mez_Snr_Equity_Const_Exit: number | null;
    mez_Snr_Equity_Const_Gross: number | null;
    mezz_Offered_Build: number | null;
    mezz_Offered_Land: number | null;
    mezz_Offered_Int: number | null;
    mezz_Offered_LenderFees: number | null;
    mezz_Offered_ProfFees: number | null;
    mezz_Offered_Total: number | null;
    mezz_Offered_Exit: number | null;
    mezz_Offered_Gross: number | null;
    mezz_Build_Offer: number | null;
    mezz_Land_Offer: number | null;
    mezz_Int_Offer: number | null;
    mezz_LenerFees_Offer: number | null;
    mezz_ProfFees_Offer: number | null;
    mezz_Gross_Offer: number | null;
    mezz_Exit_Offer: number | null;
    mezz_Total_Offer: number | null;
    lowest_Mezz_Build: number | null;
    dev_LoanReq_GrossLoanBefArrFee: number | null;
    senior_Equity_Reqd: number | null;
    senior_Gross_Profit: number | null;
    senior_ROCE: number | null;
    mezz_GrossProfit: number | null;
    mezz_Equity_Reqd: number | null;
    mezz_ROCE: number | null;
    senior_Loan_to_GDV: number | null;
    senior_Loan_to_LTC: number | null;
    senior_Final_TotCosts: number | null;
    senior_Final_Net_Loan: number | null;
    land_Total_other_Costs: number | null;
    build_Other_Costs: number | null;
    contingency_Adjusments: number | null;
    contingency_Adjusments_Percent: number | null;
    relevant_MeetsCriteria: boolean | null;
    calculatedBaseOnMatchingLoan: boolean;
    relevant_InterestAndFeesForLoanOffered: number | null;
    dev_LoanReq_BuildInterest_FullMonths: number | null;
    dev_LoanReq_QSCosts_And_Interest: number | null;
    dev_LoanReq_QSCosts_Int: number | null;
    bnfC_Adj_PartMonQS: number | null;
    bnfC_Adj_PartMonBuil: number | null;
    loanRqd_Equity_Reqd: number | null;
    loanRqd_Gross_Profit: number | null;
    loanRqd_ROCE: number | null;
    loanRqd_Loan_to_GDV: number | null;
    loanRqd_Loan_to_LTC: number | null;
    loanRqd_Final_TotCosts: number | null;
    loanRqd_Final_Net_Loan: number | null;
    mezz_OtherPercentFee: number | null;
    mezz_LenderPlusOtherPercentFee: number | null;
    mezz_Legals_PercOfOther: number | null;
    mezz_Legals_interest: number | null;
    mezz_TotFixFee: number | null;
    mezz_Lowest_QS: number | null;
    mezz_Lowest_QS_Int: number | null;
    mezz_Lowest_MF_Lender: number | null;
    mezz_Lowest_MF_Legal: number | null;
    mezz_Lowest_MF_Legal_FixedFeeInt: number | null;
    mezz_Lowest_MF_Legal_FixedFee: number | null;
    mezz_Lowest_X: number | null;
    mezz_Lowest_Bal_SalesPerInt: number | null;
    mezz_Lowest_Bal_forDistribution: number | null;
    mezz_Lowest_Calc1_A: number | null;
    mezz_Lowest_Calc1_B: number | null;
    mezz_Lowest_Calc1_C: number | null;
    mezz_Lowest_Calc1_D: number | null;
    mezz_Lowest_Calc1_E: number | null;
    mezz_Lowest_Calc1_F: number | null;
    mezz_Lowest_Calc1_G: number | null;
    mezz_Lowest_Calc1_H: number | null;
    mezz_Lowest_Calc1_J: number | null;
    mezz_Lowest_Calc1_BalForCalc2: number | null;
    mezz_Lowest_Calc2_A: number | null;
    mezz_Lowest_Calc2_B: number | null;
    mezz_Lowest_Calc2_C: number | null;
    mezz_Lowest_Calc2_D: number | null;
    mezz_Lowest_Calc2_E: number | null;
    mezz_Lowest_Calc2_F: number | null;
    mezz_Lowest_Calc2_G: number | null;
    mezz_Lowest_Calc2_H: number | null;
    mezz_Lowest_Calc2_J: number | null;
    mezz_Lowest_Calc2_K: number | null;
    mezz_Lowest_Calc2_L: number | null;
    mezz_Lowest_Calc2_M: number | null;
    mezz_Lowest_Calc2_N: number | null;
    mezz_Lowest_Calc2_BalForCalc3: number | null;
    mezz_Lowest_Calc3_B: number | null;
    mezz_Lowest_Calc3_A: number | null;
    mezz_Lowest_Calc3_C: number | null;
    mezz_Lowest_Calc3_D: number | null;
    mezz_Lowest_Result_Build: number | null;
    mezz_Lowest_Result_Interest: number | null;
    mezz_Lowest_Result_Land: number | null;
    lowest_Mezz_Land: number | null;
    lowest_Mezz_Lender_Fees: number | null;
    lowest_Mezz_Prof_Fees: number | null;
    mezz_D1LLC_A: number | null;
    mezz_D1LLC_B: number | null;
    mezz_D1LLC_C: number | null;
    mezz_D1LLC_D: number | null;
    mezz_D1LLC_E: number | null;
    mezz_D1LLC_F: number | null;
    mezz_D1LLC_G: number | null;
    mezz_D1LLC_H: number | null;
    mezz_D1LLC_J: number | null;
    mezz_D1LLC_K: number | null;
    mezz_D1LLC_L: number | null;
    mezz_D1LLC_M: number | null;
    mezz_SEC_A: number | null;
    mezz_SEC_B: number | null;
    mezz_SEC_C: number | null;
    mezz_SEC_D: number | null;
    mezz_SEC_E: number | null;
    mezz_SEC_F: number | null;
    mezz_SEC_G: number | null;
    mezz_SEC_H: number | null;
    mezz_SEC_J: number | null;
    mezz_SEC_K: number | null;
    mezz_SEC_M: number | null;
    mezz_SEC_N: number | null;
    mezz_SEC_P: number | null;
    mezz_SEC_Q: number | null;
    mezz_SEC_R: number | null;
    mez_Snr_Equity_Const_Build: number | null;
    mez_Snr_Equity_Const_Land: number | null;
    mez_Snr_Equity_Const_Lender_Fee: number | null;
    mezz_Lowest_Calc1_X: number | null;
    mezz_Lowest_Remaining_B4SalesPerion: number | null;
    mez_Snr_Equity_Const_ProfFees: number | null;
    mezz_D1LLC_P: number | null;
    mezz_D1LLC_N: number | null;
    mezz_SEC_T: number | null;
    mezz_SEC_S: number | null;
    mezz_SEC_Ja: number | null;
    mezz_SEC_Jb: number | null;
    mezz_SEC_Jc: number | null;
    mezz_SEC_Jd: number | null;
    mezz_SEC_Je: number | null;
    loanReq_LandLoanInterest: number | null;
    senAndMezz_Gross: number | null;
    senAndMezz_Exit: number | null;
    senAndMezz_Total: number | null;
    senAndMezz_Prof: number | null;
    senAndMezz_Lender: number | null;
    senAndMezz_Interest: number | null;
    senAndMezz_Land: number | null;
    senAndMezz_Build: number | null;
    qS_Initial_Percent_of_Build: number | null;
    qS_Initial_Percent_of_Build_Interest: number | null;
    dev_LegalFee_Perc_of_BuildCosts: number | null;
    legals_Percent_of_Build_Interest: number | null;
    dev_TotalLandAdditionalCosts: number | null;
    dev_TotalBuildAdditionalCosts: number | null;
    dev_Build_ContingencyPercent: number | null;
    grossLoan: number | null;
    netLoan: number | null;
    loanInterest: number | null;
    lenderFees: number | null;
    professionalFees: number | null;
    loanLabel: string;
    id: number;
    seniorProductId: number;
    mezzProductId: number | null;
    developmentInputId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_LenderResult[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_LenderResult[];
}

/** LenderResult without database generated properties */
export interface LenderResultInsert {
    dev_BuildCostContingencyAdj?: number | null;
    dev_S106CIL?: number | null;
    dev_ProfFeesPlanning?: number | null;
    dev_ProfFeesQS?: number | null;
    dev_MinContAdj?: number | null;
    dev_MaxContAdj?: number | null;
    dev_Marketing?: number | null;
    dev_SDLT?: number | null;
    dev_PurchaseCosts?: number | null;
    dev_ClientSalesPeriod?: number | null;
    dev_SalesPeriodAdj?: number | null;
    dev_CumulativeIntRate?: number | null;
    dev_GDV_MaxLoanAvail?: number | null;
    dev_GDV_LenderArrFeeIncBrokFee?: number | null;
    dev_GDV_ArrFeeIncBrokFeeInt?: number | null;
    dev_GDV_BuildCostPerMonth?: number | null;
    dev_GDV_TotBuildCostOverBuildTermIncInt?: number | null;
    dev_GDV_TotBuildCostOverLoanTermIncInt?: number | null;
    dev_GDV_IntOnBuild?: number | null;
    dev_GDV_LoanRemainPreLenderProfFees?: number | null;
    interestOnFeesAbove?: number | null;
    dev_GDV_FixedProfFeesIncInt?: number | null;
    dev_GDV_LandLoanIncInt?: number | null;
    dev_GDV_LandLoan?: number | null;
    dev_GDV_MonitorQSIncIntOverBuildT?: number | null;
    dev_GDV_MonitorQSOverLoanT?: number | null;
    dev_TotalOtherFees?: number | null;
    dev_TotOtherFeesOverBuildTerm?: number | null;
    dev_TBCAandOFBuildTerm?: number | null;
    dev_TBCAandOFLoanTerm?: number | null;
    dev_TotProjCosts?: number | null;
    dev_QSCostPerVisit?: number | null;
    dev_LTCtoTotProjCosts?: number | null;
    dev_Working1?: number | null;
    dev_LenderIncBrokPlusLegal?: number | null;
    dev_Working3Part2?: number | null;
    dev_Working3Part3?: number | null;
    dev_Working3?: number | null;
    dev_Working2?: number | null;
    dev_LandLoan?: number | null;
    dev_LandLoanInt?: number | null;
    dev_Prf_TotLoanInt?: number | null;
    dev_Prf_ArrFee?: number | null;
    dev_GDV_GrossLoan?: number | null;
    dev_GDV_TotInt?: number | null;
    dev_TotBuildAdjPlusOtherFees?: number | null;
    dev_Prf_TotLoanWOArrFeeIncAFInt?: number | null;
    dev_Prf_ArrFeeIncInterest?: number | null;
    dev_Prf_TotalGrossLoan?: number | null;
    dev_Prf_90PercLTC?: number | null;
    dev_Prf_2PercArrFee?: number | null;
    dev_TotIntLTC?: number | null;
    dev_GrossLoanLTC?: number | null;
    dev_Mez_LTCMezAvailAftMezCosts?: number | null;
    dev_Prf_LenderProfFees?: number | null;
    dev_GDV_LandLoanInt?: number | null;
    dev_EAActlCosts?: number | null;
    dev_SalesLegalActlCosts?: number | null;
    dev_TtlSalesFees?: number | null;
    dev_NDV?: number | null;
    dev_Mez_ArrFeeOnMxPsbNetLoanAftSEC?: number | null;
    dev_ValFee_LandCost?: number | null;
    dev_ValFee_GDV?: number | null;
    dev_QSInitialFeeBuildCosts?: number | null;
    dev_LenderLegalAndQSGrossLoan?: number | null;
    dev_LoanReq_BuildLoan?: number | null;
    dev_LoanReq_LandLoan?: number | null;
    dev_LoanReq_TotNetLoan?: number | null;
    dev_LoanReq_TotOtherFees?: number | null;
    dev_LoanReq_IntOnTotOtherFees?: number | null;
    dev_LoanReq_QSCosts?: number | null;
    dev_LoanReq_BuildLoanPlusQSCPV?: number | null;
    dev_LoanReq_TBCAandOFBuildTerm?: number | null;
    dev_LoanReq_TBCAandOFLoanTerm?: number | null;
    dev_LoanReq_IntOnBCAndQS?: number | null;
    dev_LoanReq_LandLoanInt?: number | null;
    dev_LoanReq_ArrFee?: number | null;
    dev_LoanReq_ArrFeeInt?: number | null;
    dev_LoanReq_GrossLoanAftArrFee?: number | null;
    dev_LoanReq_LenderArrFeeandProfFees?: number | null;
    dev_LoanReq_LoanInt?: number | null;
    dev_LoanReq_GrossLoan?: number | null;
    dev_LoanReq_GrossLoanClientRequest?: number | null;
    dev_LoanReq_EquityShortfallBuildLoan?: number | null;
    dev_LoanReq_Mez_TotOtherFees?: number | null;
    dev_LoanReq_Mez_IntOnTotOtherFees?: number | null;
    dev_Mez_CumulativeIntRate2?: number | null;
    dev_TotalOtherFeesWithDelayedStart?: number | null;
    dev_LTCGrossLoanCorrect?: boolean | null;
    seniorProduct: ProductInsert | null;
    mezzProduct?: ProductInsert | null;
    developmentInput?: DevelopmentInputInsert | null;
    dev_LoanReq_GrossSnrAftConstrMax?: number | null;
    dev_LoanReq_SnrIntAftConstrMax?: number | null;
    dev_LoanReq_SnrArrAndProfFeesAftConstrMax?: number | null;
    dev_GDV_ArrFee?: number | null;
    dev_GDV_ExitFee?: number | null;
    dev_LTC_ArrFee?: number | null;
    dev_LTC_ExitFee?: number | null;
    dev_GDV_ProfFees?: number | null;
    dev_LTC_ProfFees?: number | null;
    dev_LoanReq_ProfFees?: number | null;
    dev_LoanReq_ExitFee?: number | null;
    dev_LLAvail_BuildLoan?: number | null;
    dev_LLAvail_LandLoan?: number | null;
    dev_LLAvail_Int?: number | null;
    dev_LLAvail_LenderArrFee?: number | null;
    dev_LLAvail_ProfFees?: number | null;
    dev_LLAvail_GrossSnrLoan?: number | null;
    dev_LLAvail_ExitFee?: number | null;
    dev_LTC_TotFundCosts?: number | null;
    dev_GDV_TotFundCosts?: number | null;
    dev_LoanReq_TotFundCosts?: number | null;
    dev_LLAvail_TotFundCosts?: number | null;
    cT_LoanReq_TotLoanCosts?: number | null;
    cT_LoanReq_Profit?: number | null;
    cT_LLAvail_NetLoan?: number | null;
    cT_LLAvail_TotLoanCosts?: number | null;
    cT_LLAvail_EquityReq?: number | null;
    cT_LLAvail_Profit?: number | null;
    cT_LLAvail_ROCE?: number | null;
    dev_LoanReq_LegalFees?: number | null;
    dev_LoanReq_LenderArrFee?: number | null;
    lI_Dev_TotRate?: number | null;
    lI_Dev_ExitFee?: number | null;
    lI_Dev_ArrFeeIncBrokFee?: number | null;
    lI_Dev_ArrFeeBase?: number | null;
    lI_LoanProduct?: ProductTypeEnum;
    lI_Dev_MaxLTGDV?: number | null;
    lI_Dev_MaxLTC?: number | null;
    debugstring?: string;
    dev_LandValue?: number | null;
    dev_LandLoanConst_LandLoan?: number | null;
    dev_LandLoanConst_TotNetLoan?: number | null;
    dev_LandLoanConst_IntOnTotOtherFees?: number | null;
    dev_TotBuildCostsAdjPlusQSCPV?: number | null;
    dev_LandLoanConst_TBCAandOFBuildTerm?: number | null;
    dev_LandLoanConst_TBCAandOFLoanTerm?: number | null;
    dev_LandLoanConst_IntOnBCAndQS?: number | null;
    dev_LandLoanConst_LandLoanInt?: number | null;
    dev_LandLoanConst_GrossLoanBefArrFee?: number | null;
    dev_LandLoanConst_LegalFees?: number | null;
    dev_LandLoanConst_ArrFee?: number | null;
    dev_LandLoanConst_ArrFeeInt?: number | null;
    dev_LandLoanConst_GrossLoanAftArrFee?: number | null;
    dev_LandLoanConst_ProfFees?: number | null;
    dev_LandLoanConst_LoanInt?: number | null;
    dev_LandLoanConst_ExitFee?: number | null;
    dev_LandLoanConst_BuildLoanPlusQSCPV?: number | null;
    lenderName?: string;
    bnfC_Adjt_IntOnLndLoan?: number | null;
    bnfC_Adj_Tot_forBuilAndQS?: number | null;
    bnfC_Adj_SalPerInt?: number | null;
    bnfC_Adj_ValBefoSalPer?: number | null;
    bnfC_Adj_BuiAndQsperMon?: number | null;
    bnfC_Adj_MonCoved?: number | null;
    bnfC_Adj_FullMonCov?: number | null;
    bnfC_Adj_BuiQSAndInt?: number | null;
    bnfC_Adj_BuildLoan?: number | null;
    bnfC_Adj_Int_on_BuiAnsQs?: number | null;
    bnfC_Adj_Bal?: number | null;
    bnfC_Adj_BalanceAssInt?: number | null;
    bnfC_Adj_PartMonBal?: number | null;
    bnfC_Build?: number | null;
    bnfC_Exit?: number | null;
    bnfC_Gross?: number | null;
    bnfC_Inter?: number | null;
    bnfC_LendFees?: number | null;
    bnfC_ProfFees?: number | null;
    bnfC_TotNet?: number | null;
    finOff_Exit?: number | null;
    bnfC_Land?: number | null;
    dev_LandLoanConst_LenderFees?: number | null;
    d1LLC_LenderFees?: number | null;
    d1LLC_ProfFees?: number | null;
    d1LLC_TotNet?: number | null;
    d1LLC_ExitFee?: number | null;
    d1LLC_Gross?: number | null;
    dev_LoanReq_No_Months_Covered?: number | null;
    dev_LoanReq_Whole_MonthsCovered?: number | null;
    dev_LoanReq_BuildAndQSAndInterest_FullMonths?: number | null;
    dev_LoanReq_PartMonthBuild?: number | null;
    dev_LoanReq_InterestOnPartMonth?: number | null;
    dev_LoanReq_QS_inMonthNotFullyCovered?: number | null;
    dev_LoanReq_BalanceOfBuild?: number | null;
    dev_LoanReq_InterestOnBal_OfBuild?: number | null;
    dev_LoanReq_Interest_InSalesPeriod?: number | null;
    senior_Final_Gross?: number | null;
    senior_Final_Exit?: number | null;
    senior_Final_Total?: number | null;
    senior_Final_ProfFees?: number | null;
    senior_Final_LenderFees?: number | null;
    senior_Final_Interest?: number | null;
    senior_Final_Land?: number | null;
    senior_Final_Build?: number | null;
    mezz_LTC_A?: number | null;
    mezz_LTC_B?: number | null;
    mezz_LTC_QS_Part_Month?: number | null;
    mezz_LTC_QS_Part_Interest?: number | null;
    mezz_LTC_Remain_Mths?: number | null;
    mezz_LTC_QS_on_Rem_mths?: number | null;
    mezz_LTC_Int_OnQS_Rem_Mths?: number | null;
    mezz_LTC_QS_Int_SalsPeriod?: number | null;
    mezz_LTC_OnePlusCiF?: number | null;
    mezz_LTC_C?: number | null;
    mezz_LTC_D?: number | null;
    mezz_LTC_Calac_One?: number | null;
    mezz_LTC_Calc_Two?: number | null;
    mezz_LTC_ML?: number | null;
    mezz_LTC_ML_Int?: number | null;
    mezz_LTC_MQS?: number | null;
    mezz_LTC_MQS_Int?: number | null;
    mezz_LTC_MF?: number | null;
    mezz_LTC_MF_Int?: number | null;
    mezz_LTC_Total?: number | null;
    mezz_GDV?: number | null;
    mezz_GDV_Remaining?: number | null;
    mezz_Lowest_Total?: number | null;
    mezz_Lowest_QS_And_Int?: number | null;
    mezz_Lowest_MF?: number | null;
    mezz_Lowest_MF_Int?: number | null;
    mezz_Lowest_Build_Part_Month?: number | null;
    mezz_Lowest_Build_Part_Month_Int?: number | null;
    mezz_Lowest_Build_Full_Months?: number | null;
    mezz_Lowest_Build_Full_Months_Int?: number | null;
    mezz_Lowest_Remaining?: number | null;
    mezz_Lowest_Land_Loan?: number | null;
    mezz_Lowest_Land_Loan_Int?: number | null;
    lowest_Mezz_Interest?: number | null;
    lowest_Mezz_Total?: number | null;
    lowest_Mezz_Exit?: number | null;
    lowest_Mezz_Gross?: number | null;
    mezz_Equity_Const_Fees?: number | null;
    mezz_Equity_Const_Tot_Sen_Cost?: number | null;
    mezz_Equity_Const_MezzFees?: number | null;
    mezz_Equity_Const_SubTot?: number | null;
    mezz_Equity_Const_SeniorLimit?: number | null;
    mezz_Equity_Const_MezLimit?: number | null;
    mezz_Equity_Const_Adjsted?: number | null;
    mezz_Equity_Calc_Land?: number | null;
    mezz_Equity_Calc_Mezz_Build?: number | null;
    mezz_Equity_Calc_Mezz_BuildInt?: number | null;
    mezz_Equity_Calc_MezzLand?: number | null;
    mezz_Equity_Calc_MezzInt?: number | null;
    mezz_Equity_Calc_TotExcl_Arrangmt?: number | null;
    mezz_Equity_Calc_MezzLender?: number | null;
    mezz_Equity_Calc_MezzLenderInt?: number | null;
    mezz_Equity_Calc_Gross?: number | null;
    mez_Snr_Equity_Const_Int?: number | null;
    mez_Snr_Equity_Const_Total?: number | null;
    mez_Snr_Equity_Const_Exit?: number | null;
    mez_Snr_Equity_Const_Gross?: number | null;
    mezz_Offered_Build?: number | null;
    mezz_Offered_Land?: number | null;
    mezz_Offered_Int?: number | null;
    mezz_Offered_LenderFees?: number | null;
    mezz_Offered_ProfFees?: number | null;
    mezz_Offered_Total?: number | null;
    mezz_Offered_Exit?: number | null;
    mezz_Offered_Gross?: number | null;
    mezz_Build_Offer?: number | null;
    mezz_Land_Offer?: number | null;
    mezz_Int_Offer?: number | null;
    mezz_LenerFees_Offer?: number | null;
    mezz_ProfFees_Offer?: number | null;
    mezz_Gross_Offer?: number | null;
    mezz_Exit_Offer?: number | null;
    mezz_Total_Offer?: number | null;
    lowest_Mezz_Build?: number | null;
    dev_LoanReq_GrossLoanBefArrFee?: number | null;
    senior_Equity_Reqd?: number | null;
    senior_Gross_Profit?: number | null;
    senior_ROCE?: number | null;
    mezz_GrossProfit?: number | null;
    mezz_Equity_Reqd?: number | null;
    mezz_ROCE?: number | null;
    senior_Loan_to_GDV?: number | null;
    senior_Loan_to_LTC?: number | null;
    senior_Final_TotCosts?: number | null;
    senior_Final_Net_Loan?: number | null;
    land_Total_other_Costs?: number | null;
    build_Other_Costs?: number | null;
    contingency_Adjusments?: number | null;
    contingency_Adjusments_Percent?: number | null;
    relevant_MeetsCriteria?: boolean | null;
    calculatedBaseOnMatchingLoan?: boolean;
    relevant_InterestAndFeesForLoanOffered?: number | null;
    dev_LoanReq_BuildInterest_FullMonths?: number | null;
    dev_LoanReq_QSCosts_And_Interest?: number | null;
    dev_LoanReq_QSCosts_Int?: number | null;
    bnfC_Adj_PartMonQS?: number | null;
    bnfC_Adj_PartMonBuil?: number | null;
    loanRqd_Equity_Reqd?: number | null;
    loanRqd_Gross_Profit?: number | null;
    loanRqd_ROCE?: number | null;
    loanRqd_Loan_to_GDV?: number | null;
    loanRqd_Loan_to_LTC?: number | null;
    loanRqd_Final_TotCosts?: number | null;
    loanRqd_Final_Net_Loan?: number | null;
    mezz_OtherPercentFee?: number | null;
    mezz_LenderPlusOtherPercentFee?: number | null;
    mezz_Legals_PercOfOther?: number | null;
    mezz_Legals_interest?: number | null;
    mezz_TotFixFee?: number | null;
    mezz_Lowest_QS?: number | null;
    mezz_Lowest_QS_Int?: number | null;
    mezz_Lowest_MF_Lender?: number | null;
    mezz_Lowest_MF_Legal?: number | null;
    mezz_Lowest_MF_Legal_FixedFeeInt?: number | null;
    mezz_Lowest_MF_Legal_FixedFee?: number | null;
    mezz_Lowest_X?: number | null;
    mezz_Lowest_Bal_SalesPerInt?: number | null;
    mezz_Lowest_Bal_forDistribution?: number | null;
    mezz_Lowest_Calc1_A?: number | null;
    mezz_Lowest_Calc1_B?: number | null;
    mezz_Lowest_Calc1_C?: number | null;
    mezz_Lowest_Calc1_D?: number | null;
    mezz_Lowest_Calc1_E?: number | null;
    mezz_Lowest_Calc1_F?: number | null;
    mezz_Lowest_Calc1_G?: number | null;
    mezz_Lowest_Calc1_H?: number | null;
    mezz_Lowest_Calc1_J?: number | null;
    mezz_Lowest_Calc1_BalForCalc2?: number | null;
    mezz_Lowest_Calc2_A?: number | null;
    mezz_Lowest_Calc2_B?: number | null;
    mezz_Lowest_Calc2_C?: number | null;
    mezz_Lowest_Calc2_D?: number | null;
    mezz_Lowest_Calc2_E?: number | null;
    mezz_Lowest_Calc2_F?: number | null;
    mezz_Lowest_Calc2_G?: number | null;
    mezz_Lowest_Calc2_H?: number | null;
    mezz_Lowest_Calc2_J?: number | null;
    mezz_Lowest_Calc2_K?: number | null;
    mezz_Lowest_Calc2_L?: number | null;
    mezz_Lowest_Calc2_M?: number | null;
    mezz_Lowest_Calc2_N?: number | null;
    mezz_Lowest_Calc2_BalForCalc3?: number | null;
    mezz_Lowest_Calc3_B?: number | null;
    mezz_Lowest_Calc3_A?: number | null;
    mezz_Lowest_Calc3_C?: number | null;
    mezz_Lowest_Calc3_D?: number | null;
    mezz_Lowest_Result_Build?: number | null;
    mezz_Lowest_Result_Interest?: number | null;
    mezz_Lowest_Result_Land?: number | null;
    lowest_Mezz_Land?: number | null;
    lowest_Mezz_Lender_Fees?: number | null;
    lowest_Mezz_Prof_Fees?: number | null;
    mezz_D1LLC_A?: number | null;
    mezz_D1LLC_B?: number | null;
    mezz_D1LLC_C?: number | null;
    mezz_D1LLC_D?: number | null;
    mezz_D1LLC_E?: number | null;
    mezz_D1LLC_F?: number | null;
    mezz_D1LLC_G?: number | null;
    mezz_D1LLC_H?: number | null;
    mezz_D1LLC_J?: number | null;
    mezz_D1LLC_K?: number | null;
    mezz_D1LLC_L?: number | null;
    mezz_D1LLC_M?: number | null;
    mezz_SEC_A?: number | null;
    mezz_SEC_B?: number | null;
    mezz_SEC_C?: number | null;
    mezz_SEC_D?: number | null;
    mezz_SEC_E?: number | null;
    mezz_SEC_F?: number | null;
    mezz_SEC_G?: number | null;
    mezz_SEC_H?: number | null;
    mezz_SEC_J?: number | null;
    mezz_SEC_K?: number | null;
    mezz_SEC_M?: number | null;
    mezz_SEC_N?: number | null;
    mezz_SEC_P?: number | null;
    mezz_SEC_Q?: number | null;
    mezz_SEC_R?: number | null;
    mez_Snr_Equity_Const_Build?: number | null;
    mez_Snr_Equity_Const_Land?: number | null;
    mez_Snr_Equity_Const_Lender_Fee?: number | null;
    mezz_Lowest_Calc1_X?: number | null;
    mezz_Lowest_Remaining_B4SalesPerion?: number | null;
    mez_Snr_Equity_Const_ProfFees?: number | null;
    mezz_D1LLC_P?: number | null;
    mezz_D1LLC_N?: number | null;
    mezz_SEC_T?: number | null;
    mezz_SEC_S?: number | null;
    mezz_SEC_Ja?: number | null;
    mezz_SEC_Jb?: number | null;
    mezz_SEC_Jc?: number | null;
    mezz_SEC_Jd?: number | null;
    mezz_SEC_Je?: number | null;
    loanReq_LandLoanInterest?: number | null;
    senAndMezz_Gross?: number | null;
    senAndMezz_Exit?: number | null;
    senAndMezz_Total?: number | null;
    senAndMezz_Prof?: number | null;
    senAndMezz_Lender?: number | null;
    senAndMezz_Interest?: number | null;
    senAndMezz_Land?: number | null;
    senAndMezz_Build?: number | null;
    qS_Initial_Percent_of_Build?: number | null;
    qS_Initial_Percent_of_Build_Interest?: number | null;
    dev_LegalFee_Perc_of_BuildCosts?: number | null;
    legals_Percent_of_Build_Interest?: number | null;
    dev_TotalLandAdditionalCosts?: number | null;
    dev_TotalBuildAdditionalCosts?: number | null;
    dev_Build_ContingencyPercent?: number | null;
    grossLoan?: number | null;
    netLoan?: number | null;
    loanInterest?: number | null;
    lenderFees?: number | null;
    professionalFees?: number | null;
    seniorProductId: number;
    mezzProductId?: number | null;
    developmentInputId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_LenderResultInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_LenderResultInsert[];
}

export interface LenderResultMinimalDTO {
    id?: number;
    loanLabel?: string;
    selectedItem?: boolean;
    selectedRowNumber?: number;
    debug1Flag?: boolean;
    debug1Info?: string;
    lenderName?: string;
    senior_Final_Total?: number | null;
    senior_Final_Net_Loan?: number | null;
    senior_Final_Build?: number | null;
    senior_Final_Land?: number | null;
    senior_Final_Interest?: number | null;
    senior_Final_LenderFees?: number | null;
    senior_Final_ProfFees?: number | null;
    senior_Final_Exit?: number | null;
    senior_Final_TotCosts?: number | null;
    senior_Equity_Reqd?: number | null;
    senior_ROCE?: number | null;
    lI_Dev_TotRate?: number | null;
    lI_Dev_ArrFeeBase?: number | null;
    lI_Dev_ArrFeeIncBrokFee?: number | null;
    lI_Dev_ExitFee?: number | null;
    dev_LoanReq_GrossLoanClientRequest?: number | null;
    debugstring?: string;
    senior_Loan_to_GDV?: number | null;
    senior_Loan_to_LTC?: number | null;
    loanRqd_Loan_to_GDV?: number | null;
    loanRqd_Loan_to_LTC?: number | null;
    senior_Gross_Profit?: number | null;
    dev_LoanReq_TotFundCosts?: number | null;
    loanRqd_Final_Net_Loan?: number | null;
    dev_LoanReq_BuildLoan?: number | null;
    dev_LoanReq_LandLoan?: number | null;
    dev_LoanReq_ProfFees?: number | null;
    loanRqd_Final_TotCosts?: number | null;
    loanRqd_Equity_Reqd?: number | null;
    loanRqd_ROCE?: number | null;
    senior_Final_Gross?: number | null;
    calculatedBasedOnMatchingLoan?: boolean;
    lI_LoanProduct?: ProductTypeEnum;
    cI_Dev_BuildTerm?: number | null;
    cI_Dev_LoanTermReq?: number | null;
    dev_LoanReq_LoanInt?: number | null;
    dev_LoanReq_LenderArrFee?: number | null;
    dev_LoanReq_ExitFee?: number | null;
    dev_TotProjCosts?: number | null;
    loanRqd_Gross_Profit?: number | null;
    grossLoan?: number | null;
    netLoan?: number | null;
    loanInterest?: number | null;
    lenderFees?: number | null;
    professionalFees?: number | null;
    additionalProductInfo?: string;
    totalMonthlyRate?: number | null;
    seniorProductID?: number | null;
    logoURL?: string;
    isDeleted?: boolean;
    lastUpdatedDateTime?: Date | null;
    createdDateTime?: Date | null;
}

export interface LenderResultPageWithTotalCountDTO {
    list?: LenderResult[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface LenderResultSetDTO {
    id?: number;
    userId?: number;
    caseId?: number | null;
    matchingResults?: LenderResultMinimalDTO[];
    largestLoanResults?: LenderResultMinimalDTO[];
    combinedSummaryResultSet?: LenderResultSummaryDTO[];
    profFees?: number | null;
    location?: LocationEnum;
    projectCosts?: number | null;
    term?: number | null;
    propertyType?: PropertyTypeEnum;
    loanRequired?: number | null;
    exitStrategy?: ExitStrategyEnum;
    doYouOwnTheProperty?: boolean;
    logoURL?: string;
    developmentInputWithNoLoginUniqueRef?: string;
}

export interface LenderResultSetWithInputsDTO {
    lenderResultSet?: LenderResultSetDTO;
    developmentInput?: DevelopmentInput;
}

export interface LenderResultSummaryDTO {
    productFamily?: ProductFamilyEnum;
    id?: number;
    grossLoan?: number;
    loanToCostGross?: number;
    netLoan?: number;
    loanToValueNet?: number;
    equityOrDeposit?: number;
    profit?: number | null;
    loanTerm?: number;
    lenderLogo?: string;
    loanLabel?: string;
    productID?: number | null;
    lenderID?: number;
    lenderName?: string;
    snapshot?: string;
    interest?: number;
    annualInterest?: number;
    monthlyInterest?: number;
    arrangementFee?: number;
    exitFee?: number;
    trueMonthlyCost?: number;
    additionalProductInfo?: string;
    isMatching?: boolean;
    isLargest?: boolean;
    isHighestROCE?: boolean;
    isLowestTrueMonthlyCost?: boolean;
    isDealLender?: boolean;
    dealLenderStatus?: CaseLenderStateEnum | null;
    debug1Flag?: boolean;
    debug1Info?: string;
    lenderInternalUrl?: string;
    logoURL?: string;
    avgLenderResponseTime?: number | null;
    productSourceType?: ProductSourceTypeEnum;
    externalProductId?: string | null;
    selectedItem?: boolean;
    selectedRowNumber?: number;
    ratingCustomerService?: boolean;
    ratingSpeed?: boolean;
    ratingFlexibility?: boolean;
    ratingUserRating?: boolean;
    loanToCost?: number | null;
    netLoanPercOfTotalCost?: number | null;
    buildLoan?: number | null;
    buildLoanPercOfBuildCost?: number | null;
    landLoan?: number | null;
    landLoanPercOfLandCost?: number | null;
    totalLenderCost?: number | null;
    deposit?: number | null;
    roce?: number | null;
    depositPercOfTotalCost?: number | null;
    profitPercOfTotalCost?: number | null;
    isCaseLender?: boolean;
    caseLenderStatus?: CaseLenderStateEnum | null;
    contactUserFirstName?: string;
    contactUserLastName?: string;
    contactUserEmail?: string;
    contactUserProfilePictureUrl?: string;
    contactUserBio?: string;
    showLenderUserDetails?: boolean;
    readonly contactUserFullName?: string;
    loanInterest?: number | null;
    buildTerm?: number;
    loanToGDV?: number | null;
    lenderArrangementFee?: number | null;
    lenderExitFee?: number | null;
    lenderProfessionalFees?: number | null;
}

/** LenderResult with all properties optional except PKs */
export interface LenderResultUpdate {
    dev_BuildCostContingencyAdj?: number | null;
    dev_S106CIL?: number | null;
    dev_ProfFeesPlanning?: number | null;
    dev_ProfFeesQS?: number | null;
    dev_MinContAdj?: number | null;
    dev_MaxContAdj?: number | null;
    dev_Marketing?: number | null;
    dev_SDLT?: number | null;
    dev_PurchaseCosts?: number | null;
    dev_ClientSalesPeriod?: number | null;
    dev_SalesPeriodAdj?: number | null;
    dev_CumulativeIntRate?: number | null;
    dev_GDV_MaxLoanAvail?: number | null;
    dev_GDV_LenderArrFeeIncBrokFee?: number | null;
    dev_GDV_ArrFeeIncBrokFeeInt?: number | null;
    dev_GDV_BuildCostPerMonth?: number | null;
    dev_GDV_TotBuildCostOverBuildTermIncInt?: number | null;
    dev_GDV_TotBuildCostOverLoanTermIncInt?: number | null;
    dev_GDV_IntOnBuild?: number | null;
    dev_GDV_LoanRemainPreLenderProfFees?: number | null;
    interestOnFeesAbove?: number | null;
    dev_GDV_FixedProfFeesIncInt?: number | null;
    dev_GDV_LandLoanIncInt?: number | null;
    dev_GDV_LandLoan?: number | null;
    dev_GDV_MonitorQSIncIntOverBuildT?: number | null;
    dev_GDV_MonitorQSOverLoanT?: number | null;
    dev_TotalOtherFees?: number | null;
    dev_TotOtherFeesOverBuildTerm?: number | null;
    dev_TBCAandOFBuildTerm?: number | null;
    dev_TBCAandOFLoanTerm?: number | null;
    dev_TotProjCosts?: number | null;
    dev_QSCostPerVisit?: number | null;
    dev_LTCtoTotProjCosts?: number | null;
    dev_Working1?: number | null;
    dev_LenderIncBrokPlusLegal?: number | null;
    dev_Working3Part2?: number | null;
    dev_Working3Part3?: number | null;
    dev_Working3?: number | null;
    dev_Working2?: number | null;
    dev_LandLoan?: number | null;
    dev_LandLoanInt?: number | null;
    dev_Prf_TotLoanInt?: number | null;
    dev_Prf_ArrFee?: number | null;
    dev_GDV_GrossLoan?: number | null;
    dev_GDV_TotInt?: number | null;
    dev_TotBuildAdjPlusOtherFees?: number | null;
    dev_Prf_TotLoanWOArrFeeIncAFInt?: number | null;
    dev_Prf_ArrFeeIncInterest?: number | null;
    dev_Prf_TotalGrossLoan?: number | null;
    dev_Prf_90PercLTC?: number | null;
    dev_Prf_2PercArrFee?: number | null;
    dev_TotIntLTC?: number | null;
    dev_GrossLoanLTC?: number | null;
    dev_Mez_LTCMezAvailAftMezCosts?: number | null;
    dev_Prf_LenderProfFees?: number | null;
    dev_GDV_LandLoanInt?: number | null;
    dev_EAActlCosts?: number | null;
    dev_SalesLegalActlCosts?: number | null;
    dev_TtlSalesFees?: number | null;
    dev_NDV?: number | null;
    dev_Mez_ArrFeeOnMxPsbNetLoanAftSEC?: number | null;
    dev_ValFee_LandCost?: number | null;
    dev_ValFee_GDV?: number | null;
    dev_QSInitialFeeBuildCosts?: number | null;
    dev_LenderLegalAndQSGrossLoan?: number | null;
    dev_LoanReq_BuildLoan?: number | null;
    dev_LoanReq_LandLoan?: number | null;
    dev_LoanReq_TotNetLoan?: number | null;
    dev_LoanReq_TotOtherFees?: number | null;
    dev_LoanReq_IntOnTotOtherFees?: number | null;
    dev_LoanReq_QSCosts?: number | null;
    dev_LoanReq_BuildLoanPlusQSCPV?: number | null;
    dev_LoanReq_TBCAandOFBuildTerm?: number | null;
    dev_LoanReq_TBCAandOFLoanTerm?: number | null;
    dev_LoanReq_IntOnBCAndQS?: number | null;
    dev_LoanReq_LandLoanInt?: number | null;
    dev_LoanReq_ArrFee?: number | null;
    dev_LoanReq_ArrFeeInt?: number | null;
    dev_LoanReq_GrossLoanAftArrFee?: number | null;
    dev_LoanReq_LenderArrFeeandProfFees?: number | null;
    dev_LoanReq_LoanInt?: number | null;
    dev_LoanReq_GrossLoan?: number | null;
    dev_LoanReq_GrossLoanClientRequest?: number | null;
    dev_LoanReq_EquityShortfallBuildLoan?: number | null;
    dev_LoanReq_Mez_TotOtherFees?: number | null;
    dev_LoanReq_Mez_IntOnTotOtherFees?: number | null;
    dev_Mez_CumulativeIntRate2?: number | null;
    dev_TotalOtherFeesWithDelayedStart?: number | null;
    dev_LTCGrossLoanCorrect?: boolean | null;
    seniorProduct?: ProductUpdateWithoutPKs | null;
    mezzProduct?: ProductUpdateWithoutPKs | null;
    developmentInput?: DevelopmentInputUpdateWithoutPKs | null;
    dev_LoanReq_GrossSnrAftConstrMax?: number | null;
    dev_LoanReq_SnrIntAftConstrMax?: number | null;
    dev_LoanReq_SnrArrAndProfFeesAftConstrMax?: number | null;
    dev_GDV_ArrFee?: number | null;
    dev_GDV_ExitFee?: number | null;
    dev_LTC_ArrFee?: number | null;
    dev_LTC_ExitFee?: number | null;
    dev_GDV_ProfFees?: number | null;
    dev_LTC_ProfFees?: number | null;
    dev_LoanReq_ProfFees?: number | null;
    dev_LoanReq_ExitFee?: number | null;
    dev_LLAvail_BuildLoan?: number | null;
    dev_LLAvail_LandLoan?: number | null;
    dev_LLAvail_Int?: number | null;
    dev_LLAvail_LenderArrFee?: number | null;
    dev_LLAvail_ProfFees?: number | null;
    dev_LLAvail_GrossSnrLoan?: number | null;
    dev_LLAvail_ExitFee?: number | null;
    dev_LTC_TotFundCosts?: number | null;
    dev_GDV_TotFundCosts?: number | null;
    dev_LoanReq_TotFundCosts?: number | null;
    dev_LLAvail_TotFundCosts?: number | null;
    cT_LoanReq_TotLoanCosts?: number | null;
    cT_LoanReq_Profit?: number | null;
    cT_LLAvail_NetLoan?: number | null;
    cT_LLAvail_TotLoanCosts?: number | null;
    cT_LLAvail_EquityReq?: number | null;
    cT_LLAvail_Profit?: number | null;
    cT_LLAvail_ROCE?: number | null;
    dev_LoanReq_LegalFees?: number | null;
    dev_LoanReq_LenderArrFee?: number | null;
    lI_Dev_TotRate?: number | null;
    lI_Dev_ExitFee?: number | null;
    lI_Dev_ArrFeeIncBrokFee?: number | null;
    lI_Dev_ArrFeeBase?: number | null;
    lI_LoanProduct?: ProductTypeEnum;
    lI_Dev_MaxLTGDV?: number | null;
    lI_Dev_MaxLTC?: number | null;
    debugstring?: string;
    dev_LandValue?: number | null;
    dev_LandLoanConst_LandLoan?: number | null;
    dev_LandLoanConst_TotNetLoan?: number | null;
    dev_LandLoanConst_IntOnTotOtherFees?: number | null;
    dev_TotBuildCostsAdjPlusQSCPV?: number | null;
    dev_LandLoanConst_TBCAandOFBuildTerm?: number | null;
    dev_LandLoanConst_TBCAandOFLoanTerm?: number | null;
    dev_LandLoanConst_IntOnBCAndQS?: number | null;
    dev_LandLoanConst_LandLoanInt?: number | null;
    dev_LandLoanConst_GrossLoanBefArrFee?: number | null;
    dev_LandLoanConst_LegalFees?: number | null;
    dev_LandLoanConst_ArrFee?: number | null;
    dev_LandLoanConst_ArrFeeInt?: number | null;
    dev_LandLoanConst_GrossLoanAftArrFee?: number | null;
    dev_LandLoanConst_ProfFees?: number | null;
    dev_LandLoanConst_LoanInt?: number | null;
    dev_LandLoanConst_ExitFee?: number | null;
    dev_LandLoanConst_BuildLoanPlusQSCPV?: number | null;
    lenderName?: string;
    bnfC_Adjt_IntOnLndLoan?: number | null;
    bnfC_Adj_Tot_forBuilAndQS?: number | null;
    bnfC_Adj_SalPerInt?: number | null;
    bnfC_Adj_ValBefoSalPer?: number | null;
    bnfC_Adj_BuiAndQsperMon?: number | null;
    bnfC_Adj_MonCoved?: number | null;
    bnfC_Adj_FullMonCov?: number | null;
    bnfC_Adj_BuiQSAndInt?: number | null;
    bnfC_Adj_BuildLoan?: number | null;
    bnfC_Adj_Int_on_BuiAnsQs?: number | null;
    bnfC_Adj_Bal?: number | null;
    bnfC_Adj_BalanceAssInt?: number | null;
    bnfC_Adj_PartMonBal?: number | null;
    bnfC_Build?: number | null;
    bnfC_Exit?: number | null;
    bnfC_Gross?: number | null;
    bnfC_Inter?: number | null;
    bnfC_LendFees?: number | null;
    bnfC_ProfFees?: number | null;
    bnfC_TotNet?: number | null;
    finOff_Exit?: number | null;
    bnfC_Land?: number | null;
    dev_LandLoanConst_LenderFees?: number | null;
    d1LLC_LenderFees?: number | null;
    d1LLC_ProfFees?: number | null;
    d1LLC_TotNet?: number | null;
    d1LLC_ExitFee?: number | null;
    d1LLC_Gross?: number | null;
    dev_LoanReq_No_Months_Covered?: number | null;
    dev_LoanReq_Whole_MonthsCovered?: number | null;
    dev_LoanReq_BuildAndQSAndInterest_FullMonths?: number | null;
    dev_LoanReq_PartMonthBuild?: number | null;
    dev_LoanReq_InterestOnPartMonth?: number | null;
    dev_LoanReq_QS_inMonthNotFullyCovered?: number | null;
    dev_LoanReq_BalanceOfBuild?: number | null;
    dev_LoanReq_InterestOnBal_OfBuild?: number | null;
    dev_LoanReq_Interest_InSalesPeriod?: number | null;
    senior_Final_Gross?: number | null;
    senior_Final_Exit?: number | null;
    senior_Final_Total?: number | null;
    senior_Final_ProfFees?: number | null;
    senior_Final_LenderFees?: number | null;
    senior_Final_Interest?: number | null;
    senior_Final_Land?: number | null;
    senior_Final_Build?: number | null;
    mezz_LTC_A?: number | null;
    mezz_LTC_B?: number | null;
    mezz_LTC_QS_Part_Month?: number | null;
    mezz_LTC_QS_Part_Interest?: number | null;
    mezz_LTC_Remain_Mths?: number | null;
    mezz_LTC_QS_on_Rem_mths?: number | null;
    mezz_LTC_Int_OnQS_Rem_Mths?: number | null;
    mezz_LTC_QS_Int_SalsPeriod?: number | null;
    mezz_LTC_OnePlusCiF?: number | null;
    mezz_LTC_C?: number | null;
    mezz_LTC_D?: number | null;
    mezz_LTC_Calac_One?: number | null;
    mezz_LTC_Calc_Two?: number | null;
    mezz_LTC_ML?: number | null;
    mezz_LTC_ML_Int?: number | null;
    mezz_LTC_MQS?: number | null;
    mezz_LTC_MQS_Int?: number | null;
    mezz_LTC_MF?: number | null;
    mezz_LTC_MF_Int?: number | null;
    mezz_LTC_Total?: number | null;
    mezz_GDV?: number | null;
    mezz_GDV_Remaining?: number | null;
    mezz_Lowest_Total?: number | null;
    mezz_Lowest_QS_And_Int?: number | null;
    mezz_Lowest_MF?: number | null;
    mezz_Lowest_MF_Int?: number | null;
    mezz_Lowest_Build_Part_Month?: number | null;
    mezz_Lowest_Build_Part_Month_Int?: number | null;
    mezz_Lowest_Build_Full_Months?: number | null;
    mezz_Lowest_Build_Full_Months_Int?: number | null;
    mezz_Lowest_Remaining?: number | null;
    mezz_Lowest_Land_Loan?: number | null;
    mezz_Lowest_Land_Loan_Int?: number | null;
    lowest_Mezz_Interest?: number | null;
    lowest_Mezz_Total?: number | null;
    lowest_Mezz_Exit?: number | null;
    lowest_Mezz_Gross?: number | null;
    mezz_Equity_Const_Fees?: number | null;
    mezz_Equity_Const_Tot_Sen_Cost?: number | null;
    mezz_Equity_Const_MezzFees?: number | null;
    mezz_Equity_Const_SubTot?: number | null;
    mezz_Equity_Const_SeniorLimit?: number | null;
    mezz_Equity_Const_MezLimit?: number | null;
    mezz_Equity_Const_Adjsted?: number | null;
    mezz_Equity_Calc_Land?: number | null;
    mezz_Equity_Calc_Mezz_Build?: number | null;
    mezz_Equity_Calc_Mezz_BuildInt?: number | null;
    mezz_Equity_Calc_MezzLand?: number | null;
    mezz_Equity_Calc_MezzInt?: number | null;
    mezz_Equity_Calc_TotExcl_Arrangmt?: number | null;
    mezz_Equity_Calc_MezzLender?: number | null;
    mezz_Equity_Calc_MezzLenderInt?: number | null;
    mezz_Equity_Calc_Gross?: number | null;
    mez_Snr_Equity_Const_Int?: number | null;
    mez_Snr_Equity_Const_Total?: number | null;
    mez_Snr_Equity_Const_Exit?: number | null;
    mez_Snr_Equity_Const_Gross?: number | null;
    mezz_Offered_Build?: number | null;
    mezz_Offered_Land?: number | null;
    mezz_Offered_Int?: number | null;
    mezz_Offered_LenderFees?: number | null;
    mezz_Offered_ProfFees?: number | null;
    mezz_Offered_Total?: number | null;
    mezz_Offered_Exit?: number | null;
    mezz_Offered_Gross?: number | null;
    mezz_Build_Offer?: number | null;
    mezz_Land_Offer?: number | null;
    mezz_Int_Offer?: number | null;
    mezz_LenerFees_Offer?: number | null;
    mezz_ProfFees_Offer?: number | null;
    mezz_Gross_Offer?: number | null;
    mezz_Exit_Offer?: number | null;
    mezz_Total_Offer?: number | null;
    lowest_Mezz_Build?: number | null;
    dev_LoanReq_GrossLoanBefArrFee?: number | null;
    senior_Equity_Reqd?: number | null;
    senior_Gross_Profit?: number | null;
    senior_ROCE?: number | null;
    mezz_GrossProfit?: number | null;
    mezz_Equity_Reqd?: number | null;
    mezz_ROCE?: number | null;
    senior_Loan_to_GDV?: number | null;
    senior_Loan_to_LTC?: number | null;
    senior_Final_TotCosts?: number | null;
    senior_Final_Net_Loan?: number | null;
    land_Total_other_Costs?: number | null;
    build_Other_Costs?: number | null;
    contingency_Adjusments?: number | null;
    contingency_Adjusments_Percent?: number | null;
    relevant_MeetsCriteria?: boolean | null;
    calculatedBaseOnMatchingLoan?: boolean;
    relevant_InterestAndFeesForLoanOffered?: number | null;
    dev_LoanReq_BuildInterest_FullMonths?: number | null;
    dev_LoanReq_QSCosts_And_Interest?: number | null;
    dev_LoanReq_QSCosts_Int?: number | null;
    bnfC_Adj_PartMonQS?: number | null;
    bnfC_Adj_PartMonBuil?: number | null;
    loanRqd_Equity_Reqd?: number | null;
    loanRqd_Gross_Profit?: number | null;
    loanRqd_ROCE?: number | null;
    loanRqd_Loan_to_GDV?: number | null;
    loanRqd_Loan_to_LTC?: number | null;
    loanRqd_Final_TotCosts?: number | null;
    loanRqd_Final_Net_Loan?: number | null;
    mezz_OtherPercentFee?: number | null;
    mezz_LenderPlusOtherPercentFee?: number | null;
    mezz_Legals_PercOfOther?: number | null;
    mezz_Legals_interest?: number | null;
    mezz_TotFixFee?: number | null;
    mezz_Lowest_QS?: number | null;
    mezz_Lowest_QS_Int?: number | null;
    mezz_Lowest_MF_Lender?: number | null;
    mezz_Lowest_MF_Legal?: number | null;
    mezz_Lowest_MF_Legal_FixedFeeInt?: number | null;
    mezz_Lowest_MF_Legal_FixedFee?: number | null;
    mezz_Lowest_X?: number | null;
    mezz_Lowest_Bal_SalesPerInt?: number | null;
    mezz_Lowest_Bal_forDistribution?: number | null;
    mezz_Lowest_Calc1_A?: number | null;
    mezz_Lowest_Calc1_B?: number | null;
    mezz_Lowest_Calc1_C?: number | null;
    mezz_Lowest_Calc1_D?: number | null;
    mezz_Lowest_Calc1_E?: number | null;
    mezz_Lowest_Calc1_F?: number | null;
    mezz_Lowest_Calc1_G?: number | null;
    mezz_Lowest_Calc1_H?: number | null;
    mezz_Lowest_Calc1_J?: number | null;
    mezz_Lowest_Calc1_BalForCalc2?: number | null;
    mezz_Lowest_Calc2_A?: number | null;
    mezz_Lowest_Calc2_B?: number | null;
    mezz_Lowest_Calc2_C?: number | null;
    mezz_Lowest_Calc2_D?: number | null;
    mezz_Lowest_Calc2_E?: number | null;
    mezz_Lowest_Calc2_F?: number | null;
    mezz_Lowest_Calc2_G?: number | null;
    mezz_Lowest_Calc2_H?: number | null;
    mezz_Lowest_Calc2_J?: number | null;
    mezz_Lowest_Calc2_K?: number | null;
    mezz_Lowest_Calc2_L?: number | null;
    mezz_Lowest_Calc2_M?: number | null;
    mezz_Lowest_Calc2_N?: number | null;
    mezz_Lowest_Calc2_BalForCalc3?: number | null;
    mezz_Lowest_Calc3_B?: number | null;
    mezz_Lowest_Calc3_A?: number | null;
    mezz_Lowest_Calc3_C?: number | null;
    mezz_Lowest_Calc3_D?: number | null;
    mezz_Lowest_Result_Build?: number | null;
    mezz_Lowest_Result_Interest?: number | null;
    mezz_Lowest_Result_Land?: number | null;
    lowest_Mezz_Land?: number | null;
    lowest_Mezz_Lender_Fees?: number | null;
    lowest_Mezz_Prof_Fees?: number | null;
    mezz_D1LLC_A?: number | null;
    mezz_D1LLC_B?: number | null;
    mezz_D1LLC_C?: number | null;
    mezz_D1LLC_D?: number | null;
    mezz_D1LLC_E?: number | null;
    mezz_D1LLC_F?: number | null;
    mezz_D1LLC_G?: number | null;
    mezz_D1LLC_H?: number | null;
    mezz_D1LLC_J?: number | null;
    mezz_D1LLC_K?: number | null;
    mezz_D1LLC_L?: number | null;
    mezz_D1LLC_M?: number | null;
    mezz_SEC_A?: number | null;
    mezz_SEC_B?: number | null;
    mezz_SEC_C?: number | null;
    mezz_SEC_D?: number | null;
    mezz_SEC_E?: number | null;
    mezz_SEC_F?: number | null;
    mezz_SEC_G?: number | null;
    mezz_SEC_H?: number | null;
    mezz_SEC_J?: number | null;
    mezz_SEC_K?: number | null;
    mezz_SEC_M?: number | null;
    mezz_SEC_N?: number | null;
    mezz_SEC_P?: number | null;
    mezz_SEC_Q?: number | null;
    mezz_SEC_R?: number | null;
    mez_Snr_Equity_Const_Build?: number | null;
    mez_Snr_Equity_Const_Land?: number | null;
    mez_Snr_Equity_Const_Lender_Fee?: number | null;
    mezz_Lowest_Calc1_X?: number | null;
    mezz_Lowest_Remaining_B4SalesPerion?: number | null;
    mez_Snr_Equity_Const_ProfFees?: number | null;
    mezz_D1LLC_P?: number | null;
    mezz_D1LLC_N?: number | null;
    mezz_SEC_T?: number | null;
    mezz_SEC_S?: number | null;
    mezz_SEC_Ja?: number | null;
    mezz_SEC_Jb?: number | null;
    mezz_SEC_Jc?: number | null;
    mezz_SEC_Jd?: number | null;
    mezz_SEC_Je?: number | null;
    loanReq_LandLoanInterest?: number | null;
    senAndMezz_Gross?: number | null;
    senAndMezz_Exit?: number | null;
    senAndMezz_Total?: number | null;
    senAndMezz_Prof?: number | null;
    senAndMezz_Lender?: number | null;
    senAndMezz_Interest?: number | null;
    senAndMezz_Land?: number | null;
    senAndMezz_Build?: number | null;
    qS_Initial_Percent_of_Build?: number | null;
    qS_Initial_Percent_of_Build_Interest?: number | null;
    dev_LegalFee_Perc_of_BuildCosts?: number | null;
    legals_Percent_of_Build_Interest?: number | null;
    dev_TotalLandAdditionalCosts?: number | null;
    dev_TotalBuildAdditionalCosts?: number | null;
    dev_Build_ContingencyPercent?: number | null;
    grossLoan?: number | null;
    netLoan?: number | null;
    loanInterest?: number | null;
    lenderFees?: number | null;
    professionalFees?: number | null;
    id: number;
    seniorProductId?: number;
    mezzProductId?: number | null;
    developmentInputId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_LenderResultUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_LenderResultUpdate[];
}

/** LenderResult without PKs and database generated properties and with all properties optional */
export interface LenderResultUpdateWithoutPKs {
    dev_BuildCostContingencyAdj?: number | null;
    dev_S106CIL?: number | null;
    dev_ProfFeesPlanning?: number | null;
    dev_ProfFeesQS?: number | null;
    dev_MinContAdj?: number | null;
    dev_MaxContAdj?: number | null;
    dev_Marketing?: number | null;
    dev_SDLT?: number | null;
    dev_PurchaseCosts?: number | null;
    dev_ClientSalesPeriod?: number | null;
    dev_SalesPeriodAdj?: number | null;
    dev_CumulativeIntRate?: number | null;
    dev_GDV_MaxLoanAvail?: number | null;
    dev_GDV_LenderArrFeeIncBrokFee?: number | null;
    dev_GDV_ArrFeeIncBrokFeeInt?: number | null;
    dev_GDV_BuildCostPerMonth?: number | null;
    dev_GDV_TotBuildCostOverBuildTermIncInt?: number | null;
    dev_GDV_TotBuildCostOverLoanTermIncInt?: number | null;
    dev_GDV_IntOnBuild?: number | null;
    dev_GDV_LoanRemainPreLenderProfFees?: number | null;
    interestOnFeesAbove?: number | null;
    dev_GDV_FixedProfFeesIncInt?: number | null;
    dev_GDV_LandLoanIncInt?: number | null;
    dev_GDV_LandLoan?: number | null;
    dev_GDV_MonitorQSIncIntOverBuildT?: number | null;
    dev_GDV_MonitorQSOverLoanT?: number | null;
    dev_TotalOtherFees?: number | null;
    dev_TotOtherFeesOverBuildTerm?: number | null;
    dev_TBCAandOFBuildTerm?: number | null;
    dev_TBCAandOFLoanTerm?: number | null;
    dev_TotProjCosts?: number | null;
    dev_QSCostPerVisit?: number | null;
    dev_LTCtoTotProjCosts?: number | null;
    dev_Working1?: number | null;
    dev_LenderIncBrokPlusLegal?: number | null;
    dev_Working3Part2?: number | null;
    dev_Working3Part3?: number | null;
    dev_Working3?: number | null;
    dev_Working2?: number | null;
    dev_LandLoan?: number | null;
    dev_LandLoanInt?: number | null;
    dev_Prf_TotLoanInt?: number | null;
    dev_Prf_ArrFee?: number | null;
    dev_GDV_GrossLoan?: number | null;
    dev_GDV_TotInt?: number | null;
    dev_TotBuildAdjPlusOtherFees?: number | null;
    dev_Prf_TotLoanWOArrFeeIncAFInt?: number | null;
    dev_Prf_ArrFeeIncInterest?: number | null;
    dev_Prf_TotalGrossLoan?: number | null;
    dev_Prf_90PercLTC?: number | null;
    dev_Prf_2PercArrFee?: number | null;
    dev_TotIntLTC?: number | null;
    dev_GrossLoanLTC?: number | null;
    dev_Mez_LTCMezAvailAftMezCosts?: number | null;
    dev_Prf_LenderProfFees?: number | null;
    dev_GDV_LandLoanInt?: number | null;
    dev_EAActlCosts?: number | null;
    dev_SalesLegalActlCosts?: number | null;
    dev_TtlSalesFees?: number | null;
    dev_NDV?: number | null;
    dev_Mez_ArrFeeOnMxPsbNetLoanAftSEC?: number | null;
    dev_ValFee_LandCost?: number | null;
    dev_ValFee_GDV?: number | null;
    dev_QSInitialFeeBuildCosts?: number | null;
    dev_LenderLegalAndQSGrossLoan?: number | null;
    dev_LoanReq_BuildLoan?: number | null;
    dev_LoanReq_LandLoan?: number | null;
    dev_LoanReq_TotNetLoan?: number | null;
    dev_LoanReq_TotOtherFees?: number | null;
    dev_LoanReq_IntOnTotOtherFees?: number | null;
    dev_LoanReq_QSCosts?: number | null;
    dev_LoanReq_BuildLoanPlusQSCPV?: number | null;
    dev_LoanReq_TBCAandOFBuildTerm?: number | null;
    dev_LoanReq_TBCAandOFLoanTerm?: number | null;
    dev_LoanReq_IntOnBCAndQS?: number | null;
    dev_LoanReq_LandLoanInt?: number | null;
    dev_LoanReq_ArrFee?: number | null;
    dev_LoanReq_ArrFeeInt?: number | null;
    dev_LoanReq_GrossLoanAftArrFee?: number | null;
    dev_LoanReq_LenderArrFeeandProfFees?: number | null;
    dev_LoanReq_LoanInt?: number | null;
    dev_LoanReq_GrossLoan?: number | null;
    dev_LoanReq_GrossLoanClientRequest?: number | null;
    dev_LoanReq_EquityShortfallBuildLoan?: number | null;
    dev_LoanReq_Mez_TotOtherFees?: number | null;
    dev_LoanReq_Mez_IntOnTotOtherFees?: number | null;
    dev_Mez_CumulativeIntRate2?: number | null;
    dev_TotalOtherFeesWithDelayedStart?: number | null;
    dev_LTCGrossLoanCorrect?: boolean | null;
    seniorProduct?: ProductUpdateWithoutPKs | null;
    mezzProduct?: ProductUpdateWithoutPKs | null;
    developmentInput?: DevelopmentInputUpdateWithoutPKs | null;
    dev_LoanReq_GrossSnrAftConstrMax?: number | null;
    dev_LoanReq_SnrIntAftConstrMax?: number | null;
    dev_LoanReq_SnrArrAndProfFeesAftConstrMax?: number | null;
    dev_GDV_ArrFee?: number | null;
    dev_GDV_ExitFee?: number | null;
    dev_LTC_ArrFee?: number | null;
    dev_LTC_ExitFee?: number | null;
    dev_GDV_ProfFees?: number | null;
    dev_LTC_ProfFees?: number | null;
    dev_LoanReq_ProfFees?: number | null;
    dev_LoanReq_ExitFee?: number | null;
    dev_LLAvail_BuildLoan?: number | null;
    dev_LLAvail_LandLoan?: number | null;
    dev_LLAvail_Int?: number | null;
    dev_LLAvail_LenderArrFee?: number | null;
    dev_LLAvail_ProfFees?: number | null;
    dev_LLAvail_GrossSnrLoan?: number | null;
    dev_LLAvail_ExitFee?: number | null;
    dev_LTC_TotFundCosts?: number | null;
    dev_GDV_TotFundCosts?: number | null;
    dev_LoanReq_TotFundCosts?: number | null;
    dev_LLAvail_TotFundCosts?: number | null;
    cT_LoanReq_TotLoanCosts?: number | null;
    cT_LoanReq_Profit?: number | null;
    cT_LLAvail_NetLoan?: number | null;
    cT_LLAvail_TotLoanCosts?: number | null;
    cT_LLAvail_EquityReq?: number | null;
    cT_LLAvail_Profit?: number | null;
    cT_LLAvail_ROCE?: number | null;
    dev_LoanReq_LegalFees?: number | null;
    dev_LoanReq_LenderArrFee?: number | null;
    lI_Dev_TotRate?: number | null;
    lI_Dev_ExitFee?: number | null;
    lI_Dev_ArrFeeIncBrokFee?: number | null;
    lI_Dev_ArrFeeBase?: number | null;
    lI_LoanProduct?: ProductTypeEnum;
    lI_Dev_MaxLTGDV?: number | null;
    lI_Dev_MaxLTC?: number | null;
    debugstring?: string;
    dev_LandValue?: number | null;
    dev_LandLoanConst_LandLoan?: number | null;
    dev_LandLoanConst_TotNetLoan?: number | null;
    dev_LandLoanConst_IntOnTotOtherFees?: number | null;
    dev_TotBuildCostsAdjPlusQSCPV?: number | null;
    dev_LandLoanConst_TBCAandOFBuildTerm?: number | null;
    dev_LandLoanConst_TBCAandOFLoanTerm?: number | null;
    dev_LandLoanConst_IntOnBCAndQS?: number | null;
    dev_LandLoanConst_LandLoanInt?: number | null;
    dev_LandLoanConst_GrossLoanBefArrFee?: number | null;
    dev_LandLoanConst_LegalFees?: number | null;
    dev_LandLoanConst_ArrFee?: number | null;
    dev_LandLoanConst_ArrFeeInt?: number | null;
    dev_LandLoanConst_GrossLoanAftArrFee?: number | null;
    dev_LandLoanConst_ProfFees?: number | null;
    dev_LandLoanConst_LoanInt?: number | null;
    dev_LandLoanConst_ExitFee?: number | null;
    dev_LandLoanConst_BuildLoanPlusQSCPV?: number | null;
    lenderName?: string;
    bnfC_Adjt_IntOnLndLoan?: number | null;
    bnfC_Adj_Tot_forBuilAndQS?: number | null;
    bnfC_Adj_SalPerInt?: number | null;
    bnfC_Adj_ValBefoSalPer?: number | null;
    bnfC_Adj_BuiAndQsperMon?: number | null;
    bnfC_Adj_MonCoved?: number | null;
    bnfC_Adj_FullMonCov?: number | null;
    bnfC_Adj_BuiQSAndInt?: number | null;
    bnfC_Adj_BuildLoan?: number | null;
    bnfC_Adj_Int_on_BuiAnsQs?: number | null;
    bnfC_Adj_Bal?: number | null;
    bnfC_Adj_BalanceAssInt?: number | null;
    bnfC_Adj_PartMonBal?: number | null;
    bnfC_Build?: number | null;
    bnfC_Exit?: number | null;
    bnfC_Gross?: number | null;
    bnfC_Inter?: number | null;
    bnfC_LendFees?: number | null;
    bnfC_ProfFees?: number | null;
    bnfC_TotNet?: number | null;
    finOff_Exit?: number | null;
    bnfC_Land?: number | null;
    dev_LandLoanConst_LenderFees?: number | null;
    d1LLC_LenderFees?: number | null;
    d1LLC_ProfFees?: number | null;
    d1LLC_TotNet?: number | null;
    d1LLC_ExitFee?: number | null;
    d1LLC_Gross?: number | null;
    dev_LoanReq_No_Months_Covered?: number | null;
    dev_LoanReq_Whole_MonthsCovered?: number | null;
    dev_LoanReq_BuildAndQSAndInterest_FullMonths?: number | null;
    dev_LoanReq_PartMonthBuild?: number | null;
    dev_LoanReq_InterestOnPartMonth?: number | null;
    dev_LoanReq_QS_inMonthNotFullyCovered?: number | null;
    dev_LoanReq_BalanceOfBuild?: number | null;
    dev_LoanReq_InterestOnBal_OfBuild?: number | null;
    dev_LoanReq_Interest_InSalesPeriod?: number | null;
    senior_Final_Gross?: number | null;
    senior_Final_Exit?: number | null;
    senior_Final_Total?: number | null;
    senior_Final_ProfFees?: number | null;
    senior_Final_LenderFees?: number | null;
    senior_Final_Interest?: number | null;
    senior_Final_Land?: number | null;
    senior_Final_Build?: number | null;
    mezz_LTC_A?: number | null;
    mezz_LTC_B?: number | null;
    mezz_LTC_QS_Part_Month?: number | null;
    mezz_LTC_QS_Part_Interest?: number | null;
    mezz_LTC_Remain_Mths?: number | null;
    mezz_LTC_QS_on_Rem_mths?: number | null;
    mezz_LTC_Int_OnQS_Rem_Mths?: number | null;
    mezz_LTC_QS_Int_SalsPeriod?: number | null;
    mezz_LTC_OnePlusCiF?: number | null;
    mezz_LTC_C?: number | null;
    mezz_LTC_D?: number | null;
    mezz_LTC_Calac_One?: number | null;
    mezz_LTC_Calc_Two?: number | null;
    mezz_LTC_ML?: number | null;
    mezz_LTC_ML_Int?: number | null;
    mezz_LTC_MQS?: number | null;
    mezz_LTC_MQS_Int?: number | null;
    mezz_LTC_MF?: number | null;
    mezz_LTC_MF_Int?: number | null;
    mezz_LTC_Total?: number | null;
    mezz_GDV?: number | null;
    mezz_GDV_Remaining?: number | null;
    mezz_Lowest_Total?: number | null;
    mezz_Lowest_QS_And_Int?: number | null;
    mezz_Lowest_MF?: number | null;
    mezz_Lowest_MF_Int?: number | null;
    mezz_Lowest_Build_Part_Month?: number | null;
    mezz_Lowest_Build_Part_Month_Int?: number | null;
    mezz_Lowest_Build_Full_Months?: number | null;
    mezz_Lowest_Build_Full_Months_Int?: number | null;
    mezz_Lowest_Remaining?: number | null;
    mezz_Lowest_Land_Loan?: number | null;
    mezz_Lowest_Land_Loan_Int?: number | null;
    lowest_Mezz_Interest?: number | null;
    lowest_Mezz_Total?: number | null;
    lowest_Mezz_Exit?: number | null;
    lowest_Mezz_Gross?: number | null;
    mezz_Equity_Const_Fees?: number | null;
    mezz_Equity_Const_Tot_Sen_Cost?: number | null;
    mezz_Equity_Const_MezzFees?: number | null;
    mezz_Equity_Const_SubTot?: number | null;
    mezz_Equity_Const_SeniorLimit?: number | null;
    mezz_Equity_Const_MezLimit?: number | null;
    mezz_Equity_Const_Adjsted?: number | null;
    mezz_Equity_Calc_Land?: number | null;
    mezz_Equity_Calc_Mezz_Build?: number | null;
    mezz_Equity_Calc_Mezz_BuildInt?: number | null;
    mezz_Equity_Calc_MezzLand?: number | null;
    mezz_Equity_Calc_MezzInt?: number | null;
    mezz_Equity_Calc_TotExcl_Arrangmt?: number | null;
    mezz_Equity_Calc_MezzLender?: number | null;
    mezz_Equity_Calc_MezzLenderInt?: number | null;
    mezz_Equity_Calc_Gross?: number | null;
    mez_Snr_Equity_Const_Int?: number | null;
    mez_Snr_Equity_Const_Total?: number | null;
    mez_Snr_Equity_Const_Exit?: number | null;
    mez_Snr_Equity_Const_Gross?: number | null;
    mezz_Offered_Build?: number | null;
    mezz_Offered_Land?: number | null;
    mezz_Offered_Int?: number | null;
    mezz_Offered_LenderFees?: number | null;
    mezz_Offered_ProfFees?: number | null;
    mezz_Offered_Total?: number | null;
    mezz_Offered_Exit?: number | null;
    mezz_Offered_Gross?: number | null;
    mezz_Build_Offer?: number | null;
    mezz_Land_Offer?: number | null;
    mezz_Int_Offer?: number | null;
    mezz_LenerFees_Offer?: number | null;
    mezz_ProfFees_Offer?: number | null;
    mezz_Gross_Offer?: number | null;
    mezz_Exit_Offer?: number | null;
    mezz_Total_Offer?: number | null;
    lowest_Mezz_Build?: number | null;
    dev_LoanReq_GrossLoanBefArrFee?: number | null;
    senior_Equity_Reqd?: number | null;
    senior_Gross_Profit?: number | null;
    senior_ROCE?: number | null;
    mezz_GrossProfit?: number | null;
    mezz_Equity_Reqd?: number | null;
    mezz_ROCE?: number | null;
    senior_Loan_to_GDV?: number | null;
    senior_Loan_to_LTC?: number | null;
    senior_Final_TotCosts?: number | null;
    senior_Final_Net_Loan?: number | null;
    land_Total_other_Costs?: number | null;
    build_Other_Costs?: number | null;
    contingency_Adjusments?: number | null;
    contingency_Adjusments_Percent?: number | null;
    relevant_MeetsCriteria?: boolean | null;
    calculatedBaseOnMatchingLoan?: boolean;
    relevant_InterestAndFeesForLoanOffered?: number | null;
    dev_LoanReq_BuildInterest_FullMonths?: number | null;
    dev_LoanReq_QSCosts_And_Interest?: number | null;
    dev_LoanReq_QSCosts_Int?: number | null;
    bnfC_Adj_PartMonQS?: number | null;
    bnfC_Adj_PartMonBuil?: number | null;
    loanRqd_Equity_Reqd?: number | null;
    loanRqd_Gross_Profit?: number | null;
    loanRqd_ROCE?: number | null;
    loanRqd_Loan_to_GDV?: number | null;
    loanRqd_Loan_to_LTC?: number | null;
    loanRqd_Final_TotCosts?: number | null;
    loanRqd_Final_Net_Loan?: number | null;
    mezz_OtherPercentFee?: number | null;
    mezz_LenderPlusOtherPercentFee?: number | null;
    mezz_Legals_PercOfOther?: number | null;
    mezz_Legals_interest?: number | null;
    mezz_TotFixFee?: number | null;
    mezz_Lowest_QS?: number | null;
    mezz_Lowest_QS_Int?: number | null;
    mezz_Lowest_MF_Lender?: number | null;
    mezz_Lowest_MF_Legal?: number | null;
    mezz_Lowest_MF_Legal_FixedFeeInt?: number | null;
    mezz_Lowest_MF_Legal_FixedFee?: number | null;
    mezz_Lowest_X?: number | null;
    mezz_Lowest_Bal_SalesPerInt?: number | null;
    mezz_Lowest_Bal_forDistribution?: number | null;
    mezz_Lowest_Calc1_A?: number | null;
    mezz_Lowest_Calc1_B?: number | null;
    mezz_Lowest_Calc1_C?: number | null;
    mezz_Lowest_Calc1_D?: number | null;
    mezz_Lowest_Calc1_E?: number | null;
    mezz_Lowest_Calc1_F?: number | null;
    mezz_Lowest_Calc1_G?: number | null;
    mezz_Lowest_Calc1_H?: number | null;
    mezz_Lowest_Calc1_J?: number | null;
    mezz_Lowest_Calc1_BalForCalc2?: number | null;
    mezz_Lowest_Calc2_A?: number | null;
    mezz_Lowest_Calc2_B?: number | null;
    mezz_Lowest_Calc2_C?: number | null;
    mezz_Lowest_Calc2_D?: number | null;
    mezz_Lowest_Calc2_E?: number | null;
    mezz_Lowest_Calc2_F?: number | null;
    mezz_Lowest_Calc2_G?: number | null;
    mezz_Lowest_Calc2_H?: number | null;
    mezz_Lowest_Calc2_J?: number | null;
    mezz_Lowest_Calc2_K?: number | null;
    mezz_Lowest_Calc2_L?: number | null;
    mezz_Lowest_Calc2_M?: number | null;
    mezz_Lowest_Calc2_N?: number | null;
    mezz_Lowest_Calc2_BalForCalc3?: number | null;
    mezz_Lowest_Calc3_B?: number | null;
    mezz_Lowest_Calc3_A?: number | null;
    mezz_Lowest_Calc3_C?: number | null;
    mezz_Lowest_Calc3_D?: number | null;
    mezz_Lowest_Result_Build?: number | null;
    mezz_Lowest_Result_Interest?: number | null;
    mezz_Lowest_Result_Land?: number | null;
    lowest_Mezz_Land?: number | null;
    lowest_Mezz_Lender_Fees?: number | null;
    lowest_Mezz_Prof_Fees?: number | null;
    mezz_D1LLC_A?: number | null;
    mezz_D1LLC_B?: number | null;
    mezz_D1LLC_C?: number | null;
    mezz_D1LLC_D?: number | null;
    mezz_D1LLC_E?: number | null;
    mezz_D1LLC_F?: number | null;
    mezz_D1LLC_G?: number | null;
    mezz_D1LLC_H?: number | null;
    mezz_D1LLC_J?: number | null;
    mezz_D1LLC_K?: number | null;
    mezz_D1LLC_L?: number | null;
    mezz_D1LLC_M?: number | null;
    mezz_SEC_A?: number | null;
    mezz_SEC_B?: number | null;
    mezz_SEC_C?: number | null;
    mezz_SEC_D?: number | null;
    mezz_SEC_E?: number | null;
    mezz_SEC_F?: number | null;
    mezz_SEC_G?: number | null;
    mezz_SEC_H?: number | null;
    mezz_SEC_J?: number | null;
    mezz_SEC_K?: number | null;
    mezz_SEC_M?: number | null;
    mezz_SEC_N?: number | null;
    mezz_SEC_P?: number | null;
    mezz_SEC_Q?: number | null;
    mezz_SEC_R?: number | null;
    mez_Snr_Equity_Const_Build?: number | null;
    mez_Snr_Equity_Const_Land?: number | null;
    mez_Snr_Equity_Const_Lender_Fee?: number | null;
    mezz_Lowest_Calc1_X?: number | null;
    mezz_Lowest_Remaining_B4SalesPerion?: number | null;
    mez_Snr_Equity_Const_ProfFees?: number | null;
    mezz_D1LLC_P?: number | null;
    mezz_D1LLC_N?: number | null;
    mezz_SEC_T?: number | null;
    mezz_SEC_S?: number | null;
    mezz_SEC_Ja?: number | null;
    mezz_SEC_Jb?: number | null;
    mezz_SEC_Jc?: number | null;
    mezz_SEC_Jd?: number | null;
    mezz_SEC_Je?: number | null;
    loanReq_LandLoanInterest?: number | null;
    senAndMezz_Gross?: number | null;
    senAndMezz_Exit?: number | null;
    senAndMezz_Total?: number | null;
    senAndMezz_Prof?: number | null;
    senAndMezz_Lender?: number | null;
    senAndMezz_Interest?: number | null;
    senAndMezz_Land?: number | null;
    senAndMezz_Build?: number | null;
    qS_Initial_Percent_of_Build?: number | null;
    qS_Initial_Percent_of_Build_Interest?: number | null;
    dev_LegalFee_Perc_of_BuildCosts?: number | null;
    legals_Percent_of_Build_Interest?: number | null;
    dev_TotalLandAdditionalCosts?: number | null;
    dev_TotalBuildAdditionalCosts?: number | null;
    dev_Build_ContingencyPercent?: number | null;
    grossLoan?: number | null;
    netLoan?: number | null;
    loanInterest?: number | null;
    lenderFees?: number | null;
    professionalFees?: number | null;
    seniorProductId?: number;
    mezzProductId?: number | null;
    developmentInputId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_LenderResultUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_LenderResultUpdate[];
}

/** Lender with all properties optional except PKs */
export interface LenderUpdate {
    /** Lender Name */
    name?: string;
    lenderGenericName?: string;
    ratingCustomerService?: number | null;
    ratingSpeed?: number | null;
    ratingFlexibility?: number | null;
    ratingUserRating?: number | null;
    products?: ProductUpdate[];
    user?: ApplicationUserUpdateWithoutPKs | null;
    logoURL?: string | null;
    isBank?: boolean | null;
    lenderApplicationUsers?: ApplicationUserUpdate[];
    internalUrl?: string;
    hasLiveMarketSearch?: boolean;
    hasDevelopmentFinanceSearch?: boolean;
    hasBridgingSearch?: boolean;
    hasCommercialSearch?: boolean;
    preferredPackagersText?: string;
    isLenderReferralActive?: boolean;
    usePortalUrl?: boolean;
    portalUrl?: string;
    portalUrlActiveDateTime?: Date | null;
    sendLenderInsightsEmail?: boolean;
    bridgingFamilySnapshot?: string;
    bridgingFamilyAdditionalInfo?: string;
    commercialFamilySnapshot?: string;
    commercialFamilyAdditionalInfo?: string;
    developmentFinanceFamilySnapshot?: string;
    developmentFinanceFamilyAdditionalInfo?: string;
    isConnectLender?: boolean;
    isConnectReferralOnly?: boolean;
    avgResponseTimeDevFinance?: number | null;
    avgResponseTimeBridging?: number | null;
    avgResponseTimeCommercial?: number | null;
    avgResponseTimeOverall?: number | null;
    medianResponseTimeDevFinance?: number | null;
    medianResponseTimeBridging?: number | null;
    medianResponseTimeCommercial?: number | null;
    medianResponseTimeOverall?: number | null;
    isProfessionalServicesEnabled?: boolean;
    id: number;
    userId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_LenderUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_LenderUpdate[];
}

/** Lender without PKs and database generated properties and with all properties optional */
export interface LenderUpdateWithoutPKs {
    /** Lender Name */
    name?: string;
    lenderGenericName?: string;
    ratingCustomerService?: number | null;
    ratingSpeed?: number | null;
    ratingFlexibility?: number | null;
    ratingUserRating?: number | null;
    products?: ProductUpdate[];
    user?: ApplicationUserUpdateWithoutPKs | null;
    logoURL?: string | null;
    isBank?: boolean | null;
    lenderApplicationUsers?: ApplicationUserUpdate[];
    internalUrl?: string;
    hasLiveMarketSearch?: boolean;
    hasDevelopmentFinanceSearch?: boolean;
    hasBridgingSearch?: boolean;
    hasCommercialSearch?: boolean;
    preferredPackagersText?: string;
    isLenderReferralActive?: boolean;
    usePortalUrl?: boolean;
    portalUrl?: string;
    portalUrlActiveDateTime?: Date | null;
    sendLenderInsightsEmail?: boolean;
    bridgingFamilySnapshot?: string;
    bridgingFamilyAdditionalInfo?: string;
    commercialFamilySnapshot?: string;
    commercialFamilyAdditionalInfo?: string;
    developmentFinanceFamilySnapshot?: string;
    developmentFinanceFamilyAdditionalInfo?: string;
    isConnectLender?: boolean;
    isConnectReferralOnly?: boolean;
    avgResponseTimeDevFinance?: number | null;
    avgResponseTimeBridging?: number | null;
    avgResponseTimeCommercial?: number | null;
    avgResponseTimeOverall?: number | null;
    medianResponseTimeDevFinance?: number | null;
    medianResponseTimeBridging?: number | null;
    medianResponseTimeCommercial?: number | null;
    medianResponseTimeOverall?: number | null;
    isProfessionalServicesEnabled?: boolean;
    userId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_LenderUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_LenderUpdate[];
}

export interface LicenseAppPackage {
    /** LicenseMaster */
    licenseMaster?: LicenseMaster;
    appPackage?: AppPackage;
    externalItemRef: string | null;
    externalSubscriptionRef: string | null;
    freeDurationDays: number;
    quantityPaid: number;
    quantityFree: number;
    totalQuantity: number;
    billingFrequency: BillingFrequencyEnum;
    totalPricePerCycle: number;
    authCode: string | null;
    activeFromDate: Date | null;
    activeToDate: Date | null;
    isCustomPriceApplied: boolean;
    status: LicenseMasterStatusEnum;
    pricePerLicense: number;
    invoiceUrl: string | null;
    contractLength: ContractLengthEnum;
    id: number;
    licenseMasterId: number;
    appPackageId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** LicenseAppPackage without database generated properties */
export interface LicenseAppPackageInsert {
    licenseMaster: LicenseMasterInsert | null;
    appPackage: AppPackageInsert | null;
    externalItemRef?: string | null;
    externalSubscriptionRef?: string | null;
    freeDurationDays?: number;
    quantityPaid?: number;
    quantityFree?: number;
    totalQuantity?: number;
    billingFrequency?: BillingFrequencyEnum;
    totalPricePerCycle?: number;
    authCode?: string | null;
    activeFromDate?: Date | null;
    activeToDate?: Date | null;
    isCustomPriceApplied?: boolean;
    status?: LicenseMasterStatusEnum;
    pricePerLicense?: number;
    invoiceUrl?: string | null;
    contractLength?: ContractLengthEnum;
    licenseMasterId: number;
    appPackageId: number;
}

export interface LicenseAppPackagePageWithTotalCountDTO {
    list?: LicenseAppPackage[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** LicenseAppPackage with all properties optional except PKs */
export interface LicenseAppPackageUpdate {
    licenseMaster?: LicenseMasterUpdateWithoutPKs | null;
    appPackage?: AppPackageUpdateWithoutPKs | null;
    externalItemRef?: string | null;
    externalSubscriptionRef?: string | null;
    freeDurationDays?: number;
    quantityPaid?: number;
    quantityFree?: number;
    totalQuantity?: number;
    billingFrequency?: BillingFrequencyEnum;
    totalPricePerCycle?: number;
    authCode?: string | null;
    activeFromDate?: Date | null;
    activeToDate?: Date | null;
    isCustomPriceApplied?: boolean;
    status?: LicenseMasterStatusEnum;
    pricePerLicense?: number;
    invoiceUrl?: string | null;
    contractLength?: ContractLengthEnum;
    id: number;
    licenseMasterId?: number;
    appPackageId?: number;
}

/** LicenseAppPackage without PKs and database generated properties and with all properties optional */
export interface LicenseAppPackageUpdateWithoutPKs {
    licenseMaster?: LicenseMasterUpdateWithoutPKs | null;
    appPackage?: AppPackageUpdateWithoutPKs | null;
    externalItemRef?: string | null;
    externalSubscriptionRef?: string | null;
    freeDurationDays?: number;
    quantityPaid?: number;
    quantityFree?: number;
    totalQuantity?: number;
    billingFrequency?: BillingFrequencyEnum;
    totalPricePerCycle?: number;
    authCode?: string | null;
    activeFromDate?: Date | null;
    activeToDate?: Date | null;
    isCustomPriceApplied?: boolean;
    status?: LicenseMasterStatusEnum;
    pricePerLicense?: number;
    invoiceUrl?: string | null;
    contractLength?: ContractLengthEnum;
    licenseMasterId?: number;
    appPackageId?: number;
}

export interface LicenseDataDTO {
    subscriptionStatus?: LicenseMasterStatusEnum;
    features?: string[] | null;
    hasActiveEnterpriseLicense?: boolean;
}

export interface LicenseMaster {
    externalCustomerId: string;
    paymentEngine: PaymentEngineEnum;
    status: LicenseMasterStatusEnum;
    billingFrequency: BillingFrequencyEnum;
    licenseAppPackages?: LicenseAppPackage[];
    invoiceUrl: string;
    licenseMasters?: ApplicationUser[];
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** LicenseMaster without database generated properties */
export interface LicenseMasterInsert {
    externalCustomerId?: string;
    paymentEngine?: PaymentEngineEnum;
    status?: LicenseMasterStatusEnum;
    billingFrequency?: BillingFrequencyEnum;
    licenseAppPackages?: LicenseAppPackageInsert[];
    invoiceUrl?: string;
    licenseMasters?: ApplicationUserInsert[];
}

export interface LicenseMasterPageWithTotalCountDTO {
    list?: LicenseMaster[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export enum LicenseMasterStatusEnum {
    None = 0,
    PaidUp = 1,
    PayFailure = 2,
    Unpaid = 3,
    Cancelled = 4,
    PreCancel = 5,
    PreSubscription = 6,
    PaymentProcessing = 7,
    Trial = 8,
    Offered = 9,
}

/** LicenseMaster with all properties optional except PKs */
export interface LicenseMasterUpdate {
    externalCustomerId?: string;
    paymentEngine?: PaymentEngineEnum;
    status?: LicenseMasterStatusEnum;
    billingFrequency?: BillingFrequencyEnum;
    licenseAppPackages?: LicenseAppPackageUpdate[];
    invoiceUrl?: string;
    licenseMasters?: ApplicationUserUpdate[];
    id: number;
}

/** LicenseMaster without PKs and database generated properties and with all properties optional */
export interface LicenseMasterUpdateWithoutPKs {
    externalCustomerId?: string;
    paymentEngine?: PaymentEngineEnum;
    status?: LicenseMasterStatusEnum;
    billingFrequency?: BillingFrequencyEnum;
    licenseAppPackages?: LicenseAppPackageUpdate[];
    invoiceUrl?: string;
    licenseMasters?: ApplicationUserUpdate[];
}

export enum LinkTypeEnum {
    Development = 1,
    Bridging = 2,
    AllLoans = 3,
    Commercial = 4,
}

export enum LoanCompletionTypeEnum {
    AsSoonAsPossible = 1,
    JustCheckingMyOptions = 2,
    WithinNextFewWeeks = 3,
    WithinNext2to3Months = 4,
}

export enum LoanInvestmentTypeEnum {
    None = 0,
    Senior = 1,
    Mezzanine = 2,
    Equity = 3,
    StretchedSenior = 4,
    SeniorAndMezzanine = 5,
    DevelopmentExit = 6,
    Bridging = 7,
    Commercial = 8,
}

export enum LoanPurposeEnum {
    Speed = 1,
    DepositForAnotherPurchase = 2,
    Rebridge = 3,
    Other = 4,
    ChainBreak = 5,
    AuctionPurchase = 6,
    Refurbishment = 7,
    AnyOtherLegalPurpose = 8,
}

export enum LoanRepaymentTypeEnum {
    None = 0,
    InterestOnly = 1,
    Repayment = 2,
}

export enum LocationEnum {
    None = 0,
    London = 1,
    NorthWest = 2,
    Midlands = 4,
    EastofEngland = 8,
    SouthEast = 16,
    SouthWest = 32,
    NorthEast = 64,
    Wales = 128,
    Scotland = 256,
    NorthernIreland = 512,
    Any = 1023,
    ChannelIsland = 1024,
}

export interface MakeReferralMessageRequest {
    dealId?: number | null;
    dealName?: string;
}

export enum MaritalStatusEnum {
    None = 0,
    Single = 1,
    Married = 2,
    LivingWithPartner = 3,
    Widowed = 4,
    CivilPartnership = 5,
    Divorced = 6,
    Separated = 7,
}

export interface MarkSectionAsCompleteRequest {
    propertyName?: string;
    dealId?: number;
    productFamily?: ProductFamilyEnum;
}

export interface MarkSectionAsCompleteResponse {
    newDealNote?: DealNote | null;
    bridgingDeal?: BridgingDeal;
    commercialDeal?: CommercialDeal;
    devFinanceDeal?: DevelopmentFinanceDeal;
}

export enum MaxCommercialFloorspaceEnum {
    None = 0,
    Below50 = 1,
    FiftyOneTo75 = 2,
    Above76 = 3,
}

export enum MessageRoleEnum {
    None = 0,
    Admin = 1,
    Broker = 2,
    Lender = 4,
    Client = 8,
}

export enum MezzLegalPercentOfWhatEnum {
    GrossLoan = 1,
}

export enum ModuleEnum {
    CaseOverview = 0,
    DeveloperProfile = 1,
    DevelopmentAppraisal = 2,
    DevelopmentSchedule = 3,
    Planning = 4,
    ProfessionalTeam = 5,
    ComparableProperties = 6,
    Case = 7,
    Track = 8,
    AssetsLiabilities = 9,
    ProofOfIncome = 10,
    ApplicantDetails = 11,
    Images = 12,
    DIP = 13,
    Property = 14,
    BuildCosts = 15,
}

export interface ODataEntitySetInfo {
    typeAnnotation?: ODataTypeAnnotation | null;
    url?: string | null;
    name?: string | null;
    title?: string | null;
}

export interface ODataFunctionImportInfo {
    typeAnnotation?: ODataTypeAnnotation | null;
    url?: string | null;
    name?: string | null;
    title?: string | null;
}

export interface ODataServiceDocument {
    typeAnnotation?: ODataTypeAnnotation | null;
    entitySets?: ODataEntitySetInfo[] | null;
    singletons?: ODataSingletonInfo[] | null;
    functionImports?: ODataFunctionImportInfo[] | null;
}

export interface ODataSingletonInfo {
    typeAnnotation?: ODataTypeAnnotation | null;
    url?: string | null;
    name?: string | null;
    title?: string | null;
}

export interface ODataTypeAnnotation {
    readonly typeName?: string | null;
}

export interface OidcConfigDTO {
    authority: string;
    clientId: string;
    clientSecret?: string | null;
    scopes: string[];
}

export interface Organisation {
    /** Organisation Name */
    name: string;
    organisationType: OrganisationTypeEnum;
    applicationUsers?: ApplicationUser[];
    referredUsers?: ApplicationUser[];
    brokerUsers?: ApplicationUser[];
    companyURL: string;
    fcaNumber: string;
    isNACFBMember: boolean | null;
    location: LocationEnum | null;
    phoneNumber: string;
    logoURL: string;
    tagLine: string;
    planType: PlanTypeEnum | null;
    uniqueRef: string;
    commissionPercent: number | null;
    isWhiteLabelled: boolean;
    showLenderNames: boolean;
    isTrustedToSubmitDirectToLenders: boolean;
    sendEmailsToBorrowers: boolean;
    sendAutomaticEmailsToBorrowers: boolean;
    organisationCode: string;
    signOff: string;
    showLogoInFooter: boolean;
    showCompanyName: boolean;
    showCompanyTagLine: boolean;
    showCompanyPhoneNumber: boolean;
    showSocialMediaLinks: boolean;
    showLinkedInLink: boolean;
    showFacebookLink: boolean;
    showTwitterLink: boolean;
    showYouTubeLink: boolean;
    youTubeUrl: string;
    linkedInUrl: string;
    facebookUrl: string;
    twitterUrl: string;
    showFooterText: boolean;
    footerText: string;
    faviconURL: string;
    organisationTermForApp: string;
    licenseMaster?: LicenseMaster | null;
    isFIBAMember: boolean | null;
    helpdeskEmail: string;
    isBrickflow: boolean;
    isOnFreeTrial: boolean;
    widgetCompanyURL: string;
    hasWhiteLabelAddOnPaid: boolean;
    teamSize: TeamSizeEnum;
    isLegacyLicense: boolean;
    hasBridging: boolean;
    testimonialCustomerDetails: string;
    testimonialText: string;
    testimonialCustomerImageUrl: string;
    hasCommercialMortgage: boolean;
    preferredPackagerEmail: string;
    hasHubspotIntegration: boolean;
    hubspotPipelineStage: string;
    hasWidget: boolean;
    isDeallockerIntegrationEnabled: boolean;
    isPoweredByBrickflowHidden: boolean;
    organisationThemeColour: string;
    brokerNetworks: BrokerNetworkEnum | null;
    crMs: CRMEnum | null;
    isConnectMember: boolean;
    isProfessionalServicesEnabled: boolean;
    id: number;
    licenseMasterId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_Organisation[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_Organisation[];
}

export interface OrganisationAndBrokerDetailsMessage {
    organisation?: Organisation;
    broker?: ApplicationUser;
}

/** Organisation without database generated properties */
export interface OrganisationInsert {
    /** Organisation Name */
    name?: string;
    organisationType?: OrganisationTypeEnum;
    applicationUsers?: ApplicationUserInsert[];
    referredUsers?: ApplicationUserInsert[];
    brokerUsers?: ApplicationUserInsert[];
    companyURL?: string;
    fcaNumber?: string;
    isNACFBMember?: boolean | null;
    location?: LocationEnum | null;
    phoneNumber?: string;
    logoURL?: string;
    tagLine?: string;
    planType?: PlanTypeEnum | null;
    uniqueRef?: string;
    commissionPercent?: number | null;
    isWhiteLabelled?: boolean;
    showLenderNames?: boolean;
    isTrustedToSubmitDirectToLenders?: boolean;
    sendEmailsToBorrowers?: boolean;
    sendAutomaticEmailsToBorrowers?: boolean;
    organisationCode?: string;
    signOff?: string;
    showLogoInFooter?: boolean;
    showCompanyName?: boolean;
    showCompanyTagLine?: boolean;
    showCompanyPhoneNumber?: boolean;
    showSocialMediaLinks?: boolean;
    showLinkedInLink?: boolean;
    showFacebookLink?: boolean;
    showTwitterLink?: boolean;
    showYouTubeLink?: boolean;
    youTubeUrl?: string;
    linkedInUrl?: string;
    facebookUrl?: string;
    twitterUrl?: string;
    showFooterText?: boolean;
    footerText?: string;
    faviconURL?: string;
    organisationTermForApp?: string;
    licenseMaster?: LicenseMasterInsert | null;
    isFIBAMember?: boolean | null;
    helpdeskEmail?: string;
    isBrickflow?: boolean;
    isOnFreeTrial?: boolean;
    widgetCompanyURL?: string;
    hasWhiteLabelAddOnPaid?: boolean;
    teamSize?: TeamSizeEnum;
    isLegacyLicense?: boolean;
    hasBridging?: boolean;
    testimonialCustomerDetails?: string;
    testimonialText?: string;
    testimonialCustomerImageUrl?: string;
    hasCommercialMortgage?: boolean;
    preferredPackagerEmail?: string;
    hasHubspotIntegration?: boolean;
    hubspotAccessToken?: string | null;
    hubspotPipelineStage?: string;
    hasWidget?: boolean;
    isDeallockerIntegrationEnabled?: boolean;
    isPoweredByBrickflowHidden?: boolean;
    organisationThemeColour?: string;
    brokerNetworks?: BrokerNetworkEnum | null;
    crMs?: CRMEnum | null;
    isConnectMember?: boolean;
    isProfessionalServicesEnabled?: boolean;
    licenseMasterId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_OrganisationInsert[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_OrganisationInsert[];
}

export interface OrganisationLink {
    organisation?: Organisation;
    linkName: string;
    logoUrl: string;
    linkDescription: string;
    linkType: LinkTypeEnum;
    uniqueId: string;
    isEnabled: boolean;
    isHidden: boolean;
    triggerCount: number | null;
    contactRegisteredCount: number | null;
    searchDoneCount: number | null;
    userRegisteredCount: number | null;
    abandonedSearchesCount: number | null;
    brokerUser?: ApplicationUser | null;
    id: number;
    organisationId: number;
    brokerUserId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** OrganisationLink without database generated properties */
export interface OrganisationLinkInsert {
    organisation: OrganisationInsert | null;
    linkName: string;
    logoUrl?: string;
    linkDescription?: string;
    linkType?: LinkTypeEnum;
    uniqueId?: string;
    isEnabled?: boolean;
    isHidden?: boolean;
    triggerCount?: number | null;
    contactRegisteredCount?: number | null;
    searchDoneCount?: number | null;
    userRegisteredCount?: number | null;
    abandonedSearchesCount?: number | null;
    brokerUser?: ApplicationUserInsert | null;
    organisationId: number;
    brokerUserId?: number | null;
}

export interface OrganisationLinkPageWithTotalCountDTO {
    list?: OrganisationLink[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** OrganisationLink with all properties optional except PKs */
export interface OrganisationLinkUpdate {
    organisation?: OrganisationUpdateWithoutPKs | null;
    linkName?: string;
    logoUrl?: string;
    linkDescription?: string;
    linkType?: LinkTypeEnum;
    uniqueId?: string;
    isEnabled?: boolean;
    isHidden?: boolean;
    triggerCount?: number | null;
    contactRegisteredCount?: number | null;
    searchDoneCount?: number | null;
    userRegisteredCount?: number | null;
    abandonedSearchesCount?: number | null;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    id: number;
    organisationId?: number;
    brokerUserId?: number | null;
}

/** OrganisationLink without PKs and database generated properties and with all properties optional */
export interface OrganisationLinkUpdateWithoutPKs {
    organisation?: OrganisationUpdateWithoutPKs | null;
    linkName?: string;
    logoUrl?: string;
    linkDescription?: string;
    linkType?: LinkTypeEnum;
    uniqueId?: string;
    isEnabled?: boolean;
    isHidden?: boolean;
    triggerCount?: number | null;
    contactRegisteredCount?: number | null;
    searchDoneCount?: number | null;
    userRegisteredCount?: number | null;
    abandonedSearchesCount?: number | null;
    brokerUser?: ApplicationUserUpdateWithoutPKs | null;
    organisationId?: number;
    brokerUserId?: number | null;
}

export interface OrganisationPageWithTotalCountDTO {
    list?: Organisation[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface OrganisationProductAccessMessageResponse {
    hasBridging?: boolean;
    hasCommercial?: boolean;
    isDeallockerIntegrationEnabled?: boolean;
    isConnectMember?: boolean;
    isProfessionalServicesEnabled?: boolean;
}

export enum OrganisationTypeEnum {
    General = 0,
    Broker = 1,
}

/** Organisation with all properties optional except PKs */
export interface OrganisationUpdate {
    /** Organisation Name */
    name?: string;
    organisationType?: OrganisationTypeEnum;
    applicationUsers?: ApplicationUserUpdate[];
    referredUsers?: ApplicationUserUpdate[];
    brokerUsers?: ApplicationUserUpdate[];
    companyURL?: string;
    fcaNumber?: string;
    isNACFBMember?: boolean | null;
    location?: LocationEnum | null;
    phoneNumber?: string;
    logoURL?: string;
    tagLine?: string;
    planType?: PlanTypeEnum | null;
    uniqueRef?: string;
    commissionPercent?: number | null;
    isWhiteLabelled?: boolean;
    showLenderNames?: boolean;
    isTrustedToSubmitDirectToLenders?: boolean;
    sendEmailsToBorrowers?: boolean;
    sendAutomaticEmailsToBorrowers?: boolean;
    organisationCode?: string;
    signOff?: string;
    showLogoInFooter?: boolean;
    showCompanyName?: boolean;
    showCompanyTagLine?: boolean;
    showCompanyPhoneNumber?: boolean;
    showSocialMediaLinks?: boolean;
    showLinkedInLink?: boolean;
    showFacebookLink?: boolean;
    showTwitterLink?: boolean;
    showYouTubeLink?: boolean;
    youTubeUrl?: string;
    linkedInUrl?: string;
    facebookUrl?: string;
    twitterUrl?: string;
    showFooterText?: boolean;
    footerText?: string;
    faviconURL?: string;
    organisationTermForApp?: string;
    licenseMaster?: LicenseMasterUpdateWithoutPKs | null;
    isFIBAMember?: boolean | null;
    helpdeskEmail?: string;
    isBrickflow?: boolean;
    isOnFreeTrial?: boolean;
    widgetCompanyURL?: string;
    hasWhiteLabelAddOnPaid?: boolean;
    teamSize?: TeamSizeEnum;
    isLegacyLicense?: boolean;
    hasBridging?: boolean;
    testimonialCustomerDetails?: string;
    testimonialText?: string;
    testimonialCustomerImageUrl?: string;
    hasCommercialMortgage?: boolean;
    preferredPackagerEmail?: string;
    hasHubspotIntegration?: boolean;
    hubspotAccessToken?: string | null;
    hubspotPipelineStage?: string;
    hasWidget?: boolean;
    isDeallockerIntegrationEnabled?: boolean;
    isPoweredByBrickflowHidden?: boolean;
    organisationThemeColour?: string;
    brokerNetworks?: BrokerNetworkEnum | null;
    crMs?: CRMEnum | null;
    isConnectMember?: boolean;
    isProfessionalServicesEnabled?: boolean;
    id: number;
    licenseMasterId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_OrganisationUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_OrganisationUpdate[];
}

/** Organisation without PKs and database generated properties and with all properties optional */
export interface OrganisationUpdateWithoutPKs {
    /** Organisation Name */
    name?: string;
    organisationType?: OrganisationTypeEnum;
    applicationUsers?: ApplicationUserUpdate[];
    referredUsers?: ApplicationUserUpdate[];
    brokerUsers?: ApplicationUserUpdate[];
    companyURL?: string;
    fcaNumber?: string;
    isNACFBMember?: boolean | null;
    location?: LocationEnum | null;
    phoneNumber?: string;
    logoURL?: string;
    tagLine?: string;
    planType?: PlanTypeEnum | null;
    uniqueRef?: string;
    commissionPercent?: number | null;
    isWhiteLabelled?: boolean;
    showLenderNames?: boolean;
    isTrustedToSubmitDirectToLenders?: boolean;
    sendEmailsToBorrowers?: boolean;
    sendAutomaticEmailsToBorrowers?: boolean;
    organisationCode?: string;
    signOff?: string;
    showLogoInFooter?: boolean;
    showCompanyName?: boolean;
    showCompanyTagLine?: boolean;
    showCompanyPhoneNumber?: boolean;
    showSocialMediaLinks?: boolean;
    showLinkedInLink?: boolean;
    showFacebookLink?: boolean;
    showTwitterLink?: boolean;
    showYouTubeLink?: boolean;
    youTubeUrl?: string;
    linkedInUrl?: string;
    facebookUrl?: string;
    twitterUrl?: string;
    showFooterText?: boolean;
    footerText?: string;
    faviconURL?: string;
    organisationTermForApp?: string;
    licenseMaster?: LicenseMasterUpdateWithoutPKs | null;
    isFIBAMember?: boolean | null;
    helpdeskEmail?: string;
    isBrickflow?: boolean;
    isOnFreeTrial?: boolean;
    widgetCompanyURL?: string;
    hasWhiteLabelAddOnPaid?: boolean;
    teamSize?: TeamSizeEnum;
    isLegacyLicense?: boolean;
    hasBridging?: boolean;
    testimonialCustomerDetails?: string;
    testimonialText?: string;
    testimonialCustomerImageUrl?: string;
    hasCommercialMortgage?: boolean;
    preferredPackagerEmail?: string;
    hasHubspotIntegration?: boolean;
    hubspotAccessToken?: string | null;
    hubspotPipelineStage?: string;
    hasWidget?: boolean;
    isDeallockerIntegrationEnabled?: boolean;
    isPoweredByBrickflowHidden?: boolean;
    organisationThemeColour?: string;
    brokerNetworks?: BrokerNetworkEnum | null;
    crMs?: CRMEnum | null;
    isConnectMember?: boolean;
    isProfessionalServicesEnabled?: boolean;
    licenseMasterId?: number | null;
    ownersApplicationUsers?: DataMultiOwner_ApplicationUser_OrganisationUpdate[];
    ownersApplicationUserGroups?: DataMultiOwner_ApplicationUserGroup_OrganisationUpdate[];
}

export enum OriginatorRoleTypeEnum {
    Unknown = 0,
    Admin = 1,
    Broker = 2,
    Lender = 3,
    Borrower = 4,
}

export enum OwnNewDevelopmentEnum {
    None = 0,
    UKLimitedCompany = 1,
    UKLimitedLiabilityPartnership = 2,
    PersonalNames = 3,
    OverseasLimitedCompany = 4,
    PensionFund = 5,
    Other = 6,
}

export enum OwnOrPurchaseEnum {
    Own = 1,
    Purchasing = 2,
}

export enum OwnerOrEmployeeEnum {
    None = 0,
    Owner = 1,
    Employee = 2,
}

export enum OwnershipRoleEnum {
    None = 0,
    Director = 1,
    Shareholder = 2,
    DirectorAndShareholder = 3,
    Member = 4,
    Partner = 5,
}

export interface PasswordChangeDTO {
    oldPassword: string;
    newPassword: string;
}

export enum PaymentEngineEnum {
    Stripe = 1,
    None = 2,
}

export interface PaymentSessionDTO {
    sessionId?: string;
    sessionUrl?: string;
}

export enum PermissionTypesOnDataEnum {
    None = 1,
    Read = 2,
    Update = 4,
    Delete = 8,
    All = 14,
}

export enum PlanTypeEnum {
    Basic = 0,
    Premium = 1,
}

export enum PlanningPermissionTypeEnum {
    None = 0,
    NoPlanning = 1,
    DetailedPlanning = 2,
    OutlinePlanning = 3,
    NoPlanningRequired = 4,
    PermittedDevelopment = 5,
    NoOutlinePlanning = 6,
    VaryPlanningonExistingBuilding = 7,
    NewPlanningOnAnotherPartOfSite = 8,
    VaryPlanningOnExistingAndNewPlanningOnAnotherPartOfSite = 9,
    NewPlanningApplicationOrDemolishExistingBuilding = 10,
}

export enum PlanningResponsibilityEnum {
    Borrower = 1,
    PreviousOwner = 2,
    SomebodyElse = 3,
    NA = 4,
}

export interface PostalAddress {
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    addressLine4?: string;
    postCode?: string;
}

export interface PostcodeLocation {
    district: string;
    location: LocationEnum;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** PostcodeLocation without database generated properties */
export interface PostcodeLocationInsert {
    district?: string;
    location?: LocationEnum;
}

export interface PostcodeLocationPageWithTotalCountDTO {
    list?: PostcodeLocation[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** PostcodeLocation with all properties optional except PKs */
export interface PostcodeLocationUpdate {
    district?: string;
    location?: LocationEnum;
    id: number;
}

/** PostcodeLocation without PKs and database generated properties and with all properties optional */
export interface PostcodeLocationUpdateWithoutPKs {
    district?: string;
    location?: LocationEnum;
}

export enum PreAgreementEnum {
    None = 0,
    PreLet = 1,
    PreSold = 2,
}

export enum PreviousDevelopmentsEnum {
    None = 0,
    One = 1,
    Two = 2,
    Three = 3,
    FourOrMore = 4,
    OneOrTwo = 5,
    ThreeOrMore = 6,
}

export enum PricingFrequencyEnum {
    Monthly = 1,
    Yearly = 2,
    OneOff = 3,
}

export interface Product {
    productRef: string;
    lenderGenericName: string;
    rates?: ProductRate[];
    /** Lender */
    lender?: Lender;
    /** Product Family(LI_LoanFamily) */
    lI_LoanFamily: ProductFamilyEnum;
    /** Product Type(LI_LoanProduct) */
    lI_LoanProduct: ProductTypeEnum;
    /** Loan Investment Type(LI_LoanType) */
    lI_LoanType: LoanInvestmentTypeEnum;
    /** Location Geography (LI_Geography) */
    lI_Geography: LocationEnum;
    /** Contact Name(LI_Name) */
    lI_Name: string;
    /** Contact Landline(LI_Landline) */
    lI_Landline: string;
    /** Contact Mobile(LI_Mobile) */
    lI_Mobile: string;
    /** Contact Email(LI_Email) */
    lI_Email: string;
    /** Min Loan(LI_MinLoan) */
    lI_MinLoan: number;
    /** Max Loan(LI_MaxLoan) */
    lI_MaxLoan: number;
    /** Charge Type(LI_Charge) */
    lI_Charge: ChargeTypeEnum;
    /** Cost of Funds Type(LI_CoFType) */
    lI_CoFType: CofEnum;
    /** Cost of Funds(LI_CoF) */
    lI_CoF: number;
    /** Lender Margin(LI_Margin) */
    lI_Margin: number;
    /** Total Rate(LI_Dev_TotRate) */
    lI_Dev_TotRate: number;
    /** Personal or Corporate Guarantee(LI_PGorCG) */
    lI_PGorCG: GuaranteeEnum;
    /** Guarantee %(LI_PGorCGpercentage) */
    lI_PGorCGpercentage: number;
    /** Pure Residential(LI_PureResi) */
    lI_PureResi: number;
    /** Mixed Use(LI_MixedUse) */
    lI_MixedUse: number;
    /** Mixed Use % Commercial(LI_MixedUseCommPerc) */
    lI_MixedUseCommPerc: number;
    /** Pre Let Sales(LI_PreLetPreSale) */
    lI_PreLetPreSale: boolean;
    /** HMO(LI_HMO) */
    lI_HMO: number;
    /** Hotels(LI_Hotels) */
    lI_Hotels: number;
    /** Leisure(LI_Leisure) */
    lI_Leisure: number;
    /** Light Industrial(LI_LightIndus) */
    lI_LightIndus: number;
    /** Heavy Industrial(LI_HeavyIndus) */
    lI_HeavyIndus: number;
    /** Care Home(LI_CareHomes) */
    lI_CareHomes: number;
    /** Retirement(LI_Retirement) */
    lI_Retirement: number;
    /** Medical(LI_Medical) */
    lI_Medical: number;
    /** Student(LI_Student) */
    lI_Student: number;
    /** Office(LI_Office) */
    lI_Office: number;
    /** Retail(LI_Retail) */
    lI_Retail: number;
    /** Educational(LI_Educ) */
    lI_Educ: number;
    /** Land Without Planning(LI_LandNoPlan) */
    lI_LandNoPlan: number;
    /** Land With Outline Planning(LI_LandOutlinePlan) */
    lI_LandOutlinePlan: number;
    /** Land With Detailed Planning(LI_LandDetailedPlan) */
    lI_LandDetailedPlan: number;
    /** Will You Lend To An Individual(LI_ClientIndiv) */
    lI_ClientIndiv: YesNoMaybe;
    /** Will You Lend To A Comapany(LI_ClientCo) */
    lI_ClientCo: YesNoMaybe;
    /** Will You Lend To An Offshore Company (LI_OverSeasClient) */
    lI_OverSeasClient: YesNoMaybe;
    /** Will You Lend To A Client Based Overseas(LI_ClientOverseasCo) */
    lI_ClientOverseasCo: YesNoMaybe;
    /** Do you offer Sharia Compliant Loans(LI_ShariaLoan) */
    lI_ShariaLoan: YesNoMaybe;
    /** Will you syndicate loans with other lenders(LI_Syndication) */
    lI_Syndication: YesNoMaybe;
    /** Maximum LTC(Gross Loan)(LI_Dev_MaxLTC) */
    lI_Dev_MaxLTC: number;
    /** Maximum LTGDV(Gross Loan)(LI_Dev_MaxLTGDV) */
    lI_Dev_MaxLTGDV: number;
    /** Minimum Client 'Real' Equity(LI_Dev_MinRealEquity) */
    lI_Dev_MinRealEquity: number;
    /** Do you recognise 'sweat' Equity(LI_Dev_SweatEquity) */
    lI_Dev_SweatEquity: boolean;
    /** Arrangement Fee total (inc a 1% broker fee)(LI_Dev_ArrFeeIncBrokFee) */
    lI_Dev_ArrFeeIncBrokFee: number;
    /** Arrangement Fee (LI_Dev_ArrFeeBase) */
    lI_Dev_ArrFeeBase: number;
    /** Exit Fee(LI_Dev_ExitFee) */
    lI_Dev_ExitFee: number;
    /** Is the exit fee charged as a % of GDV or of the Gross Loan Amount (LI_Dev_ExitFeeGDVOrGrossLoan) */
    lI_Dev_ExitFeeGDVOrGrossLoan: ExitFeeChargedOnEnum;
    /** Do you deduct your arrangement fee from the loan or is it paid separately(LI_Dev_DeductArrFeeOrPaidSeparate) */
    lI_Dev_DeductArrFeeOrPaidSeparate: DeductorPayEnum;
    /** Do you charge an administation or commitment fee(LI_Dev_AdminFee) */
    lI_Dev_AdminFee: boolean;
    /** Administration Fee Amount(LI_Dev_AdminFeeAmount) */
    lI_Dev_AdminFeeAmount: number;
    /** Lender Legal Fees Are They Dedcuted From Gross Loan(LI_Dev_LenderLegalsDeductedFromLoan) */
    lI_Dev_LenderLegalsDeductedFromLoan: boolean;
    /** What Do Your Lawyers Charge(LI_Dev_LegalFees) */
    lI_Dev_LegalFees: number;
    /** Of Land Value / Purchase Price or Loan Amount (LI_LegalFees_Type) */
    lI_LegalFees_Type: LegalFeeTypeEnum;
    /** Quantity Surveyor are these deducted from the gross loan(LI_Dev_QSDeductedFromLoan) */
    lI_Dev_QSDeductedFromLoan: boolean;
    /** What Do Your Quantity Surveyor Charge for the initial assesment(LI_Dev_QSIntialFee) */
    lI_Dev_QSIntialFee: number;
    /** What are the ongoing monitoring costs of your QS(LI_Dev_QSCostPerVisit) */
    lI_Dev_QSCostPerVisit: number;
    /** Of Build Costs or Gross Loan (LI_Dev_QSInitialFeePercOfWhat) */
    lI_Dev_QSInitialFeePercOfWhat: QSChargesOfWhatEnum;
    /** Lender Valuation Estimate(LI_Dev_LenderValEst) */
    lI_Dev_LenderValEst: number;
    /** Of Land Value or GDV(LI_LenderValuation_Type) */
    lI_LenderValuation_Type: ValuationFeeTypeEnum;
    /** Is Interest Added to the Loan or Serviced(LI_Dev_InterestAddedOrServiced) */
    lI_Dev_InterestAddedOrServiced: InterestServicedorRolledEnum;
    /** Minimum Loan Term(LI_Dev_MinTerm) */
    lI_Dev_MinTerm: number;
    /** Maximum Loan Term(LI_Dev_MaxTerm) */
    lI_Dev_MaxTerm: number;
    /** Include SDLT In Total Costs For Projects(LI_Dev_IncludeSDLT) */
    lI_Dev_IncludeSDLT: boolean;
    /** Include Section106 and CIl In Total Costs For Projects(LI_Dev_IncludeS106CIL) */
    lI_Dev_IncludeS106CIL: boolean;
    /** Include Legal Fees and Estate Agency Fees For Acquistion(LI_Dev_IncludeAcquiLegalandEAFees) */
    lI_Dev_IncludeAcquiLegalandEAFees: boolean;
    /** Include planning Architect and Client QS in Costs(LI_Dev_IncludePlanningArchiClientQS) */
    lI_Dev_IncludePlanningArchiClientQS: boolean;
    /** Include Lender Interest In Total Costs For Projects(LI_Dev_IncludeLendInt) */
    lI_Dev_IncludeLendInt: boolean;
    /** Include Lender Arrangement Fee And Broker Fee In Total Costs For Projects (LI_Dev_IncludeArrFeeIncBrokFee) */
    lI_Dev_IncludeArrFeeIncBrokFee: boolean;
    /** Include Lender Exit Fee In Total Costs For Projects(LI_Dev_IncludedLenderExitFee) */
    lI_Dev_IncludedLenderExitFee: boolean;
    /** Include Marketing in Total Costs For Projects(LI_Dev_IncludeMkting) */
    lI_Dev_IncludeMkting: boolean;
    /** Include Estate Agents Fees If property Sold(LI_Dev_IncludeEAFees) */
    lI_Dev_IncludeEAFees: boolean;
    /** Include Other Fees Fixed Value(LI_Dev_IncludedOtherFees) */
    lI_Dev_IncludedOtherFees: boolean;
    /** What is the maximum LTV (net loan) allowed against the land value at completion(LI_Dev_MaxNetLoanAgainstLandValue) */
    lI_Dev_MaxNetLoanAgainstLandValue: number;
    /** For the end units do you have a maximum £ per sq ft cap(LI_Dev_MaxPoundperSqFtCap) */
    lI_Dev_MaxPoundperSqFtCap: number;
    /** Do you have a cap on the value of the individual units at the end of the project(LI_Dev_CapOnIndivUnitVal) */
    lI_Dev_CapOnIndivUnitVal: number;
    /** If you allow Mezzanine Loans which Mezzanine lenders have you worked with(LI_Dev_MezzPartners) */
    lI_Dev_MezzPartners: string;
    /** Will you allow Mezzanine Loans(LI_Dev_AllowMezz) */
    lI_Dev_AllowMezz: boolean;
    /** Do you allow a Contingency in build costs(LI_Dev_Contingency) */
    lI_Dev_Contingency: boolean;
    /** Do you allow a Min Contingency in build costs(LI_Dev_MinContingency) */
    lI_Dev_MinContingency: boolean;
    /** What is the Minimum Contingency %(LI_Dev_MinContingencyPercent) */
    lI_Dev_MinContingencyPercent: number;
    /** Do you have Maximum Contingency for build costs(LI_Dev_MaxContingency) */
    lI_Dev_MaxContingency: boolean;
    /** What is the Maximum Contingency %(LI_Dev_MaxContingencyPercent) */
    lI_Dev_MaxContingencyPercent: number;
    /** Do you have a minimum sales period after the build is completed(LI_Dev_MinSalesPeriod) */
    lI_Dev_MinSalesPeriod: boolean;
    /** What is the Minimum sales Period (Months) (LI_Dev_MinSalesMonths) */
    lI_Dev_MinSalesMonths: number;
    /** Fixed fees(LI_Dev_ProfFixedFees) */
    lI_Dev_ProfFixedFees: number;
    /** Cost of Mez Funds(LI_Dev_Mez_Cof) */
    lI_Dev_Mez_Cof: CofEnum;
    /** Mez Lender Margin(LI_Dev_Mez_Margin) */
    lI_Dev_Mez_Margin: number;
    /** Do you have a starting LTGDV(LI_Dev_Mez_StartLTGDV) */
    lI_Dev_Mez_StartLTGDV: number;
    /** Do you have a starting LTC(LI_Dev_Mez_StartLTC) */
    lI_Dev_Mez_StartLTC: number;
    /** Do you charge a % of profit share(LI_Dev_Mez_ProfShare) */
    lI_Dev_Mez_ProfShare: boolean;
    /** Profit Share %(LI_Dev_Mez_ProfSharePerc) */
    lI_Dev_Mez_ProfSharePerc: number;
    /** Mezz Interest Rate %(LI_Dev_Mez_IntRate) */
    lI_Dev_Mez_IntRate: number;
    /** Mezz Fees %(LI_Dev_Mez_ArrFeeIncBrokFee) */
    lI_Dev_Mez_ArrFeeIncBrokFee: number;
    /** Mezz QS Monitoring Per Month(LI_Dev_Mez_QSCostPerVisit) */
    lI_Dev_Mez_QSCostPerVisit: number;
    /** Mezz Exit %(LI_Dev_Mez_Exit) */
    lI_Dev_Mez_Exit: number;
    /** Mezz GDV %(LI_DevMez_LTGDV) */
    lI_Dev_Mez_LTGDV: number;
    /** Mezz LTC %(LI_Dev_Mez_LTC) */
    lI_Dev_Mez_LTC: number;
    /** Mezz Min Equity %(LI_Dev_Mez_MinEquity) */
    lI_Dev_Mez_MinEquity: number;
    mez_ID: number | null;
    lenderName: string;
    /** Part Month QS(LI_Part_Month_QS) */
    lI_Part_Month_QS: number;
    /** Mez LTC(LI_Calc_Dev_Mez_LTC) */
    lI_Calc_Dev_Mez_LTC: number;
    /** Mezz Legal PercentOfGrossLoan(Mezzz_Legal_PercentOfGrossLoan) */
    lI_Mezz_Legal_PercentOfGrossLoan: number;
    /** Mezz Legal Percent Of What(Mezz_Legal_PercentOfWhat) */
    lI_Mezz_Legal_PercentOfWhat: MezzLegalPercentOfWhatEnum;
    /** Mezz Legal Fixed Fee(Mezzz_Legal_FixedFee) */
    lI_Mezz_Legal_FixedFee: number;
    /** Mezz_D1LLC (Mezz_D1LLC) */
    lI_Mezz_D1LLC: number;
    /** Is enabled? */
    isEnabled: boolean;
    /** Additional Product Info */
    additionalProductInfo: string;
    snapshot: string;
    /** 1st time developer? */
    willLendToFirstTimeDeveloper: YesNoMaybe;
    /** Minimum number of previous developments */
    minNumberOfPreviousDevelopments: number;
    /** % of deposit required from shareholders */
    depositRequiredPerc: number;
    /** Charge on property instead of cash */
    chargeOnProperty: YesNoMaybe;
    /** Basis of interest rate */
    basisOfInterestRate: InterestRateBasis;
    /** Is fixed rate */
    isFixedRate: YesNoMaybe;
    /** Is modular */
    isModular: YesNoMaybe;
    /** Is air rights */
    isAirRights: YesNoMaybe;
    /** Is permitted development scheme */
    isPermittedDevelopmentScheme: YesNoMaybe;
    /** Is listed grade 1 */
    isListedGradeOne: YesNoMaybe;
    /** Is listed grade 2 */
    isListedGradeTwo: YesNoMaybe;
    /** Max sales price for houses */
    maxHouseSalesPrice: number;
    /** Max unit price for flats */
    maxFlatUnitPrice: number;
    /** Max number of units */
    maxNumberOfUnits: number;
    /** Has work commenced */
    isWorkStarted: YesNoMaybe;
    /** For the end flats do you have a maximum £ per sq ft cap(LI_Dev_MaxPoundperSqFtCapFlats) */
    lI_Dev_MaxPoundperSqFtCapFlats: number;
    isReBridgeAllowed: YesNoMaybe;
    isServicedInterestAllowed: YesNoMaybe;
    isTitleInsuranceAllowed: YesNoMaybe;
    isIndemnityInsuranceAllowed: YesNoMaybe;
    isRetypedValuationAllowed: YesNoMaybe;
    lI_MinUnits: number;
    lI_MaxUnitPrice: number;
    lI_BulkMinUnits: number | null;
    lI_BulkMinAverageSalesPrice: number | null;
    lI_BulkLTV: number;
    lI_BulkRate: number;
    lI_LegalFeesFlatRate: number;
    lI_ValuationFeesFlatRate: number;
    maxRefurbLevel: RefurbishmentLevelEnum;
    minOwnershipPeriod: number;
    maxIndividualUnitPrice: number;
    minIndividualUnitPrice: number;
    maxNumberOfBedrooms: number;
    isTimberFrameConstruction: YesNoMaybe;
    isConcreteConstruction: YesNoMaybe;
    acceptableEPCRating: EPCRatingTypeEnum;
    ewS1AcceptableType: EWS1GradeTypeEnum;
    isInterestOnlyAllowed: YesNoMaybe;
    isCapitalAndRepaymentAllowed: YesNoMaybe;
    stressedAnnualRate: number;
    stressedMonthlyRate: number;
    monthlyRate: number;
    allCommercialMixedUse: number;
    mufb: number;
    maxNumberOfMUFBUnits: number;
    repaymentTypes: LoanRepaymentTypeEnum;
    fixedRateTerm: FixedRateTermEnum;
    minYearsLease: number;
    individualICR: number;
    companyICR: number;
    tradingEntity: BorrowingEntityTypeEnum;
    minimumTradingPeriod: number;
    arrangementFeeAdded: YesNoMaybe;
    maxAgeAtEndOfMortgageTerm: number;
    maxAgeAtStartOfMortgageTerm: number;
    postcodeInclusionList: string;
    postcodeExclusionList: string;
    isRegulated: boolean;
    isAdverseCreditAllowed: boolean;
    isBelowMarketValueAllowed: boolean;
    isAutomatedValuationModelAllowed: boolean;
    isAuctionPurchasesAllowed: boolean;
    valuationMethod: ValuationMethodEnum | null;
    lastVerifiedDate: Date | null;
    industryAgriculturalPerc: number;
    industryPubRestaurantPerc: number;
    industryTakeawayRestaurantPerc: number;
    industryBarNightclubPerc: number;
    industryPlaceOfWorshipPerc: number;
    industryEntertainmentVenuePerc: number;
    industryGymLeisureCentrePerc: number;
    industryEquestrianPerc: number;
    industryGolfCoursePerc: number;
    industryChildrensDayNurseryPerc: number;
    industryHolidayParkPerc: number;
    industryThemeParkPerc: number;
    industrySupermarketPerc: number;
    industryMuseumPerc: number;
    industryAirportPerc: number;
    industryTransportHubPerc: number;
    industryExIndustrialSpacePerc: number;
    productSourceType: ProductSourceTypeEnum;
    externalProductId: string | null;
    id: number;
    lenderId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

export enum ProductFamilyEnum {
    None = 0,
    Development = 1,
    Bridging = 2,
    Commercial = 3,
}

/** Product without database generated properties */
export interface ProductInsert {
    productRef?: string;
    lenderGenericName?: string;
    rates?: ProductRateInsert[];
    lender: LenderInsert | null;
    /** Product Family(LI_LoanFamily) */
    lI_LoanFamily?: ProductFamilyEnum;
    /** Product Type(LI_LoanProduct) */
    lI_LoanProduct?: ProductTypeEnum;
    /** Loan Investment Type(LI_LoanType) */
    lI_LoanType?: LoanInvestmentTypeEnum;
    /** Location Geography (LI_Geography) */
    lI_Geography?: LocationEnum;
    /** Contact Name(LI_Name) */
    lI_Name?: string;
    /** Contact Landline(LI_Landline) */
    lI_Landline?: string;
    /** Contact Mobile(LI_Mobile) */
    lI_Mobile?: string;
    /** Contact Email(LI_Email) */
    lI_Email?: string;
    /** Min Loan(LI_MinLoan) */
    lI_MinLoan?: number;
    /** Max Loan(LI_MaxLoan) */
    lI_MaxLoan?: number;
    /** Charge Type(LI_Charge) */
    lI_Charge?: ChargeTypeEnum;
    /** Cost of Funds Type(LI_CoFType) */
    lI_CoFType?: CofEnum;
    /** Cost of Funds(LI_CoF) */
    lI_CoF?: number;
    /** Lender Margin(LI_Margin) */
    lI_Margin?: number;
    /** Total Rate(LI_Dev_TotRate) */
    lI_Dev_TotRate?: number;
    /** Personal or Corporate Guarantee(LI_PGorCG) */
    lI_PGorCG?: GuaranteeEnum;
    /** Guarantee %(LI_PGorCGpercentage) */
    lI_PGorCGpercentage?: number;
    /** Pure Residential(LI_PureResi) */
    lI_PureResi?: number;
    /** Mixed Use(LI_MixedUse) */
    lI_MixedUse?: number;
    /** Mixed Use % Commercial(LI_MixedUseCommPerc) */
    lI_MixedUseCommPerc?: number;
    /** Pre Let Sales(LI_PreLetPreSale) */
    lI_PreLetPreSale?: boolean;
    /** HMO(LI_HMO) */
    lI_HMO?: number;
    /** Hotels(LI_Hotels) */
    lI_Hotels?: number;
    /** Leisure(LI_Leisure) */
    lI_Leisure?: number;
    /** Light Industrial(LI_LightIndus) */
    lI_LightIndus?: number;
    /** Heavy Industrial(LI_HeavyIndus) */
    lI_HeavyIndus?: number;
    /** Care Home(LI_CareHomes) */
    lI_CareHomes?: number;
    /** Retirement(LI_Retirement) */
    lI_Retirement?: number;
    /** Medical(LI_Medical) */
    lI_Medical?: number;
    /** Student(LI_Student) */
    lI_Student?: number;
    /** Office(LI_Office) */
    lI_Office?: number;
    /** Retail(LI_Retail) */
    lI_Retail?: number;
    /** Educational(LI_Educ) */
    lI_Educ?: number;
    /** Land Without Planning(LI_LandNoPlan) */
    lI_LandNoPlan?: number;
    /** Land With Outline Planning(LI_LandOutlinePlan) */
    lI_LandOutlinePlan?: number;
    /** Land With Detailed Planning(LI_LandDetailedPlan) */
    lI_LandDetailedPlan?: number;
    /** Will You Lend To An Individual(LI_ClientIndiv) */
    lI_ClientIndiv?: YesNoMaybe;
    /** Will You Lend To A Comapany(LI_ClientCo) */
    lI_ClientCo?: YesNoMaybe;
    /** Will You Lend To An Offshore Company (LI_OverSeasClient) */
    lI_OverSeasClient?: YesNoMaybe;
    /** Will You Lend To A Client Based Overseas(LI_ClientOverseasCo) */
    lI_ClientOverseasCo?: YesNoMaybe;
    /** Do you offer Sharia Compliant Loans(LI_ShariaLoan) */
    lI_ShariaLoan?: YesNoMaybe;
    /** Will you syndicate loans with other lenders(LI_Syndication) */
    lI_Syndication?: YesNoMaybe;
    /** Maximum LTC(Gross Loan)(LI_Dev_MaxLTC) */
    lI_Dev_MaxLTC?: number;
    /** Maximum LTGDV(Gross Loan)(LI_Dev_MaxLTGDV) */
    lI_Dev_MaxLTGDV?: number;
    /** Minimum Client 'Real' Equity(LI_Dev_MinRealEquity) */
    lI_Dev_MinRealEquity?: number;
    /** Do you recognise 'sweat' Equity(LI_Dev_SweatEquity) */
    lI_Dev_SweatEquity?: boolean;
    /** Arrangement Fee total (inc a 1% broker fee)(LI_Dev_ArrFeeIncBrokFee) */
    lI_Dev_ArrFeeIncBrokFee?: number;
    /** Arrangement Fee (LI_Dev_ArrFeeBase) */
    lI_Dev_ArrFeeBase?: number;
    /** Exit Fee(LI_Dev_ExitFee) */
    lI_Dev_ExitFee?: number;
    /** Is the exit fee charged as a % of GDV or of the Gross Loan Amount (LI_Dev_ExitFeeGDVOrGrossLoan) */
    lI_Dev_ExitFeeGDVOrGrossLoan?: ExitFeeChargedOnEnum;
    /** Do you deduct your arrangement fee from the loan or is it paid separately(LI_Dev_DeductArrFeeOrPaidSeparate) */
    lI_Dev_DeductArrFeeOrPaidSeparate?: DeductorPayEnum;
    /** Do you charge an administation or commitment fee(LI_Dev_AdminFee) */
    lI_Dev_AdminFee?: boolean;
    /** Administration Fee Amount(LI_Dev_AdminFeeAmount) */
    lI_Dev_AdminFeeAmount?: number;
    /** Lender Legal Fees Are They Dedcuted From Gross Loan(LI_Dev_LenderLegalsDeductedFromLoan) */
    lI_Dev_LenderLegalsDeductedFromLoan?: boolean;
    /** What Do Your Lawyers Charge(LI_Dev_LegalFees) */
    lI_Dev_LegalFees?: number;
    /** Of Land Value / Purchase Price or Loan Amount (LI_LegalFees_Type) */
    lI_LegalFees_Type?: LegalFeeTypeEnum;
    /** Quantity Surveyor are these deducted from the gross loan(LI_Dev_QSDeductedFromLoan) */
    lI_Dev_QSDeductedFromLoan?: boolean;
    /** What Do Your Quantity Surveyor Charge for the initial assesment(LI_Dev_QSIntialFee) */
    lI_Dev_QSIntialFee?: number;
    /** What are the ongoing monitoring costs of your QS(LI_Dev_QSCostPerVisit) */
    lI_Dev_QSCostPerVisit?: number;
    /** Of Build Costs or Gross Loan (LI_Dev_QSInitialFeePercOfWhat) */
    lI_Dev_QSInitialFeePercOfWhat?: QSChargesOfWhatEnum;
    /** Lender Valuation Estimate(LI_Dev_LenderValEst) */
    lI_Dev_LenderValEst?: number;
    /** Of Land Value or GDV(LI_LenderValuation_Type) */
    lI_LenderValuation_Type?: ValuationFeeTypeEnum;
    /** Is Interest Added to the Loan or Serviced(LI_Dev_InterestAddedOrServiced) */
    lI_Dev_InterestAddedOrServiced?: InterestServicedorRolledEnum;
    /** Minimum Loan Term(LI_Dev_MinTerm) */
    lI_Dev_MinTerm?: number;
    /** Maximum Loan Term(LI_Dev_MaxTerm) */
    lI_Dev_MaxTerm?: number;
    /** Include SDLT In Total Costs For Projects(LI_Dev_IncludeSDLT) */
    lI_Dev_IncludeSDLT?: boolean;
    /** Include Section106 and CIl In Total Costs For Projects(LI_Dev_IncludeS106CIL) */
    lI_Dev_IncludeS106CIL?: boolean;
    /** Include Legal Fees and Estate Agency Fees For Acquistion(LI_Dev_IncludeAcquiLegalandEAFees) */
    lI_Dev_IncludeAcquiLegalandEAFees?: boolean;
    /** Include planning Architect and Client QS in Costs(LI_Dev_IncludePlanningArchiClientQS) */
    lI_Dev_IncludePlanningArchiClientQS?: boolean;
    /** Include Lender Interest In Total Costs For Projects(LI_Dev_IncludeLendInt) */
    lI_Dev_IncludeLendInt?: boolean;
    /** Include Lender Arrangement Fee And Broker Fee In Total Costs For Projects (LI_Dev_IncludeArrFeeIncBrokFee) */
    lI_Dev_IncludeArrFeeIncBrokFee?: boolean;
    /** Include Lender Exit Fee In Total Costs For Projects(LI_Dev_IncludedLenderExitFee) */
    lI_Dev_IncludedLenderExitFee?: boolean;
    /** Include Marketing in Total Costs For Projects(LI_Dev_IncludeMkting) */
    lI_Dev_IncludeMkting?: boolean;
    /** Include Estate Agents Fees If property Sold(LI_Dev_IncludeEAFees) */
    lI_Dev_IncludeEAFees?: boolean;
    /** Include Other Fees Fixed Value(LI_Dev_IncludedOtherFees) */
    lI_Dev_IncludedOtherFees?: boolean;
    /** What is the maximum LTV (net loan) allowed against the land value at completion(LI_Dev_MaxNetLoanAgainstLandValue) */
    lI_Dev_MaxNetLoanAgainstLandValue?: number;
    /** For the end units do you have a maximum £ per sq ft cap(LI_Dev_MaxPoundperSqFtCap) */
    lI_Dev_MaxPoundperSqFtCap?: number;
    /** Do you have a cap on the value of the individual units at the end of the project(LI_Dev_CapOnIndivUnitVal) */
    lI_Dev_CapOnIndivUnitVal?: number;
    /** If you allow Mezzanine Loans which Mezzanine lenders have you worked with(LI_Dev_MezzPartners) */
    lI_Dev_MezzPartners?: string;
    /** Will you allow Mezzanine Loans(LI_Dev_AllowMezz) */
    lI_Dev_AllowMezz?: boolean;
    /** Do you allow a Contingency in build costs(LI_Dev_Contingency) */
    lI_Dev_Contingency?: boolean;
    /** Do you allow a Min Contingency in build costs(LI_Dev_MinContingency) */
    lI_Dev_MinContingency?: boolean;
    /** What is the Minimum Contingency %(LI_Dev_MinContingencyPercent) */
    lI_Dev_MinContingencyPercent?: number;
    /** Do you have Maximum Contingency for build costs(LI_Dev_MaxContingency) */
    lI_Dev_MaxContingency?: boolean;
    /** What is the Maximum Contingency %(LI_Dev_MaxContingencyPercent) */
    lI_Dev_MaxContingencyPercent?: number;
    /** Do you have a minimum sales period after the build is completed(LI_Dev_MinSalesPeriod) */
    lI_Dev_MinSalesPeriod?: boolean;
    /** What is the Minimum sales Period (Months) (LI_Dev_MinSalesMonths) */
    lI_Dev_MinSalesMonths?: number;
    /** Fixed fees(LI_Dev_ProfFixedFees) */
    lI_Dev_ProfFixedFees?: number;
    /** Cost of Mez Funds(LI_Dev_Mez_Cof) */
    lI_Dev_Mez_Cof?: CofEnum;
    /** Mez Lender Margin(LI_Dev_Mez_Margin) */
    lI_Dev_Mez_Margin?: number;
    /** Do you have a starting LTGDV(LI_Dev_Mez_StartLTGDV) */
    lI_Dev_Mez_StartLTGDV?: number;
    /** Do you have a starting LTC(LI_Dev_Mez_StartLTC) */
    lI_Dev_Mez_StartLTC?: number;
    /** Do you charge a % of profit share(LI_Dev_Mez_ProfShare) */
    lI_Dev_Mez_ProfShare?: boolean;
    /** Profit Share %(LI_Dev_Mez_ProfSharePerc) */
    lI_Dev_Mez_ProfSharePerc?: number;
    /** Mezz Interest Rate %(LI_Dev_Mez_IntRate) */
    lI_Dev_Mez_IntRate?: number;
    /** Mezz Fees %(LI_Dev_Mez_ArrFeeIncBrokFee) */
    lI_Dev_Mez_ArrFeeIncBrokFee?: number;
    /** Mezz QS Monitoring Per Month(LI_Dev_Mez_QSCostPerVisit) */
    lI_Dev_Mez_QSCostPerVisit?: number;
    /** Mezz Exit %(LI_Dev_Mez_Exit) */
    lI_Dev_Mez_Exit?: number;
    /** Mezz GDV %(LI_DevMez_LTGDV) */
    lI_Dev_Mez_LTGDV?: number;
    /** Mezz LTC %(LI_Dev_Mez_LTC) */
    lI_Dev_Mez_LTC?: number;
    /** Mezz Min Equity %(LI_Dev_Mez_MinEquity) */
    lI_Dev_Mez_MinEquity?: number;
    mez_ID?: number | null;
    /** Part Month QS(LI_Part_Month_QS) */
    lI_Part_Month_QS?: number;
    /** Mez LTC(LI_Calc_Dev_Mez_LTC) */
    lI_Calc_Dev_Mez_LTC?: number;
    /** Mezz Legal PercentOfGrossLoan(Mezzz_Legal_PercentOfGrossLoan) */
    lI_Mezz_Legal_PercentOfGrossLoan?: number;
    /** Mezz Legal Percent Of What(Mezz_Legal_PercentOfWhat) */
    lI_Mezz_Legal_PercentOfWhat?: MezzLegalPercentOfWhatEnum;
    /** Mezz Legal Fixed Fee(Mezzz_Legal_FixedFee) */
    lI_Mezz_Legal_FixedFee?: number;
    /** Mezz_D1LLC (Mezz_D1LLC) */
    lI_Mezz_D1LLC?: number;
    /** Is enabled? */
    isEnabled?: boolean;
    /** Additional Product Info */
    additionalProductInfo?: string;
    snapshot?: string;
    /** 1st time developer? */
    willLendToFirstTimeDeveloper?: YesNoMaybe;
    /** Minimum number of previous developments */
    minNumberOfPreviousDevelopments?: number;
    /** % of deposit required from shareholders */
    depositRequiredPerc?: number;
    /** Charge on property instead of cash */
    chargeOnProperty?: YesNoMaybe;
    /** Basis of interest rate */
    basisOfInterestRate?: InterestRateBasis;
    /** Is fixed rate */
    isFixedRate?: YesNoMaybe;
    /** Is modular */
    isModular?: YesNoMaybe;
    /** Is air rights */
    isAirRights?: YesNoMaybe;
    /** Is permitted development scheme */
    isPermittedDevelopmentScheme?: YesNoMaybe;
    /** Is listed grade 1 */
    isListedGradeOne?: YesNoMaybe;
    /** Is listed grade 2 */
    isListedGradeTwo?: YesNoMaybe;
    /** Max sales price for houses */
    maxHouseSalesPrice?: number;
    /** Max unit price for flats */
    maxFlatUnitPrice?: number;
    /** Max number of units */
    maxNumberOfUnits?: number;
    /** Has work commenced */
    isWorkStarted?: YesNoMaybe;
    /** For the end flats do you have a maximum £ per sq ft cap(LI_Dev_MaxPoundperSqFtCapFlats) */
    lI_Dev_MaxPoundperSqFtCapFlats?: number;
    isReBridgeAllowed?: YesNoMaybe;
    isServicedInterestAllowed?: YesNoMaybe;
    isTitleInsuranceAllowed?: YesNoMaybe;
    isIndemnityInsuranceAllowed?: YesNoMaybe;
    isRetypedValuationAllowed?: YesNoMaybe;
    lI_MinUnits?: number;
    lI_MaxUnitPrice?: number;
    lI_BulkMinUnits?: number | null;
    lI_BulkMinAverageSalesPrice?: number | null;
    lI_BulkLTV?: number;
    lI_BulkRate?: number;
    lI_LegalFeesFlatRate?: number;
    lI_ValuationFeesFlatRate?: number;
    maxRefurbLevel?: RefurbishmentLevelEnum;
    minOwnershipPeriod?: number;
    maxIndividualUnitPrice?: number;
    minIndividualUnitPrice?: number;
    maxNumberOfBedrooms?: number;
    isTimberFrameConstruction?: YesNoMaybe;
    isConcreteConstruction?: YesNoMaybe;
    acceptableEPCRating?: EPCRatingTypeEnum;
    ewS1AcceptableType?: EWS1GradeTypeEnum;
    isInterestOnlyAllowed?: YesNoMaybe;
    isCapitalAndRepaymentAllowed?: YesNoMaybe;
    stressedAnnualRate?: number;
    stressedMonthlyRate?: number;
    monthlyRate?: number;
    allCommercialMixedUse?: number;
    mufb?: number;
    maxNumberOfMUFBUnits?: number;
    repaymentTypes?: LoanRepaymentTypeEnum;
    fixedRateTerm?: FixedRateTermEnum;
    minYearsLease?: number;
    individualICR?: number;
    companyICR?: number;
    tradingEntity?: BorrowingEntityTypeEnum;
    minimumTradingPeriod?: number;
    arrangementFeeAdded?: YesNoMaybe;
    maxAgeAtEndOfMortgageTerm?: number;
    maxAgeAtStartOfMortgageTerm?: number;
    postcodeInclusionList?: string;
    postcodeExclusionList?: string;
    isRegulated?: boolean;
    isAdverseCreditAllowed?: boolean;
    isBelowMarketValueAllowed?: boolean;
    isAutomatedValuationModelAllowed?: boolean;
    isAuctionPurchasesAllowed?: boolean;
    valuationMethod?: ValuationMethodEnum | null;
    lastVerifiedDate?: Date | null;
    industryAgriculturalPerc?: number;
    industryPubRestaurantPerc?: number;
    industryTakeawayRestaurantPerc?: number;
    industryBarNightclubPerc?: number;
    industryPlaceOfWorshipPerc?: number;
    industryEntertainmentVenuePerc?: number;
    industryGymLeisureCentrePerc?: number;
    industryEquestrianPerc?: number;
    industryGolfCoursePerc?: number;
    industryChildrensDayNurseryPerc?: number;
    industryHolidayParkPerc?: number;
    industryThemeParkPerc?: number;
    industrySupermarketPerc?: number;
    industryMuseumPerc?: number;
    industryAirportPerc?: number;
    industryTransportHubPerc?: number;
    industryExIndustrialSpacePerc?: number;
    lenderId: number;
}

export interface ProductPageWithTotalCountDTO {
    list?: Product[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface ProductRate {
    lI_LTV: number;
    lI_Rate: number;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** ProductRate without database generated properties */
export interface ProductRateInsert {
    lI_LTV?: number;
    lI_Rate?: number;
}

export interface ProductRatePageWithTotalCountDTO {
    list?: ProductRate[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** ProductRate with all properties optional except PKs */
export interface ProductRateUpdate {
    lI_LTV?: number;
    lI_Rate?: number;
    id: number;
}

/** ProductRate without PKs and database generated properties and with all properties optional */
export interface ProductRateUpdateWithoutPKs {
    lI_LTV?: number;
    lI_Rate?: number;
}

export enum ProductSourceTypeEnum {
    Internal = 0,
    NatWest = 1,
}

export enum ProductTypeEnum {
    None = 0,
    Development = 1,
    BridgingPreconstruction = 2,
    BridgingPurchaseOrRefinance = 4,
    BridgingRefurb = 8,
    BridgingDeveloperExit = 16,
    Bridging = 30,
    CommercialInvestment = 32,
    CommercialOwnerOccupied = 64,
    CommercialAll = 96,
}

/** Product with all properties optional except PKs */
export interface ProductUpdate {
    productRef?: string;
    lenderGenericName?: string;
    rates?: ProductRateUpdate[];
    lender?: LenderUpdateWithoutPKs | null;
    /** Product Family(LI_LoanFamily) */
    lI_LoanFamily?: ProductFamilyEnum;
    /** Product Type(LI_LoanProduct) */
    lI_LoanProduct?: ProductTypeEnum;
    /** Loan Investment Type(LI_LoanType) */
    lI_LoanType?: LoanInvestmentTypeEnum;
    /** Location Geography (LI_Geography) */
    lI_Geography?: LocationEnum;
    /** Contact Name(LI_Name) */
    lI_Name?: string;
    /** Contact Landline(LI_Landline) */
    lI_Landline?: string;
    /** Contact Mobile(LI_Mobile) */
    lI_Mobile?: string;
    /** Contact Email(LI_Email) */
    lI_Email?: string;
    /** Min Loan(LI_MinLoan) */
    lI_MinLoan?: number;
    /** Max Loan(LI_MaxLoan) */
    lI_MaxLoan?: number;
    /** Charge Type(LI_Charge) */
    lI_Charge?: ChargeTypeEnum;
    /** Cost of Funds Type(LI_CoFType) */
    lI_CoFType?: CofEnum;
    /** Cost of Funds(LI_CoF) */
    lI_CoF?: number;
    /** Lender Margin(LI_Margin) */
    lI_Margin?: number;
    /** Total Rate(LI_Dev_TotRate) */
    lI_Dev_TotRate?: number;
    /** Personal or Corporate Guarantee(LI_PGorCG) */
    lI_PGorCG?: GuaranteeEnum;
    /** Guarantee %(LI_PGorCGpercentage) */
    lI_PGorCGpercentage?: number;
    /** Pure Residential(LI_PureResi) */
    lI_PureResi?: number;
    /** Mixed Use(LI_MixedUse) */
    lI_MixedUse?: number;
    /** Mixed Use % Commercial(LI_MixedUseCommPerc) */
    lI_MixedUseCommPerc?: number;
    /** Pre Let Sales(LI_PreLetPreSale) */
    lI_PreLetPreSale?: boolean;
    /** HMO(LI_HMO) */
    lI_HMO?: number;
    /** Hotels(LI_Hotels) */
    lI_Hotels?: number;
    /** Leisure(LI_Leisure) */
    lI_Leisure?: number;
    /** Light Industrial(LI_LightIndus) */
    lI_LightIndus?: number;
    /** Heavy Industrial(LI_HeavyIndus) */
    lI_HeavyIndus?: number;
    /** Care Home(LI_CareHomes) */
    lI_CareHomes?: number;
    /** Retirement(LI_Retirement) */
    lI_Retirement?: number;
    /** Medical(LI_Medical) */
    lI_Medical?: number;
    /** Student(LI_Student) */
    lI_Student?: number;
    /** Office(LI_Office) */
    lI_Office?: number;
    /** Retail(LI_Retail) */
    lI_Retail?: number;
    /** Educational(LI_Educ) */
    lI_Educ?: number;
    /** Land Without Planning(LI_LandNoPlan) */
    lI_LandNoPlan?: number;
    /** Land With Outline Planning(LI_LandOutlinePlan) */
    lI_LandOutlinePlan?: number;
    /** Land With Detailed Planning(LI_LandDetailedPlan) */
    lI_LandDetailedPlan?: number;
    /** Will You Lend To An Individual(LI_ClientIndiv) */
    lI_ClientIndiv?: YesNoMaybe;
    /** Will You Lend To A Comapany(LI_ClientCo) */
    lI_ClientCo?: YesNoMaybe;
    /** Will You Lend To An Offshore Company (LI_OverSeasClient) */
    lI_OverSeasClient?: YesNoMaybe;
    /** Will You Lend To A Client Based Overseas(LI_ClientOverseasCo) */
    lI_ClientOverseasCo?: YesNoMaybe;
    /** Do you offer Sharia Compliant Loans(LI_ShariaLoan) */
    lI_ShariaLoan?: YesNoMaybe;
    /** Will you syndicate loans with other lenders(LI_Syndication) */
    lI_Syndication?: YesNoMaybe;
    /** Maximum LTC(Gross Loan)(LI_Dev_MaxLTC) */
    lI_Dev_MaxLTC?: number;
    /** Maximum LTGDV(Gross Loan)(LI_Dev_MaxLTGDV) */
    lI_Dev_MaxLTGDV?: number;
    /** Minimum Client 'Real' Equity(LI_Dev_MinRealEquity) */
    lI_Dev_MinRealEquity?: number;
    /** Do you recognise 'sweat' Equity(LI_Dev_SweatEquity) */
    lI_Dev_SweatEquity?: boolean;
    /** Arrangement Fee total (inc a 1% broker fee)(LI_Dev_ArrFeeIncBrokFee) */
    lI_Dev_ArrFeeIncBrokFee?: number;
    /** Arrangement Fee (LI_Dev_ArrFeeBase) */
    lI_Dev_ArrFeeBase?: number;
    /** Exit Fee(LI_Dev_ExitFee) */
    lI_Dev_ExitFee?: number;
    /** Is the exit fee charged as a % of GDV or of the Gross Loan Amount (LI_Dev_ExitFeeGDVOrGrossLoan) */
    lI_Dev_ExitFeeGDVOrGrossLoan?: ExitFeeChargedOnEnum;
    /** Do you deduct your arrangement fee from the loan or is it paid separately(LI_Dev_DeductArrFeeOrPaidSeparate) */
    lI_Dev_DeductArrFeeOrPaidSeparate?: DeductorPayEnum;
    /** Do you charge an administation or commitment fee(LI_Dev_AdminFee) */
    lI_Dev_AdminFee?: boolean;
    /** Administration Fee Amount(LI_Dev_AdminFeeAmount) */
    lI_Dev_AdminFeeAmount?: number;
    /** Lender Legal Fees Are They Dedcuted From Gross Loan(LI_Dev_LenderLegalsDeductedFromLoan) */
    lI_Dev_LenderLegalsDeductedFromLoan?: boolean;
    /** What Do Your Lawyers Charge(LI_Dev_LegalFees) */
    lI_Dev_LegalFees?: number;
    /** Of Land Value / Purchase Price or Loan Amount (LI_LegalFees_Type) */
    lI_LegalFees_Type?: LegalFeeTypeEnum;
    /** Quantity Surveyor are these deducted from the gross loan(LI_Dev_QSDeductedFromLoan) */
    lI_Dev_QSDeductedFromLoan?: boolean;
    /** What Do Your Quantity Surveyor Charge for the initial assesment(LI_Dev_QSIntialFee) */
    lI_Dev_QSIntialFee?: number;
    /** What are the ongoing monitoring costs of your QS(LI_Dev_QSCostPerVisit) */
    lI_Dev_QSCostPerVisit?: number;
    /** Of Build Costs or Gross Loan (LI_Dev_QSInitialFeePercOfWhat) */
    lI_Dev_QSInitialFeePercOfWhat?: QSChargesOfWhatEnum;
    /** Lender Valuation Estimate(LI_Dev_LenderValEst) */
    lI_Dev_LenderValEst?: number;
    /** Of Land Value or GDV(LI_LenderValuation_Type) */
    lI_LenderValuation_Type?: ValuationFeeTypeEnum;
    /** Is Interest Added to the Loan or Serviced(LI_Dev_InterestAddedOrServiced) */
    lI_Dev_InterestAddedOrServiced?: InterestServicedorRolledEnum;
    /** Minimum Loan Term(LI_Dev_MinTerm) */
    lI_Dev_MinTerm?: number;
    /** Maximum Loan Term(LI_Dev_MaxTerm) */
    lI_Dev_MaxTerm?: number;
    /** Include SDLT In Total Costs For Projects(LI_Dev_IncludeSDLT) */
    lI_Dev_IncludeSDLT?: boolean;
    /** Include Section106 and CIl In Total Costs For Projects(LI_Dev_IncludeS106CIL) */
    lI_Dev_IncludeS106CIL?: boolean;
    /** Include Legal Fees and Estate Agency Fees For Acquistion(LI_Dev_IncludeAcquiLegalandEAFees) */
    lI_Dev_IncludeAcquiLegalandEAFees?: boolean;
    /** Include planning Architect and Client QS in Costs(LI_Dev_IncludePlanningArchiClientQS) */
    lI_Dev_IncludePlanningArchiClientQS?: boolean;
    /** Include Lender Interest In Total Costs For Projects(LI_Dev_IncludeLendInt) */
    lI_Dev_IncludeLendInt?: boolean;
    /** Include Lender Arrangement Fee And Broker Fee In Total Costs For Projects (LI_Dev_IncludeArrFeeIncBrokFee) */
    lI_Dev_IncludeArrFeeIncBrokFee?: boolean;
    /** Include Lender Exit Fee In Total Costs For Projects(LI_Dev_IncludedLenderExitFee) */
    lI_Dev_IncludedLenderExitFee?: boolean;
    /** Include Marketing in Total Costs For Projects(LI_Dev_IncludeMkting) */
    lI_Dev_IncludeMkting?: boolean;
    /** Include Estate Agents Fees If property Sold(LI_Dev_IncludeEAFees) */
    lI_Dev_IncludeEAFees?: boolean;
    /** Include Other Fees Fixed Value(LI_Dev_IncludedOtherFees) */
    lI_Dev_IncludedOtherFees?: boolean;
    /** What is the maximum LTV (net loan) allowed against the land value at completion(LI_Dev_MaxNetLoanAgainstLandValue) */
    lI_Dev_MaxNetLoanAgainstLandValue?: number;
    /** For the end units do you have a maximum £ per sq ft cap(LI_Dev_MaxPoundperSqFtCap) */
    lI_Dev_MaxPoundperSqFtCap?: number;
    /** Do you have a cap on the value of the individual units at the end of the project(LI_Dev_CapOnIndivUnitVal) */
    lI_Dev_CapOnIndivUnitVal?: number;
    /** If you allow Mezzanine Loans which Mezzanine lenders have you worked with(LI_Dev_MezzPartners) */
    lI_Dev_MezzPartners?: string;
    /** Will you allow Mezzanine Loans(LI_Dev_AllowMezz) */
    lI_Dev_AllowMezz?: boolean;
    /** Do you allow a Contingency in build costs(LI_Dev_Contingency) */
    lI_Dev_Contingency?: boolean;
    /** Do you allow a Min Contingency in build costs(LI_Dev_MinContingency) */
    lI_Dev_MinContingency?: boolean;
    /** What is the Minimum Contingency %(LI_Dev_MinContingencyPercent) */
    lI_Dev_MinContingencyPercent?: number;
    /** Do you have Maximum Contingency for build costs(LI_Dev_MaxContingency) */
    lI_Dev_MaxContingency?: boolean;
    /** What is the Maximum Contingency %(LI_Dev_MaxContingencyPercent) */
    lI_Dev_MaxContingencyPercent?: number;
    /** Do you have a minimum sales period after the build is completed(LI_Dev_MinSalesPeriod) */
    lI_Dev_MinSalesPeriod?: boolean;
    /** What is the Minimum sales Period (Months) (LI_Dev_MinSalesMonths) */
    lI_Dev_MinSalesMonths?: number;
    /** Fixed fees(LI_Dev_ProfFixedFees) */
    lI_Dev_ProfFixedFees?: number;
    /** Cost of Mez Funds(LI_Dev_Mez_Cof) */
    lI_Dev_Mez_Cof?: CofEnum;
    /** Mez Lender Margin(LI_Dev_Mez_Margin) */
    lI_Dev_Mez_Margin?: number;
    /** Do you have a starting LTGDV(LI_Dev_Mez_StartLTGDV) */
    lI_Dev_Mez_StartLTGDV?: number;
    /** Do you have a starting LTC(LI_Dev_Mez_StartLTC) */
    lI_Dev_Mez_StartLTC?: number;
    /** Do you charge a % of profit share(LI_Dev_Mez_ProfShare) */
    lI_Dev_Mez_ProfShare?: boolean;
    /** Profit Share %(LI_Dev_Mez_ProfSharePerc) */
    lI_Dev_Mez_ProfSharePerc?: number;
    /** Mezz Interest Rate %(LI_Dev_Mez_IntRate) */
    lI_Dev_Mez_IntRate?: number;
    /** Mezz Fees %(LI_Dev_Mez_ArrFeeIncBrokFee) */
    lI_Dev_Mez_ArrFeeIncBrokFee?: number;
    /** Mezz QS Monitoring Per Month(LI_Dev_Mez_QSCostPerVisit) */
    lI_Dev_Mez_QSCostPerVisit?: number;
    /** Mezz Exit %(LI_Dev_Mez_Exit) */
    lI_Dev_Mez_Exit?: number;
    /** Mezz GDV %(LI_DevMez_LTGDV) */
    lI_Dev_Mez_LTGDV?: number;
    /** Mezz LTC %(LI_Dev_Mez_LTC) */
    lI_Dev_Mez_LTC?: number;
    /** Mezz Min Equity %(LI_Dev_Mez_MinEquity) */
    lI_Dev_Mez_MinEquity?: number;
    mez_ID?: number | null;
    /** Part Month QS(LI_Part_Month_QS) */
    lI_Part_Month_QS?: number;
    /** Mez LTC(LI_Calc_Dev_Mez_LTC) */
    lI_Calc_Dev_Mez_LTC?: number;
    /** Mezz Legal PercentOfGrossLoan(Mezzz_Legal_PercentOfGrossLoan) */
    lI_Mezz_Legal_PercentOfGrossLoan?: number;
    /** Mezz Legal Percent Of What(Mezz_Legal_PercentOfWhat) */
    lI_Mezz_Legal_PercentOfWhat?: MezzLegalPercentOfWhatEnum;
    /** Mezz Legal Fixed Fee(Mezzz_Legal_FixedFee) */
    lI_Mezz_Legal_FixedFee?: number;
    /** Mezz_D1LLC (Mezz_D1LLC) */
    lI_Mezz_D1LLC?: number;
    /** Is enabled? */
    isEnabled?: boolean;
    /** Additional Product Info */
    additionalProductInfo?: string;
    snapshot?: string;
    /** 1st time developer? */
    willLendToFirstTimeDeveloper?: YesNoMaybe;
    /** Minimum number of previous developments */
    minNumberOfPreviousDevelopments?: number;
    /** % of deposit required from shareholders */
    depositRequiredPerc?: number;
    /** Charge on property instead of cash */
    chargeOnProperty?: YesNoMaybe;
    /** Basis of interest rate */
    basisOfInterestRate?: InterestRateBasis;
    /** Is fixed rate */
    isFixedRate?: YesNoMaybe;
    /** Is modular */
    isModular?: YesNoMaybe;
    /** Is air rights */
    isAirRights?: YesNoMaybe;
    /** Is permitted development scheme */
    isPermittedDevelopmentScheme?: YesNoMaybe;
    /** Is listed grade 1 */
    isListedGradeOne?: YesNoMaybe;
    /** Is listed grade 2 */
    isListedGradeTwo?: YesNoMaybe;
    /** Max sales price for houses */
    maxHouseSalesPrice?: number;
    /** Max unit price for flats */
    maxFlatUnitPrice?: number;
    /** Max number of units */
    maxNumberOfUnits?: number;
    /** Has work commenced */
    isWorkStarted?: YesNoMaybe;
    /** For the end flats do you have a maximum £ per sq ft cap(LI_Dev_MaxPoundperSqFtCapFlats) */
    lI_Dev_MaxPoundperSqFtCapFlats?: number;
    isReBridgeAllowed?: YesNoMaybe;
    isServicedInterestAllowed?: YesNoMaybe;
    isTitleInsuranceAllowed?: YesNoMaybe;
    isIndemnityInsuranceAllowed?: YesNoMaybe;
    isRetypedValuationAllowed?: YesNoMaybe;
    lI_MinUnits?: number;
    lI_MaxUnitPrice?: number;
    lI_BulkMinUnits?: number | null;
    lI_BulkMinAverageSalesPrice?: number | null;
    lI_BulkLTV?: number;
    lI_BulkRate?: number;
    lI_LegalFeesFlatRate?: number;
    lI_ValuationFeesFlatRate?: number;
    maxRefurbLevel?: RefurbishmentLevelEnum;
    minOwnershipPeriod?: number;
    maxIndividualUnitPrice?: number;
    minIndividualUnitPrice?: number;
    maxNumberOfBedrooms?: number;
    isTimberFrameConstruction?: YesNoMaybe;
    isConcreteConstruction?: YesNoMaybe;
    acceptableEPCRating?: EPCRatingTypeEnum;
    ewS1AcceptableType?: EWS1GradeTypeEnum;
    isInterestOnlyAllowed?: YesNoMaybe;
    isCapitalAndRepaymentAllowed?: YesNoMaybe;
    stressedAnnualRate?: number;
    stressedMonthlyRate?: number;
    monthlyRate?: number;
    allCommercialMixedUse?: number;
    mufb?: number;
    maxNumberOfMUFBUnits?: number;
    repaymentTypes?: LoanRepaymentTypeEnum;
    fixedRateTerm?: FixedRateTermEnum;
    minYearsLease?: number;
    individualICR?: number;
    companyICR?: number;
    tradingEntity?: BorrowingEntityTypeEnum;
    minimumTradingPeriod?: number;
    arrangementFeeAdded?: YesNoMaybe;
    maxAgeAtEndOfMortgageTerm?: number;
    maxAgeAtStartOfMortgageTerm?: number;
    postcodeInclusionList?: string;
    postcodeExclusionList?: string;
    isRegulated?: boolean;
    isAdverseCreditAllowed?: boolean;
    isBelowMarketValueAllowed?: boolean;
    isAutomatedValuationModelAllowed?: boolean;
    isAuctionPurchasesAllowed?: boolean;
    valuationMethod?: ValuationMethodEnum | null;
    lastVerifiedDate?: Date | null;
    industryAgriculturalPerc?: number;
    industryPubRestaurantPerc?: number;
    industryTakeawayRestaurantPerc?: number;
    industryBarNightclubPerc?: number;
    industryPlaceOfWorshipPerc?: number;
    industryEntertainmentVenuePerc?: number;
    industryGymLeisureCentrePerc?: number;
    industryEquestrianPerc?: number;
    industryGolfCoursePerc?: number;
    industryChildrensDayNurseryPerc?: number;
    industryHolidayParkPerc?: number;
    industryThemeParkPerc?: number;
    industrySupermarketPerc?: number;
    industryMuseumPerc?: number;
    industryAirportPerc?: number;
    industryTransportHubPerc?: number;
    industryExIndustrialSpacePerc?: number;
    id: number;
    lenderId?: number;
}

/** Product without PKs and database generated properties and with all properties optional */
export interface ProductUpdateWithoutPKs {
    productRef?: string;
    lenderGenericName?: string;
    rates?: ProductRateUpdate[];
    lender?: LenderUpdateWithoutPKs | null;
    /** Product Family(LI_LoanFamily) */
    lI_LoanFamily?: ProductFamilyEnum;
    /** Product Type(LI_LoanProduct) */
    lI_LoanProduct?: ProductTypeEnum;
    /** Loan Investment Type(LI_LoanType) */
    lI_LoanType?: LoanInvestmentTypeEnum;
    /** Location Geography (LI_Geography) */
    lI_Geography?: LocationEnum;
    /** Contact Name(LI_Name) */
    lI_Name?: string;
    /** Contact Landline(LI_Landline) */
    lI_Landline?: string;
    /** Contact Mobile(LI_Mobile) */
    lI_Mobile?: string;
    /** Contact Email(LI_Email) */
    lI_Email?: string;
    /** Min Loan(LI_MinLoan) */
    lI_MinLoan?: number;
    /** Max Loan(LI_MaxLoan) */
    lI_MaxLoan?: number;
    /** Charge Type(LI_Charge) */
    lI_Charge?: ChargeTypeEnum;
    /** Cost of Funds Type(LI_CoFType) */
    lI_CoFType?: CofEnum;
    /** Cost of Funds(LI_CoF) */
    lI_CoF?: number;
    /** Lender Margin(LI_Margin) */
    lI_Margin?: number;
    /** Total Rate(LI_Dev_TotRate) */
    lI_Dev_TotRate?: number;
    /** Personal or Corporate Guarantee(LI_PGorCG) */
    lI_PGorCG?: GuaranteeEnum;
    /** Guarantee %(LI_PGorCGpercentage) */
    lI_PGorCGpercentage?: number;
    /** Pure Residential(LI_PureResi) */
    lI_PureResi?: number;
    /** Mixed Use(LI_MixedUse) */
    lI_MixedUse?: number;
    /** Mixed Use % Commercial(LI_MixedUseCommPerc) */
    lI_MixedUseCommPerc?: number;
    /** Pre Let Sales(LI_PreLetPreSale) */
    lI_PreLetPreSale?: boolean;
    /** HMO(LI_HMO) */
    lI_HMO?: number;
    /** Hotels(LI_Hotels) */
    lI_Hotels?: number;
    /** Leisure(LI_Leisure) */
    lI_Leisure?: number;
    /** Light Industrial(LI_LightIndus) */
    lI_LightIndus?: number;
    /** Heavy Industrial(LI_HeavyIndus) */
    lI_HeavyIndus?: number;
    /** Care Home(LI_CareHomes) */
    lI_CareHomes?: number;
    /** Retirement(LI_Retirement) */
    lI_Retirement?: number;
    /** Medical(LI_Medical) */
    lI_Medical?: number;
    /** Student(LI_Student) */
    lI_Student?: number;
    /** Office(LI_Office) */
    lI_Office?: number;
    /** Retail(LI_Retail) */
    lI_Retail?: number;
    /** Educational(LI_Educ) */
    lI_Educ?: number;
    /** Land Without Planning(LI_LandNoPlan) */
    lI_LandNoPlan?: number;
    /** Land With Outline Planning(LI_LandOutlinePlan) */
    lI_LandOutlinePlan?: number;
    /** Land With Detailed Planning(LI_LandDetailedPlan) */
    lI_LandDetailedPlan?: number;
    /** Will You Lend To An Individual(LI_ClientIndiv) */
    lI_ClientIndiv?: YesNoMaybe;
    /** Will You Lend To A Comapany(LI_ClientCo) */
    lI_ClientCo?: YesNoMaybe;
    /** Will You Lend To An Offshore Company (LI_OverSeasClient) */
    lI_OverSeasClient?: YesNoMaybe;
    /** Will You Lend To A Client Based Overseas(LI_ClientOverseasCo) */
    lI_ClientOverseasCo?: YesNoMaybe;
    /** Do you offer Sharia Compliant Loans(LI_ShariaLoan) */
    lI_ShariaLoan?: YesNoMaybe;
    /** Will you syndicate loans with other lenders(LI_Syndication) */
    lI_Syndication?: YesNoMaybe;
    /** Maximum LTC(Gross Loan)(LI_Dev_MaxLTC) */
    lI_Dev_MaxLTC?: number;
    /** Maximum LTGDV(Gross Loan)(LI_Dev_MaxLTGDV) */
    lI_Dev_MaxLTGDV?: number;
    /** Minimum Client 'Real' Equity(LI_Dev_MinRealEquity) */
    lI_Dev_MinRealEquity?: number;
    /** Do you recognise 'sweat' Equity(LI_Dev_SweatEquity) */
    lI_Dev_SweatEquity?: boolean;
    /** Arrangement Fee total (inc a 1% broker fee)(LI_Dev_ArrFeeIncBrokFee) */
    lI_Dev_ArrFeeIncBrokFee?: number;
    /** Arrangement Fee (LI_Dev_ArrFeeBase) */
    lI_Dev_ArrFeeBase?: number;
    /** Exit Fee(LI_Dev_ExitFee) */
    lI_Dev_ExitFee?: number;
    /** Is the exit fee charged as a % of GDV or of the Gross Loan Amount (LI_Dev_ExitFeeGDVOrGrossLoan) */
    lI_Dev_ExitFeeGDVOrGrossLoan?: ExitFeeChargedOnEnum;
    /** Do you deduct your arrangement fee from the loan or is it paid separately(LI_Dev_DeductArrFeeOrPaidSeparate) */
    lI_Dev_DeductArrFeeOrPaidSeparate?: DeductorPayEnum;
    /** Do you charge an administation or commitment fee(LI_Dev_AdminFee) */
    lI_Dev_AdminFee?: boolean;
    /** Administration Fee Amount(LI_Dev_AdminFeeAmount) */
    lI_Dev_AdminFeeAmount?: number;
    /** Lender Legal Fees Are They Dedcuted From Gross Loan(LI_Dev_LenderLegalsDeductedFromLoan) */
    lI_Dev_LenderLegalsDeductedFromLoan?: boolean;
    /** What Do Your Lawyers Charge(LI_Dev_LegalFees) */
    lI_Dev_LegalFees?: number;
    /** Of Land Value / Purchase Price or Loan Amount (LI_LegalFees_Type) */
    lI_LegalFees_Type?: LegalFeeTypeEnum;
    /** Quantity Surveyor are these deducted from the gross loan(LI_Dev_QSDeductedFromLoan) */
    lI_Dev_QSDeductedFromLoan?: boolean;
    /** What Do Your Quantity Surveyor Charge for the initial assesment(LI_Dev_QSIntialFee) */
    lI_Dev_QSIntialFee?: number;
    /** What are the ongoing monitoring costs of your QS(LI_Dev_QSCostPerVisit) */
    lI_Dev_QSCostPerVisit?: number;
    /** Of Build Costs or Gross Loan (LI_Dev_QSInitialFeePercOfWhat) */
    lI_Dev_QSInitialFeePercOfWhat?: QSChargesOfWhatEnum;
    /** Lender Valuation Estimate(LI_Dev_LenderValEst) */
    lI_Dev_LenderValEst?: number;
    /** Of Land Value or GDV(LI_LenderValuation_Type) */
    lI_LenderValuation_Type?: ValuationFeeTypeEnum;
    /** Is Interest Added to the Loan or Serviced(LI_Dev_InterestAddedOrServiced) */
    lI_Dev_InterestAddedOrServiced?: InterestServicedorRolledEnum;
    /** Minimum Loan Term(LI_Dev_MinTerm) */
    lI_Dev_MinTerm?: number;
    /** Maximum Loan Term(LI_Dev_MaxTerm) */
    lI_Dev_MaxTerm?: number;
    /** Include SDLT In Total Costs For Projects(LI_Dev_IncludeSDLT) */
    lI_Dev_IncludeSDLT?: boolean;
    /** Include Section106 and CIl In Total Costs For Projects(LI_Dev_IncludeS106CIL) */
    lI_Dev_IncludeS106CIL?: boolean;
    /** Include Legal Fees and Estate Agency Fees For Acquistion(LI_Dev_IncludeAcquiLegalandEAFees) */
    lI_Dev_IncludeAcquiLegalandEAFees?: boolean;
    /** Include planning Architect and Client QS in Costs(LI_Dev_IncludePlanningArchiClientQS) */
    lI_Dev_IncludePlanningArchiClientQS?: boolean;
    /** Include Lender Interest In Total Costs For Projects(LI_Dev_IncludeLendInt) */
    lI_Dev_IncludeLendInt?: boolean;
    /** Include Lender Arrangement Fee And Broker Fee In Total Costs For Projects (LI_Dev_IncludeArrFeeIncBrokFee) */
    lI_Dev_IncludeArrFeeIncBrokFee?: boolean;
    /** Include Lender Exit Fee In Total Costs For Projects(LI_Dev_IncludedLenderExitFee) */
    lI_Dev_IncludedLenderExitFee?: boolean;
    /** Include Marketing in Total Costs For Projects(LI_Dev_IncludeMkting) */
    lI_Dev_IncludeMkting?: boolean;
    /** Include Estate Agents Fees If property Sold(LI_Dev_IncludeEAFees) */
    lI_Dev_IncludeEAFees?: boolean;
    /** Include Other Fees Fixed Value(LI_Dev_IncludedOtherFees) */
    lI_Dev_IncludedOtherFees?: boolean;
    /** What is the maximum LTV (net loan) allowed against the land value at completion(LI_Dev_MaxNetLoanAgainstLandValue) */
    lI_Dev_MaxNetLoanAgainstLandValue?: number;
    /** For the end units do you have a maximum £ per sq ft cap(LI_Dev_MaxPoundperSqFtCap) */
    lI_Dev_MaxPoundperSqFtCap?: number;
    /** Do you have a cap on the value of the individual units at the end of the project(LI_Dev_CapOnIndivUnitVal) */
    lI_Dev_CapOnIndivUnitVal?: number;
    /** If you allow Mezzanine Loans which Mezzanine lenders have you worked with(LI_Dev_MezzPartners) */
    lI_Dev_MezzPartners?: string;
    /** Will you allow Mezzanine Loans(LI_Dev_AllowMezz) */
    lI_Dev_AllowMezz?: boolean;
    /** Do you allow a Contingency in build costs(LI_Dev_Contingency) */
    lI_Dev_Contingency?: boolean;
    /** Do you allow a Min Contingency in build costs(LI_Dev_MinContingency) */
    lI_Dev_MinContingency?: boolean;
    /** What is the Minimum Contingency %(LI_Dev_MinContingencyPercent) */
    lI_Dev_MinContingencyPercent?: number;
    /** Do you have Maximum Contingency for build costs(LI_Dev_MaxContingency) */
    lI_Dev_MaxContingency?: boolean;
    /** What is the Maximum Contingency %(LI_Dev_MaxContingencyPercent) */
    lI_Dev_MaxContingencyPercent?: number;
    /** Do you have a minimum sales period after the build is completed(LI_Dev_MinSalesPeriod) */
    lI_Dev_MinSalesPeriod?: boolean;
    /** What is the Minimum sales Period (Months) (LI_Dev_MinSalesMonths) */
    lI_Dev_MinSalesMonths?: number;
    /** Fixed fees(LI_Dev_ProfFixedFees) */
    lI_Dev_ProfFixedFees?: number;
    /** Cost of Mez Funds(LI_Dev_Mez_Cof) */
    lI_Dev_Mez_Cof?: CofEnum;
    /** Mez Lender Margin(LI_Dev_Mez_Margin) */
    lI_Dev_Mez_Margin?: number;
    /** Do you have a starting LTGDV(LI_Dev_Mez_StartLTGDV) */
    lI_Dev_Mez_StartLTGDV?: number;
    /** Do you have a starting LTC(LI_Dev_Mez_StartLTC) */
    lI_Dev_Mez_StartLTC?: number;
    /** Do you charge a % of profit share(LI_Dev_Mez_ProfShare) */
    lI_Dev_Mez_ProfShare?: boolean;
    /** Profit Share %(LI_Dev_Mez_ProfSharePerc) */
    lI_Dev_Mez_ProfSharePerc?: number;
    /** Mezz Interest Rate %(LI_Dev_Mez_IntRate) */
    lI_Dev_Mez_IntRate?: number;
    /** Mezz Fees %(LI_Dev_Mez_ArrFeeIncBrokFee) */
    lI_Dev_Mez_ArrFeeIncBrokFee?: number;
    /** Mezz QS Monitoring Per Month(LI_Dev_Mez_QSCostPerVisit) */
    lI_Dev_Mez_QSCostPerVisit?: number;
    /** Mezz Exit %(LI_Dev_Mez_Exit) */
    lI_Dev_Mez_Exit?: number;
    /** Mezz GDV %(LI_DevMez_LTGDV) */
    lI_Dev_Mez_LTGDV?: number;
    /** Mezz LTC %(LI_Dev_Mez_LTC) */
    lI_Dev_Mez_LTC?: number;
    /** Mezz Min Equity %(LI_Dev_Mez_MinEquity) */
    lI_Dev_Mez_MinEquity?: number;
    mez_ID?: number | null;
    /** Part Month QS(LI_Part_Month_QS) */
    lI_Part_Month_QS?: number;
    /** Mez LTC(LI_Calc_Dev_Mez_LTC) */
    lI_Calc_Dev_Mez_LTC?: number;
    /** Mezz Legal PercentOfGrossLoan(Mezzz_Legal_PercentOfGrossLoan) */
    lI_Mezz_Legal_PercentOfGrossLoan?: number;
    /** Mezz Legal Percent Of What(Mezz_Legal_PercentOfWhat) */
    lI_Mezz_Legal_PercentOfWhat?: MezzLegalPercentOfWhatEnum;
    /** Mezz Legal Fixed Fee(Mezzz_Legal_FixedFee) */
    lI_Mezz_Legal_FixedFee?: number;
    /** Mezz_D1LLC (Mezz_D1LLC) */
    lI_Mezz_D1LLC?: number;
    /** Is enabled? */
    isEnabled?: boolean;
    /** Additional Product Info */
    additionalProductInfo?: string;
    snapshot?: string;
    /** 1st time developer? */
    willLendToFirstTimeDeveloper?: YesNoMaybe;
    /** Minimum number of previous developments */
    minNumberOfPreviousDevelopments?: number;
    /** % of deposit required from shareholders */
    depositRequiredPerc?: number;
    /** Charge on property instead of cash */
    chargeOnProperty?: YesNoMaybe;
    /** Basis of interest rate */
    basisOfInterestRate?: InterestRateBasis;
    /** Is fixed rate */
    isFixedRate?: YesNoMaybe;
    /** Is modular */
    isModular?: YesNoMaybe;
    /** Is air rights */
    isAirRights?: YesNoMaybe;
    /** Is permitted development scheme */
    isPermittedDevelopmentScheme?: YesNoMaybe;
    /** Is listed grade 1 */
    isListedGradeOne?: YesNoMaybe;
    /** Is listed grade 2 */
    isListedGradeTwo?: YesNoMaybe;
    /** Max sales price for houses */
    maxHouseSalesPrice?: number;
    /** Max unit price for flats */
    maxFlatUnitPrice?: number;
    /** Max number of units */
    maxNumberOfUnits?: number;
    /** Has work commenced */
    isWorkStarted?: YesNoMaybe;
    /** For the end flats do you have a maximum £ per sq ft cap(LI_Dev_MaxPoundperSqFtCapFlats) */
    lI_Dev_MaxPoundperSqFtCapFlats?: number;
    isReBridgeAllowed?: YesNoMaybe;
    isServicedInterestAllowed?: YesNoMaybe;
    isTitleInsuranceAllowed?: YesNoMaybe;
    isIndemnityInsuranceAllowed?: YesNoMaybe;
    isRetypedValuationAllowed?: YesNoMaybe;
    lI_MinUnits?: number;
    lI_MaxUnitPrice?: number;
    lI_BulkMinUnits?: number | null;
    lI_BulkMinAverageSalesPrice?: number | null;
    lI_BulkLTV?: number;
    lI_BulkRate?: number;
    lI_LegalFeesFlatRate?: number;
    lI_ValuationFeesFlatRate?: number;
    maxRefurbLevel?: RefurbishmentLevelEnum;
    minOwnershipPeriod?: number;
    maxIndividualUnitPrice?: number;
    minIndividualUnitPrice?: number;
    maxNumberOfBedrooms?: number;
    isTimberFrameConstruction?: YesNoMaybe;
    isConcreteConstruction?: YesNoMaybe;
    acceptableEPCRating?: EPCRatingTypeEnum;
    ewS1AcceptableType?: EWS1GradeTypeEnum;
    isInterestOnlyAllowed?: YesNoMaybe;
    isCapitalAndRepaymentAllowed?: YesNoMaybe;
    stressedAnnualRate?: number;
    stressedMonthlyRate?: number;
    monthlyRate?: number;
    allCommercialMixedUse?: number;
    mufb?: number;
    maxNumberOfMUFBUnits?: number;
    repaymentTypes?: LoanRepaymentTypeEnum;
    fixedRateTerm?: FixedRateTermEnum;
    minYearsLease?: number;
    individualICR?: number;
    companyICR?: number;
    tradingEntity?: BorrowingEntityTypeEnum;
    minimumTradingPeriod?: number;
    arrangementFeeAdded?: YesNoMaybe;
    maxAgeAtEndOfMortgageTerm?: number;
    maxAgeAtStartOfMortgageTerm?: number;
    postcodeInclusionList?: string;
    postcodeExclusionList?: string;
    isRegulated?: boolean;
    isAdverseCreditAllowed?: boolean;
    isBelowMarketValueAllowed?: boolean;
    isAutomatedValuationModelAllowed?: boolean;
    isAuctionPurchasesAllowed?: boolean;
    valuationMethod?: ValuationMethodEnum | null;
    lastVerifiedDate?: Date | null;
    industryAgriculturalPerc?: number;
    industryPubRestaurantPerc?: number;
    industryTakeawayRestaurantPerc?: number;
    industryBarNightclubPerc?: number;
    industryPlaceOfWorshipPerc?: number;
    industryEntertainmentVenuePerc?: number;
    industryGymLeisureCentrePerc?: number;
    industryEquestrianPerc?: number;
    industryGolfCoursePerc?: number;
    industryChildrensDayNurseryPerc?: number;
    industryHolidayParkPerc?: number;
    industryThemeParkPerc?: number;
    industrySupermarketPerc?: number;
    industryMuseumPerc?: number;
    industryAirportPerc?: number;
    industryTransportHubPerc?: number;
    industryExIndustrialSpacePerc?: number;
    lenderId?: number;
}

export enum ProfessionsEnum {
    None = 0,
    Architect = 1,
    Builder = 2,
    Planner = 4,
    ProjectManager = 8,
    EstateAgency = 16,
    PropertySurveyor = 32,
    QuantitySurveyor = 64,
    Carpenter = 128,
    Electrician = 256,
    StructuralEngineer = 512,
}

export interface Profile {
    user?: ApplicationUser | null;
    dealClient?: DealClient | null;
    qualifications?: ProfileQualification[];
    assetLiabilityItems?: ProfileAssetLiabilityItem[];
    profileUsers?: ApplicationUser[];
    /** Date Of Birth */
    dateOfBirth: Date | null;
    /** Developed Property Before */
    developedPropertyBefore: boolean | null;
    /** How many development projects have they completed in there own name */
    developedPropertyBeforeNumber: number | null;
    /** Developed Property Before Estimate of Number or Actual */
    developedPropertyEstimate: boolean | null;
    /** How many residential development projects have they completed */
    developedResidentialPropertyCompletedNumber: number | null;
    /** How many commercial development projects have they completed */
    developedCommercialPropertyCompletedNumber: number | null;
    /** Professions worked in */
    professionsWorkedIn: ProfessionsEnum | null;
    /** # Years worked as architect */
    yearsWorkedInProfessionsListArchitect: number | null;
    /** # Years worked as Builder */
    yearsWorkedInProfessionsListBuilder: number | null;
    /** # Years worked as Carpenter */
    yearsWorkedInProfessionsListCarpenter: number | null;
    /** # Years worked as Electrician */
    yearsWorkedInProfessionsListElectrician: number | null;
    /** # Years worked as Planner */
    yearsWorkedInProfessionsListPlanner: number | null;
    /** # Years worked as Project Manager */
    yearsWorkedInProfessionsListProjectManager: number | null;
    /** # Years worked as Estate Agency */
    yearsWorkedInProfessionsListEstateAgency: number | null;
    /** # Years worked as Property Surveyor */
    yearsWorkedInProfessionsListPropertySurveyor: number | null;
    /** # Years worked as Quantity Surveyor */
    yearsWorkedInProfessionsListQuantitySurveyor: number | null;
    /** # Years worked as Structural Engineer */
    yearsWorkedInProfessionsListStructuralEngineer: number | null;
    /** Professional Qualifications */
    professionalQualifications: string | null;
    /** Skills In Order */
    skillsInOrder: string | null;
    /** Length Of Time Been Developer */
    lengthOfTimeBeenDeveloper: number | null;
    furtherInformation: string | null;
    hasCreditRefused: boolean | null;
    creditRefusedDetail: string | null;
    hasCreditConviction: boolean | null;
    creditConvictionDetails: string | null;
    hasCreditBankrupt: boolean | null;
    creditBankruptDetail: string | null;
    hasCreditCcj: boolean | null;
    creditCcjDetail: string | null;
    hasCreditDefaulted: boolean | null;
    creditDefaultedDetail: string | null;
    hasCreditRepossessed: boolean | null;
    creditRepossessedDetail: string | null;
    hasCreditStepInRightsExercised: boolean | null;
    creditStepInRightsExercisedDetail: string | null;
    hasCreditSanctioned: boolean | null;
    creditSanctionedDetail: string | null;
    hasCreditRelated: boolean | null;
    creditRelatedDetail: string | null;
    hasCreditWelfare: boolean | null;
    creditWelfareDetail: string | null;
    addressHistory: string | null;
    nationality: string | null;
    ukResident: boolean | null;
    visaStatus: string | null;
    yearsInUK: number | null;
    monthsInUK: number | null;
    postalAddress: PostalAddress;
    currentAddressFrom: Date | null;
    employmentStatus: EmploymentEnum | null;
    occupation: string | null;
    yearsInCurrentEmployment: number | null;
    monthsInCurrentEmployment: number | null;
    nameOfEmployer: string | null;
    currentAnnualIncome: number | null;
    hasCreditIvaOrCva: boolean | null;
    hasCreditArrangementWithCreditors: boolean | null;
    hasCreditFamilyResidence: boolean | null;
    homeTelephone: string | null;
    title: string | null;
    titleOption: TitleEnum;
    maritalStatus: MaritalStatusEnum;
    countryOfBirth: string | null;
    countryOfResidence: string | null;
    residentialStatus: ResidencyStatusEnum;
    creditIvaOrCvaDetail: string | null;
    creditArrangementWithCreditorsDetail: string | null;
    creditFamilyResidenceDetail: string | null;
    ukResidenceIssueDate: Date | null;
    previousProperyExperienceDetail: string | null;
    estimatedNetAssetVal: number | null;
    currentEmploymentStartDate: Date | null;
    addressStartDate: Date | null;
    hasUkResidenceFromBirth: boolean;
    trackRecord: string | null;
    id: number;
    userId: number | null;
    dealClientId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

export interface ProfileAssetLiabilityItem {
    profile?: Profile;
    alType: ALTypeEnum;
    alItemType: ALItemTypeEnum;
    description: string;
    value: number;
    startDate: Date | null;
    endDate: Date | null;
    id: number;
    profileId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** ProfileAssetLiabilityItem without database generated properties */
export interface ProfileAssetLiabilityItemInsert {
    profile: ProfileInsert | null;
    alType?: ALTypeEnum;
    alItemType?: ALItemTypeEnum;
    description?: string;
    value?: number;
    startDate?: Date | null;
    endDate?: Date | null;
    profileId: number;
}

export interface ProfileAssetLiabilityItemPageWithTotalCountDTO {
    list?: ProfileAssetLiabilityItem[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** ProfileAssetLiabilityItem with all properties optional except PKs */
export interface ProfileAssetLiabilityItemUpdate {
    profile?: ProfileUpdateWithoutPKs | null;
    alType?: ALTypeEnum;
    alItemType?: ALItemTypeEnum;
    description?: string;
    value?: number;
    startDate?: Date | null;
    endDate?: Date | null;
    id: number;
    profileId?: number;
}

/** ProfileAssetLiabilityItem without PKs and database generated properties and with all properties optional */
export interface ProfileAssetLiabilityItemUpdateWithoutPKs {
    profile?: ProfileUpdateWithoutPKs | null;
    alType?: ALTypeEnum;
    alItemType?: ALItemTypeEnum;
    description?: string;
    value?: number;
    startDate?: Date | null;
    endDate?: Date | null;
    profileId?: number;
}

/** Profile without database generated properties */
export interface ProfileInsert {
    user?: ApplicationUserInsert | null;
    dealClient?: DealClientInsert | null;
    qualifications?: ProfileQualificationInsert[];
    assetLiabilityItems?: ProfileAssetLiabilityItemInsert[];
    profileUsers?: ApplicationUserInsert[];
    /** Date Of Birth */
    dateOfBirth?: Date | null;
    /** Developed Property Before */
    developedPropertyBefore?: boolean | null;
    /** How many development projects have they completed in there own name */
    developedPropertyBeforeNumber?: number | null;
    /** Developed Property Before Estimate of Number or Actual */
    developedPropertyEstimate?: boolean | null;
    /** How many residential development projects have they completed */
    developedResidentialPropertyCompletedNumber?: number | null;
    /** How many commercial development projects have they completed */
    developedCommercialPropertyCompletedNumber?: number | null;
    /** Professions worked in */
    professionsWorkedIn?: ProfessionsEnum | null;
    /** # Years worked as architect */
    yearsWorkedInProfessionsListArchitect?: number | null;
    /** # Years worked as Builder */
    yearsWorkedInProfessionsListBuilder?: number | null;
    /** # Years worked as Carpenter */
    yearsWorkedInProfessionsListCarpenter?: number | null;
    /** # Years worked as Electrician */
    yearsWorkedInProfessionsListElectrician?: number | null;
    /** # Years worked as Planner */
    yearsWorkedInProfessionsListPlanner?: number | null;
    /** # Years worked as Project Manager */
    yearsWorkedInProfessionsListProjectManager?: number | null;
    /** # Years worked as Estate Agency */
    yearsWorkedInProfessionsListEstateAgency?: number | null;
    /** # Years worked as Property Surveyor */
    yearsWorkedInProfessionsListPropertySurveyor?: number | null;
    /** # Years worked as Quantity Surveyor */
    yearsWorkedInProfessionsListQuantitySurveyor?: number | null;
    /** # Years worked as Structural Engineer */
    yearsWorkedInProfessionsListStructuralEngineer?: number | null;
    /** Professional Qualifications */
    professionalQualifications?: string | null;
    /** Skills In Order */
    skillsInOrder?: string | null;
    /** Length Of Time Been Developer */
    lengthOfTimeBeenDeveloper?: number | null;
    furtherInformation?: string | null;
    hasCreditRefused?: boolean | null;
    creditRefusedDetail?: string | null;
    hasCreditConviction?: boolean | null;
    creditConvictionDetails?: string | null;
    hasCreditBankrupt?: boolean | null;
    creditBankruptDetail?: string | null;
    hasCreditCcj?: boolean | null;
    creditCcjDetail?: string | null;
    hasCreditDefaulted?: boolean | null;
    creditDefaultedDetail?: string | null;
    hasCreditRepossessed?: boolean | null;
    creditRepossessedDetail?: string | null;
    hasCreditStepInRightsExercised?: boolean | null;
    creditStepInRightsExercisedDetail?: string | null;
    hasCreditSanctioned?: boolean | null;
    creditSanctionedDetail?: string | null;
    hasCreditRelated?: boolean | null;
    creditRelatedDetail?: string | null;
    hasCreditWelfare?: boolean | null;
    creditWelfareDetail?: string | null;
    addressHistory?: string | null;
    nationality?: string | null;
    ukResident?: boolean | null;
    visaStatus?: string | null;
    yearsInUK?: number | null;
    monthsInUK?: number | null;
    postalAddress?: PostalAddress;
    currentAddressFrom?: Date | null;
    employmentStatus?: EmploymentEnum | null;
    occupation?: string | null;
    yearsInCurrentEmployment?: number | null;
    monthsInCurrentEmployment?: number | null;
    nameOfEmployer?: string | null;
    currentAnnualIncome?: number | null;
    hasCreditIvaOrCva?: boolean | null;
    hasCreditArrangementWithCreditors?: boolean | null;
    hasCreditFamilyResidence?: boolean | null;
    homeTelephone?: string | null;
    title?: string | null;
    titleOption?: TitleEnum;
    maritalStatus?: MaritalStatusEnum;
    countryOfBirth?: string | null;
    countryOfResidence?: string | null;
    residentialStatus?: ResidencyStatusEnum;
    creditIvaOrCvaDetail?: string | null;
    creditArrangementWithCreditorsDetail?: string | null;
    creditFamilyResidenceDetail?: string | null;
    ukResidenceIssueDate?: Date | null;
    previousProperyExperienceDetail?: string | null;
    estimatedNetAssetVal?: number | null;
    currentEmploymentStartDate?: Date | null;
    addressStartDate?: Date | null;
    hasUkResidenceFromBirth?: boolean;
    trackRecord?: string | null;
    userId?: number | null;
    dealClientId?: number | null;
}

export interface ProfilePageWithTotalCountDTO {
    list?: Profile[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

export interface ProfileQualification {
    profile?: Profile | null;
    qualificationOrSkill: string;
    isQualification: boolean;
    id: number;
    profileId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** ProfileQualification without database generated properties */
export interface ProfileQualificationInsert {
    profile?: ProfileInsert | null;
    qualificationOrSkill?: string;
    isQualification?: boolean;
    profileId?: number | null;
}

export interface ProfileQualificationPageWithTotalCountDTO {
    list?: ProfileQualification[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** ProfileQualification with all properties optional except PKs */
export interface ProfileQualificationUpdate {
    profile?: ProfileUpdateWithoutPKs | null;
    qualificationOrSkill?: string;
    isQualification?: boolean;
    id: number;
    profileId?: number | null;
}

/** ProfileQualification without PKs and database generated properties and with all properties optional */
export interface ProfileQualificationUpdateWithoutPKs {
    profile?: ProfileUpdateWithoutPKs | null;
    qualificationOrSkill?: string;
    isQualification?: boolean;
    profileId?: number | null;
}

/** Profile with all properties optional except PKs */
export interface ProfileUpdate {
    user?: ApplicationUserUpdateWithoutPKs | null;
    dealClient?: DealClientUpdateWithoutPKs | null;
    qualifications?: ProfileQualificationUpdate[];
    assetLiabilityItems?: ProfileAssetLiabilityItemUpdate[];
    profileUsers?: ApplicationUserUpdate[];
    /** Date Of Birth */
    dateOfBirth?: Date | null;
    /** Developed Property Before */
    developedPropertyBefore?: boolean | null;
    /** How many development projects have they completed in there own name */
    developedPropertyBeforeNumber?: number | null;
    /** Developed Property Before Estimate of Number or Actual */
    developedPropertyEstimate?: boolean | null;
    /** How many residential development projects have they completed */
    developedResidentialPropertyCompletedNumber?: number | null;
    /** How many commercial development projects have they completed */
    developedCommercialPropertyCompletedNumber?: number | null;
    /** Professions worked in */
    professionsWorkedIn?: ProfessionsEnum | null;
    /** # Years worked as architect */
    yearsWorkedInProfessionsListArchitect?: number | null;
    /** # Years worked as Builder */
    yearsWorkedInProfessionsListBuilder?: number | null;
    /** # Years worked as Carpenter */
    yearsWorkedInProfessionsListCarpenter?: number | null;
    /** # Years worked as Electrician */
    yearsWorkedInProfessionsListElectrician?: number | null;
    /** # Years worked as Planner */
    yearsWorkedInProfessionsListPlanner?: number | null;
    /** # Years worked as Project Manager */
    yearsWorkedInProfessionsListProjectManager?: number | null;
    /** # Years worked as Estate Agency */
    yearsWorkedInProfessionsListEstateAgency?: number | null;
    /** # Years worked as Property Surveyor */
    yearsWorkedInProfessionsListPropertySurveyor?: number | null;
    /** # Years worked as Quantity Surveyor */
    yearsWorkedInProfessionsListQuantitySurveyor?: number | null;
    /** # Years worked as Structural Engineer */
    yearsWorkedInProfessionsListStructuralEngineer?: number | null;
    /** Professional Qualifications */
    professionalQualifications?: string | null;
    /** Skills In Order */
    skillsInOrder?: string | null;
    /** Length Of Time Been Developer */
    lengthOfTimeBeenDeveloper?: number | null;
    furtherInformation?: string | null;
    hasCreditRefused?: boolean | null;
    creditRefusedDetail?: string | null;
    hasCreditConviction?: boolean | null;
    creditConvictionDetails?: string | null;
    hasCreditBankrupt?: boolean | null;
    creditBankruptDetail?: string | null;
    hasCreditCcj?: boolean | null;
    creditCcjDetail?: string | null;
    hasCreditDefaulted?: boolean | null;
    creditDefaultedDetail?: string | null;
    hasCreditRepossessed?: boolean | null;
    creditRepossessedDetail?: string | null;
    hasCreditStepInRightsExercised?: boolean | null;
    creditStepInRightsExercisedDetail?: string | null;
    hasCreditSanctioned?: boolean | null;
    creditSanctionedDetail?: string | null;
    hasCreditRelated?: boolean | null;
    creditRelatedDetail?: string | null;
    hasCreditWelfare?: boolean | null;
    creditWelfareDetail?: string | null;
    addressHistory?: string | null;
    nationality?: string | null;
    ukResident?: boolean | null;
    visaStatus?: string | null;
    yearsInUK?: number | null;
    monthsInUK?: number | null;
    postalAddress?: PostalAddress;
    currentAddressFrom?: Date | null;
    employmentStatus?: EmploymentEnum | null;
    occupation?: string | null;
    yearsInCurrentEmployment?: number | null;
    monthsInCurrentEmployment?: number | null;
    nameOfEmployer?: string | null;
    currentAnnualIncome?: number | null;
    hasCreditIvaOrCva?: boolean | null;
    hasCreditArrangementWithCreditors?: boolean | null;
    hasCreditFamilyResidence?: boolean | null;
    homeTelephone?: string | null;
    title?: string | null;
    titleOption?: TitleEnum;
    maritalStatus?: MaritalStatusEnum;
    countryOfBirth?: string | null;
    countryOfResidence?: string | null;
    residentialStatus?: ResidencyStatusEnum;
    creditIvaOrCvaDetail?: string | null;
    creditArrangementWithCreditorsDetail?: string | null;
    creditFamilyResidenceDetail?: string | null;
    ukResidenceIssueDate?: Date | null;
    previousProperyExperienceDetail?: string | null;
    estimatedNetAssetVal?: number | null;
    currentEmploymentStartDate?: Date | null;
    addressStartDate?: Date | null;
    hasUkResidenceFromBirth?: boolean;
    trackRecord?: string | null;
    id: number;
    userId?: number | null;
    dealClientId?: number | null;
}

/** Profile without PKs and database generated properties and with all properties optional */
export interface ProfileUpdateWithoutPKs {
    user?: ApplicationUserUpdateWithoutPKs | null;
    dealClient?: DealClientUpdateWithoutPKs | null;
    qualifications?: ProfileQualificationUpdate[];
    assetLiabilityItems?: ProfileAssetLiabilityItemUpdate[];
    profileUsers?: ApplicationUserUpdate[];
    /** Date Of Birth */
    dateOfBirth?: Date | null;
    /** Developed Property Before */
    developedPropertyBefore?: boolean | null;
    /** How many development projects have they completed in there own name */
    developedPropertyBeforeNumber?: number | null;
    /** Developed Property Before Estimate of Number or Actual */
    developedPropertyEstimate?: boolean | null;
    /** How many residential development projects have they completed */
    developedResidentialPropertyCompletedNumber?: number | null;
    /** How many commercial development projects have they completed */
    developedCommercialPropertyCompletedNumber?: number | null;
    /** Professions worked in */
    professionsWorkedIn?: ProfessionsEnum | null;
    /** # Years worked as architect */
    yearsWorkedInProfessionsListArchitect?: number | null;
    /** # Years worked as Builder */
    yearsWorkedInProfessionsListBuilder?: number | null;
    /** # Years worked as Carpenter */
    yearsWorkedInProfessionsListCarpenter?: number | null;
    /** # Years worked as Electrician */
    yearsWorkedInProfessionsListElectrician?: number | null;
    /** # Years worked as Planner */
    yearsWorkedInProfessionsListPlanner?: number | null;
    /** # Years worked as Project Manager */
    yearsWorkedInProfessionsListProjectManager?: number | null;
    /** # Years worked as Estate Agency */
    yearsWorkedInProfessionsListEstateAgency?: number | null;
    /** # Years worked as Property Surveyor */
    yearsWorkedInProfessionsListPropertySurveyor?: number | null;
    /** # Years worked as Quantity Surveyor */
    yearsWorkedInProfessionsListQuantitySurveyor?: number | null;
    /** # Years worked as Structural Engineer */
    yearsWorkedInProfessionsListStructuralEngineer?: number | null;
    /** Professional Qualifications */
    professionalQualifications?: string | null;
    /** Skills In Order */
    skillsInOrder?: string | null;
    /** Length Of Time Been Developer */
    lengthOfTimeBeenDeveloper?: number | null;
    furtherInformation?: string | null;
    hasCreditRefused?: boolean | null;
    creditRefusedDetail?: string | null;
    hasCreditConviction?: boolean | null;
    creditConvictionDetails?: string | null;
    hasCreditBankrupt?: boolean | null;
    creditBankruptDetail?: string | null;
    hasCreditCcj?: boolean | null;
    creditCcjDetail?: string | null;
    hasCreditDefaulted?: boolean | null;
    creditDefaultedDetail?: string | null;
    hasCreditRepossessed?: boolean | null;
    creditRepossessedDetail?: string | null;
    hasCreditStepInRightsExercised?: boolean | null;
    creditStepInRightsExercisedDetail?: string | null;
    hasCreditSanctioned?: boolean | null;
    creditSanctionedDetail?: string | null;
    hasCreditRelated?: boolean | null;
    creditRelatedDetail?: string | null;
    hasCreditWelfare?: boolean | null;
    creditWelfareDetail?: string | null;
    addressHistory?: string | null;
    nationality?: string | null;
    ukResident?: boolean | null;
    visaStatus?: string | null;
    yearsInUK?: number | null;
    monthsInUK?: number | null;
    postalAddress?: PostalAddress;
    currentAddressFrom?: Date | null;
    employmentStatus?: EmploymentEnum | null;
    occupation?: string | null;
    yearsInCurrentEmployment?: number | null;
    monthsInCurrentEmployment?: number | null;
    nameOfEmployer?: string | null;
    currentAnnualIncome?: number | null;
    hasCreditIvaOrCva?: boolean | null;
    hasCreditArrangementWithCreditors?: boolean | null;
    hasCreditFamilyResidence?: boolean | null;
    homeTelephone?: string | null;
    title?: string | null;
    titleOption?: TitleEnum;
    maritalStatus?: MaritalStatusEnum;
    countryOfBirth?: string | null;
    countryOfResidence?: string | null;
    residentialStatus?: ResidencyStatusEnum;
    creditIvaOrCvaDetail?: string | null;
    creditArrangementWithCreditorsDetail?: string | null;
    creditFamilyResidenceDetail?: string | null;
    ukResidenceIssueDate?: Date | null;
    previousProperyExperienceDetail?: string | null;
    estimatedNetAssetVal?: number | null;
    currentEmploymentStartDate?: Date | null;
    addressStartDate?: Date | null;
    hasUkResidenceFromBirth?: boolean;
    trackRecord?: string | null;
    userId?: number | null;
    dealClientId?: number | null;
}

export interface ProjectOwnership {
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction: string;
    /** Pension Type */
    pensionType: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners: number;
    /** Development Track Records */
    developmentTrackRecords?: DevelopmentTrackRecord[];
    /** Excluded Lenders */
    excludedLenders: string;
    parentCaseToAssoicateWithOnCreation: number | null;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** ProjectOwnership without database generated properties */
export interface ProjectOwnershipInsert {
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    developmentTrackRecords?: DevelopmentTrackRecordInsert[];
    /** Excluded Lenders */
    excludedLenders?: string;
}

export interface ProjectOwnershipPageWithTotalCountDTO {
    list?: ProjectOwnership[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** ProjectOwnership with all properties optional except PKs */
export interface ProjectOwnershipUpdate {
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    developmentTrackRecords?: DevelopmentTrackRecordUpdate[];
    /** Excluded Lenders */
    excludedLenders?: string;
    id: number;
}

/** ProjectOwnership without PKs and database generated properties and with all properties optional */
export interface ProjectOwnershipUpdateWithoutPKs {
    /** How Will you own the new development */
    howWillYouOwnNewDevelopment?: OwnNewDevelopmentEnum;
    /** How Will you own the new development (Other) */
    howWillYouOwnNewDevelopmentOther?: string;
    /** Has the company or Pension been formed yet */
    hasTheCompanyOrPensionBeenFormedYet?: boolean;
    /** Company / Partnership / Pension Name */
    companyPensionOrPartnershipName?: string;
    /** Company or Partnership Number */
    companyOrPartnershipNumber?: string;
    /** Company / Pension Jurisdiction */
    companyPensionJurisdiction?: string;
    /** Pension Type */
    pensionType?: string;
    /** How Many Owners / Shareholders / Partners */
    howManyOwnersShareholdersOrPartners?: number;
    developmentTrackRecords?: DevelopmentTrackRecordUpdate[];
    /** Excluded Lenders */
    excludedLenders?: string;
}

export interface PromoteSearchToCaseRequest {
    dealId?: number;
    productFamily?: ProductFamilyEnum;
}

export interface PromoteSearchToCaseResponse {
    bridgingDeal?: BridgingDeal;
    commercialDeal?: CommercialDeal;
    devFinanceDeal?: DevelopmentFinanceDeal;
    shortlistedLendersName?: string;
    selectedLendersName?: string;
    shortlistedLendersId?: number[];
}

export enum PropertyTypeDetailEnum {
    None = 0,
    Houses = 1,
    Flats = 2,
    HousesAndFlats = 4,
}

export enum PropertyTypeEnum {
    None = 0,
    Residential = 1,
    MixedUse = 2,
    Hotel = 4,
    Leisure = 8,
    CareRetirement = 16,
    Medical = 32,
    Office = 64,
    Retail = 128,
    LightIndustrial = 256,
    Student = 512,
    HeavyIndustrial = 1024,
    HMO = 2048,
    LandWithoutPlanning = 4096,
    Education = 8192,
    Retirement = 16384,
    AllCommercialMixedUse = 32768,
    MultiUnitFreeholdBlock = 65536,
    Agricultural = 131072,
    PubOrRestaurant = 262144,
    TakeawayRestaurant = 524288,
    BarAndNightclub = 1048576,
    PlaceOfWorship = 2097152,
    EntertainmentVenue = 4194304,
    GymLeisureCentre = 8388608,
    Equestrian = 16777216,
    GolfCourse = 33554432,
    ChildrensDayNursery = 67108864,
    HolidayPark = 134217728,
    ThemePark = 268435456,
    Supermarket = 536870912,
    Museum = 1073741824,
    Airport = 2147483648,
    TransportHub = 4294967296,
    ExIndustrialSpace = 8589934592,
}

export enum PurchaseProcessTypeEnum {
    RegularPurchase = 1,
    Option = 2,
}

export enum QSChargesOfWhatEnum {
    None = 0,
    BuildCost = 1,
    GrossLoan = 2,
}

export interface Qualifications {
    qualificationOrSkill: string;
    isQualification: boolean;
    caseMember?: CaseMember;
    id: number;
    caseMemberId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** Qualifications without database generated properties */
export interface QualificationsInsert {
    qualificationOrSkill?: string;
    isQualification?: boolean;
    caseMember: CaseMemberInsert | null;
    caseMemberId: number;
}

export interface QualificationsPageWithTotalCountDTO {
    list?: Qualifications[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** Qualifications with all properties optional except PKs */
export interface QualificationsUpdate {
    qualificationOrSkill?: string;
    isQualification?: boolean;
    caseMember?: CaseMemberUpdateWithoutPKs | null;
    id: number;
    caseMemberId?: number;
}

/** Qualifications without PKs and database generated properties and with all properties optional */
export interface QualificationsUpdateWithoutPKs {
    qualificationOrSkill?: string;
    isQualification?: boolean;
    caseMember?: CaseMemberUpdateWithoutPKs | null;
    caseMemberId?: number;
}

export enum RatePreferenceEnum {
    None = 0,
    Variable = 1,
    Fixed = 2,
}

export enum ReferrerEnum {
    GoogleSearch = 1,
    OtherSearch = 2,
    LinkedIn = 3,
    Facebook = 4,
    Agent = 5,
    ExistingUser = 6,
    BrickflowConsultant = 7,
    Broker = 8,
    Developer = 9,
    Other = 10,
    MassReports = 11,
    NimbusMaps = 12,
    PressRelease = 13,
    TheRodcast = 14,
    OTM = 15,
    WordOfMouth = 16,
    PersonalRecommendation = 17,
    Ad = 18,
    SocialMedia = 19,
    FIBA = 20,
}

export enum RefurbishmentLevelEnum {
    None = 0,
    Light = 1,
    Medium = 2,
    Heavy = 3,
}

export interface RegisterOrganisationDTO {
    organisationDTO?: Organisation;
    organisationAdminUserDTO?: ApplicationUser;
    inviteOrganisationUsers?: InvitedBrokerDTO[];
}

export interface RegisterUserAndSaveShortListedResultsRequest {
    enterpriseUser?: ApplicationUser;
    shortlistedResults?: DealLender[];
    password: string;
    newDealName?: string;
    dealUniqueRef?: string;
}

export enum ResidencyStatusEnum {
    None = 0,
    Owner = 1,
    Tenant = 2,
    WithFriendsorRelatives = 3,
}

export enum RoleFlagEnum {
    None = 0,
    Admin = 1,
    Broker = 2,
    Lender = 4,
    Client = 8,
    Introducer = 16,
}

export interface SaveAsSearchRequest {
    shareDealDto?: ShareDealDTO;
    searchId?: number;
    newSearchName?: string;
    productFamily?: ProductFamilyEnum;
}

export interface SaveBridgingSearchRequest {
    shareDealDto?: ShareDealDTO;
    deal?: BridgingDeal;
    clientId?: number | null;
    orgCode?: string;
    enterpriseClientDto?: Client | null;
}

export interface SaveCommercialSearchRequest {
    shareDealDto?: ShareDealDTO;
    deal?: CommercialDeal;
    clientId?: number | null;
    orgCode?: string;
    enterpriseClientDto?: Client;
}

export interface SaveDevFinanceSearchRequest {
    shareDealDto?: ShareDealDTO;
    deal: DevelopmentFinanceDeal;
    clientId?: number | null;
    orgCode?: string;
    enterpriseClientDto?: Client;
}

export interface SaveEnterpriseClientAndRenameSearchRequest {
    dealUniqueRef?: string;
    dealNewName?: string;
    clientDto?: Client;
    clientId?: number | null;
    isExistingClient?: boolean | null;
}

export interface SaveEnterpriseClientAndRenameSearchResponse {
    clientId?: number;
    productType?: ProductTypeEnum;
    organisationLinkId?: number | null;
    dealId?: number;
    isFamilyInResidence?: boolean;
    productFamily?: ProductFamilyEnum;
}

export interface SaveSearchReturnUniqueRefResponse {
    dealUniqueRef?: string;
    hasDealClient?: boolean;
    dealClientUniqueRef?: string;
}

export enum ScheduleDescriptionTypeEnum {
    DetachedHouse = 1,
    SemiDetachedHouse = 2,
    TerrancedHouse = 3,
    Cottage = 4,
    Bungalow = 5,
    Studio = 6,
    SingleStorey = 7,
    Duplex = 8,
    Triplex = 9,
}

export enum ScheduleTypeEnum {
    House = 0,
    Flat = 1,
    Parking = 2,
    Commercial = 3,
    Communal = 4,
}

export enum ScheduledJobEnum {
    UpdateOrganisationLinkStats = 1,
}

export interface ScheduledJobLog {
    scheduledJobName: ScheduledJobEnum;
    lastRunDate: Date | null;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** ScheduledJobLog without database generated properties */
export interface ScheduledJobLogInsert {
    scheduledJobName?: ScheduledJobEnum;
    lastRunDate?: Date | null;
}

export interface ScheduledJobLogPageWithTotalCountDTO {
    list?: ScheduledJobLog[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** ScheduledJobLog with all properties optional except PKs */
export interface ScheduledJobLogUpdate {
    scheduledJobName?: ScheduledJobEnum;
    lastRunDate?: Date | null;
    id: number;
}

/** ScheduledJobLog without PKs and database generated properties and with all properties optional */
export interface ScheduledJobLogUpdateWithoutPKs {
    scheduledJobName?: ScheduledJobEnum;
    lastRunDate?: Date | null;
}

export interface SearchResultsRequest {
    dealId?: number | null;
    dealClientUniqueRef?: string;
    dealUniqueRef?: string;
    returnSearchCriteriaDTO?: boolean | null;
    criteriaChanged?: boolean;
    limit?: number;
    debug1?: boolean;
    debug2?: boolean;
}

export interface SecurityCheckMessageRequest {
    uniqueId?: string;
    dateOfBirth?: Date;
    phoneNumber?: string;
    postCode?: string;
    orgUniqueRef?: string;
    brokerUserId?: number | null;
}

export enum SecurityQuestionEnum {
    None = 0,
    PhoneNumber = 1,
    PostCode = 2,
    DateOfBirth = 4,
}

export interface SelectedResult {
    developmentInputId: number;
    productId: number;
    menuId: number | null;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

export interface SelectedResultDTO {
    id?: number;
    developmentInputId?: number;
    productId?: number;
    menuId?: number | null;
}

/** SelectedResult without database generated properties */
export interface SelectedResultInsert {
    developmentInputId?: number;
    productId?: number;
    menuId?: number | null;
}

export interface SelectedResultPageWithTotalCountDTO {
    list?: SelectedResult[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** SelectedResult with all properties optional except PKs */
export interface SelectedResultUpdate {
    developmentInputId?: number;
    productId?: number;
    menuId?: number | null;
    id: number;
}

/** SelectedResult without PKs and database generated properties and with all properties optional */
export interface SelectedResultUpdateWithoutPKs {
    developmentInputId?: number;
    productId?: number;
    menuId?: number | null;
}

export interface ShareDealDTO {
    dealId?: number;
    dealName?: string;
    showLenderNamesAndLogos?: boolean;
    clientDto?: Client;
    emailLinkToClient?: boolean;
    accessLevel?: CaseAccessLevelEnum;
    isApplicant?: boolean;
    isPrimary?: boolean;
}

export interface ShareModuleRequest {
    clientFirstName?: string;
    clientLastName?: string;
    clientEmail?: string;
    note?: string;
    dealId?: number;
    section?: AppraisalModuleEnum;
    productFamily?: ProductFamilyEnum;
}

export interface ShortlistRequest {
    dealLenders?: DealLender[];
    commercialShortlistedResults?: CommercialLenderResultSummaryDTO[];
    bridgingShortlistedResults?: BridgingLenderResultSummaryDTO[];
    devFinanceShortlistedResults?: LenderResultSummaryDTO[];
}

export interface SnapshotLender {
    snapshotDate: Date;
    lenderId: number;
    lenderIsDeleted: boolean;
    lenderCreatedDateTime: Date | null;
    lenderLastUpdatedDateTime: Date | null;
    name: string;
    lenderGenericName: string;
    ratingCustomerService: number | null;
    ratingSpeed: number | null;
    ratingFlexibility: number | null;
    ratingUserRating: number | null;
    isBank: boolean | null;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** SnapshotLender without database generated properties */
export interface SnapshotLenderInsert {
    snapshotDate?: Date;
    lenderId?: number;
    lenderIsDeleted?: boolean;
    lenderCreatedDateTime?: Date | null;
    lenderLastUpdatedDateTime?: Date | null;
    name?: string;
    lenderGenericName?: string;
    ratingCustomerService?: number | null;
    ratingSpeed?: number | null;
    ratingFlexibility?: number | null;
    ratingUserRating?: number | null;
    isBank?: boolean | null;
}

export interface SnapshotLenderPageWithTotalCountDTO {
    list?: SnapshotLender[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** SnapshotLender with all properties optional except PKs */
export interface SnapshotLenderUpdate {
    snapshotDate?: Date;
    lenderId?: number;
    lenderIsDeleted?: boolean;
    lenderCreatedDateTime?: Date | null;
    lenderLastUpdatedDateTime?: Date | null;
    name?: string;
    lenderGenericName?: string;
    ratingCustomerService?: number | null;
    ratingSpeed?: number | null;
    ratingFlexibility?: number | null;
    ratingUserRating?: number | null;
    isBank?: boolean | null;
    id: number;
}

/** SnapshotLender without PKs and database generated properties and with all properties optional */
export interface SnapshotLenderUpdateWithoutPKs {
    snapshotDate?: Date;
    lenderId?: number;
    lenderIsDeleted?: boolean;
    lenderCreatedDateTime?: Date | null;
    lenderLastUpdatedDateTime?: Date | null;
    name?: string;
    lenderGenericName?: string;
    ratingCustomerService?: number | null;
    ratingSpeed?: number | null;
    ratingFlexibility?: number | null;
    ratingUserRating?: number | null;
    isBank?: boolean | null;
}

export interface SnapshotProduct {
    snapshotDate: Date;
    lenderId: number | null;
    productId: number;
    productIsDeleted: boolean;
    productCreatedDateTime: Date | null;
    productLastUpdatedDateTime: Date | null;
    productRef: string;
    isEnabled: boolean;
    lI_LoanFamily: ProductFamilyEnum;
    lI_LoanProduct: ProductTypeEnum;
    lI_Geography: LocationEnum;
    lI_MinLoan: number;
    lI_MaxLoan: number;
    lI_CoFType: CofEnum;
    lI_CoF: number;
    lI_Margin: number;
    lI_Dev_TotRate: number;
    lI_PureResi: number;
    lI_MixedUse: number;
    lI_HMO: number;
    lI_Hotels: number;
    lI_Leisure: number;
    lI_LightIndus: number;
    lI_HeavyIndus: number;
    lI_CareHomes: number;
    lI_Retirement: number;
    lI_Medical: number;
    lI_Student: number;
    lI_Office: number;
    lI_Retail: number;
    lI_Educ: number;
    lI_LandNoPlan: number;
    lI_LandOutlinePlan: number;
    lI_LandDetailedPlan: number;
    lI_ClientIndiv: YesNoMaybe;
    lI_ClientCo: YesNoMaybe;
    lI_OverSeasClient: YesNoMaybe;
    lI_ClientOverseasCo: YesNoMaybe;
    lI_ShariaLoan: YesNoMaybe;
    lI_Syndication: YesNoMaybe;
    lI_Dev_MaxLTC: number;
    lI_Dev_MaxLTGDV: number;
    lI_Dev_MinRealEquity: number;
    lI_Dev_ArrFeeIncBrokFee: number;
    lI_Dev_ArrFeeBase: number;
    lI_Dev_ExitFee: number;
    lI_Dev_MinTerm: number;
    lI_Dev_MaxTerm: number;
    lI_Dev_MaxNetLoanAgainstLandValue: number;
    lI_Dev_MaxPoundperSqFtCap: number;
    lI_Dev_CapOnIndivUnitVal: number;
    isAirRights: YesNoMaybe;
    isFixedRate: YesNoMaybe;
    isListedGradeOne: YesNoMaybe;
    isListedGradeTwo: YesNoMaybe;
    isModular: YesNoMaybe;
    isPermittedDevelopmentScheme: YesNoMaybe;
    maxHouseSalesPrice: number;
    maxFlatUnitPrice: number;
    maxNumberOfUnits: number;
    maxRefurbLevel: RefurbishmentLevelEnum | null;
    minOwnershipPeriod: number;
    maxIndividualUnitPrice: number;
    minIndividualUnitPrice: number;
    maxNumberOfBedrooms: number;
    isTimberFrameConstruction: YesNoMaybe;
    isConcreteConstruction: YesNoMaybe;
    ewS1AcceptableType: EWS1GradeTypeEnum;
    maxNumberOfMUFBUnits: number;
    minYearsLease: number;
    allCommercialMixedUse: number;
    mufb: number;
    industryAgriculturalPerc: number;
    industryPubRestaurantPerc: number;
    industryTakeawayRestaurantPerc: number;
    industryBarNightclubPerc: number;
    industryPlaceOfWorshipPerc: number;
    industryEntertainmentVenuePerc: number;
    industryGymLeisureCentrePerc: number;
    industryEquestrianPerc: number;
    industryGolfCoursePerc: number;
    industryChildrensDayNurseryPerc: number;
    industryHolidayParkPerc: number;
    industryThemeParkPerc: number;
    industrySupermarketPerc: number;
    industryMuseumPerc: number;
    industryAirportPerc: number;
    industryTransportHubPerc: number;
    industryExIndustrialSpacePerc: number;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** SnapshotProduct without database generated properties */
export interface SnapshotProductInsert {
    snapshotDate?: Date;
    lenderId?: number | null;
    productId?: number;
    productIsDeleted?: boolean;
    productCreatedDateTime?: Date | null;
    productLastUpdatedDateTime?: Date | null;
    productRef?: string;
    isEnabled?: boolean;
    lI_LoanFamily?: ProductFamilyEnum;
    lI_LoanProduct?: ProductTypeEnum;
    lI_Geography?: LocationEnum;
    lI_MinLoan?: number;
    lI_MaxLoan?: number;
    lI_CoFType?: CofEnum;
    lI_CoF?: number;
    lI_Margin?: number;
    lI_Dev_TotRate?: number;
    lI_PureResi?: number;
    lI_MixedUse?: number;
    lI_HMO?: number;
    lI_Hotels?: number;
    lI_Leisure?: number;
    lI_LightIndus?: number;
    lI_HeavyIndus?: number;
    lI_CareHomes?: number;
    lI_Retirement?: number;
    lI_Medical?: number;
    lI_Student?: number;
    lI_Office?: number;
    lI_Retail?: number;
    lI_Educ?: number;
    lI_LandNoPlan?: number;
    lI_LandOutlinePlan?: number;
    lI_LandDetailedPlan?: number;
    lI_ClientIndiv?: YesNoMaybe;
    lI_ClientCo?: YesNoMaybe;
    lI_OverSeasClient?: YesNoMaybe;
    lI_ClientOverseasCo?: YesNoMaybe;
    lI_ShariaLoan?: YesNoMaybe;
    lI_Syndication?: YesNoMaybe;
    lI_Dev_MaxLTC?: number;
    lI_Dev_MaxLTGDV?: number;
    lI_Dev_MinRealEquity?: number;
    lI_Dev_ArrFeeIncBrokFee?: number;
    lI_Dev_ArrFeeBase?: number;
    lI_Dev_ExitFee?: number;
    lI_Dev_MinTerm?: number;
    lI_Dev_MaxTerm?: number;
    lI_Dev_MaxNetLoanAgainstLandValue?: number;
    lI_Dev_MaxPoundperSqFtCap?: number;
    lI_Dev_CapOnIndivUnitVal?: number;
    isAirRights?: YesNoMaybe;
    isFixedRate?: YesNoMaybe;
    isListedGradeOne?: YesNoMaybe;
    isListedGradeTwo?: YesNoMaybe;
    isModular?: YesNoMaybe;
    isPermittedDevelopmentScheme?: YesNoMaybe;
    maxHouseSalesPrice?: number;
    maxFlatUnitPrice?: number;
    maxNumberOfUnits?: number;
    maxRefurbLevel?: RefurbishmentLevelEnum | null;
    minOwnershipPeriod?: number;
    maxIndividualUnitPrice?: number;
    minIndividualUnitPrice?: number;
    maxNumberOfBedrooms?: number;
    isTimberFrameConstruction?: YesNoMaybe;
    isConcreteConstruction?: YesNoMaybe;
    ewS1AcceptableType?: EWS1GradeTypeEnum;
    maxNumberOfMUFBUnits?: number;
    minYearsLease?: number;
    allCommercialMixedUse?: number;
    mufb?: number;
    industryAgriculturalPerc?: number;
    industryPubRestaurantPerc?: number;
    industryTakeawayRestaurantPerc?: number;
    industryBarNightclubPerc?: number;
    industryPlaceOfWorshipPerc?: number;
    industryEntertainmentVenuePerc?: number;
    industryGymLeisureCentrePerc?: number;
    industryEquestrianPerc?: number;
    industryGolfCoursePerc?: number;
    industryChildrensDayNurseryPerc?: number;
    industryHolidayParkPerc?: number;
    industryThemeParkPerc?: number;
    industrySupermarketPerc?: number;
    industryMuseumPerc?: number;
    industryAirportPerc?: number;
    industryTransportHubPerc?: number;
    industryExIndustrialSpacePerc?: number;
}

export interface SnapshotProductPageWithTotalCountDTO {
    list?: SnapshotProduct[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** SnapshotProduct with all properties optional except PKs */
export interface SnapshotProductUpdate {
    snapshotDate?: Date;
    lenderId?: number | null;
    productId?: number;
    productIsDeleted?: boolean;
    productCreatedDateTime?: Date | null;
    productLastUpdatedDateTime?: Date | null;
    productRef?: string;
    isEnabled?: boolean;
    lI_LoanFamily?: ProductFamilyEnum;
    lI_LoanProduct?: ProductTypeEnum;
    lI_Geography?: LocationEnum;
    lI_MinLoan?: number;
    lI_MaxLoan?: number;
    lI_CoFType?: CofEnum;
    lI_CoF?: number;
    lI_Margin?: number;
    lI_Dev_TotRate?: number;
    lI_PureResi?: number;
    lI_MixedUse?: number;
    lI_HMO?: number;
    lI_Hotels?: number;
    lI_Leisure?: number;
    lI_LightIndus?: number;
    lI_HeavyIndus?: number;
    lI_CareHomes?: number;
    lI_Retirement?: number;
    lI_Medical?: number;
    lI_Student?: number;
    lI_Office?: number;
    lI_Retail?: number;
    lI_Educ?: number;
    lI_LandNoPlan?: number;
    lI_LandOutlinePlan?: number;
    lI_LandDetailedPlan?: number;
    lI_ClientIndiv?: YesNoMaybe;
    lI_ClientCo?: YesNoMaybe;
    lI_OverSeasClient?: YesNoMaybe;
    lI_ClientOverseasCo?: YesNoMaybe;
    lI_ShariaLoan?: YesNoMaybe;
    lI_Syndication?: YesNoMaybe;
    lI_Dev_MaxLTC?: number;
    lI_Dev_MaxLTGDV?: number;
    lI_Dev_MinRealEquity?: number;
    lI_Dev_ArrFeeIncBrokFee?: number;
    lI_Dev_ArrFeeBase?: number;
    lI_Dev_ExitFee?: number;
    lI_Dev_MinTerm?: number;
    lI_Dev_MaxTerm?: number;
    lI_Dev_MaxNetLoanAgainstLandValue?: number;
    lI_Dev_MaxPoundperSqFtCap?: number;
    lI_Dev_CapOnIndivUnitVal?: number;
    isAirRights?: YesNoMaybe;
    isFixedRate?: YesNoMaybe;
    isListedGradeOne?: YesNoMaybe;
    isListedGradeTwo?: YesNoMaybe;
    isModular?: YesNoMaybe;
    isPermittedDevelopmentScheme?: YesNoMaybe;
    maxHouseSalesPrice?: number;
    maxFlatUnitPrice?: number;
    maxNumberOfUnits?: number;
    maxRefurbLevel?: RefurbishmentLevelEnum | null;
    minOwnershipPeriod?: number;
    maxIndividualUnitPrice?: number;
    minIndividualUnitPrice?: number;
    maxNumberOfBedrooms?: number;
    isTimberFrameConstruction?: YesNoMaybe;
    isConcreteConstruction?: YesNoMaybe;
    ewS1AcceptableType?: EWS1GradeTypeEnum;
    maxNumberOfMUFBUnits?: number;
    minYearsLease?: number;
    allCommercialMixedUse?: number;
    mufb?: number;
    industryAgriculturalPerc?: number;
    industryPubRestaurantPerc?: number;
    industryTakeawayRestaurantPerc?: number;
    industryBarNightclubPerc?: number;
    industryPlaceOfWorshipPerc?: number;
    industryEntertainmentVenuePerc?: number;
    industryGymLeisureCentrePerc?: number;
    industryEquestrianPerc?: number;
    industryGolfCoursePerc?: number;
    industryChildrensDayNurseryPerc?: number;
    industryHolidayParkPerc?: number;
    industryThemeParkPerc?: number;
    industrySupermarketPerc?: number;
    industryMuseumPerc?: number;
    industryAirportPerc?: number;
    industryTransportHubPerc?: number;
    industryExIndustrialSpacePerc?: number;
    id: number;
}

/** SnapshotProduct without PKs and database generated properties and with all properties optional */
export interface SnapshotProductUpdateWithoutPKs {
    snapshotDate?: Date;
    lenderId?: number | null;
    productId?: number;
    productIsDeleted?: boolean;
    productCreatedDateTime?: Date | null;
    productLastUpdatedDateTime?: Date | null;
    productRef?: string;
    isEnabled?: boolean;
    lI_LoanFamily?: ProductFamilyEnum;
    lI_LoanProduct?: ProductTypeEnum;
    lI_Geography?: LocationEnum;
    lI_MinLoan?: number;
    lI_MaxLoan?: number;
    lI_CoFType?: CofEnum;
    lI_CoF?: number;
    lI_Margin?: number;
    lI_Dev_TotRate?: number;
    lI_PureResi?: number;
    lI_MixedUse?: number;
    lI_HMO?: number;
    lI_Hotels?: number;
    lI_Leisure?: number;
    lI_LightIndus?: number;
    lI_HeavyIndus?: number;
    lI_CareHomes?: number;
    lI_Retirement?: number;
    lI_Medical?: number;
    lI_Student?: number;
    lI_Office?: number;
    lI_Retail?: number;
    lI_Educ?: number;
    lI_LandNoPlan?: number;
    lI_LandOutlinePlan?: number;
    lI_LandDetailedPlan?: number;
    lI_ClientIndiv?: YesNoMaybe;
    lI_ClientCo?: YesNoMaybe;
    lI_OverSeasClient?: YesNoMaybe;
    lI_ClientOverseasCo?: YesNoMaybe;
    lI_ShariaLoan?: YesNoMaybe;
    lI_Syndication?: YesNoMaybe;
    lI_Dev_MaxLTC?: number;
    lI_Dev_MaxLTGDV?: number;
    lI_Dev_MinRealEquity?: number;
    lI_Dev_ArrFeeIncBrokFee?: number;
    lI_Dev_ArrFeeBase?: number;
    lI_Dev_ExitFee?: number;
    lI_Dev_MinTerm?: number;
    lI_Dev_MaxTerm?: number;
    lI_Dev_MaxNetLoanAgainstLandValue?: number;
    lI_Dev_MaxPoundperSqFtCap?: number;
    lI_Dev_CapOnIndivUnitVal?: number;
    isAirRights?: YesNoMaybe;
    isFixedRate?: YesNoMaybe;
    isListedGradeOne?: YesNoMaybe;
    isListedGradeTwo?: YesNoMaybe;
    isModular?: YesNoMaybe;
    isPermittedDevelopmentScheme?: YesNoMaybe;
    maxHouseSalesPrice?: number;
    maxFlatUnitPrice?: number;
    maxNumberOfUnits?: number;
    maxRefurbLevel?: RefurbishmentLevelEnum | null;
    minOwnershipPeriod?: number;
    maxIndividualUnitPrice?: number;
    minIndividualUnitPrice?: number;
    maxNumberOfBedrooms?: number;
    isTimberFrameConstruction?: YesNoMaybe;
    isConcreteConstruction?: YesNoMaybe;
    ewS1AcceptableType?: EWS1GradeTypeEnum;
    maxNumberOfMUFBUnits?: number;
    minYearsLease?: number;
    allCommercialMixedUse?: number;
    mufb?: number;
    industryAgriculturalPerc?: number;
    industryPubRestaurantPerc?: number;
    industryTakeawayRestaurantPerc?: number;
    industryBarNightclubPerc?: number;
    industryPlaceOfWorshipPerc?: number;
    industryEntertainmentVenuePerc?: number;
    industryGymLeisureCentrePerc?: number;
    industryEquestrianPerc?: number;
    industryGolfCoursePerc?: number;
    industryChildrensDayNurseryPerc?: number;
    industryHolidayParkPerc?: number;
    industryThemeParkPerc?: number;
    industrySupermarketPerc?: number;
    industryMuseumPerc?: number;
    industryAirportPerc?: number;
    industryTransportHubPerc?: number;
    industryExIndustrialSpacePerc?: number;
}

export interface SnapshotSearchResult {
    searchDate: Date;
    searchId: number;
    idType: string;
    productType: ProductTypeEnum;
    caseStatus: CaseStatusEnum;
    lenderId: number | null;
    lenderName: string;
    productId: number | null;
    productRef: string;
    resultRank: number;
    totalResults: number;
    serverExecutionDuration: number;
    grossLoan: number | null;
    netLoan: number | null;
    trueMonthlyCost: number | null;
    estimatedLenderCosts: number | null;
    equityDeposit: number | null;
    loanTerm: number;
    annualInterestRate: number;
    arrangementFeePercent: number;
    exitFeePercent: number;
    profit: number | null;
    loanToCostGross: number | null;
    loanToCostNet: number | null;
    loanToCostLender: number | null;
    buildLoan: number | null;
    landLoan: number | null;
    buildLoanPercOfBuildCost: number | null;
    landLoanPercOfLandCost: number | null;
    deposit: number | null;
    roce: number | null;
    locations: LocationEnum;
    purchaseCosts: number;
    landCosts: number;
    purchasePrice: number;
    estimatedSpending: number | null;
    gdv: number | null;
    currentValue: number | null;
    loanTermReq: number;
    ownOrPurchase: OwnOrPurchaseEnum | null;
    originalPurchaseDate: Date | null;
    landOrProperty: LandOrPropertyEnum | null;
    endPropertyType: PropertyTypeEnum | null;
    planningPermissionType: PlanningPermissionTypeEnum;
    refinancedUnits: number | null;
    maxLoanRequired: boolean;
    netLoanRequired: number | null;
    refurbishmentLevel: RefurbishmentLevelEnum | null;
    refurbishmentCost: number | null;
    dI_OwnTheProperty: boolean;
    dI_ExistMortgage: boolean;
    dI_ExistingMortgageBalance: number;
    dI_ExistingLenderName: string;
    buildCost: number;
    dI_Contingency: number;
    dI_Area: number;
    dI_AreaUnit: AreaUnitEnum;
    dI_BuildCostPerArea: number;
    dI_AdditionalOngoingCosts: number;
    dI_GDV: number;
    dI_BuildTermReq: number;
    timeLeftOnLease: TimeLeftOnLeaseEnum | null;
    grossMonthlyRentalIncome: number | null;
    mortgageInterestType: InterestRateTypeEnum | null;
    fixedRateTerm: FixedRateTermEnum | null;
    totalCost: number | null;
    repaymentType: LoanRepaymentTypeEnum | null;
    borrowingEntityType: BorrowingEntityTypeEnum | null;
    tradingPeriod: TradingPeriodEnum | null;
    adjustedAnnualEBITDA: number | null;
    rankByROCE: number | null;
    rankByTMC: number | null;
    rankByGrossLoanPercent: number | null;
    rankByInterestRate: number | null;
    rankByArrangementFee: number | null;
    rankByExitFee: number | null;
    rankByNetLoanPercent: number | null;
    originatorRoleType: OriginatorRoleTypeEnum;
    originatorOrganisationId: number | null;
    originatorLenderId: number | null;
    sourceType: DealSourceTypeEnum;
    isFamilyInResidence: boolean;
    productSourceType: ProductSourceTypeEnum;
    externalProductId: string | null;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** SnapshotSearchResult without database generated properties */
export interface SnapshotSearchResultInsert {
    searchDate?: Date;
    searchId?: number;
    idType?: string;
    productType?: ProductTypeEnum;
    caseStatus?: CaseStatusEnum;
    lenderId?: number | null;
    lenderName?: string;
    productId?: number | null;
    productRef?: string;
    resultRank?: number;
    totalResults?: number;
    serverExecutionDuration?: number;
    grossLoan?: number | null;
    netLoan?: number | null;
    trueMonthlyCost?: number | null;
    estimatedLenderCosts?: number | null;
    equityDeposit?: number | null;
    loanTerm?: number;
    annualInterestRate?: number;
    arrangementFeePercent?: number;
    exitFeePercent?: number;
    profit?: number | null;
    loanToCostGross?: number | null;
    loanToCostNet?: number | null;
    loanToCostLender?: number | null;
    buildLoan?: number | null;
    landLoan?: number | null;
    buildLoanPercOfBuildCost?: number | null;
    landLoanPercOfLandCost?: number | null;
    deposit?: number | null;
    roce?: number | null;
    locations?: LocationEnum;
    purchaseCosts?: number;
    landCosts?: number;
    purchasePrice?: number;
    estimatedSpending?: number | null;
    gdv?: number | null;
    currentValue?: number | null;
    loanTermReq?: number;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    originalPurchaseDate?: Date | null;
    landOrProperty?: LandOrPropertyEnum | null;
    endPropertyType?: PropertyTypeEnum | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    refinancedUnits?: number | null;
    maxLoanRequired?: boolean;
    netLoanRequired?: number | null;
    refurbishmentLevel?: RefurbishmentLevelEnum | null;
    refurbishmentCost?: number | null;
    dI_OwnTheProperty?: boolean;
    dI_ExistMortgage?: boolean;
    dI_ExistingMortgageBalance?: number;
    dI_ExistingLenderName?: string;
    buildCost?: number;
    dI_Contingency?: number;
    dI_Area?: number;
    dI_AreaUnit?: AreaUnitEnum;
    dI_BuildCostPerArea?: number;
    dI_AdditionalOngoingCosts?: number;
    dI_GDV?: number;
    dI_BuildTermReq?: number;
    timeLeftOnLease?: TimeLeftOnLeaseEnum | null;
    grossMonthlyRentalIncome?: number | null;
    mortgageInterestType?: InterestRateTypeEnum | null;
    fixedRateTerm?: FixedRateTermEnum | null;
    totalCost?: number | null;
    repaymentType?: LoanRepaymentTypeEnum | null;
    borrowingEntityType?: BorrowingEntityTypeEnum | null;
    tradingPeriod?: TradingPeriodEnum | null;
    adjustedAnnualEBITDA?: number | null;
    rankByROCE?: number | null;
    rankByTMC?: number | null;
    rankByGrossLoanPercent?: number | null;
    rankByInterestRate?: number | null;
    rankByArrangementFee?: number | null;
    rankByExitFee?: number | null;
    rankByNetLoanPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    isFamilyInResidence?: boolean;
    productSourceType?: ProductSourceTypeEnum;
    externalProductId?: string | null;
}

export interface SnapshotSearchResultPageWithTotalCountDTO {
    list?: SnapshotSearchResult[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** SnapshotSearchResult with all properties optional except PKs */
export interface SnapshotSearchResultUpdate {
    searchDate?: Date;
    searchId?: number;
    idType?: string;
    productType?: ProductTypeEnum;
    caseStatus?: CaseStatusEnum;
    lenderId?: number | null;
    lenderName?: string;
    productId?: number | null;
    productRef?: string;
    resultRank?: number;
    totalResults?: number;
    serverExecutionDuration?: number;
    grossLoan?: number | null;
    netLoan?: number | null;
    trueMonthlyCost?: number | null;
    estimatedLenderCosts?: number | null;
    equityDeposit?: number | null;
    loanTerm?: number;
    annualInterestRate?: number;
    arrangementFeePercent?: number;
    exitFeePercent?: number;
    profit?: number | null;
    loanToCostGross?: number | null;
    loanToCostNet?: number | null;
    loanToCostLender?: number | null;
    buildLoan?: number | null;
    landLoan?: number | null;
    buildLoanPercOfBuildCost?: number | null;
    landLoanPercOfLandCost?: number | null;
    deposit?: number | null;
    roce?: number | null;
    locations?: LocationEnum;
    purchaseCosts?: number;
    landCosts?: number;
    purchasePrice?: number;
    estimatedSpending?: number | null;
    gdv?: number | null;
    currentValue?: number | null;
    loanTermReq?: number;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    originalPurchaseDate?: Date | null;
    landOrProperty?: LandOrPropertyEnum | null;
    endPropertyType?: PropertyTypeEnum | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    refinancedUnits?: number | null;
    maxLoanRequired?: boolean;
    netLoanRequired?: number | null;
    refurbishmentLevel?: RefurbishmentLevelEnum | null;
    refurbishmentCost?: number | null;
    dI_OwnTheProperty?: boolean;
    dI_ExistMortgage?: boolean;
    dI_ExistingMortgageBalance?: number;
    dI_ExistingLenderName?: string;
    buildCost?: number;
    dI_Contingency?: number;
    dI_Area?: number;
    dI_AreaUnit?: AreaUnitEnum;
    dI_BuildCostPerArea?: number;
    dI_AdditionalOngoingCosts?: number;
    dI_GDV?: number;
    dI_BuildTermReq?: number;
    timeLeftOnLease?: TimeLeftOnLeaseEnum | null;
    grossMonthlyRentalIncome?: number | null;
    mortgageInterestType?: InterestRateTypeEnum | null;
    fixedRateTerm?: FixedRateTermEnum | null;
    totalCost?: number | null;
    repaymentType?: LoanRepaymentTypeEnum | null;
    borrowingEntityType?: BorrowingEntityTypeEnum | null;
    tradingPeriod?: TradingPeriodEnum | null;
    adjustedAnnualEBITDA?: number | null;
    rankByROCE?: number | null;
    rankByTMC?: number | null;
    rankByGrossLoanPercent?: number | null;
    rankByInterestRate?: number | null;
    rankByArrangementFee?: number | null;
    rankByExitFee?: number | null;
    rankByNetLoanPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    isFamilyInResidence?: boolean;
    productSourceType?: ProductSourceTypeEnum;
    externalProductId?: string | null;
    id: number;
}

/** SnapshotSearchResult without PKs and database generated properties and with all properties optional */
export interface SnapshotSearchResultUpdateWithoutPKs {
    searchDate?: Date;
    searchId?: number;
    idType?: string;
    productType?: ProductTypeEnum;
    caseStatus?: CaseStatusEnum;
    lenderId?: number | null;
    lenderName?: string;
    productId?: number | null;
    productRef?: string;
    resultRank?: number;
    totalResults?: number;
    serverExecutionDuration?: number;
    grossLoan?: number | null;
    netLoan?: number | null;
    trueMonthlyCost?: number | null;
    estimatedLenderCosts?: number | null;
    equityDeposit?: number | null;
    loanTerm?: number;
    annualInterestRate?: number;
    arrangementFeePercent?: number;
    exitFeePercent?: number;
    profit?: number | null;
    loanToCostGross?: number | null;
    loanToCostNet?: number | null;
    loanToCostLender?: number | null;
    buildLoan?: number | null;
    landLoan?: number | null;
    buildLoanPercOfBuildCost?: number | null;
    landLoanPercOfLandCost?: number | null;
    deposit?: number | null;
    roce?: number | null;
    locations?: LocationEnum;
    purchaseCosts?: number;
    landCosts?: number;
    purchasePrice?: number;
    estimatedSpending?: number | null;
    gdv?: number | null;
    currentValue?: number | null;
    loanTermReq?: number;
    ownOrPurchase?: OwnOrPurchaseEnum | null;
    originalPurchaseDate?: Date | null;
    landOrProperty?: LandOrPropertyEnum | null;
    endPropertyType?: PropertyTypeEnum | null;
    planningPermissionType?: PlanningPermissionTypeEnum;
    refinancedUnits?: number | null;
    maxLoanRequired?: boolean;
    netLoanRequired?: number | null;
    refurbishmentLevel?: RefurbishmentLevelEnum | null;
    refurbishmentCost?: number | null;
    dI_OwnTheProperty?: boolean;
    dI_ExistMortgage?: boolean;
    dI_ExistingMortgageBalance?: number;
    dI_ExistingLenderName?: string;
    buildCost?: number;
    dI_Contingency?: number;
    dI_Area?: number;
    dI_AreaUnit?: AreaUnitEnum;
    dI_BuildCostPerArea?: number;
    dI_AdditionalOngoingCosts?: number;
    dI_GDV?: number;
    dI_BuildTermReq?: number;
    timeLeftOnLease?: TimeLeftOnLeaseEnum | null;
    grossMonthlyRentalIncome?: number | null;
    mortgageInterestType?: InterestRateTypeEnum | null;
    fixedRateTerm?: FixedRateTermEnum | null;
    totalCost?: number | null;
    repaymentType?: LoanRepaymentTypeEnum | null;
    borrowingEntityType?: BorrowingEntityTypeEnum | null;
    tradingPeriod?: TradingPeriodEnum | null;
    adjustedAnnualEBITDA?: number | null;
    rankByROCE?: number | null;
    rankByTMC?: number | null;
    rankByGrossLoanPercent?: number | null;
    rankByInterestRate?: number | null;
    rankByArrangementFee?: number | null;
    rankByExitFee?: number | null;
    rankByNetLoanPercent?: number | null;
    originatorRoleType?: OriginatorRoleTypeEnum;
    originatorOrganisationId?: number | null;
    originatorLenderId?: number | null;
    sourceType?: DealSourceTypeEnum;
    isFamilyInResidence?: boolean;
    productSourceType?: ProductSourceTypeEnum;
    externalProductId?: string | null;
}

export enum SortByEnum {
    None = 0,
    ROCE = 1,
    TrueMonthlyCost = 2,
    NetLoanSize = 3,
    LenderCosts = 4,
    LenderName = 5,
    InterestRate = 6,
    ArrangementFee = 7,
    MonthlyPayment = 8,
    DepositEquity = 9,
    LTGDV = 10,
}

export enum SourceOfIncomeEnum {
    None = 0,
    CurrentRentalFromThisProperty = 1,
    FutureRentalFromThisProperty = 2,
    FundsFromYourSavings = 3,
    FundsFromYourIncome = 4,
}

export enum StatusEnum {
    Invited = 1,
    Accepted = 2,
}

export interface StringBaseDataMultiOwnerListTuple {
    item1: string | null;
    item2: BaseDataMultiOwner[] | null;
}

export interface StringInt32DictionaryStringTuple {
    item1: { [key: string]: number; } | null;
    item2: string | null;
}

export interface StringStringListTuple {
    item1: string | null;
    item2: string[] | null;
}

export interface SubmitToLendersRequest {
    dealId?: number;
    productType?: ProductTypeEnum;
    resubmitToLenders?: boolean | null;
    lendersInfo?: LenderInfo[];
    brokerCommission?: number | null;
    brokerPhoneNumber?: string;
    isBrokerPhoneNumberUpdated?: boolean;
}

export interface TaskItem {
    description: string;
    isComplete: boolean;
    completedOn: Date | null;
    completedBy: string;
    id: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** TaskItem without database generated properties */
export interface TaskItemInsert {
    description?: string;
    isComplete?: boolean;
    completedOn?: Date | null;
    completedBy?: string;
}

export interface TaskItemPageWithTotalCountDTO {
    list?: TaskItem[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** TaskItem with all properties optional except PKs */
export interface TaskItemUpdate {
    description?: string;
    isComplete?: boolean;
    completedOn?: Date | null;
    completedBy?: string;
    id: number;
}

/** TaskItem without PKs and database generated properties and with all properties optional */
export interface TaskItemUpdateWithoutPKs {
    description?: string;
    isComplete?: boolean;
    completedOn?: Date | null;
    completedBy?: string;
}

export interface TeamMember {
    user?: ApplicationUser | null;
    case?: Case;
    teamRole: string;
    name: string;
    email: string;
    phoneNumber: string;
    website: string;
    workedWithBefore: boolean;
    previousProjects: string;
    externalProfileURL: string;
    note: string;
    teamRoleOtherDescription: string;
    id: number;
    userId: number | null;
    caseId: number;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** TeamMember without database generated properties */
export interface TeamMemberInsert {
    user?: ApplicationUserInsert | null;
    case: CaseInsert | null;
    teamRole?: string;
    name?: string;
    email?: string;
    phoneNumber?: string;
    website?: string;
    workedWithBefore?: boolean;
    previousProjects?: string;
    externalProfileURL?: string;
    note?: string;
    teamRoleOtherDescription?: string;
    userId?: number | null;
    caseId: number;
}

export interface TeamMemberPageWithTotalCountDTO {
    list?: TeamMember[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** TeamMember with all properties optional except PKs */
export interface TeamMemberUpdate {
    user?: ApplicationUserUpdateWithoutPKs | null;
    case?: CaseUpdateWithoutPKs | null;
    teamRole?: string;
    name?: string;
    email?: string;
    phoneNumber?: string;
    website?: string;
    workedWithBefore?: boolean;
    previousProjects?: string;
    externalProfileURL?: string;
    note?: string;
    teamRoleOtherDescription?: string;
    id: number;
    userId?: number | null;
    caseId?: number;
}

/** TeamMember without PKs and database generated properties and with all properties optional */
export interface TeamMemberUpdateWithoutPKs {
    user?: ApplicationUserUpdateWithoutPKs | null;
    case?: CaseUpdateWithoutPKs | null;
    teamRole?: string;
    name?: string;
    email?: string;
    phoneNumber?: string;
    website?: string;
    workedWithBefore?: boolean;
    previousProjects?: string;
    externalProfileURL?: string;
    note?: string;
    teamRoleOtherDescription?: string;
    userId?: number | null;
    caseId?: number;
}

export enum TeamSizeEnum {
    None = 0,
    One = 1,
    TwoToFive = 2,
    SixToTen = 3,
    ElevenToTwenty = 4,
    TwentyOnePlus = 5,
}

export enum TenureEnum {
    Freehold = 0,
    Leasehold = 1,
    Other = 2,
    ShareOfFreehold = 3,
    CommonholdOwnership = 4,
    JointOwnershipJointTenants = 5,
    JointOwnershipTenantsInCommon = 6,
}

export interface ThirdPartyApiAccessKey {
    secretKey: string;
    isAdmin: boolean;
    publicName: string;
    internalName: string;
    description: string;
    introducer?: Introducer | null;
    organisation?: Organisation | null;
    lenderNamesShown: boolean;
    id: number;
    introducerId: number | null;
    organisationId: number | null;
    isDeleted: boolean;
    createdDateTime: Date | null;
    lastUpdatedDateTime: Date | null;
    lastModifiedUser?: ApplicationUser | null;
    lastModifiedUserId: number | null;
    createdUserId: number | null;
    createdUser?: ApplicationUser | null;
}

/** ThirdPartyApiAccessKey without database generated properties */
export interface ThirdPartyApiAccessKeyInsert {
    secretKey?: string;
    isAdmin?: boolean;
    publicName?: string;
    internalName?: string;
    description?: string;
    introducer?: IntroducerInsert | null;
    organisation?: OrganisationInsert | null;
    lenderNamesShown?: boolean;
    introducerId?: number | null;
    organisationId?: number | null;
}

export interface ThirdPartyApiAccessKeyPageWithTotalCountDTO {
    list?: ThirdPartyApiAccessKey[] | null;
    totalRecCount?: number;
    totalPageCount?: number;
}

/** ThirdPartyApiAccessKey with all properties optional except PKs */
export interface ThirdPartyApiAccessKeyUpdate {
    secretKey?: string;
    isAdmin?: boolean;
    publicName?: string;
    internalName?: string;
    description?: string;
    introducer?: IntroducerUpdateWithoutPKs | null;
    organisation?: OrganisationUpdateWithoutPKs | null;
    lenderNamesShown?: boolean;
    id: number;
    introducerId?: number | null;
    organisationId?: number | null;
}

/** ThirdPartyApiAccessKey without PKs and database generated properties and with all properties optional */
export interface ThirdPartyApiAccessKeyUpdateWithoutPKs {
    secretKey?: string;
    isAdmin?: boolean;
    publicName?: string;
    internalName?: string;
    description?: string;
    introducer?: IntroducerUpdateWithoutPKs | null;
    organisation?: OrganisationUpdateWithoutPKs | null;
    lenderNamesShown?: boolean;
    introducerId?: number | null;
    organisationId?: number | null;
}

export interface ThirdPartyBridgingDealCriteriaDTO {
    productType?: ProductTypeEnum;
    externalRequestRef?: string;
    externalSearchRef?: string;
    resultID?: string | null;
    supplyCallback?: boolean;
    purchasePrice?: number;
    landCosts?: number;
    propertyLocation?: string;
    propertyClass?: string;
    loanTerm?: number;
    maxLoanRequired?: boolean;
    netLoanRequired?: number;
    notifyUser?: boolean;
    clientFirstName?: string;
    clientLastName?: string;
    clientEmail?: string;
    clientPhone?: string;
    clientExternalRef?: string;
    ownOrPurchase?: string;
    purchaseCosts?: number;
    currentValue?: number;
    originalPurchaseDate?: Date;
    estimatedSpending?: number;
    gdv?: number;
    estimatedEndValueOfProperty?: number;
    landOrProperty?: string;
    planningPermissionType?: string;
    landTotalOtherCosts?: number;
    refinancedUnits?: number | null;
    refurbishmentLevel?: string;
    buildCosts?: number;
}

export interface ThirdPartyBridgingResultsDTO {
    grossLoan?: number;
    netLoan?: number;
    lenderName?: string;
    trueMonthlyCost?: number;
    lenderCosts?: number;
    equityOrDeposit?: number;
    profit?: number | null;
    loanInterest?: number;
    grossLoanPercentage?: number;
    netLoanPercentage?: number;
    lenderCostsPercentage?: number;
}

export interface ThirdPartyBridgingResultsDTOThirdPartyResultHeaderDTO {
    externalRequestRef?: string;
    callBackURL?: string;
    resultID?: string;
    responseInfo?: string;
    responseTimeStamp?: Date;
    results?: ThirdPartyBridgingResultsDTO[];
}

export interface ThirdPartyCaseOrDealLenderDTO {
    lenderName?: string;
    status?: string;
    totalGrossLoan?: number | null;
    lenderArrangementFee?: number | null;
    lenderArrangementFeePercent?: number | null;
    interestRate?: number | null;
    lenderExitFee?: number | null;
    lenderExitFeePercent?: number | null;
    professionalFeesEstimate?: number | null;
    lenderAdditionalRequirements?: string;
    buildLoan?: number | null;
    landLoan?: number | null;
    contactName?: string;
    contactEmail?: string;
    contactWorkPhoneNumber?: string;
    contactMobilePhoneNumber?: string;
    interestRateType?: string;
    basisOfInterestRate?: string;
    lenderRequiresProofOfIncome?: boolean;
    lenderRequiresAssetAndLiabilitiesDocument?: boolean;
    lenderRequiresFCARegisteredBroker?: boolean;
    minimumInterestPeriod?: number | null;
    totalNetLoan?: number | null;
    lenderRequiresSiteVisit?: boolean;
    lenderRequiresInPersonMeeting?: boolean;
    lenderRequiresVideoMeeting?: boolean;
    lenderHasOwnDeclaration?: boolean;
    lenderRequiresIncomeAndExpenditure?: boolean;
}

export interface ThirdPartyCommercialDealCriteriaDTO {
    productType?: ProductTypeEnum;
    externalRequestRef?: string;
    externalSearchRef?: string;
    resultID?: string | null;
    supplyCallback?: boolean;
    purchasePrice?: number;
    landCosts?: number;
    propertyLocation?: string;
    propertyClass?: string;
    loanTerm?: number;
    maxLoanRequired?: boolean;
    netLoanRequired?: number;
    notifyUser?: boolean;
    clientFirstName?: string;
    clientLastName?: string;
    clientEmail?: string;
    clientPhone?: string;
    clientExternalRef?: string;
    ownOrPurchase?: string;
    purchaseCosts?: number;
    currentValue?: number;
    originalPurchaseDate?: Date;
    borrowingEntityType?: string;
    timeLeftOnLease?: string;
    grossMonthlyRentalIncome?: number;
    mortgageTerm?: number;
    currentPropertyType?: string;
    mortgageInterestType?: string;
    loanRepaymentType?: string;
    fixedRateTerm?: string;
    loanCompletionType?: string;
    adjustedAnnualEBITDA?: number | null;
    tradingPeriod?: string;
}

export interface ThirdPartyCommercialResultsDTO {
    grossLoan?: number;
    netLoan?: number;
    lenderName?: string;
    trueMonthlyCost?: number;
    equityOrDeposit?: number;
    monthlyPayment?: number;
    arrangementFee?: number;
    arrangementFeePercOfValue?: number | null;
    loanToValueNet?: number;
    loanToValue?: number;
    propertyValue?: number;
    interestRate?: number;
    mortgageTerm?: number;
    repaymentType?: string;
    isFixedRate?: string;
    fixedRateTerm?: string;
}

export interface ThirdPartyCommercialResultsDTOThirdPartyResultHeaderDTO {
    externalRequestRef?: string;
    callBackURL?: string;
    resultID?: string;
    responseInfo?: string;
    responseTimeStamp?: Date;
    results?: ThirdPartyCommercialResultsDTO[];
}

export interface ThirdPartyDevelopmentDealCriteriaDTO {
    productType?: ProductTypeEnum;
    externalRequestRef?: string;
    externalSearchRef?: string;
    resultID?: string | null;
    supplyCallback?: boolean;
    purchasePrice?: number;
    landCosts?: number;
    propertyLocation?: string;
    propertyClass?: string;
    loanTerm?: number;
    maxLoanRequired?: boolean;
    netLoanRequired?: number;
    notifyUser?: boolean;
    clientFirstName?: string;
    clientLastName?: string;
    clientEmail?: string;
    clientPhone?: string;
    clientExternalRef?: string;
    ownOrPurchase?: string;
    purchaseCosts?: number;
    currentValue?: number;
    originalPurchaseDate?: Date;
    buildCost?: number;
    additionalOngoingCosts?: number;
    gdv?: number;
    buildTerm?: number;
}

export interface ThirdPartyGetDealRequestDTO {
    externalRequestRef?: string;
    productType?: string;
    externalDealRef?: string;
    uniqueRef?: string;
}

export interface ThirdPartyGetDealResponseDTO {
    externalRequestRef?: string;
    responseInfo?: string;
    responseTimeStamp?: Date;
    results?: ThirdPartyGetDealResultDTO[];
}

export interface ThirdPartyGetDealResultDTO {
    name?: string;
    gdv?: number | null;
    propertyType?: string;
    location?: string;
    landCost?: number | null;
    buildCost?: number | null;
    purchasePrice?: number | null;
    currentValue?: number | null;
    status?: string;
    lastUpdatedDateTime?: Date | null;
    brokerFullName?: string;
    productType?: string;
    source?: string;
    loanRequired?: string;
    loanTerm?: number | null;
    mortgageTerm?: number | null;
    repaymentType?: string;
    externalRef?: string;
    uniqueRef?: string;
    dealLenders?: ThirdPartyCaseOrDealLenderDTO[];
}

export interface ThirdPartyGetDealsRequestDTO {
    externalRequestRef?: string;
    productType?: string;
    startDate?: Date | null;
    endDate?: Date | null;
}

export interface ThirdPartyGetDealsResponseDTO {
    externalRequestRef?: string;
    responseInfo?: string;
    responseTimeStamp?: Date;
    results?: ThirdPartyGetDealsResultDTO[];
}

export interface ThirdPartyGetDealsResultDTO {
    name?: string;
    gdv?: number | null;
    propertyType?: string;
    location?: string;
    landCost?: number | null;
    buildCost?: number | null;
    purchasePrice?: number | null;
    currentValue?: number | null;
    status?: string;
    lastUpdatedDateTime?: Date | null;
    brokerFullName?: string;
    productType?: string;
    source?: string;
    loanRequired?: string;
    loanTerm?: number | null;
    mortgageTerm?: number | null;
    repaymentType?: string;
    externalRef?: string;
    uniqueRef?: string;
}

export interface ThirdPartyReferUserDTO {
    externalRequestRef?: string;
    clientFirstName?: string;
    clientLastName?: string;
    clientEmail?: string;
    clientPhone?: string;
    clientExternalRef?: string;
}

export interface ThirdPartyReferUserResponseDTO {
    externalRequestRef?: string;
    clientExternalRef?: string;
    responseInfo?: string;
    responseTimeStamp?: Date;
}

export interface ThirdPartySearchCriteriaDTO {
    productType?: ProductTypeEnum;
    externalRequestRef?: string;
    externalSearchRef?: string;
    resultID?: string | null;
    supplyCallback?: boolean;
    purchasePrice?: number;
    landCosts?: number;
    propertyLocation?: string;
    propertyClass?: string;
    loanTerm?: number;
    maxLoanRequired?: boolean;
    netLoanRequired?: number;
    notifyUser?: boolean;
    clientFirstName?: string;
    clientLastName?: string;
    clientEmail?: string;
    clientPhone?: string;
    clientExternalRef?: string;
    buildCost?: number;
    additionalOngoingCosts?: number;
    gdv?: number;
    buildTerm?: number;
}

export interface ThirdPartySearchResultsDTO {
    grossLoan?: number;
    netLoan?: number;
    lenderName?: string;
    interestRate?: number;
    lenderArrangementFee?: number;
    lenderExitFee?: number;
    totalLenderCosts?: number;
    depositRequired?: number;
    profitForecast?: number;
}

export interface ThirdPartySearchResultsDTOThirdPartyResultHeaderDTO {
    externalRequestRef?: string;
    callBackURL?: string;
    resultID?: string;
    responseInfo?: string;
    responseTimeStamp?: Date;
    results?: ThirdPartySearchResultsDTO[];
}

export interface ThirdPartyUpdateDealResponseDTO {
    externalRequestRef?: string;
    responseInfo?: string;
    responseTimeStamp?: Date;
}

export enum TimeLeftOnLeaseEnum {
    None = 0,
    LessThanYear = 1,
    OneToThreeYears = 2,
    MoreThanThreeYears = 3,
}

export enum TitleEnum {
    None = 0,
    Mr = 1,
    Mrs = 2,
    Miss = 3,
    Ms = 4,
    Other = 5,
}

export interface TotalUnreadMessagesByAppraisal {
    appraisalId?: number;
    totalUnreadMessages?: number;
    isDeal?: boolean;
}

export interface TotalUnreadMessagesByAppraisalResponse {
    bridgingTotalUnreadMessages?: number;
    devFinanceTotalUnreadMessages?: number;
    commercialTotalUnreadMessages?: number;
}

export enum TradingPeriodEnum {
    None = 0,
    LessThanTwoYears = 1,
    MoreThanTwoYears = 2,
}

export enum UnitTypeEnum {
    None = 0,
    Flat = 1,
}

export interface UpdateBridgingSearchGetResultRequest {
    bridgingDeal?: BridgingDeal;
    criteriaChanged?: boolean;
    limit?: number;
    debug1?: boolean;
    debug2?: boolean;
    isPostcodeChange?: boolean;
    isShortlistingMore?: boolean;
}

export interface UpdateBridgingSearchGetResultResponse {
    results?: BridgingLenderResultSummaryDTO[];
    bridgingDeal?: BridgingDeal;
    criteriaLocation?: LocationEnum | null;
    postCodeErrorMessage?: string;
}

export interface UpdateCommercialSearchGetResultRequest {
    commercialDeal?: CommercialDeal;
    criteriaChanged?: boolean;
    limit?: number;
    debug1?: boolean;
    debug2?: boolean;
    isPostcodeChange?: boolean;
    isShortlistingMore?: boolean;
}

export interface UpdateCommercialSearchGetResultResponse {
    results?: CommercialLenderResultSummaryDTO[];
    commercialDeal?: CommercialDeal;
    criteriaLocation?: LocationEnum | null;
    postCodeErrorMessage?: string;
}

export interface UpdateDevFinanceSearchGetResultRequest {
    devFinanceDeal?: DevelopmentFinanceDeal;
    criteriaChanged?: boolean;
    limit?: number;
    debug1?: boolean;
    debug2?: boolean;
    isPostcodeChange?: boolean;
    isShortlistingMore?: boolean;
}

export interface UpdateDevFinanceSearchGetResultResponse {
    results?: LenderResultSummaryDTO[];
    devFinanceDealDto?: DevelopmentFinanceDeal;
    criteriaLocation?: LocationEnum | null;
    postCodeErrorMessage?: string;
}

export interface UserPermissionTypeDTO {
    id: number;
    permissions: PermissionTypesOnDataEnum;
}

export enum UserRoleEnum {
    None = 0,
    Admin = 1,
    Broker = 2,
    Lender = 3,
    Client = 4,
    Introducer = 5,
}

export interface UserSessionDataDTO {
    claims?: AppClaimsEnum[];
    userId?: number | null;
}

export interface UserSimpleDTO {
    id?: number;
    email?: string;
    phoneNumber?: string;
    firstName?: string;
    lastName?: string;
    fullName?: string;
}

export enum ValuationFeeTypeEnum {
    None = 0,
    GDV = 1,
    LandValueCost = 2,
    FlatRate = 3,
}

export enum ValuationMethodEnum {
    None = 0,
    OMV = 1,
    One80DayVP = 2,
    NinetyDayVP = 4,
    CommercialValuation = 8,
    Any = 15,
}

export interface WebConfigDTO {
    termsAndConditionsURL?: string;
    privecyURL?: string;
    cookiePolicyURL?: string;
    headerBackgroundColour?: string;
}

export enum YesNoMaybe {
    NotfilledIn = 0,
    Yes = 1,
    No = 2,
    Maybe = 3,
}

export interface Anonymous {
    "@odata.count"?: number;
    value: Account[];
}

export interface Anonymous2 {
    "@odata.count"?: number;
    value: AppFeature[];
}

export interface Anonymous3 {
    "@odata.count"?: number;
    value: ApplicationUser[];
}

export interface Anonymous4 {
    "@odata.count"?: number;
    value: AppPackage[];
}

export interface Anonymous5 {
    "@odata.count"?: number;
    value: AppPackageFeature[];
}

export interface Anonymous6 {
    "@odata.count"?: number;
    value: AppPackagePricing[];
}

export interface Anonymous7 {
    "@odata.count"?: number;
    value: AppUserPermission[];
}

export interface Anonymous8 {
    "@odata.count"?: number;
    value: AssetLiabilityItem[];
}

export interface Anonymous9 {
    "@odata.count"?: number;
    value: AuditLog[];
}

export interface Anonymous10 {
    "@odata.count"?: number;
    value: BrickflowEventLog[];
}

export interface Anonymous11 {
    "@odata.count"?: number;
    value: BridgingDeal[];
}

export interface Anonymous12 {
    "@odata.count"?: number;
    value: Case[];
}

export interface Anonymous13 {
    "@odata.count"?: number;
    value: CaseLender[];
}

export interface Anonymous14 {
    "@odata.count"?: number;
    value: CaseLenderMessage[];
}

export interface Anonymous15 {
    "@odata.count"?: number;
    value: CaseLenderMessageTrack[];
}

export interface Anonymous16 {
    "@odata.count"?: number;
    value: CaseMember[];
}

export interface Anonymous17 {
    "@odata.count"?: number;
    value: CaseNote[];
}

export interface Anonymous18 {
    "@odata.count"?: number;
    value: Client[];
}

export interface Anonymous19 {
    "@odata.count"?: number;
    value: CommercialDeal[];
}

export interface Anonymous20 {
    "@odata.count"?: number;
    value: ComparableProperty[];
}

export interface Anonymous21 {
    "@odata.count"?: number;
    value: DealClient[];
}

export interface Anonymous22 {
    "@odata.count"?: number;
    value: DealCompletion[];
}

export interface Anonymous23 {
    "@odata.count"?: number;
    value: Deal[];
}

export interface Anonymous24 {
    "@odata.count"?: number;
    value: DealFileAttachment[];
}

export interface Anonymous25 {
    "@odata.count"?: number;
    value: DealLender[];
}

export interface Anonymous26 {
    "@odata.count"?: number;
    value: DealLenderMessage[];
}

export interface Anonymous27 {
    "@odata.count"?: number;
    value: DealLenderMessageTrack[];
}

export interface Anonymous28 {
    "@odata.count"?: number;
    value: DealNote[];
}

export interface Anonymous29 {
    "@odata.count"?: number;
    value: DealSchedule[];
}

export interface Anonymous30 {
    "@odata.count"?: number;
    value: DeveloperExitFinanceDevScheduleInput[];
}

export interface Anonymous31 {
    "@odata.count"?: number;
    value: DeveloperExitFinanceLoanInput[];
}

export interface Anonymous32 {
    "@odata.count"?: number;
    value: DevelopmentFinanceDeal[];
}

export interface Anonymous33 {
    "@odata.count"?: number;
    value: DevelopmentInput[];
}

export interface Anonymous34 {
    "@odata.count"?: number;
    value: DevelopmentInputSchedule[];
}

export interface Anonymous35 {
    "@odata.count"?: number;
    value: DevelopmentInputWithNoLogin[];
}

export interface Anonymous36 {
    "@odata.count"?: number;
    value: DevelopmentTrackRecord[];
}

export interface Anonymous37 {
    "@odata.count"?: number;
    value: ExternalLinks[];
}

export interface Anonymous38 {
    "@odata.count"?: number;
    value: FeedBack[];
}

export interface Anonymous39 {
    "@odata.count"?: number;
    value: FileAttachment[];
}

export interface Anonymous40 {
    "@odata.count"?: number;
    value: Introducer[];
}

export interface Anonymous41 {
    "@odata.count"?: number;
    value: Invite[];
}

export interface Anonymous42 {
    "@odata.count"?: number;
    value: Lender[];
}

export interface Anonymous43 {
    "@odata.count"?: number;
    value: LenderOrganisation[];
}

export interface Anonymous44 {
    "@odata.count"?: number;
    value: LenderResult[];
}

export interface Anonymous45 {
    "@odata.count"?: number;
    value: LicenseAppPackage[];
}

export interface Anonymous46 {
    "@odata.count"?: number;
    value: LicenseMaster[];
}

export interface Anonymous47 {
    "@odata.count"?: number;
    value: Organisation[];
}

export interface Anonymous48 {
    "@odata.count"?: number;
    value: OrganisationLink[];
}

export interface Anonymous49 {
    "@odata.count"?: number;
    value: PostcodeLocation[];
}

export interface Anonymous50 {
    "@odata.count"?: number;
    value: Product[];
}

export interface Anonymous51 {
    "@odata.count"?: number;
    value: ProductRate[];
}

export interface Anonymous52 {
    "@odata.count"?: number;
    value: ProfileAssetLiabilityItem[];
}

export interface Anonymous53 {
    "@odata.count"?: number;
    value: Profile[];
}

export interface Anonymous54 {
    "@odata.count"?: number;
    value: ProfileQualification[];
}

export interface Anonymous55 {
    "@odata.count"?: number;
    value: ProjectOwnership[];
}

export interface Anonymous56 {
    "@odata.count"?: number;
    value: Qualifications[];
}

export interface Anonymous57 {
    "@odata.count"?: number;
    value: ScheduledJobLog[];
}

export interface Anonymous58 {
    "@odata.count"?: number;
    value: SelectedResult[];
}

export interface Anonymous59 {
    "@odata.count"?: number;
    value: SnapshotLender[];
}

export interface Anonymous60 {
    "@odata.count"?: number;
    value: SnapshotProduct[];
}

export interface Anonymous61 {
    "@odata.count"?: number;
    value: SnapshotSearchResult[];
}

export interface Anonymous62 {
    "@odata.count"?: number;
    value: TaskItem[];
}

export interface Anonymous63 {
    "@odata.count"?: number;
    value: TeamMember[];
}

export interface Anonymous64 {
    "@odata.count"?: number;
    value: ThirdPartyApiAccessKey[];
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(q: ng.IQService, message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): ng.IPromise<any> {
    if (result !== null && result !== undefined)
        return q.reject(result);
    else
        return q.reject(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: Blob, q: ng.IQService): ng.IPromise<string> {
    return new q((resolve) => {
        let reader = new FileReader();
        reader.onload = event => resolve((event.target as any).result);
        reader.readAsText(blob);
    });
}